var app = angular.module('html5Game', [
    // EXTERNAL
    // angular
    'ngResource',
    'ngSanitize',
    'ngTouch',
    // external
    //'ui.bootstrap',
    'ui.router', 
    'infinite-scroll',
    'angularLazyImg',
    'ngProgress',
    'rt.debounce',
    // INTERNAL
    // common
    'CommonMod'
    // modules
])
    // [DOC] Only providers and constants can be injected into configuration blocks.
    .config(['$locationProvider', '$stateProvider', '$urlRouterProvider', '$httpProvider', 'LoggerProvider', 'ConfigProvider', 'DictionaryProvider', 'lazyImgConfigProvider', '$compileProvider',
        function($locationProvider, $stateProvider, $urlRouterProvider, $httpProvider, LoggerProvider, ConfigProvider, DictionaryProvider, lazyImgConfigProvider, $compileProvider) {
            $compileProvider.debugInfoEnabled(false);
            // Initialize Config
            if(document.cookie.indexOf('nocacheatall') >= 0) {
                ConfigProvider.nocache(true);
            } else {
                ConfigProvider.nocache(false);
            }

            function addParam(url, param) {
                var a = document.createElement('a');
                a.href = url;
                a.search += a.search ? '&' + param : '?' + param;
                return a.href;
            }

            var scrollable = window;
            lazyImgConfigProvider.setOptions({
                offset: 100, // how early you want to load image (default = 100)
                errorClass: 'error', // in case of loading image failure what class should be added (default = null)
                successClass: 'b-loaded', // in case of loading image success what class should be added (default = null)
                onError: function(image) {
                }, // function fired on loading error
                onSuccess: function(image) {
                    /*if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
                        var evt = document.createEvent('UIEvents');
                        evt.initUIEvent('resize', true, false, window, 0);
                        window.dispatchEvent(evt);
                    } else {
                        var newEv = new Event('resize');
                        console.log(newEv);
                        window.dispatchEvent(newEv);
                    }*/
                }, // function fired on loading success
                container: angular.element(scrollable) // if scrollable container is not $window then provide it here
            });

            $httpProvider.defaults.withCredentials = true;

            $httpProvider.interceptors.push(function() {
                return {
                    request: function(config) {
                        if ((config.method && config.method === 'GET') && !config.hideLoader){
                            document.querySelector('html').classList.add('loadingRequest');
                        }
                        if(ConfigProvider.value('nocacheatall') || document.location.hash.indexOf('nocacheatall') > -1) {
                            config.url = addParam(config.url, 'nocacheatall=1');
                        }
                        if(config.method === 'JSONP') {
                            if(config.callback) {
                                config.url = addParam(config.url, 'callback=' + config.callback);
                            }
                        }
                        return config;
                    },
                    response: function(response){
                        if (response.config.method && response.config.method === 'GET'){
                            setTimeout(function(){
                                document.querySelector('html').classList.remove('loadingRequest');
                            }, 1000);
                        }
                        return response;
                    }
                };
            });

            // Initialize Logger
            LoggerProvider.configure(ConfigProvider.value('LOGGER_ENABLED'), ConfigProvider.value('SENTRY_URL'));

            // Initialize Dictionary
            if(ConfigProvider.value('IS_STAGING') || document.cookie.indexOf('nodict') >= 0) {
                DictionaryProvider.configure(true);
            } else {
                DictionaryProvider.configure(false);
            }
            var Dict = DictionaryProvider.value;

            //Operator (hide stuff at telco request - movistar...)
            var operatorReq = (document.cookie.indexOf(ConfigProvider.value('OPERATOR_REQUESTS')) !== -1) ? true : false;

            /************************************
             ************** ROUTING *************
             ************************************/

            var routeInfo = ConfigProvider.value('CUSTOM_ROUTING');
            //CUSTOM TMPL ora va da conf
            if (ConfigProvider.value('CUSTOM_ROUTING_OVERRIDE')){
                var routeInfoOverride = ConfigProvider.value('CUSTOM_ROUTING_OVERRIDE');
                angular.merge(routeInfo, routeInfoOverride);
            }

            // Set hash fragment
            $locationProvider.hashPrefix('!');

            // add trailing slash to naked url (home redirection)
            $urlRouterProvider.rule(function($injector, $location) {
                var path = $location.path();
                if(path.indexOf('/') === -1) {
                    return path + '/';
                }
            });

            // Inizialize user resolve
            var defaultUserResolve = ['User', function(User) {
                return User.getStatus();
            }];

            // Create header and footer - with default
            var headerCtr = ConfigProvider.value('HEADER_CTR'),
                footerCtr = ConfigProvider.value('FOOTER_CTR'),
                headerTpl = ConfigProvider.value('JS_TEMPLATE_PREFIX') + ConfigProvider.value('HEADER_TPL'),
                footerTpl = ConfigProvider.value('JS_TEMPLATE_PREFIX') + ConfigProvider.value('FOOTER_TPL');

            var defaultHeader = {
                templateUrl: headerTpl ? headerTpl : ConfigProvider.value('JS_TEMPLATE_PREFIX') + '/pages/header/header.ctr.html',
                controller: headerCtr ? headerCtr : 'HeaderCtr',
                resolve: {
                    currentUser: defaultUserResolve
                }
            };

            var defaultFooter = {
                templateUrl: footerTpl ? footerTpl : ConfigProvider.value('JS_TEMPLATE_PREFIX') + '/pages/parts/footer.ctr.html',
                controller: footerCtr ? footerCtr : 'FooterCtr',
                resolve: {
                    currentUser: defaultUserResolve
                }
            };

            // Routing
            if (ConfigProvider.value('ROUTER_HOME') && routeInfo.home){
                // home page;
                $stateProvider.state('home', {
                    url: ConfigProvider.value(routeInfo.home.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: Dict('SEO_WEBAPP_META_OGTAGS_HOME_TITLE') + ' ' + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.home.tmpl,
                            controller: routeInfo.home.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    data: {
                        customHeader: !!routeInfo.home.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_EXPLORE') && routeInfo.explore){
                // explore page;
                $stateProvider.state('explore', {
                    url: ConfigProvider.value(routeInfo.explore.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: Dict('SEO_WEBAPP_META_TITLE_EXPLORE') + ' ' + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.explore.tmpl,
                            controller: routeInfo.explore.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    params: { query: '' },
                    data: {
                        customHeader: !!routeInfo.explore.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_LABEL') && routeInfo.label){
                // label page;
                $stateProvider.state('label', {
                    url: ConfigProvider.value(routeInfo.label.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.label.tmpl,
                            controller: routeInfo.label.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    params: {
                        listName: ''
                    },
                    data: {
                        customHeader: !!routeInfo.label.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_CATEGORY') && routeInfo.category){
                // category page;
                $stateProvider.state('category', {
                    url: ConfigProvider.value(routeInfo.category.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.category.tmpl,
                            controller: routeInfo.category.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    params: {
                        listName: ''
                    },
                    data: {
                        customHeader: !!routeInfo.category.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_GAME_URL') && routeInfo.game){
                // game page;
                $stateProvider.state('game', {
                    url: ConfigProvider.value(routeInfo.game.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.game.tmpl,
                            controller: routeInfo.game.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    params: {
                        gameId: '',
                        gameCategory: '',
                        gameName: ''
                    },
                    data: {
                        customHeader: !!routeInfo.game.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_VIDEO_URL') && routeInfo.video){
                // video page;
                $stateProvider.state('video', {
                    url: ConfigProvider.value(routeInfo.video.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.video.tmpl,
                            controller: routeInfo.video.ctrl,
                            resolve: { currentUser: defaultUserResolve }
                        }
                    },
                    data: { customHeader: !!routeInfo.video.namedHeader }
                });
            }
            if (ConfigProvider.value('ROUTER_SEARCH') && routeInfo.search){
                // search page;
                $stateProvider.state('search', {
                    url: ConfigProvider.value(routeInfo.search.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: Dict('WEBAPP_GOLD_HEADER_MENU_SEARCH') + ' ' + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.search.tmpl,
                            controller: routeInfo.search.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    params: { query: '' },
                    data: {
                        customHeader: !!routeInfo.search.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_FAVORITES') && routeInfo.favorites){
                // favorites page;
                $stateProvider.state('favorites', {
                    url: ConfigProvider.value(routeInfo.favorites.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: 'FAVORITES ' + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.favorites.tmpl,
                            controller: routeInfo.favorites.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    data: {
                        customHeader: !!routeInfo.favorites.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_HISTORY') && routeInfo.history){
                // History page;
                $stateProvider.state('history', {
                    url: ConfigProvider.value(routeInfo.history.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: 'LAST PLAYED ' + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.history.tmpl,
                            controller: routeInfo.history.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    data: {
                        customHeader: !!routeInfo.history.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_SETTINGS') && routeInfo.settings){
                // profile/settings page;
                $stateProvider.state('settings', {
                    url: ConfigProvider.value(routeInfo.settings.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: (Dict('WEBAPP_GOLD_TOP_HELP') + ' ' + Dict('SEO_WEBAPP_TITLE_COUNTRY')),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.settings.tmpl
                        }
                    },
                    data: {
                        customHeader: !!routeInfo.settings.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_ABOUT') && routeInfo.about){
                // settings page (about);
                $stateProvider.state('about', {
                    url: ConfigProvider.value(routeInfo.about.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: 'ABOUT ' + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            template: '<dynamic-dom content="content"></dynamic-dom>',
                            controller: routeInfo.about.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve,
                                Params: function() {
                                    return {
                                        SUBSECTION: 'settings',
                                        CONTENT_ID: 'about'
                                    };
                                }
                            }
                        }
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_FORGOT') && routeInfo.forgot){
                // settings page (forgot);
                $stateProvider.state('forgot', {
                    url: ConfigProvider.value(routeInfo.forgot.url) + '?msisdn',
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: 'FORGOT ' + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + (ConfigProvider.value('ENABLE_NEWTON_USER') ? routeInfo.forgot.tmplUO30 : routeInfo.forgot.tmpl),
                            controller: ConfigProvider.value('ENABLE_NEWTON_USER') ? routeInfo.forgot.ctrlUO30 : routeInfo.forgot.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve,
                                Params: ['$stateParams', function($stateParams) {
                                    return {
                                        msisdn: $stateParams.msisdn,
                                        SUBSECTION: 'smartforgot'
                                    };
                                }]
                            }
                        }
                    },
                    data: {
                        customHeader: !!routeInfo.forgot.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_LOGIN') && routeInfo.login){
                // settings page (login);
                $stateProvider.state('login', {
                    url: ConfigProvider.value(routeInfo.login.url) + '?msisdn',
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: Dict('SEO_WEBAPP_TITLE_LOGIN') + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + (ConfigProvider.value('ENABLE_NEWTON_USER') ? routeInfo.login.tmplUO30 : routeInfo.login.tmpl),
                            controller: ConfigProvider.value('ENABLE_NEWTON_USER') ? routeInfo.login.ctrlUO30 : routeInfo.login.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve,
                                Params: ['$stateParams', function($stateParams) {
                                    return {
                                        msisdn: $stateParams.msisdn,
                                        SUBSECTION: ConfigProvider.value('ENABLE_NEWTON_USER') ? '' : 'smartlogin'
                                    };
                                }]
                            }
                        }
                    },
                    data: {
                        customHeader: !!routeInfo.login.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_WRAPPER_LOGIN') && routeInfo.wrapperlogin){
                // settings page (login);
                $stateProvider.state('wrapperlogin', {
                    url: ConfigProvider.value(routeInfo.wrapperlogin.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: 'LOGIN ' + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + (ConfigProvider.value('ENABLE_NEWTON_USER') ? routeInfo.wrapperlogin.tmplUO30 : routeInfo.wrapperlogin.tmpl),
                            controller: ConfigProvider.value('ENABLE_NEWTON_USER') ? routeInfo.wrapperlogin.ctrlUO30 : routeInfo.wrapperlogin.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve,
                                Params: ['$stateParams', function($stateParams) {
                                    return {
                                        token: $stateParams.token || null,
                                        msisdn: $stateParams.msisdn,
                                        SUBSECTION: ConfigProvider.value('ENABLE_NEWTON_USER') ? '' : 'smartlogin'
                                    };
                                }]
                            }
                        },
                        params: { token: { squash: false, value: null } }
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_WRAPPER_FORGOT') && routeInfo.forgot){
                // settings page (forgot);
                $stateProvider.state('wrapperforgot', {
                    url: ConfigProvider.value(routeInfo.forgot.url) + '?msisdn',
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: 'FORGOT ' + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + (ConfigProvider.value('ENABLE_NEWTON_USER') ? routeInfo.forgot.tmplUO30 : routeInfo.forgot.tmpl),
                            controller: ConfigProvider.value('ENABLE_NEWTON_USER') ? routeInfo.forgot.ctrlUO30 : routeInfo.forgot.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve,
                                Params: ['$stateParams', function($stateParams) {
                                    return {
                                        msisdn: $stateParams.msisdn,
                                        SUBSECTION: 'smartforgot'
                                    };
                                }]
                            }
                        }
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_RESETPSW') && routeInfo.resetpsw){
                // reset password page - unlogged - U30;
                $stateProvider.state('resetpsw', {
                    url: ConfigProvider.value(routeInfo.resetpsw.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: Dict('SEO_WEBAPP_HEAD_TITLE_INDEX') + ' ' + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.resetpsw.tmpl,
                            controller: routeInfo.resetpsw.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    data: {
                        customHeader: !!routeInfo.resetpsw.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_ADDEMAIL') && routeInfo.addemail){
                // account creation page - U30;
                $stateProvider.state('addemail', {
                    url: ConfigProvider.value(routeInfo.addemail.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: Dict('SEO_WEBAPP_HEAD_TITLE_INDEX') + ' ' + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.addemail.tmpl,
                            controller: routeInfo.addemail.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_CHANGEPSW') && routeInfo.changepassword){
                // change password page - logged - U30;
                $stateProvider.state('changepassword', {
                    url: ConfigProvider.value(routeInfo.changepassword.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: Dict('SEO_WEBAPP_HEAD_TITLE_INDEX') + ' ' + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.changepassword.tmpl,
                            controller: routeInfo.changepassword.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    data: {
                        customHeader: !!routeInfo.changepassword.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_CONFIRMMAIL') && routeInfo.confirmmail){
                // confirm mail page - U30;
                $stateProvider.state('confirmmail', {
                    url: ConfigProvider.value(routeInfo.confirmmail.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: Dict('SEO_WEBAPP_HEAD_TITLE_INDEX') + ' ' + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.confirmmail.tmpl,
                            controller: routeInfo.confirmmail.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_STATUS') && routeInfo.status){
                // settings page (status);
                $stateProvider.state('status', {
                    url: ConfigProvider.value(routeInfo.status.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: 'STATUS ' + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            templateUrl: ConfigProvider.value('ENABLE_NEWTON_USER') ? (ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.status.tmplUO30) : (ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.status.tmpl),
                            controller: ConfigProvider.value('ENABLE_NEWTON_USER') ? routeInfo.status.ctrlUO30 : routeInfo.status.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve,
                                Params: ['$stateParams', function($stateParams) {
                                    return {
                                        SUBSECTION: 'smartstatus'
                                    };
                                }]
                            }
                        }
                    },
                    data: {
                        customHeader: !!routeInfo.status.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_TERMS') && routeInfo.terms){
                // settings page (terms);
                $stateProvider.state('terms', {
                    url: ConfigProvider.value(routeInfo.terms.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: 'TERMS ' + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            template: '<dynamic-dom content="content"></dynamic-dom>',
                            controller: routeInfo.terms.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve,
                                Params: ['$stateParams', function($stateParams) {
                                    return {
                                        SUBSECTION: 'terms',
                                        CONTENT_ID: $stateParams.contentId,
                                        label: $stateParams.label
                                    };
                                }]
                            }
                        }
                    },
                    data: {
                        customHeader: !!routeInfo.terms.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_ERROR') && routeInfo.error){
                // error page;
                $stateProvider.state('error', {
                    url: ConfigProvider.value(routeInfo.error.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: 'ERROR ' + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.error.tmpl,
                            controller: routeInfo.error.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    data: {
                        customHeader: !!routeInfo.error.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_UNSUBSCRIBED') && routeInfo.unsubscribed){
                $stateProvider.state('unsubscribed', {
                    url: ConfigProvider.value(routeInfo.unsubscribed.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: Dict('STATUS_WEBAPP'),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.unsubscribed.tmpl,
                            controller: routeInfo.unsubscribed.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    data: {
                        hideOperator: operatorReq,
                        customHeader: !!routeInfo.unsubscribed.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_MFP') && routeInfo.mfp){
                $stateProvider.state('mfp', {
                    url: ConfigProvider.value(routeInfo.mfp.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: Dict('SEO_WEBAPP_TITLE_MFP'),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.mfp.tmpl,
                            controller: routeInfo.mfp.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve,
                                Params: ['$stateParams', function($stateParams) {
                                    return {
                                        title: $stateParams.title,
                                        returnurl: $stateParams.returnurl
                                    };
                                }]
                            }
                        }
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_PAYWALL') && routeInfo.wall){
                $stateProvider.state('wall', {
                    url: ConfigProvider.value(routeInfo.wall.url),
                    params: {
                        returl: null,
                        game: null
                    },
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.wall.tmpl,
                            controller: routeInfo.wall.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_PARTNER') && routeInfo.shop){
                $stateProvider
                //Partner page with iframe
                .state('shop', {
                    url: ConfigProvider.value(routeInfo.shop.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            default_title: Dict('SEO_WEBAPP_HEAD_TITLE_INDEX') + ' ' + Dict('SEO_WEBAPP_TITLE_COUNTRY'),
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.shop.tmpl,
                            controller: routeInfo.shop.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    data: {
                        customHeader: !!routeInfo.shop.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_NEWS_LIST') && routeInfo.newsList){
                $stateProvider.state('news', {
                    url: ConfigProvider.value(routeInfo.newsList.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.newsList.tmpl,
                            controller: routeInfo.newsList.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    data: {
                        customHeader: !!routeInfo.newsList.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_NEWS_ZOOM') && routeInfo.news){
                $stateProvider.state('zoom', {
                    url: ConfigProvider.value(routeInfo.news.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.news.tmpl,
                            controller: routeInfo.news.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    params: {
                        newsName: ''
                    },
                    data: {
                        customHeader: !!routeInfo.news.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_CONTEST') && ConfigProvider.value('ENABLE_CONTEST') && routeInfo.contest){
                $stateProvider.state('contest', {
                    url: ConfigProvider.value(routeInfo.contest.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.contest.tmpl,
                            controller: routeInfo.contest.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    data: {
                        customHeader: !!routeInfo.contest.namedHeader
                    }
                });
            }
            if (ConfigProvider.value('ROUTER_BADGES') && ConfigProvider.value('ENABLE_BADGES') && routeInfo.badges){
                $stateProvider.state('badges', {
                    url: ConfigProvider.value(routeInfo.badges.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.badges.tmpl,
                            controller: routeInfo.badges.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    data: {
                        customHeader: !!routeInfo.badges.namedHeader
                    }
                });
            }

            if (ConfigProvider.value('ROUTER_OFFERS') && routeInfo.applications){
                $stateProvider.state('applications', {
                    url: ConfigProvider.value(routeInfo.applications.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.applications.tmpl,
                            controller: routeInfo.applications.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    params: {
                        appsList: '',
                        appsListName: ''
                    },
                    data: {
                        customHeader: !!routeInfo.applications.namedHeader
                    }
                });
            }

            if (ConfigProvider.value('ROUTER_ZOOM_OFFERS') && routeInfo.application){
                $stateProvider.state('application', {
                    url: ConfigProvider.value(routeInfo.application.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.application.tmpl,
                            controller: routeInfo.application.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    params: {
                        appName: '',
                        appId: '',
                        appUrl: ''
                    },
                    data: {
                        customHeader: !!routeInfo.application.namedHeader
                    }
                });
            }

            if (ConfigProvider.value('ROUTER_PROMO') && routeInfo.promo){
                $stateProvider.state('promo', {
                    url: ConfigProvider.value(routeInfo.promo.url),
                    views: {
                        header: defaultHeader,
                        footer: defaultFooter,
                        main: {
                            templateUrl: ConfigProvider.value('JS_TEMPLATE_PREFIX') + routeInfo.promo.tmpl,
                            controller: routeInfo.promo.ctrl,
                            resolve: {
                                currentUser: defaultUserResolve
                            }
                        }
                    },
                    data: {
                        customHeader: !!routeInfo.promo.namedHeader
                    }
                });
            }
            
/*             if (ConfigProvider.value('USE_ROUTE_FALLBACK_PROMO')){
                $stateProvider.state('root', {
                    url: '/',
                    onEnter: function($state) {
                        if (User.getStatus()) {
                            location.replace(`${ConfigProvider.value('DEST_DOMAIN')}${ConfigProvider.value('ROUTE_FALLBACK_PROMO')}`);
                        } else {
                            $state.go('login');
                        }
                    }
                });
            } */
            $urlRouterProvider.otherwise('/');
        }

    ])

    // [DOC] Only instances and constants can be injected into run blocks.
    .run(['Header', '$location', '$window', '$rootScope', '$stateParams', '$anchorScroll', 'Analytics', 'Cat', 'Devices', 'Config', 'Logger', 'Dictionary', 'User', '$http', 'dateFilter', 'Favorites', 'Meta', 'LabelsObj', 'Utils', 'ngProgressFactory', '$state', 'GoogleManager', 'Settings', 'EventBus', 'Theme', 'ContestService', 'Leaderboard',
        function(Header, $location, $window, $rootScope, $stateParams, $anchorScroll, Analytics, Cat, Devices, Config, Logger, Dictionary, User, $http, dateFilter, Favorites, Meta, LabelsObj, Utils, ngProgressFactory, $state, GoogleManager, Settings, EventBus, Theme, ContestService, Leaderboard) {

            //console.log('states', $state.get()); // per vedere TUTTI gli states registrati.
            // Init SnowPlow
            //console.log('snowplow init check from web app', window.snowplow);
            if (window.snowplow !== undefined && Config.value('SNOWPLOW_TRACKING_ANALYTICS')) {
                const collectorUrl = window.location.origin.includes('https') ? window.location.origin.replace('https://', '') : window.location.origin.replace('http://', '');
                const collector = window.location.origin.includes('2') ? 'com-digitalvirgo-prod1.mini.snplow.net' : collectorUrl;

                var countrySP = window.location.origin;
                var arrayStringCountry = countrySP.split('.');
                var appId = Dictionary.value('SNOWPLOW_APP_ID') || '';
                var optionsSp = window.location.origin.includes('2') ? {
                    appId: appId
                } : {
                    appId: appId,
                    discoverRootDomain: true,
                    cookieName: '_sp_',
                    contexts: {
                        performanceTiming: true
                    }
                };
                window.snowplow('newTracker', 'sp1', collector, optionsSp);
            }

            //end snowplow init

            if (Config.value('CHANGE_THEME_ENABLED')){
                Theme.setThemeAtBootstrap();
            }
            var standalone = Utils.isStandalone();
            if (Config.value('SHOW_PWA_INSTALL') && !standalone){

                if ('onbeforeinstallprompt' in window) {
                    var deferredPWAPrompt = '';
                    window.addEventListener('beforeinstallprompt', function(e){
                        e.preventDefault();
                        deferredPWAPrompt = e;
                        //console.info('beforeinstallprompt event was fired.');
                        EventBus.trigger('installPrompt', deferredPWAPrompt);
                    });
                } else {
                    EventBus.trigger('installPrompt');
                }
            }


            //init lang direction
            $rootScope.RTLlang = document.querySelector('html').getAttribute('dir') === 'rtl';
            //Check current language when there is multilanguage
            if(Config.value('SHOW_MULTIPLE_LANGUAGE')) {
                $rootScope.langList = langList;
                $rootScope.currLang = Config.value('LANGUAGE');
            }
            $rootScope.shuffle = Config.value('SHUFFLE_ON') || '';
            $rootScope.shuffleHome = Config.value('SHUFFLE_HOME_SINGLE_LIST') || '';
            $rootScope.shuffleLists = Config.value('SHUFFLE_LISTS') || ''; //separate, because it messes up infinite scroll for now.

            document.querySelector('html').classList.remove('no-js');
            document.querySelector('html').classList.add('js');

            if(Config.value('HAS_CRITICAL_LESS')) { //critical first-loading enabled
                //commented out because the loading mechanism is not reliable.
                var lessCSS,
                    lessURL;
                lessURL = [Config.value('LESS_URL'), '?file=', Config.value('LESS_CSS_NAME'), '&country=', Config.value('API_COUNTRY'), '&v=', Config.value('SERVICE_CSS_VERSION')].join('');
                lessCSS = loadCSS(lessURL, document.querySelector('#confs'));
                onloadCSS(lessCSS, function() {
                    setTimeout(function(){
                        $rootScope.$broadcast('less-loaded');
                        Utils.triggerResize();
                    }, 250);
                    //double call caused by Chrome upon changeng media attr for css.
                    //Should not happen if no disable cache - only seen it with dev tools open.
                });
            }

            JsStorage.init({
                type: 'cookie',
                path: '/'
            });

            Devices.initialize();

            var querystring = Utils.getQueryString();
            var propQuerystringObj = {};
            if(querystring) {
                if(querystring.utm_source) { propQuerystringObj.utm_source = querystring.utm_source; }
                if(querystring.utm_medium) { propQuerystringObj.utm_medium = querystring.utm_medium; }
                if(querystring.utm_campaign) { propQuerystringObj.utm_campaign = querystring.utm_campaign; }
                if(querystring.utm_content) { propQuerystringObj.utm_content = querystring.utm_content; }
                if(querystring.trackExecutionKey) { propQuerystringObj.trackExecutionKey = querystring.trackExecutionKey; }
                if(document.http_referrer) { propQuerystringObj.http_referrer = document.referrer; }
                propQuerystringObj.dest = querystring.dest || 'N/A';
                Logger.log('Newton tracking campaign', querystring, propQuerystringObj);
            }

            //USER
            var nAdapter = {
                secretId: Config.value('NEWTON_SECRETID'),
                enable: (!Config.value('DISABLE_NEWTON_TRACKING')),
                waitLogin: true,
                logger: console,
                properties: {},
                config: {
                    whiteLabel: Config.value('WHITE_LABEL'),
                    isInternational: Config.value('IS_INTERNATIONAL') ? true : false
                },
                pushCallback: function(pushData) {
                    /** wait at least one tick */
                    setTimeout(function() {
                        //console.info('Push Arrived!', pushData);
                        if(pushData.customs && pushData.customs.url_zoom_simple) {
                            //console.info('Redirect to:', pushData.customs.url_zoom_simple);
                            $state.go('game', {
                                gameURL: pushData.customs.url_zoom_simple
                            });
                        } else if(pushData.customs && pushData.customs.url_zoom_absolute) {
                           // console.info('Hard Redirect to:', pushData.customs.url_zoom_absolute);
                            window.location.href = pushData.customs.url_zoom_absolute;
                        }

                    }, 0);
                }
            };

            nAdapter.properties = propQuerystringObj;
            nAdapter.properties.country = Config.value('COUNTRY_CODE') || Config.value('TLD');
            nAdapter.properties.environment = Utils.isStandalone() ? 'webapp_standalone' : 'webapp';
            if(Config.value('WHITE_LABEL')) {
                nAdapter.properties.white_label_id = Config.value('WHITE_LABEL');
            }

            if(!!Config.value('APPSFLYER_ENABLED') && JsStorage.isLocalStorageSupported()) {
                if(!!JsStorage.get('appsFlyerData', { type: 'localstorage' }) && !!Config.value('APPSFLYER_FIELDS')) {
                    var appsFlyerData = JSON.parse(JsStorage.get('appsFlyerData', {
                        type: 'localstorage'
                    }));
                    var appsFlyerFields = Config.value('APPSFLYER_FIELDS');

                    for(var p = 0; p < appsFlyerFields.length; p++) {
                        var hasProp = Object.prototype.hasOwnProperty.call(appsFlyerData, appsFlyerFields[p]);
                        if(hasProp) {
                            nAdapter.properties[Config.value('APPSFLYER_PREFIX') + appsFlyerFields[p]] = appsFlyerData[appsFlyerFields[p]];
                        }
                    }
                }
            }
            if(JsStorage.isLocalStorageSupported()) {
                if(JsStorage.get('deviceId', { type: 'localstorage' })) {
                    nAdapter.properties.deviceId = JsStorage.get('deviceId', {
                        type: 'localstorage'
                    });
                }
            }

            if(Config.value('ENABLE_NEWTON_USER')){ //U30
                useris.init({
                    domain: Config.value('DEST_DOMAIN'),
                    country: Config.value('REAL_COUNTRY'),
                    enableAliasCheck: Config.value('ENABLE_ALIAS_URL'),
                    alaisCheckUrl: Config.value('ALIAS_URL'),
                    disablePinInput: Config.value('HIDE_LOGINPIN'),
                    hybridnews: 0,
                    store_type: '',
                    apikey: Config.value('MOTIME_API_KEY'),
                    enableGoogleCheckbox: Config.value('SHOW_GOOGLE_CHECKBOX'),
                    emailIdentityEnabled: Config.value('IDENTITY_EMAIL_ENABLED'),
                    identityFbEnabled: Config.value('IDENTITY_FB_ENABLED'),
                    redirectToMipRegisterAtStart: Config.value('REDIRECT_TO_MIP_REGISTER_AT_START'),
                    regexObject: {
                        msisdn: Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'),
                        pin: Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_PIN'),
                        password: Config.value('REGEXP_VALIDATE_PASSWD') || '[a-zA-Z0-9]',
                        email: Config.value('REGEXP_VALIDATE_EMAIL'),
                        generic: '.',
                        genericPassword: '.'
                    }
                });

                // (1) Newton init
                NewtonAdapter.init({
                    logger: Logger,
                    enable: Config.value('ENABLE_NEWTON_TRACKING'),
                    waitLogin: true,
                    secretId: Config.value('NEWTON_SECRETID'),
                    properties: nAdapter.properties,
                    config: {
                        whiteLabel: Config.value('WHITE_LABEL'),
                        isInternational: Config.value('IS_INTERNATIONAL') ? true : false,
                        getSnowPlowInstance: function () {
                            return window.snowplow || null;
                        }
                    }
                }).then(function(){
                    // (2) User init
                    User.init(function(resp){
                        Logger.info('User ', resp);
                        if(NewtonAdapter.isUserLogged()){
                            if (Config.value('SNOWPLOW_TRACKING_ANALYTICS') && Config.value('SNOWPLOW_FUNNEL_ACTIVATION') && window.snowplow !== undefined) {
                                // send the event for MX telcel login tracking
                                window.snowplow('trackSelfDescribingEvent', {
                                    event: {
                                        schema: 'iglu:com.dgp/dv_funnel_interaction/jsonschema/1-0-0',
                                        data: {
                                            step_name: Dictionary.value('SNOWPLOW_USER_AUTH_AUTO'),
                                            step_position: 1,
                                            step_description: 'HE',
                                            type_of_action: 'OK',
                                            funnel_name: Dictionary.value('SNOWPLOW_FUNNEL_NAME')
                                        }
                                    }
                                });
                            }
                            $rootScope.userData = resp;
                            document.querySelector('body').classList.add('logged');
                            if (JsStorage.get('user-login-show-feedback', { type: 'cookie' })) {
                                useris.PopupManager.showUserFeedback({
                                    type: 'positive',
                                    feedback: {
                                        message: Config.value('SHOW_OTP_LOGIN') ? Dictionary.value('WEBAPP_HOME_FROM_OTP') : Dictionary.value('WEBAPP_UO30_FEEDBACK_LOGIN')
                                    }
                                });

                                JsStorage.delete('user-login-show-feedback', { type: 'cookie' });
                            }

                            nAdapter.properties.bridge_session_id = NewtonAdapter.getSessionId() ? (NewtonAdapter.getSessionId()) : '';

                        } else if (JsStorage.get('user-logout-show-feedback', { type: 'cookie' })){
                            useris.PopupManager.showUserFeedback({
                                type: 'positive',
                                feedback: {
                                    message: Dictionary.value('WEBAPP_UO30_FEEDBACK_LOGOUT')
                                }
                            });

                            JsStorage.delete('user-logout-show-feedback', { type: 'cookie' });
                        }

                    });

                    // (3) Newton login
                    NewtonAdapter.login({
                        logged: false
                    });

                    // (4) Listen Newton login/logout
                    NewtonAdapter.setUserStateChangeListener({
                        onLoginStateChange: function(){
                            User.init(function(resp){
                                EventBus.trigger('User-State-Changed');
                                if(NewtonAdapter.isUserLogged()){
                                    EventBus.trigger('User-Login');
                                    EventBus.trigger('User-Login-Menu', true);
                                } else {
                                    EventBus.trigger('User-Logout');
                                    EventBus.trigger('User-Logout-Menu', true);
                                }
                            });
                        }
                    });
                }).catch(function(e) {
                    console.log(e, 'Promise Rejected');
                });


            } else {  //U20
                User.init(function(user) {
                    Logger.log('USER', user);
                });

                User.getStatus(function(user){

                    $rootScope.userData = user;
                    NewtonAdapter.init(nAdapter);

                    var newtonLoginObj = {
                        logged: false,
                        userProperties: {}
                    };

                    if(user.logged) {

                        newtonLoginObj = {
                            logged: true,
                            type: 'external',
                            userId: user.id
                        };

                        newtonLoginObj.userProperties = propQuerystringObj;

                        if(user.msisdn) {
                            newtonLoginObj.userProperties.msisdn = user.msisdn;
                        }

                        if(Config.value('TLD')) {
                            newtonLoginObj.userProperties.country = Config.value('TLD');
                        }

                        if(Config.value('REAL_COUNTRY')) {
                            newtonLoginObj.userProperties.real_country = Config.value('REAL_COUNTRY');
                        }
                        document.querySelector('body').classList.add('logged');
                        //Analytics.eventTrack({ category: 'Behavior', action: 'Login', valuable_cd: 'No', action_cd: 'Yes' });
                        //Newton.eventTrack({ category: 'Behavior', action: 'Login', valuable_cd: 'No', action_cd: 'Yes' });
                    }

                    newtonLoginObj.userProperties.user_type = User.getUserType(user);
                    NewtonAdapter.login(newtonLoginObj);
                });
            } // end user20

            User.getStatus(function(user){
                
                //set accesstypeBadges visibility
                $rootScope.userType = User.getUserType(user);
                $rootScope.showBadge = Utils.setBadge($rootScope.userType);
                // get condition for privacyflag
                if (!Config.value('DIDOMI_API_KEY') || !Config.value('DIDOMI_ID')){
                    if(!Config.value('PRIVACY_BLOCK_SAVE_USER_FLAG') && !!Config.value('SHOW_PRIVACY_BLOCK') && !user.privacy_agreed) {
                        $rootScope.privacyCondition = document.cookie.indexOf('prvcflag') === -1;
                        if($rootScope.privacyCondition) {
                            var prop = {
                                category: 'Behavior',
                                action: 'CookieAlertLoad',
                                label: $location.absUrl(),
                                valuable_cd: 'No',
                                action_cd: 'Yes',
                                country: Config.value('REAL_COUNTRY'),
                                language: window.navigator.language
                            };
                            Analytics.eventTrack(prop);
                            NewtonAdapter.trackEvent({
                                name: prop.action,
                                properties: prop
                            });
                        }
                    } else {
                        $rootScope.privacyCondition = false;
                    }
                }
            });

            //ANALYTICS
            var CustomEnv = nAdapter.properties.environment;
            Analytics.setDimension(9, CustomEnv);
            Analytics.setDimension(6, Config.value('TLD'));
            Analytics.setDimension(7, Config.value('SERVICE_TITLE'));

            User.getStatus(function(user){
                if(user.logged) {
                    Analytics.setDimension(1, 'logged');
                    if (user.id){
                        Analytics.set('&uid', user.id);
                    }
                    //else - se uo30, cosa ci si mette?

                    if(user.subscribed) {
                        if(user.operator && user.operator.indexOf('fake') > -1) {
                            Analytics.setDimension(2, 'buongiorno');
                        } else {
                            Analytics.setDimension(2, 'premium');
                        }
                    } else {
                        Analytics.setDimension(2, 'free');
                    }
                } else {
                    Analytics.setDimension(1, 'not logged');
                }
            });

            Analytics.pageTrack($location.url());
            setCustomDim = true;

            /**************************
            ***  GOOGLE TAG MANAGER ***
            **************************/

            if(Config.value('GOOGLE_TAG_ENABLE') && Config.value('GOOGLE_TAG_ID') && Config.value('ENABLE_DATA_LAYER_MANAGER')){
                var operator = JsStorage.get('operator', { type: 'cookie' });
                Settings.getNetworkProperty().$promise.then(function(resp){
                    User.getStatus(function(user){
                        var userStatus = function(H){
                            if(!operator){
                                return Dictionary.value('WEBAPP_SERVICE_STATE_UNKNOWN' + H);
                            }else if (user.logged){
                                return Dictionary.value('WEBAPP_SERVICE_STATE_LOGGED' + H);
                            }else if (!user.logged){
                                return Dictionary.value('WEBAPP_SERVICE_STATE_UNLOGGED' + H);

                            }
                        };

                        var userLogged = function(H) {
                            if (NewtonAdapter.isUserLogged()) {
                                return Dictionary.value('WEBAPP_USER_IDENTIFIED' + H);
                            } else {
                                return Dictionary.value('WEBAPP_USER_NOT_IDENTIFIED' + H);
                            }
                        };
                        var dataLayerDefault;
                        if (Config.value('IS_EMOCION_GTM')) {
                            dataLayerDefault = {
                                'Tipo de red': resp.networkType ? Dictionary.value('WEBAPP_TYPE_CONNECTION_3G') : Dictionary.value('WEBAPP_TYPE_CONNECTION_WIFI'),
                                'Seccion de navegacion': Dictionary.value('WEBAPP_NAVIGATION_SECTION'),
                                'Seccion de navegacion /h': Dictionary.value('WEBAPP_NAVIGATION_SECTION_H'),
                                'Tipo de pagina': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_OTHER'),
                                'Tipo de pagina /h': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_OTHER_H'),
                                'Vertical': Dictionary.value('WEBAPP_VERTICAL_CATEGORY'),
                                'Vertical /h': Dictionary.value('WEBAPP_VERTICAL_CATEGORY_H'),
                                'Subcategoria tematica': Dictionary.value('WEBAPP_VERTICAL_SUBCATEGORY'),
                                'Subcategoria tematica /h': Dictionary.value('WEBAPP_VERTICAL_SUBCATEGORY_H'),
                                'Servicio': Dictionary.value('WEBAPP_SERVICE_NAME'),
                                'Servicio /h ': Dictionary.value('WEBAPP_SERVICE_NAME_H'),
                                'Contenido': Dictionary.value('WEBAPP_NO_APPLICABLE_CONTENT'),
                                'Contenido /h': Dictionary.value('WEBAPP_NO_APPLICABLE_CONTENT_H'),
                                'Proveedor del servicio': Dictionary.value('WEBAPP_SERVICE_PROVIDER'),
                                'Proveedor del servicio /h': Dictionary.value('WEBAPP_SERVICE_PROVIDER_H'),
                                'Proveedor tecnico del servicio': Dictionary.value('WEBAPP_TECHNICAL_PROVIDER'),
                                'Proveedor tecnico del servicio /h': Dictionary.value('WEBAPP_TECHNICAL_PROVIDER_H'),
                                'Estado de suscripcion al servicio': userStatus(''),
                                'Estado de suscripcion al servicio /h': userStatus('_H'),
                                'Estado de identificación de usuario': userLogged(''),
                                'Estado de identificación de usuario /h': userLogged('_H')
                            };
                        } else {
                            var newtonProps = {
                                'action': 'pageview',
                                'category': 'Behavior',
                                'label': $stateParams.label,
                                'content_id': $stateParams.contentId,
                                'zip_download': 'Yes',
                                'game_title': $stateParams.game_title,
                                'valuable_cd': 'Yes',
                                'action_cd': 'Yes',
                                'country': Config.value('REAL_COUNTRY'),
                                'language': window.navigator.language
                            };

                            dataLayerDefault = {
                                'properties': newtonProps
                            };
                        }


                        if(Config.value('GTM_CHECK_USER_LOGIN') && user.logged){
                            dataLayerDefault.eventName = IS_FIRST_ACCESS ? 'userFirstLogin' : 'userLogin';
                            dataLayerDefault.label = Config.value('WHITE_LABEL') ? Config.value('WHITE_LABEL') : $location.absUrl();
                        }

                        GoogleManager.init(dataLayerDefault);
                    });
                });
            }

            //infinite scroll prefs
            $rootScope.scrollPrefs = {
                doc: ($rootScope.deviceType === 'phone') ? true : false,
                check: ($rootScope.deviceType === 'phone') ? false : true
            };

            //Initialize history array (since native js history does not give access to URLs for security reasons)
            $rootScope.from = [];

            Cat.trackExecution();

            // set host name
            $rootScope.hostName = $location.protocol() + '://' + $location.host();

            $rootScope.behaviour = {};
            $rootScope.progressbar = ngProgressFactory.createInstance();

            /**
             * Saving some dictionary
             * keys for the sdk
             */
            if(JsStorage.isLocalStorageSupported()) {
                var dictionary = Dictionary.list();
                var vhost = Config.list();
                JsStorage.setMultiple({
                    gfsdk_dictionary: dictionary,
                    gfsdk_vhost: vhost
                }, {
                    type: 'localstorage'
                });
            }

            var makeRef = function(prev, prevParams) {
                var ref = prev.url;

                for(var key in prevParams) {
                    ref = ref.replace(':' + key, prevParams[key]);
                }
                return ref;
            };

            /****************************************
            *** get conf pages with GTM setting  ****
            *****************************************/
            var gtmPagesConf = [];
            var gtmPagesPath = [];

            if(Config.value('GTM_PAGES')){
                gtmPagesConf = Config.value('GTM_PAGES');
                // set the route path page
                for(var jkl = 0; jkl < gtmPagesConf.length; jkl++){
                    gtmPagesPath.push(Config.value(gtmPagesConf[jkl]));
                }
            }

            /****************************************
            * get conf pages with canonical setting *
            *****************************************/
            var canonicalPagesPath = [];

            if(Config.value('CANONICAL_URL_PAGES')){
                var canonicalPagesConf = Config.value('CANONICAL_URL_PAGES');
                // set the route path page
                for(var k = 0; k < canonicalPagesConf.length; k++){
                    if (Config.value(canonicalPagesConf[k])){
                        canonicalPagesPath.push(Config.value(canonicalPagesConf[k]));
                    }
                }
            }

            // On page change - start
            $rootScope.$on('$stateChangeStart', function(e, curr, currParams, prev, prevParams) {
                $rootScope.scrollBg = false;
                $rootScope.showHomePromo = false;
                var loader = document.querySelector('.reqLoader');
                loader.classList.remove('forceHide');
                if (Config.value('PROMO_ITEMS') && curr.name === 'home'){
                    $rootScope.showHomePromo = true;
                }

                Logger.log('PAGE :: STATECHANGESTART :: ' + $rootScope.currentPage, $rootScope.currentRoute, curr, $stateParams, document.referrer);

                //save history in array, used by back btn in header.ctr
                if(Config.value('ROUTE_REAL_HISTORY')) {
                    if(!$rootScope.goingBack) {
                        var prevUrl = makeRef(prev, prevParams);
                        if(prevUrl && prevUrl !== '^' && (!$rootScope.from.length || ($rootScope.from.length && prevUrl !== $rootScope.from[0]))) { /*&& prevUrl !== '/'*/
                            var isExcluded = false,
                                prevIsTab = false,
                                currIsTab = false;
                            for(var n = 0; n < Config.value('ROUTE_EXCLUDED').length; n++) {
                                if(prevUrl.indexOf(Config.value('ROUTE_EXCLUDED')[n]) > -1) {
                                    isExcluded = true;
                                    break;
                                }
                            }
                            if(!isExcluded) {
                                for(var i = 0; i < Config.value('ROUTE_TABS').length; i++) {
                                    if(prevUrl.indexOf(Config.value('ROUTE_TABS')[i]) > -1) {
                                        prevIsTab = true;
                                        break;
                                    }
                                }
                                for(var j = 0; j < Config.value('ROUTE_TABS').length; j++) {
                                    if(curr.name.indexOf(Config.value('ROUTE_TABS')[j]) > -1) {
                                        currIsTab = true;
                                        break;
                                    }
                                }
                                if(prevIsTab && currIsTab) {
                                    if(!Config.value('ROUTE_TABS_CHECK')) {
                                        $rootScope.from.unshift(prevUrl);
                                        if($rootScope.from.length === Config.value('ROUTE_HISTORY_MAXLENGTH')) {
                                            $rootScope.from.pop();
                                        }
                                    }
                                } else {
                                    $rootScope.from.unshift(prevUrl);
                                    if($rootScope.from.length === Config.value('ROUTE_HISTORY_MAXLENGTH')) {
                                        $rootScope.from.pop();
                                    }
                                }
                            }
                        }
                    } else {
                        $rootScope.goingBack = false;
                    }
                }

                // revert og-tags
                Meta.revert();

                var progressColor = Config.value('PROGRESSBAR_COLOR') || 'white';
                var progressHeight = Config.value('PROGRESSBAR_HEIGHT') || '4px';
                $rootScope.progressbar.setParent(document.getElementById('mainSection'));
                $rootScope.progressbar.setHeight(progressHeight);
                $rootScope.progressbar.setColor(progressColor);
                $rootScope.progressbar.start();
            });

            var setCustomDim = false;

            // On page change - complete
            $rootScope.$on('$stateChangeSuccess', function(e, curr, currParams, prev, prevParams) {
                var currRoute = curr.url;
                var prevRef = makeRef(prev, prevParams);
                $rootScope.called = false;
                if(JsStorage.isLocalStorageSupported()) {
                    if(JsStorage.get('prev_loc', { type: 'localstorage' })) {
                        JsStorage.delete('prev_loc', { type: 'localstorage' });
                    }
                    JsStorage.set('prev_loc', $location.absUrl(), { type: 'localstorage' });
                }

                //setup tmpl name print for QA automated tests
                var tplArray = curr && curr.views && curr.views.main && curr.views.main.templateUrl ? curr.views.main.templateUrl : false;
                var headerFile = Utils.getFileName(Config.value('HEADER_TPL')),
                    footerFile = Utils.getFileName(Config.value('FOOTER_TPL')),
                    mainFile = Utils.getFileName(tplArray);


                var pageViewProps = $stateParams;
                var pageTitle = curr && curr.views && curr.views.main && curr.views.main.default_title ? curr.views.main.default_title : '';
                var finalTitle = $stateParams.gameName || $stateParams.listName || pageTitle || document.title;
                Meta.setTitle(finalTitle);
                // set currentRoute
                $rootScope.currentRoute = '';
                if(curr.name) {
                    $rootScope.currentRoute += curr.name + '-page';
                }
                if($stateParams.contentId) {
                    $rootScope.currentRoute += ' ' + $stateParams.contentId;
                }

                // set currentPage
                $rootScope.currentPage = '';
                if(curr.views.main.controller) {
                    $rootScope.currentPage += curr.views.main.controller;
                }
                if(curr.name === 'freeWelcome' || curr.name === 'freeThankyou') {
                    $rootScope.currentPage += ' free';
                }

                pageViewProps.action = 'pageview';
                pageViewProps.page_name = $rootScope.currentRoute;
                pageViewProps.http_referrer = document.referrer || '';
                pageViewProps.previous_pageview = prevRef || '';
                pageViewProps.page_path = $location.absUrl();
                pageViewProps.msisdn = $stateParams.msisdn || '';
                pageViewProps.url = $location.absUrl();

                pageViewProps.page_title = finalTitle;

                // set sectionId
                if($rootScope.currentRoute === 'label-page') {
                    $rootScope.sectionId = $stateParams.labelId;
                }
                if($rootScope.currentRoute === 'category-page') {
                    $rootScope.sectionId = $stateParams.categoryId;
                }
                // log of page name and details
                Logger.log('PAGE :: STATECHANGE :: ' + $rootScope.currentPage, $rootScope.currentRoute, curr, $stateParams, document.referrer);

                //track pageview for pages that don't need an api resp
                if ($rootScope.currentRoute !== 'game-page'
                 && $rootScope.currentRoute !== 'label-page'
                 && $rootScope.currentRoute !== 'category-page'
                 && $rootScope.currentRoute !== 'zoom-page'){
                    NewtonAdapter.trackPageview({
                        properties: pageViewProps
                    });

                    Analytics.pageTrack($location.url(), {
                        ref_cd: prevRef
                    });
                } else if (prevRef === '^') {
                    $rootScope.$on('pageview-' + $rootScope.currentRoute, function(){
                        pageViewProps.page_title = document.title;
                        NewtonAdapter.trackPageview({
                            properties: pageViewProps
                        });

                        Analytics.pageTrack($location.url(), {
                            ref_cd: prevRef
                        });
                    });
                } else {
                    NewtonAdapter.trackPageview({
                        properties: pageViewProps
                    });

                    Analytics.pageTrack($location.url(), {
                        ref_cd: prevRef
                    });
                }


                /****************************************************************
                 * GTM_PAGES check router page path in conf with
                 * current router path, if It's not in array, set GTM 'other pages'
                 ****************************************************************/

                if (Config.value('GOOGLE_TAG_ENABLE') && Config.value('GOOGLE_TAG_ID') && Config.value('ENABLE_DATA_LAYER_MANAGER')) {
                    if ((currRoute !== '') && (gtmPagesPath.length > 0 && gtmPagesPath.indexOf(currRoute) === -1)) {
                        $rootScope.$watch('meta.title', function (newValue, oldValue) {
                            GoogleManager.set({
                                'Tipo de pagina': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_OTHER'),
                                'Tipo de pagina /h': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_OTHER'),
                                Contenido: Dictionary.value('WEBAPP_NO_APPLICABLE_CONTENT'),
                                'Contenido /h': Dictionary.value('WEBAPP_NO_APPLICABLE_CONTENT_H'),
                                event: 'changePage'
                            });


                        });
                    }
                }


                $rootScope.progressbar.complete(); //was in document.ready but sometimes hangs

                angular.element(document).ready(function() { //stick footer to the bottom if page height < screen height, without using fussy positioning
                    if((curr.url !== '') && (canonicalPagesPath.length > 0 && canonicalPagesPath.indexOf(curr.url) !== -1)){
                        Meta.setCanonical($location.absUrl());
                    } else {
                        $rootScope.meta.canonical = false;
                    }

                    var mainSection = document.querySelector('.container-fluid');
                    var outerSection = document.querySelector('#mainSection');
                    var footer = document.querySelector('footer');
                    var body = document.querySelector('body');
                    var header = document.querySelector('header');
                    var internalHeader = outerSection.querySelector('header');
                    var internalFooter = outerSection.querySelector('footer');

                      //tmpl name print for QA automated tests using var defined above
                    if (internalHeader){
                        internalHeader.dataset.header_tpl = headerFile.replace('.html', '');
                    }
                    if (internalFooter){
                        internalFooter.dataset.footer_tpl = footerFile.replace('.html', '');
                    }
                    if (body){
                        body.dataset.main_tpl = mainFile ? mainFile.replace('.html', '') : 'dynamicDOM';
                    }
                    //end qa auto test tmpl

                    var headerText = document.querySelector('#header-text') ? document.querySelector('#header-text').scrollHeight : 0;
                    var installBanner = document.querySelector('.hybridInstall[postype="header-banner"]') ? document.querySelector('.hybridInstall[postype="header-banner"]').scrollHeight : 0;
                    if(outerSection.scrollHeight < window.innerHeight && !Config.value('NO_CONTAINER_RESIZE') && (mainSection && footer && header)) {
                        mainSection.style.minHeight = parseInt(window.innerHeight - (footer.scrollHeight + header.scrollHeight + installBanner + headerText), 10) + 'px';
                    }
                    $anchorScroll();
                    if(curr.name === 'home' && !Config.value('HOME_SINGLE_LIST') && !Config.value('NO_HOME_RESIZE')) {
                        setTimeout(function(){
                            Utils.resizeHomeItems();
                            Utils.triggerResize();
                        }, 100);
                    }

                    if ($rootScope.addtohome && !Utils.isStandalone() && Config.value('WEBAPP_JS_ADD2HOME_POPUP') && !Config.value('INSTALL_HYBRID_VISIBLE')){
                        if((curr.name === 'home') && !Config.value('ADD2HOME_AFTER_GAMEPLAY')){
                            $rootScope.$on('less-loaded', function(){
                            //OnBoarding conditions to show Add2Home the second time the user visits (BNEE).
                                if (!Config.value('SHOW_ONBOARDING') || (Config.value('SHOW_ONBOARDING') && JsStorage.get('obClosed'))){
                                    $rootScope.addtohome.show();
                                }
                            });
                        }
                    }

                    $rootScope.$broadcast('routechanged');

                    var avoidScrolltopStates = Config.value('SCROLLTOP_ENABLED_STATES') || [];
                    if (avoidScrolltopStates.length){
                        for(var i = 0; i < avoidScrolltopStates.length; i++) {
                            if (curr.name === avoidScrolltopStates[i]){
                                $rootScope.showButton4State = true;
                            }
                        }
                    } else {
                        $rootScope.showButton4State = true;
                    }

                    if (Config.value('EXTERNAL_COOKIE_CLOSEBTN')) {
                        setTimeout(function(){
                      //to close the cookie box if it's not ours (Orange Jeux FR; put the accept or close button id in the conf key)
                      //doesn't work 100% because of timing.
                            var extBtnCookie = document.querySelector(Config.value('EXTERNAL_COOKIE_CLOSEBTN'));
                            if (extBtnCookie){
                                extBtnCookie.setAttribute('data-mipqa', 'privacyBox-close-btn');
                            }
                        }, 5000);
                    }

                    switch (curr.name) {
                    case 'settings':
                        snowplowKey = 'myaccount';
                        break;
                    case 'terms':
                        snowplowKey = 'termsandconditions';
                        break;
                    case 'home':
                        snowplowKey = 'servicehomepage';
                        break;
                    case 'status':
                        snowplowKey = 'cancelationpage';
                        break;
                    default:
                        snowplowKey = 'servicepage';
                        break;
                    }

                    // Track Page view of snowplow
                    if (window.snowplow !== undefined && Config.value('SNOWPLOW_TRACKING_ANALYTICS')) {
                        window.snowplow('trackPageView', {
                            context: [{
                                schema: 'iglu:com.dgp/page_category/jsonschema/1-0-0',
                                data: {
                                    kind_of_page: snowplowKey
                                }
                            }]
                        });
                    }

                });
            });

            // create callback for privacy box closing
            $rootScope.closePrivacy = function() {
                $rootScope.privacyCondition = false;
                if(Config.value('PRIVACY_BLOCK_SAVE_USER_FLAG')) {
                    var timestampNow = new Date().getTime();
                    var dateNow = dateFilter(timestampNow, 'yyyy-MM-dd HH:mm:ss');
                    User.setProperties({
                        privacy_agreed: true,
                        date_privacy_cookie_agree: dateNow
                    });
                }

                var prop = {
                    category: 'Behavior',
                    action: 'CookieAlertClose',
                    label: '<Page>',
                    valuable_cd: 'No',
                    action_cd: 'Yes',
                    country: Config.value('REAL_COUNTRY'),
                    language: window.navigator.language
                };
                Analytics.eventTrack(prop);
                NewtonAdapter.trackEvent({
                    name: prop.action,
                    properties: prop
                });
            };

            // Log of Config, Dict, User
            Logger.log('CONFIGURATION', Config.list());
            Logger.log('DICTIONARY', Dictionary.list());

            Meta.init();

            // add-to-homescreen

            if(Config.value('WEBAPP_JS_ADD2HOME_POPUP')) {
                var addToHomeList = Config.value('ADD2HOME_UA_LIST') || [],
                    addToHomeEnabled = false;

                if (Config.value('INSTALL_HYBRID_VISIBLE') && (($rootScope.selector === 'android' && Config.value('GOOGLEPLAY_STORE_URL')) || ($rootScope.selector === 'ios' && Config.value('ITUNES_STORE_URL')))){
                    addToHomeEnabled = false;
                } else {
                    for(var i = 0; i < addToHomeList.length; i++) {
                        if(Config.value('UA') === addToHomeList[i]) {
                            addToHomeEnabled = true;
                            break;
                        }
                    }
                }
                var ATHTrack = function(act){
                    var ATHprop = {
                        category: 'Behavior',
                        action: 'Add2Home_' + act,
                        label: $location.absUrl(),
                        valuable_cd: 'No',
                        action_cd: 'Yes',
                        country: Config.value('REAL_COUNTRY'),
                        language: window.navigator.language
                    };
                    Analytics.eventTrack(ATHprop);
                    NewtonAdapter.trackEvent({
                        name: ATHprop.action,
                        properties: ATHprop
                    });
                };
                if(addToHomeEnabled) {

                    var osMessage;
                    switch(Config.value('UA')) {
                    case 'ANDROID':
                        osMessage = Dictionary.value('WEBAPP_ADD2HOME_POPUP_ANDROID');
                        break;
                    case 'APPLE_IPHONE':
                    case 'APPLE_IPAD':
                        osMessage = Dictionary.value('WEBAPP_ADD2HOME_POPUP_IOS');
                        break;
                    default:
                        osMessage = Dictionary.value('WEBAPP_ADD2HOME_POPUP_ANDROID');
                        break;
                    }

                    $rootScope.addtohome = addToHomescreen({
                        modal: false, //prevents further actions on the website until the message is closed. Non uso il flag perchè mette l'overlay - quindi lo metto sempre false
                        mandatory: false, //the website is not accessible until the user adds the application to the homescreen. This is useful mainly for web-app-capable applications that need full screen viewing to be accessed (eg: games).
                        skipFirstVisit: Config.value('ADD2HOME_SKIPFIRST') || false, //setting this to true prevents the message to appear the first time the user visits your website. It is highly recommended to enable this option!
                        startDelay: Config.value('ADD2HOME_DELAY') || 10, //seconds to wait from page load before showing the message. Default: 1.
                        lifespan: Config.value('ADD2HOME_MODAL') ? 0 : 10, //seconds to wait before automatically close the message. Default: 15 (set to 0 to disable automatic removal).
                        fontSize: 14,
                        displayPace: Config.value('ADD2HOME_DISPLAYPACE') || 1440, //minutes before the message is shown again. By default it’s set to 1440, meaning that we will be showing the message only once per day.
                        maxDisplayCount: Config.value('ADD2HOME_SHOW_TIMES') || 100, //absolute maxium number of times the call out will be shown. (0 = no limit).
                        icon: true, //display the touch icon in the pop up message. Default: true
                        message: osMessage, //you can provide your custom message if you don’t like the default.
                        onShow: function(){ ATHTrack('shown'); }, //custom function executed when the message is shown.
                        onAdd: function(){ ATHTrack('added'); }, //custom function executed when the application is added to the homescreen. Please note that this is a guesstimate (see below).
                        onPrivate: function(){ ATHTrack('privateMode'); },
                        onRemove: function(){ ATHTrack('closed'); }, //executed when the message is removed
                        detectHomescreen: false, //ATH tries to detect the homescreen. Supported values are: false, true (=’hash’), ‘hash’, ‘queryString’, ‘smartURL’ (see below).
                        debug: Config.value('IS_STAGING') ? true : false,
                        autostart: Config.value('ADD2HOME_AUTOSTART') || false //the message is not shown automatically and you have to trigger it programmatically.
                    });

                    if (!Utils.isStandalone()){
                        if (Config.value('ADD2HOME_AFTER_GAMEPLAY') && document.referrer && (document.referrer.indexOf('html5gameplay') !== -1)){
                            //addToHomescreen.removeSession(); not needed ;)
                            $rootScope.addtohome.show();
                        }
                    }
                }
            }

            // Audit tool
            Audit.init({
                enable: !!INIT_AUDIT
            });
        }
    ]);

angular.module('CommonMod', ['ngResource'])

    .constant('LabelsObj', COLLECTION_LABELS)

    .constant('ConfObj', CONFIG)

    .constant('DictObj', DICTIONARY)

    .constant('EventBus', new JsEventbus());

angular.module('CommonMod').filter('config', ['Config', function(Config) {
    return function(input) {
        return Config.value(input);
    };
}]);

angular.module('CommonMod').provider('Config', ['ConfObj',
    function(ConfObj) {

        // METODI DEL PROVIDER
        var myProvider = {

            nocache: function(nocacheatall) {
                if(nocacheatall) {
                    ConfObj.nocacheatall = '&nocacheatall=1';
                } else {
                    ConfObj.nocacheatall = '';
                }
            },

            value: function(input) {
                if(input) {
                    var value = ConfObj[input];
                    if(typeof value === 'undefined') {
                        input = input.toUpperCase();
                        value = ConfObj[input];
                        if(typeof value === 'undefined') {
                            return null;
                        }
                    }
                    return value;
                } else {
                    return null;
                }
            },

            list: function() {
                var value = ConfObj;
                if(typeof ConfObj === 'undefined') {
                    value = [];
                }
                return value;
            }

        };


        // aggiunge a this il myProvider riportato sopra,
        // in questo modo si possono chiamare i methods da .config()
        angular.extend(this, myProvider);

        // richiama il myProvider riportato sopra,
        // in questo modo si possono chiamare i methods da .run()
        this.$get = [function() {
            return myProvider;
        }];

    }
]);

angular.module('CommonMod').factory('Devices', [
    '$rootScope', '$location', '$http', 'Config', 'Dictionary', 'Logger',
    function($rootScope, $location, $http, Config, Dictionary, Logger) {

        return {
            initialize: function() {
                $rootScope.selector = this.getPlatform();
                $rootScope.deviceType = this.getDeviceType($rootScope.selector);
                $rootScope.checkCompatibility = $rootScope.deviceType !== 'pc' ? 1 : 0;
                $rootScope.format = this.setFormat(false);
            },

            setFormat: function(user) {
                var platform = this.getPlatform();
                var formatConf = Config.value('GAME_FORMATS_BY_PLATFORM');
                var finalFormat = formatConf[platform] || 'html5applications'; //fallback
                if (platform === 'android'){
                    var msisdnUser = false; //is this used? I think not.
                    if(Config.value('ANDROID_PREMIUM_FULLCATALOG_ENABLED') && user) {
                        msisdnUser = !!((user.subscribed && user[Config.value('ANDROID_PREMIUM_FULLCATALOG_KEY')]));
                    }
                    //end of maybe unused
                    finalFormat = !Config.value('ANDROID_CATALOG_DISABLED') ? formatConf.android : formatConf.pc;
                }
                return finalFormat;
            },

            getPlatform: function() {
                var selector = '';
                var platform = Config.value('DEVICE_OS') || Config.value('UA') || '';
                var platformIOS = new RegExp(/iPhone|iPad|iPod|iOS|APPLE_IPHONE|APPLE_IPAD/i);
                var platformANDROID = new RegExp(/Android|ANDROID/i);
                selector = '';
                if(platform.match(platformIOS)) {
                    selector = 'ios';
                } else if(platform.match(platformANDROID)) {
                    selector = 'android';
                } else {
                    selector = 'other';
                }
                return selector;
            },

            getDeviceType: function(selector) {
                /*
                    Device type info from conf
                    result is applied as two classes to HTML element: 
                    ios | android, pc | phone | tablet
                    +===============+===========+===========+===============+================+====+
                    |   Conf key    |  iPhone   |   iPad    | Android-phone | Android-tablet | PC |
                    +===============+===========+===========+===============+================+====+
                    | IS_TABLET     | 0         | 1         | 0             | 0              | 0  |
                    +---------------+-----------+-----------+---------------+----------------+----+
                    | IS_SMARTPHONE | 1         | 0         | 1             | 0              | 0  |
                    +---------------+-----------+-----------+---------------+----------------+----+
                    | DEVICE_OS     | iPhone OS | iPhone OS | Android       | Android        | '' |
                    +---------------+-----------+-----------+---------------+----------------+----+
                */
                var deviceType = '';
                switch(selector) {
                case 'ios':
                    if(Config.value('IS_TABLET')) {
                        deviceType = 'tablet';
                    } else {
                        deviceType = 'phone';
                    }
                    break;
                case 'android':
                    if(Config.value('IS_SMARTPHONE')) {
                        deviceType = 'phone';
                    } else {
                        deviceType = 'tablet';
                    }
                    break;
                default:
                    deviceType = 'pc';
                    break;
                }
                return deviceType;
            },

            serializeObj: function(obj) {
                if(obj) {
                    var result = [];
                    for(var property in obj) {
                        result.push(encodeURIComponent(property) + '=' + encodeURIComponent(obj[property]));
                    }
                    return result.join('&');
                }
            }

        };

    }
]);

angular.module('html5Game').factory('MFP',
    ['$http', 'Config', 'Devices', '$location', 'Analytics', '$rootScope',
        function ($http, Config, Devices, $location, Analytics, $rootScope) {

            return {
                mfpSetAndGo: function(user, options){
                    var storeUrl = Devices.getPlatform() === 'ios' ? Config.value('ITUNES_STORE_URL') : Config.value('GOOGLEPLAY_STORE_URL');
                    var noStore = false;
                    var pageTitle = $location.url();
                    if (Devices.getPlatform() === 'android'){
                        var gameIntent = Config.value('GOOGLEPLAY_STORE_URL_INTENT_GAMEID');
                        if (options && options.gameId && gameIntent){
                            storeUrl = gameIntent.replace(/{GAMEID}/g, options.gameId);
                        }
                    }
                    if(options) {
                        if(options.title) {
                            pageTitle = options.title;
                        }
                        if(options.url) {
                            storeUrl = options.url;
                        }
                        if(options.noStore) {
                            noStore = true;
                        }
                    }
                    var posType = (options && options.posType && options.posType === 'midpage') ? pageTitle : 'header_banner';
                    storeUrl = storeUrl.replace('<page>', posType);


                    if(Config.value('MFP_ENABLE')) {
                        var MfpApiURL = Config.value('MFP_API_URL') + 'put?',
                            ponyApiURL = Config.value('MOA_API_CREATEPONY') + '?data=';

                        var returnURL = (options && options.returnurl) ? options.returnurl : $location.absUrl();
                        if(options && options.noStore) {
                            returnURL = '';
                        }

                        NewtonAdapter.getTransientToken(function (err, resp) {
                            var ponyParams = {
                                data: {
                                    return_url: $location.absUrl(),
                                    cookieData: {
                                        cookie: JsStorage.getMultiple(Config.value('MFP_COOKIE_LIST').split(',')) || '',
                                        newton: {}
                                    }
                                }
                            };

                            ponyParams.data.cookieData.newton.session_id = NewtonAdapter.getSessionId() ? (NewtonAdapter.getSessionId()) : '';
                            ponyParams.data.cookieData.newton.user_id = resp.token ? resp.token : resp;

                            if(Config.value('ENABLE_NEWTON_USER')){
                                ponyParams = btoa(JSON.stringify(ponyParams.data));
                            } else {
                                ponyParams = encodeURIComponent(JSON.stringify(ponyParams));
                            }

                            var mfpParams = {
                                apikey: Config.value('MOTIME_API_KEY') ? Config.value('MOTIME_API_KEY') : Config.value('MOA_API_KEY'),
                                contents_inapp: {
                                    api_country: Config.value('MFP_CONTENT_INAPP_API_COUNTRY') ? Config.value('MFP_CONTENT_INAPP_API_COUNTRY') : Config.value('API_COUNTRY'),
                                    country: Config.value('MFP_CONTENT_INAPP_TLD') ? Config.value('MFP_CONTENT_INAPP_TLD') : Config.value('TLD'),
                                    fpnamespace: Config.value('MFP_NAMESPACE') ? Config.value('MFP_NAMESPACE') : Config.value('SITE_PROFILE'),
                                    extData: {
                                        domain: Config.value('DEST_DOMAIN'),
                                        return_url: '',
                                        ponyUrl: ''
                                    }
                                },
                                country: Config.value('MFP_TLD') ? Config.value('MFP_TLD') : Config.value('TLD'),
                                expire: Config.value('MFP_EXPIRE') || 300
                            };

                            var ponyUrl;
                            $http.get(ponyApiURL + ponyParams)
                                .then(function(data) {
                                    ponyUrl = data.data.ponyUrl ? data.data.ponyUrl.replace('&', '') : '';
                                    mfpParams.contents_inapp.extData.ponyUrl = ponyUrl;
                                    mfpParams.contents_inapp.extData.return_url = (options && options.noStore) ? '' : encodeURIComponent(ponyParams.return_url);
                                    mfpParams.contents_inapp = JSON.stringify(mfpParams.contents_inapp);
                                    MfpApiURL += decodeURIComponent(Devices.serializeObj(mfpParams));
                                    //PONY REQUEST
                                    var prop = {
                                        'action': 'mfp_ponyRequest',
                                        'category': 'Behavior',
                                        'pony_url': ponyUrl,
                                        'valuable_cd': 'No',
                                        'action_cd': 'No'
                                    };
                                    Analytics.eventTrack(prop);
                                    NewtonAdapter.trackEvent({
                                        name: prop.action,
                                        properties: prop
                                    });
                                    return $http.get(MfpApiURL);
                                })
                                .then(function(data) {
                                    //MFP SET
                                    var prop2 = {
                                        'action': 'mfp_set',
                                        'category': 'Behavior',
                                        'status': data && data.data && data.data.status ? data.data.status : '',
                                        'valuable_cd': 'No',
                                        'action_cd': 'No'
                                    };
                                    Analytics.eventTrack(prop2);
                                    NewtonAdapter.trackEvent({
                                        name: prop2.action,
                                        properties: prop2
                                    });
                                    if (options && options.goFunction){
                                        options.goFunction(storeUrl, options);
                                        $rootScope.showIntentBtn = true;
                                    } else if(!noStore) {
                                        if(!!ponyUrl && Config.value('APPSFLYER_AUTOLOGIN')) {
                                            storeUrl = storeUrl.replace('<af_sub1>', encodeURIComponent(ponyUrl));
                                        }
                                        location.href = storeUrl;
                                    }
                                }).catch(function(reason) {
                                    //MFP FAIL
                                    var prop3 = {
                                        'action': 'mfp_fail',
                                        'category': 'Behavior',
                                        'valuable_cd': 'No',
                                        'action_cd': 'No'
                                    };
                                    Analytics.eventTrack(prop3);
                                    NewtonAdapter.trackEvent({
                                        name: prop3.action,
                                        properties: prop3
                                    });
                                });
                        });
                    } else {
                        setTimeout(function() {
                            $location.href = storeUrl;
                        }, 1);
                    }
                }
            };
        }
    ]
);

angular.module('CommonMod').directive('dictionary', ['$sce', 'Dictionary', 'Config', 'Utils', function($sce, Dictionary, Config, Utils) {

    return {
        restrict: 'E',
        templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/common/dictionary/dictionary.dir.html',
        replace: true,
        scope: {
            key: '='
        },
        link: function($scope, $element, $attr) {
            $scope.setDir = Utils.setTextDirection;
            var listener = $scope.$watch('key', function(input) {
                $scope.value = $sce.trustAsHtml(Dictionary.value(input));
                listener();
            });

        }
    };

}]);

angular.module('CommonMod').filter('dictionary', ['Dictionary', function(Dictionary) {

    return function(input) {
        return Dictionary.value(input);
    };

}]);

angular.module('CommonMod').provider('Dictionary', ['DictObj', function(DictObj) {

    var showKeys = false;

    // METODI DEL PROVIDER
    var myProvider = {

        configure: function(showKeysVal) {
            showKeys = showKeysVal;
        },

        value: function(input) {
            if(input) {

                // get key attribute and upper case it
                var key = input.toUpperCase();

                // get dictionary value
                if(DictObj[key]) {
                    return DictObj[key];
                } else if(showKeys) {
                    return '[[' + key.replace(/_/g, ' ') + ']]';
                } else {
                    return '';
                }

            } else {
                return null;
            }
        },

        list: function() {
            if(angular.isDefined(DictObj)) {
                return DictObj;
            } else {
                return [];
            }
        }

    };


    // aggiunge a this il myProvider riportato sopra,
    // in questo modo si possono chiamare i methods da .config()
    angular.extend(this, myProvider);

    // richiama il myProvider riportato sopra,
    // in questo modo si possono chiamare i methods da .run()
    this.$get = [function() {
        return myProvider;
    }];

}]);

angular.module('CommonMod').provider('Logger', [function() {

    var _this = this;
    _this.isEnabled = true;


    // methods
    this.configure = function(_isEnabled, sentryUrl) {
        _this.isEnabled = !!_isEnabled;
        _this.sentryUrl = sentryUrl;
    };

    // public object
    _this.$get = ['$log', 'Sentry', function($log, Sentry) {

        var sentry = new Sentry(_this.sentryUrl);

        var object = {

            log: function() {
                if(JsStorage.get('loggeractive', { type: 'cookie' })) {
                    return $log.log(Array.prototype.slice.call(arguments));
                } else {
                    return false;
                }

            },

            debug: function(value) {
                if(_this.isEnabled) {
                    return $log.debug(value);
                } else {
                    return false;
                }
            },

            warn: function(value) {
                if(_this.isEnabled) {
                    return $log.warn(value);
                } else {
                    return false;
                }
            },

            info: function(value) {
                if(_this.isEnabled) {
                    return $log.info(value);
                } else {
                    return false;
                }
            },

            error: function(value, console) {

                if(_this.isEnabled) {
                    return(sentry.error(value) && $log.error(value));
                } else {
                    return sentry.error(value);
                }
            }


        };

        return object;
    }];


}]);

angular.module('CommonMod').factory('Sentry', ['$window',
    function($window) {

        var object = function(sentryUrl) {

            if(sentryUrl) {
                Raven.config(sentryUrl).install();
            }

            this.error = function(error) {
                if($window.Raven && !!sentryUrl) {
                    Raven.captureMessage(error);
                    return true;
                } else {
                    return false;
                }
            };

        };
        return object;

    }
]).factory('$exceptionHandler', ['$window', '$log',
    function($window, $log) {
        if($window.Raven) {

            return function(exception, cause) {
                /*eslint-disable */
                $log.error.apply($log, arguments);
                /*eslint-enable */
                Raven.captureException(exception);
            };

        } else {

            return function(exception, cause) {
                /*eslint-disable */
                $log.error.apply($log, arguments);
                /*eslint-enable */
            };

        }
    }
]);

/* Add to Homescreen v3.2.3 ~ (c) 2015 Matteo Spinelli ~ @license: http://cubiq.org/license */
/*eslint-disable */
(function (window, document) {
/*
       _   _ _____     _____
 ___ _| |_| |_   _|___|  |  |___ _____ ___ ___ ___ ___ ___ ___ ___
| .'| . | . | | | | . |     | . |     | -_|_ -|  _|  _| -_| -_|   |
|__,|___|___| |_| |___|__|__|___|_|_|_|___|___|___|_| |___|___|_|_|
                              by Matteo Spinelli ~ http://cubiq.org
*/

// Check for addEventListener browser support (prevent errors in IE<9)
var _eventListener = 'addEventListener' in window;

// Check if document is loaded, needed by autostart
var _DOMReady = false;
if ( document.readyState === 'complete' ) {
	_DOMReady = true;
} else if ( _eventListener ) {
	window.addEventListener('load', loaded, false);
}

function loaded () {
	window.removeEventListener('load', loaded, false);
	_DOMReady = true;
}

// regex used to detect if app has been added to the homescreen
var _reSmartURL = /\/ath(\/)?$/;
var _reQueryString = /([\?&]ath=[^&]*$|&ath=[^&]*(&))/;

// singleton
var _instance;
function ath (options) {
	_instance = _instance || new ath.Class(options);

	return _instance;
}

// message in all supported languages
ath.intl = {
	cs_cs: {
		ios: 'Pro přidáni této webové aplikace na úvodní obrazovku: stlačte %icon a pak <strong>Přidat na úvodní obrazovku</strong>.',
		android: 'Pro přidáni této webové aplikace na úvodní obrazovku otevřete menu nastavení prohlížeče a stlačte <strong>Přidat na úvodní obrazovku</strong>. <small>K menu se dostanete stlačením hardwaroveho tlačítka, když ho vaše zařízení má, nebo stlačením pravé horní menu ikony <span class="ath-action-icon">icon</span>.</small>'
	},

	de_de: {
		ios: 'Um diese Web-App zum Home-Bildschirm hinzuzufügen, tippen Sie auf %icon und dann <strong>Zum Home-Bildschirm</strong>.',
		android: 'Um diese Web-App zum Home-Bildschirm hinzuzufügen, öffnen Sie das Menü und tippen dann auf <strong>Zum Startbildschirm hinzufügen</strong>. <small>Wenn Ihr Gerät eine Menütaste hat, lässt sich das Browsermenü über diese öffnen. Ansonsten tippen Sie auf %icon.</small>'
	},

	da_dk: {
		ios: 'For at tilføje denne web app til hjemmeskærmen: Tryk %icon og derefter <strong>Føj til hjemmeskærm</strong>.',
		android: 'For at tilføje denne web app til hjemmeskærmen, åbn browser egenskaber menuen og tryk på <strong>Føj til hjemmeskærm</strong>. <small>Denne menu kan tilgås ved at trykke på menu knappen, hvis din enhed har en, eller ved at trykke på det øverste højre menu ikon %icon.</small>'
	},

	el_gr: {
		ios: 'Για να προσθέσετε την εφαρμογή στην αρχική οθόνη: πατήστε το %icon και μετά <strong>Πρόσθεσε στην αρχική οθόνη</strong>.',
		android: 'Για να προσθέσετε την εφαρμογή στην αρχική οθόνη, ανοίξτε τις επιλογές του browser σας και πατήστε το <strong>Προσθήκη στην αρχική οθόνη</strong>. <small>Μπορείτε να έχετε πρόσβαση στο μενού, πατώντας το κουμπί του μενού του κινητού σας ή το πάνω δεξιά κουμπί του μενού %icon.</small>'
	},

	en_us: {
		ios: 'To add this web app to the home screen: tap %icon and then <strong>Add to Home Screen</strong>.',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon %icon.</small>'
	},

	es_es: {
		ios: 'Para añadir esta aplicación web a la pantalla de inicio: pulsa %icon y selecciona <strong>Añadir a pantalla de inicio</strong>.',
		android: 'Para añadir esta aplicación web a la pantalla de inicio, abre las opciones y pulsa <strong>Añadir a pantalla inicio</strong>. <small>El menú se puede acceder pulsando el botón táctil en caso de tenerlo, o bien el icono de la parte superior derecha de la pantalla %icon.</small>'
	},

	fi_fi: {
		ios: 'Liitä tämä sovellus kotivalikkoon: klikkaa %icon ja tämän jälkeen <strong>Lisää kotivalikkoon</strong>.',
		android: 'Lisätäksesi tämän sovelluksen aloitusnäytölle, avaa selaimen valikko ja klikkaa tähti -ikonia tai <strong>Lisää aloitusnäytölle tekstiä</strong>. <small>Valikkoon pääsee myös painamalla menuvalikkoa, jos laitteessasi on sellainen tai koskettamalla oikealla yläkulmassa menu ikonia %icon.</small>'
	},

	fr_fr: {
		ios: 'Pour ajouter cette application web sur l\'écran d\'accueil : Appuyez %icon et sélectionnez <strong>Ajouter sur l\'écran d\'accueil</strong>.',
		android: 'Pour ajouter cette application web sur l\'écran d\'accueil : Appuyez sur le bouton "menu", puis sur <strong>Ajouter sur l\'écran d\'accueil</strong>. <small>Le menu peut-être accessible en appuyant sur le bouton "menu" du téléphone s\'il en possède un <i class="fa fa-bars"></i>. Sinon, il se trouve probablement dans la coin supérieur droit du navigateur %icon.</small>'
	},

	he_il: {
		ios: '<span dir="rtl">להוספת האפליקציה למסך הבית: ללחוץ על %icon ואז <strong>הוסף למסך הבית</strong>.</span>',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon %icon.</small>'
	},

	hu_hu: {
		ios: 'Ha hozzá szeretné adni ezt az alkalmazást a kezdőképernyőjéhez, érintse meg a következő ikont: %icon , majd a <strong>Hozzáadás a kezdőképernyőhöz</strong> menüpontot.',
		android: 'Ha hozzá szeretné adni ezt az alkalmazást a kezdőképernyőjéhez, a böngésző menüjében kattintson a <strong>Hozzáadás a kezdőképernyőhöz</strong> menüpontra. <small>A böngésző menüjét a következő ikon megérintésével tudja megnyitni: %icon.</small>'
	},

	it_it: {
		ios: 'Per aggiungere questa web app alla schermata iniziale: premi %icon e poi <strong>Aggiungi a Home</strong>.',
		android: 'Per aggiungere questa web app alla schermata iniziale, apri il menu opzioni del browser e premi su <strong>Aggiungi alla homescreen</strong>. <small>Puoi accedere al menu premendo il pulsante hardware delle opzioni se la tua device ne ha uno, oppure premendo l\'icona %icon in alto a destra.</small>'
	},

	ja_jp: {
		ios: 'このウェプアプリをホーム画面に追加するには、%iconをタップして<strong>ホーム画面に追加</strong>してください。',
		android: 'このウェプアプリをホーム画面に追加するには、ブラウザのオプションメニューから<strong>ホーム画面に追加</strong>をタップしてください。<small>オプションメニューは、一部の機種ではデバイスのメニューボタンから、それ以外では画面右上の%iconからアクセスできます。</small>'
 	},

	ko_kr: {
		ios: '홈 화면에 바로가기 생성: %icon 을 클릭한 후 <strong>홈 화면에 추가</strong>.',
		android: '브라우저 옵션 메뉴의 <string>홈 화면에 추가</string>를 클릭하여 홈화면에 바로가기를 생성할 수 있습니다. <small>옵션 메뉴는 장치의 메뉴 버튼을 누르거나 오른쪽 상단의 메뉴 아이콘 %icon을 클릭하여 접근할 수 있습니다.</small>'
	},

	nb_no: {
		ios: 'For å installere denne appen på hjem-skjermen: trykk på %icon og deretter <strong>Legg til på Hjem-skjerm</strong>.',
		android: 'For å legge til denne webappen på startsiden åpner en nettlesermenyen og velger <strong>Legg til på startsiden</strong>. <small>Menyen åpnes ved å trykke på den fysiske menyknappen hvis enheten har det, eller ved å trykke på menyikonet øverst til høyre %icon.</small>'
	},

	pt_br: {
		ios: 'Para adicionar este app à tela de início: clique %icon e então <strong>Tela de início</strong>.',
		android: 'Para adicionar este app à tela de início, abra o menu de opções do navegador e selecione <strong>Adicionar à tela inicial</strong>. <small>O menu pode ser acessado pressionando o "menu" button se o seu dispositivo tiver um, ou selecionando o ícone %icon no canto superior direito.</small>'
	},

	pt_pt: {
		ios: 'Para adicionar esta app ao ecrã principal: clique %icon e depois <strong>Ecrã principal</strong>.',
		android: 'Para adicionar esta app web ecrã principal, abra o menu de opções do navegador e selecione <strong>Adicionar à tela inicial</strong>. <small>O menu pode ser acessado pressionando o "menu" button se o seu dispositivo tiver um, ou selecionando o ícone %icon no canto superior direito.</small>'
	},

	nl_nl: {
		ios: 'Om deze webapp aan je startscherm toe te voegen, klik op %icon en dan <strong>Zet in startscherm</strong>.',
		android: 'Om deze webapp aan je startscherm toe te voegen, open de browserinstellingen en tik op <strong>Toevoegen aan startscherm</strong>. <small>Gebruik de "menu" knop als je telefoon die heeft, anders het menu-icoon rechtsbovenin %icon.</small>'
	},

	ru_ru: {
		ios: 'Чтобы добавить этот сайт на свой домашний экран, нажмите на иконку %icon и затем <strong>На экран "Домой"</strong>.',
		android: 'Чтобы добавить сайт на свой домашний экран, откройте меню браузера и нажмите на <strong>Добавить на главный экран</strong>. <small>Меню можно вызвать, нажав на кнопку меню вашего телефона, если она есть. Или найдите иконку сверху справа %icon[иконка].</small>'
	},

	sk_sk: {
		ios: 'Pre pridanie tejto webovej aplikácie na úvodnú obrazovku: stlačte %icon a potom <strong>Pridať na úvodnú obrazovku</strong>.',
		android: 'Pre pridanie tejto webovej aplikácie na úvodnú obrazovku otvorte menu nastavenia prehliadača a stlačte <strong>Pridať na úvodnú obrazovku</strong>. <small>K menu sa dostanete stlačením hardwaroveho tlačidla, ak ho vaše zariadenie má, alebo stlačením pravej hornej menu ikony <span class="ath-action-icon">icon</span>.</small>'
	},

	sv_se: {
		ios: 'För att lägga till denna webbapplikation på hemskärmen: tryck på %icon och därefter <strong>Lägg till på hemskärmen</strong>.',
		android: 'För att lägga till den här webbappen på hemskärmen öppnar du webbläsarens alternativ-meny och väljer <strong>Lägg till på startskärmen</strong>. <small>Man hittar menyn genom att trycka på hårdvaruknappen om din enhet har en sådan, eller genom att trycka på menyikonen högst upp till höger %icon.</small>'
	},

	tr_tr: {
		ios: 'Uygulamayı ana ekrana eklemek için, %icon ve ardından <strong>ana ekrana ekle</strong> butonunu tıklayın.',
		android: 'Uygulamayı ana ekrana eklemek için, menüye girin ve <strong>ana ekrana ekle</strong> butonunu tıklayın. <small>Cihazınız menü tuşuna sahip ise menüye girmek için menü tuşunu tıklayın. Aksi takdirde %icon butonunu tıklayın.</small>'
	},

	uk_ua: {
		ios: 'Щоб додати цей сайт на початковий екран, натисніть %icon, а потім <strong>На початковий екран</strong>.',
		android: 'Щоб додати цей сайт на домашній екран, відкрийте меню браузера та виберіть <strong>Додати на головний екран</strong>. <small>Це можливо зробити, натиснувши кнопку меню на вашому смартфоні, якщо така є. Або ж на іконці зверху справа %icon.</small>'
	},

	zh_cn: {
		ios: '如要把应用程序加至主屏幕,请点击%icon, 然后<strong>添加到主屏幕</strong>',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon %icon.</small>'
	},

	zh_tw: {
		ios: '如要把應用程式加至主屏幕, 請點擊%icon, 然後<strong>加至主屏幕</strong>.',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon %icon.</small>'
	}
};

// Add 2 characters language support (Android mostly)
for ( var lang in ath.intl ) {
	ath.intl[lang.substr(0, 2)] = ath.intl[lang];
}

// default options
ath.defaults = {
	appID: 'org.cubiq.addtohome',		// local storage name (no need to change)
	fontSize: 15,				// base font size, used to properly resize the popup based on viewport scale factor
	debug: false,				// override browser checks
	logging: false,				// log reasons for showing or not showing to js console; defaults to true when debug is true
	modal: false,				// prevent further actions until the message is closed
	mandatory: false,			// you can't proceed if you don't add the app to the homescreen
	autostart: true,			// show the message automatically
	skipFirstVisit: false,		// show only to returning visitors (ie: skip the first time you visit)
	startDelay: 1,				// display the message after that many seconds from page load
	lifespan: 15,				// life of the message in seconds
	displayPace: 1440,			// minutes before the message is shown again (0: display every time, default 24 hours)
	maxDisplayCount: 0,			// absolute maximum number of times the message will be shown to the user (0: no limit)
	icon: true,					// add touch icon to the message
	message: '',				// the message can be customized
	validLocation: [],			// list of pages where the message will be shown (array of regexes)
	onInit: null,				// executed on instance creation
	onShow: null,				// executed when the message is shown
	onRemove: null,				// executed when the message is removed
	onAdd: null,				// when the application is launched the first time from the homescreen (guesstimate)
	onPrivate: null,			// executed if user is in private mode
	privateModeOverride: false,	// show the message even in private mode (very rude)
	detectHomescreen: false		// try to detect if the site has been added to the homescreen (false | true | 'hash' | 'queryString' | 'smartURL')
};

// browser info and capability
var _ua = window.navigator.userAgent;

var _nav = window.navigator;
_extend(ath, {
	hasToken: document.location.hash == '#ath' || _reSmartURL.test(document.location.href) || _reQueryString.test(document.location.search),
	isRetina: window.devicePixelRatio && window.devicePixelRatio > 1,
	isIDevice: (/iphone|ipod|ipad/i).test(_ua),
	isMobileChrome: _ua.indexOf('Android') > -1 && (/Chrome\/[.0-9]*/).test(_ua) && _ua.indexOf("Version") == -1,
	isMobileIE: _ua.indexOf('Windows Phone') > -1,
	language: _nav.language && _nav.language.toLowerCase().replace('-', '_') || ''
});

// falls back to en_us if language is unsupported
ath.language = ath.language && ath.language in ath.intl ? ath.language : 'en_us';

ath.isMobileSafari = ath.isIDevice && _ua.indexOf('Safari') > -1 && _ua.indexOf('CriOS') < 0;
ath.OS = ath.isIDevice ? 'ios' : ath.isMobileChrome ? 'android' : ath.isMobileIE ? 'windows' : 'unsupported';

ath.OSVersion = _ua.match(/(OS|Android) (\d+[_\.]\d+)/);
ath.OSVersion = ath.OSVersion && ath.OSVersion[2] ? +ath.OSVersion[2].replace('_', '.') : 0;

ath.isStandalone = 'standalone' in window.navigator && window.navigator.standalone;
ath.isTablet = (ath.isMobileSafari && _ua.indexOf('iPad') > -1) || (ath.isMobileChrome && _ua.indexOf('Mobile') < 0);

ath.isCompatible = (ath.isMobileSafari && ath.OSVersion >= 6) || ath.isMobileChrome;	// TODO: add winphone

var _defaultSession = {
	lastDisplayTime: 0,			// last time we displayed the message
	returningVisitor: false,	// is this the first time you visit
	displayCount: 0,			// number of times the message has been shown
	optedout: false,			// has the user opted out
	added: false				// has been actually added to the homescreen
};

ath.removeSession = function (appID) {
	try {
		if (!localStorage) {
			throw new Error('localStorage is not defined');
		}

		localStorage.removeItem(appID || ath.defaults.appID);
	} catch (e) {
		// we are most likely in private mode
	}
};

ath.doLog = function (logStr) {
	if ( this.options.logging ) {
		console.log(logStr);
	}
};

ath.Class = function (options) {
	// class methods
	this.doLog = ath.doLog;

	// merge default options with user config
	this.options = _extend({}, ath.defaults);
	_extend(this.options, options);
	// override defaults that are dependent on each other
	if ( this.options && this.options.debug && (typeof this.options.logging === "undefined") ) {
		this.options.logging = true;
	}

	// IE<9 so exit (I hate you, really)
	if ( !_eventListener ) {
		return;
	}

	// normalize some options
	this.options.mandatory = this.options.mandatory && ( 'standalone' in window.navigator || this.options.debug );
	this.options.modal = this.options.modal || this.options.mandatory;
	if ( this.options.mandatory ) {
		this.options.startDelay = -0.5;		// make the popup hasty
	}
	this.options.detectHomescreen = this.options.detectHomescreen === true ? 'hash' : this.options.detectHomescreen;

	// setup the debug environment
	if ( this.options.debug ) {
		ath.isCompatible = true;
		ath.OS = typeof this.options.debug == 'string' ? this.options.debug : ath.OS == 'unsupported' ? 'android' : ath.OS;
		ath.OSVersion = ath.OS == 'ios' ? '8' : '4';
	}

	// the element the message will be appended to
	this.container = document.body;

	// load session
	this.session = this.getItem(this.options.appID);
	this.session = this.session ? JSON.parse(this.session) : undefined;

	// user most likely came from a direct link containing our token, we don't need it and we remove it
	if ( ath.hasToken && ( !ath.isCompatible || !this.session ) ) {
		ath.hasToken = false;
		_removeToken();
	}

	// the device is not supported
	if ( !ath.isCompatible ) {
 		this.doLog("Add to homescreen: not displaying callout because device not supported");
		return;
	}

	this.session = this.session || _defaultSession;

	// check if we can use the local storage
	try {
		if (!localStorage) {
			throw new Error('localStorage is not defined');
		}

		localStorage.setItem(this.options.appID, JSON.stringify(this.session));
		ath.hasLocalStorage = true;
	} catch (e) {
		// we are most likely in private mode
		ath.hasLocalStorage = false;

		if ( this.options.onPrivate ) {
			this.options.onPrivate.call(this);
		}
	}

	// check if this is a valid location
	var isValidLocation = !this.options.validLocation.length;
	for ( var i = this.options.validLocation.length; i--; ) {
		if ( this.options.validLocation[i].test(document.location.href) ) {
			isValidLocation = true;
			break;
		}
	}

	// check compatibility with old versions of add to homescreen. Opt-out if an old session is found
	if ( this.getItem('addToHome') ) {
		this.optOut();
	}

	// critical errors:
	if ( this.session.optedout ) {
		this.doLog("Add to homescreen: not displaying callout because user opted out");
		return;
	}
	if ( this.session.added ) {
		this.doLog("Add to homescreen: not displaying callout because already added to the homescreen");
		return;
	}
	if ( !isValidLocation ) {
		this.doLog("Add to homescreen: not displaying callout because not a valid location");
		return;
	}

	// check if the app is in stand alone mode
	if ( ath.isStandalone ) {
		// execute the onAdd event if we haven't already
		if ( !this.session.added ) {
			this.session.added = true;
			this.updateSession();

			if ( this.options.onAdd && ath.hasLocalStorage ) {	// double check on localstorage to avoid multiple calls to the custom event
				this.options.onAdd.call(this);
			}
		}

		this.doLog("Add to homescreen: not displaying callout because in standalone mode");
		return;
	}

	// (try to) check if the page has been added to the homescreen
	if ( this.options.detectHomescreen ) {
		// the URL has the token, we are likely coming from the homescreen
		if ( ath.hasToken ) {
			_removeToken();		// we don't actually need the token anymore, we remove it to prevent redistribution

			// this is called the first time the user opens the app from the homescreen
			if ( !this.session.added ) {
				this.session.added = true;
				this.updateSession();

				if ( this.options.onAdd && ath.hasLocalStorage ) {	// double check on localstorage to avoid multiple calls to the custom event
					this.options.onAdd.call(this);
				}
			}

			this.doLog("Add to homescreen: not displaying callout because URL has token, so we are likely coming from homescreen");
			return;
		}

		// URL doesn't have the token, so add it
		if ( this.options.detectHomescreen == 'hash' ) {
			history.replaceState('', window.document.title, document.location.href + '#ath');
		} else if ( this.options.detectHomescreen == 'smartURL' ) {
			history.replaceState('', window.document.title, document.location.href.replace(/(\/)?$/, '/ath$1'));
		} else {
			history.replaceState('', window.document.title, document.location.href + (document.location.search ? '&' : '?' ) + 'ath=');
		}
	}

	// check if this is a returning visitor
	if ( !this.session.returningVisitor ) {
		this.session.returningVisitor = true;
		this.updateSession();

		// we do not show the message if this is your first visit
		if ( this.options.skipFirstVisit ) {
			this.doLog("Add to homescreen: not displaying callout because skipping first visit");
			return;
		}
	}

	// we do no show the message in private mode
	if ( !this.options.privateModeOverride && !ath.hasLocalStorage ) {
		this.doLog("Add to homescreen: not displaying callout because browser is in private mode");
		return;
	}

	// all checks passed, ready to display
	this.ready = true;

	if ( this.options.onInit ) {
		this.options.onInit.call(this);
	}

	if ( this.options.autostart ) {
		this.doLog("Add to homescreen: autostart displaying callout");
		this.show();
	}
};

ath.Class.prototype = {
	// event type to method conversion
	events: {
		load: '_delayedShow',
		error: '_delayedShow',
		orientationchange: 'resize',
		resize: 'resize',
		scroll: 'resize',
		click: 'remove',
		touchmove: '_preventDefault',
		transitionend: '_removeElements',
		webkitTransitionEnd: '_removeElements',
		MSTransitionEnd: '_removeElements'
	},

	handleEvent: function (e) {
		var type = this.events[e.type];
		if ( type ) {
			this[type](e);
		}
	},

	show: function (force) {
		// in autostart mode wait for the document to be ready
		if ( this.options.autostart && !_DOMReady ) {
			setTimeout(this.show.bind(this), 50);
			// we are not displaying callout because DOM not ready, but don't log that because
			// it would log too frequently
			return;
		}

		// message already on screen
		if ( this.shown ) {
			this.doLog("Add to homescreen: not displaying callout because already shown on screen");
			return;
		}

		var now = Date.now();
		var lastDisplayTime = this.session.lastDisplayTime;

		if ( force !== true ) {
			// this is needed if autostart is disabled and you programmatically call the show() method
			if ( !this.ready ) {
				this.doLog("Add to homescreen: not displaying callout because not ready");
				return;
			}

			// we obey the display pace (prevent the message to popup too often)
			if ( now - lastDisplayTime < this.options.displayPace * 60000 ) {
				this.doLog("Add to homescreen: not displaying callout because displayed recently");
				return;
			}

			// obey the maximum number of display count
			if ( this.options.maxDisplayCount && this.session.displayCount >= this.options.maxDisplayCount ) {
				this.doLog("Add to homescreen: not displaying callout because displayed too many times already");
				return;
			}
		}

		this.shown = true;

		// increment the display count
		this.session.lastDisplayTime = now;
		this.session.displayCount++;
		this.updateSession();

		// try to get the highest resolution application icon
		if ( !this.applicationIcon ) {
			if ( ath.OS == 'ios' ) {
				this.applicationIcon = document.querySelector('head link[rel^=apple-touch-icon][sizes="152x152"],head link[rel^=apple-touch-icon][sizes="144x144"],head link[rel^=apple-touch-icon][sizes="120x120"],head link[rel^=apple-touch-icon][sizes="114x114"],head link[rel^=apple-touch-icon]');
			} else {
				this.applicationIcon = document.querySelector('head link[rel^="shortcut icon"][sizes="196x196"],head link[rel^=apple-touch-icon]');
			}
		}

		var message = '';

		if ( typeof this.options.message == 'object' && ath.language in this.options.message ) {		// use custom language message
			message = this.options.message[ath.language][ath.OS];
		} else if ( typeof this.options.message == 'object' && ath.OS in this.options.message ) {		// use custom os message
			message = this.options.message[ath.OS];
		} else if ( this.options.message in ath.intl ) {				// you can force the locale
			message = ath.intl[this.options.message][ath.OS];
		} else if ( this.options.message !== '' ) {						// use a custom message
			message = this.options.message;
		} else if ( ath.OS in ath.intl[ath.language] ) {				// otherwise we use our message
			message = ath.intl[ath.language][ath.OS];
		}

		// add the action icon
		message = '<p>' + message.replace(/%icon(?:\[([^\]]+)\])?/gi, function(matches, group1) {
			return '<span class="ath-action-icon">' + (!!group1 ? group1 : 'icon') + '</span>';
		}) + '</p>';

		// create the message container
		this.viewport = document.createElement('div');
		this.viewport.className = 'ath-viewport';
		if ( this.options.modal ) {
			this.viewport.className += ' ath-modal';
		}
		if ( this.options.mandatory ) {
			this.viewport.className += ' ath-mandatory';
		}
		this.viewport.style.position = 'absolute';

		// create the actual message element
        this.element = document.createElement('div');
        this.closeBtn = document.createElement('div');
        this.closeBtn.className = 'closeBtn';
        this.closeBtn.setAttribute('data-mipqa','btn-close-add2home');
		this.element.className = 'ath-container ath-' + ath.OS + ' ath-' + ath.OS + (parseInt(ath.OSVersion) || '') + ' ath-' + (ath.isTablet ? 'tablet' : 'phone');
		this.element.style.cssText = '-webkit-transition-property:-webkit-transform,opacity;-webkit-transition-duration:0s;-webkit-transition-timing-function:ease-out;transition-property:transform,opacity;transition-duration:0s;transition-timing-function:ease-out;';
		this.element.style.webkitTransform = 'translate3d(0,-' + window.innerHeight + 'px,0)';
		this.element.style.transform = 'translate3d(0,-' + window.innerHeight + 'px,0)';
        this.element.appendChild(this.closeBtn);
		// add the application icon
		if ( this.options.icon && this.applicationIcon ) {
			this.element.className += ' ath-icon';
			this.img = document.createElement('img');
			this.img.className = 'ath-application-icon';
			this.img.addEventListener('load', this, false);
			this.img.addEventListener('error', this, false);

			this.img.src = this.applicationIcon.href;
			this.element.appendChild(this.img);
		}

		this.element.innerHTML += message;

		// we are not ready to show, place the message out of sight
		this.viewport.style.left = '-99999em';

		// attach all elements to the DOM
		this.viewport.appendChild(this.element);
		this.container.appendChild(this.viewport);

		// if we don't have to wait for an image to load, show the message right away
		if ( this.img ) {
			this.doLog("Add to homescreen: not displaying callout because waiting for img to load");
		} else {
			this._delayedShow();
		}
	},

	_delayedShow: function (e) {
		setTimeout(this._show.bind(this), this.options.startDelay * 1000 + 500);
	},

	_show: function () {
		var that = this;

		// update the viewport size and orientation
		this.updateViewport();

		// reposition/resize the message on orientation change
		window.addEventListener('resize', this, false);
		window.addEventListener('scroll', this, false);
		window.addEventListener('orientationchange', this, false);

		if ( this.options.modal ) {
			// lock any other interaction
			document.addEventListener('touchmove', this, true);
		}

		// Enable closing after 1 second
		if ( !this.options.mandatory ) {
			setTimeout(function () {
				that.element.children[0].addEventListener('click', that, true);
			}, 1000);
		}

		// kick the animation
		setTimeout(function () {
			that.element.style.webkitTransitionDuration = '1.2s';
			that.element.style.transitionDuration = '1.2s';
			that.element.style.webkitTransform = 'translate3d(0,0,0)';
			that.element.style.transform = 'translate3d(0,0,0)';
		}, 0);

		// set the destroy timer
		if ( this.options.lifespan ) {
			this.removeTimer = setTimeout(this.remove.bind(this), this.options.lifespan * 1000);
		}

		// fire the custom onShow event
		if ( this.options.onShow ) {
			this.options.onShow.call(this);
		}
	},

	remove: function () {
		clearTimeout(this.removeTimer);

		// clear up the event listeners
		if ( this.img ) {
			this.img.removeEventListener('load', this, false);
			this.img.removeEventListener('error', this, false);
		}

		window.removeEventListener('resize', this, false);
		window.removeEventListener('scroll', this, false);
		window.removeEventListener('orientationchange', this, false);
		document.removeEventListener('touchmove', this, true);
		this.closeBtn.removeEventListener('click', this, true);

		// remove the message element on transition end
		this.element.addEventListener('transitionend', this, false);
		this.element.addEventListener('webkitTransitionEnd', this, false);
		this.element.addEventListener('MSTransitionEnd', this, false);

		// start the fade out animation
		this.element.style.webkitTransitionDuration = '0.3s';
		this.element.style.opacity = '0';
	},

	_removeElements: function () {
		this.element.removeEventListener('transitionend', this, false);
		this.element.removeEventListener('webkitTransitionEnd', this, false);
		this.element.removeEventListener('MSTransitionEnd', this, false);

		// remove the message from the DOM
		this.container.removeChild(this.viewport);

		this.shown = false;

		// fire the custom onRemove event
		if ( this.options.onRemove ) {
			this.options.onRemove.call(this);
		}
	},

	updateViewport: function () {
		if ( !this.shown ) {
			return;
		}

		this.viewport.style.width = window.innerWidth + 'px';
		this.viewport.style.height = window.innerHeight + 'px';
		this.viewport.style.left = window.scrollX + 'px';
		this.viewport.style.top = window.scrollY + 'px';

		var clientWidth = document.documentElement.clientWidth;

		this.orientation = clientWidth > document.documentElement.clientHeight ? 'landscape' : 'portrait';

		var screenWidth = ath.OS == 'ios' ? this.orientation == 'portrait' ? screen.width : screen.height : screen.width;
		this.scale = screen.width > clientWidth ? 1 : screenWidth / window.innerWidth;

		this.element.style.fontSize = this.options.fontSize / this.scale + 'px';
	},

	resize: function () {
		clearTimeout(this.resizeTimer);
		this.resizeTimer = setTimeout(this.updateViewport.bind(this), 100);
	},

	updateSession: function () {
		if ( ath.hasLocalStorage === false ) {
			return;
		}

        if (localStorage) {
            localStorage.setItem(this.options.appID, JSON.stringify(this.session));
        }
	},

	clearSession: function () {
		this.session = _defaultSession;
		this.updateSession();
	},

	getItem: function(item) {
		try {
			if (!localStorage) {
				throw new Error('localStorage is not defined');
			}

			return localStorage.getItem(item);
		} catch(e) {
			// Preventing exception for some browsers when fetching localStorage key
			ath.hasLocalStorage = false;
		}
	},

	optOut: function () {
		this.session.optedout = true;
		this.updateSession();
	},

	optIn: function () {
		this.session.optedout = false;
		this.updateSession();
	},

	clearDisplayCount: function () {
		this.session.displayCount = 0;
		this.updateSession();
	},

	_preventDefault: function (e) {
		e.preventDefault();
		e.stopPropagation();
	}
};

// utility
function _extend (target, obj) {
	for ( var i in obj ) {
		target[i] = obj[i];
	}

	return target;
}

function _removeToken () {
	if ( document.location.hash == '#ath' ) {
		history.replaceState('', window.document.title, document.location.href.split('#')[0]);
	}

	if ( _reSmartURL.test(document.location.href) ) {
		history.replaceState('', window.document.title, document.location.href.replace(_reSmartURL, '$1'));
	}

	if ( _reQueryString.test(document.location.search) ) {
		history.replaceState('', window.document.title, document.location.href.replace(_reQueryString, '$2'));
	}
}

// expose to the world
window.addToHomescreen = ath;

})(window, document);
/*eslint-enable */

angular.module('CommonMod').factory('Analytics', [
    '$rootScope', 'Config', '$location',
    function($rootScope, Config, $location) {

        /**
         * Track Google Analytics pageview
         * @function pageTrack
         * @memberof Analytics
         * @param {string} path - path of page (e.g. /favorites, /games/gamename_gameid)
         */
        this.pageTrack = function(path, properties) {
            if (Config.value('ENABLE_ANALYTICS')){
                var obj = {
                    hitType: 'pageview',
                    page: path
                };
                if(properties && properties.ref_cd) {
                    obj.dimension10 = properties.ref_cd;
                }
              //soluzione sudicia per la migrazione DV
                analytics('send', obj);
            }
        };

        /**
         * Track Google Analytics event
         * @function eventTrack
         * @memberof Analytics
         * @param {object} properties - configuration
         * @param {string} [properties.type] - Set type, required
         * @param {string} [properties.category] - Set category, required
         * @param {string} [properties.action] - Set action, required
         * @param {string} [properties.value] - Set value, optional
         * @param {string} [properties.label] - Set label, optional
         * @param {string} [properties.noninteraction] - Set noninteraction, optional
         * @param {object} [properties.valuable_cd] - Set valuable customdim, optional
         * @param {object} [properties.action_cd] - Set action customdim, optional
         * @param {object} [properties.ref_cd] - Set ref customdim, optional
         * @param {object} [properties.customdim] - Set customdim, optional
         */
        this.eventTrack = function(properties) {
          
            if (Config.value('ENABLE_ANALYTICS')){
                var obj = {
                    hitType: 'event', // required
                    eventCategory: properties.category, // required
                    eventAction: properties.action // required 
                };

                if(properties.value) {
                    var parsed = parseInt(properties.value, 10);
                    obj.eventValue = isNaN(parsed) ? 0 : parsed;
                }

                if(properties.title) {
                    obj.title = properties.title;
                }

                if(properties.label) {
                    if(properties.label === '<Page>') {
                        obj.eventLabel = $location.url();
                    } else {
                        obj.eventLabel = properties.label;
                    }
                }

                // predefined custom dimensions 
                if(properties.valuable_cd) {
                    obj.dimension5 = properties.valuable_cd;
                }
                if(properties.action_cd) {
                    obj.dimension8 = properties.action_cd;
                }

                // free custom dimensions 
                if(properties.customdim && properties.customdim.key) {
                    obj['dimension' + properties.customdim.key] = properties.customdim.value;
                }

                if(properties.noninteraction) {
                    obj.nonInteraction = 1;
                }
            
                analytics('send', obj);
            }
        };

        /**
         * Set custom dimension, usually used for session/user dimensions
         * @function setDimension
         * @memberof Analytics
         * @param {integer} dimension - slot number of custom dimension
         * @param {string} value - value of custom dimension
         */
        this.setDimension = function(dimension, value) {
            if (Config.value('ENABLE_ANALYTICS')){
                if(typeof dimension === 'number') {
                    dimension = 'dimension' + dimension;
                }
            
                analytics('set', dimension, value);
            }
        };

        /**
         * Set custom metric, usually used for session/user metric
         * @function setMetric
         * @memberof Analytics
         * @param {integer} metric - slot number of custom metric
         * @param {string} value - value of custom metric
         */
        this.setMetric = function(metric, value) {
            if (Config.value('ENABLE_ANALYTICS')){
                if(typeof metric === 'number') {
                    metric = 'metric' + metric;
                }
            
                analytics('set', metric, value);
            }
        };

        /**
         * Set free property
         * @function set
         * @memberof Analytics
         * @param {string} property - name of property
         * @param {string} value - value of property
         */
        this.set = function(property, value) {
            if (Config.value('ENABLE_ANALYTICS')){
                analytics('set', property, value);
            }
        };

        return this;
    }
]);

/*eslint-disable */
angular.module('html5Game').factory('GoogleManager',
    ['$rootScope', '$q', 'Config', 'Dictionary', function($rootScope, $q, Config, Dictionary) {

        var defaultDataLayer = {};
        var defer = $q.defer();

        this.init = function(initDL){
            defaultDataLayer = initDL;

            if(Config.value('GOOGLE_TAG_ENABLE') && Config.value('GOOGLE_TAG_ID') && Config.value('ENABLE_DATA_LAYER_MANAGER')){
																window.dataLayer.push(initDL);
																
																(function(w,d,s,l,i){w[l] = w[l] || [];w[l].push({'gtm.start':
																new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
																j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
																'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
																})(window,document,'script','dataLayer',Config.value('GOOGLE_TAG_ID'));
																
            }
            defer.resolve();
        };

        this.set = function(setDL){
            //console.log(['API', 'Header', '3', setDL]);
            defer.promise.then(function(){
                if(Config.value('GOOGLE_TAG_ENABLE') && Config.value('GOOGLE_TAG_ID') && Config.value('ENABLE_DATA_LAYER_MANAGER')){
                    var newDataLayer = {};

                    for(var ddlKey in defaultDataLayer){
                        newDataLayer[ddlKey] = defaultDataLayer[ddlKey];
                        //console.log(defaultDataLayer[ddlKey], defaultDataLayer);
                    }
                    for(var sdlKey in setDL){
                        newDataLayer[sdlKey] = setDL[sdlKey];
                        //console.log(setDL[sdlKey], setDL);
                    }
										window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push(newDataLayer);
                   
                    //console.log(['API', 'Header', '4', newDataLayer]);

                }
            });
        };

        return this;
    }]
);
/*eslint-enable */
/*
* angular-ui-bootstrap
* http://angular-ui.github.io/bootstrap/

* Version: 2.5.0 - 2017-01-28
* License: MIT
*/
/*eslint-disable*/
angular.module("ui.bootstrap", ["ui.bootstrap.tpls","ui.bootstrap.accordion","ui.bootstrap.collapse","ui.bootstrap.tabindex"]);
angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html","uib/template/accordion/accordion.html"]);
angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex'])

.constant('uibAccordionConfig', {
closeOthers: true
})

.controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function($scope, $attrs, accordionConfig) {
// This array keeps track of the accordion groups
this.groups = [];

// Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
this.closeOthers = function(openGroup) {
var closeOthers = angular.isDefined($attrs.closeOthers) ?
    $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
if (closeOthers) {
    angular.forEach(this.groups, function(group) {
    if (group !== openGroup) {
        group.isOpen = false;
    }
    });
}
};

// This is called from the accordion-group directive to add itself to the accordion
this.addGroup = function(groupScope) {
var that = this;
this.groups.push(groupScope);

groupScope.$on('$destroy', function(event) {
    that.removeGroup(groupScope);
});
};

// This is called from the accordion-group directive when to remove itself
this.removeGroup = function(group) {
var index = this.groups.indexOf(group);
if (index !== -1) {
    this.groups.splice(index, 1);
}
};
}])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
.directive('uibAccordion', function() {
return {
controller: 'UibAccordionController',
controllerAs: 'accordion',
transclude: true,
templateUrl: function(element, attrs) {
    return attrs.templateUrl || 'uib/template/accordion/accordion.html';
}
};
})

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
.directive('uibAccordionGroup', function() {
return {
require: '^uibAccordion',         // We need this directive to be inside an accordion
transclude: true,              // It transcludes the contents of the directive into the template
restrict: 'A',
templateUrl: function(element, attrs) {
    return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
},
scope: {
    heading: '@',               // Interpolate the heading attribute onto this scope
    panelClass: '@?',           // Ditto with panelClass
    isOpen: '=?',
    isDisabled: '=?'
},
controller: function() {
    this.setHeading = function(element) {
    this.heading = element;
    };
},
link: function(scope, element, attrs, accordionCtrl) {
    element.addClass('panel');
    accordionCtrl.addGroup(scope);

    scope.openClass = attrs.openClass || 'panel-open';
    scope.panelClass = attrs.panelClass || 'panel-default';
    scope.$watch('isOpen', function(value) {
    element.toggleClass(scope.openClass, !!value);
    if (value) {
        accordionCtrl.closeOthers(scope);
    }
    });

    scope.toggleOpen = function($event) {
    if (!scope.isDisabled) {
        if (!$event || $event.which === 32) {
        scope.isOpen = !scope.isOpen;
        }
    }
    };

    var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
    scope.headingId = id + '-tab';
    scope.panelId = id + '-panel';
}
};
})

// Use accordion-heading below an accordion-group to provide a heading containing HTML
.directive('uibAccordionHeading', function() {
return {
transclude: true,   // Grab the contents to be used as the heading
template: '',       // In effect remove this element!
replace: true,
require: '^uibAccordionGroup',
link: function(scope, element, attrs, accordionGroupCtrl, transclude) {
    // Pass the heading to the accordion-group controller
    // so that it can be transcluded into the right place in the template
    // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
    accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
}
};
})

// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
.directive('uibAccordionTransclude', function() {
return {
require: '^uibAccordionGroup',
link: function(scope, element, attrs, controller) {
    scope.$watch(function() { return controller[attrs.uibAccordionTransclude]; }, function(heading) {
    if (heading) {
        var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
        elem.html('');
        elem.append(heading);
    }
    });
}
};

function getHeaderSelectors() {
    return 'uib-accordion-header,' +
        'data-uib-accordion-header,' +
        'x-uib-accordion-header,' +
        'uib\\:accordion-header,' +
        '[uib-accordion-header],' +
        '[data-uib-accordion-header],' +
        '[x-uib-accordion-header]';
}
});

angular.module('ui.bootstrap.collapse', [])

.directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function($animate, $q, $parse, $injector) {
var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
return {
    link: function(scope, element, attrs) {
    var expandingExpr = $parse(attrs.expanding),
        expandedExpr = $parse(attrs.expanded),
        collapsingExpr = $parse(attrs.collapsing),
        collapsedExpr = $parse(attrs.collapsed),
        horizontal = false,
        css = {},
        cssTo = {};

    init();

    function init() {
        horizontal = !!('horizontal' in attrs);
        if (horizontal) {
        css = {
            width: ''
        };
        cssTo = {width: '0'};
        } else {
        css = {
            height: ''
        };
        cssTo = {height: '0'};
        }
        if (!scope.$eval(attrs.uibCollapse)) {
        element.addClass('in')
            .addClass('collapse')
            .attr('aria-expanded', true)
            .attr('aria-hidden', false)
            .css(css);
        }
    }

    function getScrollFromElement(element) {
        if (horizontal) {
        return {width: element.scrollWidth + 'px'};
        }
        return {height: element.scrollHeight + 'px'};
    }

    function expand() {
        if (element.hasClass('collapse') && element.hasClass('in')) {
        return;
        }

        $q.resolve(expandingExpr(scope))
        .then(function() {
            element.removeClass('collapse')
            .addClass('collapsing')
            .attr('aria-expanded', true)
            .attr('aria-hidden', false);

            if ($animateCss) {
            $animateCss(element, {
                addClass: 'in',
                easing: 'ease',
                css: {
                overflow: 'hidden'
                },
                to: getScrollFromElement(element[0])
            }).start()['finally'](expandDone);
            } else {
            $animate.addClass(element, 'in', {
                css: {
                overflow: 'hidden'
                },
                to: getScrollFromElement(element[0])
            }).then(expandDone);
            }
        }, angular.noop);
    }

    function expandDone() {
        element.removeClass('collapsing')
        .addClass('collapse')
        .css(css);
        expandedExpr(scope);
    }

    function collapse() {
        if (!element.hasClass('collapse') && !element.hasClass('in')) {
        return collapseDone();
        }

        $q.resolve(collapsingExpr(scope))
        .then(function() {
            element
            // IMPORTANT: The width must be set before adding "collapsing" class.
            // Otherwise, the browser attempts to animate from width 0 (in
            // collapsing class) to the given width here.
            .css(getScrollFromElement(element[0]))
            // initially all panel collapse have the collapse class, this removal
            // prevents the animation from jumping to collapsed state
            .removeClass('collapse')
            .addClass('collapsing')
            .attr('aria-expanded', false)
            .attr('aria-hidden', true);

            if ($animateCss) {
            $animateCss(element, {
                removeClass: 'in',
                to: cssTo
            }).start()['finally'](collapseDone);
            } else {
            $animate.removeClass(element, 'in', {
                to: cssTo
            }).then(collapseDone);
            }
        }, angular.noop);
    }

    function collapseDone() {
        element.css(cssTo); // Required so that collapse works when animation is disabled
        element.removeClass('collapsing')
        .addClass('collapse');
        collapsedExpr(scope);
    }

    scope.$watch(attrs.uibCollapse, function(shouldCollapse) {
        if (shouldCollapse) {
        collapse();
        } else {
        expand();
        }
    });
    }
};
}]);

angular.module('ui.bootstrap.tabindex', [])

.directive('uibTabindexToggle', function() {
return {
restrict: 'A',
link: function(scope, elem, attrs) {
    attrs.$observe('disabled', function(disabled) {
    attrs.$set('tabindex', disabled ? -1 : null);
    });
}
};
});

angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function($templateCache) {
$templateCache.put("uib/template/accordion/accordion-group.html",
"<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
"  <h4 class=\"panel-title\">\n" +
"    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
"  </h4>\n" +
"</div>\n" +
"<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
"  <div class=\"panel-body\" ng-transclude></div>\n" +
"</div>\n" +
"");
}]);

angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function($templateCache) {
$templateCache.put("uib/template/accordion/accordion.html",
"<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
}]);
/*eslint-enable*/
'use strict';

angular.module('CommonMod').factory('User', ['Config', 'Devices', 'User20', 'User30', '$rootScope', 
    function (Config, Devices, User20, User30, $rootScope) {

        if(Config.value('ENABLE_NEWTON_USER')){
            return User30;
        } else {
            return User20;
        }

    }]
);
angular.module('html5Game').directive('consentManager', ['Config', 'Utils', '$state',
    function(Config){ 
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/pages/parts/consent.html',
            replace: true,
            link: {
                post: function($scope, $element, $attr) {
                    $scope.openPrefs = function () {
                        if (Didomi && Didomi.preferences) {
                            Didomi.preferences.show();
                        }
                    };
                }
            }
        };
    }
]);

angular.module('CommonMod').factory('User20', ['Config', '$resource', '$rootScope', 'Devices', '$q', 'Logger', 'Utils', 'Analytics', 
    function(Config, $resource, $rootScope, Devices, $q, Logger, Utils, Analytics) {
        /**************************
        ***    PRIVATE SPACE    ***
        **************************/

        var userInitPromise = $q.defer();
        $rootScope.userReady = false;

        var apiCalls = $resource('', {}, {
            userCheck: { //user.get
                method: 'GET',
                url: Config.value('MOA_API_USER_CHECK'),
                isArray: false,
                cache: false,
                hideLoader: true,
                transformResponse: function(data){
                    var object = angular.fromJson(data);
                    Logger.info('API', 'User', 'userCheck (remote 2.0)', object);
                    return object;
                }
            },
            userUpdate: { //ex-user.dadanetupdate
                method: 'POST',
                url: Config.value('MOA_API_USER_OPTIONSUPDATE'),
                isArray: false,
                cache: false,
                transformResponse: function(data){
                    var object = angular.fromJson(data);
                    Logger.info('API', 'User', 'userUpdate (remote 2.0)', object);
                    return object;
                }
            },
            userUpdateNickname: { //user.set
                method: 'POST',
                url: Config.value('MOA_API_MIP_USER_PROFILE_UPDATE'),
                isArray: false,
                cache: false,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            },
            userUpdateEmail: { //user.changeemail
                method: 'POST',
                url: Config.value('MOA_API_USER_CHANGE_EMAIL'),
                isArray: false,
                cache: false,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            },
            userDisconnect: { //user.fbDisconnect
                method: 'GET',
                url: Config.value('MOA_API_MIP_USER_FBDISCONNECT'),
                isArray: false,
                cache: false,
                callback: 'JSON_CALLBACK'
            }
        });

        /**************************
         ***    PUBLIC SPACE     ***
        **************************/

        return {
            // init user: call user.check API and get status
            init: function(callback){
                if(!!JsStorage.get('dadanetuser', { type: 'cookie' }) || Config.value('USERCHECK_ALWAYS_CALLED')){
                    userInitPromise.promise = apiCalls.userCheck().$promise;
                    userInitPromise.promise.then(function(resp){
                        $rootScope.userReady = true;
                        //$rootScope.format = Devices.setFormat(resp);
                        if(callback){ callback(resp); }
                    });
                } else {
                    userInitPromise.promise.then(function(resp){
                        $rootScope.userReady = true;
                        if(callback){ callback(resp); }
                    });
                    var userCheckObject = {
                        logged: 0,
                        message: 'Not found',
                        status: '404',
                        subscribed: false
                    };
                    //$rootScope.format = Devices.setFormat(userCheckObject);
                    userInitPromise.resolve(userCheckObject);
                    Logger.info('API', 'User', 'userCheck (local 2.0)', userCheckObject);
                }
            },

            // return user status
            getStatus: function(callback){
                userInitPromise.promise.then(function(resp){
                    resp.fb_auth_id = resp.auth_id || '';
                    resp.email = resp.mipuser_email || '';
                    resp.id = resp.user;
                    if(!resp.nickname && resp.fb_name) {
                        resp.nickname = resp.fb_name;
                    }
                    if(callback){
                        callback(resp);
                    } else {
                        return resp;
                    }
                });
            },

            // return user property
            getProperty: function(property, callback){
                userInitPromise.promise.then(function(resp){
                    if(callback){
                        callback(resp);
                    } else {
                        return resp;
                    }
                });
            },

            setProperties: function(properties){
                userInitPromise.promise.then(function(){
                    apiCalls.userUpdate(properties);
                });
            },

            setNickname: function(properties, callback){ //serialize input
                //properties: {data_user.nickname : newNick}
                userInitPromise.promise.then(function(){
                    apiCalls.userUpdateNickname(properties).$promise.then(function(resp){
                        if(callback){
                            callback(resp);
                        } else {
                            return resp;
                        }
                    });
                });
            },

            setEmail: function(properties, callback){ //serialize input
                userInitPromise.promise.then(function(){
                    apiCalls.userUpdateEmail(properties).$promise.then(function(resp){
                        if(callback){
                            callback(resp);
                        } else {
                            return resp;
                        }
                    });
                });
            },

            fbDisconnect: function(callback){
                userInitPromise.promise.then(function(resp){
                    apiCalls.userDisconnect().$promise.then(callback(resp));
                });
            },

            getGameAccess: function(game, userType) {
                return Utils.getGameAccess(game, userType);
            },

            getUserType: function(user) {
                return Utils.getUserType(user);
            }
        };
    }
]);

angular.module('CommonMod').factory('User30',
    ['$resource', '$rootScope', '$q', 'Config', 'Devices', 'Utils', 'Logger', 'EventBus', 'Analytics', 
        function ($resource, $rootScope, $q, Config, Devices, Utils, Logger, EventBus, Analytics) {

            /**************************
            ***    PRIVATE SPACE    ***
            **************************/

            $rootScope.userReady = false;

            var apiCalls = $resource('', {}, {
                userCheck: {
                    method: 'GET',
                    url: Config.value('MOA_API_USER_PROFILE_GET'),
                    isArray: false,
                    cache: false,
                    hideLoader: true,
                    params: {
                        access_token: function(){
                            return NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                        }
                    },

                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        Logger.info('API', 'User', 'userCheck (remote 3.0)', object);
                        return object;
                    }
                },
                userUpdate: {
                    method: 'POST',
                    url: Config.value('MOA_API_USER_OPTIONSUPDATE'),
                    isArray: false,
                    cache: false,
                    params: {
                        access_token: function(){
                            return NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                        }
                    },
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        Logger.info('API', 'User', 'userUpdate (remote 3.0)', object);
                        return object;
                    }
                },
                userUpdateProfile: {
                    method: 'POST',
                    url: Config.value('MOA_API_USER_PROFILE_UPDATE'),
                    isArray: false,
                    cache: false,
                    params: {
                        access_token: function(){
                            return NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                        }
                    },
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                },
                userUpdateEmail: {
                    method: 'POST',
                    url: Config.value('MOA_API_USER_CHANGE_EMAIL'),
                    isArray: false,
                    cache: false,
                    params: {
                        access_token: function(){
                            return NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                        }
                    },
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                },
                userDisconnect: { //user.fbDisconnect
                    method: 'GET',
                    url: Config.value('MOA_API_MIP_USER_FBDISCONNECT'),
                    isArray: false,
                    cache: false,
                    params: {
                        access_token: function(){
                            return NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                        }
                    }
                },
                userUnsubscribe: { //nuova? su game 20 è URLMGR_ACTION_URL
                    method: 'GET',
                    url: Config.value('MOA_API_USER_UNSUBSCRIBE'),
                    isArray: false,
                    cache: false,
                    params: {
                        access_token: function(){
                            return NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                        }
                    },
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        Logger.info('API', 'User', 'unsubcribe (remote 3.0)', object);
                        return object;
                    }
                }
            });

            /**************************
            ***    PUBLIC SPACE     ***
            **************************/

            return {
                init: function(callback){
                    var _this = this;
                    if (Config.value('SYNCSTATE_BEFORE_USERPROP')){
                        Newton.getSharedInstance().syncUserState(function(){});
                    }    
                    if(NewtonAdapter.isUserLogged()){
                        apiCalls.userCheck().$promise.then(function(resp){
                            $rootScope.userReady = true;
                            //$rootScope.format = Devices.setFormat(resp);
                            if(callback){ callback(resp); }
                            Logger.info('API', 'User', 'init', 'logged', NewtonAdapter.getUserToken(), resp);
                            EventBus.trigger('User-Init', resp);
                        }, function(respError){
                            useris.PopupManager.showUserFeedback({
                                type: 'error',
                                feedback: {
                                    message: Dictionary.value('WEBAPP_UO30_USERPROP_ERROR_RETRY')
                                } 
                            });
                        });
                    } else {
                        var userCheckObject = {
                            logged: 0,
                            message: 'Not found',
                            status: '404',
                            subscribed: false
                        };
                        $rootScope.userReady = true;
                        //$rootScope.format = Devices.setFormat(userCheckObject);
                        if(callback){ callback(userCheckObject); }
                        Logger.info('API', 'User', 'init', 'unlogged', userCheckObject);
                        EventBus.trigger('User-Init', userCheckObject);
                    }
                },

                getStatus: function(callback){
                    EventBus.on('User-Init', function(resp){
                        if(callback){ callback(resp); }
                    });
                },

                getProperty: function(property, callback){
                    EventBus.on('User-Init', function(resp){
                        if(callback){ callback(resp[property]); }
                    });
                },

                setProperties: function(properties, callback){
                    var newProperties = {
                        data_user: properties
                    };
                    EventBus.on('User-Init', function(){
                        apiCalls.userUpdate(newProperties).$promise.then(function(userUpdateResp){
                            if(callback){ callback(userUpdateResp); }
                        });
                    });
                },

                setNickname: function(properties, callback, errCallback){ //serialize input
                    //properties: {data_user.nickname : newNick}
                    var newProperties = {
                        data_user: properties
                    };
                    EventBus.on('User-Init', function(){
                        apiCalls.userUpdateProfile(newProperties).$promise.then(function(resp){
                            if(callback){
                                callback(resp);
                            } else {
                                return resp;
                            }
                        },
                        function(respError){
                            if(errCallback){
                                errCallback(respError);
                            } else {
                                return respError;
                            }
                        });
                    });
                },

                setProfile: function(properties, callback, errCallback){ //serialize input
                    //per l'age check di VN, è uguale al setNickname, si minimizza le regression.
                    var newProperties = {
                        data_user: properties
                    };
                    EventBus.on('User-Init', function(){
                        apiCalls.userUpdateProfile(newProperties).$promise.then(function(resp){
                            if(callback){
                                callback(resp);
                            } else {
                                return resp;
                            }
                        },
                        function(respError){
                            if(errCallback){
                                errCallback(respError);
                            } else {
                                return respError;
                            }
                        });
                    });
                },

                setEmail: function(properties, callback){ //serialize input
                    EventBus.on('User-Init', function(){
                        apiCalls.userUpdateEmail(properties).$promise.then(function(resp){
                            if(callback){
                                callback(resp);
                            } else {
                                return resp;
                            }
                        });
                    });
                },

                fbDisconnect: function(callback){
                    EventBus.on('User-Init', function(){
                        apiCalls.userDisconnect().$promise.then(callback(resp));
                    });
                },

                getGameAccess: function(game, userType) { //serve EventBus per questa?
                    return Utils.getGameAccess(game, userType);
                },

                getUserType: function(user) { //serve EventBus per questa?
                    return Utils.getUserType(user);
                },
                unsubscribe: function(params, callback){
                    if (Config.value('REDIRECT_TO_EXTERNAL_UNSUB')){
                        //la chiave deve contenere la url!!!
                        window.location.href = Config.value('REDIRECT_TO_EXTERNAL_UNSUB');
                    } else {
                        var userUnsubscribe = function(){
                            apiCalls.userUnsubscribe(params, function(resp){
                                EventBus.off('User-Init', userUnsubscribe);
                                callback(resp);
                            }, function(err){
                                callback(false);
                            });
                        };
                        EventBus.on('User-Init', userUnsubscribe);
                    }
                }
            };
        }
    ]
);

angular.module('CommonMod').filter('accentedText',
    function() {
        return function(string, word) {
            if(string) {
                if(!word) {
                    word = 0;
                }
                var strs = string.split(' ');
                strs[0] = '<span class="color-accent">' + strs[word] + '</span>';
                return strs.join(' ');
            } else {
                return '';
            }
        };
    }
);

angular.module('CommonMod').directive('dynamicDom', function($compile) {
    return {
        restrict: 'AE',
        transclude: true,
        scope: true,
        link: function(scope, ele, attrs) {
            if(attrs.eventName) {
                var event1 = scope.$on(attrs.eventName, function(e, dom) {
                    var frag = $compile(angular.element(dom))(scope);
                    ele.append(frag);
                });
                scope.$on('$destroy', function() {
                    event1();
                });
            }

            scope.$watch('content', function(html) {
                ele.html(html);
                $compile(ele.contents())(scope);
            });
        }
    };
});

angular.module('CommonMod').directive('editable', function($compile, Config) {
    return {
        restrict: 'E',
        scope: {
            value: '@',
            onAccept: '&',
            onCancel: '&',
            externalEditId: '@',
            emptyValid: '@',
            addclassfield: '@',
            addclasstext: '@'
        },
        templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/common/utils/editable.dir.html',
        link: function(scope, element, attrs) {
            scope.emptyValid = scope.emptyValid === 'true';
            element.addClass('editable');

            function getPart(role) {
                var el = element[0].querySelector('[data-ngedit=' + role + ']');
                return angular.element(el);
            }

            var textElement = getPart('text');
            var editElement = getPart('edit');
            var inputElement = getPart('input');
            var acceptElement = getPart('accept');
            var cancelElement = getPart('cancel');

            var extEdit = angular.element(element[0]);
            scope.extedit = extEdit;
            var oldvalue = null;

            function mode(modeval) {
                if(modeval === 'text') {
                    inputElement[0].blur();
                    inputElement.val(scope.value);
                    textElement.css('display', '');
                    editElement.css('display', 'none');
                    extEdit.removeClass('editing');
                    scope.editing = false;
                }
                if(modeval === 'edit') {
                    textElement.css('display', 'none');
                    editElement.css('display', '');
                    extEdit.addClass('editing');
                    scope.editing = true;
                    inputElement[0].focus();
                }
            }
            mode('text');

            function handleConfirm(e) {
                if(inputElement.val()) {
                    scope.value = inputElement.val();
                    scope.onAccept({
                        value: scope.value
                    });
                    mode('text');
                } else {
                    handleCancel();
                }
            }

            function handleCancel(e) {
                scope.value = oldvalue;
                scope.onCancel();
                mode('text');
            }

            scope.edit = function() {
                mode('edit');
                if(inputElement.val()) {
                    oldvalue = inputElement.val();
                }
            };

            if(extEdit) {
                extEdit.on('click', function() {
                    scope.edit();
                });
            }

            editElement.bind('keypress', function(event) {
                if(event.which === 13) {
                    handleConfirm();
                    event.preventDefault();
                }
            });

            if(!textElement.attr('ng-click')) {
                textElement.bind('click', function(event) {
                    scope.edit();
                    event.preventDefault();
                });
            }

            if(attrs.onAccept === undefined) {
                acceptElement.css('display', 'none');
            }
            acceptElement.bind('click', function(e) {
                handleConfirm();
            });

            if(attrs.onCancel === undefined) {
                cancelElement.css('display', 'none');
            }
            cancelElement.bind('click', handleCancel);

            inputElement.bind('blur', function(event) {
                handleConfirm(event);
            });

            $compile(textElement)(scope);
            $compile(editElement)(scope);

        }
    };
});

angular.module('CommonMod').filter('generateWelcomeMailUrl',
    ['Config',
        function(Config){

            return function(url, key) {
                if (url){
                    return url.replace(':' + key, objectToQueryString(Config.value(key)));
                }
            };

            function objectToQueryString(object){
                var str = [];
                for(var p in object){
                    str.push(p + '=' + object[p]);
                }
                return str.join('&');
            }

        }
    ]
);
angular.module('CommonMod').filter('imageSize', [
    'ImageSize',
    function(ImageSize) {
        return ImageSize.replace;
    }
]);

angular.module('CommonMod').factory('ImageSize', [function() {

    var service = {
        replace: function(url, width, height) {
            width = width || 0;
            height = height || 0;
            if(angular.isDefined(url)) {
                if(angular.isNumber(width) && angular.isNumber(height)) {
                    if(angular.isString(url)) {
                        return url.replace('[WSIZE]', width).replace('[HSIZE]', height).replace('[METHOD]', 'crop');
                    } else if(angular.isArray(url)) {
                        for(var k = 0; k < url.length; k++) {
                            url[k] = url[k].replace('[WSIZE]', width).replace('[HSIZE]', height).replace('[METHOD]', 'crop');
                        }
                        return url;
                    }
                } else {
                    return url;
                }
            }

            return null;
        }
    };

    return service;
}]);

angular.module('html5Game').factory('Mail',
    ['$resource', 'Config', 'generateWelcomeMailUrlFilter', 'Logger',
        function ($resource, Config, generateWelcomeMailUrl, Logger) {

            return $resource('', {}, {

                sendAfterChangePassword: {
                    method: 'GET',
                    url: Config.value('MOA_API_MOA_MAILER_PASSWORDCHANGED'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var object = angular.fromJson(data);
                        Logger.info('API', 'Zoom', 'get', object);
                        return object;
                    }
                },

                sendAfterReset: {
                    method: 'GET',
                    url: Config.value('MOA_API_MOA_MAILER_RESETPASSWORD'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        Logger.info('API', 'Zoom', 'getRelated', array);
                        return array;
                    }
                },
                
                sendWelcomeMail: {
                    method: 'GET',
                    url: generateWelcomeMailUrl(Config.value('MOA_API_MOA_MAILER_WELCOMEMAIL'), 'MAILPRODUCT_OTHERPARAMS'),
                    isArray: false,
                    cache: false,
                    transformResponse: function(data){
                        var array = angular.fromJson(data);
                        Logger.info('API', 'Mail', 'sendWelcomeMail', array);
                        return array;
                    }
                }
                
            });
        }
    ]
  );
angular.module('CommonMod').filter('objectLength', [function() {
    return function(object) {

        if((typeof object === 'object') && (object instanceof Object)) {
            return Object.keys(object).length;
        } else {
            return null;
        }

    };
}]);

angular.module('html5Game').directive('imageonload', 
    function(){ 
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                element.bind('load', function() {
                    scope.$apply(attrs.imageonload)(true);
                });
            }
        };
    });

angular.module('CommonMod').filter('optimizeCanonical',
    function() {
        return function(canonicalString){
            if(canonicalString && canonicalString.length > 0) {
                var returnedCanonical = canonicalString;
                var indexOfQuestion = returnedCanonical.indexOf('?');
                var indexOfHashbang = returnedCanonical.indexOf('#!');
                
                if(indexOfQuestion !== -1 && (indexOfQuestion < indexOfHashbang)){
                    returnedCanonical = returnedCanonical.substr(0, indexOfQuestion) + returnedCanonical.substr(indexOfHashbang);
                }

                if(returnedCanonical.indexOf('?') > 0) {
                    returnedCanonical = returnedCanonical.split('?')[0];
                }  
                  
                return returnedCanonical;
            } else {
                return '';
            }
        };
    }
);
angular.module('CommonMod').filter('ordinalSuffix', [
    'Dictionary',
    function(Dictionary) {

        return function(number) {
            number += ''; // implicit cast to string

            var lastDigit = number[number.length - 1];
            var Dict = Dictionary.value;
            var suffix;

            // SPECIAL CASES

            /* if the number has at least two digits and the penultimate is 1
             *  then the suffix is always 'th':
             *  11 -> 11th (not 11st)
             *  12 -> 12th (not 12nd)
             *  13 -> 13th (not 13rd)
             */
            if(number.length > 1 && number[number.length - 2] === '1') {
                suffix = Dict('WEBAPP_SCORE_TH');
            } else {
                // NORMAL CASES
                switch(lastDigit) {
                case '1':
                    suffix = Dict('WEBAPP_SCORE_ST');
                    break;
                case '2':
                    suffix = Dict('WEBAPP_SCORE_ND');
                    break;
                case '3':
                    suffix = Dict('WEBAPP_SCORE_RD');
                    break;
                default:
                    suffix = Dict('WEBAPP_SCORE_TH');
                }
            }

            return number + suffix;
        };
    }
]);

angular.module('CommonMod').factory('Ranking', ['Logger', 'Config', 'User',
    function(Logger, Config, User) {

        var service = {
            set: function(options, otherparam) {

                if(!options || typeof options !== 'object' || !options.contentId){
                    return false;
                }

                var acquisitionType = 'natural';
                var ranking = 0;
                if(!options.scope){
                    options.scope = 'consumption';
                }

                if(Config.value('CONTENT_RANKING')[options.section][options.name]) {
                    User.getStatus(function(user) {

                        if(user.session_id || (Config.value('ENABLE_NEWTON_USER') && NewtonAdapter.getSessionId())) {
                            acquisitionType = 'acquisition';
                        }

                        ranking = Config.value('CONTENT_RANKING')[options.section][options.name][User.getUserType(user)];
                        
                        if(typeof ranking === 'object') {
                            ranking = Config.value('CONTENT_RANKING')[options.section][options.name][User.getUserType(user)][acquisitionType];
                        }
                        
                        //console.info('Rank path', options.section, options.name, User.getUserType(user), acquisitionType, ranking);

                        if(!!ranking) {
                            NewtonAdapter.rankContent({
                                contentId: options.contentId + '',
                                score: ranking,
                                scope: options.scope
                            });
                            return ranking;
                        }

                    });
                }
                return ranking;
            }
        };

        return service;
    }
]);

angular.module('CommonMod').filter('rfc822ts', [function() {
    return function(rfcDate) {

        if(rfcDate) {
            var date = new Date(rfcDate);

            if(Object.prototype.toString.call(date) === '[object Date]') {
                if(!isNaN(date.getTime())) {
                    return date.getTime();
                } else {
                    return null;
                }
            } else {
                return null;
            }

        } else {
            return null;
        }

    };
}]);

angular.module('CommonMod').filter('round',
    function() {

        return function(number) {
            return Math.round(number / 2);
        };
    }
);

// https://gist.github.com/thewarpaint/

angular.module('CommonMod')
    .filter('thousandSuffix', function() {
        return function(input, decimals) {
            var exp,
                rounded,
                suffixes = ['k', 'M', 'G', 'T', 'P', 'E'];

            if(window.isNaN(input)) {
                return null;
            }

            if(input < 1000) {
                return input;
            }

            exp = Math.floor(Math.log(input) / Math.log(1000));

            return(input / Math.pow(1000, exp)).toFixed(decimals) + suffixes[exp - 1];
        };
    });

angular.module('CommonMod').filter('titleCase', [
    'Dictionary',
    function(Dictionary) {

        return function(string) {
            if(string) {
                return string;
                //return string[0].toUpperCase() + string.substring(1, string.length).toLowerCase();
            } else {
                return '';
            }
        };
    }
]);


angular.module('CommonMod').factory('Utils', [

    '$rootScope', '$location', 'Dictionary', 'Config', '$filter', '$http', '$state', '$window', 'Analytics', 'debounce', 'imageSizeFilter', 'GoogleManager',
    function($rootScope, $location, Dictionary, Config, $filter, $http, $state, $window, Analytics, debounce, imageSizeFilter, GoogleManager) {

        var getMaximumDepth = function(element) {
            var child = element.firstChild;
            var childrenDepth = [];

            if(!child) {
                return 1;
            }

            while(child) {
                childrenDepth.push(getMaximumDepth(child));
                child = child.nextSibling;
            }
            /*eslint-disable */
            return Math.max.apply(Math, childrenDepth) + 1;
            /*eslint-enable */
        };

        var service = {
            getQueryString: function(qs){
                var url = qs ? qs : window.location.href;
                var querystring = {};
                url = decodeURIComponent(url);
                var pairs = url.substring(url.indexOf('?') + 1).split('#!')[0].split('&');
                for(var i = 0; i < pairs.length; i++) {
                    var pair = pairs[i].split('=');
                    querystring[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
                }
                return querystring;
            },

            setBadge: function(userType) {
                var showBadges = Config.value('ACCESS_TYPE_RULES') || false;
                if(showBadges && showBadges[userType]) {
                    showBadges = showBadges[userType];
                }
                return showBadges;
            },

            getGameAccess: function(game, userType) {
                var can;
                if (Config.value('EXTERNAL_CANUSE_ONLY')){
                    can = true;
                } else {
                    can = false;
                    if(game.access_type[userType] === true) {
                        can = true;
                    }
                }
                return can;
            },

            getUserType: function(user) {
                var userType = 'guest';
                if(user.logged) {
                    userType = 'free';
                    if(user.subscribed) {
                        userType = 'premium';
                    }
                }
                return userType;
            },

            redirectUnloggedToLogin: function(user, zoomUrl) {
                if (!user.logged && Config.value('REDIRECT_UNLOGGED_TO_LOGIN')) {
                    $rootScope.ageCheckZoomUrl = zoomUrl;
                    this.goTo('login');
                    return true;
                }
                return false;
            },

            getSingleGameAccess: function(accessType) {
                var gameaccess;
                if(accessType) {
                    if(accessType.guest && accessType.free && accessType.premium) {
                        gameaccess = 'guest';
                    } else if(!accessType.guest && accessType.free) {
                        gameaccess = 'free';
                    } else if(!accessType.free && accessType.premium) {
                        gameaccess = 'premium';
                    }
                }
                return gameaccess;
            },

            colorAccentedTitles: function(txt, filters) {
                for(var i = 0; i < filters.length; i++) {
                    txt = $filter(filters[i])(txt);
                }
                return txt;
            },

            setBtnLabel: function(format, custom, os) {
                var btnLabel = Dictionary.value('WEBAPP_CANVAS_BUTTON_PLAY');
                switch(format){
                case 'androidapplications':
                    btnLabel = Dictionary.value('WEBAPP_BUTTON_DOWNLOAD');
                    break;
                case 'cloudapplications':
                    btnLabel = Dictionary.value('WEBAPP_BUTTON_CLOUDPLAY');
                    break;
                case 'html5applications':
                default:
                    btnLabel = Dictionary.value('WEBAPP_CANVAS_BUTTON_PLAY');
                    break;
                }
                if (custom && Dictionary.value(custom)){
                    btnLabel = Dictionary.value(custom);
                }
                return btnLabel;
            },

            stickyCallToAction: function(conf){
                if (conf){
                    var persistentPlay = document.querySelector(conf.fixedEl);
                    var fixedPlay = document.querySelector(conf.fixedElTop);
                    if (fixedPlay){
                        var callback = function(entries) {
                            entries.forEach(function(entry){
                                if (entry.isIntersecting){
                                    fixedPlay.classList.remove(conf.toggleClass);
                                } else {
                                    fixedPlay.classList.add(conf.toggleClass);
                                }
                            });
                        };
                        var observer = new IntersectionObserver(callback);
                        var target = persistentPlay;
                        observer.observe(target);
                    }
                }
            },

            setGameFormatBtn: function(format, apk, html5){
                var cloud = html5; //intanto che si fa l'icona per i giochi cloud
                // eslint-disable-next-line
                return (format === 'androidapplications') ? apk : (format === 'cloudapplications') ? cloud : html5;
            },

            setTextDirection: function(text) {
                if (text){
                    var dir = 'ltr';
                    var regex = new RegExp('[\u0600-\u06ff]|[\u0750-\u077f]|[\ufb50-\ufbc1]|[\ufbd3-\ufd3f]|[\ufd50-\ufd8f]|[\ufd92-\ufdc7]|[\ufe70-\ufefc]|[\uFDF0-\uFDFD]'); //Arabic unicode range
                    if(regex.test(text)) {
                        dir = 'rtl';
                    }
                    return dir;
                }
            },

            resizeHomeItems: function(image) {
                var cardsContent = document.querySelectorAll('.home.cards-content');
                if(cardsContent.length) {
                    Array.prototype.forEach.call(cardsContent, function(el, i) {
                        if (el.clientHeight > 0 && el.querySelector('.titled-card').offsetHeight > 0){
                            el.style.height = el.querySelector('.titled-card').offsetHeight + 'px';
                        }
                    });
                }
            },

            shuffleArray: function(array) {
                for(var i = array.length - 1; i > 0; i--) {
                    var j = Math.floor(Math.random() * (i + 1));
                    var temp = array[i];
                    array[i] = array[j];
                    array[j] = temp;
                }
                return array;
            },

            avoidDuplicateItems: function(list, zoomGameId, gamesToShow, controlList){
                // list: list to be filtered for duplicates
                // zoomgameid: for completeness
                // gamestoshow: how many items should the returned list have
                // controlList: list against which to check for duplicates.
                var gamesIds = [zoomGameId];
                var games = document.querySelectorAll(controlList);
                games.forEach(function(game){
                    var myid = game.getAttribute('data-gameid');                 
                    gamesIds.push(myid + '');
                });
    
                var unique = list.filter(function(el) {
                    return gamesIds.indexOf(el.id + '') < 0;
                });
                var finalGames = unique.slice(0, gamesToShow);
                return finalGames;
            },

            removeAllDupes: function(arr, value){
                for (var i = 0; i < arr.length; ++i) {
                    for (var j = 0; j < arr.length; ++j) {
                        if (i !== j && arr[i][value] === arr[j][value]) {
                            arr.splice(j, 1);  
                        }
                    }          
                }
                return arr;
            },

            forceFirstContent: function(items){
            /* FORCE FIRST CONTENT (from fb campaigns)
                1) get content id
                2) see if the item is already in the home label items id list
                2a) if it is, put it in the first position (if pos > 0)
                2b) if not, add it to the items list and push out the last items of the list
            */
                var forcedContentID = Config.value('first_content_id') ? Config.value('first_content_id') : false; //1
                if(forcedContentID) {
                    var isAlreadyThere = false;
                    for(var f = 0; f < items.length; f++) {
                        if(items[f].id === forcedContentID) { //2
                            isAlreadyThere = true;
                            if(f !== 0) { //2a
                                var a = items.splice(f, 1); // removes the item
                                items.unshift(a[0]); // adds it back to the beginning
                            }
                            break;
                        }
                    }
                    if(!isAlreadyThere) {
                        Item.get({
                            ID: forcedContentID
                        }, function(e) { //2b
                            items.unshift(e);
                            items.pop();
                            return items;
                        });
                    } else {
                        return items;
                    }
                } else {
                    return items;
                }
            },

            getRandomArbitrary: function(start, delta, trueValue) {
                var value;
                if(trueValue) {
                    value = trueValue;
                } else {
                    var num = parseInt(start * 2.7, 10);
                    value = parseInt(num + delta, 10) + '';
                    value = parseInt(value.substr(-4), 10);
                }
                return $filter('thousandSuffix')(value, 1);
                //idea di Aurelio: numero generato da dato statico di ciascun item tipo id, per non farli cambiare troppo
            },

            getRandomInt: function (min, max) {
                min = Math.ceil(min);
                max = Math.floor(max);
                return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
            },

            isStandalone: function() {
                var isStandalone;
                if(window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches) {
                    return true;
                } else if (document.referrer.startsWith('android-app://')) {
                    isStandalone = 'twa';
                    return true;
                } else if (navigator.standalone || isStandalone) {
                    isStandalone = 'standalone';
                    return true;
                } else {
                    isStandalone = 'browser';
                    return false;
                }
            },

            gameGoesTo: function(item, itemtype){
              //not really used in ALL game elements, not updated with new types.
                /*"ALWAYS_GOTO_ZOOM" : { //baseconf for GMY
                    "general":true, //lists
                    "games":true, //explore
                    "slider":false, //big home carousel
                    "slidersmall":true, //home small carousel, history, favs, related
                    "itemspot":false, //home label items,
                    "sliderldb":false //bnee home leaderboard
                }*/
                if (item && itemtype){
                    var goToZoomConf = Config.value('ALWAYS_GOTO_ZOOM'),
                        itemDest;

                    if (item.format === 'androidapplications' || (goToZoomConf && goToZoomConf[itemtype])){
                        itemDest = 'zoom';
                    } else {
                        itemDest = 'play';
                    }
                    return itemDest;
                }
            },

            getReturnUrl: function() {
                //get returnurl from location querystring
                var returl = Config.value('DEST_DOMAIN');
                var params;
                if(document.location.search.substr(1)) {
                    params = this.getQueryString(document.location.search.substr(1));
                } else if($location.search()) {
                    params = $location.search();
                }
                if(params && params.return_url) {
                    returl = encodeURIComponent(params.return_url);
                }
                return returl;
            },

            getURLseparator: function(url) {
                var separator = (url.indexOf('?') !== -1) ? '&' : '?';
                return separator;
            },

            isEllipsisActive: function(element) {
                return element.scrollHeight > element.clientHeight;
            },
            mapObjToArr: function(arr){
                return Object.keys(arr).map(function(e) { return arr[e]; });
            },

            validateNick: function(nick){
                var isValid = false;
                if (nick.length >= Config.value('NICKNAME_MINSIZE') && nick.length <= Config.value('NICKNAME_MAXSIZE')){
                    isValid = true;
                }
                return isValid;
            },

            sortLabels: function(sortedConf, labelsList){
                if (sortedConf && labelsList){
                    var sortedLabels = [];
                    sortedConf.forEach(function(key) {
                        var found = false;
                        labelsList = labelsList.filter(function(item) {
                            if(!found && item.slug === key) {
                                sortedLabels.push(item);
                                found = true;
                                return false;
                            } else {
                                return true;
                            }
                        });
                    });
                    return sortedLabels;
                } else {
                    return labelsList;
                }
            },

            getRatio: function(imgsObj, width){
                //takes all images.cover fields from api, returns only the actual images and not the size fields
                var ratioedImg = [];
                var calcRatios = Config.value('IMAGE_RATIOS_FOR_CSS');
                // eslint-disable-next-line array-callback-return
                Object.keys(imgsObj).filter(function (propertyName) {

                    if (propertyName.indexOf('_sizes') === -1){ 
                        ratioedImg.push({ 'ratio': propertyName.replace('ratio_', ''), img: imgsObj[propertyName], calculatedRatio: calcRatios[propertyName] });
                    }
                });
                return ratioedImg;
            },

            getRatioConf: function(section, defaultRatio){
                var imgRatioConf = Config.value('IMAGE_RATIO');
                return imgRatioConf && imgRatioConf[section] ? imgRatioConf[section] : defaultRatio;
            },

            getDefaultList: function(labels, labelData){
                var defaultLabel = { id: '', enc_name: '', slug: '' };
                if (labels.length){
                    for (var i = 0; i < labels.length; i++) {
                        if (labels[i].items){
                            if (labels[i].id === labelData || labels[i].enc_name === labelData || labels[i].slug === labelData) {
                                defaultLabel = labels[i];
                            }
                        }
                    }
                    if (labels[0].items && (!defaultLabel.id && !defaultLabel.enc_name && !defaultLabel.slug)){
                        defaultLabel = labels[0];
                    }
                }
                return defaultLabel;
            },

            openZoom: function(item){
                var evAction = 'ZoomClick';
                var newtonProps = {
                    'action': evAction,
                    'category': 'Behavior',
                    'label': item.id + '',
                    'zip_download': 'Yes',
                    'game_title': item.default_title || item.title || '',
                    'valuable_cd': 'Yes',
                    'action_cd': 'Yes'
                };
                Analytics.eventTrack(newtonProps);
                NewtonAdapter.trackEvent({
                    name: newtonProps.action,
                    properties: newtonProps
                });
                if (GoogleManager){
                    GoogleManager.set(newtonProps);
                }
                $state.go('game', { gameURL: item.url_zoom_simple, gameId: item.id, gameCategory: item.category && item.category.category_id ? item.category.category_id : null, gameName: item.title });
            },

            itemPlay: function(item, goToZoom, position, type, checkCompatibility, Ranking) {
                var linkPrefs = Config.value('ALWAYS_GOTO_ZOOM');
                var evAction = goToZoom ? 'ZoomClick' : 'PlayClick';
                var newtonProps = {
                    'action': evAction,
                    'category': 'Behavior',
                    'label': item.id + '',
                    'zip_download': 'Yes',
                    'game_title': item.default_title || item.title || '',
                    'valuable_cd': 'Yes',
                    'action_cd': 'Yes'
                };
                if (position){
                    newtonProps.position = position;
                }
                if (typeof $attrs !== 'undefined' && $attrs.section){
                    newtonProps.section_src = $attrs.section;
                }
                Analytics.eventTrack(newtonProps);
                NewtonAdapter.trackEvent({
                    name: newtonProps.action,
                    properties: newtonProps
                });
                if (GoogleManager){
                    GoogleManager.set(newtonProps);
                }
                Ranking.set({ section: 'Play', name: 'PlayClick', contentId: item.id + '', scope: 'consumption' });
                item.showIncompatible = false;
                if (item.format === 'androidapplications'){
                    if (item.compatibility || !checkCompatibility || (Config.value('INCOMPATIBLES_ZOOM_ONLY') && goToZoom)){
                        $state.go('game', { gameURL: item.url_zoom_simple, gameId: item.id, gameCategory: item.category && item.category.category_id ? item.category.category_id : null, gameName: item.title });
                    } else {
                        item.showIncompatible = true;
                    }

                } else if (goToZoom && (linkPrefs && linkPrefs[type])) {
                    $state.go('game', { gameURL: item.url_zoom_simple, gameId: item.id, gameCategory: item.category && item.category.category_id ? item.category.category_id : null, gameName: item.title });
                } else {
                    var gameType = this.getSingleGameAccess(item.access_type),
                        canAccess = this.getGameAccess(item, $rootScope.userType);
                    if (canAccess) {
                        $window.location.href = item.url_play;
                    } else if($rootScope.userType === 'guest' && gameType === 'free'){
                        $state.go('wall', { game: item, returl: encodeURIComponent(item.url_play) }, {
                            reload: true
                        });
                    } else {
                        $window.location.href = item.url_leaf_engine_subscription;
                    }
                }
            },

            getFileName: function(filePath){
                if (filePath){
                    var paths = filePath.split('/');
                    return paths[parseInt(paths.length - 1, 10)] || false;
                }
            },

            setJSclass: function(remove, mainCTA, otherCTAs){
                if (mainCTA){
                    if (remove) {
                        mainCTA.classList.remove('jsdisabled');
                        if (otherCTAs) {
                            otherCTAs.classList.remove('jsdisabled-others');
                        }
                    } else {
                        mainCTA.classList.add('jsdisabled');
                        if (otherCTAs) {
                            otherCTAs.classList.add('jsdisabled-others');
                        }
                    }
                }
            },            
            getApp: function(playConf, e) { 
              //custom dld for Orange offer page =_= (same as gameplay below but dld only).
              //per evitare di dover fare seimila regression quando ci chiederanno cambiamenti
              // al funzionamento, dato che questa Offer Page dovrebbe avere vita breve. 
                var prop = {
                    'action': 'offer_click_subscribe',
                    'category': 'Behavior',
                    'page_url': $location.absUrl(),
                    'label': $location.absUrl(),
                    'content_id': playConf.gameObj.id,
                    'offer_app_title': playConf.gameObj.default_title || playConf.gameObj.title || '',
                    'valuable_cd': 'Yes',
                    'action_cd': 'Yes'
                };
                Analytics.eventTrack(prop);
                NewtonAdapter.trackEvent({
                    name: prop.action,
                    properties: prop
                });
                if (GoogleManager){
                    GoogleManager.set(prop);
                }
                /*playConf : MANDATORY
                    gameObj: gameObj
                    isZoom: true| false
                    cta: button reference
                    User: User
                */
                if (e) {
                    e.preventDefault();
                }
                var User = playConf && playConf.User ? playConf.User : false;
                var Utils = this;
                if (playConf.gameObj){
                    User.init(function(user) {
                        userType = User.getUserType(user);
                        canAccess = User.getGameAccess(playConf.gameObj, userType);
                        if (canAccess){
                            if (playConf.gameObj.url_external){
                                //$window.location.href = playConf.gameObj.url_external;
                                $window.open(playConf.gameObj.url_external, '_blank');
                            } else if(playConf.gameObj.format === 'androidapplications') {
                                $rootScope.$emit('dld-errorfalse');
                                //disable all if in list, to avoid issues. change class to not show them grayed out in list except for the active one.

                                $http({
                                    method: 'GET',
                                    url: playConf.gameObj.url_api_dld
                                }).then(function(response) {
                                    if (response.data.url_download){
                                        $window.location.href = response.data.url_download;
            
                                        prop = {
                                            'action': 'DownloadAPKStart',
                                            'category': 'Behavior',
                                            'label': playConf.gameObj.id,
                                            'game_title': playConf.gameObj.default_title || playConf.gameObj.title || '',
                                            'ota_url': response.data.url_download,
                                            'valuable_cd': 'No',
                                            'action_cd': 'No'
                                        };
                                        Analytics.eventTrack(prop);
                                        NewtonAdapter.trackEvent({
                                            name: prop.action,
                                            properties: prop
                                        });
                                        if (GoogleManager){
                                            GoogleManager.set(prop);
                                        }
                                        setTimeout(function(){
                                            $rootScope.$emit('dld-tip-hide');
                                        }, Config.value('SHOW_DLD_TIP_TIMER') || 10000);
            
                                        if(Config.value('MFP_ON_APKDLD') && playConf.MFP) {
                                            playConf.MFP.mfpSetAndGo(!!user.logged, {
                                                url: response.data.url_download,
                                                noStore: true
                                            });
                                        }
                                    } else if (response.data.status === '1403') {
                                        prop = {
                                            'action': 'DownloadAPK_notSubscribed',
                                            'category': 'Behavior',
                                            'label': playConf.gameObj.id,
                                            'game_title': playConf.gameObj.default_title || playConf.gameObj.title || '',
                                            'ota_url': response.data.status,
                                            'valuable_cd': 'No',
                                            'action_cd': 'No'
                                        };
                                        Analytics.eventTrack(prop);
                                        NewtonAdapter.trackEvent({
                                            name: prop.action,
                                            properties: prop
                                        });
                                        if (GoogleManager){
                                            GoogleManager.set(prop);
                                        }
                                        $window.location.href = playConf.gameObj.url_leaf_engine_subscription;
                                    } else if (response.data.error_url){
                                        prop = {
                                            'action': 'DownloadAPK_noDLDurl',
                                            'category': 'Behavior',
                                            'label': playConf.gameObj.id,
                                            'game_title': playConf.gameObj.default_title || playConf.gameObj.title,
                                            'ota_url': '',
                                            'error_url': response.data.error_url,
                                            'valuable_cd': 'No',
                                            'action_cd': 'No'
                                        };
                                        Analytics.eventTrack(prop);
                                        NewtonAdapter.trackEvent({
                                            name: prop.action,
                                            properties: prop
                                        });
                                        $window.location.href = response.data.error_url;
                                    } else {
                                        $rootScope.$emit('dld-tip-hide');
                                        $rootScope.$emit('dld-error');
                                        prop = {
                                            'action': 'DownloadAPK_noDLDurl',
                                            'category': 'Behavior',
                                            'label': playConf.gameObj.id,
                                            'game_title': playConf.gameObj.default_title || playConf.gameObj.title || '',
                                            'ota_url': '',
                                            'valuable_cd': 'No',
                                            'action_cd': 'No'
                                        };
                                        Analytics.eventTrack(prop);
                                        NewtonAdapter.trackEvent({
                                            name: prop.action,
                                            properties: prop
                                        });
                                        if (GoogleManager){
                                            GoogleManager.set(prop);
                                        }
                                    }
                                }, function(response) {
                                    $rootScope.$emit('dld-tip-hide');
                                    $rootScope.$emit('dld-error');
                                    prop = {
                                        'action': 'DownloadAPK_apiDLDerror',
                                        'category': 'Behavior',
                                        'label': playConf.gameObj.id,
                                        'game_title': playConf.gameObj.default_title || playConf.gameObj.title || '',
                                        'ota_url': playConf.gameObj.url_api_dld,
                                        'valuable_cd': 'No',
                                        'action_cd': 'No'
                                    };
                                    Analytics.eventTrack(prop);
                                    NewtonAdapter.trackEvent({
                                        name: prop.action,
                                        properties: prop
                                    });
                                    if (GoogleManager){
                                        GoogleManager.set(prop);
                                    }
                                });
                            }
                        } else {
                            //No canAccess
                            $window.location.href = playConf.gameObj.url_leaf_engine_subscription;
                        }
                    });
                } else {
                    console.log('missing game object');
                }
            },
            getAgeCheckCutoff: function(minAge){
                var today = new Date();
                var cutoff = new Date(
                    today.getFullYear() - minAge,
                    today.getMonth(),
                    today.getDate()
                );
                return cutoff;
            },
            isUserOfAge: function(dob, minAge) {
                var parsedDob = new Date(dob);
                var cutoff = this.getAgeCheckCutoff(minAge);
            
                return { isOfAge: parsedDob <= cutoff, cutoff: cutoff };
            },

            gamePlay: function(playConf, e, fromAgeCheck) {
                 //actual content fruition, itemplay is only a gotozoom with tracking.
                /*playConf : MANDATORY
                    gameObj: gameObj
                    isZoom: true| false
                    cta: button reference
                    User: User
                    Ranking: Ranking
                    --assuming Ranking and $scope as defined in the context
                */
                if (e) {
                    e.preventDefault();
                }
                var User = playConf && playConf.User ? playConf.User : false;
                var Ranking = playConf && playConf.Ranking ? playConf.Ranking : false;
                var Utils = this;
                if (playConf.gameObj){
                    $rootScope.playConf = playConf;
                    if (!playConf.isZoom && playConf.gameObj.format === 'androidapplications') {
                        Utils.openZoom(playConf.gameObj);
                    } else {
                        User.init(function(user) {
                            userType = User.getUserType(user);
                            if (!fromAgeCheck && Utils.redirectUnloggedToLogin(user, playConf.gameObj.url_zoom)) {
                                return;
                            }
                            canAccess = User.getGameAccess(playConf.gameObj, userType);
                            if (canAccess){
                                //AGE CHECK - Pilot: CN Vietnam 
                                var errorUrl = Config.value('DEST_DOMAIN') + Config.value('AGE_CHECK_ERROR_URL');
                                if (Config.value('AGE_RANGE_CHECK') && !user.date_of_birth && !fromAgeCheck){
                                    var hasAnswered = JsStorage.get('ageCheckAnswer', { type: 'cookie' });
                                    try {
                                        if (sessionStorage.getItem('ageCheckFailed')) {
                                            window.location.href = errorUrl;
                                            return false;
                                        }
                                    } catch (err) {
                                        console.info(err);
                                    }

                                    if (user.logged){
                                        switch($rootScope.hasAnswered){
                                        case 1:
                                            $rootScope.showAgeForm = true;
                                            if (!$rootScope.ageCheckModal[0].open){
                                                $rootScope.ageCheckModal[0].showModal();
                                            }
                                            break;
                                        case 2:
                                        default:
                                            if (!$rootScope.ageCheckModal[0].open){
                                                $rootScope.ageCheckModal[0].showModal();
                                            }
                                            break;
                                        }
                                    } else {
                                        /*eslint-disable no-lonely-if*/
                                        if ($rootScope.hasAnswered === 1) {
                                            $rootScope.ageCheckZoomUrl = playConf.gameObj.url_zoom;
                                            Utils.goTo('login');
                                        }
                                    }
                                    return false;
                                }
                                //End age check

                                //Android APK
                                if(playConf.gameObj.format === 'androidapplications') {
                                    var mainCTA = e ? e.target : false,
                                        otherCTAs = playConf.cta && playConf.cta[0] ? document.querySelector(playConf.cta[0]) : false;
                                    Utils.setJSclass(false, mainCTA, otherCTAs);
                                    
                                    $rootScope.$emit('dld-errorfalse');
                                    //disable all if in list, to avoid issues. change class to not show them grayed out in list except for the active one.
                
                                    var prop = {
                                        'action': 'DownloadAPK',
                                        'category': 'Behavior',
                                        'label': playConf.gameObj.id,
                                        'game_title': playConf.gameObj.default_title || playConf.gameObj.title || '',
                                        'valuable_cd': 'Yes',
                                        'action_cd': 'Yes'
                                    };
                                    Analytics.eventTrack(prop);
                                    NewtonAdapter.trackEvent({
                                        name: prop.action,
                                        properties: prop
                                    });

                                    // Track Page view of snowplow
                                    if (window.snowplow !== undefined && Config.value('SNOWPLOW_TRACKING_ANALYTICS')) {
                                        window.snowplow('trackSelfDescribingEvent', {
                                            event: {
                                                schema: 'iglu:com.dgp/dv_user_interaction/jsonschema/1-0-0',
                                                data: {}
                                            },
                                            context: [
                                                {
                                                    schema: 'iglu:com.dgp/interaction_element/jsonschema/1-0-1',
                                                    data: {
                                                        environment: 'browser', 
                                                        tracking_name: 'DownloadAPK'
                                                    }
                                                }
                                            ]
                                        });
                                    }
                                    if (GoogleManager){
                                        GoogleManager.set(prop);
                                    }
                                    Ranking.set({ section: 'Play', name: 'DownloadAPK', contentId: playConf.gameObj.id + '', scope: 'consumption' });
                                    $http({
                                        method: 'GET',
                                        url: playConf.gameObj.url_api_dld
                                    }).then(function(response) {
                                        if (response.data.url_download){
                                            if(Config.value('SHOW_DLD_TIP')) {
                                                $rootScope.$emit('dld-tip-show');
                                                if (playConf.isZoom){
                                                    var feedback = document.querySelector('.feedbackContainer');
                                                    if (feedback && feedback.offsetTop){
                                                        $window.scrollTo(0, feedback.offsetTop);
                                                    }
                                                }
                                            }
                                            $window.location.href = response.data.url_download;
                
                                            prop = {
                                                'action': 'DownloadAPKStart',
                                                'category': 'Behavior',
                                                'label': playConf.gameObj.id,
                                                'game_title': playConf.gameObj.default_title || playConf.gameObj.title || '',
                                                'ota_url': response.data.url_download,
                                                'valuable_cd': 'No',
                                                'action_cd': 'No'
                                            };
                                            Analytics.eventTrack(prop);
                                            NewtonAdapter.trackEvent({
                                                name: prop.action,
                                                properties: prop
                                            });
                                            if (GoogleManager){
                                                GoogleManager.set(prop);
                                            }

                                            // Use Config.value('SNOWPLOW_TRACKING_ANALYTICS') to wrap with an if statement
                                            // Send Event DownloadAPk 
                                            if (window.snowplow !== undefined && Config.value('SNOWPLOW_TRACKING_ANALYTICS')) {
                                                window.snowplow('trackSelfDescribingEvent', {
                                                    event: {
                                                        schema: 'iglu:com.dgp/dv_content_consumption/jsonschema/1-0-0',
                                                        data: {}
                                                    },
                                                    context: [
                                                        {
                                                            schema: 'iglu:com.dgp/dv_product/jsonschema/1-0-2',
                                                            data: {
                                                                service_id: playConf.gameObj.snowplow_service_id.toString(), 
                                                                service_category: playConf.gameObj.snowplow_service_category, 
                                                                service_name: playConf.gameObj.snowplow_service_name || window.location.hostname, 
                                                                service_type: playConf.gameObj.snowplow_service_type, 
                                                                rubric_id: playConf.gameObj.category.id_category.toString(),
                                                                rubric_name: playConf.gameObj.category.name_category,
                                                                content_id: playConf.gameObj.id.toString(),
                                                                content_name: playConf.gameObj.title || '',
                                                                content_type: playConf.gameObj.format,
                                                                provider_name: playConf.gameObj.publisher.title_publisher
                                                            }
                                                        }
                                                    ]
                                                });
                                                
                                                // Snowplow: Send dv_user_interaction with DownloadAPK tracking name
                                                window.snowplow('trackSelfDescribingEvent', {
                                                    event: {
                                                        schema: 'iglu:com.dgp/dv_user_interaction/jsonschema/1-0-0',
                                                        data: {}
                                                    },
                                                    context: [
                                                        {
                                                            schema: 'iglu:com.dgp/interaction_element/jsonschema/1-0-1',
                                                            data: {
                                                                environment: 'browser', 
                                                                tracking_name: 'DownloadAPK'
                                                            }
                                                        }
                                                    ]
                                                });
                                            }
                
                                            setTimeout(function(){
                                                $rootScope.$emit('dld-tip-hide');
                                                Utils.setJSclass(true, mainCTA, otherCTAs);
                                            }, Config.value('SHOW_DLD_TIP_TIMER') || 10000);
                
                                            if(Config.value('MFP_ON_APKDLD') && playConf.MFP) {
                                                playConf.MFP.mfpSetAndGo(!!user.logged, {
                                                    url: response.data.url_download,
                                                    noStore: true
                                                });
                                            }
                                        } else if (response.data.status === '1403') {
                                            prop = {
                                                'action': 'DownloadAPK_notSubscribed',
                                                'category': 'Behavior',
                                                'label': playConf.gameObj.id,
                                                'game_title': playConf.gameObj.default_title || playConf.gameObj.title || '',
                                                'ota_url': response.data.status,
                                                'valuable_cd': 'No',
                                                'action_cd': 'No'
                                            };
                                            Analytics.eventTrack(prop);
                                            NewtonAdapter.trackEvent({
                                                name: prop.action,
                                                properties: prop
                                            });
                                            if (GoogleManager){
                                                GoogleManager.set(prop);
                                            }
                                            if (!Utils.redirectUnloggedToLogin(user, playConf.gameObj.url_zoom)) {
                                                $window.location.href = playConf.gameObj.url_leaf_engine_subscription;
                                            }
                                        } else if (response.data.error_url){
                                            prop = {
                                                'action': 'DownloadAPK_noDLDurl',
                                                'category': 'Behavior',
                                                'label': playConf.gameObj.id,
                                                'game_title': playConf.gameObj.default_title || playConf.gameObj.title,
                                                'ota_url': '',
                                                'error_url': response.data.error_url,
                                                'valuable_cd': 'No',
                                                'action_cd': 'No'
                                            };
                                            Analytics.eventTrack(prop);
                                            NewtonAdapter.trackEvent({
                                                name: prop.action,
                                                properties: prop
                                            });
                                            if (GoogleManager){
                                                GoogleManager.set(prop);
                                            }
                                            $window.location.href = response.data.error_url;
                                        } else {
                                            $rootScope.$emit('dld-tip-hide');
                                            $rootScope.$emit('dld-error');
                                            Utils.setJSclass(true, mainCTA, otherCTAs);
                                            prop = {
                                                'action': 'DownloadAPK_noDLDurl',
                                                'category': 'Behavior',
                                                'label': playConf.gameObj.id,
                                                'game_title': playConf.gameObj.default_title || playConf.gameObj.title || '',
                                                'ota_url': '',
                                                'valuable_cd': 'No',
                                                'action_cd': 'No'
                                            };
                                            Analytics.eventTrack(prop);
                                            NewtonAdapter.trackEvent({
                                                name: prop.action,
                                                properties: prop
                                            });
                                            if (GoogleManager){
                                                GoogleManager.set(prop);
                                            }
                                        }
                                    }, function(response) {
                                        Utils.setJSclass(true, mainCTA, otherCTAs);
                                        $rootScope.$emit('dld-tip-hide');
                                        $rootScope.$emit('dld-error');
                                        prop = {
                                            'action': 'DownloadAPK_apiDLDerror',
                                            'category': 'Behavior',
                                            'label': playConf.gameObj.id,
                                            'game_title': playConf.gameObj.default_title || playConf.gameObj.title || '',
                                            'ota_url': playConf.gameObj.url_api_dld,
                                            'valuable_cd': 'No',
                                            'action_cd': 'No'
                                        };
                                        Analytics.eventTrack(prop);
                                        NewtonAdapter.trackEvent({
                                            name: prop.action,
                                            properties: prop
                                        });
                                        if (GoogleManager){
                                            GoogleManager.set(prop);
                                        }
                                    });
                                } else {
                                    //HTML5 or CLOUD
                                    if (Config.value('SHOW_LOADER_ON_PLAY')){
                                        document.querySelector('html').classList.add('loadingRequest');
                                    }
                                    var action = 'PlayClick';
                                    var newtonProps = {
                                        'action': action,
                                        'category': 'Behavior',
                                        'label': playConf.gameObj.id,
                                        'content_id': playConf.gameObj.id,
                                        'zip_download': 'Yes',
                                        'game_title': playConf.gameObj.default_title || playConf.gameObj.title || '',
                                        'valuable_cd': 'Yes',
                                        'action_cd': 'Yes'
                                    };
                                    Analytics.eventTrack(newtonProps);
                                    NewtonAdapter.trackEvent({
                                        name: newtonProps.action,
                                        properties: newtonProps
                                    });
                                    if (GoogleManager){
                                        GoogleManager.set(newtonProps);
                                    }
                                    Ranking.set({ section: 'Play', name: 'PlayClick', contentId: playConf.gameObj.id + '', scope: 'consumption' });
                                    if (playConf.GoogleManager){
                                        playConf.GoogleManager.set(newtonProps);
                                    }
                                    setTimeout(function() {
                                        $window.location.href = playConf.gameObj.url_play;
                                    }, 100);
                                }
                            } else {
                                //No canAccess
                                if (!Utils.redirectUnloggedToLogin(user, playConf.gameObj.url_zoom)) {
                                    $window.location.href = playConf.gameObj.url_leaf_engine_subscription;
                                }
                            }
                        });
                    }
                } else {
                    console.log('missing game object');
                }   
            },

            goToZoom: function(item){
                //I'm not using a normal ng-href here, because it reloads the webapp. Using ui-router $state.go method instead. (look into ui-sref)
                var slug = item.url_zoom_simple.replace('/' + item.id, '');
                $state.go('zoom', { newsSlug: slug, newsId: item.id, newsName: item.title }, { reload: false });
            },

            goTo: function(where, data){
                if (where && $state.get(where)){
                    data = data || {};
                    $state.go(where, data, {
                        reload: false
                    });
                }
            },

            headerBack: function(e) {
                $rootScope.goingBack = true;
                if(Config.value('ROUTE_REAL_HISTORY') && $rootScope.from.length) {
                    // if we want to follow user's history if user has a history within the webapp (as opposed to always sending them to the fallback)                
                    var backUrl = $rootScope.from[0];
                    $rootScope.from.shift(); //remove url we navigated to from history
                    $location.path(backUrl).replace();
                } else { //if user does not have a navigation history and/or we want to always send them to fallback route
                    $location.path(Config.value('ROUTE_FALLBACK')).replace();
                }
            },

            convertToDate: function(epoch) {
                var date;
                if (!isNaN(epoch)) {
                    if (epoch <= 9999999999) {
                        epoch *= 1000;
                    }
                    date = new Date(epoch);
                    date = date.toLocaleDateString(isoLang, { day: 'numeric', month: 'short', year: 'numeric' });
                    //new Intl.DateTimeFormat(isolang').format(date);
                } else {
                    date = '';
                }
                return date;
            },

            truncateAtChar: function(text, char){
                if (text && text.length > char){
                    return text.substring(0, parseInt(char, 10)) + '...';
                } else {
                    return text;
                }
            },

            triggerResize: function(){
                var resizeEvent = window.document.createEvent('UIEvents'); 
                resizeEvent.initUIEvent('resize', true, false, window, 0); 
                window.dispatchEvent(resizeEvent);
            },

            getBiggerWinSize: function(max){
                var wW = window.innerWidth;
                var wH = window.innerHeight;
                var biggerSize = (wW > wH) ? wW : wH;
                if (max && (biggerSize > max)) {
                    biggerSize = max; //e.g. returns 1280 if screen is 4400, to avoid loading huuuge imgs
                }
                return biggerSize;
            },

            getItemsNumber: function(type){ //for single-line lists only (to avoid wrapping)
                var windowWidth = window.innerWidth > 1024 ? 1024 : window.innerWidth;
                if (type) {
                    switch(type){
                    case 'card':
                        if (windowWidth < 500) {
                            return 2;
                        } else if (windowWidth > 500 && windowWidth <= 768){
                            return 3;
                        } else if (windowWidth > 768){
                            return 4;
                        }
                        break;
                    case 'small':
                        if (windowWidth < 500) {
                            return 3;
                        } else if (windowWidth > 500 && windowWidth <= 768){
                            return 4;
                        } else if (windowWidth > 768){
                            return 5;
                        }
                        break;
                    case 'boxed':
                    default:
                        if (windowWidth < 500) {
                            return 1;
                        } else if (windowWidth > 500 && windowWidth <= 768){
                            return 2;
                        } else if (windowWidth > 768){
                            return 3;
                        }
                        break;
                    }
                }
            },

            getActiveGlideItem: function(glideSlider, sliderName, $scope, datamipqa){
                var clickitem;
                var baseEl = document.querySelector(sliderName);
                // adding events to the clones shouldn't be necessary as the events re-check all existing elements in that moment.
                glideSlider.on('run.before', function(){ 
                    var els = baseEl ? baseEl.querySelectorAll('.glide__slides li') : false;
                    if (els.length){
                        clickitem = els[0].querySelector('[data-mipqa="' + datamipqa + '"]');
                        angular.forEach(els, function(el) {
                            el.querySelector(clickitem.tagName).removeAttribute('data-mipqa');
                        });
                    }
                });
                glideSlider.on('run.after', function(){
                    var els = baseEl ? baseEl.querySelectorAll('.glide__slides li') : false;
                    if (els.length){
                        angular.forEach(els, function(el) {
                            if (el.classList.contains('glide__slide--active')){
                                el.querySelector(clickitem.tagName).setAttribute('data-mipqa', datamipqa);
                            }
                        });
                    }
                });
                $scope.$on('$destroy', function() {
                    glideSlider.destroy();
                });
                //almost there. it works, almost. On gamester home page it gives data.mipqa to previous item, not active. check events to use.
            },

            isScrolledIntoView: function(el) {
                var isVisible;
                if (el){
                    var rect = el.getBoundingClientRect();
                    var elemTop = rect.top;
                    var elemBottom = rect.bottom;
                    // Only completely visible elements return true:
                    isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
                    // Partially visible elements return true:
                    //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
                    return isVisible;
                }
            },

            getSize4Density: function(defaultSize, singleSize){
                //defaultSize: size to be multiplied, singleSize: bigger for devixePixelratio == 1
                if (Config.value('USE_BASE_IMG_DENSITY')){
                    return defaultSize;
                } else {
                    return window.devicePixelRatio && window.devicePixelRatio > 1 ? Math.round(defaultSize * window.devicePixelRatio) : singleSize;
                }
            },
            
            goToCat: function(category) {
                if (category && $state.get('category')){
                    $state.go('category', {
                        categoryId: category.id || '',
                        categoryName: category.name || '',
                        listName: category.name || ''
                    }, {
                        reload: true
                    });
                }
            },

            goToLab: function(label) {
                if (label && $state.get('label')){
                    $state.go('label', {
                        labelName: label.enc_name || '',
                        labelId: label.id || '',
                        listName: label.name || ''
                    }, {
                        reload: true
                    });
                }
            },

            updateCSSprops: function(propName, propValue){
                var root = document.documentElement;
                root.style.setProperty(propName, propValue);
            },

            getDictionaryLinks: function(pattern, action){
                //per settings e footer da dict (MT arcade, Orange BF);
                const subUrl = pattern.url;
                const subLabel = pattern.label;
                const dict = Object.keys(Dictionary.list());
                var linkUrls = [];
                var linkLabels = [];
                var linksArray = [];
                var suffixValueUrl;
                var suffixValueLabel;
                for (x = 0; x < dict.length; x++) {
                    if (dict[x].startsWith(subUrl.slice(0, Math.max(dict[x].length - 1, 1)))){
                        linkUrls.push(dict[x]);
                    }

                    if (dict[x].startsWith(subLabel.slice(0, Math.max(dict[x].length - 1, 1)))) {
                        linkLabels.push(dict[x]);
                    }
                }
                for (j = 0; j < linkUrls.length; j++) {
                    suffixValueUrl = linkUrls[j].charAt(linkUrls[j].length - 1);
                    for (i = 0; i < linkLabels.length; i++) {
                        suffixValueLabel = linkLabels[i].charAt(linkLabels[i].length - 1);
                        if (parseInt(suffixValueUrl, 10) === parseInt(suffixValueLabel, 10)){
                            linksArray.push({ url: Dictionary.value(linkUrls[j]), label: Dictionary.value(linkLabels[i]), action: action ? action : false });
                        }
                    }
                }
                return linksArray;
            },
            addToken: function(e, url){
                e.preventDefault();
                var linkUrl = url ? url : this.url;
                if (Config.value('EXTERNAL_LINKS_WITH_TOKEN')){
                    if (NewtonAdapter.isUserLogged()){
                        NewtonAdapter.getTransientToken(function (err, response) {
                            var usertoken = '?_uot=' + (response.token ? response.token : response);
                            window.location.href = linkUrl + usertoken;
                        });
                    } else {
                        window.location.href = linkUrl;
                    }
                } else {
                    window.location.href = linkUrl;
                }
            }
        };

        return service;
    }
]);

angular.module('html5Game').factory('Category', ['$resource', 'Config', 'Logger', '$rootScope', 'Devices', function($resource, Config, Logger, $rootScope, Devices) {

    $rootScope.format = Devices.setFormat(false);
    return $resource('', {}, {

        getList: {
            method: 'GET',
            url: Config.value('MOA_API_CATEGORIES'),
            params: {
                FORMATS: $rootScope.format
            },
            isArray: true,           
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            interceptor: {
                response: function(data) {
                    Logger.log('API :: Category :: getList', data.data, {
                        method: data.config.method,
                        url: data.config.url
                    });
                    return data.data;
                }
            }
        },

        get: {
            method: 'GET',
            url: Config.value('MOA_API_CATEGORIES'),
            params: {
                FORMATS: $rootScope.format
            },
            isArray: false,
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            interceptor: {
                response: function(data) {
                    Logger.log('API :: Category :: get', data.data, {
                        id: data.data.id,
                        method: data.config.method,
                        url: data.config.url
                    });
                    return data.data;
                }
            }

        }

    });
}]);


angular.module('html5Game').factory('Favorites', ['$rootScope', 'Favorites20', 'Favorites30', 'Config', 'Devices',
    function($rootScope, Favorites20, Favorites30, Config, Devices) {
        $rootScope.format = Devices.setFormat(false);
        if(Config.value('ENABLE_NEWTON_USER')){
            return Favorites30;
        } else {
            return Favorites20;
        }
    }
]);
    
angular.module('html5Game').factory('Favorites30', ['$resource', 'Config', 'Logger', '$rootScope', function($resource, Config, Logger, $rootScope) {

    return $resource('', {}, {
        load: { 
            method: 'GET',
            url: Config.value('ENABLE_NEWTON_USER') ? Config.value('MOA_API_FAVORITES_GETLIST_UO30') : Config.value('MOA_API_FAVORITES_GET'),
            params: {
                USER_ID: '@USER_ID',
                size: 51,
                access_token: function(){
                    return (NewtonAdapter.isUserLogged() && Config.value('ENABLE_NEWTON_USER')) ? NewtonAdapter.getUserToken() : '';
                }
            },
            isArray: true,
            transformResponse: function(data) {
                if(data) {
                    data = angular.fromJson(data);

                    if(!angular.isArray(data)) {
                        data = [];
                    }
                }
                Logger.log('API :: Favorites :: load', data);
                return data;
            }
        },

        getList: {
            method: 'GET',
            interceptor: {
                response: function(response) {
                    var result = response.resource;
                    result.$status = response.status;

                    return result;
                }
            },
            url: Config.value('ENABLE_NEWTON_USER') ? Config.value('MOA_API_FAVORITES_GETLIST_UO30') : Config.value('MOA_API_FAVORITES_GET'),
            params: {
                size: '@size',
                offset: '@offset',
                access_token: function(){
                    return (NewtonAdapter.isUserLogged() && Config.value('ENABLE_NEWTON_USER')) ? NewtonAdapter.getUserToken() : '';
                }
            },
            isArray: true,
            hideLoader: true,
            transformResponse: function(data) {
                if(data) {
                    data = angular.fromJson(data);

                    if(!angular.isArray(data)) {
                        data = [];
                    }
                }
                Logger.log('API :: Favorites :: getList', data);
                return data;
            }
        },

        add: {
            method: 'POST',
            url: Config.value('ENABLE_NEWTON_USER') ? Config.value('MOA_API_FAVORITES_SET_UO30') : Config.value('MOA_API_FAVORITES_SET'),
            params: {
                content_id: '@content_id',
                contentId: '@content_id',
                contentType: 'item',
                access_token: function(){
                    return (NewtonAdapter.isUserLogged() && Config.value('ENABLE_NEWTON_USER')) ? NewtonAdapter.getUserToken() : '';
                },
                timestamp: function(){
                    return Date.now();
                }
            },
            isArray: false,
            transformResponse: function(data) {
                if(data) {
                    data = angular.fromJson(data);

                    if(angular.isArray(data)) {
                        data = {};
                    }
                }
                Logger.log('API :: Favorites :: add', data);
                return data;
            }
        },

        delete: {
            method: 'POST',
            url: Config.value('ENABLE_NEWTON_USER') ? Config.value('MOA_API_FAVORITES_DELETE_UO30') : Config.value('MOA_API_FAVORITES_DELETE'),
            params: {
                content_id: '@content_id',
                contentId: '@content_id',
                contentType: 'item',
                access_token: function(){
                    return (NewtonAdapter.isUserLogged() && Config.value('ENABLE_NEWTON_USER')) ? NewtonAdapter.getUserToken() : '';
                },
                timestamp: function(){
                    return Date.now();
                }
            },
            isArray: false,
            transformResponse: function(data) {
                if(data) {
                    data = angular.fromJson(data);

                    if(angular.isArray(data)) {
                        data = {};
                    }
                }
                Logger.log('API :: Favorites :: delete', data);
                return data;
            }
        }

    });
}]);

/**********
For information: https://www.lucidchart.com/publicSegments/view/54c0b2a9-0b94-4dc3-a661-636b0a009bef/image.pdf
**********/


angular.module('html5Game').factory('Favorites20', ['$rootScope', '$resource', '$q', 'Config', 'Logger', 'User',
    function($rootScope, $resource, $q, Config, Logger, User) {

        var defer = $q.defer();
        var quickList = [];

        var core = {

            load: function() {
                User.getStatus(function(user) {
                    if(user.logged) {

                        api.load({
                            USER_ID: user.id
                        }, function(data) {
                            console.log('fav ser', data);
                            if(data.length > 0) {
                                // get quickList
                                for(var k = 0; k < data.length; k++) {
                                    quickList.push(data[k].id);


                                    if(k === data.length - 1) {
                                        // resolve defer
                                        defer.resolve();
                                        // logger
                                        Logger.log('MODULES :: Favorites', 'load :: OK', quickList, data.length);
                                    }
                                }
                            } else {
                                // resolve defer
                                defer.resolve();
                                // logger
                                Logger.log('MODULES :: Favorites', 'load :: OK :: empty', quickList);
                            }


                        }, function() {

                            // get quickList
                            quickList = [];
                            // resolve defer
                            defer.resolve();
                            // logger
                            Logger.log('MODULES :: Favorites', 'load :: KO', quickList);

                        });

                    } else {
                        // resolve defer
                        defer.resolve();
                        // logger
                        Logger.log('MODULES :: Favorites', 'load :: not logged', quickList);
                    }
                });
            },

            getList: function(size, offset, callback) {
                User.getStatus(function(user) {
                    if(user.logged) {

                        api.getList({
                            size: size,
                            offset: offset
                        }, function(data) {

                            // logger
                            Logger.log('MODULES :: Favorites', 'getList :: OK', data);
                            // callback
                            callback(data);

                        }, function() {

                            // logger
                            Logger.log('MODULES :: Favorites', 'getList :: KO', []);
                            // callback
                            callback([]);

                        });

                    } else {
                        // logger
                        Logger.log('MODULES :: Favorites', 'getList :: not logged', []);
                        // callback
                        callback([]);
                    }
                });
            },

            getStatus: function(id, callback) {
                defer.promise.then(function() {
                    if(angular.isDefined(quickList[id]) && quickList[id]) {
                        callback(true);
                        // logger
                        Logger.log('MODULES :: Favorites', 'getStatus', id, true);
                    } else {
                        callback(false);
                        // logger
                        Logger.log('MODULES :: Favorites', 'getStatus', id, false);
                    }
                });
            },

            add: function(id, callback) {
                defer.promise.then(function() {
                    api.add({
                        content_id: id
                    }, function() {

                        callback(true);
                        // change quickList
                        quickList[id] = true;
                        // logger
                        Logger.log('MODULES :: Favorites', 'add :: OK', id, true);

                    }, function() {

                        callback(false);
                        // logger
                        Logger.log('MODULES :: Favorites', 'add :: KO', id, false);

                    });
                });
            },

            delete: function(id, callback) {
                defer.promise.then(function() {
                    api.delete({
                        content_id: id
                    }, function() {

                        callback(true);
                        // change quickList
                        quickList[id] = false;
                        // logger
                        Logger.log('MODULES :: Favorites', 'delete :: OK', id, true);

                    }, function() {

                        callback(false);
                        // logger
                        Logger.log('MODULES :: Favorites', 'delete :: KO', id, false);

                    });
                });
            },

            getCount: function(id, callback) {
                api.getCount({
                    ID: id
                }, function(data) {

                    callback(data.amount);
                    // logger
                    Logger.log('MODULES :: Favorites', 'getCount :: OK', id, data.amount);

                }, function() {

                    callback(null);
                    // logger
                    Logger.log('MODULES :: Favorites', 'getCount :: KO', id, null);

                });
            }
        };

        var api = $resource('', {}, {

            load: { 
                method: 'GET',
                //url: Config.value('MOA_API_LIKE_USER_ITEMS'),
                url: Config.value('ENABLE_NEWTON_USER') ? Config.value('MOA_API_FAVORITES_GETLIST_UO30') : Config.value('MOA_API_FAVORITES_GET'),
                hideLoader: true,
                params: {
                    USER_ID: '@USER_ID',
                    size: 51,
                    ACCESS_TOKEN: function(){
                        return (NewtonAdapter.isUserLogged() && Config.value('ENABLE_NEWTON_USER')) ? NewtonAdapter.getUserToken() : '';
                    }
                },
                isArray: true,
                transformResponse: function(data) {
                    if(data) {
                        data = angular.fromJson(data);

                        if(!angular.isArray(data)) {
                            data = [];
                        }
                    }
                    Logger.log('API :: Favorites :: load', data);
                    return data;
                }
            },

            getList: {
                method: 'GET',
                hideLoader: true,
                interceptor: {
                    response: function(response) {
                        var result = response.resource;
                        result.$status = response.status;

                        return result;
                    }
                },
                url: Config.value('ENABLE_NEWTON_USER') ? Config.value('MOA_API_FAVORITES_GETLIST_UO30') : Config.value('MOA_API_FAVORITES_GET'),
                params: {
                    size: '@size',
                    offset: '@offset',
                    ACCESS_TOKEN: function(){
                        return (NewtonAdapter.isUserLogged() && Config.value('ENABLE_NEWTON_USER')) ? NewtonAdapter.getUserToken() : '';
                    }
                },
                isArray: true,
                transformResponse: function(data) {
                    if(data) {
                        data = angular.fromJson(data);

                        if(!angular.isArray(data)) {
                            data = [];
                        }
                    }
                    Logger.log('API :: Favorites :: getList', data);
                    return data;
                }
            },

            getCount: {
                method: 'GET',
                url: Config.value('MOA_API_LIKE_ITEM_USERS'),
                params: {
                    ID: '@ID'
                },
                isArray: false,
                hideLoader: true,
                transformResponse: function(data) {
                    if(data) {
                        data = angular.fromJson(data);

                        if(angular.isArray(data)) {
                            data = {};
                        }
                    }
                    Logger.log('API :: Favorites :: getCount', data);
                    return data;
                }
            },

            add: {
                method: 'POST',
                url: Config.value('ENABLE_NEWTON_USER') ? Config.value('MOA_API_FAVORITES_SET_UO30') : Config.value('MOA_API_FAVORITES_SET'),
                params: {
                    content_id: '@content_id',
                    contentId: '@content_id',
                    contentType: 'item',
                    ACCESS_TOKEN: function(){
                        return (NewtonAdapter.isUserLogged() && Config.value('ENABLE_NEWTON_USER')) ? NewtonAdapter.getUserToken() : '';
                    },
                    timestamp: function(){
                        return Date.now();
                    }
                },
                isArray: false,
                transformResponse: function(data) {
                    if(data) {
                        data = angular.fromJson(data);

                        if(angular.isArray(data)) {
                            data = {};
                        }
                    }
                    Logger.log('API :: Favorites :: add', data);
                    return data;
                }
            },

            delete: {
                method: 'POST',
                url: Config.value('ENABLE_NEWTON_USER') ? Config.value('MOA_API_FAVORITES_DELETE_UO30') : Config.value('MOA_API_FAVORITES_DELETE'),
                params: {
                    content_id: '@content_id',
                    contentId: '@content_id',
                    contentType: 'item',
                    ACCESS_TOKEN: function(){
                        return (NewtonAdapter.isUserLogged() && Config.value('ENABLE_NEWTON_USER')) ? NewtonAdapter.getUserToken() : '';
                    },
                    timestamp: function(){
                        return Date.now();
                    }
                },
                isArray: false,
                transformResponse: function(data) {
                    if(data) {
                        data = angular.fromJson(data);

                        if(angular.isArray(data)) {
                            data = {};
                        }
                    }
                    Logger.log('API :: Favorites :: delete', data);
                    return data;
                }
            }

        });

        return core;

    }
]);

angular.module('html5Game').factory('Item', ['$resource', 'Config', 'Logger', '$rootScope', 'User', '$state', 'Devices', function($resource, Config, Logger, $rootScope, User, $state, Devices) {

    $rootScope.format = Devices.setFormat(false);

    return $resource('', {}, {

        getList: {
            method: 'GET',
            url: Config.value('MOA_API_CONTENTS'),
            params: {
                FORMATS: $rootScope.format,
                CHECK_OTA: $rootScope.checkCompatibility,
                USER_TYPE: $rootScope.userType,
                SORT: Config.value('HOME_SORT') || '-updated_date'
            },
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            isArray: true,
            interceptor: {
                response: function(data) {
                    Logger.log('API :: Item :: getList', data.data, {
                        method: data.config.method,
                        url: data.config.url
                    });
                    return data.data;
                }
            }
        },

        getRandom: {
            method: 'GET',
            url: Config.value('MOA_API_CONTENTS'),
            params: {
                FORMATS: $rootScope.format,
                CHECK_OTA: $rootScope.checkCompatibility,
                SIZE: 2
            },
            isArray: true,
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            interceptor: {
                response: function(data) {
                    Logger.log('API :: Item :: getRandom', data.data, {
                        method: data.config.method,
                        url: data.config.url
                    });
                    return data.data;
                }
            }
        },

        historyList: {
            method: 'GET',
            url: Config.value('ENABLE_NEWTON_USER') ? Config.value('MOA_API_HISTORY_GETLIST') : Config.value('MOA_API_USER_HISTORY'),
            params: {
                access_token: function(){
                    return (NewtonAdapter.isUserLogged() && Config.value('ENABLE_NEWTON_USER')) ? NewtonAdapter.getUserToken() : '';
                }
            },
            isArray: true,
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            interceptor: {
                response: function(data) {
                    Logger.log('API :: Item :: historyList', data.data, {
                        method: data.config.method,
                        url: data.config.url
                    });
                    return data.data;
                }
            }
        },

        favoritesList: { 
            method: 'GET',
            interceptor: {
                response: function(response) {
                    var result = response.resource;
                    result.$status = response.status;

                    return result;
                }
            },
            url: Config.value('ENABLE_NEWTON_USER') ? Config.value('MOA_API_FAVORITES_GETLIST_UO30') : Config.value('MOA_API_FAVORITES_GET'),
            params: {
                size: '@size',
                offset: '@offset',
                access_token: function(){
                    return (NewtonAdapter.isUserLogged() && Config.value('ENABLE_NEWTON_USER')) ? NewtonAdapter.getUserToken() : '';
                }
            },
            isArray: true,
            transformResponse: function(data) {
                if(data) {
                    data = angular.fromJson(data);

                    if(!angular.isArray(data)) {
                        data = [];
                    }
                }
                Logger.log('API :: Item :: FavoritesList', data);
                return data;
            }
        },

        searchList: {
            method: 'GET',
            url: Config.value('MOA_API_SEARCH'),
            params: {
                FORMATS: $rootScope.format,
                CHECK_OTA: $rootScope.checkCompatibility,
                USER_TYPE: $rootScope.userType
            },
            
            isArray: true,
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            interceptor: {
                response: function(data) {
                    Logger.log('API :: Item :: searchList', data.data, {
                        method: data.config.method,
                        url: data.config.url
                    });
                    return data.data;
                }
            }
        },

        relatedList: {
            method: 'GET',
            url: Config.value('MOA_API_RELATED'),
            params: {
                FORMATS: $rootScope.format,
                CHECK_OTA: $rootScope.checkCompatibility,
                USER_TYPE: $rootScope.userType
            },
            
            isArray: true,
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            interceptor: {
                response: function(data) {
                    Logger.log('API :: Item :: relatedList', data.data, {
                        method: data.config.method,
                        url: data.config.url
                    });
                    return data.data;
                }
            }
        },

        get: {
            method: 'GET',
            url: Config.value('MOA_API_CONTENTS'),
            params: {
                FORMATS: $rootScope.format,
                CHECK_OTA: $rootScope.checkCompatibility,
                SORT: Config.value('HOME_SORT') || '-updated_date'
            },
            
            isArray: false,
            transformResponse: function(data, headersGetter, status) {
                if(Array.isArray(data) && !data.length) {
                    $state.go('error', {}, {
                        reload: true
                    });
                    /* eslint-disable */
                    return;
                    /* eslint-enable */
                } else {
                    return JSON.parse(data);
                }
            },
            interceptor: {
                responseError: function(data) {
                    $state.go('error', {}, {
                        reload: true
                    });
                },
                response: function(data) {
                    if(data.data) {
                        Logger.log('API :: Item :: get', data.data, {
                            id: data.data.id,
                            method: data.config.method,
                            url: data.config.url
                        });
                        return data.data;
                    } else {
                        $state.go('error', {}, {
                            reload: true
                        });
                    }
                }
            }
        },
        
        getPushed: { //non è usato da nessuna parte...
            method: 'GET',
            url: Config.value('MOA_API_CONTENTS_PUSH'),
            params: {
                FORMATS: $rootScope.format,
                CHECK_OTA: $rootScope.checkCompatibility,
                SIZE: 1,
                SORT: '-meta.inserted_date',
                USER_TYPE: $rootScope.userType
            },
            
            isArray: true,
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            interceptor: {
                response: function(data) {
                    Logger.log('API :: Item :: getPush', data.data, {
                        id: data.data.id,
                        method: data.config.method,
                        url: data.config.url
                    });
                    return data.data;
                }
            }
        }
    });
}]);

angular.module('html5Game').factory('Label', ['$q', 'Logger', 'LabelsObj', '$resource', 'Config', '$rootScope', function($q, Logger, LabelsObj, $resource, Config, $rootScope) {
    return {
        
        getList: function(object) {
            var deferred = $q.defer();
            var returnArray = [];

            // get start and size
            var start = (object && object.OFFSET) ? parseInt(object.OFFSET, 10) : 0;
            var size = (object && object.SIZE) ? parseInt(object.SIZE, 10) : 0;

            // get end
            var end = (size && LabelsObj.length > start + size) ? start + size : LabelsObj.length;

            // cycle labels and get labels by size and offset
            for(var i = start, k = 0; i < end; i++, k++) {
                returnArray[k] = LabelsObj[i];
            }

            // logger
            Logger.log('DNFW :: Label :: getList', returnArray, {
                start: start,
                end: end
            });

            // resolve and return
            deferred.resolve(returnArray);
            return {
                promise: deferred.promise,
                data: returnArray
            };
        },

        get: function(object) {
            var foundObj = null;

            if(object.ID) {

                // cycle labels and get label by id
                angular.forEach(LabelsObj, function(value, key) {
                    if(value.id === object.ID) {
                        foundObj = value;
                    }
                });

                // logger
                Logger.log('DNFW :: Label :: get', foundObj, {
                    id: object.ID
                });


            } else if(angular.isDefined(object.POSITION) && (object.POSITION < LabelsObj.length)) {

                // get label by position
                foundObj = LabelsObj[object.POSITION];

                // logger
                Logger.log('DNFW :: Label :: get', foundObj, {
                    position: object.POSITION
                });

            } else if(object.LABEL_SLUG) {
                // cycle labels and get label by slug
                angular.forEach(LabelsObj, function(value, key) {
                    if(value.enc_name === object.LABEL_SLUG) {
                        foundObj = value;
                    }
                });

                // logger
                Logger.log('DNFW :: Label :: get', foundObj, {
                    label_slug: object.LABEL_SLUG
                });

            } else {

                // logger
                Logger.log('DNFW :: Label :: get', foundObj);

            }

            return foundObj;
        }

    };
}]);

angular.module('html5Game').factory('LabelAPI', ['$resource', 'Config', 'Logger', '$rootScope', 'Devices', function($resource, Config, Logger, $rootScope, Devices) {

    $rootScope.format = Devices.setFormat(false);
    return $resource('', {}, {

        getList: {
            method: 'GET',
            url: Config.value('MOA_API_LABELS'),
            params: {
                FORMATS: $rootScope.format
            },
            
            isArray: true,
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            interceptor: {
                response: function(data) {
                    Logger.log('API :: LabelsAPI :: getList', data.data, {
                        method: data.config.method,
                        url: data.config.url
                    });
                    return data.data;
                }
            }
        },

        get: {
            method: 'GET',
            url: Config.value('MOA_API_LABELS'),
            params: {
                FORMATS: $rootScope.format,
                SIZE: 1
            },
            
            isArray: false, 
            transformResponse: function(data) {
                var objectData = JSON.parse(data);
                var object = objectData[0] ? objectData[0] : objectData;
                return object;
            },
            interceptor: {
                response: function(data) {
                    Logger.log('API :: LabelsAPI :: get', data.data, {
                        id: data.data.id,
                        method: data.config.method,
                        url: data.config.url
                    });
                    return data.data;
                }
            }

        }

    });
}]);

angular.module('html5Game').factory('News', ['$resource', 'Config', 'Logger', function($resource, Config, Logger) {
    return $resource('', {}, {
        getList: {
            method: 'GET',
            url: Config.value('CONTENTS_LIST_NEWS4GAMES'),
            isArray: true,
            cache: false,
            transformResponse: function(data) {
                var object = angular.fromJson(data);
                return object;
            },
            interceptor: {
                response: function(data) {
                    Logger.log('API :: News :: getList', data.data, {
                        method: data.config.method,
                        url: data.config.url
                    });
                    return data.data;
                }
            }
        },

        get: {
            method: 'GET',
            url: Config.value('CONTENTS_LIST_NEWS4GAMES'),
            isArray: false,
            cache: false,
            transformResponse: function(data) {
                var object = angular.fromJson(data);
                return object;
            },
            interceptor: {
                response: function(data) {
                    Logger.log('API :: News :: get', data.data, {
                        method: data.config.method,
                        url: data.config.url
                    });
                    return data.data;
                }
            }
        },

        getRelated: {
            method: 'GET',
            url: Config.value('CONTENTS_LIST_NEWS4GAMES'),
            params: {
                get_related: 1,
                size: 4
            },
            isArray: true,
            cache: false,
            transformResponse: function(data) {
                var object = angular.fromJson(data);
                return object;
            },
            interceptor: {
                response: function(data) {
                    Logger.log('API :: News :: getRelated', data.data, {
                        method: data.config.method,
                        url: data.config.url
                    });
                    return data.data;
                }
            }
        }
    });
}]);

angular.module('html5Game').factory('Video', 
    ['$resource', 'Config', 'Logger', '$rootScope', 'User', '$state', function ($resource, Config, Logger, $rootScope, User, $state) {   
        var bvPlayerUrl = '';
        if(Config.value('BPLAYER_DEST_DOMAIN')){
            bvPlayerUrl = Config.value('BPLAYER_DEST_DOMAIN');
        }else{
            bvPlayerUrl = Config.value('DEST_DOMAIN');
        }
        bvPlayerUrl += Config.value('BPLAYER_URL_PATH');

        return $resource('', {}, {
            relatedList: {
                method: 'GET',
                url: Config.value('MOA_API_RELATED'),
                params: {
                    FORMATS: $rootScope.format,
                    CHECK_OTA: $rootScope.checkCompatibility,
                    USER_TYPE: $rootScope.userType
                },
                isArray: true,
                interceptor: {
                    response: function(data){
                        Logger.log('API :: Item :: relatedList', data.data, {
                            method: data.config.method,
                            url: data.config.url
                        });
                        return data.data;
                    }
                }
            },

            get: {
                method: 'GET',
                url: bvPlayerUrl,
                params: {
                    action: 'getInfo'
                },
                isArray: false,
                transformResponse: function(data, headersGetter, status){
                    if (Array.isArray(data) && !data.length){
                        $state.go('error', {}, { reload: true });
                        return;
                    } else {
                        return data;
                    }
                },
                interceptor: {
                    responseError: function(data){
                        // $state.go('error', {}, {reload: true})
                    },
                    response: function(data){
                        if (data.data){
                            Logger.log('API :: Item :: get', data.data, {
                                id: data.data.id,
                                method: data.config.method,
                                url: data.config.url
                            });
                            return data.data;
                        } else {
                            return false;
                            //$state.go('error', {}, {reload: true})
                        }
                    }
                }
            }

        });
    }]
);

angular.module('html5Game').factory('Theme', ['Config', 'EventBus', 'Analytics', '$state', '$location',
    function(Config, EventBus, Analytics, $state, $location) {

        const matchMediaPrefDark = window.matchMedia('(prefers-color-scheme: dark)');

        var service = {
            onSystemThemeChange: function (e) {
                service.applyTheme(e.matches);
                EventBus.trigger('theme-changed', e.matches);
            },
            startListeningToOSTheme: function() {
                try {
                  // Chrome & Firefox
                    matchMediaPrefDark.addEventListener('change', service.onSystemThemeChange);
                } catch (e1) {
                    try {
                      // Safari
                        matchMediaPrefDark.addListener(service.onSystemThemeChange);
                    } catch (e2) {
                        console.log(e2);
                    }
                }
            },
            stopListeningToOSTheme: function() {
                try {
                  // Chrome & Firefox
                    matchMediaPrefDark.removeEventListener('change', service.onSystemThemeChange);
                } catch (e1) {
                    try {
                      // Safari
                        matchMediaPrefDark.removeListener(service.onSystemThemeChange);
                    } catch (e2) {
                        console.log(e2);
                    }
                    
                }
            },
            getThemeDarkPref: function(){
                const prefDarkMQ = window.matchMedia('(prefers-color-scheme: dark)').matches;
                var themePrefDark, 
                    themePrefDarkFromStorage;
                if (Config.value('RESPECT_DEVICE_COLORPREF')){
                    themePrefDark = prefDarkMQ;
                }
                if (JsStorage.isLocalStorageSupported()) {
                    themePrefDarkFromStorage = JsStorage.get('themePrefDark', { type: 'localstorage' });
                } else {
                    themePrefDarkFromStorage = JsStorage.get('themePrefDark', { type: 'cookie' });
                }
                return (typeof themePrefDarkFromStorage === 'undefined') ? themePrefDark : themePrefDarkFromStorage;
            },
            applyTheme: function(activateDark){
                document.querySelector('html').dataset.darktheme = activateDark;
                service.setThemePref(activateDark);
                var props = {
                    category: 'Behavior',
                    action: 'color_scheme_change',
                    page_name: $state.current.name,
                    page_url: $location.absUrl(),
                    chosen_scheme: activateDark ? 'dark' : 'light',
                    label: $location.absUrl(),
                    valuable_cd: 'No',
                    action_cd: 'No'
                };
                Analytics.eventTrack(props);
                NewtonAdapter.trackEvent({
                    name: props.action,
                    properties: props
                });
            },
            setThemePref: function(isDark){
                if (JsStorage.isLocalStorageSupported()) {
                    JsStorage.set('themePrefDark', isDark, { type: 'localstorage' });
                } else {
                    JsStorage.set('themePrefDark', isDark, { type: 'cookie' });
                }  
            },
            toggleTheme: function(theme){
                service.applyTheme(theme);
            },
            setThemeAtBootstrap: function(){
                if (Config.value('RESPECT_DEVICE_COLORPREF')){
                    service.startListeningToOSTheme();
                }
                service.applyTheme(service.getThemeDarkPref());
            }
        };
        return service;
    }
]);

angular.module('html5Game').factory('ContestService', ['$resource', 'Config', 'Logger', '$rootScope', 'EventBus', 'BadgeService', 'Dictionary', function($resource, Config, Logger, $rootScope, EventBus, BadgeService, Dictionary) {
    var contestData = $resource('', {}, {
        getContest: {
            method: 'GET',
            url: Config.value('MOA_API_GAMIFICATION_CONTEST'),
            isArray: false,
            cache: false,
            hideLoader: true,
            params: {
                use_vhost_def: JsStorage.get('debug-contest', { type: 'cookie' }) ? 1 : ''
            },
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            interceptor: {
                response: function(data) {
                    Logger.log('API :: Contest :: get', data);
                    return data.data;
                }
            }
        },
        getActiveContestData: {
            method: 'GET',
            url: Config.value('MOA_API_GAMIFICATION_ACTIVE_CONTEST'),
            isArray: false,
            cache: false,
            hideLoader: true,
            params: {
                use_vhost_def: JsStorage.get('debug-contest', { type: 'cookie' }) ? 1 : ''
            },
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            interceptor: {
                responseError: function(data) {
                    EventBus.trigger('ContestError', data);
                },
                response: function(data) {
                    Logger.log('API :: Contest :: getActive', data);
                    return data.data;
                }
            }
        },
        getActiveMultiContestData: {
            method: 'GET',
            url: Config.value('MOA_API_GAMIFICATION_ACTIVE_MULTI_CONTEST'),
            isArray: true,
            cache: false,
            hideLoader: true,
            params: {
                use_vhost_def: JsStorage.get('debug-contest', { type: 'cookie' }) ? 1 : ''
            },
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            interceptor: {
                responseError: function(data) {
                    EventBus.trigger('ContestError', data);
                },
                response: function(data) {
                    Logger.log('API :: Contest :: getActiveMulti', data);
                    return data.data;
                }
            }
        },
        getGame: {
            method: 'GET',
            url: Config.value('MOA_API_CONTENTS'),
            isArray: false,
            params: {
                FORMATS: $rootScope.format,
                CHECK_OTA: $rootScope.checkCompatibility
            },
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            interceptor: {
                responseError: function(data) {
                    console.log('error contestgame');
                },
                response: function(data) {
                    if(data.data) {
                        return data.data;
                    }
                }
            }
        }
        /*
        Data if there's an active contest
          COMPETITION_ID: "908c5c75a0e0f5e7cb90aca545e856ac"
          CONTENT_ID: "ee4c2fb49503a70558cb1dde0c433e07"
          CONTEST_TIMEFRAME_UTC:
              finish: "2020-11-10T00:00:00Z"
              start: "2020-10-20T00:00:00Z"
        
        If there's no active contest: thows 404;
        */
    });
    return {
        getActiveContest: function(callback){
            contestData.getActiveContestData({ extended_result: 1 }).$promise.then(function(resp){
                if(callback){ callback(resp); }
            });
        },
        getActiveMultiContest: function(callback){
            contestData.getActiveMultiContestData({ extended_result: 1, add_scores: 1, user_score: NewtonAdapter.getUserToken() ? 1 : '', user_id: NewtonAdapter.getUserToken() || '', lang: Config.value('LANGUAGE') || '' }).$promise.then(function(resp){
                if(callback){ callback(resp); }
            }, function(err){
                if(callback){ callback([]); }
            });
        },

        getContestGame: function(id, callback){  //non dovrebbe servire questa.
            contestData.getGame({ content_id: id, CONTENT_ID: id, ID: id }).$promise.then(function(resp){
                //EventBus.trigger('ContestGame', resp);
                if(callback){ callback(resp); }
            });
        },
        getContestById: function(id, callback, moredata){
            contestData.getContest({ competition_id: id, extended_result: 1 }).$promise.then(function(resp){
                if(callback){ callback(resp, moredata); }
            });
        },
        timeLeft: function(timeFrame){ //obj 
            var timeSetup = {
                timeLeft: false,
                isContestOver: false,
                notStarted: false,
                finishHour: false
            };
            if (timeFrame){
                //UTC date format:  "aaaa-mm-ggThh:mm:ssZ" so we manage Local time automatically
                var isDays = true;
                var finish = new Date(timeFrame.finish);
                var start = new Date(timeFrame.start);
                var timeLeft = (finish - Date.now()) / (1000 * 60 * 60 * 24);
                var timeBefore = (start - Date.now()) / (1000 * 60 * 60 * 24);
                if (timeBefore > 0) {
                    timeSetup.notStarted = true;
                }
                var plural = '';
                var timeKey = 'WEBAPP_COMPETITION_TIMELEFT_DAY';
                if (timeSetup.notStarted) {
                    if (timeBefore < 1) {
                        timeBefore = (finish - Date.now()) / (1000 * 60 * 60);
                        timeKey = 'WEBAPP_COMPETITION_TIMELEFT_HOUR';
                    }
                    if (Math.round(timeBefore) > 1){
                        plural = 'S';
                    }
                    timeSetup.notStarted = Math.round(timeBefore) + ' ' + Dictionary.value(timeKey + plural); 
                    //not used at the moment, it might be useful in the future.
                } else {
                    if (timeLeft < 1) {
                        var locale = navigator.language || navigator.languages[0] || [];
                        timeLeft = (finish - Date.now()) / (1000 * 60 * 60);
                        timeKey = 'WEBAPP_COMPETITION_TIMELEFT_HOUR';
                        isDays = false;
                        if (timeLeft < 1) {
                            timeLeft = 1;
                            timeSetup.finishHour = new Date(finish).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
                        }
                    }
                    if (Math.round(timeLeft) > 1){
                        plural = 'S';
                        //if anyone has a better idea to manage plural/singular dict keys, I'm all ears! ^___^
                    }
                    var finalTime = Math.round(timeLeft);
                    timeSetup.timeLeft = finalTime <= 0 ? false : finalTime + ' ' + Dictionary.value(timeKey + plural);
                    timeSetup.isContestOver = Boolean(finalTime <= 0);
                }
            } else {
                timeSetup.isContestOver = true;
            }
            return timeSetup;
        },
        winOrLose: function(timeleft, callback){ //timeleft: dates obj from get active contest
            if (NewtonAdapter.isUserLogged()){      
                BadgeService.getCompetitionBadges({ access_token: NewtonAdapter.getUserToken() || '' }).$promise.then(function(data){
                    if(data && data.length > 0){
                        data.forEach(function(badge){
                            contestData.getContest({ competition_id: badge.relatedIDs[0], extended_result: 1 }, function(resp){
                                resp.badgeData = badge;
                                if(callback){ callback(resp); }
                            });
                        });
                    } else if(callback){ callback(false); }
                });
            } else if(callback){ callback(false); }
        }
    };

}]);

angular.module('html5Game').factory('BadgeService', ['Config', '$resource', 'Logger', function(Config, $resource, Logger) {

    return $resource('', {}, {
        getAllBadges: {
            method: 'GET',
            url: Config.value('MOA_API_GAMIFICATION_USER_BADGES'),
            isArray: true,
            //only_achieved=1 per avere solo quelli già presi
            params: {
                use_vhost_def: JsStorage.get('debug-badge', { type: 'cookie' }) ? 1 : ''
            },           
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            interceptor: {
                response: function(data) {  
                    return data.data;
                }
            }
        },
        getUnseenBadges: {
            method: 'GET',
            url: Config.value('MOA_API_GAMIFICATION_UNSEEN_BADGES'),
            isArray: true,
            params: {
                use_vhost_def: JsStorage.get('debug-badge', { type: 'cookie' }) ? 1 : ''
            },         
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            interceptor: {
                response: function(data) {  
                    return data.data;
                }
            }
        },
        getBadgeByCode: {
            method: 'GET',
            url: Config.value('MOA_API_GAMIFICATION_BADGE_BY_CODE'),
            isArray: true,           
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            params: {
                use_vhost_def: JsStorage.get('debug-badge', { type: 'cookie' }) ? 1 : ''
            },
            interceptor: {
                response: function(data) {  
                    return data.data;
                }
            }
        },
        claimBadge: {
            method: 'GET',
            url: Config.value('MOA_API_GAMIFICATION_SET_BADGE_SEEN'),
            isArray: false,           
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            interceptor: {
                response: function(data) {  
                    return data.data;
                }
            }
        },  

        getCompetitionBadges: {
            method: 'GET',
            url: Config.value('MOA_API_GAMIFICATION_CHECK_WON_BADGE'),
            isArray: true,           
            transformResponse: function(data) {
                return JSON.parse(data);
            },
            params: {
                code: Config.value('BADGE_CODES').contest_win.name,
                use_vhost_def: JsStorage.get('debug-badge', { type: 'cookie' }) ? 1 : ''
            },
            interceptor: {
                response: function(data) {  
                    return data.data;
                }
            }
        }
    });
}]);

angular.module('html5Game').directive('inPageAdv', ['$rootScope', 'User', 'Config', '$window', '$document',
    function($rootScope, User, Config, $window, $document) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/adv/inPageAdv.dir.html',
            replace: true,
            scope: {
                position: '@'
            },
            link: {
                post: function($scope, $element, $attr) {
                    var initAds = function(currentUser) {
                        var userLogged = !(parseInt(currentUser.logged, 10) === 0);
                        var free = !currentUser.subscribed;
                        var showBanner = false;

                        // ads active on webapp context
                        if(Config.value('SHOW_WEBAPP_ADS')) {
                            // ads active on mobile only
                            if(Config.value('SHOW_WEBAPP_ADS_MOBILE_ONLY')) {
                                if($rootScope.deviceType === 'phone') {
                                    showBanner = true;
                                } else {
                                    showBanner = false;
                                }
                            } else {
                                showBanner = true;
                            }
                        }

                        if(Config.value('SHOW_INPAGE_ADS') && (!userLogged || free) && showBanner) {
                            var adclient = Config.value('AD_CLIENT');
                            $scope.slot = Config.value(($rootScope.currentPage + '_' + $attr.position + '_ADV').toUpperCase());
                            if($scope.slot && adclient) {
                                $scope.showFrame = true;
                                $scope.adurl = Config.value('DEST_DOMAIN') + Config.value('AD_IFRAME_URL').replace('/', '') + '?INPAGE_AD_CLIENT=' + adclient + '&INPAGE_AD_SLOT=' + $scope.slot;
                            }
                        }
                    };
                    User.getStatus(initAds);
                }
            }
        };
    }
]);

angular.module('CommonMod').factory('Cat', [
    '$rootScope', '$http', '$location', 'Config', 'Logger', 'Utils',
    function($rootScope, $http, $location, Config, Logger, Utils) {

        this.trackExecution = function() {
            if(Config.value('CAT_TRACKING_ENABLED')) {
                var querystring = Utils.getQueryString();
                var alreadySub = decodeURIComponent(JsStorage.get('b_justlogged'));
                Logger.log('cat qss params', querystring);

                if(!querystring || !querystring.trackExecutionKey || !querystring.dest) {
                    Logger.log('cat.ser.js', 'no valid cat params in qs, looking into cookie');
                    var cookieCat = JsStorage.get(Config.value('CAT_TRACK_COOKIE_NAME'));
                    if(cookieCat) {
                        Logger.log('cat params set from cookie', cookieCat);
                        querystring = Utils.getQueryString(cookieCat);
                        Logger.log('cat found params cookie', querystring);
                        $rootScope.cookieCat = querystring;
                    }
                }

                Logger.log('cat.ser.js', 'check params');
                if(!!querystring && !!querystring.trackExecutionKey && !!querystring.dest) {
                    Logger.log('cat.ser.js', 'deleting cookie - test');
                    JsStorage.delete(Config.value('CAT_TRACK_COOKIE_NAME'));
                    var params = {
                        callback: 'JSON_CALLBACK'
                    };
                    var catparams = Config.value('CAT_PARAMS');
                    Logger.log('CAT PARAMS', catparams);
                    for(var key in catparams.MANDATORY) {
                        params[catparams.MANDATORY[key]] = querystring[key];
                    }
                    for(var keyOpt in catparams.OPTIONAL) {
                        if(typeof querystring[keyOpt] !== 'undefined') {
                            params[catparams.OPTIONAL[keyOpt]] = querystring[keyOpt];
                        }
                    }
                    $rootScope.cookieCat = querystring;

                    var promise = $http({
                        method: 'GET',
                        url: Config.value('CAT_TRACKING_URL'),
                        hideLoader: true,
                        params: params
                    });

                    promise.then(function(response) {
                        Logger.log('MODULE :: Cat', querystring, params, response.data.data);
                    });

                }
                var checkSub = new RegExp(/(^1:){1}/g);
                if ($rootScope.cookieCat && !!(alreadySub && typeof alreadySub.match === 'function' && alreadySub.match(checkSub))){
                    $rootScope.cookieCat.b_justlogged = '1';
                    //check sul typeof messo per fixare l'errore che AVVORTE viene fuori dopo l'unsub. (GMY-2718)
                }
            }
        };

        return this;
    }
]);

angular.module('html5Game').directive('imageloaded', ['$timeout', function($timeout) {
    return {
        restrict: 'A',
        link: function($scope, element, attrs) {
            element.bind('load', function() {
                $timeout(function(){ 
                    $scope.$parent.loaded = true;
                    $scope.loaded = true;
                });
                //could be refined.
            });
        }
    };
}]);
angular.module('html5Game').directive('imagelazy', ['$timeout', 'Config', 'Utils', 'Ranking', function($timeout, Config, Utils, Ranking) {
    return {
        restrict: 'E',
        templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/content/items/imglazyelement.html',
        replace: true,
        transclude: true,
        scope: {
            callback: '&',
            loadedclass: '@',
            source: '='
        },
        link: function($scope, element, attrs) {
            $scope.itemPlay = function(item, goToZoom, position, type, checkCompatibility) {
                Utils.itemPlay(item, goToZoom, position, type, checkCompatibility, Ranking);
            };
            element.bind('load', function() {
                $timeout(function(){ 
                    element[0].classList.add($scope.loadedclass); //b-loaded
                    Utils.triggerResize();
                    if ($scope.callback) {
                        $timeout(function(){
                            $scope.callback();
                        });
                    }
                });
            });
        }
    };
}]);
angular.module('html5Game').directive('items', ['$rootScope', '$timeout', 'Logger', 'User', 'Item', 'Config', 'Utils', 'Ranking', 'imageSizeFilter', 'MFP', 'EventBus', '$location', '$state', 'Analytics', 'GoogleManager', 'Dictionary', 
    function ($rootScope, $timeout, Logger, User, Item, Config, Utils, Ranking, imageSizeFilter, MFP, EventBus, $location, $state, Analytics, GoogleManager, Dictionary) {

        return {
            restrict: 'E',
            templateUrl: function ($element, $attr) {
                return Config.value('JS_TEMPLATE_PREFIX') + '/modules/content/items/' + $attr.tmplname;
            },
            replace: false,
            scope: {
                category: '=',
                label: '=',
                labelslug: '=',
                publisher: '=',
                related: '=',
                query: '=',
                callbackfirst: '=',
                history: '=',
                favorites: '=',
                callbackitems: '&',
                size: '@',
                sizecrop: '@',
                readyitems: '=',
                gotolist: '&',
                imgratio: '@',
                abstract: '=',
                type: '@',
                accesstype: '@',
                tmplname: '@',
                formaticons: '=',
                slider: '@',
                sliderconf: '@',
                slidertitle: '@',
                description: '@',
                mixratio: '@',
                infinite: '=',
                useoutertitle: '=',
                latest: '=',
                showmoreactive: '=',
                shufflegames: '=',
                forcedcontent: '=',
                list: '=',
                highlighted: '=',
                storelink: '='
            },
            link: function ($scope, $element, $attr) {


                // initialize variables and get attributes
                var slider,
                    sliderOpts;
                $scope.noItems = false;
                $scope.lazyClass = Config.value('LAZYLOADING_CLASS');
                $scope.index = 0;
                $scope.doneOnce = false;
                $scope.items = $scope.readyitems ? $scope.readyitems : [];
                $scope.disableScroll = true;
                $scope.loadingSpinner = false;
                $scope.firstLoading = true;
                $scope.size = $scope.size || 8;
                $scope.offset = $scope.offset || 0;
                $scope.imgRatio = $scope.imgratio || 'ratio_1';
                $scope.gameName = !!Config.value('GAMETITLE_BIGSLIDER');

                if (Config.value('GAME_FORMAT_ICONS') && $scope.formaticons) {
                    $scope.apkicon = Config.value('apk_light');
                    $scope.html5icon = Config.value('html5_light');
                    $scope.apkicon_long = Config.value('apk_long_light');
                    $scope.html5icon_long = Config.value('html5_long_light');
                }

                //get utility methods
                $scope.getRandomArbitrary = Utils.getRandomArbitrary; //only used for generallist, remove?
                $scope.setBtnLabel = Utils.setBtnLabel;
                $scope.showBadge = $rootScope.showBadge;
                $scope.getSingleGameAccess = Utils.getSingleGameAccess;
                $scope.setGameFormatBtn = Utils.setGameFormatBtn;
                $scope.truncateAtChar = Utils.truncateAtChar;
                $scope.setDir = Utils.setTextDirection;
                $scope.openZoom = Utils.openZoom;
                $scope.goTo = function (where, data, item, list, eventname) { // for temporary offer page Orange jeux
                    if (eventname) {

                        var props = {
                            category: 'Behavior',
                            action: eventname,
                            page_name: $state.current.name,
                            page_url: $location.absUrl(),
                            label: $location.absUrl(),
                            content_id: item.id + '',
                            offer_app_title: item.default_title || item.title || '',
                            valuable_cd: 'No',
                            action_cd: 'No'
                        };
                        Analytics.eventTrack(props);
                        NewtonAdapter.trackEvent({
                            name: props.action,
                            properties: props
                        });
                    }
                    Utils.goTo(where, data);
                };
                $scope.getApp = function (game) {
                    Utils.getApp({ gameObj: game, isZoom: false, cta: document.querySelector('#contentBtn'), User: User, MFP: MFP });
                };

                $scope.goToList = function (list, noTracking) {
                    if (typeof $scope.gotolist !== 'undefined') {
                        if (!list && $scope.list) {
                            list = $scope.list;
                        }
                        $scope.gotolist(list);
                        if (!noTracking) {
                            var props = {
                                category: 'Behavior',
                                action: 'more_games_click',
                                page_name: $state.current.name,
                                page_url: $location.absUrl(),
                                label: $location.absUrl(),
                                list_id: list ? list.id : '',
                                list_name: list ? list.name : '',
                                valuable_cd: 'No',
                                action_cd: 'No'
                            };
                            Analytics.eventTrack(props);
                            NewtonAdapter.trackEvent({
                                name: props.action,
                                properties: props
                            });
                        }
                    }
                };

                $scope.itemPlay = function (item, goToZoom, position, type, checkCompatibility) {
                    if (item.id === 'external_store_link' && item.url_play){
                        location.href = item.url_play;
                    } else {
                        var eventType = 'game_list_click';
                        if ($scope.slider) {
                            eventType = 'slider_click';
                            if ($scope.highlighted) {
                                eventType = 'highlighted_game_click';
                            }
                        }

                        var listInfo;
                        if ($scope.query) {
                            listInfo = { name: 'search: ' + $scope.query };
                        } else if ($scope.latest) {
                            listInfo = { name: 'latest' };
                        } else if ($scope.related) {
                            listInfo = { name: 'related: ' + $scope.related };
                        } else if ($scope.labelslug) {
                            listInfo = { name: $scope.labelslug };
                        } else {
                            listInfo = $scope.category || $scope.label || $scope.list;
                        }

                        var props = {
                            category: 'Behavior',
                            action: eventType,
                            page_name: $state.current.name,
                            page_url: $location.absUrl(),
                            label: $location.absUrl(),
                            position: position,
                            content_id: item.id + '',
                            game_title: item.default_title || item.title || '',
                            valuable_cd: 'No',
                            action_cd: 'No'
                        };

                        if (listInfo && listInfo.id) {
                            props.list_id = listInfo.id;
                        }
                        if (listInfo && listInfo.name) {
                            props.list_name = listInfo.name;
                        }

                        Analytics.eventTrack(props);
                        NewtonAdapter.trackEvent({
                            name: props.action,
                            properties: props
                        });
                        if (GoogleManager) {
                            GoogleManager.set(props);
                        }
                        if (goToZoom) {
                            Utils.openZoom(item);
                        } else {
                            Utils.gamePlay({ gameObj: item, isZoom: false, cta: document.querySelector('#contentBtn'), User: User, Ranking: Ranking, MFP: MFP, GoogleManager: GoogleManager });
                        }
                    }
                };


                // Mixed ratio items methods
                var mixedRatioContent = {
                    setupMixedAttrs: function (arr, config) {
                        var maxW = window.innerWidth < 768 ? window.innerWidth : 768;
                        arr.forEach(function (item) {
                            item.mixedRatio = {
                                ratio: config.ratio,
                                imgFull: imageSizeFilter(item.images.cover[config.ratio], Utils.getSize4Density(maxW, maxW), 0)
                            };
                        });
                        return arr;
                    },
                    mixedRatioItems: function (items, config) {
                        var mixedItems = [];
                        for (var k = 0; k < config.length; k++) {
                            if (typeof config[k].size === 'number') {
                                var splicedItems = mixedRatioContent.setupMixedAttrs(items.splice(0, config[k].size), config[k]);
                                mixedItems = mixedItems.concat(splicedItems);
                                $scope.size = parseInt(config[k].size + $scope.size, 10);
                            } else {
                                mixedItems = mixedItems.concat(mixedRatioContent.setupMixedAttrs(items, config[k]));
                            }
                        }
                        return mixedItems;
                    },
                    mixedRatioSizes: function (config) {
                        var size = 0;
                        for (var z = 0; z < config.length; z++) {
                            if (typeof config[z].size === 'number') {
                                size = parseInt(config[z].size + size, 10);
                            }
                        }
                        return size;
                    }
                };

                if ($scope.mixratio) {
                    var confSize = window.innerWidth < 768 ? '_SMALL' : '_BIG'; //only for mixedratio DIR
                    $scope.mixedConfig = Config.value($scope.mixratio + confSize);
                    if ($scope.mixedConfig) {
                        $scope.size = mixedRatioContent.mixedRatioSizes($scope.mixedConfig);
                    } else {
                        $scope.mixratio = false;
                    }
                }

                // push items into scope, after performing some tasks
                var pushItems = function (newItems) {
                    $scope.items = $scope.items.concat(newItems);
                    if ($scope.items.length) {
                        $element.attr('data-itemsnumber', parseInt($scope.items.length, 10));
                        if ($scope.shufflegames) {
                            $scope.items = Utils.shuffleArray($scope.items);
                            $scope.shufflegames = '';
                        }
                        if ($scope.sizecrop) {
                            $scope.items = $scope.items.slice(0, parseInt($scope.sizecrop, 10));
                        }
                        if ($scope.forcedcontent) {
                            Utils.forceFirstContent($scope.items);
                        }

                        $scope.imgWSize = $scope.items.length === 1 ? Utils.getBiggerWinSize(1024) : Utils.getSize4Density(360, 360);
                        $scope.imgHSize = 0;

                        if ($scope.slider) {
                            mountSlider($scope.items);
                        } else if ($scope.mixratio) {
                            mixedRatioContent.mixedRatioItems($scope.items, $scope.mixedConfig);
                        }

                        $rootScope.$emit('lazyImg:refresh');

                        // enable infinitescroll if it's not last page
                        if (parseInt(newItems.length, 10) >= parseInt($scope.size, 10)) {
                            $timeout(function () {
                                $scope.disableScroll = false;
                            }, 2000);
                        }
                        // callback first time
                        if ($scope.firstLoading && $scope.callbackfirst) {
                            $scope.callbackfirst(newItems);
                            $scope.firstLoading = false;
                        }
                        if ($scope.callbackitems && $scope.callbackitems.call()) { //TODO: do not show ads if no items!!!!!
                            $scope.itemsExist = false;
                            if ((Config.value('SHOW_WEBAPP_ADS') && $scope.items.length > 1) || (!Config.value('SHOW_WEBAPP_ADS') && $scope.items.length)) {
                                $scope.itemsExist = true;
                            }
                            $scope.callbackitems.call()({
                                itemsExist: $scope.itemsExist
                            });
                            //send info to parent ctr if there are items or not (to show messages in cse there are not).
                            //change to event noresults and general fallback if no items(to be defined)?
                        }
                    } else {
                        //fallback? Empty event?
                    }
                };

                // watch scope values
                $scope.$watch('readyitems', function (value) {
                    //console.log('ready', $scope.readyitems, value);
                    if (value && value.length) {
                        pushItems(value);
                    }
                });

                var listener = $scope.$watchCollection('[category,label,publisher,related,query,labelslug,history,favorites,latest]', function (object) {
                    if (object[0] || object[1] || object[2] || object[5]) {
                        $scope.clearItems();
                        $scope.loadItems();
                        listener();
                    } else if (object[3]) {
                        $scope.clearItems();
                        $scope.loadRelatedItems();
                        listener();
                    } else if (object[4]) {
                        $scope.clearItems();
                        $scope.loadSearchItems();
                        listener();
                    } else if (object[6]) {
                        $scope.clearItems();
                        $scope.loadHistoryItems();
                        listener();
                    } else if (object[7]) {
                        $scope.clearItems();
                        $scope.loadFavoriteItems();
                        listener();
                    } else if (object[8]) {
                        //fallback se non ci sono label o items?
                        $scope.clearItems();
                        $scope.loadAnyItems();
                        listener();
                        //console.log('MISSING ITEMS from $watch', object);
                    } else {
                        //fallback se non ci sono label o items?
                        //console.log('MISSING ITEMS from $watch', object);
                    }
                });

                // clear items
                $scope.clearItems = function () {
                    $scope.items = [];
                };

                var loadMoreTracking = function (items, pagenum, list) {
                    var props = {
                        category: 'Behavior',
                        action: 'load_more_scroll',
                        page_name: $state.current.name,
                        page_url: $location.absUrl(),
                        label: $location.absUrl(),
                        added_games: items,
                        scroll_num: pagenum,
                        valuable_cd: 'No',
                        action_cd: 'No'
                    };
                    Analytics.eventTrack(props);
                    NewtonAdapter.trackEvent({
                        name: props.action,
                        properties: props
                    });
                };

                // load items by category, label or publisher
                $scope.loadItems = function (more) {
                    var category = $scope.category && $scope.category.id ? $scope.category.id : $scope.category;
                    var label = $scope.label && $scope.label.id ? $scope.label.id : $scope.label;
                    var callParams = {
                        SIZE: $scope.size,
                        OFFSET: $scope.offset,
                        CATEGORY: category || '',
                        LABEL: label || '',
                        LABEL_SLUG: $scope.labelslug,
                        PUBLISHER: $scope.publisher,
                        ACCESS_TYPE: $scope.accesstype
                    };
                    Item.getList(callParams).$promise.then(function (tmpItems) {
                        Logger.log('MODULE :: Item :: itemsList :: loadItems', tmpItems, callParams);
                        if (tmpItems.length) {
                            pushItems(tmpItems);
                            if (more) {
                                loadMoreTracking(tmpItems.length, parseInt($scope.offset / $scope.size, 10));
                            }
                        } else if (!$scope.doneOnce) {
                            $scope.$emit('noresults', callParams);
                            EventBus.trigger('zeroitems', callParams);
                            //fallback??
                            //console.log('MISSING ITEMS', callParams);
                        } else {
                            EventBus.trigger('zeroitems', callParams);
                            //console.log('Load more', callParams, $scope.doneOnce);
                        }
                    },
                        function (error) {
                            $scope.$emit('noresults', error);
                        });
                };

                $scope.loadAnyItems = function (more) {
                    var callParams = {
                        SIZE: $scope.size,
                        OFFSET: $scope.offset,
                        LABEL_SLUG: Config.value('TOPGAMES_LABELSLUG')
                    };
                    Item.getList(callParams).$promise.then(function (tmpItems) {
                        Logger.log('MODULE :: Item :: itemsList :: loadAnyItems', tmpItems, callParams);
                        if (tmpItems.length) {
                            pushItems(tmpItems);
                        } else {
                            callParams.LABEL_SLUG = '';
                            Item.getList(callParams).$promise.then(function (tmpAnyItems) {
                                if (tmpAnyItems.length) {
                                    pushItems(tmpAnyItems);
                                } else {
                                    $scope.$emit('noresults', callParams);
                                    //console.log('MISSING ITEMS', callParams);
                                }
                            });
                        }
                    },
                        function (error) {
                            $scope.$emit('noresults', error);
                        });
                };

                // load related items
                $scope.loadRelatedItems = function (more) {
                    Item.relatedList({
                        SIZE: $scope.size,
                        OFFSET: $scope.offset,
                        ID: $scope.related
                    }).$promise.then(function (tmpItems) {
                        Logger.log('MODULE :: Item :: itemsList :: loadRelatedItems', tmpItems, {
                            SIZE: $scope.size,
                            OFFSET: $scope.offset,
                            ID: $scope.related
                        });
                        if (tmpItems.length) {
                            pushItems(tmpItems);
                            $scope.$emit('relatedResults');
                        } else {
                            $scope.$emit('noRelatedResults');
                        }
                    },
                        function (error) {
                            $scope.$emit('noRelatedResults', error);
                        });
                };

                // load items by query string
                $scope.loadSearchItems = function (more) {
                    Item.searchList({
                        SIZE: $scope.size,
                        OFFSET: $scope.offset,
                        QUERY: $scope.query
                    }).$promise.then(function (tmpItems) {
                        Logger.log('MODULE :: Item :: itemsList :: loadSearchItems', tmpItems, {
                            SIZE: $scope.size,
                            OFFSET: $scope.offset,
                            QUERY: $scope.query
                        });
                        if (tmpItems.length) {
                            pushItems(tmpItems);
                            EventBus.trigger('searchResults', tmpItems.length);
                            var propsRes = {
                                category: 'Behavior',
                                action: 'search_results',
                                page_name: $state.current.name,
                                page_url: $location.absUrl(),
                                label: $location.absUrl(),
                                query: $scope.query,
                                results: tmpItems.length,
                                valuable_cd: 'No',
                                action_cd: 'No'
                            };
                            Analytics.eventTrack(propsRes);
                            NewtonAdapter.trackEvent({
                                name: propsRes.action,
                                properties: propsRes
                            });
                            if (more) {
                                loadMoreTracking(tmpItems.length, parseInt($scope.offset / $scope.size, 10));
                            }
                        } else if (!$scope.doneOnce) {
                            EventBus.trigger('noSearchResults');
                        }
                    },
                        function (error) {
                            EventBus.trigger('noSearchResults', error);
                        });
                };

                // load user history items
                $scope.loadHistoryItems = function (more) {
                    Item.historyList({
                        SIZE: $scope.size,
                        OFFSET: $scope.offset
                    }).$promise.then(function (tmpItems) {
                        Logger.log('MODULE :: Item :: itemsList :: loadHistoryItems', tmpItems, {
                            SIZE: $scope.size,
                            OFFSET: $scope.offset
                        });
                        //questo si può rimuovere se c'è l'infinite? O va visto se funge il size della api?
                        if (tmpItems.length > parseInt($scope.size, 10)) {
                            tmpItems = tmpItems.slice(0, parseInt($scope.size, 10));
                        }
                        if (tmpItems.length) {
                            pushItems(tmpItems);
                            $scope.$emit('historyFull');
                        } else if (!$scope.doneOnce) {
                            $scope.$emit('noHistory');
                        }

                    },
                        function (error) {
                            $scope.$emit('noHistory', error);
                        });
                };

                // load user's favourite items
                $scope.loadFavoriteItems = function (more) {
                    if (Config.value('ENABLE_FAVORITES')) {
                        Item.favoritesList({
                            size: $scope.size,
                            OFFSET: $scope.offset
                        }).$promise.then(function (tmpItems) {
                            Logger.log('MODULE :: Item :: itemsList :: loadFavoriteItems', tmpItems, {
                                size: $scope.size,
                                OFFSET: $scope.offset
                            });
                            if (tmpItems.length) {
                                pushItems(tmpItems);
                                $scope.$emit('favoritesFull');
                            } else if (!$scope.doneOnce) {
                                $scope.$emit('noFavorites');
                            }
                        },
                            function (error) {
                                $scope.$emit('noFavorites', error);
                            });
                    } else {
                        $scope.$emit('noFavorites');
                    }
                };

                //sliders & carousel: need to have the items ready when they are intialized, otherwise Glide breaks
                if ($scope.slider) {
                    sliderOpts = { //base conf used for small sliders on base gameasy products
                        type: 'carousel',
                        startAt: 1,
                        focusAt: 'center',
                        gap: 4,
                        perView: 2,
                        peek: 50,
                        animationDuration: 500,
                        autoplay: 3000,
                        direction: $rootScope.RTLlang ? 'rtl' : 'ltr',
                        breakpoints: {
                            4000: { perView: 6 },
                            1024: { perView: 5 },
                            768: { perView: 4 },
                            600: { perView: 3 },
                            480: { perView: 2 },
                            320: { perView: 2 }
                        }
                    };
                    if ($scope.sliderconf) {
                        angular.merge(sliderOpts, Config.value($scope.sliderconf));
                    }
                }

                var mountSlider = function (els) {
                    if (els && $scope.slider && document.querySelector('.slider-' + $attr.dataindex + ' .glide')) {
                        var sliderName = '.slider-' + $attr.dataindex + ' .glide';
                        $scope.items = $scope.shufflegames ? Utils.shuffleArray(els) : els;
                        if ($scope.items) {
                            slider = new Glide('.slider-' + $attr.dataindex + ' .glide', sliderOpts);

                            //EXTERNAL ITEM INJECTION: used on Gamester QA for Store banner in home carousel
                            if (Config.value('CAROUSEL_EXTERNAL_ITEM_INJECTION') && $attr.storelink) {
                                var externalItem = {
                                    'id': 'external_store_link',
                                    'title': Dictionary.value('WEBAPP_STORE_BUTTON_TITLE'),
                                    'custom_label': 'WEBAPP_STORE_BUTTON_TITLE',
                                    'description': '',
                                    'default_title': '',
                                    'default_description': '',
                                    'description_short': '',
                                    'images': {
                                        'cover': {
                                            'ratio_1_4': Config.value('additional-banner'),
                                            'ratio_2': Config.value('additional-banner'),
                                            'ratio_1_5': Config.value('additional-banner'),
                                            'ratio_0_7': Config.value('additional-banner'),
                                            'ratio_1': Config.value('additional-banner')
                                        }
                                    },
                                    'url_zoom': Config.value('EXTERNAL_MENU_LINK2'),
                                    'url_zoom_simple': Config.value('EXTERNAL_MENU_LINK2'),
                                    'url_leaf_engine_subscription': Config.value('EXTERNAL_MENU_LINK2'),
                                    'compatibility': true,
                                    'url_play': Config.value('EXTERNAL_MENU_LINK2'),
                                    'is_external': true,
                                    'format': 'banner',
                                    'access_type': {
                                        'guest': true,
                                        'free': true,
                                        'premium': true
                                    },
                                    'mipqa': 'link-menu-store'
                                };
                                $scope.items.splice(parseInt($scope.items.length / 2, 10), 0, externalItem);
                            }

                            if ($scope.slider === 'carousel') {
                                slider.on('mount.after', function () {
                                    var elements = $element[0].querySelectorAll('.glide__slide--clone');
                                    if (elements.length) {
                                        angular.forEach(elements, function (el) {
                                            el.addEventListener('click', function () {
                                                var index = el.dataset.itemindex;
                                                var item = $scope.items[index];
                                                if (item) {
                                                    $scope.itemPlay(item, true, index + 1, 'custom');
                                                }
                                            });
                                        });
                                    }
                                });
                            }

                            slider.on('swipe.end', function () {
                                var props = {
                                    category: 'Behavior',
                                    action: 'slider_swipe',
                                    page_name: $state.current.name,
                                    page_url: $location.absUrl(),
                                    label: $location.absUrl(),
                                    valuable_cd: 'No',
                                    action_cd: 'No'
                                };
                                if ($scope.list && $scope.list.id) {
                                    props.list_id = $scope.list.id;
                                }
                                if ($scope.list && $scope.list.name) {
                                    props.list_name = $scope.list.name;
                                }
                                Analytics.eventTrack(props);
                                NewtonAdapter.trackEvent({
                                    name: props.action,
                                    properties: props
                                });
                            });

                            if (Config.value('SHOW_MORE_IN_SLIDER') && $attr.showmoreactive) {
                                var showMore = {
                                    showMore: true
                                };
                                $scope.items.push(showMore);
                            }

                            setTimeout(function () {
                                slider.mount();
                                Utils.triggerResize();
                            }, 250);
                        }
                    }
                };

                //infinite scroll
                $scope.loadMore = function () {
                    $scope.doneOnce = true;
                    if ($scope.infinite && !$scope.disableScroll) {
                        // disable infinitescroll
                        $scope.disableScroll = true;
                        // enable loadingSpinner
                        $scope.loadingSpinner = true;
                        // increase offset
                        $scope.offset = parseInt($scope.offset, 10) + parseInt($scope.size, 10);
                        // load more items
                        Logger.log('MODULE :: Item :: itemsList :: loadMore', $scope.offset);
                        if ($scope.category || $scope.label || $scope.publisher) {
                            $scope.loadItems(true);
                        } else if ($scope.related) {
                            $scope.loadRelatedItems();
                        } else if ($scope.query) {
                            $scope.loadSearchItems(true);
                        } else if ($scope.history) {
                            $scope.loadHistoryItems();
                        } else if ($scope.favorites) {
                            $scope.loadFavoriteItems();
                        }
                    }
                };

            }
        };

    }]);

angular.module('html5Game').directive('itemSingle', ['$rootScope', '$state', 'EventBus', 'Config', 'User', 'Utils', 'Ranking', 'Dictionary', 'Leaderboard',
    function($rootScope, $state, EventBus, Config, User, Utils, Ranking, Dictionary, Leaderboard) {
        //single item, used for contest/competition
        return {
            restrict: 'E',
            templateUrl: function($element, $attr) {
                var tpl = $attr.tmplname ? $attr.tmplname : 'itemSingle.html';
                return Config.value('JS_TEMPLATE_PREFIX') + '/modules/content/items/' + tpl;
            },
            replace: true,
            scope: {
                imgratio: '=',
                contest: '='
            },
            link: function($scope, $element, $attr) {
                $scope.$watch('contest', function (newValue, oldValue) {
                    if (newValue || oldValue){
                        $scope.game = $scope.contest.content_info;
                        $scope.imgratio = $scope.imgratio || 'ratio_2';
                        if ($scope.imgratio && $scope.imgratio === 'ratio_1'){
                            $scope.gameImg = $scope.contest.content_info.images.icon ? $scope.contest.content_info.images.icon : $scope.contest.content_info.images.cover[$scope.imgratio];
                        } else {
                            $scope.gameImg = $scope.contest.content_info.images.cover[$scope.imgratio];
                        }
                        $scope.imgWSize = Utils.getSize4Density(180, 360);
                        $scope.imgHSize = 0;
                        $scope.gamePlay = function(e) {
                            Utils.gamePlay({ gameObj: $scope.contest.content_info, User: User, Ranking: Ranking }, e);
                        };
                        $scope.itemZoom = function(item) {
                            Utils.itemPlay(item, true, false, 'custom', false, Ranking);
                        };
                        $scope.setBtnLabel = Utils.setBtnLabel;
                        $scope.setGameFormatBtn = Utils.setGameFormatBtn; 
                        $scope.truncateAtChar = Utils.truncateAtChar;
                        $scope.setDir = Utils.setTextDirection;
                        $scope.showBadge = $rootScope.showBadge;
                        $scope.getSingleGameAccess = Utils.getSingleGameAccess;

                        $scope.start = $scope.contest.CONTEST_TIMEFRAME_UTC.start; //(new Date($scope.contest.CONTEST_TIMEFRAME_UTC.start).getTime() / 1000);
                        $scope.end = $scope.contest.CONTEST_TIMEFRAME_UTC.finish;//(new Date($scope.contest.CONTEST_TIMEFRAME_UTC.finish).getTime() / 1000);

                        $scope.ready = true; 
                    }
                });
            }
        };

    }
]);

angular.module('html5Game').directive('list', ['$rootScope', '$timeout', 'Logger', 'User', 'Item', 'Config', 'Utils', 'Label', 'Category', '$state',
    function($rootScope, $timeout, Logger, User, Item, Config, Utils, Label, Category, $state) {

        return {
            restrict: 'E',
            templateUrl: function($element, $attr) {
                return Config.value('JS_TEMPLATE_PREFIX') + '/modules/lists/' + $attr.tmplname;
            },
            replace: false,
            scope: {
                categories: '=',
                labels: '=',
                labelslug: '=',
                userlists: '=',
                callbackfirst: '=',
                callbackitems: '&',
                size: '@',
                readyitems: '=',
                gotolist: '&',
                imgratio: '=',
                noimg: '=',
                sliderconfig: '=' //vedere se funge...
            },
            link: function($scope, $element, $attr) {

                /***************************************
                 ************ INITIALIZATION ************
                 ***************************************/
                $scope.truncateAtChar = Utils.truncateAtChar;
                $scope.setDir = Utils.setTextDirection;
                $scope.goToList = function(list){
                    if (typeof $scope.gotolist !== 'undefined'){
                        $scope.gotolist(list);
                    }
                };

                // initialize variables and get attributes
                $scope.lazyClass = Config.value('LAZYLOADING_CLASS');
                $scope.index = 0;
                $scope.doneOnce = false;
                $scope.items = $scope.readyitems ? $scope.readyitems : [];
                $scope.disableScroll = true;
                $scope.loadingSpinner = false;
                $scope.firstLoading = true;
                $scope.size = $scope.size || 10;
                $scope.offset = $scope.offset || 0;
                $scope.imgratio = $scope.imgratio || 'ratio_1';
                // watch scope values
                var listener = $scope.$watchCollection('[categories,labels,labelslug,userlists,readyitems]', function(object) {
                    if(object[0] || object[1] || object[2] || object[5]) { //gestire casi in cui ci sono entrambe o tutte le liste tipo listnav (che poi è il caso più frequente)
                        $scope.clearItems();
                        $scope.loadItems();
                        listener();
                    } else if(object[3]) {
                        $scope.clearItems();
                        $scope.loadRelatedItems();
                        listener();
                    } else if(object[4]) {
                        $scope.clearItems();
                        $scope.loadSearchItems();
                        listener();
                    } else if(object[6]) {
                        $scope.clearItems();
                        $scope.loadHistoryItems();
                        listener();
                    } else if(object[7]) {
                        $scope.clearItems();
                        $scope.loadFavoriteItems();
                        listener();
                    } else if(object[8]) {
                        $scope.pushItems($scope.readyitems);
                        listener();
                    }/* else {
                        //fallback se non ci sono label o items?
                        $scope.clearItems();
                        $scope.loadItems(true);
                        listener();
                    }*/
                });

                // clear items
                $scope.clearItems = function() {
                    $scope.items = [];
                };

                /***************************************
                 ********** LOAD ITEMS FROM API *********
                 ***************************************/

                // load items by category, label or publisher
                $scope.loadItems = function(fakeNoResults) {
                    var callParams = {
                        SIZE: $scope.size,
                        OFFSET: $scope.offset,
                        CATEGORY: $scope.category,
                        LABEL: $scope.label,
                        LABEL_SLUG: $scope.labelslug,
                        PUBLISHER: $scope.publisher,
                        ACCESS_TYPE: $scope.accesstype
                    };
                    Item.getList(callParams).$promise.then(function(tmpItems) {
                        Logger.log('MODULE :: Item :: itemsList :: loadItems', tmpItems, callParams);
                        if (tmpItems){
                            $scope.pushItems(tmpItems);
                            if (fakeNoResults){
                                $scope.noResults = true;
                                $scope.$emit('noresults', callParams);
                            }
                        } else {
                            $scope.$emit('noresults', callParams);
                            //fallback??
                        }
                    });
                };

                // load related items
                $scope.loadRelatedItems = function() {
                    Item.relatedList({
                        SIZE: $scope.size,
                        OFFSET: $scope.offset,
                        ID: $scope.related
                    }).$promise.then(function(tmpItems) {
                        Logger.log('MODULE :: Item :: itemsList :: loadRelatedItems', tmpItems, {
                            SIZE: $scope.size,
                            OFFSET: $scope.offset,
                            ID: $scope.related
                        });
                        $scope.pushItems(tmpItems);
                    });
                };

                // load items by query string
                $scope.loadSearchItems = function() {
                    Item.searchList({
                        SIZE: $scope.size,
                        OFFSET: $scope.offset,
                        QUERY: $scope.query
                    }).$promise.then(function(tmpItems) {
                        Logger.log('MODULE :: Item :: itemsList :: loadSearchItems', tmpItems, {
                            SIZE: $scope.size,
                            OFFSET: $scope.offset,
                            QUERY: $scope.query
                        });
                        $scope.pushItems(tmpItems);
                    });
                };

                $scope.loadHistoryItems = function() {
                    Item.historyList({
                        SIZE: $scope.size,
                        OFFSET: $scope.offset
                    }).$promise.then(function(tmpItems) {
                        Logger.log('MODULE :: Item :: itemsList :: loadHistoryItems', tmpItems, {
                            SIZE: $scope.size,
                            OFFSET: $scope.offset
                        });
                        //questo si può rimuovere se c'è l'infinite? O va visto se funge il size della api?
                        if (tmpItems.length > parseInt($scope.size, 10)){
                            tmpItems = tmpItems.slice(0, parseInt($scope.size, 10));
                        }
                        $scope.pushItems(tmpItems);
                    });
                };

                $scope.loadFavoriteItems = function() {
                    Item.favoritesList({
                        size: $scope.size,
                        OFFSET: $scope.offset
                    }).$promise.then(function(tmpItems) {
                        Logger.log('MODULE :: Item :: itemsList :: loadFavoriteItems', tmpItems, {
                            size: $scope.size,
                            OFFSET: $scope.offset
                        });
                        $scope.pushItems(tmpItems);
                    });
                };

                /***************************************
                 ******* PUSH LOADED ITEMS TO VIEW ******
                 ***************************************/

                $scope.pushItems = function(newItems) {
                    $scope.items = $scope.items.concat(newItems);

                    if ($attr.shufflegames){
                        $scope.items = Utils.shuffleArray($scope.items);
                        $attr.shufflegames = '';
                    }
                    switch($attr.type) {
                    case 'general':
                        //sta cosa del banner la mettiamo meglio? O si leva dalle liste?
                        if(Config.value('INSTALL_HYBRID_VISIBLE') && Config.value('INSTALL_HYBRID_MIDPAGE_VISIBLE') && (($rootScope.selector === 'android' && Config.value('GOOGLEPLAY_STORE_URL')) || ($rootScope.selector === 'ios' && Config.value('ITUNES_STORE_URL'))) && !$scope.doneOnce) {
                            $scope.items.splice(2, 0, 'hybridinstall');
                        } else if(Config.value('SHOW_WEBAPP_ADS') && !$scope.doneOnce && Config.value('SHOW_INPAGE_ADS')) {
                            $scope.items.splice(2, 0, 'adv');
                        }
                        break;
                    case 'simple':
                    case 'boxed':    
                        $scope.extended = !!$scope.abstract;
                        $scope.imgWSize = $scope.items.length === 1 ? Utils.getBiggerWinSize(1024) : Utils.getSize4Density(360, 360);
                        $scope.imgHSize = 0;
                        $rootScope.$emit('lazyImg:refresh');
                        break;
                    case 'games':
                        if (Config.value('GAME_FORMAT_ICONS')){
                            $scope.apkicon = Config.value('apk_light');
                            $scope.html5icon = Config.value('html5_light');
                        }
                        $scope.imgWSize = $scope.items.length === 1 ? Utils.getBiggerWinSize(1024) : Utils.getSize4Density(360, 360);
                        $scope.imgHSize = 0;
                        $rootScope.$emit('lazyImg:refresh');
                        break;
                    default:
                        //placeholder - otherwise hyb install shows in explore as well.
                        break;
                    }

                    // enable infinitescroll if it's not last page
                    if(parseInt(newItems.length, 10) >= parseInt($scope.size, 10)) {
                        $timeout(function() {
                            $scope.disableScroll = false;
                        }, 2000);
                    }
                    // callback first time
                    if($scope.firstLoading && $scope.callbackfirst) {
                        $scope.callbackfirst(newItems);
                        $scope.firstLoading = false;
                    }
                    if($scope.callbackitems && $scope.callbackitems.call()) { //TODO: do not show ads if no items!!!!!
                        $scope.itemsExist = false;
                        if((Config.value('SHOW_WEBAPP_ADS') && $scope.items.length > 1) || (!Config.value('SHOW_WEBAPP_ADS') && $scope.items.length)) {
                            $scope.itemsExist = true;
                        }
                        $scope.callbackitems.call()({
                            itemsExist: $scope.itemsExist
                        });
                        //send info to parent ctr if there are items or not (to show messages in cse there are not).
                        //change to event noresults and general fallback if no items(to be defined)?
                    }
                };

                /***************************************
                ***********  INFINITE SCROLL ***********
                ***************************************/

                $scope.loadMore = function(){
                    $scope.doneOnce = true;
                    if($scope.infinite && !$scope.disableScroll){
                        // disable infinitescroll
                        $scope.disableScroll = true;
                        // enable loadingSpinner
                        $scope.loadingSpinner = true;
                        // increase offset
                        $scope.offset = parseInt($scope.offset, 10) + parseInt($scope.size, 10);
                        // load more items
                        Logger.log('MODULE :: Item :: itemsList :: loadMore', $scope.offset);
                        if($scope.category || $scope.label || $scope.publisher){
                            $scope.loadItems();
                        } else if($scope.related){
                            $scope.loadRelatedItems();
                        } else if($scope.query){
                            $scope.loadSearchItems();
                        } else if ($scope.history){
                            $scope.loadHistoryItems();
                        } else if ($scope.favorites){
                            $scope.loadFavoriteItems();
                        }
                    }
                };
            }
        };

    }]);

angular.module('html5Game').directive('listMixedRatio', ['$rootScope', 'Item', 'Config', 'LabelAPI', '$state', 'Utils', 'Ranking', 'ImageSize', 'imageSizeFilter', '$location', 'Analytics', 
    function($rootScope, Item, Config, Label, $state, Utils, Ranking, ImageSize, imageSizeFilter, $location, Analytics) {

        return {
            restrict: 'E',
            templateUrl: function($element, $attr) {
                return Config.value('JS_TEMPLATE_PREFIX') + '/modules/content/items/mixedRatioList.html';
            },
            replace: false,
            scope: {
                items: '=',
                callbackitems: '&',
                size: '@',
                gotolist: '&',
                label: '=',
                labelslug: '=',
                category: '=',
                mixratio: '@',
                shufflegames: '=',
                highlighted: '=',
                tinyimg: '='
            },
            link: function($scope, $element, $attr) {

                /***************************************
                 ************ INITIALIZATION ************
                 ***************************************/
                $scope.lazyClass = Config.value('LAZYLOADING_CLASS');
                $scope.setGameFormatBtn = Utils.setGameFormatBtn; 
                var listInfo = $scope.labelslug ? { name: $scope.labelslug } : $scope.label || $scope.category;

                $scope.$watch('label', function (newValue, oldValue) {
                    if (newValue || oldValue){
                        listInfo = $scope.label;
                    }
                });
                $scope.$watch('category', function (newValue, oldValue) {
                    if (newValue || oldValue){
                        listInfo = $scope.category;
                    }
                });
                $scope.$watch('labelslug', function (newValue, oldValue) {
                    if (newValue || oldValue){
                        listInfo = { name: $scope.labelslug };
                    }
                });

                $scope.confSize = window.innerWidth < 768 ? '_SMALL' : '_BIG';
                $scope.mixedConfig = Config.value($scope.mixratio + $scope.confSize);

                if (Config.value('GAME_FORMAT_ICONS')){
                    $scope.apkicon = Config.value('apk_light');
                    $scope.html5icon = Config.value('html5_light');
                }

                var setupMixedAttrs = function(arr, config){
                    var maxW = window.innerWidth < 768 ? window.innerWidth : 768;
                    arr.forEach(function(item){
                        item.mixedRatio = {
                            ratio: config.ratio,
                            imgFull: imageSizeFilter(item.images.cover[config.ratio], Utils.getSize4Density(maxW, maxW), 0)
                        };
                    });
                    return arr;
                };

                var mixedRatioItems = function(items, config){
                    var mixedItems = [];
                    for(var k = 0; k < config.length; k++){
                        if (typeof config[k].size === 'number'){
                            var splicedItems = setupMixedAttrs(items.splice(0, config[k].size), config[k]);
                            mixedItems = mixedItems.concat(splicedItems);
                            $scope.size = parseInt(config[k].size + $scope.size, 10);
                        } else {
                            mixedItems = mixedItems.concat(setupMixedAttrs(items, config[k]));
                        }
                    }
                    var highlightedId = [];
                    var highlightedTitle = [];
                
                    for(var f = 0; f < mixedItems.length; f++){
                        highlightedTitle.push((mixedItems[f].default_title || mixedItems[f].title));
                        highlightedId.push(mixedItems[f].id);
                    }
                    var props = {
                        category: 'Behavior',
                        action: 'highlighted_games_displayed',
                        page_name: $state.current.name,
                        page_url: $location.absUrl(),
                        label: $location.absUrl(),
                        list_id: listInfo ? listInfo.id : '',
                        list_name: listInfo ? listInfo.name : '',
                        content_ids: highlightedId.join(),
                        game_titles: highlightedTitle.join(),
                        valuable_cd: 'No',
                        action_cd: 'No'
                    };
                    Analytics.eventTrack(props);
                    NewtonAdapter.trackEvent({
                        name: props.action,
                        properties: props
                    });
                    return mixedItems;
                };
                var size = 0;
                for(var z = 0; z < $scope.mixedConfig.length; z++){
                    if (typeof $scope.mixedConfig[z].size === 'number'){
                        size = parseInt($scope.mixedConfig[z].size + size, 10);
                    }
                }
                if ($scope.items) {
                    $scope.items = $scope.shufflegames ? mixedRatioItems(Utils.shuffleArray($scope.items), $scope.mixedConfig) : mixedRatioItems($scope.items, $scope.mixedConfig);
                    $element.attr('data-itemsnumber', parseInt($scope.items.length, 10));
                } else if ($scope.category || $scope.label || $scope.labelslug){
                    Item.getList({
                        SIZE: $scope.size || size || 12,
                        OFFSET: 0,
                        CATEGORY: $scope.category,
                        LABEL: $scope.label,
                        LABEL_SLUG: $scope.labelslug
                    }).$promise.then(function(tmpItems) {
                        if (tmpItems){
                            if ($scope.shufflegames){
                                $scope.items = mixedRatioItems(Utils.shuffleArray(tmpItems), $scope.mixedConfig);
                            } else {
                                $scope.items = mixedRatioItems(tmpItems, $scope.mixedConfig);
                            }
                            $element.attr('data-itemsnumber', parseInt($scope.items.length, 10));
                        }
                    });
                } else {
                    Item.getList({
                        SIZE: $scope.size || size || 12,
                        OFFSET: 0
                    }).$promise.then(function(tmpItems) {
                        if ($scope.shufflegames){
                            $scope.items = mixedRatioItems(Utils.shuffleArray(tmpItems), $scope.mixedConfig);
                        } else {
                            $scope.items = mixedRatioItems(tmpItems, $scope.mixedConfig);
                        }
                        $element.attr('data-itemsnumber', parseInt($scope.items.length, 10));
                    });
                }
                
                if($scope.callbackitems && $scope.callbackitems.call()) {
                    $scope.itemsExist = $scope.items ? !!$scope.items.length : false;
                    $scope.callbackitems.call()({
                        itemsExist: $scope.itemsExist
                    });
                }
                
                if (Config.value('HOME_ITEMS_DIRECT_PLAY') && $state.is('home')){
                    $scope.itemPlay = function(item, a, b, c, d, e){ //e for event, others for compatibility with the default method
                        var allEls = document.querySelectorAll('.item_actions');
                        angular.forEach(allEls, function(el) {
                            el.classList.add('hidden');
                        });
                        document.querySelector('.item_actions.id' + item.id).classList.remove('hidden');
                    };
                } else {
                    $scope.itemPlay = function(item, goToZoom, position, type, checkCompatibility) {
                        Utils.itemPlay(item, goToZoom, position, type, checkCompatibility, Ranking);
                        var props = {
                            category: 'Behavior',
                            action: 'highlighted_game_click',
                            page_name: $state.current.name,
                            page_url: $location.absUrl(),
                            game_title: item.default_title || item.title,
                            list_id: listInfo ? listInfo.id + '' : '',
                            list_name: listInfo ? listInfo.name : '',
                            content_id: item.id + '',
                            position: position,
                            label: item.id + '',
                            valuable_cd: 'No',
                            action_cd: 'No'
                        };
                        Analytics.eventTrack(props);
                        NewtonAdapter.trackEvent({
                            name: props.action,
                            properties: props
                        });
                    };
                }

                $scope.setDir = Utils.setTextDirection;

                $scope.showBadge = $rootScope.showBadge;
                $scope.getSingleGameAccess = Utils.getSingleGameAccess;
            }
        };

    }]);

angular.module('html5Game').directive('itemActions', ['$rootScope', '$timeout', 'Logger', 'User', 'Item', 'Config', 'Utils', 'Ranking', 'MFP',
    function($rootScope, $timeout, Logger, User, Item, Config, Utils, Ranking, MFP) {

        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/content/items/itemActions.dir.html',
            replace: false,
            scope: {
                item: '='
            },
            link: function($scope, $element, $attr) {

                $scope.setBtnLabel = Utils.setBtnLabel;
                $scope.openZoom = Utils.openZoom;
                $scope.itemZoom = function(item) {
                    Utils.itemPlay(item, true, false, 'custom', false, Ranking);
                };
                $scope.gamePlay = function(item, e) {
                    Utils.gamePlay({ gameObj: item, isZoom: false, cta: $element[0], User: User, Ranking: Ranking, MFP: MFP }, e);
                    $element[0].classList.add('hidden');
                };

            }
        };

    }]);

angular.module('html5Game').directive('listNews', ['$rootScope', '$timeout', 'Logger', 'News', 'Config', 'Utils',
    function($rootScope, $timeout, Logger, News, Config, Utils) {
        return {
            restrict: 'E',
            templateUrl: function() {
                return Config.value('JS_TEMPLATE_PREFIX') + '/modules/content/news/newsList.html';
            },
            scope: {
                size: '@',
                infinite: '@',
                extended: '@',
                imgratio: '=',
                id: '@'
            },
            link: function($scope, $element, $attr) {
                /***************************************
                 ************ INITIALIZATION ************
                 ***************************************/
                $scope.lazyClass = Config.value('LAZYLOADING_CLASS');
                $scope.goToZoom = Utils.goToZoom;
                $scope.separator = $attr.separator;
                /**
                 * Images attributes
                 */
                $scope.imgWSize = Config.value('HIGHER_QUALITY_IMGS') ? 360 : 240;
                $scope.imgHSize = 0;
                $scope.imgRatio = $attr.imgratio || 'ratio_1';
                /**
                 * All items shown
                 */
                $scope.items = [];
                /**
                 * Flag to disable lazyload while loading new items
                 */
                //$scope.disableScroll = true;
                /**
                 * Size param for the API call
                 */
                $scope.size = $attr.size || 10;
                /**
                 * Offset param for the API call
                 */
                $scope.offset = $attr.offset || 0;
                /**
                 * Is infinite scroll enabled?
                 */
                $scope.infinite = $attr.infinite || false;
                /**
                 * Flag to show more info of the items (abstract, date)
                 */
                $scope.extended = $attr.extended || false;

                /**
                 * Utilities
                 */
                $scope.convertToDate = Utils.convertToDate;
                $scope.setDir = Utils.setTextDirection;

                /**
                 * Get items to show from the News service
                 */
                $scope.truncateAtChar = Utils.truncateAtChar;

                $scope.loadItems = function() {
                    News.getList({
                        size: $scope.size,
                        offset: $scope.offset,
                        id: $scope.id
                    }).$promise.then(function(items) {
                        Logger.log('MODULE :: News :: newsList :: loadItems', items, {
                            SIZE: $scope.size,
                            OFFSET: $scope.offset
                        });
                        if (items && items.length) {
                            $scope.pushItems(items);
                            $scope.$emit('results');
                        } else {
                            $scope.$emit('noresults');
                        }
                    });
                };

                /**
                 * Callback for the lazyload, set the correct offset value and call loadItems()
                 */
                $scope.loadMore = function() {
                    if ($scope.infinite && !$scope.disableScroll) {
                        $scope.disableScroll = true;
                        $scope.offset = parseInt($scope.offset, 10) + parseInt($scope.size, 10);
                        if ($scope.offset < 30){
                            Logger.log('MODULE :: News :: newsList :: loadMore', $scope.offset);
                            $scope.loadItems();
                        } else {
                            $scope.disableScroll = true;
                        }
                    }
                };

                /**
                 * Add new items to the visible items array
                 */
                $scope.pushItems = function(items) {
                    $scope.items = $scope.items.concat(items);

                    $rootScope.$emit('lazyImg:refresh');

                    if (parseInt(items.length, 10) >= parseInt($scope.size, 10)) {
                        $timeout(function() {
                            $scope.disableScroll = false;
                        }, 2000);
                    }
                };

                $scope.loadItems();
            }
        };
    }
]);

angular.module('html5Game').directive('sliderNews', ['Config', 'Utils', 'News', '$rootScope', 'Logger',
    function(Config, Utils, News, $rootScope, Logger) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/content/news/newsSlider.html',
            scope: {
                callbackitems: '&',
                size: '@',
                imgratio: '='
            },
            link: function($scope, $element, $attr) {
                $scope.goTo = Utils.goTo;
                $scope.goToZoom = Utils.goToZoom;
                $scope.imgRatio = $attr.imgratio || 'ratio_1';
                $scope.imgTrueRatio = $scope.imgRatio === 'ratio_1' || $scope.imgRatio === 'ratio_1_4' ? $scope.imgRatio : 'ratio_1_4';
                $scope.imgWSize = Utils.getSize4Density(320, 440);
                $scope.imgHSize = 0;
                $scope.size = $scope.size || 10;
                $scope.offset = $attr.offset || 0;
                $scope.setDir = Utils.setTextDirection;
                $scope.truncateAtChar = Utils.truncateAtChar;

                var newsSlider = new Glide('.newsContainer', {
                    type: 'slider',
                    startAt: 0,
                    focusAt: 0,
                    rewind: false,
                    gap: 16,
                    peek: { before: 8, after: 50 },
                    autoplay: false,
                    bound: true,
                    breakpoints: {
                        4000: { perView: 3 },
                        1024: { perView: 3 },
                        768: { perView: 2 },
                        600: { perView: 2 },
                        480: { perView: 1 },
                        320: { perView: 1 }
                    },
                    direction: $rootScope.RTLlang ? 'rtl' : 'ltr'
                });

                var mountSlider = function(els){
                    $scope.items = els;
                    if ($scope.items.length){
                        if (Config.value('SHOW_MORE_IN_SLIDER') && $attr.showmoreactive){
                            var showMore = {
                                showMore: true
                            };
                            $scope.items.push(showMore);
                        }
                        setTimeout(function(){
                            newsSlider.mount(); //fare unificata
                            Utils.triggerResize();
                        }, 250);
                    }
                };
                News.getList({
                    size: $scope.size,
                    offset: $scope.offset
                }).$promise.then(function(items) {
                    Logger.log('MODULE :: News :: newsList :: loadItems', items, {
                        SIZE: $scope.size,
                        OFFSET: $scope.offset
                    });
                    if (items){
                        mountSlider(items);
                    }
                });
            }
            
        };
    }
]);

/*
 * angular-lazy-load
 *
 * Copyright(c) 2014 Paweł Wszoła <wszola.p@gmail.com>
 * MIT Licensed
 *
 */

/**
 * @author Paweł Wszoła (wszola.p@gmail.com)
 *
 */

angular.module('angularLazyImg', []);

angular.module('angularLazyImg').factory('LazyImgMagic', [
    '$window', '$rootScope', 'lazyImgConfig', 'lazyImgHelpers',
    function($window, $rootScope, lazyImgConfig, lazyImgHelpers) {


        var winDimensions,
            $win,
            images,
            isListening,
            options;
        var checkImagesT,
            saveWinOffsetT,
            containers;

        images = [];
        isListening = false;
        options = lazyImgConfig.getOptions();
        $win = angular.element($window);
        winDimensions = lazyImgHelpers.getWinDimensions();
        saveWinOffsetT = lazyImgHelpers.throttle(function() {
            winDimensions = lazyImgHelpers.getWinDimensions();
        }, 60);
        containers = [options.container || $win];

        function checkImages() {
            for(var i = images.length - 1; i >= 0; i--) {
                var image = images[i];
                if(image && lazyImgHelpers.isElementInView(image.$elem[0], options.offset, winDimensions)) {
                    loadImage(image);
                    images.splice(i, 1);
                }
            }
            if(images.length === 0) {
                stopListening();
            }
        }

        $rootScope.$on('slided', function() {
            checkImages();
        });

        checkImagesT = lazyImgHelpers.throttle(checkImages, 30);

        function listen(param) {
            containers.forEach(function(container) {
                container[param]('scroll', checkImagesT);
                container[param]('touchmove', checkImagesT);
            });
            $win[param]('resize', checkImagesT);
            $win[param]('resize', saveWinOffsetT);
        }

        function startListening() {
            isListening = true;
            setTimeout(function() {
                checkImages();
                listen('on');
            }, 1);
        }

        function stopListening() {
            isListening = false;
            listen('off');
        }

        function removeImage(image) {
            var index = images.indexOf(image);
            if(index !== -1) {
                images.splice(index, 1);
            }
        }

        function loadImage(photo) {
            var img = new Image();
            img.onerror = function() {
                if(options.errorClass) {
                    photo.$elem.addClass(options.errorClass);
                }
                $rootScope.$emit('lazyImg:error', photo);
                options.onError(photo);
            };
            img.onload = function() {
                setPhotoSrc(photo.$elem, photo.src);
                if(options.successClass) {
                    photo.$elem.addClass(options.successClass);
                }
                $rootScope.$emit('lazyImg:success', photo);
                options.onSuccess(photo);
            };
            img.src = photo.src;
        }

        function setPhotoSrc($elem, src) {
            if($elem[0].nodeName.toLowerCase() === 'img') {
                $elem[0].src = src;
            } else {
                $elem.css('background-image', 'url("' + src + '")');
            }
        }

        // PHOTO
        function Photo($elem) {
            this.$elem = $elem;
        }

        Photo.prototype.setSource = function(source) {
            this.src = source;
            images.unshift(this);
            if(!isListening) {
                startListening();
            }
        };

        Photo.prototype.removeImage = function() {
            removeImage(this);
            if(images.length === 0) {
                stopListening();
            }
        };

        Photo.prototype.checkImages = function() {
            checkImages();
        };

        Photo.addContainer = function(container) {
            stopListening();
            containers.push(container);
            startListening();
        };

        Photo.removeContainer = function(container) {
            stopListening();
            containers.splice(containers.indexOf(container), 1);
            startListening();
        };

        return Photo;

    }
]);

angular.module('angularLazyImg').provider('lazyImgConfig', function() {


    this.options = {
        offset: 100,
        errorClass: null,
        successClass: null,
        onError: function() {},
        onSuccess: function() {}
    };

    this.$get = function() {
        var options = this.options;
        return {
            getOptions: function() {
                return options;
            }
        };
    };

    this.setOptions = function(options) {
        angular.extend(this.options, options);
    };
});
angular.module('angularLazyImg').factory('lazyImgHelpers', [
    '$window',
    function($window) {


        function getWinDimensions() {
            return {
                height: $window.innerHeight,
                width: $window.innerWidth
            };
        }

        function isElementInView(elem, offset, winDimensions) {
            var rect = elem.getBoundingClientRect();
            var bottomline = winDimensions.height + offset;
            return(
                rect.left >= 0 && rect.right <= winDimensions.width + offset && ((rect.top >= 0 && rect.top <= bottomline) || (rect.bottom <= bottomline && rect.bottom >= 0 - offset))
            );
        }

        // http://remysharp.com/2010/07/21/throttling-function-calls/
        function throttle(fn, threshhold, scope) {
            var last,
                deferTimer;
            return function() {
                var context = scope || this;
                var now = +new Date(),
                    args = arguments;
                if(last && now < last + threshhold) {
                    clearTimeout(deferTimer);
                    deferTimer = setTimeout(function() {
                        last = now;
                        fn.apply(context, args);
                    }, threshhold);
                } else {
                    last = now;
                    fn.apply(context, args);
                }
            };
        }

        return {
            isElementInView: isElementInView,
            getWinDimensions: getWinDimensions,
            throttle: throttle
        };

    }
]);
angular.module('angularLazyImg')
    .directive('lazyImg', [
        '$rootScope', 'LazyImgMagic',
        function($rootScope, LazyImgMagic) {


            function link(scope, element, attributes) {
                var lazyImage = new LazyImgMagic(element);
                attributes.$observe('lazyImg', function(newSource) {
                    if(newSource) {
                        // in angular 1.3 it might be nice to remove observer here
                        lazyImage.setSource(newSource);
                    }
                });
                scope.$on('$destroy', function() {
                    lazyImage.removeImage();
                });
                $rootScope.$on('lazyImg.runCheck', function() {
                    lazyImage.checkImages();
                });
                $rootScope.$on('lazyImg:refresh', function() {
                    lazyImage.checkImages();
                });
            }

            return {
                link: link,
                restrict: 'A'
            };
        }
    ])
    .directive('lazyImgContainer', [
        'LazyImgMagic',
        function(LazyImgMagic) {


            function link(scope, element) {
                LazyImgMagic.addContainer(element);
                scope.$on('$destroy', function() {
                    LazyImgMagic.removeContainer(element);
                });
            }

            return {
                link: link,
                restrict: 'A'
            };
        }
    ]);

angular.module('html5Game').directive('leaderboard', [
    '$rootScope', '$state', '$window', '$swipe', 'Logger', 'Config', 'Utils', 'User', 'Ranking', 'Dictionary',
    function($rootScope, $state, $window, $swipe, Logger, Config, Utils, User, Ranking, Dictionary) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/leaderboard/leaderboard.dir.html',
            scope: {
                items: '='
            },
            link: function($scope, $element, $attrs) {
                $scope.ldbTitle = Utils.colorAccentedTitles(Dictionary.value('WEBAPP_ZOOM_LDB_TITLE'), ['accentedText']);

                $scope.itemPlay = function(item, goToZoom, position, type, checkCompatibility) {
                    Utils.itemPlay(item, goToZoom, position, type, checkCompatibility, Ranking);
                };
            }
        };
    }
]);

angular.module('html5Game').directive('leaderboardZoom', ['Leaderboard', 'Config', 'Utils', 'EventBus', 'Dictionary',
    function(Leaderboard, Config, Utils, EventBus, Dictionary) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/leaderboard/competitionLeaderboardZoom.dir.html',
            scope: {
                limit: '@',
                game: '=',
                dates: '=',
                items: '='
            },
            link: function($scope, $element, $attrs) {
                $scope.$watch('game', function (newValue, oldValue) {
                    if (newValue || oldValue){
                        var start = (new Date($scope.dates.start).getTime() / 1000),
                            end = (new Date($scope.dates.finish).getTime() / 1000);
                        if (!$scope.items) {
                            Leaderboard.getCompetitionLeaderboard({
                                limit: $scope.limit || 5,
                                content_id: $scope.game.id + '',
                                user_id: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
                                start_timestamp: start,
                                end_timestamp: end   
                            }).$promise.then(function(data) {
                                if(data && data.length) {
                                    $scope.items = data;
                                } else {
                                    $scope.showInvite = true;
                                }
                            });
                        }

                        $scope.ldbTitle = Dictionary.value('WEBAPP_ZOOM_LDB_TITLE');
                        $scope.setDir = Utils.setTextDirection;
                    }
                });
            }
        };
    }
]);

angular.module('html5Game').directive('contestTime', ['Config', 'ContestService', 'Dictionary', 'Utils',
    function(Config, ContestService, Dictionary, Utils) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/leaderboard/contestTime.html',
            replace: true,
            scope: {
                page: '@',
                basic: '=',
                dates: '='
            },
            link: function($scope, $element, $attr) {
                $scope.setDir = Utils.setTextDirection;
                $scope.$watch('dates', function (newValue, oldValue) {
                    if (newValue || oldValue){
                        var time = ContestService.timeLeft($scope.dates);
                        $scope.timeLeft = time.timeLeft;
                        $scope.isContestOver = time.isContestOver;
                        $scope.notStarted = time.notStarted;
                        $scope.finishHour = time.finishHour;
                    } else {
                        $scope.isContestOver = true;
                    }
                });
            }
        };

    }
]);

angular.module('html5Game').directive('contestPlayers', ['$rootScope', '$state', 'EventBus', 'Config', 'User', 'Utils', '$timeout', 'Dictionary', 'Leaderboard',
    function($rootScope, $state, EventBus, Config, User, Utils, $timeout, Dictionary, Leaderboard) {
        //single item, used for contest/competition
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/leaderboard/contestPlayers.html',
            replace: true,
            scope: {
                game: '=',
                endtime: '=',
                starttime: '='
            },
            link: function($scope, $element, $attr) {
                $scope.contestPlayers = 0;

                $scope.$watch('game', function (newValue, oldValue) {
                    if (newValue || oldValue){
                        $scope.contestPlayers = 0;
                        $scope.setDir = Utils.setTextDirection;
                        var start = (new Date($scope.starttime).getTime() / 1000),
                            end = (new Date($scope.endtime).getTime() / 1000);
                        Leaderboard.getCompetitionPlayers({
                            content_id: $scope.game.id + '',
                            end_timestamp: end,
                            start_timestamp: start
                        }).$promise.then(function(data) {
                            if(data && data.count && parseInt(data.count, 10) > 0) {
                                $scope.contestPlayers = data.count;
                            }
                        });
                    }
                });
            }
        };

    }
]);

angular.module('html5Game').directive('contestNoResults', ['Config', 'Utils', 'User', 'Ranking',
    function(Config, Utils, User, Ranking) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/leaderboard/contestNoResults.html',
            replace: true,
            scope: {
                game: '='
            },
            link: function($scope, $element, $attr) {
                $scope.gamePlay = function(e) {
                    Utils.gamePlay({ gameObj: $scope.game, User: User, Ranking: Ranking }, e);
                };
                $scope.setBtnLabel = Utils.setBtnLabel;
                $scope.setDir = Utils.setTextDirection;
              
            }
        };

    }
]);

angular.module('html5Game').directive('contestEnded', ['Config', 'Utils', 'User', 'Ranking',
    function(Config, Utils, User, Ranking) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/leaderboard/contestEnded.html',
            replace: true,
            link: function($scope, $element, $attr) {

              
            }
        };

    }
]);

angular.module('html5Game').directive('contestHomeSection', ['Config', '$state', 'Analytics', 'Utils', 'BadgeService', 'ContestService', 
    function(Config, $state, Analytics, Utils, BadgeService, ContestService) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/leaderboard/contestHomeSection.html',
            replace: true,
            scope: false,
            link: function($scope, $element, $attr) {  
                if (Config.value('ENABLE_CONTEST')) {
                    var tplPath = Config.value('JS_TEMPLATE_PREFIX') + '/modules/leaderboard/';

                    $scope.imgHSize = 0;
                    $scope.imgWSize = Utils.getSize4Density(200, 300);

                    var setupContest = function(data){ 
                        $scope.contests = data || [];
                        if ($scope.contests.length){
                            if ($scope.contests.length === 1){
                                $scope.singleGame = $scope.contests[0].content_info;
                            }
                            $scope.contests.forEach(function(contest){
                                if (contest && contest.CONTEST_TIMEFRAME_UTC){
                                    var time = ContestService.timeLeft(contest.CONTEST_TIMEFRAME_UTC);
                                    contest.timeLeft = time.timeLeft;
                                    contest.isContestOver = time.isContestOver;
                                    contest.notStarted = time.notStarted;
                                    contest.gameImg = contest.content_info.images.icon || contest.content_info.images.cover.ratio_1;
                                    contest.ready = true;
                                } else {
                                    contest.isContestOver = true;
                                }
                               // console.log('setupcontest', contest);
                            });
                        }
                        ContestService.winOrLose(false, setupWinner);
                    };
                    var setupWinner = function(contestWithBadge){ //badgedata
                        //console.log('setupwinner', contestWithBadge);
                        if (contestWithBadge){
                            var noDupContest = $scope.contests.findIndex(function(contestExisting){
                                return contestExisting.COMPETITION_ID === contestWithBadge.badgeData.relatedIDs[0];
                            });
                            //se c'è già un oggetto contest con quell'id, significa che è attivo e non ci può essere un badge (ad ora c'è solo il badge vincitore)
                            var contestObj = (noDupContest > -1) ? false : contestWithBadge;

                            if (contestObj){
                                contestObj.badgeClaimed = false;
                                contestObj.ready = true;
                                contestObj.iswinner = true;
                                contestObj.isContestOver = true;
                                contestObj.claimBadge = function(){
                                    BadgeService.claimBadge({ id: contestObj.badgeData.id, access_token: NewtonAdapter.getUserToken() || '' }); 
                                    contestObj.badgeClaimed = true;
                                    var prop = {
                                        category: 'Behavior',
                                        action: 'Gamification_ContestWinner',
                                        label: contestObj.content_info && contestObj.content_info.id ? contestObj.content_info.id : '',
                                        valuable_cd: 'No',
                                        action_cd: 'Yes'
                                    };
                                    Analytics.eventTrack(prop);
                                    NewtonAdapter.trackEvent({
                                        name: prop.action,
                                        properties: prop
                                    });

                                    $state.go('badges');
                                };

                                $scope.contests.push(contestObj);
                            }
                        }
                        $scope.isMulti = $scope.contests && $scope.contests.length > 1 ? true : false;
                        $scope.contest = $scope.contests && $scope.contests.length ? $scope.contests[0] : false;
                        if ($scope.isMulti) {
                            $scope.tpl = tplPath + 'multiContest.html';
                            $scope.imgratio = 'ratio_1';
                        } else if (Config.value('CONTEST_NEW_SINGLE_TPL')) { 
                            $scope.tpl = tplPath + 'singleContest_hutch.html';
                            $scope.imgratio = 'ratio_1';
                        } else if (!$scope.isMulti && !Config.value('CONTEST_NEW_SINGLE_TPL')) {
                            $scope.tpl = tplPath + 'singleContest.html';
                        }
                        //console.table({ 'winorlose': 1, ismulti: $scope.isMulti, contest: $scope.contest, contests: $scope.contests });
                    };
                    ContestService.getActiveMultiContest(setupContest);
                }
            }
        };

    }
]);

angular.module('html5Game').directive('contestHomeChild', ['Config', '$state', 'Analytics', 'EventBus', 'BadgeService', 'ContestService', 
    function(Config, $state, Analytics, EventBus, BadgeService, ContestService) {
        return {
            restrict: 'E',
            template: '<ng-include src="getTemplateUrl()"/>',
            replace: true,
            scope: false,
            link: function($scope, $element, $attr) {
                $scope.getTemplateUrl = function() {
                    return $scope.tpl;
                };    
            }
                
        };

    }
]);

angular.module('html5Game').directive('contestCard', ['Config', '$state', 'Analytics', 'EventBus', 'BadgeService', 'ContestService', 
    function(Config, $state, Analytics, EventBus, BadgeService, ContestService) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/leaderboard/contestCard.html',
            replace: true,
            scope: false,
            link: function($scope, $element, $attr) {

            }
                
        };

    }
]);

angular.module('html5Game').factory('Leaderboard', ['Config', '$resource', 'Logger', function(Config, $resource, Logger) {

    return $resource('', {}, {

        getLatest: { //general latest scores - every game, every user
            method: 'GET',
            url: Config.value('MOA_API_LEADERBOARD_LAST_SCORE'),
            params: {
                limit: Config.value('LEADERBOARD_LAST_SCORE_ITEMS') || ''
            },
            isArray: false,
            hideLoader: true,
            interceptor: {
                response: function(data) {
                    Logger.log('API :: Leaderboard :: getLatest', data.data, data.data.response.data.last_scores, {
                        method: data.config.method,
                        url: data.config.url
                    });
                    return data.data.response.data.last_scores;
                }
            }
        },
        getUsrTopPositions: {
            method: 'GET',
            url: Config.value('MOA_API_LEADERBOARD_TOP_POSITIONS'),
            params: {
                limit: '@limit',
                content_id: '@content_id'
            }, //limit, usr_id, content_id
            isArray: false,
            hideLoader: true,
            interceptor: {
                response: function(data) {
                    Logger.log('API :: Leaderboard :: getUsrTopPositions', data.data.response.data.top_scorer, {
                        method: data.config.method,
                        url: data.config.url
                    });
                    return data.data.response.data.top_scorer;
                }
            }
        },
        getCompetitionLeaderboard: {
            method: 'GET',
            url: Config.value('MOA_API_LEADERBOARD_TOP_POSITIONS'),
            params: {
                limit: '@limit',
                content_id: '@content_id',
                user_id: '@user_id',
                contest: 1
            }, //limit, usr_id, content_id
            interceptor: {
                response: function(data) {
                    Logger.log('API :: Leaderboard :: getCompetitionLeaderboard', data.data.response.data.top_scorer, {
                        method: data.config.method,
                        url: data.config.url
                    });
                    return data.data.response.data.top_scorer;
                }
            }
        },
        getCompetitionPlayers: {
            url: Config.value('MOA_API_LEADERBOARD_PLAYER_COUNTER'),
            params: {
                content_id: '@content_id'
            },
            isArray: false,
            hideLoader: true,
            interceptor: {
                response: function(data) {
                    Logger.log('API :: Leaderboard :: getCompetitionPlayers', data.data.response, {
                        method: data.config.method,
                        url: data.config.url
                    });
                    return data.data.response.data;
                }
            }
        }
    });
}]);

angular.module('html5Game').directive('competitionleaderboard', [
    '$rootScope', 'EventBus', 'Config', 'Utils', 'Leaderboard', 'Ranking',
    function($rootScope, EventBus, Config, Utils, Leaderboard, Ranking) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/leaderboard/competitionLeaderboard.dir.html',
            scope: {
                titlekey: '=',
                limit: '@',
                game: '=',
                dates: '=',
                items: '='
            },
            link: function($scope, $element, $attrs) {
                $scope.$watch('game', function (newValue, oldValue) {
                    if (newValue || oldValue){
                        $scope.ready = true;
                        var config = Config.value('LEADERBOARD_SLIDER_CONF');
                        config.direction = 'ltr';
      
                        $scope.title = Config.value($scope.titlekey);
                        var LdbSlider = new Glide('.ldb.competition', config);
                        $scope.imgHSize = 0;
                        $scope.imgWSize = Utils.getSize4Density(200, 300);
                        $scope.gameImg = $rootScope.deviceType === 'phone' ? $scope.game.images.cover.ratio_1 : $scope.game.images.cover.ratio_2;
                        var start = (new Date($scope.dates.start).getTime() / 1000),
                            end = (new Date($scope.dates.finish).getTime() / 1000);

                        if (!$scope.items){
                            Leaderboard.getCompetitionLeaderboard({
                                limit: $scope.limit || 5,
                                content_id: $scope.game.id + '',
                                user_id: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
                                start_timestamp: start,
                                end_timestamp: end   
                            }).$promise.then(function(data) {
                                if(data.length && data[0]) {
                                    $scope.items = data;
                                    setTimeout(function(){
                                        LdbSlider.mount(); 
                                        Utils.triggerResize();
                                    }, 250);
                                } else {
                                    $scope.noLdb = true;
                                }
                            });
                        }


                        LdbSlider.on('mount.after', function() {
                            var elements = $element[0].querySelectorAll('.glide__slide--clone');
                            angular.forEach(elements, function(el) {
                                el.addEventListener('click', function() {
                                    var index = el.dataset.itemindex;
                                    var item = $scope.items[index];
                                    if (item) {
                                        $scope.itemPlay(item, true, false, 'slidersmall');
                                    }
                                });
                            });
                        });

                        $scope.setDir = Utils.setTextDirection;
                        $scope.itemPlay = function(item, goToZoom, position, type, checkCompatibility) {
                            Utils.itemPlay(item, goToZoom, position, type, checkCompatibility, Ranking);
                        };
                    }
                });
            }
        };
    }
]);


angular.module('html5Game').directive('contestPrizesInfo', [
    '$rootScope', '$state', 'Config', 'Utils', 'Leaderboard', 'Ranking',
    function($rootScope, $state, Config, Utils, Leaderboard, Ranking) {
        return {
            restrict: 'EA',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/leaderboard/contestPrizesInfo.html',
            scope: {
                game: '='
            },
            link: function($scope, $element, $attrs) {    
                $scope.isModalOpen = false;
                $scope.openModal = function(){
                    $scope.isModalOpen = true;
                };
                $scope.closeModal = function(){
                    $scope.isModalOpen = false;
                };

                $scope.setDir = Utils.setTextDirection;
                $scope.itemPlay = function(item, goToZoom, position, type, checkCompatibility) {
                    if (item){
                        Utils.itemPlay(item, goToZoom, position, type, checkCompatibility, Ranking);
                    } else {
                        $state.go('contest', {}, { reload: true });
                    }
                };
            }
        };
    }
]);

angular.module('html5Game').directive('contestWinnerHome', ['Config', '$state', 'Analytics', 'EventBus', 'BadgeService', 'ContestService', 
    function(Config, $state, Analytics, EventBus, BadgeService, ContestService) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/leaderboard/contestWinnerHome.html',
            replace: true,
            scope: {
                contest: '='
            },
            link: function($scope, $element, $attr) {

            }
                
        };

    }
]);

angular.module('html5Game').directive('imgsliderleaderboard', [
    '$rootScope', 'Logger', 'Config', 'Utils', 'Leaderboard', 'Ranking',
    function($rootScope, Logger, Config, Utils, Leaderboard, Ranking) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/imgsliderLeaderboard/imgsliderLeaderboard.dir.html',
            scope: {
                moretext: '=',
                ribbontext: '@',
                categorylink: '='
            },
            link: function($scope, $element, $attrs) {
                var LdbSlider = new Glide('.ldb', {
                    type: 'carousel',
                    startAt: 0,
                    focusAt: 'center',
                    gap: 0,
                    peek: 30,
                    direction: $rootScope.RTLlang ? 'rtl' : 'ltr',
                    autoplay: 3000,
                    breakpoints: {
                        4000: { perView: 6 },
                        1024: { perView: 5 },
                        768: { perView: 4 },
                        600: { perView: 3 },
                        480: { perView: 2 },
                        320: { perView: 2 }
                    }
                });

                Leaderboard.getLatest().$promise.then(function(data) {
                    if(!Config.value('LEADERBOARD_ALLOWED_GAMES')) {
                        $scope.items = data;
                    } else {
                        var homeLDB = [];
                        for(var i = 0; i < data.length; i++) {
                            if(data[i].game_info.game_type === Config.value('LEADERBOARD_ALLOWED_GAMES')) {
                                homeLDB.push(data[i]);
                            }
                        }
                        $scope.items = homeLDB;
                    }
                    if ($scope.items.length){
                        setTimeout(function(){
                            LdbSlider.mount(); 
                            Utils.triggerResize();
                        }, 250);
                    } else {
                        $scope.noLdb = true;
                    }
                });

                LdbSlider.on('mount.after', function() {
                    var elements = $element[0].querySelectorAll('.glide__slide--clone');
                    angular.forEach(elements, function(el) {
                        el.addEventListener('click', function() {
                            var index = el.dataset.itemindex;
                            var item = $scope.items[index];
                            if (item) {
                                $scope.itemPlay(item, true, false, 'slidersmall');
                            }
                        });
                    });
                });

                $scope.showBadge = $rootScope.showBadge;
                $scope.getSingleGameAccess = Utils.getSingleGameAccess;
                $scope.gameGoesTo = Utils.gameGoesTo;

                $scope.itemPlay = function(item, goToZoom, position, type, checkCompatibility) {
                    Utils.itemPlay(item, goToZoom, position, type, checkCompatibility, Ranking);
                };

            }
        };
    }
]);

angular.module('html5Game').directive('favoriteButton', ['$rootScope', 'Config', 'Logger', 'User', 'Favorites30', 'Analytics', '$location', 'Ranking', '$sce',
    function($rootScope, Config, Logger, User, Favorites, Analytics, $location, Ranking, $sce) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/like/favoriteButton.dir.html',
            replace: true,
            scope: {
                itemid: '=',
                unloggedurl: '='
            },
            link: function($scope, $element, $attr) {    
                $scope.favBtnIcon = '';
                var checkFavorites = function() {
                    User.getStatus(function(user) {
                        if (user.logged){
                            $scope.logged = true;
                            Favorites.getList().$promise.then(function(data){
                                $scope.status = false;
                                for (var i = 0; i < data.length; i++) {
                                    if (data[i].id === $scope.itemid){
                                        $scope.status = true;
                                        break;
                                    }
                                }
                            });
                            Logger.log('MODULE :: Favorites30 :: FavoritesButton :: getStatus', $scope.itemid, $scope.status);
                        }
                    });
                };

                var listener = $scope.$watch('itemid', function(itemid) {
                    if(itemid) {
                        checkFavorites();
                        listener();
                    }
                });
                $scope.manageFavorites = function(added) {
                    User.getStatus(function(user) {
                        if (user.logged && $scope.itemid){
                            if (added){
                                Favorites.add({
                                    content_id: $scope.itemid + '',
                                    contentId: $scope.itemid + ''
                                }).$promise.then(function(){
                                    $rootScope.$broadcast('favs-add', { item: $scope.itemid });
                                    $scope.status = true;
                                    Logger.log('MODULE :: Favorites :: favoritesButton :: like', $scope.itemid);
                                });
                                Ranking.set({ section: 'Favorites', name: 'Add', contentId: $scope.itemid + '', scope: 'consumption' });

                                var prop = {
                                    category: 'Favorites',
                                    action: 'Add',
                                    label: $location.absUrl(),
                                    valuable_cd: 'No',
                                    action_cd: 'Yes'
                                };
                                Analytics.eventTrack(prop);
                                NewtonAdapter.trackEvent({
                                    name: prop.action,
                                    properties: prop
                                });
                            } else {
                                Favorites.delete({
                                    content_id: $scope.itemid,
                                    contentId: $scope.itemid
                                }).$promise.then(function(){
                                    $scope.status = false;
                                    $rootScope.$broadcast('favs-remove', { item: $scope.itemid });
                                    Logger.log('MODULE :: Favorites :: favoritesButton :: dislike', $scope.itemid);
                                });
                                
                                Ranking.set({ section: 'Favorites', name: 'Remove', contentId: $scope.itemid + '', scope: 'consumption' });

                                var prop2 = {
                                    category: 'Favorites',
                                    action: 'Remove',
                                    label: $location.absUrl(),
                                    valuable_cd: 'No',
                                    action_cd: 'Yes'
                                };
                                Analytics.eventTrack(prop2);
                                NewtonAdapter.trackEvent({
                                    name: prop2.action,
                                    properties: prop2
                                });
                            }
                        } else if (!user.logged) {
                            //$scope.$parent.showsignin = true; //in gamepagewithlists
                            $scope.$emit('showsignin');
                        }
                    });
                };
                $scope.favBtnIcon = $sce.trustAsResourceUrl(Config.value('favorites-button'));  
                SVGInjector.SVGInjector(document.querySelectorAll('.favbtn.inject-me'));

                $element.ready(function(){
                    SVGInjector.SVGInjector(document.querySelectorAll('.favbtn.inject-me'));
                });
            }
        };

    }
]);

angular.module('html5Game').directive('info', ['$rootScope', 'Logger', 'Config', 'Dictionary', 'User', '$state',
    function($rootScope, Logger, Config, Dictionary, User, $state) {

        return {
            restrict: 'E',
            replace: false,
            scope: {
                infotext: '@', //dictionary key name
                showonce: '=', //boolean
                showclose: '=', //boolean
                cookiename: '@', //cookie name to avoid seeing the info msg again
                showaccess: '=', //boolean (connect btn)
                setclass: '=', //boolean (influences explore triangle class)
                lostconnectionmsg: '=' //boolean (offline message)
            },
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/message/info.dir.html',
            link: function($scope, $element, $attr) {
                $scope.showinfo = !(($scope.showonce && JsStorage.get($scope.cookiename, {
                    type: 'cookie'
                })));
                $scope.userContent = !($attr.setclass);

                if($attr.setclass && $rootScope.headerData) {
                    $rootScope.headerData.showinfo = $scope.showinfo;
                }

                User.getStatus(function(user) {
                    if(!user.logged) {
                        $scope.unlogged = true;
                    }
                });

                $scope.closeInfo = function() {
                    if($scope.showonce) {
                        JsStorage.set($scope.cookiename, 1, {
                            type: 'cookie'
                        });
                    }
                    $scope.showinfo = false;
                    if($attr.setclass) {
                        $rootScope.headerData.showinfo = $scope.showinfo;
                    }
                };
            }
        };
    }
]);

angular.module('html5Game').directive('message', ['$document', '$timeout', 'Logger', 'Utils', '$rootScope', 'Config',
    function($document, $timeout, Logger, Utils, $rootScope, Config) {

        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/message/message.dir.html',
            replace: true,
            transclude: true,
            scope: {
                if: '=',
                insideAction: '&',
                closeAction: '&',
                closeTime: '=',
                closeButton: '='
            },
            link: function($scope, $element, $attr) {
                // initialize variables
                var show = function(val) {
                    $scope.visible = val;
                };
                show(false);
                // initialize variables

                // get attributes
                var ifPresent = angular.isDefined($attr.if);
                var cookieName = angular.isDefined($attr.cookie) ? $attr.cookie : false;
                var cookieDays = angular.isDefined($attr.days) ? parseInt($attr.days, 10) : 0;
                var closeOnClick = angular.isDefined($attr.closeOnClick) ? $attr.closeOnClick : false;


                // display or hide message
                var listener = $scope.$watch('if', function(value) {
                    var ifValue = value;
                    // (IF is not present) or (IF is present and is true)
                    var conditionOne = !ifPresent || (ifPresent && !!ifValue);
                    // (COOKIE is not present) or (COOKIE is present but is not exists)
                    var conditionTwo = !cookieName || (cookieName && !angular.isDefined(JsStorage.get(cookieName, { type: 'cookie' })));
                    // verify conditions and display/hide message
                    if(conditionOne && conditionTwo) {
                        show(true);

                        listener();
                    }

                });


                $scope.closeAlert = function() {
                    // hide message
                    show(false);
                    $rootScope.privacyCondition = false;
                    // set cookie, if present
                    if(cookieName) {
                        if(cookieDays) {
                            JsStorage.set(cookieName, 1, {
                                type: 'cookie',
                                exdays: cookieDays
                            });
                        } else {
                            JsStorage.set(cookieName, 1, {
                                type: 'cookie'
                            });
                        }
                    }
                    // call callback function
                    if($scope.closeAction && typeof $scope.closeAction === 'function') {
                        var expressionHandler = $scope.closeAction();
                        if(expressionHandler && typeof expressionHandler === 'function') {
                            expressionHandler();
                        }
                    }
                    document.removeEventListener('scroll', $scope.closeAlert);
                    if(angular.element(document.querySelector('#cookie-overlay'))) {
                        angular.element(document.querySelector('#cookie-overlay')).remove();
                    }
                };

                if($scope.insideAction && typeof $scope.insideAction === 'function' && closeOnClick === 'inside') {
                    $scope.insideFunction = true;
                } else {
                    $scope.insideFunction = false;
                }

                $scope.clickInside = function() {
                    if($scope.insideAction && typeof $scope.insideAction === 'function') {
                        $scope.insideAction();
                        if(closeOnClick === 'inside') {
                            $scope.closeAlert();
                        }
                    }
                };

                $element.ready(function() {
                    if($scope.visible) {
                        /*
                            Auto-contained close-triggering behaviours (by telco request),
                            with one flag each, so it's more flexible if needed ;)
                        */

                        //close on scroll
                        if(Config.value('CLOSE_COOKIE_ON_SCROLL')) {
                            //remove the eventListener in the Close function as on line 76:
                            //  document.removeEventListener('scroll', $scope.closeAlert);
                            document.addEventListener('scroll', $scope.closeAlert, false);
                        }

                        //close on click outside the box
                        if(Config.value('CLOSE_COOKIE_ON_EXTERNAL_CLICK')) {
                            /*
                                If the directive has a parent with zIndex, put the id in place of #privacy-box.
                                If the directive has zIndex itself, you should be able to use
                                    var cookieZindex = $element.css('zIndex');
                                instead of getComputedStyle.
                            */
                            var cookieZindex = window.getComputedStyle(document.querySelector('#privacy-box'), null).getPropertyValue('z-index');
                            var cookieOverlay = angular.element('<div id="cookie-overlay"></div>');
                            $document.find('body').append(cookieOverlay);
                            cookieOverlay.css({
                                zIndex: cookieZindex - 1,
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0
                            });
                            document.querySelector('#cookie-overlay').addEventListener('click', function(e) {
                                e.stopPropagation();
                                $scope.closeAlert();
                                cookieOverlay.remove();
                            }, false);
                        }

                        //close on internal link click
                        if(Config.value('CLOSE_COOKIE_ON_INTERNAL_LINK')) {
                            var cookieLink = $element.find('a')[0];
                            if(cookieLink) {
                                cookieLink.addEventListener('click', function(e) {
                                    e.preventDefault();
                                    $scope.closeAlert();
                                    location.href = cookieLink.getAttribute('href');
                                }, false);
                            }
                        }
                    }

                });
            }
        };
    }
]);

angular.module('html5Game').service('Meta', ['$rootScope', '$location', 'Config', 'Dictionary', '$filter', 'EventBus',
    function($rootScope, $location, Config, Dictionary, $filter, EventBus) {
        return {
            init: function() {

                $rootScope.meta = {
                    type: Dictionary.value('SEO_WEBAPP_META_OGTAGS_TYPE'),
                    title: Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TITLE'),
                    twitterTitle: Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TITLE') + ' - ' + Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TAG_LINE'),
                    site_name: Dictionary.value('SEO_WEBAPP_META_OGTAGS_NAME'),
                    url: $location.absUrl(),
                    description: Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_DESC'),
                    image: Config.value('og-img'),
                    app_id: Config.value('FB_APPID'),
                    jsonld: {},
                    canonical: ''
                };
            },
            revert: function(){
                $rootScope.meta = {
                    type: Dictionary.value('SEO_WEBAPP_META_OGTAGS_TYPE'),
                    title: Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TITLE'),
                    twitterTitle: Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TITLE') + ' - ' + Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TAG_LINE'),
                    site_name: Dictionary.value('SEO_WEBAPP_META_OGTAGS_NAME'),
                    url: $location.absUrl(),
                    description: Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_DESC'),
                    image: Config.value('og-img'),
                    app_id: Config.value('FB_APPID'),
                    jsonld: {},
                    canonical: ''
                };
            },
            setCanonical: function(url){
                $rootScope.meta.canonical = $filter('optimizeCanonical')(url);
            },
            setTwitterTitle: function(twitterTitle) {
                $rootScope.meta.twitterTitle = twitterTitle;
            },
            setType: function(type) {
                $rootScope.meta.type = type;
            },
            setTitle: function(title, callBack) {
                $rootScope.meta.title = title;
                if(callBack){
                    window.setTimeout(function(){
                        callBack();
                    }, 1000);
                }
            },
            setSiteName: function(siteName) {
                $rootScope.meta.site_name = siteName;
            },
            setDescription: function(description) {
                $rootScope.meta.description = description;
            },
            setImage: function(image) {
                $rootScope.meta.image = image;
            },
            setAppID: function(appId) {
                $rootScope.meta.appId = appId;
            },
            setUrl: function(url) {
                if(typeof url === 'string') {
                    $rootScope.meta.url = url;
                } else {
                    $rootScope.meta.url = $location.absUrl();
                }
            },
            setJsonLd: function(jsonld) {
                $rootScope.meta.jsonld = JSON.stringify(jsonld);
            }
        };
    }
]);

angular.module('html5Game').directive('scrolltotop', ['Config', 'debounce', '$rootScope', function(Config, debounce, $rootScope) {

    return {
        restrict: 'E',
        templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/scrollToTop/scrollToTop.dir.html',
        replace: true,
        link: function($scope, $element, $attr) {
            var pageHeight = window.innerHeight;           

            window.onscroll = debounce(100, function() {
                if(pageYOffset > pageHeight) {
                    $scope.showScrollTop = true;
                    if (Config.value('SCROLLTOP_ABOVE_FOOTER')){
                        var footerPos = document.querySelector('footer .footer');
                        var footerCoords = footerPos ? footerPos.getBoundingClientRect() : false;
                        if (footerCoords && footerCoords.top <= ((window.innerHeight || document.documentElement.clientHeight) - 30)){
                            var btnPos = footerCoords.top - 32;
                            $element.css({ 'bottom': 'auto', 'top': btnPos + 'px' });
                        } else {
                            var bottomPos = '20px';
                            if (document.querySelector('.game-page .fixed')){
                                bottomPos = '90px';
                            }
                            $element.css({ 'top': 'auto', 'bottom': bottomPos });
                        }
                    }
                } else {
                    $scope.showScrollTop = false;
                }
            });

            $scope.onClickCallback = function() {
                window.scroll({
                    top: 0, 
                    left: 0, 
                    behavior: 'smooth'
                });
            };
        }

    };

}]);

angular.module('html5Game').factory('Settings', ['$resource', 'Config', 'Logger', function($resource, Config, Logger) {
    return $resource('', {}, {

        get: {
            method: 'GET',
            url: Config.value('MOA_API_SMART_SECTION'),
            //callback: 'JSON_CALLBACK',
            isArray: false,
            params: {
                access_token: function(){
                    return (NewtonAdapter.isUserLogged() && Config.value('ENABLE_NEWTON_USER')) ? NewtonAdapter.getUserToken() : '';
                }
            },
            transformResponse: function(data) {
                var object = angular.fromJson(data);
                if(object) {
                    object.html = object.content;
                }
                return object;
            },
            interceptor: {
                response: function(data) {
                    Logger.log('API :: Settings :: get', data.data, {
                        method: data.config.method,
                        url: data.config.url
                    });
                    setTimeout(function(){
                        document.querySelector('html').classList.remove('loadingRequest');
                    }, 200);
                    return data.data;
                }
            }
        },
        getList: {
            method: 'GET',
            url: Config.value('MOA_API_SMART_SECTION'),
            //callback: 'JSON_CALLBACK',
            isArray: false,
            params: {
                access_token: function(){
                    return (NewtonAdapter.isUserLogged() && Config.value('ENABLE_NEWTON_USER')) ? NewtonAdapter.getUserToken() : '';
                }
            },
            transformResponse: function(data) {
                var object = angular.fromJson(data);
                return object;
            },
            interceptor: {
                response: function(data) {
                    Logger.log('API :: Settings :: getList', data.data, {
                        method: data.config.method,
                        url: data.config.url
                    });
                    setTimeout(function(){
                        document.querySelector('html').classList.remove('loadingRequest');
                    }, 200);
                    return data.data;
                }
            }
        },
        getNetworkProperty: {
            method: 'GET',
            url: Config.value('DEST_DOMAIN') + Config.value('NETWORK_INFO_API_URL'),
            isArray: false,
            cache: false,
            params: {
                access_token: function(){
                    return (NewtonAdapter.isUserLogged() && Config.value('ENABLE_NEWTON_USER')) ? NewtonAdapter.getUserToken() : '';
                }
            },
            transformResponse: function(data){
                var object = angular.fromJson(data);
                Logger.info('API', 'Settings', 'getNetworkProperty', object);
                return object;
            }
        }

    });
}]);

angular.module('html5Game').directive('userFeedback', ['Config', 'User', '$document',
    function(Config, User, $document){
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/user-feedback/userFeedback.dir.html',
            scope: {},
            link: function($scope, $element, $attr){
                useris.PopupManager.init(Config.value('USERIS_POPUP_CONFIGURATION'), function(resp){
                    //console.log('USERIS', 'Popup initialized', resp);
                });
            }
        };
    }]
);
 
angular.module('html5Game').controller('AccountCtr', ['$scope', 'Config', '$state', '$rootScope', 'Dictionary', function($scope, Config, $state, $rootScope, Dictionary) {
    $scope.uo30 = !!Config.value('ENABLE_NEWTON_USER');
    $scope.profileTmpl = Config.value('JS_TEMPLATE_PREFIX') + '/pages/profilePage.ctr.html';
    if (Config.value('ALTERNATIVE_SETTINGS_TPL')){
        $scope.settingsTmpl = Config.value('JS_TEMPLATE_PREFIX') + Config.value('ALTERNATIVE_SETTINGS_TPL');
    } else {
        $scope.settingsTmpl = Config.value('ENABLE_NEWTON_USER') ? Config.value('JS_TEMPLATE_PREFIX') + '/pages/parts/settings30.ctr.html' : Config.value('JS_TEMPLATE_PREFIX') + '/pages/parts/settings.ctr.html';
    }
    if ($state.current.data && $state.current.data.customHeader){
        $rootScope.headerData = { customHeaderTitle: Dictionary.value('WEBAPP_TITLE_ACCOUNT') };
    }
}]);

angular.module('html5Game').controller('AccountCreationCtrl', ['$scope', '$stateParams', '$location', '$q', 'Config', 'Utils', 'Dictionary', 'Mail', 'User',
    function($scope, $stateParams, $location, $q, Config, Utils, Dictionary, Mail, User) {
        console.log('Placeholder controller for AccountCreationCtrl - add email');

        var returnUrl = Utils.getQueryString().return_url || '#!' + Config.value('ROUTER_HOME');
        var sendSMSonLoad = !!Config.value('FR_FLOW_SEND_SMS_ONPAGELOAD');
        var skip = (Utils.getQueryString().skip && !sendSMSonLoad) ? Utils.getQueryString().skip : 0;

        var identityPromises = [];

        var oldMailIdentityPromise = NewtonAdapter.getIdentity('email');
        var genericIdentityPromise = NewtonAdapter.getIdentity('generic');

        var removeIdentities = function(){
            $q.all(identityPromises).then(function(identities){
                identities.forEach(function(identity) {
                    if(identity){
                        identity.delete(function(err){
                            if(err){
                                console.log('Error ', err, 'Removing: ', identity);
                            } else {
                                console.log(identity, 'Removed Successfully');
                            }
                        });
                    }
                }, this);
            });
        };

        identityPromises.push(oldMailIdentityPromise);
        identityPromises.push(genericIdentityPromise);

        genericIdentityPromise.then(function(generic){
            console.log('Generic Identity: ', generic);
        });

        oldMailIdentityPromise.then(function(email){
            console.log('Email Identity: ', email);
        });

        User.getStatus(function(userStatus){
            if(userStatus.logged){
                var configParams = Config.value('MAILPRODUCT_OTHERPARAMS');
                var userParams = {};

                useris.userRegistration({
                    element: document.getElementById('blackboard'),
                    access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',                            
                    smsTemplate: Dictionary.value('MIPCONNECT_WELCOME_SKIP_SMS_TEXT') || Dictionary.value('MIPCONNECT_WELCOME_REGISTER_SMS_TEXT'),
                    skipRegister: skip
                }, {
                    onSuccess: function(userCredentials){
                        
                        for(var key in configParams){
                            if(configParams[key].indexOf(':') >= 0){
                                var value = configParams[key].replace(':', '');
    
                                if(value === 'USERNAME' || value === 'EMAIL'){
                                    userParams[key] = userCredentials.email;
                                } else {
                                    User.getProperty(value.toLowerCase(), function(resp){ // eslint-disable-line
                                        if(resp){
                                            userParams[key] = resp;
                                        }
                                    });
                                }
                            } else {
                                userParams[key] = configParams[key];
                            }
                        }
    
                        userCredentials.params = userParams;
    
                        console.log('User Params to add Identity: ', userCredentials);
    
                        NewtonAdapter.addIdentity(userCredentials).then(function(resp){
                            console.log(resp);
    
                            if(userCredentials.skipped){
                                console.log('Identity generic added!', resp);

                                useris.PopupManager.showUserFeedback({
                                    type: 'generic',
                                    feedback: {
                                        message: Dictionary.value('WEBAPP_UO30_SUGGESTION_ACCOUNTCREATION_CHECKSMS'),
                                        icon: 'icon-sms'
                                    }
                                });

                                window.location.href = '#!/' + Config.value('ROUTER_HOME');
                            } else {
                                if(!Config.value('MIPCONNECT_SIGNUP_TRIANGULATION')){
                                    removeIdentities();
                                }
        
                                if(!Config.value('MIPCONNECT_SIGNUP_TRIANGULATION') && !Config.value('SEND_MAIL_AFTER_ADDIDENTITY_EMAIL')){
                                    Mail.sendWelcomeMail({
                                        EMAIL: userCredentials.email,
                                        USERNAME: userCredentials.email
                                    }).$promise.then(function(mailResp){

                                        useris.PopupManager.showUserFeedback({
                                            type: 'positive',
                                            feedback: {
                                                message: Dictionary.value('WEBAPP_UO30_FEEDBACK_EMAILADDED')
                                            }
                                        });

                                        console.log(mailResp);
                                    });
                                } else {
                                    useris.PopupManager.showUserFeedback({
                                        type: 'generic',
                                        feedback: {
                                            message: Dictionary.value('WEBAPP_UO30_SUGGESTION_EMAILADDED_CHECKMAIL'),
                                            icon: 'icon-email'
                                        }
                                    });
                                }

                                window.location.href = '#!/' + Config.value('ROUTER_HOME');
                            }
                        }).catch(function(err){
                            var dictKey = Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                                Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

                            if (dictKey) {
                                useris.PopupManager.showUserFeedback({
                                    type: 'error',
                                    feedback: {
                                        message: dictKey
                                    }
                                });
                            }
                        });
                    },
                    onCancel: function(){
                        window.location.href = '#!' + Config.value('ROUTER_SETTINGS');
                    },
                    onError: function(error){
                        console.log(error);
                        window.location.reload();
                    },
                    onTemplateLoaded: function(options){
                        var skippedGenericCredentials = { skipped: 1, type: 'generic', smsTemplate: Dictionary.value('MIPCONNECT_WELCOME_SKIP_SMS_TEXT') || Dictionary.value('MIPCONNECT_WELCOME_REGISTER_SMS_TEXT') };
                        if (sendSMSonLoad){
                            NewtonAdapter.addIdentity(skippedGenericCredentials).then(function(resp){
                                console.log('Identity generic added! Now sendind SMS.', resp);
                            }).catch(function(err){
                                var dictKey = Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                                    Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_GENERIC');
    
                                if (dictKey) {
                                    useris.PopupManager.showUserFeedback({
                                        type: 'error',
                                        feedback: {
                                            message: dictKey
                                        }
                                    });
                                }
                            });
                        }
                    }
                });
            } else {
                $location.path(Config.value('ROUTER_HOME'));
            }
        });
    }
]);

angular.module('html5Game').controller('ChangePasswordCtrl', ['$scope', '$q', '$stateParams', '$location', 'Config', 'Dictionary', 'User', 'Mail',
    function($scope, $q, $stateParams, $location, Config, Dictionary, User, Mail) {
        console.log('Placeholder controller for ChangePasswordCtrl');

        $scope.email = false;

        User.getStatus(function(userStatus){
            if(userStatus.logged){
                NewtonAdapter.getIdentity('email').then(function(identity){
                    if(identity){
                        $scope.email = identity.getIdentifier();
                        useris.changePassword({
                            element: document.getElementById('blackboard'),
                            access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : ''
                        }, {
                            onSuccess: function(userCredentials){ 
                                identity.updateSecret(userCredentials.oldPassword, userCredentials.newPassword, function(err){
                                    if(!err){
                                        if(Config.value('SEND_EMAIL_AFTER_CHANGEPSW')){
                                            Mail.sendAfterChangePassword({ 
                                                USERNAME: identity.getIdentifier(),
                                                EMAIL: identity.getIdentifier()
                                            }).$promise.then(function(resp){
                                                console.log('Mail sent');
                                            });
                                        } 

                                        useris.PopupManager.showUserFeedback({
                                            type: 'positive',
                                            feedback: {
                                                message: Dictionary.value('WEBAPP_UO30_FEEDBACK_PSWCHANGED')
                                            }
                                        });

                                        window.location.href = '#!' + Config.value('ROUTER_SETTINGS');
                                    } else {
                                        var dictKey = Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                                            Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

                                        if (dictKey) {
                                            useris.PopupManager.showUserFeedback({
                                                type: 'error',
                                                feedback: {
                                                    message: dictKey
                                                }
                                            });
                                        }
                                    }
                                });
                            },
                            onCancel: function () {
                                window.history.back();
                            },
                            onError: function(error){
                                console.log(error);
                                window.location.reload();
                            }
                        });
                    } else {
                        window.location.href = '#!/' + Config.value('ROUTER_ERROR');
                    }
                }).catch(function(err){
                    var dictKey = Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                        Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

                    if (dictKey) {
                        useris.PopupManager.showUserFeedback({
                            type: 'error',
                            feedback: {
                                message: dictKey
                            }
                        });
                    }
                }); 
            } else {
                $location.path(Config.value('ROUTER_HOME'));
            }
        });
    }
]);

angular.module('html5Game').controller('ConfirmMailCtrl', ['$scope', 'Config', 'User', 'Dictionary', '$stateParams',
    function($scope, Config, User, Dictionary, $stateParams) {
        console.log('Placeholder controller for ConfirmMailCtrl');

        var newtonConfirmCallback = function(){
            NewtonAdapter.getIdentity('generic').then(function(genericIdentity){

                useris.PopupManager.showUserFeedback({
                    type: 'positive',
                    feedback: {
                        message: Dictionary.value('WEBAPP_UO30_FEEDBACK_EMAILADDED_CONFIRMED')
                    }
                });
                
                        
                if(genericIdentity){
                    genericIdentity.delete(function(err){
                        if(err){
                            console.log(err);
                            window.location.href = '#!' + Config.value('ROUTER_ERROR');
                        } else {
                            console.log('Generic identity Removed!');
                        }
                    });
                }

                Mail.sendWelcomeMail({
                    EMAIL: $stateParams.email,
                    USERNAME: $stateParams.email
                }).$promise.then(function(mailResp){
                    console.log(mailResp);
                    
                    window.location.href = '#!' + Config.value('ROUTER_HOME');
                });

            }).catch(function(err){
                console.log(err);
            });
        };
        
        User.getStatus(function(userStatus){
            if(userStatus.logged){
                NewtonAdapter.confirmEmail({
                    token: $stateParams.token
                }).then(function(resp){
                    newtonConfirmCallback();
                }).catch(function(err){
                    var dictKey = Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                        Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

                    if (dictKey) {
                        useris.PopupManager.showUserFeedback({
                            type: 'error',
                            feedback: {
                                message: dictKey
                            }
                        });
                    }
                    
                    window.location.href = '#!' + Config.value('ROUTER_ERROR') + '?code=' + err.code;
                });
            } else {
                NewtonAdapter.confirmEmailAndLogin({
                    token: $stateParams.token
                }).then(function(resp){
                    newtonConfirmCallback();
                }).catch(function(err){
                    console.log('confirmEmail failed', err);

                    useris.PopupManager.showUserFeedback({
                        type: 'error',
                        feedback: {
                            message: 'ERROR'
                        }
                    });
                    
                    window.location.href = '#!' + Config.value('ROUTER_ERROR') + '?code=' + err.code;
                });
            }
        });
    }
]);

angular.module('html5Game').controller('ErrorPageCtr', ['$scope', '$location', '$stateParams', 'Logger',
    function($scope, $location, $stateParams, Logger) {

        $scope.errorCode = $location.search().error;

        if($location.search().error) {
            $scope.errorCode = $location.search().error;
        } else if($stateParams.code) {
            $scope.errorCode = $stateParams.code.replace('/', '');
        } else {
            $scope.errorCode = 'GENERAL';
        }

        Logger.log('PAGE ErrorPage', 'errorCode', $scope.errorCode);

    }
]);

angular.module('html5Game').controller('Explore', ['$scope', '$rootScope', 'LabelAPI', 'Category', 'User', '$timeout', 'Config', 'Dictionary', 'Meta', 'Utils', 'GoogleManager', '$state',
    function($scope, $rootScope, Label, Category, User, $timeout, Config, Dictionary, Meta, Utils, GoogleManager, $state) {

        Meta.setTitle(Dictionary.value('SEO_WEBAPP_META_TITLE_EXPLORE'));
        Meta.setDescription(Dictionary.value('SEO_WEBAPP_META_DESCRIPTION_EXPLORE'));
        $scope.getItemsNumber = Utils.getItemsNumber;
        $scope.showBadge = $rootScope.showBadge;
        $scope.inputFocus = false;
        $scope.setDir = Utils.setTextDirection;
        $scope.goLabel = Utils.goToLab;
        $scope.goCategory = Utils.goToCat;
        $scope.goTo = Utils.goTo;
        $scope.stateName = $state.$current.name;
        $scope.isSearch = $state.is('search');

        $scope.labels = [];
        $scope.waitingLabels = true;
        $scope.offset = Utils.getRandomInt(0, 10);
        var catOffset = 0,
            catsSize = ($rootScope.deviceType === 'phone') ? 3 : 6;    

        var labelsPromise = Label.getList({
            SIZE: 10,
            OFFSET: 0
        }).$promise;

        labelsPromise.then(function(labels){
            for(var j = 0; j < labels.length; j++) {
                //remove label from list if empty
                if (labels[j].items){
                    $scope.labels.push(labels[j]);
                }
            }

            if (document.querySelector('.labelSlider')){
                var labelSlider = new Glide('.labelSlider', { //used only once, in this page only. Not worth it to make it a directive for now
                    type: 'slider',
                    startAt: 1,
                    bound: true,
                    gap: 4,
                    perView: 1,
                    peek: 50,
                    animationDuration: 500,
                    autoplay: 3000,
                    direction: $rootScope.RTLlang ? 'rtl' : 'ltr',
                    breakpoints: {
                        4000: { perView: 4 },
                        1050: { perView: 4 },
                        780: { perView: 3 },
                        600: { perView: 2 },
                        450: { perView: 2, peek: 30 },
                        350: { perView: 1, peek: 80 }
                    }
                });

                if ($scope.labels.length){
                    setTimeout(function(){
                        labelSlider.mount();
                        $scope.waitingLabels = false;
                        Utils.triggerResize();
                    }, 250);
                }
            }
        });

        $scope.categories = Category.getList({
            SIZE: catsSize,
            OFFSET: 0
        });

        $scope.$on('noresults', function(e, d){
            if (d.CATEGORY){
                for(var i = 0; i < $scope.categories.length; i++) {
                    if ($scope.categories[i].id === d.CATEGORY) {
                        $scope.categories[i].isEmpty = true;
                    }
                }
            }
        });

        User.getStatus(function(user) {
            if(user.logged) {
                $scope.favorites = true;
                $scope.$on('favoritesFull', function(){
                    $scope.favoritesList = true;
                });
                $scope.$on('noFavorites', function(){
                    $scope.favoritesList = false;
                });
            }
        });

        $scope.loadMore = function() {
            // disable infinitescroll
            $scope.disableScroll = true;
            // enable loadingSpinner
            $scope.loadingSpinner = true;
            // increase offset
            catOffset = parseInt(catOffset, 10) + parseInt(catsSize, 10);

            var categoriesPromise = Category.getList({
                SIZE: catsSize,
                OFFSET: catOffset
            }).$promise;

            $timeout(function() {
                $scope.loadingSpinner = false;
            }, 5000);

            categoriesPromise.then(function(data) {
                if(data.length) {
                    for(var i = 0; i < data.length; i++) {
                        $scope.categories.push(data[i]);
                    }
                    $scope.disableScroll = false;
                } else {
                    $scope.disableScroll = true;
                }
            });
        };
    }
]);

angular.module('html5Game').controller('ExploreList', ['$scope', '$rootScope', 'LabelAPI', 'Category', 'User', '$timeout', 'Config', 'Dictionary', 'Meta', 'Utils', 'GoogleManager',
    function($scope, $rootScope, Label, Category, User, $timeout, Config, Dictionary, Meta, Utils, GoogleManager) {

        Meta.setTitle(Dictionary.value('SEO_WEBAPP_META_TITLE_EXPLORE'));
        Meta.setDescription(Dictionary.value('SEO_WEBAPP_META_DESCRIPTION_EXPLORE'));
        $scope.inputFocus = false;
        $scope.setDir = Utils.setTextDirection;
        $scope.goLabel = Utils.goToLab;
        $scope.goCategory = Utils.goToCat;
        $scope.goTo = Utils.goTo;

        $scope.labels = [];
        Label.getList({
            SIZE: 10,
            OFFSET: 0
        }).$promise.then(function(labels){
            for(var j = 0; j < labels.length; j++) {
                if (labels[j].items){
                    $scope.labels.push(labels[j]);
                }
            }
        });

        $scope.categories = Category.getList({
            SIZE: 30,
            OFFSET: 0
        });
    }
]);

angular.module('html5Game').controller('ExploreMultiCtr', ['$rootScope', '$scope', 'Config', '$state', '$stateParams', 'Label', 'Category', 'Utils', 'Ranking', '$document',
    function($rootScope, $scope, Config, $state, $stateParams, Label, Category, Utils, Ranking, $document) {
        $scope.searchResultsTmpl = Config.value('JS_TEMPLATE_PREFIX') + '/pages/search/searchResultsUnified.html';
        $scope.isSearch = $state.is('search');
        $scope.isUserStuff = $state.is('history') || $state.is('favorites');
        var palette = '';
        if (!$scope.isSearch){
            var stateName;
            switch($state.$current.name){
            case 'history':
            case 'favorites':
                stateName = $state.$current.name;
                break;
            default:
                stateName = '';  
                break;  
            }
            $scope.selectedlist = $stateParams.labelId || $stateParams.categoryId || stateName;
        }
        $scope.imgRatioList = Utils.getRatioConf('list', 'ratio_2');
        var setPalette = function(navpalette) {
            document.querySelector('body').setAttribute('data-palette', navpalette);
        };
        $scope.infiniteScroll = $scope.isUserStuff ? false : true;
        if (!$scope.isSearch && !$scope.isUserStuff){
            if ($stateParams.labelId) {
                $scope.labelId = $stateParams.labelId;
                //palette = 'color0';
            } else if ($stateParams.categoryId) {
                $scope.categoryId = $stateParams.categoryId;
                //palette = 'color1';
            } else {
                $scope.labelslug = Utils.getDefaultList(Label.getList().data, Config.value('ACTIVITY_NOCONTENT_LABEL_SLUG'));
                $scope.labelId = $scope.labelslug.id;
                $scope.selectedlist = $scope.labelId;
                //palette = '';
                if (!$scope.labelId){
                    var fallbackCategory = Category.getList({
                        SIZE: 1,
                        OFFSET: 0
                    }).$promise;
                    fallbackCategory.then(function(data) {
                        $scope.categoryId = data[0].id;
                        $scope.selectedlist = $scope.categoryId;
                    });
                }
            }
//unify with listgeneral page?
            angular.element($document).ready(function() {
                setPalette(palette);
            });
        }
    }]
);

angular.module('html5Game').controller('Forgot30Ctrl', ['$scope', 'Config', 'Dictionary', '$window', '$state', '$rootScope', 
    function($scope, Config, Dictionary, $window, $state, $rootScope) {
        $scope.showForgotKey = false;   
        var localWrapperFlow;         
        if(JsStorage.isLocalStorageSupported()) {
            localWrapperFlow = !!JsStorage.get('wrapperFlow', { type: 'localstorage' });
            if (localWrapperFlow && !document.querySelector('#wrapperlogin-page')) {
                document.querySelector('html').id = 'wrapperlogin-page';
            }
        }
        var isWrapperFlow = document.querySelector('html').id === 'wrapperlogin-page' || localWrapperFlow;

        if (!isWrapperFlow){
            if ($state.current.data && $state.current.data.customHeader){
                $rootScope.headerData = { customHeaderTitle: Config.value('GLOBAL_ACCOUNT_HEADER_TITLE') ? Dictionary.value('WEBAPP_TITLE_ACCOUNT') : Dictionary.value('WEBAPP_UO30_FORGOT') };
            }
        }
        var goBack = function(credentials, userCred){
            if (!isWrapperFlow){
                if (credentials === 'msisdn'){
                    $window.location.href = '#!' + Config.value('ROUTER_LOGIN') + '?sentpin=1&msisdn=' + encodeURIComponent(userCred.msisdn);
                } else {
                    $state.go('home', {}, {
                        reload: true
                    });
                }
            } else {
                $state.go('wrapperlogin', {
                    token: userCred.msisdn ? userCred.msisdn : ''
                }, {
                    reload: true
                });
            }
        };

        useris.forgot({
            element: document.getElementById('blackboard'),
            access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
            smsTemplate: Dictionary.value('PASSWORD_RECOVERY_SMS') ? Dictionary.value('PASSWORD_RECOVERY_SMS') : ''
        }, {
            onSuccess: function(userCredentials){


                if (userCredentials.msisdn && Config.value('INTERNATIONAL_PREFIX')) {
                    if (userCredentials.msisdn.indexOf(Config.value('INTERNATIONAL_PREFIX')) !== 0 && userCredentials.msisdn.match(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))) {
                        userCredentials.msisdn = Config.value('INTERNATIONAL_PREFIX') + userCredentials.msisdn.match(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))[1];
                        //console.log('MSISDN optimized with ' + Config.value('INTERNATIONAL_PREFIX') + ' ', userCredentials.msisdn);
                    }
                }

                
                NewtonAdapter.recoverPassword(userCredentials).then(function(resp){
            
                    if(userCredentials.msisdn){

                        useris.PopupManager.showUserFeedback({
                            type: 'generic',
                            feedback: {
                                message: Dictionary.value('WEBAPP_UO30_SUGGESTION_FORGOT_CHECKSMS'),
                                icon: 'icon-sms'
                            }
                        });

                        goBack('msisdn', userCredentials);
                    } else if(userCredentials.email) {
                        
                        useris.PopupManager.showUserFeedback({
                            type: 'generic',
                            feedback: {
                                message: Dictionary.value('WEBAPP_UO30_SUGGESTION_FORGOT_CHECKMAIL'),
                                icon: 'icon-email'
                            }
                        });

                        goBack('email', userCredentials);

                        $scope.$apply();
                    } 
                }).catch(function(error){
                    if(userCredentials.msisdn){
                        useris.PopupManager.showUserFeedback({
                            type: 'generic',
                            feedback: {
                                message: Dictionary.value('WEBAPP_UO30_SUGGESTION_FORGOT_CHECKSMS'),
                                icon: 'icon-sms'
                            }
                        });

                        goBack('msisdn', userCredentials);
                    } else if(userCredentials.email) {

                        useris.PopupManager.showUserFeedback({
                            type: 'generic',
                            feedback: {
                                message: Dictionary.value('WEBAPP_UO30_SUGGESTION_FORGOT_CHECKMAIL'),
                                icon: 'icon-email'
                            }
                        });

                        goBack('email', userCredentials);
                    }
                });
            },
            onError: function(error){
                
                $window.location.reload();
            }
        });
    }
]);

angular.module('html5Game').controller('ForgotPageCtr', ['$scope', 'Settings', 'Config', '$http', 'Params', 'Utils',
    function($scope, Settings, Config, $http, Params, Utils) {

        var resetEmailPasswd = Config.value('DEST_DOMAIN') + Config.value('URLMGR_MIP-RESET-LINK');
        // define regex of phone number
        var VALIDATION_TEL = new RegExp(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN')),
            VALIDATION_EMAIL = new RegExp(Config.value('REGEXP_VALIDATE_EMAIL')),
            INVALID = new RegExp(/(?=a)b/),
            userType = 'not defined';


        // initialize userform object
        $scope.userform = {
            phone_number: ''
        };

        // get phone number from query string, if present
        if(typeof (Params.msisdn) !== 'undefined' && Params.msisdn !== 'true') {
            if(Params.msisdn.indexOf(' ') === 0) {
                $scope.userform.phone_number = Params.msisdn.replace(' ', '+');
            } else {
                $scope.userform.phone_number = Params.msisdn;
            }
        }

        $scope.watchType = function(evt) { //on input change - validates the username type and changes passwd validation pattern accordingly
            $scope.VALIDATION_USERNAME = (function() {
                if(VALIDATION_EMAIL.test(document.querySelector('#username').value) === true) {
                    userType = 'email';
                    return VALIDATION_EMAIL;
                } else {
                    userType = 'msisdn';
                    return VALIDATION_TEL;
                }
            }());
        };

        $scope.submitForm = function(form) {
            $scope.errorUserReq = false;
            $scope.errorUserPatt = false;
            if(form.$valid) {
                if(userType === 'email') {
                    var mailData = 'email=' + $scope.userform.phone_number + '&action=reset';
                    $http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
                    $http({
                        method: 'POST',
                        url: resetEmailPasswd,
                        data: mailData,
                        responseType: 'json'
                    }).then(function successCallback(response) {
                        location.href = '/mip/resetcheckemail';
                    }, function errorCallback(response) {
                    });
                } else {
                    if(JsStorage.isLocalStorageSupported()) {
                        JsStorage.set('userform.username', $scope.userform.phone_number, {
                            type: 'localstorage'
                        });
                    }
                    document.getElementById('frmlogin').setAttribute('action', Config.value('URLMGR_LOSTPASSWORD_URL'));
                    document.getElementById('frmlogin').submit();
                }
            } else {
                $scope.errorUserReq = !!(form.phone_number.$error.required);
                $scope.errorUserPatt = !!(form.phone_number.$error.pattern);
            }
        };

        // get page content
        //document.querySelector('html').classList.add('loadingRequest');
        Settings.get(Params, function(e) {
            $scope.content = e.content;
        });

    }
]);

angular.module('html5Game').controller('HeaderCtr', ['$rootScope', '$scope', '$window', '$sce', 'Config', 'User', '$state', '$location', 'Utils',
    function($rootScope, $scope, $window, $sce, Config, User, $state, $location, Utils) {
        $rootScope.headerData = {};
        $scope.overHeader = false;
        $scope.links = [];
        $scope.avatar = false;
        $scope.customHeader = ($state.current.data && $state.current.data.customHeader) ? $state.current.data.customHeader : false;
        $scope.fullHeader = !!Config.value('FULL_HEADER');
        if (Config.value('SVG_HEADER_INJECTED')){
            $scope.headerSvg = $sce.trustAsResourceUrl(Config.value('header-svg')); 
            angular.element(document.querySelector('.headersvg')).ready(function(){
                SVGInjector.SVGInjector(document.getElementsByClassName('headersvg'));
            });
        }
        if (Config.value('SVG_SUBHEADER_INJECTED')){
            $scope.subheaderSvg = $sce.trustAsResourceUrl(Config.value('subheader-svg')); 
            angular.element(document.querySelector('.subheadersvg')).ready(function(){
                SVGInjector.SVGInjector(document.getElementsByClassName('subheadersvg'));
            });
        }
        // get condition for over header
        User.getStatus(function(user) {
            $scope.userLogged = user.logged;
            if(!!Config.value('SHOW_OVER_HEADER_OPERATORS') &&
                Config.value('SHOW_OVER_HEADER_OPERATORS').indexOf(user.operator) > -1) {
                $scope.overHeader = true;
                $scope.links = HEADER_LINKS;
            }
            if(user.logged && user.fb_auth_id) {
                $scope.avatar = 'https://graph.facebook.com/' + user.fb_auth_id + '/picture?type=square&height=100&width=100';
            }
        });

        $scope.setDir = Utils.setTextDirection;
        $rootScope.$on('fbdisconnect', function() {
            $scope.avatar = false;
        });

        $scope.goTo = Utils.goTo;

        $scope.headerBack = Utils.headerBack;

    }]);
angular.module('html5Game').factory('Header', function() {
    return {};
});

angular.module('html5Game').controller('HeaderCloud', ['$rootScope', '$scope', '$window', '$sce', 'Config', 'User', '$state', '$location', 'Utils', '$document',
    function($rootScope, $scope, $window, $sce, Config, User, $state, $location, Utils, $document) {
        $rootScope.headerData = {};
        $scope.overHeader = false;
        $scope.links = [];
        $scope.avatar = false;
        $scope.setDir = Utils.setTextDirection;
        $scope.goTo = Utils.goTo;
        $scope.headerBack = Utils.headerBack;
        $scope.isProfile = $state.is('favorites') || $state.is('history');
        $scope.customHeader = ($state.current.data && $state.current.data.customHeader) ? $state.current.data.customHeader : false;
        // get condition for over header (telco requirements, usually PT, ES)
        User.getStatus(function(user) {
            $scope.userLogged = user.logged;
            if(!!Config.value('SHOW_OVER_HEADER_OPERATORS') &&
                Config.value('SHOW_OVER_HEADER_OPERATORS').indexOf(user.operator) > -1) {
                $scope.overHeader = true;
                $scope.links = HEADER_LINKS;
            }
        });
        var headerConf = Config.value('HEADER_STATES');
        //header secondario con back e nome pagina
        $scope.currentStateHasSecondaryHeader = headerConf.secondary.length ? ($state.current.name && headerConf.secondary.indexOf($state.current.name) !== -1) : false;

        //questo è invertito: nella conf ci sono le pagine dove NON ci va messo.
        $scope.currentStateHasPrimaryHeader = headerConf.primary_notvisible.length ? ($state.current.name && headerConf.primary_notvisible.indexOf($state.current.name) === -1) : true;
        
        //headerino fisso che appare quando si scrolla (come nella zoom Orange)
        $scope.currentStateHasFixedHeader = headerConf.fixed.length ? ($state.current.name && headerConf.fixed.indexOf($state.current.name) !== -1) : false;
        $document.ready(function() {
            if ($scope.currentStateHasFixedHeader){
                var conf = {
                    fixedEl: '.header-secondary-nav',
                    fixedElTop: '.header-secondary-nav-fixed',
                    toggleClass: 'persistent'
                };
                Utils.stickyCallToAction(conf);
            }
        });
    }]);
angular.module('html5Game').controller('HomePageBase', [
    '$rootScope',
    '$scope',
    'User',
    'LabelAPI',
    'Category',
    'EventBus',
    'Dictionary',
    'Meta',
    '$state',
    'Utils',
    'Config',
    '$document',
    'GoogleManager',
    function(
      $rootScope,
      $scope,
      User,
      Label,
      Category,
      EventBus,
      Dictionary,
      Meta,
      $state,
      Utils,
      Config,
      $document,
      GoogleManager
    ) { 
        Meta.setTwitterTitle(
          Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TITLE') + 
          ' - ' +  
          Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TAG_LINE')
        );
        Meta.setTitle(Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TITLE'));
        Meta.setDescription(Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_DESC'));

        $scope.$watch('meta.title', function(newValue, oldValue) { 
            GoogleManager.set({
                'Tipo de pagina': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_HOME'),
                'Tipo de pagina /h': Dictionary.value(
                  'WEBAPP_NAVIGATION_SERVICE_HOME_H'
                ),
                Contenido: Dictionary.value('WEBAPP_NO_APPLICABLE_CONTENT'),
                'Contenido /h': Dictionary.value('WEBAPP_NO_APPLICABLE_CONTENT_H'),
                event: 'changePage'
            });
        });
        $scope.emptylist = {};
        EventBus.on('zeroitems', function(resp){
            console.log('zero', resp);
            if (resp.LABEL) {
                $scope.emptylist[resp.LABEL] = resp.LABEL;
            }
        });

        $scope.getItemsNumber = Utils.getItemsNumber;
        $scope.topGames = Config.value('TOPGAMES_LABELSLUG');
        $scope.miscList = [];
        $scope.showMidBanner = Config.value('INSTALL_HYBRID_VISIBLE') && Config.value('INSTALL_HYBRID_MIDPAGE_VISIBLE') && ($rootScope.selector === 'android' || $rootScope.selector === 'ios');
        $scope.setDir = Utils.setTextDirection;
        $scope.goToList = function(list) { 
            $state.go(
              list,
                {},
                { 
                    reload: true
                }
            );
        };
        $scope.goLabel = Utils.goToLab;
        $scope.goCategory = Utils.goToCat;

        var createMiscList = function(list1, list2) { 
            var miscList = list1
                .map(function(v, k) { 
                    return [v, list2[k]];
                })
                .reduce(function(a, b) { 
                    return a.concat(b);
                }, []);
            return miscList.filter(Boolean);
        };

        // get list of categories/labels
        var categoriesPromise = Category.getList({
            SIZE: 5,
            OFFSET: 0
        }).$promise;

        var labelsPromise = Label.getList({
            SIZE: 5,
            OFFSET: 0
        }).$promise;
        labelsPromise.then(function(labs) { 
            categoriesPromise.then(function(cats) { 
                for(var i = 0; i < labs.length; i++) { 
                    if(!Object.keys(labs[i].items).length) { 
                        labs.splice(i, 1);
                    } else if ($scope.topGames && labs[i].slug === $scope.topGames) { 
                        labs.splice(i, 1);
                    } else {
                        labs[i].islabel = true;
                    }
                }
                for(var j = 0; j < cats.length; j++) { 
                    cats[j].iscategory = true;
                }
                $scope.miscList = createMiscList(labs, cats);
            });
        });

        User.getStatus(function(user) { 
            if(user.logged) { 
                $scope.history = true;
                $scope.$on('historyFull', function() { 
                    $scope.historyList = true;
                });
                $scope.$on('noHistory', function() { 
                    $scope.historyList = false;
                });
            } else { 
                $scope.historyList = false;
            }
        });

        $document.ready(function() { 
            $rootScope.$broadcast('less-loaded');
        });
    }]);

angular.module('html5Game').controller('HomeCategoriesCtr', ['Config', '$rootScope', '$scope', 'Item', 'LabelAPI', 'Category', 'Dictionary', 'Meta', '$document', 'GoogleManager', '$window', 'Utils', 'User', 
    function(Config, $rootScope, $scope, Item, Label, Category, Dictionary, Meta, $document, GoogleManager, $window, Utils, User) {

        Meta.setTwitterTitle(Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TITLE') + ' - ' + Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TAG_LINE'));
        Meta.setTitle(Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TITLE'));
        Meta.setDescription(Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_DESC'));

        $scope.$watch('meta.title', function (newValue, oldValue) {
            GoogleManager.set({
                'Tipo de pagina': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_HOME'),
                'Tipo de pagina /h': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_HOME_H'),
                'Contenido': Dictionary.value('WEBAPP_NO_APPLICABLE_CONTENT'),
                'Contenido /h': Dictionary.value('WEBAPP_NO_APPLICABLE_CONTENT_H'),
                'event': 'changePage'
            });
        });

        $scope.setDir = Utils.setTextDirection;
        $scope.goToCat = Utils.goToCat;
        $scope.goToLab = Utils.goToLab;
        $scope.goTo = Utils.goTo;
        $scope.categories = [];

        var setupCategories = function(data, catsize, catlist){  //items, number of items to return, additional list with games (true, false)
            var dataProcessed = Utils.shuffleArray(data);
            catsize = catlist ? catsize + 1 : catsize;
            dataProcessed = dataProcessed.slice(0, catsize);
            if (catlist){
                $scope.randomCategory = dataProcessed.shift();
            }
            $scope.categories = dataProcessed;
            $scope.catItem = [];
            //--cat-text-color
            $scope.categories.forEach(function(item, index){
                $scope.catItem[index] = '#000';
                item.textColor = '#000';
            });
        };

//label with top partner games only: label slug decided with Malik & Mario. Conf key TOP_PARTNER_GAMES_LABELSLUG
//label without partner games: label slug decided with Malik & Mario. Conf key NOT_PARTNER_GAMES_LABELSLUG

        $scope.topGames = Config.value('TOP_PARTNER_GAMES_LABELSLUG');
        $scope.ourGamesSlug = Config.value('NOT_PARTNER_GAMES_LABELSLUG');

        if (Config.value('ENABLE_FAVORITES') && Config.value('ACTIVITY_HISTORY')){
            User.getStatus(function(user) {
                if(user.logged) {
                    //$scope.myGames = [];
                    Item.favoritesList({
                        size: 10,
                        OFFSET: 0
                    }).$promise.then(function(tmpFavs) {
                        if (tmpFavs.length){
                            for (i = 0; i < tmpFavs.length; i++){
                                tmpFavs[i].userlist = 'favorites';
                            }
                        }
                        Item.historyList({
                            size: 10,
                            OFFSET: 0
                        }).$promise.then(function(tmpPlayed) {
                            if (tmpPlayed.length){
                                for (i = 0; i < tmpPlayed.length; i++){
                                    tmpPlayed[i].userlist = 'history';
                                }
                            }
                            var userListArray = tmpFavs.concat(tmpPlayed);
                            if (userListArray.length){
                                $scope.myGames = Utils.removeAllDupes(userListArray, 'id').slice(0, 6);
                            }
                        });
                    });
                }
            });
        }

        var ourGames = Label.get({
            LABEL_SLUG: $scope.ourGamesSlug
        }).$promise;
        ourGames.then(function(labelData){
            $scope.ourGamesOffset = Utils.getRandomInt(0, Object.keys(labelData.items).length);
            $scope.ourGames = labelData;
            //could've used the normal items dir method, but until we have items shuffling API-side, this would always show the first two items - hence the temporary "trick".
        });

        //categories: $rootScope.listnav (compiled by listnav)
        if ($rootScope.listnav) {
            var categories = [];
            angular.forEach($rootScope.listnav, function(cat) {
                if (!cat.url_label && !cat.state){
                    categories.push(cat);
                }
            });
            setupCategories(categories, 6, true);
        } else {
            var categoriesList = Category.getList({
                SIZE: 20,
                OFFSET: 0
            }).$promise;

            categoriesList.then(function(cats){
                setupCategories(cats, 6, true);
            });
        }

        $document.ready(function() {
            $rootScope.$broadcast('less-loaded');
        });
    }
]);

angular.module('html5Game').controller('HomeSlidersCtr', ['$rootScope', 'Config', '$scope', 'Item', 'LabelAPI', 'Category', 'Dictionary', 'Meta', '$document', 'GoogleManager', '$window', 'Utils',
    function($rootScope, Config, $scope, Item, Label, Category, Dictionary, Meta, $document, GoogleManager, $window, Utils) {
        Meta.setTwitterTitle(Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TITLE') + ' - ' + Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TAG_LINE'));
        Meta.setTitle(Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TITLE'));
        Meta.setDescription(Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_DESC'));

        $scope.$on('noresults', function(e, d){
            if (d.LABEL){
                for(var i = 0; i < $scope.lists.length; i++) {
                    if ($scope.lists[i].id === d.LABEL) {
                        $scope.lists[i].isEmpty = true;
                    }
                }
            }
        });
 
        $scope.$watch('meta.title', function (newValue, oldValue) {
            GoogleManager.set({
                'Tipo de pagina': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_HOME'),
                'Tipo de pagina /h': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_HOME_H'),
                'Contenido': Dictionary.value('WEBAPP_NO_APPLICABLE_CONTENT'),
                'Contenido /h': Dictionary.value('WEBAPP_NO_APPLICABLE_CONTENT_H'),
                'event': 'changePage'
            });
        });

        $scope.goTo = Utils.goTo;
        $scope.goToCat = Utils.goToCat;
        $scope.goToLab = Utils.goToLab;
        $scope.setDir = Utils.setTextDirection;

        $scope.selection = { slug: Config.value('TOPGAMES_LABELSLUG') };
        $scope.mostplayed = { slug: Config.value('MOSTPLAYED_LABELSLUG') };

        if (window.matchMedia('(min-width: 768px)').matches) {
            $scope.respSize = 8;
        } else {
            $scope.respSize = 15;
        }

        var labelsAPI = Label.getList({
            SIZE: 7,
            OFFSET: 0
        }).$promise;

        labelsAPI.then(function(labelsList){
            $scope.lists = [];
            var tempList = [];
            var labels = labelsList;
            if (labels.length){
                for (var i = 0; i < labels.length; i++) {
                    if (labels[i].slug === $scope.selection.slug){
                        $scope.selection = labels[i];
                        labels.splice(i, 1);
                    } else if (labels[i].slug === $scope.mostplayed.slug){
                        labels[i].url = labels[i].url_label;
                        $scope.mostplayed = labels[i];
                        labels.splice(i, 1);
                    }
                    if (labels[i]){
                        labels[i].url = labels[i].url_label;
                        tempList.push(labels[i]);
                    }
                }
                if (!$scope.selection.id){
                    $scope.selection = '';
                }
                if (!$scope.mostplayed.id){
                    $scope.mostplayed = '';
                }
                if ($scope.mostplayed){
                    tempList.unshift($scope.mostplayed);
                }
                $scope.lists = tempList;
                $scope.goToList = $scope.goToLab;
            }/* else {
                var categoriesList = Category.getList({
                    SIZE: 7,
                    OFFSET: 0
                }).$promise;

                categoriesList.then(function(cats){
                    for (var z = 0; z < cats.length; z++) {
                        cats[z].url = cats[z].url_category;
                    }
                    $scope.goToList = $scope.goToCat;
                    $scope.lists = cats;
                });
            }*/ // FALLBACK NOT NEEDED (we need to know when there's empy content)
        });

        $document.ready(function() {
            $rootScope.$broadcast('less-loaded');
        });
    }
]);

'use strict';

angular.module('html5Game').controller('HomePage_singleList', 
    ['$rootScope', '$scope', 'Config', 'Item', 'LabelAPI', 'Ranking', 'Logger', 'Dictionary', 'Meta', 'Cat', '$state', 'Utils', 'Leaderboard', '$location', 'Analytics', '$document', 'GoogleManager', 
        function ($rootScope, $scope, Config, Item, Label, Ranking, Logger, Dictionary, Meta, Cat, $state, Utils, Leaderboard, $location, Analytics, $document, GoogleManager) {

            Meta.setTwitterTitle(Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TITLE') + ' - ' + Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TAG_LINE'));
            Meta.setTitle(Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TITLE'));
            Meta.setDescription(Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_DESC'));
            $scope.$watch('meta.title', function (newValue, oldValue) {
                GoogleManager.set({
                    'Tipo de pagina': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_HOME'),
                    'Tipo de pagina /h': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_HOME_H'),
                    'Contenido': Dictionary.value('WEBAPP_NO_APPLICABLE_CONTENT'),
                    'Contenido /h': Dictionary.value('WEBAPP_NO_APPLICABLE_CONTENT_H'),
                    'event': 'changePage'
                });
            });

            $scope.goTo = Utils.goTo;
            $scope.ldbSliderTitle = Dictionary.value('WEBAPP_HOME_LDB_TITLE');

            $document.ready(function() {
                $rootScope.$broadcast('less-loaded');
            });
        }
    ]);

angular.module('html5Game').controller('HomePagePlugin', ['$rootScope', '$scope', 'User', 'LabelAPI', 'Category', 'Logger', 'Dictionary', 'Meta', '$state', 'Utils', 'Config', '$document', 'GoogleManager',
    function($rootScope, $scope, User, Label, Category, Logger, Dictionary, Meta, $state, Utils, Config, $document, GoogleManager) {

        Meta.setTwitterTitle(Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TITLE') + ' - ' + Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TAG_LINE'));
        Meta.setTitle(Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TITLE'));
        Meta.setDescription(Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_DESC'));
        $scope.$watch('meta.title', function (newValue, oldValue) {
            GoogleManager.set({
                'Tipo de pagina': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_HOME'),
                'Tipo de pagina /h': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_HOME_H'),
                Contenido: Dictionary.value('WEBAPP_NO_APPLICABLE_CONTENT'),
                'Contenido /h': Dictionary.value('WEBAPP_NO_APPLICABLE_CONTENT_H'),
                event: 'changePage'
            });
        });

        $scope.setDir = Utils.setTextDirection;
        $scope.goToCat = Utils.goToCat;
        var catsPromise = Category.getList({
            SIZE: 4,
            OFFSET: 0
        }).$promise;
        catsPromise.then(function(cats){

            //if img don't come from cms
            /*
            angular.forEach(cats, function(cat) {
                switch(cat.id){
                case 'ad161a6d242bd7cf0250577c9895cd8b':
                    cat.img = Config.value('arcadeHome');
                    break;
                case '5f1eab0ed5839d296d9e71721155b617':
                    cat.img = Config.value('classicHome');
                    break;
                case '3a1f6168f9dc6d9dd1240d28f1aca271':
                    cat.img = Config.value('combatHome');
                    break;
                case '091b2522e65cdbb318b52c41f0ca5096':
                    cat.img = Config.value('raceHome');
                    break;
                default:
                    cat.img = '';
                }
            });
            */
            //end

            $scope.cats = cats;
        });

        $document.ready(function() {
            $rootScope.$broadcast('less-loaded');
        });
    }
]);

angular.module('html5Game').controller('ListGeneral', ['$rootScope', '$scope', '$state', '$stateParams', 'LabelAPI', 'Category', 'Dictionary', 'Config', 'GoogleManager', 'Utils', 'User', 'Item', '$timeout', 'Ranking', 'EventBus', 'Meta', '$document', 'imageSizeFilter', 
    function($rootScope, $scope, $state, $stateParams, Label, Category, Dictionary, Config, GoogleManager, Utils, User, Item, $timeout, Ranking, EventBus, Meta, $document, imageSizeFilter) {
        $scope.showResults = false;
        $scope.showNoResults = false;
        $scope.isHome = $state.is('home');
        $scope.labelId = $stateParams.labelId;
        $scope.categoryId = $stateParams.categoryId;
        $scope.itemsize = ($rootScope.deviceType === 'phone' ? 5 : 10);
        $scope.labelslug = Config.value('TOPGAMES_LABELSLUG');
        $scope.infiniteScroll = true;
        $scope.imgRatioList = Utils.getRatioConf('list', 'ratio_2');
        $scope.selectedlist = $stateParams.labelId || $stateParams.categoryId || '';
        $scope.detailedList = !!Config.value('DETAILED_LIST');
        $scope.confSize = window.innerWidth < 768 ? '_SMALL' : '_BIG'; //only for mixedratio DIR
        var setData = function(list, state){
            if (state) {
                list = {
                    name: state,
                    titlePage: Dictionary.value('WEBAPP_MYLIST_TITLE') 
                    //state === 'history' ? Dictionary.value('WEBAPP_LAST_PLAYED') : Dictionary.value('WEBAPP_FAVOURITES')
                };
            } else if (list) {
                list.titlePage = list.name;
            }
            //$rootScope.titlePage = list.titlePage + ' ' + Dictionary.value('SEO_WEBAPP_TITLE_COUNTRY');
            $rootScope.headerData = {
                customHeaderTitle: list.titlePage,
                listType: list.url_label ? 'label' : 'category',
                listId: list.url_label ? $scope.labelId : $scope.categoryId
            };
            Meta.setTitle(list.titlePage + ' ' + Dictionary.value('SEO_WEBAPP_TITLE_COUNTRY'), function(){
                $rootScope.$emit('pageview-' + $rootScope.currentRoute);
            });

            $scope.$watch('meta.title', function (newValue, oldValue) {
                GoogleManager.set({
                    'Tipo de pagina': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_LIST'),
                    'Tipo de pagina /h': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_LIST_H'),
                    'Contenido': list.name,
                    'Contenido /h': list.name,
                    'event': 'changePage'
                });
            });
        };

        if ($scope.labelId){
            $scope.list = Label.get({
                ID: $scope.labelId
            });
            $scope.list.$promise.then(function(data){
                setData($scope.list);
                if (!data.images.url_preview_big){
                    var labelsPromise = Label.getList({
                        SIZE: 10,
                        OFFSET: 0
                    }).$promise;
          
                    labelsPromise.then(function(labels){
                        for(var j = 0; j < labels.length; j++) {
                            if (labels[j].id === $scope.labelId){
                                $rootScope.labelImg = labels[j].images.url_preview_big;
                            }
                        }
                    });
                } else {
                    $rootScope.labelImg = data.images.url_preview_big;
                }
            });
        } else if ($scope.categoryId){
            $scope.list = Category.get({
                ID: $scope.categoryId
            });
            $scope.list.$promise.then(function(){
                setData($scope.list);
                console.log($scope.list);
            });
        } else if ($state.is('history')){
            $scope.infiniteScroll = false;
            $scope.itemsize = 10;
            $scope.historyPage = true;
            User.getStatus(function(user) {
                if(user.logged) {
                    $scope.history = true;
                } else {
                    $scope.showNoResults = true;
                }
                setData(null, 'history');
                $scope.$on('noHistory', function(){
                    $scope.showNoResults = true;
                });
            });
            $scope.myList = 'history';
        } else if ($state.is('favorites')){
            $scope.infiniteScroll = false;
            $scope.itemsize = 10;
            $scope.favoritesPage = true;
            User.getStatus(function(user) {
                if(user.logged) {
                    $scope.favorites = true;
                } else {
                    $scope.showNoResults = true;
                }
                setData(null, 'favorites');
                $scope.$on('noFavorites', function(){
                    $scope.showNoResults = true;
                });
            });
            $scope.myList = 'favorites';

        } else if (Config.value('HOME_MASONRY') && $scope.isHome) {
            $scope.size = ($rootScope.deviceType === 'phone') ? 12 : 24;
            var setColumns = function(){
                if (window.matchMedia('(min-width: 768px)').matches){
                    $scope.gridWidth = 240;
                } else if (window.matchMedia('(min-width: 1025px)').matches) {
                    $scope.gridWidth = 250;
                } else if (window.matchMedia('(max-width: 320px)').matches) {
                    $scope.gridWidth = 146;
                } else {
                    $scope.gridWidth = 150;    
                }
                var pageW = (window.matchMedia('(min-width: 1024px)').matches) ? 1024 : window.innerWidth;
                $scope.cols = parseInt(pageW / $scope.gridWidth, 10);
                $scope.imgWidth = Utils.getSize4Density($scope.gridWidth, parseInt($scope.gridWidth * 1.5, 10));
            };
            setColumns();

            $scope.showBadge = $rootScope.showBadge;
            $scope.getSingleGameAccess = Utils.getSingleGameAccess;
            $scope.disableScroll = true;
            $scope.offset = 0;
            
            var moreItems;
            var macyInstance;
            var loadItems = function(first){
                $rootScope.called = true;
                var loader = document.querySelector('.reqLoader');
                if (!first){
                    loader.classList.add('forceHide');
                }
                Item.getList({
                    SIZE: $scope.size, // was: Config.value('MAX_HOME_ITEMS') - too many for 2g
                    OFFSET: $scope.offset,
                    LABEL_SLUG: $scope.labelslug
                }).$promise.then(function(tmpItems) {
                    if (first && Config.value('MIN_HOME_ITEMS') && tmpItems.length < Config.value('MIN_HOME_ITEMS')){
                        moreItems = Item.getList({
                            SIZE: parseInt(Config.value('MIN_HOME_ITEMS'), 10) - tmpItems.length,
                            OFFSET: $scope.offset + tmpItems.length,
                            LABEL: '',
                            LABEL_SLUG: ''
                        }).$promise;
                    } else {
                        moreItems = Promise.resolve();
                    }
                        
                    moreItems.then(function(more){
                        if (more){
                            tmpItems = tmpItems.concat(more);
                        }
                        for (var i = 0; i < tmpItems.length; i++){
                            var mixImg = Utils.getRatio(tmpItems[i].images.cover);
                            mixImg = Utils.shuffleArray(mixImg);
                            tmpItems[i].mixedImage = { img: imageSizeFilter(mixImg[0].img, 256, 0), ratio: mixImg[0].ratio, calculatedRatio: mixImg[0].calculatedRatio };
                        }
                      
                        if (!$scope.pics) {
                            $scope.pics = [];
                        }
                        $scope.pics = ($rootScope.shuffleHome && first) ? Utils.shuffleArray($scope.pics.concat(tmpItems)) : $scope.pics.concat(Utils.shuffleArray(tmpItems));
    
                        $scope.pics = Utils.removeAllDupes($scope.pics, 'id');

                        if (first){
                            macyInstance = Macy({
                                container: '.msnry-cols',
                                trueOrder: false,
                                waitForImages: false,
                                mobileFirst: true,
                                useOwnImageLoader: false,
                                margin: { x: 4, y: 4 },
                                columns: 2,
                                breakAt: {
                                    1200: 5,
                                    940: 4,
                                    520: 3,
                                    400: 2
                                }
                            });
    
                            macyInstance.runOnImageLoad(function(event) {
                                if (event.data.img) {
                                    macyInstance.recalculate(true);
                                }
                            }, true);
                        
                        } else if (macyInstance){              
                            macyInstance.recalculateOnImageLoad();
                            Utils.triggerResize();
                        }
                        
                        if(tmpItems.length && (parseInt($scope.pics.length, 10) <= parseInt(Config.value('MAX_HOME_ITEMS'), 10))) {
                            $timeout(function() {
                                $scope.disableScroll = false; 
                            }, 1000);
                        }
                        
                    });
                });
            };

            $scope.loadMore = function(){ 
                if(!$scope.disableScroll){
                    $scope.disableScroll = true;
                    $scope.offset = parseInt($scope.offset, 10) + parseInt($scope.size, 10);
                    loadItems(false); 
                }
            };

            $scope.itemPlay = function(item, goToZoom, position, type, checkCompatibility) {
                Utils.itemPlay(item, goToZoom, position, type, checkCompatibility, Ranking);
            };

            if (!$rootScope.called === true){
                loadItems(true);
            }

            angular.element(window).bind('resize', function() {
                setColumns();
                if (macyInstance){
                    macyInstance.recalculate(true);
                }
            });
        } else {
            $scope.showNoResults = true;
        }

        //Dynamic colors and svg bg - ADD DOCUMENTATION ON THIS!
        if (Config.value('DYNAMIC_CSS_CHANGE') && Config.value('DYNAMIC_CSS_PROPS')){
            var listInfo = $scope.categoryId || $scope.labelId; //magari farlo più generico
            var propData = Config.value('DYNAMIC_CSS_PROPS')['cat_' + listInfo];
            if (propData && propData.length){
                propData.forEach(function(prop){
                    Utils.updateCSSprops(prop.name, prop.value);
                });
            }
        }
        //End dynamic colors

        $scope.$on('noresults', function(){
            if(!$scope.showResults) {
                $scope.showNoResults = true;
            }
        });
    }
]);

angular.module('html5Game').controller('ListUser', ['$rootScope', '$scope', '$state', '$stateParams', 'LabelAPI', 'Category', 'Dictionary', 'Config', 'GoogleManager', 'Utils', 'User', 'Item', '$timeout', 'Ranking', 'EventBus', 'Meta', '$document', 
    function($rootScope, $scope, $state, $stateParams, Label, Category, Dictionary, Config, GoogleManager, Utils, User, Item, $timeout, Ranking, EventBus, Meta, $document) {
        $scope.showResults = false;
        $scope.showNoResults = false;
        $scope.isHome = $state.is('home');
        $scope.labelId = $stateParams.labelId;
        $scope.categoryId = $stateParams.categoryId;
        $scope.itemsize = ($rootScope.deviceType === 'phone' ? 5 : 10);
        $scope.labelslug = Config.value('TOPGAMES_LABELSLUG');
        $scope.infiniteScroll = true;
        $scope.imgRatioList = Utils.getRatioConf('list', 'ratio_1');
        $scope.selectedlist = $stateParams.labelId || $stateParams.categoryId || '';
        $scope.detailedList = !!Config.value('DETAILED_LIST');
        $scope.confSize = window.innerWidth < 768 ? '_SMALL' : '_BIG'; //only for mixedratio DIR
        $scope.customHeader = ($state.current.data && $state.current.data.customHeader) ? $state.current.data.customHeader : false;
        var setData = function(list, state){
            if (state) {
                list = {
                    name: state,
                    titlePage: state === 'history' ? Dictionary.value('WEBAPP_LAST_PLAYED') : Dictionary.value('WEBAPP_FAVOURITES'),
                    namedHeader: Dictionary.value('WEBAPP_MYLIST_TITLE')
                };
            } else if (list) {
                list.titlePage = list.name;
                list.namedHeader = list.name;
            }
            //$rootScope.titlePage = list.titlePage + ' ' + Dictionary.value('SEO_WEBAPP_TITLE_COUNTRY');
            $rootScope.headerData = {
                customHeaderTitle: list.namedHeader,
                listType: list.url_label ? 'label' : 'category'
            };
            Meta.setTitle(list.titlePage + ' ' + Dictionary.value('SEO_WEBAPP_TITLE_COUNTRY'), function(){
                $rootScope.$emit('pageview-' + $rootScope.currentRoute);
            });

            $scope.$watch('meta.title', function (newValue, oldValue) {
                GoogleManager.set({
                    'Tipo de pagina': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_LIST'),
                    'Tipo de pagina /h': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_LIST_H'),
                    'Contenido': list.name,
                    'Contenido /h': list.name,
                    'event': 'changePage'
                });
            });
        };

        if ($scope.labelId){
            $scope.list = Label.get({
                ID: $scope.labelId
            });
            $scope.list.$promise.then(function(data){
                setData($scope.list);
                if (!data.images.url_preview_big){
                    var labelsPromise = Label.getList({
                        SIZE: 10,
                        OFFSET: 0
                    }).$promise;
          
                    labelsPromise.then(function(labels){
                        for(var j = 0; j < labels.length; j++) {
                            if (labels[j].id === $scope.labelId){
                                $rootScope.labelImg = labels[j].images.url_preview_big;
                            }
                        }
                    });
                } else {
                    $rootScope.labelImg = data.images.url_preview_big;
                }
            });
        } else if ($scope.categoryId){
            $scope.list = Category.get({
                ID: $scope.categoryId
            });
            $scope.list.$promise.then(function(){
                setData($scope.list);
            });
        } else if ($state.is('history')){
            $scope.infiniteScroll = false;
            $scope.itemsize = 10;
            $scope.historyPage = true;
            User.getStatus(function(user) {
                if(user.logged) {
                    $scope.history = true;
                } else {
                    $scope.showNoResults = true;
                }
                setData(null, 'history');
                $scope.$on('noHistory', function(){
                    $scope.showNoResults = true;
                });
            });
            $scope.myList = 'history';
        } else if ($state.is('favorites')){
            $scope.infiniteScroll = false;
            $scope.itemsize = 10;
            $scope.favoritesPage = true;
            User.getStatus(function(user) {
                if(user.logged) {
                    $scope.favorites = true;
                } else {
                    $scope.showNoResults = true;
                }
                setData(null, 'favorites');
                $scope.$on('noFavorites', function(){
                    $scope.showNoResults = true;
                });
            });
            $scope.myList = 'favorites';

        } else {
            $scope.showNoResults = true;
        }

        //Dynamic colors and svg bg - ADD DOCUMENTATION ON THIS!
        if (Config.value('DYNAMIC_CSS_CHANGE') && Config.value('DYNAMIC_CSS_PROPS')){
            var listInfo = $scope.categoryId || $scope.labelId; //magari farlo più generico
            var propData = Config.value('DYNAMIC_CSS_PROPS')['cat_' + listInfo];
            if (propData.length){
                propData.forEach(function(prop){
                    Utils.updateCSSprops(prop.name, prop.value);
                });
            }
        }
        //End dynamic colors

        $scope.$on('noresults', function(){
            if(!$scope.showResults) {
                $scope.showNoResults = true;
            }
        });
    }
]);

angular.module('html5Game').controller('Contest', ['$scope', 'EventBus', '$rootScope', 'User', 'Config', 'Analytics', '$sce', 'Dictionary', 'Utils', 'Settings', 'Ranking', '$timeout', 'ContestService', 
    function($scope, EventBus, $rootScope, User, Config, Analytics, $sce, Dictionary, Utils, Settings, Ranking, $timeout, ContestService) {

        var setupContest = function(data){ 
            $scope.isMulti = data && data.length > 1 ? true : false;
            $scope.contests = data ? data : [];
            // single contest.: $scope.contests[0];

            if (data && data.length){
                $scope.contests.forEach(function(contest){
                    if (contest && contest.CONTEST_TIMEFRAME_UTC){
                        var time = ContestService.timeLeft(contest.CONTEST_TIMEFRAME_UTC);
                        if (time){
                            contest.timeLeft = time.timeLeft;
                            contest.isContestOver = time.isContestOver;
                            contest.notStarted = time.notStarted;
                        }
                        $timeout(function(){
                            contest.gamePlay = function(e) {
                                Utils.gamePlay({ gameObj: contest.content_info, User: User, Ranking: Ranking }, e);
                            };
                            contest.ready = true;
                        }, 0);
                    } else {
                        contest.isContestOver = true;
                    }
                });
            } else {
                $scope.isContestOver = true;
            }
        };
        ContestService.getActiveMultiContest(setupContest);

        $scope.imgratio = Config.value('CONTEST_NEW_SINGLE_TPL') ? 'ratio_1' : Config.value('CONTEST_PAGE_GAME_RATIO') || 'ratio_2';
        $scope.itemZoom = function(item) {
            Utils.itemPlay(item, true, false, 'custom', false, Ranking);
        };
        $scope.setBtnLabel = Utils.setBtnLabel;
        $scope.setGameFormatBtn = Utils.setGameFormatBtn;
        $scope.setDir = Utils.setTextDirection;

        //change Nick UO30
        var settingsParams = {
            SUBSECTION: 'newtonsmartstatusprofile',
            CONTENT_ID: 'newtonsmartstatusprofile',
            output_format: 'json'
        };
        $scope.logged = !!NewtonAdapter.isUserLogged();


        Settings.get(settingsParams).$promise.then(function(resp){
            $scope.userProfile = $sce.trustAsHtml(resp.content);

            useris.profile({
                element: false,
                access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
                doNotLoad: true
            }, {
                onSaveNickname: function (obj) {
                    if (obj.newNickname && Utils.validateNick(obj.newNickname)){
                        User.setNickname({
                            name: obj.newNickname
                        }, function (changedNickname) {
                            obj.callbackSuccess(obj.newNickname);
                            useris.PopupManager.showUserFeedback({
                                type: 'positive',
                                feedback: {
                                    message: Dictionary.value('WEBAPP_UO30_FEEDBACK_NICKNAME_UPDATED')
                                }
                            });  
                            var prop = {
                                category: 'Behavior',
                                action: 'NicknameAdded',
                                valuable_cd: 'No',
                                action_cd: 'Yes'
                            };
                            Analytics.eventTrack(prop);
                            NewtonAdapter.trackEvent({
                                name: prop.action,
                                properties: prop
                            });
                        },
                        function(respErr){
                          /*
                          403 generico
                          403.1 blacklist
                          403.2 sintassi
                          403.3 nickname già usato
                          */
                            switch (respErr.data.error_code) {
                            case '403.1':
                                useris.PopupManager.showUserFeedback({
                                    type: 'error',
                                    feedback: {
                                        message: Dictionary.value('WEBAPP_UO30_ERROR_NICKNAME_BLACKLISTED')
                                    }
                                });
                                break;
                            case '403.2':
                                useris.PopupManager.showUserFeedback({
                                    type: 'error',
                                    feedback: {
                                        message: Dictionary.value('WEBAPP_UO30_ERROR_NICKNAME_NOT_COMPLIANT')
                                    }
                                });
                                break;
                            case '403.3':
                                useris.PopupManager.showUserFeedback({
                                    type: 'error',
                                    feedback: {
                                        message: Dictionary.value('WEBAPP_UO30_ERROR_NICKNAME_DUPLICATE')
                                    }
                                });
                                break;
                          
                            default:
                                useris.PopupManager.showUserFeedback({
                                    type: 'error',
                                    feedback: {
                                        message: Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_GENERIC')
                                    }
                                });
                                break;
                            }
                        });
                    } else {
                        useris.PopupManager.showUserFeedback({
                            type: 'error',
                            feedback: {
                                message: Dictionary.value('WEBAPP_UO30_ERROR_NICKNAME_LENGTH')
                            }
                        });
                    }
                },
                onError: function (error) {
                    useris.triggerError('useris-username-error');
                }
            });
        });
    }
]);

angular.module('html5Game').controller('Badges', ['$scope', 'Item', '$rootScope', 'User', 'Config', 'Analytics', 'ContestService', 'Utils', 'BadgeService', 'Ranking',
    function($scope, Item, $rootScope, User, Config, Analytics, ContestService, Utils, BadgeService, Ranking) {
        $scope.achievedBadges = [];
        BadgeService.getAllBadges({ only_achieved: 1, access_token: (NewtonAdapter.isUserLogged() && Config.value('ENABLE_NEWTON_USER')) ? NewtonAdapter.getUserToken() : '' }).$promise.then(function(data){
            if (data){
                $scope.achievedBadges = data || [];
                for (var i = 0; i < $scope.achievedBadges.length; i++) {
                    $scope.achievedBadges[i].contestData = {};
                    var badgeData = $scope.achievedBadges && $scope.achievedBadges[i] && $scope.achievedBadges[i].relatedIDs[0] ? $scope.achievedBadges[i].relatedIDs[0] : false;
                    if (badgeData){ //
                        // eslint-disable-next-line no-loop-func
                        ContestService.getContestById(badgeData, function(resp, moredata){
                            moredata.contestData = resp.content_info; 
                        }, $scope.achievedBadges[i]);
                    }
                }
            }
        });

        $scope.setDir = Utils.setTextDirection;
        $scope.itemZoom = function(item) {
            Utils.itemPlay(item, true, false, 'custom', false, Ranking);
        };
        
    }
]);

/* eslint-disable */
angular.module('html5Game').controller('Login30Ctrl', ['$scope', '$window', 'Config', 'Utils', 'Dictionary', 'EventBus', '$state', '$stateParams', 'User', 'debounce', '$rootScope', '$timeout',
    function ($scope, $window, Config, Utils, Dictionary, EventBus, $state, $stateParams, User, debounce, $rootScope, $timeout) {

        // dummy comment
        var isWrapperFlow = $state.is('wrapperlogin');
        /*
         * check that we are not in the wrapper flow
         * otherwise it becomes inaccessible
         */
        if (!isWrapperFlow && NewtonAdapter.isUserLogged()) {
            $state.go('home');
        } else {

            $scope.showLoggedKey = false;
            var wrapperUrls = {
                unlogged_url: Config.value('WRAPPER_UNLOGGED_URL'),
                loggedfree_url: Config.value('WRAPPER_LOGGEDFREE_URL'),
                subscribed_url: Config.value('WRAPPER_SUBSCRIBED_URL')
            };

            var token,
                returnUrl,
                refreshUrl;
            if (isWrapperFlow) {
                if (JsStorage.isLocalStorageSupported()) {
                    JsStorage.set('wrapperFlow', 1, {
                        type: 'localstorage'
                    });
                }
                token = NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                document.querySelector('html').id = 'wrapperlogin-page';
                $scope.wrapperMsisdn = $stateParams.token ? $stateParams.token : '';
            } else {
                token = NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
                returnUrl = Utils.getQueryString().return_url || '#!' + Config.value('ROUTER_HOME');
                refreshUrl = '/';

                if ($state.current.data && $state.current.data.customHeader) {
                    $rootScope.headerData = {customHeaderTitle: Config.value('GLOBAL_ACCOUNT_HEADER_TITLE') ? Dictionary.value('WEBAPP_TITLE_ACCOUNT') : Dictionary.value('WEBAPP_UO30_LOGIN')};
                }
            }

            $scope.returnUrl = returnUrl;
            $scope.subscribeLinkHref = Dictionary.value('WEBAPP_LOGIN_SUBSCRIBE_LINK_HREF') || Config.value('URLMGR_SUBSCRIBE');

            var postLoginFlow = debounce(300, function () {
                User.getStatus(function (user) {
                    if (isWrapperFlow) {
                        var tToken = 'newtonToken=';
                        NewtonAdapter.getTransientToken(function (err, response) {
                            var tResp = response.token ? response.token : response;
                            var wrapperToken = {session_id: NewtonAdapter.getSessionId(), user_id: tResp};
                            tToken += btoa(JSON.stringify(wrapperToken));
                            if (user.subscribed) {
                                var moreParams = {
                                    user_id: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
                                    user_phone_number: user.msisdn,
                                    user_phone_operator: user.operator,
                                    sub_end_date: user.next_billing_timestamp,
                                    country: Config.value('TLD'),
                                    serviceId: Config.value('SITE_SERVICE')
                                };

                                var queryString = Object.keys(moreParams).map(function (key) {
                                    return key + '=' + encodeURIComponent(moreParams[key]);
                                }).join('&');

                                $window.location.href = wrapperUrls.subscribed_url + '?' + tToken + '&' + queryString;
                            } else {
                                $window.location.href = wrapperUrls.loggedfree_url + '&' + tToken;
                            }
                        });
                    }
                });
            });

            if (isWrapperFlow && NewtonAdapter.isUserLogged()) {
                postLoginFlow();
            } else {
                /*eslint-disable */
                if (NewtonAdapter.isUserLogged()) {
                    $scope.showLoggedKey = true;
                } else {
                    /*eslint-enable */
                    useris.login({
                        element: document.getElementById('blackboard'),
                        access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : ''
                    }, {
                        onSuccess: function (userCredentials) {
                        
                            if (Config.value('IDENTITY_EMAIL_ENABLED')){
                                var userCred = userCredentials.username || userCredentials.msisdn || userCredentials.email;
                                if (/^\+?\d+$/.test(userCred)) {
                                    // do phone number check validity and if correct go with login msisdn
                                    userCredentials.type = 'msisdn';
                                    userCredentials.msisdn = userCred;
                                    userCredentials.pin = userCredentials.pin ? userCredentials.pin : userCredentials.password;
                                } else {
                                    //do login/pw or email pw depending if contains @
                                    if (/@/.test(userCred)) {
                                        userCredentials.type = 'email';
                                        userCredentials.email = userCred
                                        //go with mail/pw
                                    } else {
                                        //go with generic
                                        userCredentials.type = 'generic';
                                        userCredentials.username = userCred;
                                    }
                                }
                                
                                
                            }


                            if (userCredentials.type === 'msisdn' && Config.value('INTERNATIONAL_PREFIX')) {
                                if (userCredentials.msisdn.indexOf(Config.value('INTERNATIONAL_PREFIX')) !== 0 && userCredentials.msisdn.match(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))) {
                                    userCredentials.msisdn = Config.value('INTERNATIONAL_PREFIX') + userCredentials.msisdn.match(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))[1];
                                    //console.log('MSISDN optimized with ' + Config.value('INTERNATIONAL_PREFIX') + ' ', userCredentials.msisdn);
                                }
                            }


                            // call NewtonAdapter login
                            NewtonAdapter.login(userCredentials).then(function (resp) {
                                // console.log(resp);
                                // when login is successful, redirect to returnUrl
                                EventBus.on('User-Login', function () {
                                    if (isWrapperFlow) {
                                        postLoginFlow();
                                    } else if (Config.value('UO30_FORCE_REFRESH_AFTER_LOGIN')) {

                                        JsStorage.set('user-login-show-feedback', 'true', {type: 'cookie', path: '/'});
                                        if (Config.value('AGE_RANGE_CHECK') && $rootScope.ageCheckZoomUrl){
                                            $timeout(function(){
                                                $window.location.href = $rootScope.ageCheckZoomUrl;
                                            })
                                        } else {
                                            $window.location.href = '/';
                                        }

                                    } else {
                                        useris.PopupManager.showUserFeedback({
                                            type: 'positive',
                                            feedback: {
                                                message: Dictionary.value('WEBAPP_UO30_FEEDBACK_LOGIN')
                                            }
                                        });

                                        $timeout(function(){
                                            $window.location.href = returnUrl;
                                        });
                                    }

                                });
                            }).catch(function (err) {
                                var dictKey = Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                                    Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

                                if (dictKey) {
                                    useris.PopupManager.showUserFeedback({
                                        type: 'error',
                                        feedback: {
                                            message: dictKey
                                        }
                                    });
                                }
                            });
                        },
                        onError: function (err) {
                            var dictKey = Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                                Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

                            if (dictKey) {
                                useris.PopupManager.showUserFeedback({
                                    type: 'error',
                                    feedback: {
                                        message: dictKey
                                    }
                                });
                            }
                        },
                        onTemplateLoaded: function (tmplInfo) {
                            //NB: forgot link is ok just as it is.
                            if (document.querySelector('#username') && isWrapperFlow && $scope.wrapperMsisdn) {
                                document.querySelector('#username').value = $scope.wrapperMsisdn;
                            }
                        },
                        onFacebookSuccess: function () {
                            console.log('To be implemented');
                        },
                        onFacebookError: function () {
                            console.log('To be implemented');
                        }
                    });
                }
            }

            $scope.logout = function () {
                NewtonAdapter.logout().then(function (resp) {
                    console.log('Logged Out!');
                    $scope.showLoggedKey = false;
                    $window.location.href = '#!' + Config.value('ROUTER_HOME');
                });
            };
        }
    }
]);
/* eslint-enable */

angular.module('html5Game').controller('LoginPageCtr', ['$scope', 'Settings', 'Config', 'Params', '$http', '$state', 'Utils', 'User',
    function($scope, Settings, Config, Params, $http, $state, Utils, User) {

        User.getStatus(function(user){
            if(user.logged) {
                $state.go('home', {}, {
                    reload: true
                });
            }
        });

        var loginWithEmail = Config.value('MOA_API_MIP_USER_MIPLOGIN');
        var returnUrl = Utils.getReturnUrl();
        var VALIDATION_PIN = new RegExp(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_PIN')),
            VALIDATION_TEL = new RegExp(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN')),
            VALIDATION_EMAIL = new RegExp(Config.value('REGEXP_VALIDATE_EMAIL')),
            VALIDATION_PASSWD = new RegExp(Config.value('REGEXP_VALIDATE_PASSWD')),
            userType = 'not defined';

        // initialize userform object
        $scope.userform = {
            username: '',
            password: ''
        };

        // get phone number from localStorage, if present
        if(JsStorage.isLocalStorageSupported()) {
            $scope.userform.username = JsStorage.get('userform.username', {
                type: 'localstorage'
            }) || '';
        }

        $scope.go = function(where) {
            $state.go(where, {}, {
                reload: true
            });
        };

        // get phone number from query string, if present
        if(typeof (Params.msisdn) !== 'undefined' && Params.msisdn !== 'true') {
            if(Params.msisdn.indexOf(' ') === 0) {
                $scope.userform.username = Params.msisdn.replace(' ', '+');
            } else {
                $scope.userform.username = Params.msisdn;
            }
        }

        $scope.errorUserReq = false;
        $scope.errorUserPatt = false;
        $scope.errorPassReq = false;
        $scope.errorPassPatt = false;
        $scope.errorCheckbox = false;
        $scope.error401 = false;
        $scope.error403 = false;
        $scope.errorOperator = false;


        $scope.submitForm = function(form) {
            $scope.errorUserReq = false;
            $scope.errorUserPatt = false;
            $scope.errorPassReq = false;
            $scope.errorPassPatt = false;
            $scope.errorCheckbox = false;
            $scope.error401 = false;
            $scope.error403 = false;
            $scope.errorOperator = false;

            if(form.$valid) {
                Params.username = $scope.userform.username;
                Params.password = $scope.userform.password;
                Params.return_url = returnUrl;
                Params.operator = $scope.userform.operator ? $scope.userform.operator : '';

                if(userType !== 'email') {
                    Settings.get(Params, function(e) {

                        switch(e.status) {
                        case '302':
                            location.href = decodeURIComponent(e.content);
                            break;
                        default:
                            $scope.content = e.content;
                            break;
                        }
                    });
                } else {
                    var mailData = 'email=' + Params.username + '&password=' + Params.password + '&action=login';
                    $http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
                    $http({
                        method: 'POST',
                        url: loginWithEmail,
                        data: mailData,
                        responseType: 'json',
                        params: {
                            return_url: returnUrl
                        }
                    }).then(function successCallback(response) {
                        location.href = response.data.redirect_url;
                    }, function errorCallback(response) {
                        $scope['error' + response.status] = true;
                    });
                }
            } else {
                $scope.errorUserReq = !!(form.username.$error.required);
                $scope.errorUserPatt = !!(form.username.$error.pattern);
                if(form.password) {
                    $scope.errorPassReq = !!(form.password.$error.required);
                    $scope.errorPassPatt = !!(form.password.$error.pattern);
                }
                $scope.errorOperator = !!((form.operator && form.operator.$error));
                if(form.terms && form.terms.$error) {
                    $scope.errorCheckbox = !!(form.terms.$error.required);
                }
            }
        };

        $scope.watchType = function() { //on input change - validates the username type and changes passwd validation pattern accordingly
            $scope.VALIDATION_USERNAME = (function() {
                if(VALIDATION_EMAIL.test(document.querySelector('#username').value) === true) {
                    userType = 'email';
                    $scope.VALIDATION_PASSWORD = VALIDATION_PASSWD;
                    return VALIDATION_EMAIL;
                } else {
                    userType = 'msisdn';
                    $scope.VALIDATION_PASSWORD = VALIDATION_PIN;
                    return VALIDATION_TEL;
                }
            }());
        };

        $scope.toggle = true;
        //document.querySelector('html').classList.add('loadingRequest');
        Settings.get(Params, function(e) {
            $scope.content = e.content;
        });
    }
]);


angular.module('html5Game').controller('Login30OTP', ['$scope', '$window', 'Config', 'Utils', 'Dictionary', 'EventBus', '$state', '$stateParams', 'User', 'debounce', '$rootScope',
    function($scope, $window, Config, Utils, Dictionary, EventBus, $state, $stateParams, User, debounce, $rootScope) {
      
        var isWrapperFlow = $state.is('wrapperlogin');

        
        //Wrapper flow setup
        $scope.showLoggedKey = false;
        var wrapperUrls = {
            unlogged_url: Config.value('WRAPPER_UNLOGGED_URL'),
            loggedfree_url: Config.value('WRAPPER_LOGGEDFREE_URL'),
            subscribed_url: Config.value('WRAPPER_SUBSCRIBED_URL') 
        };
        
        var token, 
            returnUrl, 
            refreshUrl;
        if (isWrapperFlow) {
            if(JsStorage.isLocalStorageSupported()) {
                JsStorage.set('wrapperFlow', 1, {
                    type: 'localstorage'
                });
            }
            token = NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
            document.querySelector('html').id = 'wrapperlogin-page';
            $scope.wrapperMsisdn = $stateParams.token ? $stateParams.token : '';
        } else {
            token = NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '';
            returnUrl = Utils.getQueryString().return_url || '#!' + Config.value('ROUTER_HOME');
            refreshUrl = '/';

            if ($state.current.data && $state.current.data.customHeader){
                $rootScope.headerData = { customHeaderTitle: Config.value('GLOBAL_ACCOUNT_HEADER_TITLE') ? Dictionary.value('WEBAPP_TITLE_ACCOUNT') : Dictionary.value('WEBAPP_UO30_LOGIN') };
            }
        }

        $scope.returnUrl = returnUrl;

        var postLoginFlow = debounce(300, function(){
            User.getStatus(function(user){
                if (isWrapperFlow) {
                    var tToken = 'newtonToken=';
                    NewtonAdapter.getTransientToken(function (err, response) {
                        var tResp = response.token ? response.token : response;
                        var wrapperToken = { session_id: NewtonAdapter.getSessionId(), user_id: tResp };
                        tToken += btoa(JSON.stringify(wrapperToken));
                        if (user.subscribed){
                            var moreParams = {
                                user_id: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
                                user_phone_number: user.msisdn,
                                user_phone_operator: user.operator,
                                sub_end_date: user.next_billing_timestamp,
                                country: Config.value('TLD'),
                                serviceId: Config.value('SITE_SERVICE')
                            };
                            
                            var queryString = Object.keys(moreParams).map(function(key) {
                                return key + '=' + encodeURIComponent(moreParams[key]);
                            }).join('&');

                            $window.location.href = wrapperUrls.subscribed_url + '?' + tToken + '&' + queryString;
                        } else {
                            $window.location.href = wrapperUrls.loggedfree_url + '&' + tToken;
                        }
                    });
                }
            });
        });
         //Wrapper flow setup end

         // Se è loggato, ce lo leviamo di torno subito.
        if(NewtonAdapter.isUserLogged()){
            if (!isWrapperFlow){
                $scope.showLoggedKey = true;
                $state.go('home');
            } else {
                postLoginFlow();
            }
            return;
        }


        // OTP Setup
        //OTP setup start
        var countrySmsMsg = Dictionary.value('PASSWORD_RECOVERY_SMS') ? Dictionary.value('PASSWORD_RECOVERY_SMS') : '';
        var fakeSmsMgs = 'Your PIN is: ';
        var countryRegex = new RegExp(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'));
        var fakeRegex = new RegExp(/^(\+00)/i);
        $scope.stepPhoneActive = true;
        $scope.stepOTPActive = false;
        $scope.subscribeUrl = Config.value('URLMGR_SUBSCRIBE-URL');
        var returnUrlOtp = Utils.getQueryString().return_url || '#!' + Config.value('ROUTER_HOME') + '?otp=1';
        $scope.otpModel = {
            msisdn: '',
            passw_: []
        };
        var OTPLength = 6;
        $scope.OTParray = Array.from(Array(OTPLength + 1).keys()).slice(1);
        $scope.changeUI = function() {
            if ($scope.stepPhoneActive === true){
                $scope.stepPhoneActive = false;
                $scope.stepOTPActive = true;
            }
        };
        $scope.sendSPFunnelEvent = function(stepName, stepPosition, typeOfAction, funnelName) {
            if (Config.value('SNOWPLOW_TRACKING_ANALYTICS') && Config.value('SNOWPLOW_FUNNEL_ACTIVATION') && window.snowplow !== undefined) {
                // send the event for MX telcel login tracking
                window.snowplow('trackSelfDescribingEvent', {
                    event: {
                        schema: 'iglu:com.dgp/dv_funnel_interaction/jsonschema/1-0-0',
                        data: {
                            step_name: stepName,
                            step_position: stepPosition,
                            step_description: 'user_recognition',
                            type_of_action: typeOfAction,
                            funnel_name: funnelName
                        }
                    }
                });
            }
        };
        $scope.sendSpUserEvent = function(context) {
            if (Config.value('SNOWPLOW_TRACKING_ANALYTICS') && Config.value('SNOWPLOW_FUNNEL_ACTIVATION') && window.snowplow !== undefined) {
                // send the event for MX telcel login tracking
                window.snowplow('trackSelfDescribingEvent', {
                    event: {
                        schema: 'iglu:com.dgp/dv_user_interaction/jsonschema/1-0-0',
                        data: {}
                    },
                    context: [
                        {
                            schema: 'iglu:com.dgp/interaction_element/jsonschema/1-0-3',
                            data: context || {
                                environment: 'browser',
                                tracking_name: 'interaction_default'
                            }
                        }
                    ]
                });
            }
        };
        var manageErr = function(err) {
            var dictKey = Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                    Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

            if(dictKey){
                useris.PopupManager.showUserFeedback({
                    type: 'error',
                    feedback: {
                        message: dictKey
                    }
                });
            }
        };
        //sposta il focus sul prossimo campo dell'otp
        var getCaretPosition = function(el) {
        // Internet Explorer Caret Position
            if (document.selection && document.selection.createRange) {
                var range = document.selection.createRange();
                var bookmark = range.getBookmark();
                return bookmark.charCodeAt(2) - 2;
            }
        // Firefox Caret Position
            return el.setSelectionRange && el.selectionStart;
        };
        var getRightRegex = function() {
            var field = document.querySelector('#phone_number');
            return {
                regex: field.value.match(fakeRegex) ? fakeRegex : countryRegex, 
                msg: field.value.match(fakeRegex) ? fakeSmsMgs : countrySmsMsg
            };
        };
        $scope.goBack = function(){
            $scope.stepPhoneActive = true;
            $scope.stepOTPActive = false;
        };
        // OTP setup end

        //OTP OnREADY
        angular.element(document).ready(function () {
            //sennò si fanno cose
            var frmforgot = document.querySelector('#frmforgot') || null;
            var phoneNum = frmforgot.querySelector('#phone_number') || null;
            var phoneNumHidden = frmforgot.querySelector('#username') || null;
            var password = frmforgot.querySelector('#passw') || null;
            var otpNums = document.querySelectorAll('.login-input-otp') || null;
            if (phoneNumHidden && isWrapperFlow && $scope.wrapperMsisdn){
                phoneNumHidden.value = $scope.wrapperMsisdn;
            }

            // send the event to SNOWPLOW
            $scope.sendSPFunnelEvent(Dictionary.value('SNOWPLOW_MSISDN_REQUEST'), 1, 'OK', Dictionary.value('SNOWPLOW_FUNNEL_NAME'));

            $scope.setPhoneField = function(e) {
                if (phoneNum.value) { //la validazione la fa useris
                    phoneNumHidden.value = phoneNum.value;
                }
            };
            $scope.doForgot = function() {
                // Send the user Interaction event to SNOWPLOW
                const interactionElementContext = {
                    environment: 'browser',
                    tracking_name: Dictionary.value('SNOWPLOW_USER_BUTTON_CONTINUAR'),
                    step_position: 1,
                    step_name: Dictionary.value('SNOWPLOW_MSISDN_REQUEST'),
                    type_of_action: 'OK'
                };
                $scope.sendSpUserEvent(interactionElementContext);
                var msisdn = phoneNumHidden.value;
                if (!JsStorage.get('fakeOTPLogin') && msisdn && Config.value('INTERNATIONAL_PREFIX')) {
                    if (msisdn.indexOf(Config.value('INTERNATIONAL_PREFIX')) !== 0 && msisdn.match(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))) {
                        msisdn = Config.value('INTERNATIONAL_PREFIX') + msisdn.match(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))[1];
                        console.log('MSISDN optimized with ' + Config.value('INTERNATIONAL_PREFIX') + ' ', msisdn);
                    }
                }
                var forgotData = { msisdn: msisdn, smsTemplate: getRightRegex().msg };
                var validateRegex = getRightRegex().regex;
                //console.log('forgot', forgotData, validateRegex);
                if (!phoneNum.value.match(validateRegex)) {
                    useris.PopupManager.showUserFeedback({
                        type: 'error',
                        feedback: {
                            message: Dictionary.value('WEBAPP_UO30_ERROR_WRONG_USERDATA')
                        }
                    });
                } else {
                    $scope.changeUI();
                    // send the event to SNOWPLOW
                    $scope.sendSPFunnelEvent(Dictionary.value('SNOWPLOW_PIN_REQUEST'), 1, 'OK', Dictionary.value('SNOWPLOW_FUNNEL_NAME'));
            
                    NewtonAdapter.recoverPassword(forgotData).then(function(resp){
                        //console.log('recoverpasswd', forgotData, resp);
                    }).catch(function(error){
                        //console.log('forgotData forgot error', forgotData, error);
                    });

                    useris.PopupManager.showUserFeedback({
                        type: 'generic',
                        feedback: {
                            message: Dictionary.value('WEBAPP_UO30_SUGGESTION_FORGOT_CHECKSMS'),
                            icon: 'icon-sms'
                        }
                    });  
                }
            };

            $scope.resendPIN = function() {
                $scope.doForgot();
                // Send the user Interaction event to SNOWPLOW
                const interactionElementContext = {
                    environment: 'browser',
                    tracking_name: Dictionary.value('SNOWPLOW_LINK_REINVIAR_CODIGO'),
                    step_position: 1,
                    step_name: Dictionary.value('SNOWPLOW_PIN_REQUEST'),
                    type_of_action: 'OK'
                };
                $scope.sendSpUserEvent(interactionElementContext);
                angular.forEach(otpNums, function(otpin){
                    otpin.value = '';
                    $scope.otpModel.passw_ = [];
                });
            };

            if (otpNums) {
                angular.forEach(otpNums, function(otpin){
                    var tabindex = parseInt(otpin.tabIndex, 10);
                    var maxlength = parseInt(otpin.maxLength, 10);

                    otpin.addEventListener('keydown', function(e) {
                        var val = otpin.value,
                            cp, 
                            code = e.which || e.keyCode;

                        if (val.length === maxlength && [8, 37, 38, 39, 40, 46].indexOf(code) === -1) {

                            var next = document.querySelectorAll('#passw_' + (tabindex + 1));
                            /* eslint-disable no-unused-expressions */
                            next.length && next[0].focus();
                            return;
                        }

                        cp = getCaretPosition(this);
                        if ((cp === 0 && code === 46) || (cp === 1 && code === 8)) {
                            var prev = document.querySelectorAll('#passw_' + (tabindex - 1));
                            e.preventDefault();
                            otpin.value = val.substring(1);
                            /* eslint-disable no-unused-expressions */
                            prev.length && prev[0].focus();
                            return;
                        }
                    });
                    otpin.addEventListener('input', function (e) {
                        if (otpin.value) {
                            //password.value = $scope.otpModel.passw_.join('');
                            password.value = ('' + otpNums[0].value + otpNums[1].value + otpNums[2].value + otpNums[3].value + otpNums[4].value + otpNums[5].value);
                        }
                    });
                });
            }

            $scope.doLogin = function(e) {
                var userCredentials = { type: 'msisdn', logged: true, msisdn: phoneNumHidden.value, pin: password.value };
                var validateRegex = getRightRegex().regex;

                
                //console.log('login data', userCredentials, validateRegex);
                if (!phoneNum.value.match(validateRegex)) {
                    useris.PopupManager.showUserFeedback({
                        type: 'error',
                        feedback: {
                            message: Dictionary.value('WEBAPP_UO30_ERROR_MSISDN_INVALID')
                        }
                    });
                    // Send the user Interaction event to SNOWPLOW
                    const interactionElementContext = {
                        environment: 'browser',
                        tracking_name: Dictionary.value('SNOWPLOW_BUTTON_ACCEDER'),
                        step_position: 1,
                        step_name: Dictionary.value('SNOWPLOW_PIN_REQUEST'),
                        type_of_action: 'KO'
                    };
                    $scope.sendSpUserEvent(interactionElementContext);
                    $scope.sendSPFunnelEvent(Dictionary.value('SNOWPLOW_PIN_REQUEST'), 1, 'KO', Dictionary.value('SNOWPLOW_FUNNEL_NAME')); 
                } else {
                    //console.log('userCredentials login', userCredentials);
                    if (!JsStorage.get('fakeOTPLogin') && userCredentials.msisdn && Config.value('INTERNATIONAL_PREFIX')) {
                        if (userCredentials.msisdn.indexOf(Config.value('INTERNATIONAL_PREFIX')) !== 0 && userCredentials.msisdn.match(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))) {
                            userCredentials.msisdn = Config.value('INTERNATIONAL_PREFIX') + userCredentials.msisdn.match(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))[1];
                            //console.log('MSISDN optimized with ' + Config.value('INTERNATIONAL_PREFIX') + ' ', userCredentials.msisdn);
                        }
                    }
                    // Send the user Interaction event to SNOWPLOW
                    const interactionElementContext = {
                        environment: 'browser',
                        tracking_name: Dictionary.value('SNOWPLOW_BUTTON_ACCEDER'),
                        step_position: 1,
                        step_name: Dictionary.value('SNOWPLOW_PIN_REQUEST'),
                        type_of_action: 'OK'
                    };
                    $scope.sendSpUserEvent(interactionElementContext);

                    // call NewtonAdapter login
                    NewtonAdapter.login(userCredentials).then(function(resp){
                        // console.log('login resp', resp);

                        // when login is successful, redirect to returnUrl
                        EventBus.on('User-Login', function(){
                            if (isWrapperFlow){
                                document.querySelector('html').classList.add('loadingRequest');
                                postLoginFlow();
                            } else if (Config.value('UO30_FORCE_REFRESH_AFTER_LOGIN')) {
                                JsStorage.set('user-login-show-feedback', 'true', { type: 'cookie', path: '/' });
                                window.location.href = '/?otp=1';
                            } else {
                                useris.PopupManager.showUserFeedback({
                                    type: 'positive',
                                    feedback: {
                                        message: Dictionary.value('WEBAPP_HOME_FROM_OTP')
                                    }
                                });
                                $scope.sendSPFunnelEvent(Dictionary.value('SNOWPLOW_PIN_REQUEST'), 1, 'KO', Dictionary.value('SNOWPLOW_FUNNEL_NAME')); 
                                $state.go('home');
                            }
                        });
                    }).catch(function(err){
                        $scope.sendSPFunnelEvent(Dictionary.value('SNOWPLOW_PIN_REQUEST'), 1, 'KO', Dictionary.value('SNOWPLOW_FUNNEL_NAME')); 
                        manageErr(err);
                    });
                }
            };

        });
        //OTP OnREADY End

        $scope.logout = function(){
            NewtonAdapter.logout().then(function(resp){
                //console.log('Logged Out!');
                $scope.showLoggedKey = false;
                $window.location.href = '#!' + Config.value('ROUTER_HOME');
            });
        };
    }
]);

angular.module('html5Game').controller('MfpPageCtr', ['$scope', 'Devices', 'User', 'Params', 'Analytics', 'Utils', 'MFP', 'Config',
    function($scope, Devices, User, Params, Analytics, Utils, MFP, Config) {

        var init = function() {
            if(JsStorage.isLocalStorageSupported()) {
                JsStorage.set('install_clicked', 1, {
                    type: 'localstorage'
                });
            }

            User.getStatus(function(currentUser) {
                var sessionMfp = new Date().getTime();
                var userLogged = !(parseInt(currentUser.logged, 10) === 0);
                if(userLogged) {
                    if (Config.value('ENABLE_NEWTON_USER')){
                        NewtonAdapter.getTransientToken(function (err, resp) {
                            var userId = resp.token ? resp.token : resp;
                            sessionMfp = sessionMfp + '-' + userId;
                        });
                    } else {
                        sessionMfp = sessionMfp + '-' + currentUser.id;
                    }
                }

                var prop = {
                    page: encodeURI(Params.returnurl),
                    page_type: 'gameover_app_install',
                    action: 'MFP_set',
                    session_mfp: sessionMfp
                };
                Analytics.eventTrack(prop);
                NewtonAdapter.trackEvent({
                    name: prop.action,
                    properties: prop
                });

                MFP.mfpSetAndGo(userLogged, {
                    title: encodeURI(Params.title),
                    returnurl: encodeURI(Params.returnurl),
                    store_protocol: 'http',
                    session_mfp: sessionMfp,
                    posType: 'gameover_app_install'
                });

            });
        };

        init();

    }
]);

angular.module('html5Game').directive('horizNavigation', ['$rootScope', '$state', 'Config', 'Label', 'Item', 'Category', 'debounce', 'Utils', 'Dictionary', 'User',
    function($rootScope, $state, Config, Label, Item, Category, debounce, Utils, Dictionary, User) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/pages/nav/horizNavigation.dir.html',
            replace: true,
            scope: {
                selectedlist: '='
            },
            link: function($scope, $element, $attr) {
                var startIndex = 0;
                var navMarquee = new Glide('.navigationMarquee', {
                    type: 'carousel',
                    startAt: 0,
                    focusAt: 'center',
                    gap: 4,
                    autoheight: true,
                    direction: $rootScope.RTLlang ? 'rtl' : 'ltr',
                    breakpoints: {
                        4000: { perView: 8, peek: 0 },
                        1025: { perView: 7, peek: 0 },
                        769: { perView: 6, peek: 0 },
                        600: { perView: 4, peek: 0 },
                        520: { perView: 4, peek: 0 },
                        361: { perView: 4, peek: 0 },
                        321: { perView: 3, peek: 0 }
                    }
                });

                $scope.setDir = Utils.setTextDirection;

                var buttonListeners = {};

                navMarquee.on(['mount.after', 'update'], function() {
                    setTimeout(function() {
                        var elements = $element[0].querySelectorAll('.glide__slide--clone');

                        angular.forEach(elements, function(el) {
                            var button = el.getElementsByTagName('button')[0];
                            var index = el.dataset.itemindex;

                            var callback = function() {
                                var item = $scope.items[index];
                                if (item) {
                                    $scope.goTo(item);
                                }
                            };

                            if (buttonListeners[index]) {
                                button.removeEventListener('click', buttonListeners[index]);
                            }

                            button.addEventListener('click', callback);
                            buttonListeners[index] = callback;
                        });
                    });
                });

                angular.element(window).bind('resize', function() {
                    if (window.matchMedia('(min-width: 1024px)').matches) {
                        $scope.showControls = true;
                    } else {
                        $scope.showControls = false;
                    }
                    $scope.$apply();
                });

                var additionalItems = {
                    /*random: {
                        name: Dictionary.value('WEBAPP_NAV_RANDOM_SECTION_TITLE'),
                        url_cover: Config.value('nav-rand'),
                        state: 'random'
                    },*/
                    favorites: {
                        name: Dictionary.value('WEBAPP_NAV_FAVORITES_SECTION_TITLE'),
                        url_cover: Config.value('nav-fav'),
                        state: 'favorites',
                        id: 'favorites'
                    },
                    history: {
                        name: Dictionary.value('WEBAPP_NAV_HISTORY_SECTION_TITLE'),
                        url_cover: Config.value('nav-hist'),
                        state: 'history',
                        id: 'history'
                    }
                };

                if ($rootScope.navigationMarquee){
                    $scope.items = $rootScope.navigationMarquee;
                    setTimeout(function(){
                        if ($scope.items.length){
                            //Utils.getActiveGlideItem(navMarquee, '.navigationMarquee', $scope, 'btn-go-to-list');
                            navMarquee.mount();
                        }
                    }, 200);
                } else {
                    var navigationStuff = [];
                    User.getStatus(function(user) {
                        // load labels and categories
                        var labels = [];
                        $scope.labels = [];
                        if (!Config.value('HIDE_LABELS_IN_NAV')){
                            labels = Label.getList({
                                SIZE: 20,
                                OFFSET: 0
                            }).data;
                            var hiddenCharts = Config.value('HIDE_CHARTS_EXPLORE') || [];
                            for(var j = 0; j < labels.length; j++) {
                                if (labels[j].items){
                                    var hiddenIndex = hiddenCharts.indexOf(labels[j].slug);
                                    if (hiddenIndex === -1){
                                        $scope.labels.push(labels[j]);
                                    }
                                }
                            }
                        }
                        var categoriesList = Category.getList({
                            SIZE: 30,
                            OFFSET: 0
                        }).$promise;

                        categoriesList.then(function(cats) {

                            navigationStuff = $scope.labels && Array.isArray($scope.labels) ? $scope.labels : [];

                            if(cats.length) {
                                for(var z = 0; z < cats.length; z++) {
                                    navigationStuff.push(cats[z]);
                                }
                            }
                            if (additionalItems && Config.value('SHOW_STATIC_ITEMS_IN_NAV')){
                                //navigationStuff.push(additionalItems.random);
                                if (user.logged){
                                    var favorites = Item.favoritesList({
                                        SIZE: 1,
                                        OFFSET: 0
                                    }).$promise;
                                    var history = Item.historyList({
                                        SIZE: 1,
                                        OFFSET: 0
                                    }).$promise;
                                    favorites.then(function(tmpItems) {
                                        if(tmpItems.length) {
                                            navigationStuff.push(additionalItems.favorites);
                                        }
                                        history.then(function(tmpRecentItems) {
                                            if(tmpRecentItems.length) {
                                                navigationStuff.push(additionalItems.history);
                                            }
                                        });
                                    });
                                }
                            }
                            $scope.items = navigationStuff;
                            $rootScope.navigationMarquee = $scope.items;
                            setTimeout(function(){
                                if ($scope.items.length){
                                    //Utils.getActiveGlideItem(navMarquee, '.navigationMarquee', $scope, 'btn-go-to-list');
                                    navMarquee.mount();
                                    setCurrentIndex($scope.items, document.querySelector('.selected'));
                                }
                            }, 250);
                        });
                    });
                }

                var setCurrentIndex = function(itemsList, selected){
                    var currentIndex = selected ? selected.getAttribute('nav-index') : startIndex;
                    selected = selected || document.querySelector('.navslider:first-of-type');
                    if (selected){
                        startIndex = currentIndex;
                        if (navMarquee){ navMarquee.update({ startAt: startIndex }); }
                    } else {
                        $scope.selectedlist = itemsList ? itemsList[startIndex] : '';
                    }
                };

                $scope.goTo = debounce(300, function(item) {
                    /*if (item && item.state && item.state === 'random'){
                        var randItem = Utils.getRandomInt(0, $scope.items.length - Object.keys(additionalItems).length);
                        item = $scope.items[randItem];
                    }*/
                    if (item.url_label){
                        $state.go('label', {
                            labelName: item.enc_name,
                            labelId: item.id,
                            listName: item.name
                        }, {
                            reload: true
                        });
                    } else if (item && item.state){
                        $state.go(item.state, {}, { reload: true });
                    } else if (item && item.url_category) {
                        $state.go('category', {
                            categoryId: item.id,
                            categoryName: item.name,
                            listName: item.name
                        }, {
                            reload: true
                        });
                    }

                });

                $element.ready(function(){
                    setCurrentIndex($scope.items, document.querySelector('.selected'));
                });
            }
        };
    }
]);

angular.module('html5Game').directive('listnav', ['$rootScope', '$state', '$window', 'Config', 'LabelAPI', 'Category', 'debounce', 'Utils', 'Dictionary', 'User',
    function($rootScope, $state, $window, Config, Label, Category, debounce, Utils, Dictionary, User) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/pages/nav/listnav.dir.html',
            replace: true,
            controller: 'ListGeneral',
            link: function($scope, $element, $attr) {
                var options = {
                    type: 'slider',
                    startAt: 0,
                    gap: 8,
                    bound: true,
                    autoheight: true,
                    rewind: false,
                    direction: $rootScope.RTLlang ? 'rtl' : 'ltr',
                    breakpoints: {
                        4000: { perView: 9 },
                        1025: { perView: 8 },
                        800: { perView: 7 },
                        600: { perView: 6 },
                        481: { perView: 4 },
                        321: { perView: 3 } 
                    }
                };

                $scope.setDir = Utils.setTextDirection;

                if (Config.value('LISTNAV_CONF')){
                    var optionsOverride = Config.value('LISTNAV_CONF');
                    angular.merge(options, optionsOverride);
                }

                document.querySelector('.listnav').classList.add('loadingcarousel');

                var startIndex = 0;
                var navMarquee = new Glide('.listnav', options);

                var setCurrentIndex = function(itemsList, selected){
                    var currentIndex = selected ? selected.getAttribute('slide-index') : startIndex;
                    if (selected){
                        startIndex = currentIndex;
                        if (navMarquee){ navMarquee.update({ startAt: startIndex }); }
                    }
                };

                var additionalItems = {
                    random: {
                        name: Dictionary.value('WEBAPP_NAV_RANDOM_SECTION_TITLE'),
                        url_cover: Config.value('nav-rand'),
                        state: 'random'
                    },
                    favorites: {
                        name: Dictionary.value('WEBAPP_NAV_FAVORITES_SECTION_TITLE'),
                        url_cover: Config.value('nav-fav'),
                        state: 'favorites'
                    }
                };


                $scope.goTo = debounce(500, function(item, islabel, e) {
                    e.preventDefault();
                    if (item && item.state && item.state === 'random'){
                        var randItem = Utils.getRandomInt(0, $scope.items.length - Object.keys(additionalItems).length);
                        item = $scope.items[randItem];
                        islabel = item.url_label || false;
                    }
                    if (item && islabel){
                        $state.go('label', {
                            labelName: item.enc_name,
                            labelId: item.id,
                            listName: item.name
                        }, {
                            reload: true
                        });
                    } else if (item && item.state && item.state === 'favorites'){
                        $state.go(item.state, {}, { reload: true });
                    } else if (item && item.id) {
                        $state.go('category', {
                            categoryId: item.id,
                            categoryName: item.name,
                            listName: item.name
                        }, {
                            reload: true
                        });
                    }
                });

                var finalizeList = function(cats, user){
                    if(cats.length) {
                        for(var z = 0; z < cats.length; z++) {
                            $scope.items.push(cats[z]);
                        }
                    }
                    if (additionalItems && Config.value('SHOW_STATIC_ITEMS_IN_NAV')){
                        if(user.logged) {
                            $scope.items.push(additionalItems.favorites);
                        } 
                        $scope.items.push(additionalItems.random);
                    }
                    $rootScope.listnav = $scope.items;
                    setTimeout(function(){
                        if ($scope.items.length){
                            navMarquee.mount();
                            setCurrentIndex($scope.items, document.querySelector('.selected'));
                        }
                    }, 200);
                };

                if ($rootScope.listnav){
                    $scope.items = $rootScope.listnav;
                    setTimeout(function(){
                        if ($scope.items.length){
                            navMarquee.mount();
                            setCurrentIndex($scope.items, document.querySelector('.selected'));
                        }
                    }, 200);
                } else {
                    User.getStatus(function(user) {
                        // load labels and categories
                        var categoriesList = Category.getList({
                            SIZE: 30,
                            OFFSET: 0
                        }).$promise;
                        var labelsList;
                        if (!Config.value('HIDE_LABELS_IN_NAV')){
                            labelsList = Label.getList({
                                SIZE: 10,
                                OFFSET: 0
                            }).$promise;
                        }

                        categoriesList.then(function(cats) {
                            $scope.items = [];
                            if (!Config.value('HIDE_LABELS_IN_NAV')){
                                labelsList.then(function(labels){
                                    Array.prototype.forEach.call(labels, function(label, i) {
                                        if (!Config.value('SHOW_ALL_LABELS') && (label && label.slug === Config.value('TOPGAMES_LABELSLUG'))){
                                            labels.splice(i, 1);
                                        }
                                    });
                                    $scope.items = labels;
                                    finalizeList(cats, user);
                                });
                            } else {
                                finalizeList(cats, user);
                            }

                        }); 
                    });
                }

                angular.element(document.querySelector('.listnav')).ready(function(){
                    document.querySelector('.listnav').classList.remove('loadingcarousel');
                });
            }
        };   
    }
]);

angular.module('html5Game').directive('secondarynav', ['Config', 'User', 'Utils', 
    function(Config, User, Utils) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/pages/nav/secondarynav.dir.html',
            scope: {
                mini: '=',
                nav: '='
            },
            replace: true,
            link: {
                post: function($scope, $element, $attr) {
                    
                    for(var i = 0; i < $scope.nav.length; i++){
                        $scope[$scope.nav[i]] = true;
                    }
                    $scope.goTo = Utils.goTo;

                    User.getStatus(function(user){
                        $scope.userLogged = user.logged;
                    });

                }
            }
        };
    }
]);

angular.module('html5Game').directive('subsBanner', ['Config', 'Utils', 'Dictionary', '$sce', 'EventBus', '$state', '$location', 'Analytics',  
    function(Config, Utils, Dictionary, $sce, EventBus, $state, $location, Analytics) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/pages/parts/subsBanner.dir.html',
            scope: {
                mini: '='
            },
            link: {
                post: function($scope, $element, $attr) {
                    $scope.setDir = Utils.setTextDirection;
                    $scope.guestUser = !NewtonAdapter.isUserLogged();

                    var propsClick = {
                        category: 'Behavior',
                        action: 'subs_banner_click',
                        page_name: $state.current.name,
                        page_url: $location.absUrl(),
                        type: $scope.mini ? 'compact' : 'full',
                        label: $location.absUrl(),
                        valuable_cd: 'No',
                        action_cd: 'No'
                    };
                    var propsDisplay = {
                        category: 'Behavior',
                        action: 'subs_banner_displayed',
                        page_name: $state.current.name,
                        page_url: $location.absUrl(),
                        type: $scope.mini ? 'compact' : 'full',
                        label: $location.absUrl(),
                        valuable_cd: 'No',
                        action_cd: 'No'
                    };

                    if ($attr.gamepage) {
                        EventBus.on('gameLoaded', function(game){
                            $scope.ctaUrl = game.url_leaf_engine_subscription;
                            $scope.content = true;
                            $scope.contentText = $sce.trustAsHtml(Dictionary.value('WEBAPP_SUBSCRIPTION_BANNER_CONTENT_TITLE').replace('{content}', game.title));
                            propsDisplay.content_id = game.id + '';
                            propsDisplay.game_title = game.default_title || game.title;
                            propsClick.content_id = game.id + '';
                            propsClick.game_title = game.default_title || game.title;
                        });
                    } else {
                        $scope.ctaUrl = Config.value('URLMGR_SUBSCRIBE');
                    }

                    $scope.trackClickEvent = function(){
                        Analytics.eventTrack(propsClick);
                        NewtonAdapter.trackEvent({
                            name: propsClick.action,
                            properties: propsClick
                        });
                        window.location.href = $scope.ctaUrl;
                    };

                    $scope.$on('$destroy', function() {
                        $scope.contentText = false;
                        $scope.ctaUrl = false;
                        $scope.content = false;
                    });

                    $element.ready(function(){
                        if ($scope.guestUser && Config.value('SHOW_SUBSCRIPTION_BANNER_IN_PAGE')){
                            Analytics.eventTrack(propsDisplay);
                            NewtonAdapter.trackEvent({
                                name: propsDisplay.action,
                                properties: propsDisplay
                            });
                        }
                    });
                }
            }
        };
    }
]);

angular.module('html5Game').controller('NewsPageListCtr', ['$rootScope', '$scope', '$stateParams', 'News', 'Config', 'Dictionary', 'Meta', 'GoogleManager',
    function($rootScope, $scope, $stateParams, Category, Config, Dictionary, Meta, GoogleManager) {
        $scope.itemsize = ($rootScope.deviceType === 'phone' ? 5 : 12);
        $scope.showNoResults = false;

        $scope.$on('noresults', function(){
            $scope.showNoResults = true;
        });
        $scope.$on('results', function() {
            $scope.showNoResults = false;
        });

        Meta.setTitle(Dictionary.value('SEO_WEBAPP_META_TITLE_NEWS'));
        Meta.setDescription(Dictionary.value('SEO_WEBAPP_META_DESCRIPTION_NEWS'));

        $scope.$watch('meta.title', function (newValue, oldValue) {
            GoogleManager.set({
                'Tipo de pagina': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_LIST'),
                'Tipo de pagina /h': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_LIST_H'),
                'Contenido': Dictionary.value('WEBAPP_NO_APPLICABLE_CONTENT'),
                'Contenido /h': Dictionary.value('WEBAPP_NO_APPLICABLE_CONTENT_H'),
                'event': 'changePage'
            });
        });

    }
]);

angular.module('html5Game').controller('NewsPageZoomCtr', ['$rootScope', '$scope', '$stateParams', 'imageSizeFilter', 'Config', 'Dictionary', 'Meta', 'GoogleManager', 'Utils', 'News', '$sce', 'ImageSize', '$document', '$window',
    function($rootScope, $scope, $stateParams, imageSizeFilter, Config, Dictionary, Meta, GoogleManager, Utils, News, $sce, ImageSize, $document, $window) {
        $scope.news = null;
        $scope.newsDesc = null;
        $scope.coverRatio = null;
        $scope.coverImage = null;
        $scope.titlePage = null;

        $scope.setDir = Utils.setTextDirection;
        $scope.convertToDate = Utils.convertToDate;

        $rootScope.headerData = {
            customHeaderTitle: ''
        };

        var newsId = $stateParams.newsId;
        News.get({
            content_id: newsId
        }).$promise.then(function(result) {
            if (result) {
                Meta.setTwitterTitle(result.title);
                Meta.setTitle(result.title + ' ' + Dictionary.value('SEO_WEBAPP_TITLE_COUNTRY'), function(){
                    $rootScope.$emit('pageview-' + $rootScope.currentRoute);
                });
                Meta.setDescription(result.description);
                Meta.setUrl();
                Meta.setImage(imageSizeFilter(result.images.cover.ratio_1_4, 1200, 900));
                Meta.setJsonLd({
                    '@context': 'https://schema.org',
                    '@type': '', // TODO Article type
                    name: result.title,
                    url: $window.location.href,
                    image: result.images.cover.ratio_1_4,
                    description: result.description,
                    inLanguage: [Config.value('REAL_COUNTRY')]
                });
                //$rootScope.titlePage = result.title + ' ' + Dictionary.value('SEO_WEBAPP_TITLE_COUNTRY');
                $scope.newsDesc = $sce.trustAsHtml(result.description);
                $scope.$watch('meta.title', function() {
                    GoogleManager.set({
                        'Tipo de pagina': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_CONTENT'),
                        'Tipo de pagina /h': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_CONTENT_H'),
                        'Contenido': result.title,
                        'Contenido /h': result.title,
                        'event': 'changePage'
                    });
                });

                $scope.coverRatio = 'ratio_1_4';
                var coverLoader = { //not used as of now, because news imgs are not the expected size (ratio_1_4 is still square as ratio_1_4)
                    img: result.images.cover[$scope.coverRatio],
                    hSize: 4,
                    vSize: 0
                };
                $scope.imgWSize = Utils.getBiggerWinSize(1280);
                $scope.imgHSize = 0;

                $scope.news = result;
            }
        });

        $document.ready(function() {
            $rootScope.$broadcast('less-loaded');
        });
    }
]);

angular.module('html5Game').controller('iframeCtr', ['Config', 'Dictionary', 'Meta', '$sce', '$timeout', '$scope', 'User',
    function(Config, Dictionary, Meta, $sce, $timeout, $scope, User) {

        Meta.setTwitterTitle(Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TITLE') + ' - ' + Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TAG_LINE'));
        Meta.setTitle(Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_TITLE'));
        Meta.setDescription(Dictionary.value('SEO_WEBAPP_META_OGTAGS_HOME_DESC'));

        $scope.iframeUrl = $sce.trustAsResourceUrl(Config.value('IFRAME_PAGE_URL'));

        User.getStatus(function(user) {
            $scope.canAccess = Boolean(user.logged && user.subscribed);

            if (Config.value('IFRAME_PAGE_PREMIUM_ONLY') && !$scope.canAccess){
                document.querySelector('html').classList.add('loadingRequest');
                window.location.href = Config.value('URLMGR_SUBSCRIBE');
            } else {
                $timeout(function() {
                    $scope.showIframe = true;
                }, 0);
            }
        });
    }
]);
angular.module('html5Game').directive('activitynav', ['Config', 'Utils',
    function(Config, Utils) {

        return {
            restrict: 'E',
            replace: true,
            scope: {
                active: '@'
            },
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/modules/activity/activitynav.dir.html',
            link: function($scope, $element, $attr) {
                $scope.goTo = Utils.goTo;
            }
        };
    }
]);

angular.module('html5Game').directive('activity', ['Config', 'Utils', 
    function(Config, Utils){ 
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/pages/parts/activity.dir.html',
            replace: true,
            link: {
                post: function($scope, $element, $attr) {
                    $scope.goTo = Utils.goTo;
            
                }
            }
        };
    }
]);

angular.module('html5Game').directive('fblogin', ['$rootScope', 'Config', 'Analytics', '$window', 'Utils', 
    function($rootScope, Config, Analytics, $window, Utils) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/pages/parts/FBLogin.dir.html',
            replace: true,
            link: {
                post: function($scope, $element, $attr) {
                    $scope.fbLogin = function(event, returl) {
                        event.preventDefault();
                        event.stopPropagation();
                        var url = Config.value('URLMGR_MIP-FBLOGIN-LINK');
                        var returnURL = returl || Utils.getReturnUrl();
                        url = returnURL ? (url + Utils.getURLseparator(url) + 'return_url=' + returnURL) : url;

                        var prop = {
                            category: 'Behavior',

                            action: 'FBConnect',
                            valuable_cd: 'No',
                            action_cd: 'Yes'
                        };
                        NewtonAdapter.trackEvent({
                            name: prop.action,
                            properties: prop
                        });
                        Analytics.eventTrack(prop);

                        $window.location.href = url;
                    };
                }
            }
        };
    }
]);

angular.module('html5Game').controller('FooterCtr', ['$rootScope', '$scope', 'Config', 'Dictionary', 'User', 'Logger', 'Utils', '$state', '$sce',
    function($rootScope, $scope, Config, Dictionary, User, Logger, Utils, $state, $sce) {

        // INIZIALIZE ARRAY LINKS
        $scope.setDir = Utils.setTextDirection;
        $scope.links = [];
        $scope.linksExternal = [];
        $scope.linkClass = Config.value('CUSTOM_LINKFOOTER_CLASS') || '';
        $scope.langList = langList;
        $rootScope.hideOperator = ($state.current.data && $state.current.data.hideOperator) ? $state.current.data.hideOperator : false;
        $scope.hideFooter = false;

        if (Dictionary.value('WEBAPP_FOOTER_COPYRIGHT') && Config.value('SHOW_COPY_ON_FOOTER')){
            var footerCopy = Dictionary.value('WEBAPP_FOOTER_COPYRIGHT');
            $scope.footerCopy = footerCopy.replace('{year}', new Date().getFullYear());
        }

        if (Config.value('CONDITIONAL_LOGO_OPERATOR_COOKIE')){
            var opCookie = JsStorage.get('operator', { type: 'cookie' });
            User.getStatus(function(user){
                if ((user.operator === Config.value('CONDITIONAL_LOGO_OPERATOR_COOKIE')) || (opCookie && opCookie === Config.value('CONDITIONAL_LOGO_OPERATOR_COOKIE'))){
                    $scope.logoClass = Config.value('CONDITIONAL_LOGO_OPERATOR_COOKIE').replace('.', '_');
                }
            });
        }

        if (Config.value('SHOW_MULTIPLE_LANGUAGE')){
            $scope.currLang = Config.value('LANGUAGE');
        }
        if(Config.value('ENABLE_DYNAMIC_FOOTER_LINK')) {
            $scope.links = FOOTER_LINKS;
        }

        if(Config.value('EXTERNAL_FOOTER_LINKS_PATTERN')) {
            var addToken = Utils.addToken;
            $scope.linksExternal = Utils.getDictionaryLinks(Config.value('EXTERNAL_FOOTER_LINKS_PATTERN'), addToken);
        }

        if (!Config.value('SHOW_FOOTER_IN_ACCOUNT') && $state.is('settings')){
            $scope.hideFooter = true;
        } else {
            $scope.hideFooter = false;
        }
        if(JsStorage.get('locallogin-show', { type: 'cookie' })) {
            $scope.showLocallogin = true;
        }
    }
]);

angular.module('html5Game').directive('hybridInstall', ['$rootScope', 'Config', 'debounce', 'Analytics', 'User', 'Utils', '$location', 'Dictionary', 'MFP', '$state',
    function($rootScope, Config, debounce, Analytics, User, Utils, $location, Dictionary, MFP, $state) {
        return {
            restrict: 'E',
            templateUrl: function($element, $attr) {
                var tpl = '';
                if ($attr.tmplname){
                    tpl = $attr.tmplname;
                } else {
                    tpl = 'hybridInstall.dir.html';
                }
                var tplUrl = Config.value('JS_TEMPLATE_PREFIX') + '/pages/parts/' + tpl;
                return tplUrl;
            },
            replace: true,
            link: {
                post: function($scope, $element, $attr) {
                    $scope.extendedclass = $attr.extendedclass;
                    var posType = $attr.postype;

                    $rootScope.$on('routechanged', function(){
                        switch($state.current.name){
                        case 'login':
                        case 'forgot':
                        case 'settings':
                        case 'status':
                        case 'terms':
                        case 'wrapperlogin':
                        case 'resetpsw':
                        case 'addemail':
                        case 'changepassword':
                        case 'confirmmail':
                        case 'unsubscribed':
                        case 'error':
                        case 'mfp':
                            $scope.noInstall_State = true;
                            break;
                        default:
                            $scope.noInstall_State = false;                       
                        }
                        User.getStatus(initInstall);
                    });

                    $scope.setDir = Utils.setTextDirection;
                    $scope.setDictDevice = function(keyName) {
                        //append _$SELECTOR to dict key name - only if the selector-specific key has a value.
                        var deviceKey = keyName;
                        if($rootScope.selector) {
                            if(Dictionary.value(keyName + '_' + $rootScope.selector.toUpperCase())) {
                                deviceKey = keyName + '_' + $rootScope.selector.toUpperCase();
                            }
                        }
                        return Dictionary.value(deviceKey);
                    };

                    var initInstall = function(currentUser) {
                        var userLogged = !(parseInt(currentUser.logged, 10) === 0);

                        var necessaryConditions = [ //necessary conditions to show the install banner
                            Config.value('INSTALL_HYBRID_VISIBLE'),
                            //main flag must be set
                            !$scope.noInstall_State,
                            //current page is not the MFP courtesy page (user lands there after clicking install banner on gameover or in-game)
                            ($rootScope.selector === 'android' || $rootScope.selector === 'ios'),
                            //device must be either Android or iOS
                            (!Config.value('INSTALL_HYBRID_ONLYLOGGED') || (Config.value('INSTALL_HYBRID_ONLYLOGGED') && userLogged)),
                            //if there's the flag for showing the banner to logged only, user must be logged. Otherwise, show banner to everybody
                            (($rootScope.selector === 'android' && Config.value('GOOGLEPLAY_STORE_URL')) || ($rootScope.selector === 'ios' && Config.value('ITUNES_STORE_URL')))
                            //store urls must be filled in for the current device
                        ];

                        if(posType === 'header-banner') { //further conditions for header banner
                            necessaryConditions.push(
                                (JsStorage.isLocalStorageSupported()) ? !JsStorage.get('install_clicked', {
                                    type: 'localstorage'
                                }) : true,
                                //localstorage key set after click on INSTALL must not be present
                                !JsStorage.get('closeInstall_clicked', {
                                    type: 'cookie'
                                })
                                //cookie set after dismissal of banner must not be present
                            );
                            if (Config.value('SHOW_NATIVE_INSTALL_EXTENDED')){
                                var topBanner = document.querySelector('.native-install.simple');
                                $rootScope.$on('hideTopBanner', function(){
                                    if (topBanner) {
                                        topBanner.classList.add('away');
                                    }
                                    // not using showBanner here to avoid messing with the preliminary conditions :)
                                });
                                $rootScope.$on('showTopBanner', function(){
                                    if (topBanner) {
                                        window.scroll({
                                            top: 0, 
                                            left: 0, 
                                            behavior: 'smooth'
                                        });
                                        topBanner.classList.remove('away');
                                    }
                                });
                            }
                        }

                        if (posType === 'bottom-banner'){
                            necessaryConditions.push(
                                Config.value('SHOW_NATIVE_INSTALL_EXTENDED'),
                                (JsStorage.isLocalStorageSupported()) ? !JsStorage.get('install_clicked', {
                                    type: 'localstorage'
                                }) : true,
                                //localstorage key set after click on INSTALL must not be present
                                !JsStorage.get('closeInstall_session', {
                                    type: 'cookie'
                                })
                                //session cookie must not be set
                            );
                            $rootScope.showBeforePlay = necessaryConditions.every(function(condition) {
                                return(Boolean(condition)) === true;
                            });

                        }

                        $scope.showBanner = necessaryConditions.every(function(condition) { //used to avoid excessively complex if/else statements
                            return(Boolean(condition)) === true;
                        });

                        if($scope.showBanner === true) {
                            var loadProps = {
                                category: 'Behavior',
                                action: 'NativeAppPromoLoad',
                                label: $location.absUrl(),
                                valuable_cd: 'No',
                                action_cd: 'No'
                            };
                            if (posType === 'header-banner'){
                                window.scroll({
                                    top: 0, 
                                    left: 0, 
                                    behavior: 'smooth'
                                });
                            }
                            debounce(500, function() {
                                Analytics.eventTrack(loadProps);
                                NewtonAdapter.trackEvent({
                                    name: loadProps.action,
                                    properties: loadProps
                                });
                            });

                            if (Config.value('SHOW_NATIVE_INSTALL_EXTENDED') && posType === 'bottom-banner'){
                                $scope.$on('showZoomBanner', function() {
                                    if ($rootScope.showBeforePlay){
                                        $scope.mobileFingerPrint($scope.MFPoptions);
                                        $rootScope.$broadcast('hideTopBanner'); 
                                    }
                                });
                            }
                        }

                        $scope.mobileFingerPrint = debounce(500, function(opts) {
                            if(JsStorage.isLocalStorageSupported() && posType === 'header-banner') {
                                JsStorage.set('install_clicked', 1, {
                                    type: 'localstorage',
                                    path: '/'
                                });
                            }
                            var clickProps = {
                                category: 'Behavior',
                                action: 'NativeAppPromoClick',
                                label: $location.absUrl(),
                                valuable_cd: 'No',
                                action_cd: 'Yes'
                            };
                            Analytics.eventTrack(clickProps);
                            NewtonAdapter.trackEvent({
                                name: clickProps.action,
                                properties: clickProps
                            });

                            // Snowplow send dv_user_interaction with NativeAppPromoClick
                            if (window.snowplow !== undefined && Config.value('SNOWPLOW_TRACKING_ANALYTICS')) {
                                window.snowplow('trackSelfDescribingEvent', {
                                    event: {
                                        schema: 'iglu:com.dgp/dv_user_interaction/jsonschema/1-0-0',
                                        data: {}
                                    },
                                    context: [
                                        {
                                            schema: 'iglu:com.dgp/interaction_element/jsonschema/1-0-1',
                                            data: {
                                                environment: 'browser', 
                                                tracking_name: 'NativeAppPromoClick'
                                            }
                                        }
                                    ]
                                });
                            }

                            var currDate = new Date();
                            var sessionMfp = currDate.getTime() + '' + currDate.getMilliseconds();

                            var prop = {
                                label: $location.absUrl(),
                                page_type: 'banner_app_install',
                                action: 'MFP_set',
                                session_mfp: sessionMfp
                            };
                            Analytics.eventTrack(prop);
                            // Newton.eventTrack(prop);
                            NewtonAdapter.trackEvent({
                                name: prop.action,
                                properties: prop
                            });

                            var mfpOpts = {
                                session_mfp: sessionMfp,
                                posType: posType,
                                gameId: opts && opts.gameId ? opts.gameId : '',
                                url: opts && opts.url ? opts.url : '',
                                goFunction: opts && opts.goFunction ? opts.goFunction : ''
                            };

                            MFP.mfpSetAndGo(userLogged, mfpOpts);
                            if(posType === 'header-banner') {
                                $scope.showBanner = false;
                                $rootScope.showBeforePlay = false;
                                $rootScope.$broadcast('hideTopBanner');
                            }
                        });
                        $scope.closeAppBanner = function(extended) {
                            var closeProps = {
                                category: 'Behavior',
                                action: 'NativeAppPromoClose',
                                label: $location.absUrl(),
                                valuable_cd: 'No',
                                action_cd: 'Yes'
                            };
                            if (extended) {
                                $scope.showextendedbanner = false;
                                JsStorage.set('closeInstall_session', 1, {
                                    type: 'cookie', 
                                    exdays: 1,
                                    path: '/'
                                });
                                $scope.$emit('continueOnWeb');
                                $rootScope.showBeforePlay = false;
                            } else {
                                JsStorage.set('closeInstall_clicked', 1, {
                                    exdays: parseInt(Config.value('HYBRID_INSTALL_SHOW_INTERVAL'), 10),
                                    path: '/'
                                });
                                $scope.showBanner = false;
                            }
                            Analytics.eventTrack(closeProps);
                            NewtonAdapter.trackEvent({
                                name: closeProps.action,
                                properties: closeProps
                            });
                        };
                    };
                    User.getStatus(initInstall);

                    var resizeInstall = function() {
                        var listEl = document.querySelector(':not(home-page) .list-item');
                        if(listEl) {
                            var siblingHeight = listEl.getBoundingClientRect();
                            //did not use .offsetHeight as we need the decimals as well, otherwise the list layout breaks
                            $element.parent().parent().css({ 'height': siblingHeight.height + 'px', 'padding': '0' });
                        }
                    };

                    if(posType === 'midpage' && $scope.showBanner) {
                        angular.element(document).ready(function() {
                            resizeInstall();
                        });
                        angular.element(window).bind('resize', function() {
                            resizeInstall();
                        });
                    }
                }
            }
        };
    }
]);

angular.module('html5Game').directive('gamificationTabs', ['Config', 'Utils', '$state',
    function(Config, Utils, $state){ 
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/pages/parts/gamificationTabs.html',
            replace: true,
            link: {
                post: function($scope, $element, $attr) {
                    $scope.goTo = Utils.goTo;
                    $scope.isContest = $state.is('contest');
                    $scope.isBadges = $state.is('badges');
                }
            }
        };
    }
]);

'use strict';

angular.module('html5Game').directive('onboarding',
    ['$rootScope', 'Config', 'Analytics', 'Utils', '$location', 'Dictionary', '$timeout',
        function($rootScope, Config, Analytics, Utils, $location, Dictionary, $timeout) {
            return {
                restrict: 'E',
                templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/pages/parts/onboarding.dir.html',
                replace: true,
                link: {
                    post: function($scope, $element, $attr){

                        $scope.showOB = false;

                        //occhio all'add2home.Messa condiz. in app.js per farlo partire la volta dopo l'onboarding
                        window.OBdata = {
                            Welcome: {
                                obAction: 'onboarding-welcome-viewed',
                                cookieName: 'obWelcome',
                                item: '#step1',
                                step: 1
                            },
                            Gameinfo: {
                                obAction: 'onboarding-gameinfo-viewed',
                                cookieName: 'obGameinfo',
                                item: '#step2',
                                step: 2
                            },
                            Close: {
                                obAction: 'onboarding-closed',
                                cookieName: 'obClosed',
                                item: '#onboarding-cont',
                                step: 'final'
                            },
                            Ended: {
                                obAction: 'onboarding-ended',
                                cookieName: 'obClosed',
                                item: '#onboarding-cont',
                                step: 'final'
                            }
                        };

                        var step1 = document.querySelector('#step1'),
                            step2 = document.querySelector('#step2'),
                            outerCont = document.querySelector('#onboarding-cont'),
                            outerContPos,
                            step1Els,
                            step2Els,
                            step1sample,
                            step2sample,
                            obText,
                            autoclose;

                        window.OBcommon = function(data, activeclose) {
                            if (!JsStorage.get(data.cookieName)){
                                var obProps = { category: 'Behavior', action: data.obAction, label: $location.absUrl(), valuable_cd: 'No', action_cd: 'Yes' };
                                Analytics.eventTrack(obProps);
                                NewtonAdapter.trackEvent({ name: obProps.action, properties: obProps });

                                JsStorage.set(data.cookieName, 1);
                            }
                            if (activeclose){
                                step1.pauseAnimations();
                                step2.pauseAnimations();
                                $timeout(function(){
                                    $scope.showOB = false;
                                }, 0);
                            }
                        };

                        $scope.closeOB = function(){
                            $timeout.cancel(autoclose);
                            OBcommon(OBdata.Close, true);
                        };

                        $scope.showOB = (JsStorage.get(OBdata.Close.cookieName) && JsStorage.get(OBdata.Gameinfo.cookieName)) ? false : true;

                        $element.ready(function(){
                            $timeout(function(){ //Safari fix
                                outerContPos = outerCont.getBoundingClientRect();
                                step1Els = document.querySelectorAll('#step1 [begin="indefinite"]');
                                step2Els = document.querySelectorAll('#step2 [begin]');
                                step1sample = document.querySelector('#balloonIntro');
                                step2sample = document.querySelector('#balloonGame');
                                obText = document.querySelector('#balloonText');
                                var game = document.querySelector('#obGame') ? document.querySelector('#obGame') : document.querySelectorAll('.homeMixed figure')[3];
                                
                                var pos = game.getBoundingClientRect();
                                var gameSample = game.cloneNode(true);
                                var gameSampleCont = document.querySelector('#gameSample');

                                step1sample.setAttributeNS(null, 'onbegin', 'OBcommon(OBdata.Welcome)');
                                step2sample.setAttributeNS(null, 'onbegin', 'OBcommon(OBdata.Gameinfo)');
                                step2sample.setAttributeNS(null, 'onend', 'OBcommon(OBdata.Ended,true)');

                                //mettere controllo su immagini caricate nella home, sennò gamesample a volte non si vede (anche se magari è un problema di devel??)
                                game.querySelector('img').classList.add('gameinfo');
                                gameSampleCont.appendChild(gameSample);
                                gameSampleCont.style.top = parseInt(((pos.top + Math.round(window.pageYOffset)) - outerContPos.top), 10) + 'px';
                                gameSampleCont.style.left = parseInt(pos.left - outerContPos.left, 10) + 'px';
                                gameSample.style.width = parseInt(game.offsetWidth, 10) + 'px';
                                gameSample.style.height = parseInt(game.offsetHeight, 10) + 'px';

                                if (!JsStorage.get(OBdata.Welcome.cookieName)){
                                    Array.prototype.forEach.call(step1Els, function(el, i) { //start it all
                                        el.beginElement();
                                        obText.classList.add('startAnim');
                                        if ($rootScope.selector === 'ios'){
                                            OBcommon(OBdata.Welcome);
                                            autoclose = $timeout(function(){
                                                OBcommon(OBdata.Ended, true);
                                            }, 30500);
                                        }
                                    });
                                } else if (!JsStorage.get(OBdata.Gameinfo.cookieName)) {
                                    Array.prototype.forEach.call(step2Els, function(el, i){ //start it all
                                        el.beginElement();
                                        outerCont.classList.add('nextScene');
                                        if ($rootScope.selector === 'ios'){
                                            OBcommon(OBdata.Gameinfo);
                                            autoclose = $timeout(function(){
                                                OBcommon(OBdata.Ended, true);
                                            }, 18000);
                                        }
                                    });
                                }
                            }, 500);
                        });
                    }
                }
            };
        }
    ]);

angular.module('html5Game').controller('SettingsCtr', [
    '$scope', '$rootScope', 'Settings', 'Config', '$location', '$state', 'Analytics', '$http', '$document', 'Utils',
    function($scope, $rootScope, Settings, Config, $location, $state, Analytics, $http, $document, Utils) {
        var listWrap,
            dataMap = {};

        var activeParent;
        var activeBody;
        //document.querySelector('html').classList.add('loadingRequest');
        Settings.get({
            SUBSECTION: 'settings',
            CONTENT_ID: 0
        }, function(e) {
            $scope.$broadcast('settingsDataEvent', e.html);

            //new
            $document.ready(function() {
                if(Config.value('SETTINGS_OPEN_AT_START')) {
                    var openEl = document.querySelector("[data-open='1']");
                    if(openEl) { //pezza bruttissima x telco req. rifattorizzare come su news!
                        $scope.select(false, openEl);
                        var settingsOpen = document.createEvent('MouseEvent');
                        settingsOpen.initEvent('click', true, true);
                        openEl.querySelector('a').dispatchEvent(settingsOpen);
                    }
                }
            });
        });

        $scope.select = function(event, openEl) {
            var subsection,
                contentid,
                external,
                activeEl;
            if(event) {
                subsection = event.target.getAttribute('data-subsection');
                contentid = event.target.getAttribute('data-contentid');
                external = event.target.getAttribute('data-external');
                activeEl = event.target;
            } else if(openEl) { //new
                var subsectionAttr = openEl.querySelector('[data-subsection]');
                var contentidAttr = openEl.querySelector('[data-contentid]');
                var externalAttr = openEl.querySelector('[data-external]');
                subsection = subsectionAttr ? subsectionAttr.getAttribute('data-subsection') : '';
                contentid = contentidAttr ? contentidAttr.getAttribute('data-contentid') : '';
                external = externalAttr ? externalAttr.getAttribute('data-external') : '';
                activeEl = openEl.querySelector('[data-subsection]');
            }
            /*if (Element && Element.prototype.closest){
                activeParent = activeEl.closest('.panel-default');
                activeBody = activeParent.querySelector('.panel-body');
                activeBody.classList.add('loadingDocs');
            }*/
            var id = subsection + '-' + contentid;

            if(external) {
                $window.location.href = external;
            } else if(!dataMap[id]) {
                //document.querySelector('html').classList.add('loadingRequest');
                Settings.get({
                    SUBSECTION: subsection,
                    CONTENT_ID: contentid
                }, function(e) {
                    dataMap[id] = true;
                    $scope.$broadcast(id, e.html);
                });
            }
            if(activeEl && activeEl.classList) {
                Array.prototype.forEach.call(document.querySelectorAll('[data-subsection]'), function(el, i) {
                    if(activeEl !== el) {
                        el.classList.remove('opened');
                    }
                });
                activeEl.classList.toggle('opened');
            }
        };

        $scope.goToLogin = function() {
            $state.go('login', {}, {
                reload: true
            });
        };

        var loginWithEmail = Config.value('MOA_API_MIP_USER_MIPLOGIN');

        var returnUrl = Utils.getReturnUrl();

        var VALIDATION_PIN = new RegExp(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_PIN')),
            VALIDATION_TEL = new RegExp(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN')),
            VALIDATION_EMAIL = new RegExp(Config.value('REGEXP_VALIDATE_EMAIL')),
            VALIDATION_PASSWD = new RegExp(Config.value('REGEXP_VALIDATE_PASSWD')),
            userType = 'not defined';

        // initialize userform object
        $scope.userform = {
            username: '',
            password: ''
        };

        // get phone number from localStorage, if present
        if(JsStorage.isLocalStorageSupported()) {
            $scope.userform.username = JsStorage.get('userform.username', {
                type: 'localstorage'
            }) || '';
        }
        // get phone number from query string, if present
        var Params = {};
        Params.SUBSECTION = 'smartlogin';
        if($location.search().msisdn) {
            Params.msisdn = $location.search().msisdn;
        }

        if (typeof (Params.msisdn) !== 'undefined' && Params.msisdn !== 'true') {
            if(Params.msisdn.indexOf(' ') === 0) {
                $scope.userform.username = Params.msisdn.replace(' ', '+');
            } else {
                $scope.userform.username = Params.msisdn;
            }
        }

        $scope.watchType = function() { //on input change - validates the username type and changes passwd validation pattern accordingly
            $scope.VALIDATION_USERNAME = (function() {
                if(VALIDATION_TEL.test($scope.userform.username) === true) {
                    userType = 'msisdn';
                    $scope.VALIDATION_PASSWORD = VALIDATION_PIN;
                    return VALIDATION_TEL;
                } else if(VALIDATION_EMAIL.test($scope.userform.username) === true) {
                    userType = 'email';
                    $scope.VALIDATION_PASSWORD = VALIDATION_PASSWD;
                    return VALIDATION_EMAIL;
                } else {
                    return false;
                }
            }());
        };
        $scope.toggle = true;
        $scope.resetErrors = function() {
            $scope.errorUserReq = false;
            $scope.errorUserPatt = false;
            $scope.errorPassReq = false;
            $scope.errorPassPatt = false;
            $scope.errorCheckbox = false;
            $scope.error401 = false;
            $scope.error403 = false;
        };

        $scope.resetErrors();

        $scope.submitForm = function(form) {
            $scope.resetErrors();
            if(form.$valid) {

                Params.username = $scope.userform.username;
                Params.password = $scope.userform.password;

                if(userType === 'email') {
                    var mailData = 'email=' + Params.username + '&password=' + Params.password + '&action=login';
                    $http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
                    $http({
                        method: 'POST',
                        url: loginWithEmail,
                        data: mailData,
                        responseType: 'json',
                        params: {
                            return_url: returnUrl
                        }
                    }).then(function successCallback(response) {
                        location.href = response.data.redirect_url;
                    }, function errorCallback(response) {
                        $scope['error' + response.status] = true;
                    });
                } else {
                    Settings.get(Params, function(e) {

                        switch(e.status) {
                        case '302':
                            window.location.href = e.content;
                            break;
                        default:
                            $scope.content = e.content;
                            break;
                        }
                    });
                }
            } else {
                $scope.errorUserReq = !!(form.username.$error.required);
                $scope.errorUserPatt = !!(form.username.$error.pattern);
                $scope.errorPassReq = !!(form.password.$error.required);
                $scope.errorPassPatt = !!(form.password.$error.pattern);
                if(form.terms && form.terms.$error) {
                    $scope.errorCheckbox = !!(form.terms.$error.required);
                }
            }
        };

    }
]);

angular.module('html5Game').controller('Settings30Ctr', [
    '$scope', 'Settings', 'Config', '$location', 'Utils', 'Dictionary', 'User', '$sce', '$filter', 'Theme', 'EventBus', 'debounce', '$timeout', 'Analytics', '$state', '$rootScope',
    function($scope, Settings, Config, $location, Utils, Dictionary, User, $sce, $filter, Theme, EventBus, debounce, $timeout, Analytics, $state, $rootScope) {
        $scope.active = -1;
        var returnUrl = Utils.getQueryString().return_url || '#!' + Config.value('ROUTER_HOME');
        var settingsParams = {
            SUBSECTION: 'settings',
            CONTENT_ID: 0,
            output_format: 'json'
        };
        $scope.themeChoice = {};
        $scope.logged = !!NewtonAdapter.isUserLogged();
        $scope.themeChoice = { dark: Theme.getThemeDarkPref() };
        $scope.toggleTheme = debounce(310, Theme.toggleTheme);
        $scope.goTo = Utils.goTo;
        EventBus.on('theme-changed', function(data){
            $timeout(function(){ 
                if (data !== $scope.themeChoice.dark){
                    $scope.themeChoice.dark = data;
                }
            }, 0);
        });

        if (Config.value('SHOW_SEPARATE_USER_NAME') && Config.value('ADD_USER_NAME') && !Config.value('SHOW_STATUS_UO30_PROFILE')){
            //change Nick UO30
            var settingsParamsName = {
                SUBSECTION: 'newtonsmartstatusprofile',
                CONTENT_ID: 'newtonsmartstatusprofile',
                output_format: 'json'
            };
            //YES this repetition is very ugly. Will make a utility method out of it as soon as I can, use it for Contest page as well.
            Settings.get(settingsParamsName).$promise.then(function(resp){
                $scope.userProfile = $sce.trustAsHtml(resp.content);
    
                useris.profile({
                    element: false,
                    access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
                    doNotLoad: true
                }, {
                    onSaveNickname: function (obj) {
                        if (obj.newNickname && Utils.validateNick(obj.newNickname)){
                            User.setNickname({
                                name: obj.newNickname
                            }, function (changedNickname) {
                                obj.callbackSuccess(obj.newNickname);
                                useris.PopupManager.showUserFeedback({
                                    type: 'positive',
                                    feedback: {
                                        message: Dictionary.value('WEBAPP_UO30_FEEDBACK_NICKNAME_UPDATED')
                                    }
                                });  
                                var prop = {
                                    category: 'Behavior',
                                    action: 'NicknameAdded',
                                    valuable_cd: 'No',
                                    action_cd: 'Yes'
                                };
                                Analytics.eventTrack(prop);
                                NewtonAdapter.trackEvent({
                                    name: prop.action,
                                    properties: prop
                                });
                            },
                            function(respErr){
                              /*
                              403 generico
                              403.1 blacklist
                              403.2 sintassi
                              403.3 nickname già usato
                              */
                                switch (respErr.data.error_code) {
                                case '403.1':
                                    useris.PopupManager.showUserFeedback({
                                        type: 'error',
                                        feedback: {
                                            message: Dictionary.value('WEBAPP_UO30_ERROR_NICKNAME_BLACKLISTED')
                                        }
                                    });
                                    break;
                                case '403.2':
                                    useris.PopupManager.showUserFeedback({
                                        type: 'error',
                                        feedback: {
                                            message: Dictionary.value('WEBAPP_UO30_ERROR_NICKNAME_NOT_COMPLIANT')
                                        }
                                    });
                                    break;
                                case '403.3':
                                    useris.PopupManager.showUserFeedback({
                                        type: 'error',
                                        feedback: {
                                            message: Dictionary.value('WEBAPP_UO30_ERROR_NICKNAME_DUPLICATE')
                                        }
                                    });
                                    break;
                              
                                default:
                                    useris.PopupManager.showUserFeedback({
                                        type: 'error',
                                        feedback: {
                                            message: Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_GENERIC')
                                        }
                                    });
                                    break;
                                }
                            });
                        } else {
                            useris.PopupManager.showUserFeedback({
                                type: 'error',
                                feedback: {
                                    message: Dictionary.value('WEBAPP_UO30_ERROR_NICKNAME_LENGTH')
                                }
                            });
                        }
                    },
                    onError: function (error) {
                        useris.triggerError('useris-username-error');
                    }
                });
            });
        }

        $scope.trackClickEvent = function(section){
            var props = {
                category: 'Behavior',
                action: 'doc_list_click',
                page_name: (section.content_id || section.subsection), // + ' - ' + section.label,
                page_url: $location.absUrl(),
                label: $location.absUrl(),
                valuable_cd: 'No',
                action_cd: 'No'
            };
            Analytics.eventTrack(props);
            NewtonAdapter.trackEvent({
                name: props.action,
                properties: props
            });
            //if (section.is_external){
            window.location.href = section.url;
            /* } else {
                Utils.goTo('terms', { content_id: section.content_id, subsection: section.subsection, contentId: section.content_id });
            } */  
        };

        var addSectionsToScope = function(content) {
            $scope.sections = $filter('orderBy')(content, 'position');
            for(var k = 0; k < $scope.sections.length; k++){
                if($scope.sections[k].open_at_start){
                    $scope.open($scope.sections[k], k);
                    break;
                }
            }
        };


        // open method
        $scope.open = function(section, index){
            // active/deactive section
            if($scope.active !== index){
                $scope.active = index;
            } else {
                $scope.active = -1;
            }

            // fill text
            if(!$scope.sections[index].text){ //$scope.sections[index].page_type !== $scope.LOCAL_PAGE_TYPE &&
                settingsParams.SUBSECTION = section.subsection;
                settingsParams.CONTENT_ID = section.content_id;

                Settings.get(settingsParams).$promise.then(function(resp){
                    $scope.sections[index].text = $sce.trustAsHtml(resp.content);

                    if(section.page_type === 'login'){
                        useris.login({
                            element: false,
                            access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
                            doNotLoad: true
                        }, {
                            onSuccess: function(userCredentials){

                                if (userCredentials.type === 'msisdn' && Config.value('INTERNATIONAL_PREFIX')) {
                                    if (userCredentials.msisdn.indexOf(Config.value('INTERNATIONAL_PREFIX')) !== 0 && userCredentials.msisdn.match(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))) {
                                        userCredentials.msisdn = Config.value('INTERNATIONAL_PREFIX') + userCredentials.msisdn.match(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))[1];
                                        console.log('MSISDN optimized with ' + Config.value('INTERNATIONAL_PREFIX') + ' ', userCredentials.msisdn);
                                    }
                                }

                                // call NewtonAdapter login
                                NewtonAdapter.login(userCredentials).then(function(userisResp){
                                    console.log(userisResp);

                                    // when login is successful, redirect to returnUrl
                                    EventBus.on('User-Login', function(){

                                        if (Config.value('UO30_FORCE_REFRESH_AFTER_LOGIN')) {

                                            JsStorage.set('user-login-show-feedback', 'true', { type: 'cookie', path: '/' });

                                            window.location.href = '/';

                                        } else {
                                            useris.PopupManager.showUserFeedback({
                                                type: 'positive',
                                                feedback: {
                                                    message: Dictionary.value('WEBAPP_UO30_FEEDBACK_LOGIN')
                                                }
                                            });

                                            $window.location.href = returnUrl;
                                        }
                                    });
                                }).catch(function(err){
                                    var dictKey = Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                                        Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

                                    if (dictKey) {
                                        useris.PopupManager.showUserFeedback({
                                            type: 'error',
                                            feedback: {
                                                message: dictKey
                                            }
                                        });
                                    }
                                });
                            },
                            onError: function(error){
                                console.log(error);
                            },
                            onFacebookSuccess: function(userCredentials){
                                console.log('To be implemented');
                            },
                            onFacebookError: function(err){
                                console.log('To be implemented');
                            }
                        });
                    } else if(section.page_type === 'newtonsmartstatusprofile'){
                        useris.profile({
                            element: false,
                            access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
                            doNotLoad: true
                        }, {
                            onSaveNickname: function (obj) {
                                if (obj.newNickname && Utils.validateNick(obj.newNickname)){
                                    User.setNickname({
                                        name: obj.newNickname
                                    }, function (changedNickname) {
                                        obj.callbackSuccess(obj.newNickname);
                                        useris.PopupManager.showUserFeedback({
                                            type: 'positive',
                                            feedback: {
                                                message: Dictionary.value('WEBAPP_UO30_FEEDBACK_NICKNAME_UPDATED')
                                            }
                                        });  
                                        var prop = {
                                            category: 'Behavior',
                                            action: 'NicknameAdded',
                                            valuable_cd: 'No',
                                            action_cd: 'Yes'
                                        };
                                        Analytics.eventTrack(prop);
                                        NewtonAdapter.trackEvent({
                                            name: prop.action,
                                            properties: prop
                                        });
                                    },
                                    function(respErr){
                                      /*
                                      403 generico
                                      403.1 blacklist
                                      403.2 sintassi
                                      403.3 nickname già usato
                                      */
                                        switch (respErr.data.error_code) {
                                        case '403.1':
                                            useris.PopupManager.showUserFeedback({
                                                type: 'error',
                                                feedback: {
                                                    message: Dictionary.value('WEBAPP_UO30_ERROR_NICKNAME_BLACKLISTED')
                                                }
                                            });
                                            break;
                                        case '403.2':
                                            useris.PopupManager.showUserFeedback({
                                                type: 'error',
                                                feedback: {
                                                    message: Dictionary.value('WEBAPP_UO30_ERROR_NICKNAME_NOT_COMPLIANT')
                                                }
                                            });
                                            break;
                                        case '403.3':
                                            useris.PopupManager.showUserFeedback({
                                                type: 'error',
                                                feedback: {
                                                    message: Dictionary.value('WEBAPP_UO30_ERROR_NICKNAME_DUPLICATE')
                                                }
                                            });
                                            break;
                                        
                                        default:
                                            useris.PopupManager.showUserFeedback({
                                                type: 'error',
                                                feedback: {
                                                    message: Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_GENERIC')
                                                }
                                            });
                                            break;
                                        }
                                    });
                                } else {
                                    useris.PopupManager.showUserFeedback({
                                        type: 'error',
                                        feedback: {
                                            message: Dictionary.value('WEBAPP_UO30_ERROR_NICKNAME_LENGTH')
                                        }
                                    });
                                }
                            },
                            onError: function (error) {
                                useris.triggerError('useris-username-error');
                            }
                        });
                    } else if (section.page_type === 'newtonsmartstatussocial') {
                        useris.social({
                            element: false,
                            access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
                            doNotLoad: true
                        }, {
                            onFacebookRegisterSuccess: function(){
                                console.log('Facebook login');
                            },
                            onFacebookDisconnect: function(){
                                console.log('Facebook disconnect');
                            }
                        });
                    } else if(section.page_type === 'smartstatus'){
                        useris.smartstatus({
                            element: false,
                            access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
                            doNotLoad: true
                        }, {

                            onUnsubLoggedSuccess: function(params){

                                unsubscriptionFlow(params);
                            },
                            onUnsubLoggedError: function(err){
                                console.log(err);
                            },
                            onUnsubUnloggedSuccess: function(params){
                                if (params.TYPE === 'msisdn' && Config.value('INTERNATIONAL_PREFIX')) {
                                    if (params.IDENTITY.indexOf(Config.value('INTERNATIONAL_PREFIX')) !== 0 && params.IDENTITY.match(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))) {
                                        params.IDENTITY = Config.value('INTERNATIONAL_PREFIX') + params.IDENTITY.match(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))[1];
                                        console.log('MSISDN optimized with ' + Config.value('INTERNATIONAL_PREFIX') + ' ', params.IDENTITY);
                                    }
                                }
                                unsubscriptionFlow(params);
                            },
                            onUnsubUnloggedError: function(err){
                                console.log(err);
                            }
                        });
                    }
                });
            }
        };

        var unsubscriptionFlow = function(params){
            var redirectUrl = false;

            User.unsubscribe(params, function(unsubResp){
                if(unsubResp){
                    console.log('Unsubscription completed', unsubResp);

                    if(Config.value('DISABLE_USERFEEDBACK_POPUP') !== true){
                        useris.PopupManager.showUserFeedback({
                            type: 'positive',
                            feedback: {
                                message: Dictionary.value('WEBAPP_UO30_FEEDBACK_SUBS_DELETED')
                            }
                        });
                    }

                    if(unsubResp.config_key){
                        redirectUrl = Config.value(unsubResp.config_key);
                    } else if(unsubResp.url){
                        redirectUrl = unsubResp.url;
                    }

                    switch(unsubResp.status){
                    case 302:
                        if(unsubResp.unsubscribed){
                            NewtonAdapter.logout().then(function(logoutResp){
                                window.location.href = redirectUrl;
                            });
                        } else {
                            window.location.href = redirectUrl;
                        }
                        break;
                    case 200:
                        $scope.dictKey = Dictionary.value(unsubResp.dict_key);
                        break;
                    default:
                        $scope.dictKey = Dictionary.value(unsubResp.dict_key);
                    }
                } else {
                    $location.path(Config.value('ROUTER_ERROR'));
                }
            });
        };

        $scope.userLogout = function(){
            NewtonAdapter.logout().then(function (resp) {
                console.log('success', resp);

                if (Config.value('UO30_FORCE_REFRESH_AFTER_LOGIN')) {
                    JsStorage.set('user-logout-show-feedback', 'true', { type: 'cookie', path: '/' });
                    window.location.href = '/';

                } else {
                    useris.PopupManager.showUserFeedback({
                        type: 'positive',
                        feedback: {
                            message: Dictionary.value('WEBAPP_UO30_FEEDBACK_LOGOUT')
                        }
                    });

                    window.location.href = '#!' + Config.value('ROUTER_HOME');
                }
            }).catch(function (err) {
                console.log('err', err);
                window.location.href = '#!' + Config.value('ROUTER_ERROR');
            });

        };

        if (Config.value('EXTERNAL_SETTINGS_LINKS')){
            $scope.login = { url: '/#!' + Config.value('ROUTER_LOGIN'), label: Dictionary.value('WEBAPP_LOGIN') };
            $scope.linksExternal = Utils.getDictionaryLinks(Config.value('EXTERNAL_SETTINGS_LINKS_PATTERN'));
        } else {
            Settings.getList(settingsParams).$promise.then(function(resp){
                addSectionsToScope(resp.content);
            });
        }
    }
]);

angular.module('html5Game').directive('welcome', ['$rootScope', 'Config', 'Analytics', 'User', 'Dictionary', '$state', '$sce',  
    function($rootScope, Config, Analytics, User, Dictionary, $state, $sce) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/pages/parts/welcome.dir.html',
            replace: true,
            link: {
                post: function($scope, $element, $attr) {
                    $scope.showWelcome = false;
                    if (Config.value('SVG_HEADER_INJECTED')){
                        $scope.headerSvg = $sce.trustAsResourceUrl(Config.value('header-svg')); 
                        angular.element(document.querySelector('.headersvg')).ready(function(){
                            SVGInjector.SVGInjector(document.getElementsByClassName('headersvg'));
                        });
                    }
                    angular.element(document).ready(function(){
                        var isHome = $state.is('home') || !!document.querySelector('.home-page');

                        if (Config.value('SHOW_WELCOME_MODAL') && isHome){
                            var flagType = 'localstorage';

                            if(!JsStorage.isLocalStorageSupported()) {
                                flagType = 'cookie';
                            }

                            if(!JsStorage.get('welcome_seen', { type: flagType })) {
                                $scope.showWelcome = true;
                                $scope.$apply();
                                JsStorage.set('welcome_seen', 1, { type: flagType });
                            }

                            $scope.closeWelcome = function(){
                                $scope.showWelcome = false;
                            };
                        }
                    });
                }
            }
        };
    }
]);

angular.module('html5Game').directive('ageCheck', ['$rootScope', 'Config', 'Analytics', 'User', 'Utils', '$state', '$sce',  
    function($rootScope, Config, Analytics, User, Utils, $state, $sce) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/pages/parts/ageCheck.dir.html',
            replace: true,
            scope: {
            },
            link: {
                post: function($scope, $element, $attr) {
                    $scope.minAge = Config.value('AGE_RANGE_CHECK');
                    $rootScope.ageCheckModal = angular.element($element);
                    $rootScope.hasAnswered = JsStorage.get('ageCheckAnswer');
                    $rootScope.showAgeForm = false;
                    $scope.dateCheckActive = Config.value('AGE_RANGE_CHECK_DATE');
                    var errorUrl = Config.value('DEST_DOMAIN') + Config.value('AGE_CHECK_ERROR_URL'); 
                    
                    //AGE CHECK 
                    if ($scope.minAge){
                        User.getStatus(function(user) {
                            if (user.logged){
                                /*eslint-disable no-lonely-if*/
                                if (!user.date_of_birth && $rootScope.hasAnswered !== 1){
                                    /*eslint-disable no-lonely-if*/
                                    if (!$rootScope.ageCheckModal[0].open){
                                        $rootScope.ageCheckModal[0].showModal();
                                    }
                                }
                            } else {
                                try {
                                    if (sessionStorage.getItem('ageCheckFailed')) {
                                        window.location.href = errorUrl;
                                        return false;
                                    } else if ($rootScope.hasAnswered !== 1) {
                                        if (!$rootScope.ageCheckModal[0].open){
                                            $rootScope.ageCheckModal[0].showModal();
                                        }
                                    }
                                } catch (err) {
                                    console.info(err);
                                }
                            }
                        });
                    }


                    function parseDate(data) {
                        var date = data instanceof Date ? data : new Date(data);
                        if (isNaN(date.getTime())) {
                            throw new Error('Invalid date value: ' + data);
                        }
                        return date.getFullYear() + '-'
                            + ('0' + (date.getMonth() + 1)).slice(-2) + '-'
                            + ('0' + date.getDate()).slice(-2);
                    }

                    var cutoffParam = $scope.dateCheckActive ? Utils.getAgeCheckCutoff($scope.minAge) : Utils.getAgeCheckCutoff(0);

                    $scope.cutoff = parseDate(cutoffParam);

                    $scope.sendAnswer = function(answer){
                        if (window.snowplow !== undefined && Config.value('SNOWPLOW_TRACKING_ANALYTICS')) {
                            window.snowplow('trackSelfDescribingEvent', {
                                event: {
                                    schema: 'iglu:com.dgp/dv_user_interaction/jsonschema/1-0-0',
                                    data: {}
                                },
                                context: [
                                    {
                                        schema: 'iglu:com.dgp/interaction_element/jsonschema/1-0-1',
                                        data: {
                                            environment: 'browser', 
                                            element_type: 'button', 
                                            tracking_name: 'age_control_dialog_' + answer ? 'yes' : 'no'
                                        }
                                    }
                                ]
                            });
                        }    

                        JsStorage.set('ageCheckAnswer', answer ? 1 : 2, { type: 'cookie', exhours: 1 });  
                        $rootScope.hasAnswered = answer ? 1 : 2;    

                        if (!answer){
                            $rootScope.ageCheckModal[0].close();
                            try {
                                sessionStorage.setItem('ageCheckFailed', '1');
                            } catch (err) {
                                console.info(err);
                            }
                            $rootScope.ageCheckModal[0].close();
                            window.location.href = errorUrl;
                        } else if (!NewtonAdapter.isUserLogged()){
                            $rootScope.ageCheckModal[0].close();
                            Utils.goTo('login');
                        } else if ($rootScope.playConf){
                            if (NewtonAdapter.isUserLogged()){
                                $rootScope.showAgeForm = true;
                            } else {
                                Utils.goTo('login');
                            }
                        } else {
                            $rootScope.ageCheckModal[0].close();
                        }
                    };
                    
                    $scope.sendAgeData = function(e){
                        e.preventDefault();
                        if (window.snowplow !== undefined && Config.value('SNOWPLOW_TRACKING_ANALYTICS')) {
                            window.snowplow('trackSelfDescribingEvent', {
                                event: {
                                    schema: 'iglu:com.dgp/dv_user_interaction/jsonschema/1-0-0',
                                    data: {}
                                },
                                context: [
                                    {
                                        schema: 'iglu:com.dgp/interaction_element/jsonschema/1-0-1',
                                        data: {
                                            environment: 'browser', 
                                            element_type: 'button', 
                                            tracking_name: 'age_control_userdata_send'
                                        }
                                    }
                                ]
                            });
                        }  

                        var form = e.target;
                        var ageProps = {
                            first_name: form.elements.firstName.value,
                            last_name: form.elements.lastName.value,
                            date_of_birth: form.elements.dateOfBirth.value
                        };
                        User.setProfile(ageProps, function(resp) {
                            var prop = {
                                category: 'Behavior',
                                action: 'SetAgeCheckData',
                                valuable_cd: 'No',
                                action_cd: 'Yes'
                            };
                            Analytics.eventTrack(prop);
                            NewtonAdapter.trackEvent({
                                name: prop.action,
                                properties: prop
                            });

                        });
                        
                        $rootScope.ageCheckModal[0].close();

                        var isUserOfAge = $scope.dateCheckActive ? Utils.isUserOfAge(ageProps.date_of_birth, $scope.minAge) : { isOfAge: true }; 

                        if ($rootScope.playConf && (isUserOfAge.isOfAge)) {
                            Utils.gamePlay($rootScope.playConf, false, true);
                        } else if (!isUserOfAge.isOfAge) {
                            sessionStorage.setItem('ageCheckFailed', '1');
                            window.location.href = errorUrl;
                        }
                    };
                }
            }
        };
    }
]);

angular.module('html5Game').directive('crossSellingBanner', ['Config', 'Utils', 'Dictionary', '$window', '$rootScope', 
    function(Config, Utils, Dictionary, $window, $rootScope){ 
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/pages/parts/crossSellingBanner.html',
            replace: true,
            link: {
                post: function($scope, $element, $attr) {
                    $scope.goToUrl = function () {
                        if (window.snowplow !== undefined && Config.value('SNOWPLOW_TRACKING_ANALYTICS')) {
                            console.log('Launch Event Snowplow');
                            window.snowplow('trackSelfDescribingEvent', {
                                event: {
                                    schema: 'iglu:com.dgp/dv_user_interaction/jsonschema/1-0-0',
                                    data: {}
                                },
                                context: [
                                    {
                                        schema: 'iglu:com.dgp/interaction_element/jsonschema/1-0-1',
                                        data: {
                                            environment: 'browser', 
                                            element_type: 'button', 
                                            tracking_name: 'cross_selling_banner'
                                        }
                                    }
                                ]
                            });
                        }    

                        var url = Dictionary.value('WEBAPP_CROSS_SELLING_BANNER_LINK');
                        if (url) {
                            $window.open(url, '_blank');
                        }
                    };                   
                }
            }
        };
    }
]);

angular.module('html5Game').controller('ProfilePageCtr', ['$scope', '$state', '$rootScope', 'User', 'Config', 'Analytics', 'debounce', 'Dictionary', 'Utils',
    function($scope, $state, $rootScope, User, Config, Analytics, debounce, Dictionary, Utils) {
        $scope.signup_link = Config.value('URLMGR_MIP-SIGNUP-LINK');
        $scope.account_creation_link = Config.value('URLMGR_MIP-REGISTER-LINK');
        $scope.account_creation_link_skipped = $scope.account_creation_link + '?skipped=1';
        $scope.changePasswdLink = Config.value('URLMGR_MIP-CHANGEPASSWORD-LINK');
        $scope.username = null;
        $scope.email = null;
        $scope.setLogin3G = false;
        $scope.avatar = Config.value('default-avatar');
        var oldNick;
        var VALIDATION_EMAIL = new RegExp(Config.value('REGEXP_VALIDATE_EMAIL'));
        $scope.goToLogin = function() {
            if(Config.value('SWITCH_LOGIN_TO_SUSCRIBE')) {
                window.location.href = Config.value('DEST_DOMAIN') + Config.value('URLMGR_SUBSCRIBE');
            } else if(Config.value('ALTERNATIVE_LOGIN_LINK')) {
                window.location.href = Config.value('ALTERNATIVE_LOGIN_LINK');
            } else {
                $state.go('login', {}, {
                    reload: true
                });
            }
        };
        $scope.goTo = Utils.goTo;

        User.getStatus(function(d) {
            if(!d.logged && !JsStorage.get('operator')) {
                $scope.setLogin3G = true;
            }
            oldNick = (d.nickname && d.nickname !== 'undefined') ? d.nickname : '';
            $scope.username = oldNick;
            $scope.email = d.email || false;
            $scope.skipped = !!((d.skipped_account_creation && d.skipped_account_creation === true));
            if(d.fb_auth_id) {
                $scope.avatar = 'https://graph.facebook.com/' + d.fb_auth_id + '/picture?type=square&height=100&width=100';
                $scope.fbImgClass = true;
                // era: Config.value('FB_USER_PIC_URL').replace('{FACEBOOKID}',d.auth_id); ma sbarellava perchè appende caratteri UNICODE strani alla fine della url O_O
            }
        });

        $scope.fbDisconnect = function() {
            User.fbDisconnect(function(resp){
                if (resp.logged && !resp.subscribed){
                    $window.location.reload();
                } else {
                    $rootScope.userData.fb_auth_id = '';
                    $scope.avatar = Config.value('default-avatar');
                    $scope.fbImgClass = false;
                    $rootScope.$broadcast('fbdisconnect');
                }
            });
            var prop = {
                category: 'Behavior',
                action: 'FBDisconnect',
                valuable_cd: 'No',
                action_cd: 'Yes'
            };
            Analytics.eventTrack(prop);
            NewtonAdapter.trackEvent({
                name: prop.action,
                properties: prop
            });
        };

        $scope.save = debounce(300, function(value) {
            if(value && value !== oldNick) {
                User.setNickname('data_user[nickname]=' + value, function(resp) {
                    if(resp.status !== '200') {
                        $scope.username = oldNick;
                        //showerror?
                    } else {
                        $scope.username = value;
                    }
                    var prop = {
                        category: 'Behavior',
                        action: 'EditNickname',
                        valuable_cd: 'No',
                        action_cd: 'Yes'
                    };
                    Analytics.eventTrack(prop);
                    NewtonAdapter.trackEvent({
                        name: prop.action,
                        properties: prop
                    });
                });
            } else {
                $scope.noChange();
            }
        });

        $scope.noChange = function() {
            $scope.username = oldNick;
            $scope.$apply();
        };

        $scope.changeEmail = debounce(300, function(value) {
            $scope.emailChgError = false;
            value = value || $scope.email;
            if(value !== $scope.email) {
                if(VALIDATION_EMAIL.test(value)) {
                    var data = 'new_email=' + value + '&new_email_2=' + value;
                    User.setEmail(data, finalizeEmailChange);
                    var prop = {
                        category: 'Behavior',
                        action: 'EditEmail',
                        valuable_cd: 'No',
                        action_cd: 'Yes'
                    };
                    Analytics.eventTrack(prop);
                    NewtonAdapter.trackEvent({
                        name: prop.action,
                        properties: prop
                    });
                } else {
                    $scope.email = $rootScope.userData.email;
                    $scope.emailChgError = Dictionary.value('WEBAPP_EMAILFORMAT_ERROR');
                }
            }
        });

        var finalizeEmailChange = function(response) {
            $scope.emailChgError = response.message;
            if(!Config.value('MIPCONNECT_EMAIL_CONFIRMATION')) {
                $scope.email = response.actual_email;
            }
        };

    }
]);

angular.module('html5Game').controller('ResetPasswordCtrl', ['$scope', '$stateParams', 'Config', 'Dictionary', 'Mail',
    function($scope, $stateParams, Config, Dictionary, Mail) {
        console.log('Placeholder controller for ResetPasswordCtrl');

        if(NewtonAdapter.isUserLogged()){

            useris.PopupManager.showUserFeedback({
                type: 'error',
                feedback: {
                    message: Dictionary.value('WEBAPP_ERROR_NEWTON_GENERIC_ERROR')
                }
            });
        
            window.location.href = '#!' + Config.value('ROUTER_HOME');
        } else {
            useris.resetPassword({
                element: document.getElementById('blackboard'),
                token: $routeParams.token,
                email: $routeParams.email,
                access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : ''
            }, {
                onSuccess: function (userCredentials) {
                    console.log(userCredentials);
                    NewtonAdapter.resetPassword(userCredentials).then(function (resp) {
                        if (Config.value('SEND_EMAIL_AFTER_RESET')) {
                            Mail.sendAfterReset({
                                USERNAME: $stateParams.email,
                                EMAIL: $stateParams.email
                            }).$promise.then(function (mailResp) {

                                useris.PopupManager.showUserFeedback({
                                    type: 'positive',
                                    feedback: {
                                        message: Dictionary.value('WEBAPP_UO30_FEEDBACK_PSWRESET')
                                    }
                                });

                                window.location.href = '#!' + Config.value('ROUTER_LOGIN');
                            });
                        } else {

                            useris.PopupManager.showUserFeedback({
                                type: 'positive',
                                feedback: {
                                    message: Dictionary.value('WEBAPP_UO30_FEEDBACK_PSWRESET')
                                }
                            });

                            window.location.href = '#!' + Config.value('ROUTER_LOGIN');
                        }
                    }).catch(function (err) {
                        var dictKey = Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) ?
                            Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_' + err.code.toUpperCase()) : Dictionary.value('WEBAPP_UO30_ERROR_NEWTON_GENERIC');

                        if (dictKey) {
                            useris.PopupManager.showUserFeedback({
                                type: 'error',
                                feedback: {
                                    message: dictKey
                                }
                            });
                        }
                    });
                },
                onError: function (error) {
                    console.log(error);
                    window.location.href = '#!' + Config.value('ROUTER_ERROR');
                }
            });
        }
    }
]);

angular.module('html5Game').directive('searchField', ['Config', 'Utils', '$location', '$state', 'Analytics', 
    function(Config, Utils, $location, $state, Analytics) {
        return {
            restrict: 'E',
            templateUrl: Config.value('JS_TEMPLATE_PREFIX') + '/pages/search/searchForm.html',
            replace: true,
            scope: true,
            link: {
                post: function($scope, $element, $attr) {

                    // eslint-disable-next-line
                    $scope.searchPattern = Config.value('USE_SEARCH_REGEX')  ? /^[\w\d]+$/ : '';
                    $scope.newSearch = function(e) {
                        if ($scope.newQuery){
                            if ($scope.newQuery === 'Locallogin_DV' && Config.value('LOCALLOGIN_SHORTCUT_ENABLED')){ //done for cloud gaming testing
                                location.href = '/locallogin';
                            } else {
                                Utils.goTo('search', {
                                    query: $scope.newQuery
                                });
                                var props = {
                                    category: 'Behavior',
                                    action: 'search_query',
                                    page_name: $state.current.name,
                                    page_url: $location.absUrl(),
                                    label: $location.absUrl(),
                                    query: $scope.newQuery,
                                    valuable_cd: 'No',
                                    action_cd: 'No'
                                };
                                Analytics.eventTrack(props);
                                NewtonAdapter.trackEvent({
                                    name: props.action,
                                    properties: props
                                });
                            }
                        }
                    };
                }
            }
        };
    }
]);
angular.module('html5Game').controller('SearchPage', ['$rootScope', '$scope', '$stateParams', '$location', 'LabelAPI', 'Dictionary', 'Config', 'Utils', '$state', 'Analytics', 'EventBus', 'Meta', 'Category',  
    function($rootScope, $scope, $stateParams, $location, Label, Dictionary, Config, Utils, $state, Analytics, EventBus, Meta, Category) {

        $scope.searchResultsTmpl = Config.value('SEARCH_TPL') ? Config.value('JS_TEMPLATE_PREFIX') + Config.value('SEARCH_TPL') : Config.value('JS_TEMPLATE_PREFIX') + '/pages/search/searchResultsUnified.html';
        // initialize variables
        // get query, if exists
        $scope.query = $stateParams.query ? $stateParams.query : '';
        if($scope.query) {
            $scope.newQuery = $scope.query;
        } else {
            $scope.showNoResults = true;
            $scope.query = '';
        }
        Meta.setTitle(Dictionary.value('WEBAPP_GOLD_HEADER_MENU_SEARCH') + ' ' + $scope.query + ' ' + Dictionary.value('SEO_WEBAPP_TITLE_COUNTRY'), function(){
            $rootScope.$emit('pageview-' + $rootScope.currentRoute);
        });

        $scope.getRatioConf = Utils.getRatioConf;
        $scope.inputFocus = false;
        $scope.imgRatio = Utils.getRatioConf('search', 'ratio_2');
        $scope.goLabel = function(list){
            var props = {
                category: 'Behavior',
                action: 'list_click',
                page_name: $state.current.name,
                page_url: $location.absUrl(),
                label: $location.absUrl(),
                list_id: list.id,
                list_type: 'chart',
                list_title: list.name,
                valuable_cd: 'No',
                action_cd: 'No'
            };
            Analytics.eventTrack(props);
            NewtonAdapter.trackEvent({
                name: props.action,
                properties: props
            });
            Utils.goToLab(list);
        };
        
        Label.getList({
            SIZE: 10,
            OFFSET: 0
        }).$promise.then(function(labelsList){
            if (Config.value('LABELS_IN_SEARCH')){
                var searchLabelsList = Config.value('LABELS_IN_SEARCH_LIST');
                var searchLabels = [];
                $scope.chartSelection = [];
                for(var i = 0; i < labelsList.length; i++) {
                    if (Config.value('TOPGAMES_LABELSLUG') && labelsList[i].slug === Config.value('TOPGAMES_LABELSLUG')) {
                        $scope.firstLabelId = labelsList[i];
                    } 
                    if (searchLabelsList && searchLabelsList.length){
                        for(var l = 0; l < searchLabelsList.length; l++) {
                            if (labelsList[i].slug === searchLabelsList[l]){
                                searchLabels.push(labelsList[i]);
                            }
                        }
                    }
                    if ((!searchLabelsList && Config.value('TOPGAMES_LABELSLUG') && labelsList[i].slug === Config.value('TOPGAMES_LABELSLUG')) || !Object.keys(labelsList[i].items).length){
                        labelsList.splice(i, 1);
                    }               
                }
                if (searchLabels && searchLabels.length){
                    $scope.chartSelection = searchLabels;
                } else {
                    $scope.chartSelection = labelsList;
                }
            } else {
                var labelsListShuffled = Utils.shuffleArray(labelsList);
                for(var j = 0; j < labelsListShuffled.length; j++) {
                    if (Object.keys(labelsListShuffled[j].items).length){
                        $scope.firstLabelId = labelsListShuffled[j];
                        break;
                    }
                }
            }
        });

        if (Config.value('SHOW_CATEGORIES_IN_SEARCH')){
            Category.getList({
                SIZE: 30,
                OFFSET: 0
            }).$promise.then(function(categories) {
                $scope.otherCategories = categories;
            });
        }

        // get results length and show/hide blocks
        EventBus.on('noSearchResults', function(){
            $scope.showNoResults = true;
            $scope.showResults = false;
        });
        EventBus.on('searchResults', function(){
            $scope.showResults = true;
            $scope.showNoResults = false;
        });

        //$rootScope.titlePage = Dictionary.value('WEBAPP_GOLD_HEADER_MENU_SEARCH') + ' ' + $scope.query + ' ' + Dictionary.value('SEO_WEBAPP_TITLE_COUNTRY');
    }
]);

angular.module('html5Game').controller('GameZoom', ['$rootScope', '$scope', '$window', '$stateParams', 'ContestService', 'EventBus', 'Item', 'User', 'imageSizeFilter', 'Config', 'Dictionary', 'Meta', 'Analytics', 'ImageSize', 'Utils', 'Ranking', '$state', '$sce', '$document', 'GoogleManager', 'MFP', 'debounce', 'Leaderboard', '$timeout', '$location',
    function($rootScope, $scope, $window, $stateParams, ContestService, EventBus, Item, User, imageSizeFilter, Config, Dictionary, Meta, Analytics, ImageSize, Utils, Ranking, $state, $sce, $document, GoogleManager, MFP, debounce, Leaderboard, $timeout, $location) {
        //get game id. Can it be done in a cleaner way?
        var url = $stateParams.gameURL;
        var array = url.split('_');
        var id = array[array.length - 1];
        var gameId = $stateParams.gameId + '' || id.replace('.html', '');
        $scope.listConfig = Config.value('ZOOM_LIST_TPLS');
        $scope.getGameHtml5 = false;
        $scope.showLDB = false;
        $scope.showLDBCompetition = false;

        var setupContest = function(data){
            $scope.isMulti = data && data.length > 1 ? true : false;
            $scope.contests = data ? data : [];
            // single contest: $scope.contests[0];
            if ($scope.contests){
                $scope.contests.forEach(function(contest){
                    if (contest && contest.content_info && contest.content_info.id && contest.CONTENT_ID === gameId){
                        if (contest.CONTEST_TIMEFRAME_UTC){
                            $scope.contestResults = contest && contest.leaderboard && contest.leaderboard.top_scorer ? contest.leaderboard.top_scorer : false;
                            var time = ContestService.timeLeft(contest.CONTEST_TIMEFRAME_UTC);
                            if (time){
                                $scope.timeLeft = time.timeLeft;
                                $scope.isContestOver = time.isContestOver;
                                $scope.notStarted = time.notStarted;
                                $scope.start = contest.CONTEST_TIMEFRAME_UTC.start;
                                $scope.end = contest.CONTEST_TIMEFRAME_UTC.finish;
                                $scope.contestDates = contest.CONTEST_TIMEFRAME_UTC;
                            }

                            $scope.contestGame = contest.content_info;
                            if (Config.value('SHOW_LEADERBOARDS_COMPETITION')){
                                $scope.showLDBCompetition = true;
                                $scope.showLDB = false;
                            }
                            $scope.myScore = contest.user_score;
                            $scope.ready = true;
                            $scope.isContestGame = !!($scope.contestGame.id + '' === $scope.game.id + '');
                        } else {
                            $scope.isContestOver = true;
                        }
                    }
                });
            }
        };
        if (Config.value('ENABLE_CONTEST')){
            ContestService.getActiveMultiContest(setupContest);
        }

        $scope.dldAnimation = $sce.trustAsResourceUrl(Config.value('dld-animation'));

        $scope.setFlags = function(data) {
            if(data && data.itemsExist) {
                $scope.showResults = true;
            } else {
                $scope.showNoResults = true;
            }
        };

        // call Game item
        $scope.game = Item.get({
            ID: gameId
        });

        var MFPIntent = function(storeUrl, opts){ // make it a utility method if we want intent on header banner as well
            var dldButton, 
                dldHiddenButton;
            if (Config.value('DOWNLOAD_NATIVEAPP_ON_APK_DLD') && $scope.game.format === 'androidapplications' && opts){ //zozzeria per vodafone qatar
                dldButton = opts ? opts.dldButton : document.querySelector('#getContentBtn');
                dldHiddenButton = opts ? opts.dldHiddenButton : document.querySelector('#invisibleDownloadButton_extZoom');
                // eslint-disable-next-line no-script-url
                dldHiddenButton.setAttribute('href', 'javascript:window.location.href=\'' + storeUrl + '\'; 0;');
            } else {
                dldButton = document.querySelector('#native_intent_ext');
                dldHiddenButton = document.querySelector('#invisibleDownloadButton_ext');
                if (dldHiddenButton && dldButton){
                    dldButton.addEventListener('click', function(evt){
                        evt.preventDefault();
                        // eslint-disable-next-line no-script-url
                        dldHiddenButton.setAttribute('href', 'javascript:window.location.href=\'' + storeUrl + '\'; 0;');
                        dldHiddenButton.click(evt);
                        $scope.$emit('hideZoomBanner');
                        if(JsStorage.isLocalStorageSupported()) {
                            JsStorage.set('install_clicked', 1, {
                                type: 'localstorage',
                                path: '/'
                            });
                        }
                    });
                }
            }
        };

        var MFPZoomIntent = function(storeUrl, opts){ // ugly workaround for vodafone qatar request
            MFPIntent(storeUrl, opts);
        };

        $scope.$on('hideZoomBanner', function(){
            $scope.showextendedbanner = false;
            $scope.getGameHtml5 = true;
            $scope.showBanner = false;
            $rootScope.showBeforePlay = false;
            $rootScope.showIntentBtn = false;
            $scope.$apply();
        });

        $scope.MFPoptions = {
            gameId: gameId,
            goFunction: MFPIntent
        };

        var canAccess = false;
        var userType = 'guest';
        var gameType = '';

        $rootScope.scrollBg = true;
        $scope.incompatible = false;
        $scope.showDldTip = false;
        $scope.moreHidden = true;
        $scope.dldError = false;
        $scope.size = 10;
        $scope.offset = 0;
        $scope.groupBy = 2;
        $scope.storeUrl = false;
        $scope.showsignin = false;
        $scope.ctaBtnLabel = '';
        $scope.$on('showsignin', function(){
            $scope.showsignin = true;
        });
        $scope.getItemsNumber = Utils.getItemsNumber;
        $scope.goTo = Utils.goTo;
        $scope.setDir = Utils.setTextDirection;
        $scope.descMipQA = 'content-text-zoom';
        $scope.toggleDescription = function(){
            $scope.moreHidden = !$scope.moreHidden;
            $scope.descMipQA = $scope.moreHidden ? 'content-text-zoom' : 'content-text-zoom-full';
            var props = {
                category: 'Behavior',
                action: 'read_more_click',
                page_name: $state.current.name,
                page_url: $location.absUrl(),
                content_id: gameId,
                game_title: $scope.game.default_title || $scope.game.title,
                label: $location.absUrl(),
                valuable_cd: 'No',
                action_cd: 'No'
            };
            Analytics.eventTrack(props);
            NewtonAdapter.trackEvent({
                name: props.action,
                properties: props
            });
        };

        var otherGames = Config.value('ZOOM_OTHER_LIST_TYPE') ? 'boxed' : 'small';
        $scope.otherGamesSize = otherGames === 'boxed' ? 2 : 4;//Utils.getItemsNumber(otherGames);
        $scope.nextList = function(data) {
            if (data && data.itemsExist){
                $scope.gameCat = $scope.game && $scope.game.category ? $scope.game.category.id_category : '';
                Item.getList({
                    SIZE: 20,
                    CATEGORY: $stateParams.gameCategory ? $stateParams.gameCategory : $scope.gameCat
                }).$promise.then(function(categoryItems) {
                    categoryItems = $rootScope.shuffle ? Utils.shuffleArray(categoryItems) : categoryItems;
                    $scope.categoryZoomList = Utils.avoidDuplicateItems(categoryItems, gameId, $scope.otherGamesSize, '[data-mipqa="zoom-related"] [data-gameid]');
                    if (!$scope.categoryZoomList.length){
                        Item.getList({
                            SIZE: 20
                        }).$promise.then(function(altCategoryItems) {
                            altCategoryItems = $rootScope.shuffle ? Utils.shuffleArray(altCategoryItems) : altCategoryItems;
                            $scope.categoryZoomList = Utils.avoidDuplicateItems(altCategoryItems, gameId, $scope.otherGamesSize, '[data-mipqa="zoom-related"] [data-gameid]');
                        });
                    }
                });
            } else {
                Item.getList({
                    SIZE: 20
                }).$promise.then(function(categoryItems) {
                    categoryItems = $rootScope.shuffle ? Utils.shuffleArray(categoryItems) : categoryItems;
                    $scope.categoryZoomList = Utils.avoidDuplicateItems(categoryItems, gameId, $scope.otherGamesSize, '[data-mipqa="zoom-related"] [data-gameid]');
                });
            }
        };

        Item.relatedList({
            SIZE: 1,
            OFFSET: 0,
            ID: gameId
        }).$promise.then(function(tmpItems) {
            $scope.relitems = tmpItems;
        });

        $scope.imgRatioRelated = Utils.getRatioConf('zoomRelated', 'ratio_1_4');
        $scope.currentIndex = false;

        if (Config.value('USE_SCREENSHOT_SLIDER')){
            $scope.screenshotSlider = new Glide('.screenshotSlider', {
                type: 'slider',
                startAt: 0,
                focusAt: 0,
                bound: true,
                gap: 16,
                peek: { before: 0, after: 90 },
                direction: $rootScope.RTLlang ? 'rtl' : 'ltr',
                breakpoints: {
                    4000: { perView: 4 },
                    1050: { perView: 4 },
                    780: { perView: 3 },
                    600: { perView: 2 },
                    450: { perView: 1 },
                    350: { perView: 1 }
                }
            });
        }

        $scope.showScreenshots = debounce(300, function(images, i){

            $scope.selected = '';
            if (i < 0){
                i = images.length - 1;
            } else if (i >= images.length) {
                i = 0;
            }
            if ($scope.deviceType === 'phone' && images[i]){
                $scope.selected = images[i];
                $scope.currentIndex = i;
                $scope.showShot = true;
                var prop = {
                    'action': 'Screenshot-view',
                    'category': 'Behavior',
                    'label': gameId,
                    'game_title': $scope.game.default_title || $scope.game.title,
                    'valuable_cd': 'No',
                    'action_cd': 'No'
                };
                Analytics.eventTrack(prop);
                NewtonAdapter.trackEvent({
                    name: prop.action,
                    properties: prop
                });
            }
        });

        $scope.randomItem = function(){
            var prop;
            var rndGame;
            Item.getRandom({
                OFFSET: Utils.getRandomInt(0, 60) //SIZE: 2 in item.ser
            }).$promise.then(function(data){
                if (data[0]){
                    rndGame = data[0];
                    if (data && data[0] && data[0].id === gameId && data[1]){
                        rndGame = data[1];
                        prop = {
                            'action': 'RandomGame',
                            'category': 'Behavior',
                            'label': rndGame.id + '',
                            'game_title': rndGame.default_title || rndGame.title,
                            'valuable_cd': 'No',
                            'action_cd': 'No'
                        };
                        Analytics.eventTrack(prop);
                        NewtonAdapter.trackEvent({
                            name: prop.action,
                            properties: prop
                        });
                    }
                    Utils.openZoom(rndGame);
                } else {
                    Item.getRandom({
                        OFFSET: Utils.getRandomInt(0, 10) //SIZE: 2 in item.ser
                    }).$promise.then(function(datafallback){
                        rndGame = datafallback[0];
                        if (datafallback && datafallback[0] && datafallback[0].id === gameId && datafallback[1]){
                            rndGame = datafallback[1];
                            prop = {
                                'action': 'RandomGame',
                                'category': 'Behavior',
                                'label': rndGame.id + '',
                                'game_title': rndGame.default_title || rndGame.title,
                                'valuable_cd': 'No',
                                'action_cd': 'No'
                            };
                            Analytics.eventTrack(prop);
                            NewtonAdapter.trackEvent({
                                name: prop.action,
                                properties: prop
                            });
                        }
                        Utils.openZoom(rndGame);
                    });
                }
            });
        };

        var getImgOrientation = function(image){
            var orientation = 'vertical';
            var img = new Image();
            img.src = image;
            img.onload = function() {
                if (this.naturalWidth > this.naturalHeight){
                    orientation = 'horizontal';
                }
            };
            return orientation;
        };

        var checkFavs = function(){
            if (Config.value('ENABLE_FAVORITES') && !Config.value('NO_FAVS_IN_ZOOM')){
                User.getStatus(function(user) {
                    if(user.logged) {
                        $scope.favorites = true;
                        $scope.$on('favoritesFull', function(){
                            $scope.favoritesList = true;
                        });
                        $scope.$on('noFavorites', function(){
                            $scope.favoritesList = false;
                        });
                    }
                });
            }
        };
        $rootScope.$on('favs-add', function(event, opt){ //chiude screenshots
            if ($scope.showShot) { $scope.showShot = false; }
        });

        $rootScope.$on('dld-error', function(){
            $scope.dldError = true;
        });
        $rootScope.$on('dld-errorfalse', function(){
            $scope.dldError = false;
        });
        $rootScope.$on('dld-tip-show', function(){
            $scope.showDldTip = true;
        });
        $rootScope.$on('dld-tip-hide', function(){
            $timeout(function(){
                $scope.showDldTip = false;
            });
        });

        $rootScope.$on('favs-remove', function(event, opt){
            if ($scope.showShot) { $scope.showShot = false; }
            var removed = document.querySelector('.favorites [data-gameid="' + opt.item + '"]');
            if (removed){
                var removedCont = document.querySelector('.favorites .listGame');
                removedCont.removeChild(removed);
            }//add method to eliminate container if no more favorites.
        });

        // toggle description
        $scope.flagInfo = false;
        $scope.showInfo = function() {
            $scope.flagInfo = !$scope.flagInfo;
        };

        // play game
        $scope.getGame = function(e){
            
            if ($rootScope.showBeforePlay && $scope.game.format !== 'androidapplications'){ //if condition for native install && for big native install
                $scope.goNative();
            } else {
                $scope.gamePlay(e);
            }
        };

        $scope.goNative = function(){
            if (Config.value('SHOW_NATIVE_INSTALL_EXTENDED') && !JsStorage.get('closeInstall_session', { type: 'cookie' })){
                $scope.$broadcast('showZoomBanner');
                $scope.getGameHtml5 = true;
                $scope.showextendedbanner = true;
            }
        };

        $scope.$on('continueOnWeb', function(){
            $scope.showextendedbanner = false;
            $scope.getGameHtml5 = true;
            $scope.showBanner = false;
            $rootScope.showBeforePlay = false;
            $scope.gamePlay(false);
        });

        var directNativeDld = function(format){
            if (Config.value('DOWNLOAD_NATIVEAPP_ON_APK_DLD') && format === 'androidapplications'){ 
                User.getStatus(function(user) {
                    if(user.logged) {
                        var MFPoptions = {
                            gameId: gameId,
                            goFunction: MFPZoomIntent,
                            dldButton: document.querySelector('#getContentBtn'),
                            dldHiddenButton: document.querySelector('#invisibleDownloadButton_extZoom')
                        };
                        MFP.mfpSetAndGo(false, MFPoptions);
                    }
                });
            }
        };

        $scope.gamePlay = function(e) {
            if ($scope.showShot) { $scope.showShot = false; }
            if (!document.querySelector('.browser-info svg')){
                SVGInjector.SVGInjector(document.querySelectorAll('.inject-me'));
            }
            
            if (Config.value('DOWNLOAD_NATIVEAPP_ON_APK_DLD') && $scope.game.format === 'androidapplications'){ 

                User.getStatus(function(user) {
                    if (document.querySelector('#invisibleDownloadButton_extZoom') && user.logged){
                        document.querySelector('#invisibleDownloadButton_extZoom').click();
                    } else {
                        Utils.gamePlay({ gameObj: $scope.game, isZoom: true, cta: document.querySelector('#getContentBtn'), User: User, Ranking: Ranking, MFP: MFP }, e);
                    }
                });
            } else {
                Utils.gamePlay({ gameObj: $scope.game, isZoom: true, cta: document.querySelector('#getContentBtn'), User: User, Ranking: Ranking, MFP: MFP }, e);
            }
        };

        $scope.game.$promise.then(function(result) {
            if(result) {
                Meta.setTwitterTitle(result.title);
                Meta.setTitle(result.title + ' ' + Dictionary.value('SEO_WEBAPP_TITLE_COUNTRY'), function(){
                    $rootScope.$emit('pageview-' + $rootScope.currentRoute);
                });
                Meta.setDescription(result.description);
                Meta.setUrl();
                Meta.setImage(imageSizeFilter(result.images.cover.ratio_2, 1200, 600));
                Meta.setJsonLd({
                    '@context': 'https://schema.org',
                    '@type': Dictionary.value('SEO_WEBAPP_JSONLD_TYPE'),
                    name: result.title,
                    url: $window.location.href,
                    image: result.images.cover.ratio_1_4,
                    description: result.description,
                    inLanguage: [Config.value('REAL_COUNTRY')],
                    aggregateRating: {
                        '@type': 'AggregateRating',
                        ratingValue: Dictionary.value('SEO_WEBAPP_RATING_VALUE'),
                        ratingCount: (Math.random() * 10000).toFixed(0) // - reviewCount speak with gianfra
                    },
                    author: {
                        '@type': 'Organization',
                        name: result.publisher.title_publisher,
                        url: result.publisher.url_publisher
                    },
                    publisher: result.publisher.title_publisher,
                    genre: [result.category.name_category],
                    memoryRequirements: result.size,
                    storageRequirements: result.size,
                    gamePlatform: [Dictionary.value('SEO_WEBAPP_GAME_PLATFORM')],
                    operatingSystem: Dictionary.value('SEO_WEBAPP_OPERATING_SYSTEM')
                });

                directNativeDld(result.format);

                if (Config.value('GAME_FORMAT_ICONS')){
                    var apkicon = Config.value('apk_long_dark');
                    var html5icon = Config.value('html5_long_dark');
                    $scope.btnFormat = Utils.setGameFormatBtn(result.format, apkicon, html5icon);
                }
                $rootScope.headerData = {
                    customHeaderTitle: ''//because we have it below
                };
                $scope.gameDesc = $sce.trustAsHtml(result.description);
                $scope.pegiAge = result.classification && result.classification.age ? result.classification.age : 0;
                gameType = Utils.getSingleGameAccess(result.access_type);
                Ranking.set({ section: 'Page', name: $rootScope.currentRoute, contentId: $scope.game.id + '', scope: 'consumption' });

                $scope.gameImages = [];
                $scope.coverImage = [];

                var coverRatioFromConf = Utils.getRatioConf('gamezoom_cover', 'ratio_1');

                $scope.coverRatio = (window.matchMedia('(min-width: 768px)').matches) ? 'ratio_2' : coverRatioFromConf;

                var gameCoverData = {
                    img: $scope.game.images.cover[$scope.coverRatio],
                    hSize: Utils.getBiggerWinSize(1280),
                    vSize: 0
                };
                var gameScreenshotsData = {
                    img: $scope.game.images.screenshot,
                    hSize: (window.matchMedia('(min-width: 768px)').matches) ? 500 : 300,
                    vSize: 0
                };

                var coverLoader = {
                    img: $scope.game.images.cover[$scope.coverRatio],
                    hSize: 4,
                    vSize: 0
                };

                $scope.coverLoader = ImageSize.replace(coverLoader.img, coverLoader.hSize, coverLoader.vSize);

                $scope.coverImage.push(ImageSize.replace(gameCoverData.img, gameCoverData.hSize, gameCoverData.vSize));
                angular.forEach(gameScreenshotsData.img, function(value, key) {
                    if(value) {
                        $scope.gameImages.push(ImageSize.replace(value, gameScreenshotsData.hSize, gameScreenshotsData.vSize));
                    }
                });

                $scope.orientation = getImgOrientation($scope.gameImages[0]);

                if ($scope.gameImages.length && Config.value('USE_SCREENSHOT_SLIDER')){
                    setTimeout(function(){
                        $scope.screenshotSlider.mount();
                    }, 250);
                }

                if (result.format === 'androidapplications'){
                    if(!result.compatibility){
                        $scope.incompatible = true;
                    }
                }
                SVGInjector.SVGInjector(document.querySelectorAll('.inject-me'));
                $scope.ctaBtnLabel = Utils.setBtnLabel(result.format);
                if($scope.game.format === 'androidapplications') {
                    $scope.gamePackage = true;
                    if($rootScope.selector !== 'android') {
                        $scope.fromSitemap = true;
                    }
                }

                //$rootScope.titlePage = result.title + ' ' + Dictionary.value('SEO_WEBAPP_TITLE_COUNTRY');
                $scope.$watch('meta.title', function (newValue, oldValue) {
                    GoogleManager.set({
                        'Tipo de pagina': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_CONTENT'),
                        'Tipo de pagina /h': Dictionary.value('WEBAPP_NAVIGATION_SERVICE_CONTENT_H'),
                        'Contenido': result.title,
                        'Contenido /h': result.title,
                        'event': 'changePage'
                    });
                });
                User.getStatus(function(user) {
                    userType = User.getUserType(user);
                    canAccess = User.getGameAccess(result, userType);
                    $scope.canAccess = canAccess;
                });

                if((Config.value('ENABLE_CONTEST') && !$scope.isContestGame) && (Config.value('SHOW_LEADERBOARD') && (Config.value('LEADERBOARD_ALLOWED_GAMES') && $scope.game.game_type === Config.value('LEADERBOARD_ALLOWED_GAMES')))) {
                    Leaderboard.getUsrTopPositions({
                        limit: 5,
                        content_id: gameId
                    }).$promise.then(function(data) {
                        if(data) {
                            $scope.gameLdb = data;
                            $scope.showLDB = true;
                        }
                    });
                }

                if (Config.value('AUTODOWNLOAD_AFTER_SUB') && Config.value('AUTODOWNLOAD_PARAMS')){
                    var cookieCat = $rootScope.cookieCat ? $rootScope.cookieCat : false;
                    //refactor with EventBus!!!
                    $rootScope.$on('less-loaded', function() {
                        //start apk auto dld
                        //if all required params are found in querystring/cookie
                        //and the user is entitled to the apk content
                        if (cookieCat){
                            var subParams = Config.value('AUTODOWNLOAD_PARAMS'),
                                dldAllowed = 0;

                            angular.forEach(subParams, function (value, index) {
                                if (cookieCat[value]){
                                    dldAllowed++;
                                } else {
                                    dldAllowed = 0;
                                }
                            });

                            //dldAllowed = !!subParams.length;
                            if (canAccess && !$scope.incompatible && ($scope.game.format === 'androidapplications') && (dldAllowed === subParams.length || (Config.value('USERCHECK_ALWAYS_CALLED') && $rootScope.cookieCat.b_justlogged))){
                                $scope.gamePlay(false);
                                cookieCat = '';
                                $rootScope.cookieCat = '';
                            }
                        }
                    });
                }
            }
        });

        angular.element(window).bind('resize', function() {
            if ($scope.coverRatio && $scope.coverRatio === 'ratio_1'){
                $scope.coverImgH = (window.matchMedia('(min-width: 768px)').matches) ? 384 : window.innerWidth;
            } else {
                $scope.coverImgH = '';
            }
        });

        $document.ready(function() {
            checkFavs();
            $rootScope.$broadcast('less-loaded');
        });

        $scope.$on('$destroy', function() {
            Utils.updateCSSprops('--game-zoom-cover-bg', 'black');
        });

    }]);

angular.module('html5Game').controller('SettingZoomCtr', 
    ['$scope', 'Params', 'Settings', 'User', 'Config', '$state', '$location', 'Analytics', '$stateParams', function ($scope, Params, Settings, User, Config, $state, $location, Analytics, $stateParams) {
        $scope.showUnsubConfirm = false;
        User.getStatus(function(user){
            if (user.logged && user.subscribed) {
                if (Config.value('ENABLE_NEWTON_USER')){
                    Params.t = user.subscriptiontime || '';
                } else {
                    Params.t = user.data_iscr_utc || '';
                }
                if (Config.value('SHOW_UNSUB_CONFIRM') && Config.value('SHOW_UNSUB_CONFIRM').indexOf(user.operator) > -1){
                    $scope.showUnsubConfirm = true;
                }
            }
        }); 

        $scope.backToAccount = function(){
            var props = {
                category: 'Behavior',
                action: 'doc_back_click',
                page_name: Params.CONTENT_ID ? Params.CONTENT_ID : Params.SUBSECTION,
                page_url: $location.absUrl(),
                label: $location.absUrl(),
                valuable_cd: 'No',
                action_cd: 'No'
            };
            Analytics.eventTrack(props);
            NewtonAdapter.trackEvent({
                name: props.action,
                properties: props
            });
            $state.go('settings');
        };
        //document.querySelector('html').classList.add('loadingRequest');
        Settings.get(Params, function(response){
            $scope.content = response.content;
            $scope.text = response.content;
        });

    }]);

angular.module('html5Game').controller('SettingZoom30Ctr', [
    '$q', '$scope', '$state', '$sce', '$location', 'Dictionary', 'Settings', 'User', 'Config', 'Analytics', '$stateParams', '$rootScope', 
    function($q, $scope, $state, $sce, $location, Dictionary, Settings, User, Config, Analytics, $stateParams, $rootScope){

        /*******************
        ***  INIT VARS   ***
        *******************/

        if ($state.current.data && $state.current.data.customHeader){
            $rootScope.headerData = { customHeaderTitle: Dictionary.value('WEBAPP_TITLE_ACCOUNT') };
        }

        $scope.backToAccount = function(){
            var props = {
                category: 'Behavior',
                action: 'doc_back_click',
                page_name: $state.current.name,
                page_url: $location.absUrl(),
                label: $location.absUrl(),
                valuable_cd: 'No',
                action_cd: 'No'
            };
            Analytics.eventTrack(props);
            NewtonAdapter.trackEvent({
                name: props.action,
                properties: props
            });
            $state.go('settings');
        };
 
        $scope.showFooter = true;
        var subsectionParam = 'smartstatus';
        var contentidParam = '';
        var settingsDefer = $q.defer();

        var settingsParams = {
            SUBSECTION: 'smartstatus',
            CONTENT_ID: '',
            HYBRID: 0,
            STORETYPE: 0
        };

        $scope.status = true;

/*         if($stateParams.SUBSECTION){
            subsectionParam = $stateParams.SUBSECTION;
        } else if($stateParams.subsection){
            subsectionParam = $stateParams.subsection;
        }

        if($stateParams.CONTENT_ID){
            contentidParam = $stateParams.CONTENT_ID;
        } else if($stateParams.contentid){
            contentidParam = $stateParams.contentid;
        } */

        settingsParams.SUBSECTION = subsectionParam;
        settingsParams.CONTENT_ID = contentidParam;
        settingsDefer.resolve(settingsParams);
      

        /*******************
        ***  API CALLS   ***
        *******************/

        settingsDefer.promise.then(function(promiseResp){
            Settings.get(promiseResp, function(resp){
                $scope.text = $sce.trustAsHtml(resp.content);

                if(Config.value('ENABLE_NEWTON_USER')){
                    useris.smartstatus({
                        element: false,
                        access_token: NewtonAdapter.isUserLogged() ? NewtonAdapter.getUserToken() : '',
                        doNotLoad: true                                
                    }, {

                        onUnsubLoggedSuccess: function(params){
                            
                            unsubscriptionFlow(params);
                        }, 
                        onUnsubLoggedError: function(err){
                            console.log(err);
                        }, 
                        onUnsubUnloggedSuccess: function(params){
                            if (params.TYPE === 'msisdn' && Config.value('INTERNATIONAL_PREFIX')) {
                                if (params.IDENTITY.indexOf(Config.value('INTERNATIONAL_PREFIX')) !== 0 && params.IDENTITY.match(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))) {
                                    params.IDENTITY = Config.value('INTERNATIONAL_PREFIX') + params.IDENTITY.match(Config.value('COUNTRY_REGEXP_VALIDATE_PLATINUM_MSISDN'))[1];
                                    console.log('MSISDN optimized with ' + Config.value('INTERNATIONAL_PREFIX') + ' ', params.IDENTITY);
                                }
                            }
                            unsubscriptionFlow(params);
                            
                        },
                        onUnsubUnloggedError: function(err){
                            console.log(err);
                        }
                    });
                }
            });
        });

        var unsubscriptionFlow = function(params){
            var redirectUrl = false;
        
            User.unsubscribe(params, function(unsubResp){
                if(unsubResp){

                    if(Config.value('DISABLE_USERFEEDBACK_POPUP') !== true){
                        useris.PopupManager.showUserFeedback({
                            type: 'positive',
                            feedback: {
                                message: Dictionary.value('WEBAPP_UO30_FEEDBACK_SUBS_DELETED')
                            }
                        });
                    }

                    if(unsubResp.config_key){
                        redirectUrl = Config.value(unsubResp.config_key);
                    } else if(unsubResp.url){
                        redirectUrl = unsubResp.url;
                    }

                    switch(unsubResp.status){

                    case 302:
                        if(unsubResp.unsubscribed){
                            NewtonAdapter.logout().then(function(logoutResp){
                                window.location.href = redirectUrl;
                            });
                        } else {
                            window.location.href = redirectUrl;
                        }

                        break;

                    case 200:
                        $scope.DictionaryKey = Dictionary.value(unsubResp.Dictionary_key);
                        break;

                    default: 
                        $scope.DictionaryKey = Dictionary.value(unsubResp.Dictionary_key);                
                    }
                } else {
                    $location.path(Config.value('ROUTER_ERROR'));
                }
            });
        };
    }
]);

angular.module('html5Game').controller('WallPageCtr', ['$rootScope', '$scope', 'User', 'Utils', '$stateParams', 'Config', '$window', '$state',
    function($rootScope, $scope, User, Utils, $stateParams, Config, $window, $state) {
        if ($stateParams.game && !Config.value('PROFILE_FBCONNECT_SHOW')){
            $window.location.href = $stateParams.game.url_leaf_engine_subscription;
        } else if ($stateParams.game) {
            $scope.returl = $stateParams.returl;
            $scope.game = $stateParams.game; 
        } else {
            $state.go('home', {}, {
                reload: true
            });
        }
    }
]);

angular.module('html5Game').controller('UnsubPageCtr', [
    '$scope', '$state', 'Config', '$rootScope',  
    function($scope, $state, Config, $rootScope){
        if ($state.current.data && $state.current.data.customHeader){
            $rootScope.headerData = { customHeaderTitle: Dictionary.value('WEBAPP_TITLE_ACCOUNT') };
        }
        var ms = Config.value('MILLISECS_TO_REDIRECT_AFTER_UNSUB') || 5000;
        if (Config.value('REDIRECT_AFTER_UNSUBSCRIBE')){
            setTimeout(function(){
                $state.go('home');
            }, ms);
        }
        
    }
]);

angular.module("html5Game").run(["$templateCache", function($templateCache) {$templateCache.put("/js/wl/webstore_gameasy/app/cloudfiles/list_item.html","<div itemtype=\"http://schema.org/VideoGame\" class=\"list-item\" callbackitems=\"callbackitems\" ng-repeat=\"item in items track by $index\" ng-if=\"(game)\" data-gameid=\"{{item.id}}\" data-mipqa=\"list-item\" data-format=\"{{item.format}}\"><figure><a data-mipqa=\"{{config.img.directplay ? \'clickitem-gameplay\' : \'clickitem\'}}\" ng-click=\"imgCallback()\" title=\"{{item.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" class=\"list-cover {{item.format}}\"><img alt=\"{{item.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" lazy-img=\"{{item.images.cover[imgRatio] | imageSize:imgWSize:imgHSize}}\" class=\"b-lazy img-responsive {{lazyClass}}\" ng-src=\"{{item.images.cover[imgRatio] | imageSize:4:0}}\"></a></figure><figcaption ng-if=\"config.figcaption.visible\" data-mipqa=\"{{config.figcaption.directplay ? \'clickitem-gameplay\' : \'clickitem\'}}\" ng-click=\"itemPlay(game,true, $index+1, \'general\')\"><p class=\"item-publisher\" dir=\"{{setDir(item.publisher.title_publisher)}}\" ng-if=\"config.publisher.visible\"><span>{{item.publisher.title_publisher}}</span></p><p class=\"item-title\" dir=\"{{setDir(item.title)}}\" ng-if=\"config.title.visible\"><span>{{item.title}}</span></p><p class=\"item-abstract\" dir=\"{{setDir(item.description_short)}}\" ng-if=\"config.abstract.visible\"><span>{{item.description_short}}</span></p></figcaption><button ng-if=\"config.cta.visible\" type=\"button\" data-mipqa=\"{{config.cta.directplay ? \'clickitem-gameplay\' : \'clickitem\'}}\" class=\"btn play {{item.format}}\" ng-click=\"\" title=\"{{item.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" dir=\"{{setDir(setBtnLabel(item.format, config.cta.dict))}}\">{{setBtnLabel(item.format, config.cta.dict)}}</button></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/account.ctr.html","<div ng-controller=\"AccountCtr\" ng-class=\"{\'account-logged\':userData.logged}\" data-mipqa=\"account-page\"><div ng-include=\"profileTmpl\" ng-if=\"!uo30\"></div><div class=\"clear-both\" ng-include=\"settingsTmpl\"></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/accountCreation.ctr.html","<div><div id=\"blackboard\"></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/changePassword.ctr.html","<div><div class=\"center-block\" ng-hide=\"showSuccessKey\"><p class=\"general-margin-t\"><dictionary key=\"\'WEBAPP_CHANGEPASSWORD_MESSAGE\'\"></dictionary></p><div id=\"blackboard\"></div></div><div class=\"center-block\" ng-show=\"showSuccessKey\"><p class=\"general-margin-t\"><dictionary key=\"\'WEBAPP_CHANGEPASSWORD_SUCCESS\'\"></dictionary></p><span class=\"btn btn__general btn--read\"><a href=\"#!/\"><dictionary key=\"\'WEBAPP_GO_HOME\'\"></dictionary></a></span></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/confirmMail.ctr.html","<div><p>Placeholder for confirmMail U30</p></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/errorPage.ctr.html","<div class=\"text-center error-container\"><h3 class=\"general-padding\"><dictionary key=\"\'ERROR_\' + errorCode + \'_DESCRIPTION\'\"></dictionary></h3><h4 class=\"general-padding\"><a href=\"/#!/\" class=\"btn\"><dictionary key=\"\'WEBAPP_GO_TO_HOME\'\"></dictionary></a></h4></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/forgot30.ctr.html","<div><div id=\"blackboard\"></div><div class=\"center-block general-padding\" ng-show=\"showForgotKey\"><p class=\"general-padding-t-b\"><dictionary key=\"\'WEBAPP_SEND_EMAIL_SUCCESS\'\"></dictionary></p><a class=\"btn btn__general center-block btn--forgot\" href=\"#!/\"><span><dictionary key=\"\'MIPCONNECT_LABEL_BACK_TO_SITE\'\"></dictionary></span></a></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/login30.ctr.html","<div><div id=\"blackboard\"></div><div class=\"center-block general-padding\" ng-if=\"(\'LINK_IN_LOGIN\' | config)\"><a class=\"btn center-block btn--forgot\" ng-href=\"{{(\'LINK_IN_LOGIN\' | config)}}\"><dictionary key=\"\'WEBAPP_LINK_IN_LOGIN_TEXT\'\"></dictionary></a></div><div class=\"center-block general-padding\" ng-if=\"(\'SHOW_SUBSCRIBE_LINK_LOGIN_CUSTOM\' | config)\"><p><dictionary key=\"\'WEBAPP_LOGIN_SUBSCRIBE_TEXT\'\"></dictionary><a class=\"btn center-block btn--forgot\" ng-href=\"{{subscribeLinkHref}}\"><dictionary key=\"\'WEBAPP_LOGIN_SUBSCRIBE_LINK_TEXT\'\"></dictionary></a></p></div><div class=\"center-block general-padding\" ng-show=\"showLoggedKey\"><div class=\"center-block general-padding\"><h3><dictionary key=\"\'MIPCONNECT_ALREADY_SUBSCRIBE\'\"></dictionary></h3><a class=\"btn play center-block btn--forgot\" ng-href=\"{{returnUrl}}\"><dictionary key=\"\'MIPCONNECT_LABEL_BACK_TO_SITE\'\"></dictionary></a></div><p class=\"center-block general-padding\"><dictionary key=\"\'MIPCONNECT_FB_OR\'\"></dictionary></p><div><button class=\"btn link center-block logout\" type=\"button\" id=\"logout\" ng-click=\"logout()\"><dictionary key=\"\'MIPCONNECT_LBL_LOGOUT\'\"></dictionary></button></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/loginOtp.html","<div class=\"otp-login\"><div id=\"blackboard\"><div class=\"account30 container\" data-mipqa=\"login-page\"><div id=\"smartlogin-container\" class=\"form\"><form id=\"frmforgot\" name=\"frmforgot\" class=\"form\" autocomplete=\"off\"><div id=\"errormsg\" ng-if=\"!(\'INLINE_USERIS\' | config)\" class=\"form__message useris-error-msg\" data-mipqa=\"error-inpage-message\" style=\"display:none\"><div class=\"form__line\"><span class=\"icon icon-allert\"></span><div class=\"message\"><dictionary key=\"\'WEBAPP_UO30_ERROR_WRONG_USERDATA\'\"></dictionary></div></div></div><div id=\"useris-error-newton-error\" ng-if=\"!(\'INLINE_USERIS\' | config)\" class=\"form__message useris-error-newton-error\" data-mipqa=\"error-inpage-message\" style=\"display:none\"><div class=\"form__line\"><span class=\"icon icon-allert\"></span><div class=\"message\"><dictionary key=\"\'WEBAPP_UO30_ERROR_NEWTON_GENERIC\'\"></dictionary></div></div></div><input type=\"hidden\" name=\"action\" value=\"sendPassword\"> <input type=\"hidden\" name=\"password_requested\" value=\"1\"><div class=\"form__line\" id=\"msisdnBox\" ng-show=\"stepPhoneActive\"><h2 data-mipqa=\"page-titol\"><dictionary key=\"\'WEBAPP_UO30_OTP_FORGOT_INSERT_NUMBER\'\"></dictionary></h2><user-feedback ng-if=\"(\'INLINE_USERIS\' | config)\"></user-feedback><label for=\"phone_number\" class=\"flying_label\"><input type=\"text\" id=\"phone_number\" ng-model=\"otpModel.msisdn\" name=\"phone_number\" autocomplete=\"off\" required data-mipqa=\"msisdn-email-form\" inputmode=\"tel\" ng-change=\"setPhoneField($event)\"><dictionary key=\"\'WEBAPP_UO30_LOGIN_INSERT_USER\'\"></dictionary></label><div class=\"form__control\"><button id=\"forgotbutton\" class=\"btn-success\" data-doform=\"1\" type=\"button\" ng-disabled=\"frmforgot.phone_number.$invalid\" data-mipqa=\"forgot-confirm-button\" ng-click=\"doForgot()\"><dictionary key=\"\'WEBAPP_UO30_FORGOT_GET_PASSWORD\'\"></dictionary></button><p class=\"more-actions\"><a href=\"{{subscribeUrl}}\"><dictionary key=\"\'WEBAPP_UO30_SUBSCRIBE\'\"></dictionary></a></p></div></div><input type=\"hidden\" id=\"passw\" name=\"password\" required> <input type=\"hidden\" id=\"username\" name=\"username\"><div class=\"form__line\" id=\"otpBox\" ng-show=\"stepOTPActive\"><h2 data-mipqa=\"page-titol\"><dictionary key=\"\'WEBAPP_UO30_OTP_LOGIN_INSERT_PIN\'\"></dictionary></h2><input ng-repeat=\"otp in OTParray track by $index\" maxlength=\"1\" class=\"login-input login-input-otp\" id=\"{{\'passw_\'+($index + 1) }}\" type=\"text\" required inputmode=\"numeric\" size=\"1\" pattern=\"[0-9]\" tabindex=\"{{$index + 1}}\" ng-model=\"otpModel.passw_[$index]\" name=\"{{\'passw_\'+($index + 1) }}\" value=\"\" data-mipqa=\"pin-psw-form\" autocomplete=\"off\"><div class=\"form__control\"><button id=\"frmbutton\" class=\"btn-success\" data-doform=\"1\" ng-disabled=\"frmforgot.passw_1.$invalid || frmforgot.passw_2.$invalid || frmforgot.passw_3.$invalid || frmforgot.passw_4.$invalid || frmforgot.passw_5.$invalid || frmforgot.passw_6.$invalid\" value=\"\" data-mipqa=\"confirm-button\" type=\"button\" ng-click=\"doLogin($event)\"><dictionary key=\"\'WEBAPP_UO30_LOGIN_CONFIRM\'\"></dictionary></button><p class=\"more-actions\"><button type=\"button\" id=\"forgotbutton_resend\" ng-click=\"resendPIN()\" class=\"link-button\"><dictionary key=\"\'WEBAPP_UO30_RESEND\'\"></dictionary></button><button type=\"button\" id=\"backToMsisdn\" class=\"link-button\" ng-click=\"goBack()\"><dictionary key=\"\'WEBAPP_UO30_BACK_TO_FORM\'\"></dictionary></button></p></div></div></form></div></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/loginOtpTelcel.html","<div class=\"otp-login\"><div id=\"blackboard\"><div class=\"account30 container\" data-mipqa=\"login-page\"><div id=\"smartlogin-container\" class=\"form\"><form id=\"frmforgot\" name=\"frmforgot\" class=\"form\" autocomplete=\"off\"><div id=\"errormsg\" ng-if=\"!(\'INLINE_USERIS\' | config)\" class=\"form__message useris-error-msg\" data-mipqa=\"error-inpage-message\" style=\"display:none\"><div class=\"form__line\"><span class=\"icon icon-allert\"></span><div class=\"message\"><dictionary key=\"\'WEBAPP_UO30_ERROR_WRONG_USERDATA\'\"></dictionary></div></div></div><div id=\"useris-error-newton-error\" ng-if=\"!(\'INLINE_USERIS\' | config)\" class=\"form__message useris-error-newton-error\" data-mipqa=\"error-inpage-message\" style=\"display:none\"><div class=\"form__line\"><span class=\"icon icon-allert\"></span><div class=\"message\"><dictionary key=\"\'WEBAPP_UO30_ERROR_NEWTON_GENERIC\'\"></dictionary></div></div></div><input type=\"hidden\" name=\"action\" value=\"sendPassword\"> <input type=\"hidden\" name=\"password_requested\" value=\"1\"><div class=\"form__line\" id=\"msisdnBox\" ng-show=\"stepPhoneActive\"><h2 data-mipqa=\"page-titol\"><dictionary key=\"\'WEBAPP_UO30_OTP_FORGOT_INSERT_NUMBER\'\"></dictionary></h2><user-feedback ng-if=\"(\'INLINE_USERIS\' | config) && stepPhoneActive\"></user-feedback><label for=\"phone_number\" class=\"flying_label\"><input type=\"text\" id=\"phone_number\" ng-model=\"otpModel.msisdn\" name=\"phone_number\" autocomplete=\"off\" required data-mipqa=\"msisdn-email-form\" inputmode=\"tel\" ng-change=\"setPhoneField($event)\"><dictionary key=\"\'WEBAPP_UO30_LOGIN_INSERT_USER\'\"></dictionary></label><div class=\"form__control\"><button id=\"forgotbutton\" class=\"btn-success\" data-doform=\"1\" type=\"button\" ng-disabled=\"frmforgot.phone_number.$invalid\" data-mipqa=\"forgot-confirm-button\" ng-click=\"doForgot()\"><dictionary key=\"\'WEBAPP_UO30_FORGOT_GET_PASSWORD\'\"></dictionary></button></div></div><input type=\"hidden\" id=\"passw\" name=\"password\" required> <input type=\"hidden\" id=\"username\" name=\"username\"><div class=\"form__line\" id=\"otpBox\" ng-show=\"stepOTPActive\"><h2 data-mipqa=\"page-titol\"><dictionary key=\"\'WEBAPP_UO30_OTP_LOGIN_INSERT_PIN\'\"></dictionary></h2><user-feedback ng-if=\"(\'INLINE_USERIS\' | config) && stepOTPActive\"></user-feedback><input ng-repeat=\"otp in OTParray track by $index\" maxlength=\"1\" class=\"login-input login-input-otp\" id=\"{{\'passw_\'+($index + 1) }}\" type=\"text\" required inputmode=\"numeric\" size=\"1\" pattern=\"[0-9]\" tabindex=\"{{$index + 1}}\" ng-model=\"otpModel.passw_[$index]\" name=\"{{\'passw_\'+($index + 1) }}\" value=\"\" data-mipqa=\"pin-psw-form\" autocomplete=\"off\"><div class=\"form__control\"><button id=\"frmbutton\" class=\"btn-success\" data-doform=\"1\" ng-disabled=\"frmforgot.passw_1.$invalid || frmforgot.passw_2.$invalid || frmforgot.passw_3.$invalid || frmforgot.passw_4.$invalid || frmforgot.passw_5.$invalid || frmforgot.passw_6.$invalid\" value=\"\" data-mipqa=\"confirm-button\" type=\"button\" ng-click=\"doLogin($event)\"><dictionary key=\"\'WEBAPP_UO30_LOGIN_CONFIRM\'\"></dictionary></button><p class=\"more-actions\"><button type=\"button\" id=\"forgotbutton_resend\" ng-click=\"resendPIN()\" class=\"link-button\"><dictionary key=\"\'WEBAPP_UO30_RESEND\'\"></dictionary></button><button type=\"button\" id=\"backToMsisdn\" class=\"link-button\" ng-click=\"goBack()\"><dictionary key=\"\'WEBAPP_UO30_BACK_TO_FORM\'\"></dictionary></button></p></div></div></form></div></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/mfpPage.ctr.html","<div class=\"mfpPage\"><h3>{{\'WEBAPP_MFP_STORE_REDIRECTION\' | dictionary}}</h3><img ng-src=\"{{\'loader\' | config}}\"></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/profilePage.ctr.html","<div ng-controller=\"ProfilePageCtr\"><div ng-if=\"userData.logged\"><div class=\"user-details\"><div class=\"avatar\"><div class=\"border-circle\"><img ng-src=\"{{avatar}}\" class=\"img-responsive\" ng-class=\"{\'fb-image\':fbImgClass}\"></div></div><div id=\"usernameChange\" ng-if=\"(\'USERNAME_IN_AVATARBLOCK\' | config) && !(\'HIDE_CHANGENICK\' | config)\"><h2 class=\"h2 editable\"><editable value=\"{{username}}\" on-accept=\"save(value)\" addclasstext=\"edit-name\" on-cancel=\"noChange()\" external-edit-id=\"edit-nick\" empty-valid=\"false\"></editable></h2><p ng-show=\"!username\" class=\"margin-bottom-14\"><small><dictionary key=\"\'WEBAPP_SETNICKNAME\'\"></dictionary></small></p></div></div><div class=\"box-user text-center\"><div id=\"usernameChange\" ng-if=\"!(\'USERNAME_IN_AVATARBLOCK\' | config) && !(\'HIDE_CHANGENICK\' | config)\"><h2 class=\"h2 editable\"><editable value=\"{{username}}\" on-accept=\"save(value)\" addclasstext=\"edit-name\" on-cancel=\"noChange()\" external-edit-id=\"edit-nick\" empty-valid=\"false\"></editable></h2><p ng-show=\"!username\" class=\"margin-bottom-14\"><small><dictionary key=\"\'WEBAPP_SETNICKNAME\'\"></dictionary></small></p></div><div id=\"emailChange\"><h2 class=\"h2 editable\" ng-if=\"((\'PROFILE_EMAIL_SHOW\'|config) && email && !skipped)\"><editable value=\"{{email}}\" on-accept=\"changeEmail(value)\" addclasstext=\"edit-email\" addclassfield=\"longField\" external-edit-id=\"edit-email\" empty-valid=\"false\"></editable></h2><p ng-show=\"emailChgError\" class=\"margin-bottom-14\"><small>{{emailChgError}}</small></p><p ng-if=\"((\'PROFILE_EMAIL_SHOW\'|config) && email && !skipped)\" class=\"margin-bottom-14\"><a ng-href=\"{{changePasswdLink}}\"><dictionary key=\"\'WEBAPP_CHANGE_PASSWORD\'\"></dictionary></a></p></div><div class=\"connect row\"><div ng-show=\"userData.fb_auth_id && (\'PROFILE_FBCONNECT_SHOW\'|config)\" class=\"box-data\" ng-class=\"{ oneicon: !((\'PROFILE_FBCONNECT_SHOW\'|config) && (\'PROFILE_EMAIL_SHOW\'|config)) }\"><h4><dictionary key=\"\'MIPCONNECT_LBL_FB_DISCONNECT\'\"></dictionary></h4><a ng-click=\"fbDisconnect()\"><span class=\"btn general-margin-tb\"><dictionary key=\"\'WEBAPP_LBL_FB_DISCONNECT\'\"></dictionary></span></a></div><div class=\"box-data\"><div class=\"center-block\" ng-show=\"!userData.fb_auth_id && (\'PROFILE_FBCONNECT_SHOW\'|config) && !skipped\"><h4><dictionary key=\"\'WEBAPP_CONNECT_WITH\'\"></dictionary></h4><fblogin data-mipqa=\"fbconnect-account-logged\"></fblogin></div><div ng-show=\"(!userData.email && (\'PROFILE_EMAIL_SHOW\'|config)) || ((\'PROFILE_EMAIL_SHOW\'|config) && userData.email && skipped) \" class=\"center-block\"><div class=\"container-or single-margin\" ng-show=\"!userData.fb_auth_id && (\'PROFILE_FBCONNECT_SHOW\'|config) && !skipped\"><span class=\"or-txt\"><dictionary key=\"\'MIPCONNECT_FB_OR\'\"></dictionary></span></div><a ng-if=\"!skipped\" ng-href=\"{{account_creation_link}}\" class=\"btn email\"><span class=\"icon-email_login\"></span><dictionary key=\"\'WEBAPP_CONNECT_EMAIL\'\"></dictionary></a><a ng-if=\"skipped\" ng-href=\"{{account_creation_link_skipped}}\" class=\"btn email\"><span class=\"icon-email_login\"></span><dictionary key=\"\'WEBAPP_ACCOUNT_CREATION_TIP\'\"></dictionary></a></div></div></div></div><activity></activity></div><div class=\"user-details settings-log\" ng-hide=\"userData.logged\" ng-if=\"\'SETTINGS_LOGIN_SHOW\'|config\"><h1 ng-show=\"!(\'HIDE_LOGIN_BUTTON_ALL\' | config) && (((\'HIDE_LOGIN_3G\' | config) && setLogin3G) || !(\'HIDE_LOGIN_3G\' | config))\" class=\"text-center\"><dictionary key=\"\'WEBAPP_TITLE_ACCOUNT\'\"></dictionary></h1><fblogin data-mipqa=\"fbconnect-account-unlogged\"></fblogin><div class=\"center-block center no-log-or\" ng-if=\"(\'PROFILE_FBCONNECT_SHOW\'|config) && (!(\'HIDE_LOGIN_BUTTON_ALL\' | config) && (((\'HIDE_LOGIN_3G\' | config) && setLogin3G) || !(\'HIDE_LOGIN_3G\' | config)))\"><span><dictionary key=\"\'MIPCONNECT_FB_OR\'\"></dictionary></span><hr></div><div class=\"center-block general-margin-tb\" ng-show=\"!(\'HIDE_LOGIN_BUTTON_ALL\' | config) && (((\'HIDE_LOGIN_3G\' | config) && setLogin3G) || !(\'HIDE_LOGIN_3G\' | config))\"><a class=\"btn play\" data-mipqa=\"go-to-login\" ng-click=\"goToLogin()\"><dictionary key=\"\'MIPCONNECT_TITLE_LOGIN\'\"></dictionary></a></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/resetPassword.ctr.html","<div><div id=\"blackboard\"></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/silent.html","");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/unsubscribedPage.html","<div class=\"static-page unsubscribed\"><p id=\"doc_test\"><dictionary key=\"\'STATUS_UNSUBSCRIBE_TEXT_WEBAPP1\'\"></dictionary></p><p id=\"doc_test\"><dictionary key=\"\'STATUS_UNSUBSCRIBE_TEXT_WEBAPP2\'\"></dictionary></p><div class=\"center homeLink\" ng-if=\"!hideOperator && !(\'HIDE_BUTTON_BACKHOME\' | config)\"><a class=\"btn link anchor\" href=\"/#!/\" data-mipqa=\"unsubscribed-return-home\"><dictionary key=\"\'WEBAPP_NEXT\'\"></dictionary></a></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/wallPage.ctr.html","<div class=\"paywall\" ng-if=\"game\"><h2 class=\"general-margin\">{{game.title}}</h2><div class=\"zoom-noslider\"><img ng-src=\"{{game.images.cover.ratio_2 | imageSize:640:0}}\" class=\"img-responsive\"></div><p class=\"general-margin\"><dictionary key=\"\'WEBAPP_PAYWALL_FBCONNECT\'\"></dictionary></p><fblogin data-mipqa=\"fbconnect-account-unlogged\" returl=\"returl\"></fblogin><ul class=\"general-margin\"><li><span class=\"icon-check_list\"></span><dictionary key=\"\'WEBAPP_PAYWALL_FB_TEXT_1\'\"></dictionary></li><li><span class=\"icon-check_list\"></span><dictionary key=\"\'WEBAPP_PAYWALL_FB_TEXT_2\'\"></dictionary></li><li><span class=\"icon-check_list\"></span><dictionary key=\"\'WEBAPP_PAYWALL_FB_TEXT_3\'\"></dictionary></li></ul></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/common/dictionary/dictionary.dir.html","<span class=\"dict\" ng-bind-html=\"value\" dir=\"{{setDir(value)}}\"></span>");
$templateCache.put("/js/wl/webstore_gameasy/app/common/user/user.dir.html","<span ng-bind-html=\"value\"></span>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/adv/inPageAdv.dir.html","<div class=\"ad_container\" ng-show=\"showFrame\"><iframe class=\"adFrame ad_{{slot}}\" frameborder=\"no\" scrolling=\"no\" width=\"100%\" ng-src=\"{{adurl}}\" seamless></iframe></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/common/utils/dynamicDom.dir.html","<dynamic-dom content=\"content\"></dynamic-dom>");
$templateCache.put("/js/wl/webstore_gameasy/app/common/utils/editable.dir.html","<div><span data-ngedit=\"text\" ng-bind=\"value\" ng-class=\"addclasstext\"></span><div data-ngedit=\"edit\" class=\"editbox\"><input class=\"input-profile\" ng-class=\"addclassfield\" data-ngedit=\"input\" ng-model=\"value\" ng-required=\"required\"><a data-ngedit=\"accept\" class=\"icon-penna\"></a></div><a id=\"{{externalEditId}}\" class=\"icon-penna show-editable\"></a></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/imgsliderLeaderboard/imgsliderLeaderboard.dir.html","<div class=\"glide slider-home-container ldb\" ng-hide=\"noLdb\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides slider-wrapper mobile\"><li ng-repeat=\"item in items track by $index\" class=\"slider glide__slide\" data-mipqa=\"gotogame\" data-gamedest=\"{{gameGoesTo(item.game_info, \'sliderldb\')}}\" ng-click=\"itemPlay(item.game_info,true,{{$index+1}},\'sliderldb\');\"><img data-mipqa=\"{{getSingleGameAccess(item.access_type)}}\" title=\"{{item.game_info.title}} {{\'WEBAPP_CANVAS_BUTTON_PLAY\' | dictionary}}\" ng-src=\"{{(item.game_info.images.home_sprite || item.game_info.images.cover.ratio_1) | imageSize:124:124 }}\" class=\"img-responsive\"><p class=\"ldb-nick ellipsis\">{{item.player_name}}</p><p class=\"ldb-score ellipsis\">{{item.score}}</p><p class=\"ldb-game ellipsis\">{{item.game_info.title}}</p></li></ul></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/activity/activitynav.dir.html","<ul class=\"tabs\"><li ng-if=\"(\'ACTIVITY_HISTORY\'|config)\" class=\"tab-history\" ng-class=\"{ \'active\': active ==\'history\', \'col-xs-6\' :(\'ACTIVITY_HISTORY\'|config)&&(\'ACTIVITY_FAVOURITES\'|config)}\"><a ng-click=\"goTo(\'history\')\"><h3 class=\"center\"><dictionary key=\"\'WEBAPP_LAST_PLAYED\'\"></dictionary></h3></a></li><li ng-if=\"(\'ACTIVITY_FAVOURITES\'|config)\" class=\"tab-favorites\" ng-class=\"{ \'active\': active ==\'favorites\', \'col-xs-6\' :(\'ACTIVITY_HISTORY\'|config)&&(\'ACTIVITY_FAVOURITES\'|config)}\"><a ng-click=\"goTo(\'favorites\')\"><h3 class=\"center\"><dictionary key=\"\'WEBAPP_FAVOURITES\'\"></dictionary></h3></a></li></ul>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/leaderboard/competitionLeaderboard.dir.html","<div class=\"competitionHome\" ng-if=\"(\'SHOW_LEADERBOARDS_COMPETITION\' | config) && (\'ENABLE_CONTEST\' | config) && !isContestOver\"><section class=\"contest-game\" ng-class=\"{\'noLdb\' : noLdb}\"><figure itemtype=\"http://schema.org/VideoGame\" ng-class=\"{\'wide\' : $root.deviceType !== \'phone\'}\"><a data-mipqa=\"gotogame_img\" ng-click=\"itemPlay(game,true,1,\'custom\');\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\"><img alt=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" ng-src=\"{{gameImg | imageSize:imgWSize:imgHSize}}\" class=\"img-responsive\" style=\"background-image: url({{gameImg | imageSize:4:0}});\"></a><figcaption><span class=\"contest-game-title\">{{game.title}}</span><contest-players game=\"game\" starttime=\"dates.start\" endtime=\"dates.end\" ng-if=\"(\'SHOW_PLAYER_COUNT_HOME\' | config)\" ng-hide=\"noLdb\"></contest-players><button type=\"button\" data-mipqa=\"clickitem-gameplay\" class=\"btn play playContest\" ng-click=\"itemPlay(game,false,1,\'custom\');\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" dir=\"{{setDir(setBtnLabel((\'WEBAPP_CANVAS_BUTTON_PLAY\' | dictionary)))}}\">{{\'WEBAPP_CANVAS_BUTTON_PLAY\' | dictionary}}</button></figcaption></figure><section class=\"contest-ldb\" ng-hide=\"noLdb\" dir=\"ltr\"><h3 class=\"ldb-title\" dir=\"{{setDir((\'WEBAPP_COMPETITION_HOME_LEADERBOARD_TITLE\' | dictionary))}}\"><span class=\"icon-coppa\"></span><dictionary key=\"\'WEBAPP_COMPETITION_HOME_LEADERBOARD_TITLE\'\"></dictionary></h3><div class=\"glide slider-home-container ldb competition\" dir=\"ltr\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides slider-wrapper mobile\"><li ng-repeat=\"item in items track by $index\" class=\"slider glide__slide\" ng-class=\"{\'is-viewer\' : item.is_viewer}\" data-mipqa=\"gotogame\" data-gamedest=\"{{gameGoesTo(game, \'sliderldb\')}}\" ng-click=\"itemPlay(game,true,{{$index+1}},\'sliderldb\');\"><p class=\"ldb-pos\"><span>{{item.position}}</span></p><div class=\"playerdata\"><p class=\"ldb-nick\">{{item.user_info.name || item.player_name}}</p><p class=\"ldb-score\">{{item.score}}</p></div></li></ul></div></div></section><contest-no-results ng-if=\"(noLdb && !(\'SHOW_PRIZES_BANNER\' | config))\" game=\"game\"></contest-no-results></section></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/leaderboard/competitionLeaderboardZoom.dir.html","<div class=\"ldb-zoom-container\" ng-show=\"game\" ng-class=\"{\'noResults\':showInvite}\" ng-if=\"(\'SHOW_LEADERBOARDS_COMPETITION\' | config) && (\'ENABLE_CONTEST\' | config) && !isContestOver\"><div class=\"ldb-list ldb-zoom\" ng-if=\"(\'SHOW_LEADERBOARDS_COMPETITION\' | config) && items && items.length\"><h3 class=\"ldb-title\"><dictionary key=\"\'WEBAPP_COMPETITION_ZOOM_LEADERBOARD_TITLE\'\"></dictionary></h3><ul><li ng-repeat=\"item in items\" ng-class=\"{\'is-viewer\' : item.is_viewer}\" dir=\"ltr\"><span class=\"ldb-pos\">{{item.position}}</span><span class=\"ldb-img\"><img class=\"ldb-avatar\" ng-src=\"{{\'default-avatar\' | config}}\"></span><span class=\"ldb-nick\">{{item.user_info.name || item.player_name}}</span><span class=\"ldb-score\">{{item.score}}</span></li></ul></div><contest-no-results ng-if=\"showInvite\" game=\"game\"></contest-no-results></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/leaderboard/contestBadge.html","<div class=\"contest-badge\" ng-if=\"(\'SHOW_LEADERBOARDS_COMPETITION\' | config) && (\'ENABLE_CONTEST\' | config) && badges.length\"><h2><dictionary key=\"\'WEBAPP_CONTEST_MY_BADGES\'\"></dictionary></h2><div class=\"contest-winner\"><div class=\"winner-badge\" ng-repeat=\"badge in badges track by $index\"><img class=\"responsive-img\" ng-src=\"{{(\'badge_first-contest\' | config)}}\"><p ng-click=\"itemZoom(badge)\">{{badge.title}}</p></div><div class=\"winner-badge comingsoon\"><img class=\"responsive-img\" ng-src=\"{{(\'badge_first-contest\' | config)}}\"><p><dictionary key=\"\'WEBAPP_CONTEST_MY_BADGES_PLAYFORMORE\'\"></dictionary></p></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/leaderboard/contestCard.html","<div class=\"contest-card\" ng-show=\"contest\"><div itemscope itemtype=\"http://schema.org/VideoGame\" class=\"contest-game-box\" ng-if=\"!contest.notStarted\" ng-show=\"contest.ready\"><item-single contest=\"contest\" imgratio=\"imgratio\" ng-if=\"!contest.isContestOver\" tmplname=\"contestItem.html\"></item-single><contest-time page=\"contest-page\" dates=\"contest.CONTEST_TIMEFRAME_UTC\"></contest-time><leaderboard-zoom game=\"contest.content_info\" items=\"contest.leaderboard.top_scorer\" dates=\"contest.CONTEST_TIMEFRAME_UTC\" limit=\"3\" ng-show=\"contest.content_info && contest.ready\" ng-if=\"(\'SHOW_LEADERBOARDS_COMPETITION\' | config) && !contest.isContestOver\"></leaderboard-zoom></div><a class=\"more-contest\" ng-if=\"contest && contest.leaderboard && contest.leaderboard.top_scorer && contest.leaderboard.top_scorer.length\" ng-href=\"{{contest.content_info.url_zoom}}\"><dictionary key=\"\'WEBAPP_MORE_SCORES\'\"></dictionary></a></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/leaderboard/contestEnded.html","<div class=\"contestNoResults ended\"><p><dictionary key=\"\'WEBAPP_COMPETITION_ENDED\'\" ng-if=\"!contest.notStarted\"></dictionary></p><p><dictionary key=\"\'WEBAPP_COMPETITION_ENDED_WAITFORNEXT\'\"></dictionary></p></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/leaderboard/contestHomeSection.html","<div class=\"contest-container\" ng-class=\"{\'nocontest\':!contest}\"><div contest-prizes-info game=\"singleGame\" ng-if=\"(\'SHOW_PRIZES_BANNER\' | config) && (\'ENABLE_CONTEST\' | config)\"></div><contest-home-child tmplname=\"{{tpl}}\"></contest-home-child></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/leaderboard/contestNoResults.html","<div class=\"contestNoResults\"><p><dictionary key=\"\'WEBAPP_COMPETITION_INVITE\'\"></dictionary></p><button type=\"button\" data-mipqa=\"clickitem-gameplay\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" class=\"btn play {{game.format}}\" ng-click=\"gamePlay($event)\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" dir=\"{{setDir(setBtnLabel(game.format))}}\">{{setBtnLabel(game.format)}}</button></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/leaderboard/contestPlayers.html","<p class=\"onlineNow\" ng-class=\"{\'noPlayers\' : contestPlayers === 0}\" dir=\"{{setDir((\'WEBAPP_COMPETITION_ONLINEPLAYERS\' | dictionary))}}\">{{contestPlayers}}<dictionary key=\"\'WEBAPP_COMPETITION_ONLINEPLAYERS\'\"></dictionary></p>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/leaderboard/contestPrizesInfo.html","<div class=\"contest-prizes-banner-container\"><div class=\"container-contest-prizes-banner\"><div class=\"contest-prizes-banner-content\"><div class=\"gift-box\"></div><dictionary key=\"\'WEBAPP_CONTEST_PRIZES_BANNER_TEXT\'\"></dictionary><button type=\"button\" class=\"btn\" ng-click=\"openModal()\"><dictionary key=\"\'WEBAPP_CONTEST_PRIZES_BANNER_BUTTON\'\"></dictionary></button></div><div class=\"contest-prizes-modal\" ng-show=\"isModalOpen\"><div class=\"contest-prizes-modal-content\"><button type=\"button\" class=\"close\" ng-click=\"closeModal()\"></button><div class=\"contest-prizes-modal-body\"><h3><dictionary key=\"\'WEBAPP_CONTEST_PRIZES_MODAL_TITLE_FIRST\'\"></dictionary></h3><div class=\"first-block-modal\"><div class=\"second-prize\"><div class=\"ico-modal-prize\"></div><div class=\"text-modal-prize\"><dictionary key=\"\'WEBAPP_CONTEST_PRIZES_MODAL_TEXT_SECOND_PRIZE\'\"></dictionary></div><div class=\"modal-prize\"><dictionary key=\"\'WEBAPP_CONTEST_PRIZES_MODAL_SECOND_PRIZE\'\"></dictionary></div></div><div class=\"first-prize\"><div class=\"ico-modal-prize\"></div><div class=\"text-modal-prize\"><dictionary key=\"\'WEBAPP_CONTEST_PRIZES_MODAL_TEXT_FIRST_PRIZE\'\"></dictionary></div><div class=\"modal-prize\"><dictionary key=\"\'WEBAPP_CONTEST_PRIZES_MODAL_FIRST_PRIZE\'\"></dictionary></div></div><div class=\"third-prize\"><div class=\"ico-modal-prize\"></div><div class=\"text-modal-prize\"><dictionary key=\"\'WEBAPP_CONTEST_PRIZES_MODAL_TEXT_THIRD_PRIZE\'\"></dictionary></div><div class=\"modal-prize\"><dictionary key=\"\'WEBAPP_CONTEST_PRIZES_MODAL_THIRD_PRIZE\'\"></dictionary></div></div></div><button type=\"button\" class=\"btn\" ng-click=\"itemPlay(game)\"><dictionary key=\"\'WEBAPP_CONTEST_PRIZES_MODAL_BUTTON_PLAY_WIN\'\"></dictionary></button><div ng-if=\"(\'SHOW_MODAL_BLOCK_DAILY_REWARDS\'|config)\"><hr><div class=\"container-second-block-modal\"><h3><dictionary key=\"\'WEBAPP_CONTEST_PRIZES_MODAL_TITLE_SECOND\'\"></dictionary></h3><div class=\"second-block-modal\"><h4><dictionary key=\"\'WEBAPP_CONTEST_PRIZES_MODAL_SUBTITLE_SECOND\'\"></dictionary></h4></div><div class=\"box-modal-rewards\"><div class=\"arrow-modal-contest\"></div><div class=\"text-rewards\"><dictionary key=\"\'WEBAPP_CONTEST_PRIZES_MODAL_REWARDS\'\"></dictionary></div><div class=\"arrow-modal-contest arrow-right\"></div></div></div><button type=\"button\" class=\"btn\" ng-click=\"itemPlay(game)\"><dictionary key=\"\'WEBAPP_CONTEST_PRIZES_MODAL_BUTTON\'\"></dictionary></button></div></div></div></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/leaderboard/contestTime.html","<div class=\"contestTimeframe {{page}}\" ng-class=\"{\'ended\' : isContestOver}\"><span class=\"countdown\" ng-class=\"{\'hidden\': basic}\"></span><p dir=\"{{setDir((\'WEBAPP_COMPETITION_TIMELEFT\' | dictionary))}}\"><span class=\"contest-active\" ng-hide=\"finishHour\" ng-if=\"!isContestOver\" dir=\"{{setDir((\'WEBAPP_COMPETITION_TIMELEFT\' | dictionary))}}\"><dictionary key=\"\'WEBAPP_COMPETITION_TIMELEFT\'\"></dictionary><span class=\"timeleft\"><dictionary key=\"\'WEBAPP_COMPETITION_TIMELEFT_AMOUNT\'\"></dictionary>&nbsp;{{timeLeft}}&nbsp;</span></span><span class=\"contest-active\" ng-show=\"finishHour\" ng-if=\"!isContestOver\" dir=\"{{setDir((\'WEBAPP_COMPETITION_ENDTIME\' | dictionary))}}\"><dictionary key=\"\'WEBAPP_COMPETITION_ENDTIME\'\"></dictionary><span class=\"timeleft\"><dictionary key=\"\'WEBAPP_COMPETITION_TIMELEFT_AMOUNT\'\"></dictionary>&nbsp;{{finishHour}}&nbsp;</span></span><span class=\"contest-active\" ng-if=\"isContestOver\"><dictionary key=\"\'WEBAPP_COMPETITION_ENDED\'\"></dictionary></span></p></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/leaderboard/contestWinnerHome.html","<div class=\"contest-winner contest-item ended badge-won\" ng-if=\"contest.isContestOver && contest.iswinner && !contest.badgeClaimed\"><figure><div class=\"winner-badge\"><img class=\"responsive-img\" ng-src=\"{{(\'ratio_1\' | config)}}\"></div><figcaption class=\"ifWon\"><span class=\"contest-game-title\">{{contest.content_info.title}}</span><div class=\"winner-claim\"><h3 dir=\"{{setDir((\'WEBAPP_CONTEST_WINNER_TITLE\' | dictionary))}}\"><dictionary key=\"\'WEBAPP_CONTEST_WINNER_TITLE\'\"></dictionary></h3><p dir=\"{{setDir((\'WEBAPP_CONTEST_WINNER_TEXT\' | dictionary))}}\"><dictionary key=\"\'WEBAPP_CONTEST_WINNER_TEXT\'\"></dictionary></p></div><button ng-if=\"(\'BUTTON_INSIDE_CAPTION\' | config)\" type=\"button\" class=\"btn play\" ng-click=\"contest.claimBadge(contest.badgeData.id)\"><dictionary key=\"\'WEBAPP_CONTEST_CLAIM_BADGE\'\"></dictionary></button></figcaption></figure><button ng-if=\"!(\'BUTTON_INSIDE_CAPTION\' | config)\" type=\"button\" class=\"btn play\" ng-click=\"contest.claimBadge(contest.badgeData.id)\"><dictionary key=\"\'WEBAPP_CONTEST_CLAIM_BADGE\'\"></dictionary></button></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/leaderboard/leaderboard.dir.html","<div class=\"ldb-list ldb-zoom\" ng-if=\"((\'SHOW_LEADERBOARD\' | config) || (\'SHOW_LEADERBOARDS_COMPETITION\' | config)) && items.length\"><h3 ng-bind-html=\"ldbTitle\" dir=\"{{setDir(ldbTitle)}}\"></h3><ul><li ng-repeat=\"item in items\" ng-class=\"{\'myScore\' : myScore, \'topScores\' : item.position <= 3 }\"><span class=\"ldb-pos ellipsis\">{{item.position}}</span><span class=\"ldb-nick ellipsis\"><span class=\"ldb-img ellipsis\"><img class=\"ldb-avatar\" ng-src=\"{{\'default-avatar\' | config}}\"></span>{{item.player_name}}</span><span class=\"ldb-score ellipsis\">{{item.score}}</span></li></ul></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/leaderboard/multiContest.html","<div class=\"contest-home-multi contest-card_container\" ng-if=\"(\'SHOW_LEADERBOARDS_COMPETITION\' | config) && (\'ENABLE_CONTEST\' | config) && !contest.notStarted\"><h2 class=\"contest-title\" dir=\"{{setDir((\'WEBAPP_CONTEST_HOME_TITLE\' | dictionary))}}\"><dictionary key=\"\'WEBAPP_CONTEST_HOME_TITLE\'\"></dictionary></h2><div class=\"contest-item\" ng-repeat=\"contest in contests track by $index\" ng-if=\"(contest && !contest.isContestOver) || (contest.isContestOver && contest.iswinner)\" ng-class=\"{\'ended\' : contest.isContestOver, \'badge-won\' : contest.iswinner }\" ng-show=\"contest.ready\"><div class=\"contest-active\" ng-if=\"contest && !contest.isContestOver\"><item-single contest=\"contest\" imgratio=\"imgratio\"></item-single></div><contest-winner-home contest=\"contest\"></contest-winner-home></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/leaderboard/singleContest.html","<div class=\"contest-home\" ng-class=\"{\'ended\' : contests[0].isContestOver, \'badge-won\' : contests[0].iswinner }\" ng-if=\"(\'SHOW_LEADERBOARDS_COMPETITION\' | config) && (\'ENABLE_CONTEST\' | config) && !contests[0].notStarted\" ng-show=\"contests[0].ready\"><contest-time basic=\"true\" dates=\"contests[0].CONTEST_TIMEFRAME_UTC\" page=\"home\" ng-show=\"(contests[0].iswinner && !contests[0].badgeClaimed) || (!contests[0].isContestOver && contests[0].CONTEST_TIMEFRAME_UTC)\"></contest-time><div class=\"contest-winner contest-item ended badge-won\" ng-if=\"contest.isContestOver && contest.iswinner && !contest.badgeClaimed\"><h2 class=\"ifWon\" ng-if=\"contest.isContestOver && contest.iswinner && !contest.badgeClaimed\" dir=\"{{setDir((\'WEBAPP_COMPETITION_HOME_GAME_TITLE\' | dictionary))}}\"><dictionary key=\"\'WEBAPP_COMPETITION_HOME_GAME_TITLE\'\"></dictionary><span class=\"contest-game-title\">{{contest.content_info.title}}</span></h2><div class=\"winner-badge\"><img class=\"responsive-img\" ng-src=\"{{(\'ratio_1\' | config)}}\"></div><div class=\"winner-claim\"><h3><dictionary key=\"\'WEBAPP_CONTEST_WINNER_TITLE\'\"></dictionary></h3><p><dictionary key=\"\'WEBAPP_CONTEST_WINNER_TEXT\'\"></dictionary></p><button type=\"button\" class=\"btn play\" ng-click=\"claimBadge(contest.badgeData.id)\"><dictionary key=\"\'WEBAPP_CONTEST_CLAIM_BADGE\'\"></dictionary></button></div></div><competitionleaderboard limit=\"10\" section=\"leaderboard\" game=\"contests[0].content_info\" dates=\"contests[0].CONTEST_TIMEFRAME_UTC\" ng-if=\"!contests[0].isContestOver\"></competitionleaderboard></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/leaderboard/singleContest_hutch.html","<div class=\"contest-home-multisingle contest-card_container\" ng-class=\"{\'ended\' : contest.isContestOver, \'badge-won\' : contest.iswinner }\" ng-if=\"(\'SHOW_LEADERBOARDS_COMPETITION\' | config) && (\'ENABLE_CONTEST\' | config) && !contest.notStarted\" ng-show=\"contest.ready\"><h2 class=\"contest-title\" dir=\"{{setDir((\'WEBAPP_CONTEST_HOME_TITLE\' | dictionary))}}\"><dictionary key=\"\'WEBAPP_CONTEST_HOME_TITLE\'\"></dictionary></h2><contest-winner-home contest=\"contest\"></contest-winner-home><contest-card contest=\"contest\" ng-if=\"!contest.isContestOver\"></contest-card></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/like/favoriteButton.dir.html","<button ng-show=\"(\'ENABLE_FAVORITES\'|config)\" class=\"btn favs\" title=\"{{\'WEBAPP_ADD_FAVORITE\' | dictionary}}\" data-btnlabel=\"{{\'WEBAPP_ADD_FAVORITE\' | dictionary}}\" ng-click=\"manageFavorites(!status)\" data-mipqa=\"btn-favorite\" ng-class=\"{\'unlikeditem\' : !status, \'likeditem\' : status, \'logged\' : logged}\"><div class=\"favbtn inject-me\" data-src=\"{{favBtnIcon}}\"></div></button>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/message/info.dir.html","<div class=\"info-message\" ng-class=\"{\'user-content\':userContent}\" ng-if=\"showinfo\"><button ng-show=\"showclose\" class=\"close-message\" type=\"button\" ng-click=\"closeInfo()\"><span class=\"icon-x\"></span></button><p><dictionary key=\"infotext\"></dictionary></p><div class=\"info-access\" ng-if=\"showaccess && unlogged\"><fblogin></fblogin></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/message/message.dir.html","<div class=\"message info-message\" ng-class=\"{\'text-btn\': (\'SHOW_PRIVACY_BUTTON_TEXT\'|config)}\" ng-show=\"visible\"><div role=\"alert\"><button ng-if=\"closeButton && !(\'SHOW_PRIVACY_BUTTON_TEXT\'|config)\" type=\"button\" class=\"close\" ng-click=\"closeAlert()\" data-mipqa=\"privacyBox-close-btn\"><dictionary key=\"\'WEBAPP_PRIVACY_BUTTON_TEXT\'\" ng-if=\"(\'SHOW_PRIVACY_BUTTON_TEXT\'|config)\"></dictionary></button><div ng-transclude ng-if=\"insideFunction\" ng-click=\"clickInside()\"></div><div ng-transclude ng-if=\"!insideFunction\"></div><p ng-if=\"(\'SHOW_PRIVACY_BUTTON_TEXT\'|config)\"><button ng-if=\"closeButton\" type=\"button\" class=\"text-btn\" ng-click=\"closeAlert()\" data-mipqa=\"privacyBox-close-btn\"><dictionary key=\"\'WEBAPP_PRIVACY_BUTTON_TEXT\'\"></dictionary></button></p></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/badges/badges.html","<div class=\"contest badges\"><gamification-tabs></gamification-tabs><main><div class=\"badge-container\"><div class=\"my-badges\"><div class=\"winner-badge\" ng-repeat=\"badge in achievedBadges track by $index\" ng-if=\"userData.logged\"><img class=\"responsive-img\" ng-src=\"{{(\'badge_first-contest\' | config)}}\"><p ng-click=\"itemZoom(badge.contestData)\">{{badge.contestData.title}}</p></div><div class=\"winner-badge comingsoon\" ng-hide=\"achievedBadges && achievedBadges.length\"><img class=\"responsive-img\" ng-src=\"{{(\'badge_first-contest\' | config)}}\"><p><dictionary key=\"\'WEBAPP_CONTEST_MY_BADGES_PLAYFORMORE\'\"></dictionary></p></div></div></div></main></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/scrollToTop/scrollToTop.dir.html","<div class=\"scrolltop-button\" ng-class=\"{\'showed\':showScrollTop}\" ng-click=\"onClickCallback()\"><span class=\"icon-arrow\"></span></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/contest/contest.html","<div class=\"contest\"><gamification-tabs></gamification-tabs><main><h2 dir=\"{{setDir((\'WEBAPP_CONTEST_HOME_TITLE\' | dictionary))}}\" class=\"contest-title\" ng-if=\"isMulti || ( \'CONTEST_NEW_SINGLE_TPL\' | config )\"><dictionary key=\"\'WEBAPP_CONTEST_HOME_TITLE\'\"></dictionary></h2><div class=\"contest-profile\" ng-if=\"userData.logged\"><section ng-bind-html=\"userProfile\"></section></div><div class=\"multi-contest\" ng-if=\"isMulti || ( \'CONTEST_NEW_SINGLE_TPL\' | config )\"><contest-ended ng-if=\"isContestOver || notStarted\"></contest-ended><contest-card ng-repeat=\"contest in contests track by $index\" contest=\"contest\"></contest-card></div><div class=\"single-contest_legacy\" ng-if=\"!isMulti && !( \'CONTEST_NEW_SINGLE_TPL\' | config )\"><contest-ended ng-if=\"contests[0].isContestOver || contests[0].notStarted\"></contest-ended><div itemscope itemtype=\"http://schema.org/VideoGame\" class=\"contest-game-box\" ng-if=\"!contests[0].notStarted\" ng-show=\"contests[0].ready\"><item-single contest=\"contests[0]\" imgratio=\"imgratio\" ng-if=\"!contests[0].isContestOver\"></item-single><contest-time page=\"contest-page\" dates=\"contests[0].CONTEST_TIMEFRAME_UTC\"></contest-time><leaderboard-zoom game=\"contests[0].content_info\" dates=\"contests[0].CONTEST_TIMEFRAME_UTC\" limit=\"20\" ng-show=\"contests[0].content_info && contests[0].ready\" ng-if=\"(\'SHOW_LEADERBOARDS_COMPETITION\' | config) && !contests[0].isContestOver\"></leaderboard-zoom></div></div></main></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/header/header.ctr.html","<div class=\"navbar\" role=\"navigation\" id=\"main-header\" ng-class=\"{\'fullHeader\' : customHeader && fullHeader}\" ng-if=\"!(\'HIDE_MAIN_HEADER\'|config)\"><div ng-if=\"(\'SVG_HEADER_INJECTED\' | config) && headerSvg\" class=\"headersvg\" data-src=\"{{headerSvg}}\"></div><div class=\"elements\" ng-if=\"!customHeader || (customHeader && fullHeader)\"><div class=\"fixedLogo\" ng-class=\"{\'pull-right\' : RTLlang, \'pull-left\' : !RTLlang }\"><a class=\"link-head logo\" data-mipqa=\"logo-link\" ng-click=\"goTo(\'home\')\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\"></a></div><div ng-class=\"{\'pull-left\' : RTLlang, \'pull-right\' : !RTLlang }\"><a ng-if=\"(\'SHOW_CONTEST_LINK\' | config) && (\'ROUTER_CONTEST\' | config) && (\'ENABLE_CONTEST\' | config)\" class=\"contest link-head\" data-mipqa=\"header-link-contest\" ng-click=\"goTo(\'contest\')\" data-label=\"{{\'WEBAPP_GAMIFICATION_HEADER_ICON_TITLE\' | dictionary }}\"><span class=\"icon-coppa\"></span></a><a ng-if=\"(\'SHOW_PARTNER_LINK\' | config) && !(\'HIDE_PARTNER_LINK_HEAD\' | config)\" class=\"shop link-head\" data-mipqa=\"header-link-shop\" ng-click=\"goTo(\'shop\')\" data-label=\"{{\'WEBAPP_SHOP_HEADER_ICON_TITLE\' | dictionary }}\"><span class=\"icon-shop\"></span></a><a ng-if=\"(\'SHOW_NEWS\' | config)\" class=\"news link-head\" data-mipqa=\"header-link-news\" ng-click=\"goTo(\'news\')\" data-label=\"{{\'WEBAPP_NEWS_HEADER_ICON_TITLE\' | dictionary }}\"><span class=\"icon-news\"></span></a><a class=\"explore link-head arrow-top\" data-mipqa=\"header-link-explore\" ng-class=\"{\'arrow-top--light\' : headerData.showinfo, \'arrow-top--dark\' : !headerData.showinfo}\" ng-click=\"goTo(\'explore\')\" data-label=\"{{\'WEBAPP_HEADER_ICON_EXPLORE_TITLE\' | dictionary }}\"><span class=\"icon-search_spento\"></span></a><a data-mipqa=\"header-link-settings-logged\" class=\"account logged link-head arrow-top arrow-top--dark\" ng-class=\"{\'fbImage\':avatar}\" ng-href=\"{{\'LOGGED_SETTINGS_LINK\' | config}}\" ng-if=\"userLogged && !(\'HIDE_ACCOUNT_HEADER_BUTTON\' | config)\" data-label=\"{{\'WEBAPP_HEADER_ICON_ACCOUNT_TITLE\' | dictionary }}\"><span ng-if=\"!avatar\" class=\"icon-account_spento\"></span><span ng-if=\"avatar\" class=\"avatar\"><img ng-src=\"{{avatar}}\" class=\"img-responsive fb-image\"></span></a><a data-mipqa=\"header-link-settings-unlogged\" class=\"account link-head arrow-top arrow-top--dark unlogged\" ng-href=\"{{\'URLMGR_SETTINGS-LINK\' | config}}\" ng-if=\"!userLogged && !(\'HIDE_ACCOUNT_HEADER_BUTTON\' | config)\"><span class=\"icon-account_acceso\"></span><span class=\"btn\"><dictionary key=\"\'WEBAPP_LABEL_LOGIN\'\"></dictionary></span></a></div></div><div class=\"elements\" ng-if=\"(customHeader && !fullHeader)\"><div ng-class=\"{\'pull-right\' : RTLlang, \'pull-left\' : !RTLlang }\"><a class=\"link-head backBtn\" data-mipqa=\"btn-back\" ng-click=\"headerBack($event);\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\"><span class=\"icon-back\"></span></a></div><h1 class=\"head-elements\" dir=\"{{setDir(headerData.customHeaderTitle)}}\" ng-bind-html=\"headerData.customHeaderTitle\"></h1></div></div><div ng-if=\"(\'SHOW_TEXT_HEADER_OPERATORS\' | config)\" class=\"text-header-box\" id=\"header-text\"><div ng-if=\"userLogged\"><dictionary key=\"\'WEBAPP_HOME_IS_LOGGED\'\"></dictionary></div><div ng-if=\"!userLogged\"><dictionary key=\"\'WEBAPP_HOME_NOT_LOGGED\'\"></dictionary></div></div><h4 class=\"hfooter text-center\" ng-show=\"overHeader\"><span ng-repeat=\"link in links\"><a href=\"{{link.url}}\">{{link.label}}</a></span></h4><secondarynav ng-if=\"(\'HEADER_BTNS_INPAGE\' | config) && (\'HIDE_MAIN_HEADER\' | config)\" nav=\"[\'home\',\'explore\',\'settings\']\" class=\"secnav-{{currentRoute}}\"></secondarynav><div class=\"elements subHeader\" ng-if=\"(customHeader && fullHeader) || (customHeader && (\'HIDE_MAIN_HEADER\'|config))\"><div ng-if=\"(\'SVG_SUBHEADER_INJECTED\' | config) && subheaderSvg\" class=\"subheadersvg\" data-src=\"{{subheaderSvg}}\"></div><div ng-class=\"{\'pull-right\' : RTLlang, \'pull-left\' : !RTLlang }\"><a class=\"link-head backBtn\" ng-click=\"headerBack($event);\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\"><span class=\"icon-back\"></span></a></div><h1 class=\"head-elements\" dir=\"{{setDir(headerData.customHeaderTitle)}}\" ng-bind-html=\"headerData.customHeaderTitle\"></h1><div class=\"subheader-account\" ng-if=\"(\'SHOW_ACCOUNT_BTN_SUBHEADER\' | config)\"><a data-mipqa=\"header-link-settings-unlogged\" class=\"account link-head unlogged\" ng-href=\"{{\'URLMGR_SETTINGS-LINK\' | config}}\" ng-if=\"!userLogged && !(\'HIDE_ACCOUNT_HEADER_BUTTON\' | config)\" title=\"(\'WEBAPP_LABEL_LOGIN\' | dictionary)\"><span class=\"icon-account_spento\"></span></a><a data-mipqa=\"header-link-settings-logged\" class=\"account logged link-head\" ng-class=\"{\'fbImage\':avatar}\" ng-href=\"{{\'LOGGED_SETTINGS_LINK\' | config}}\" ng-if=\"userLogged && !(\'HIDE_ACCOUNT_HEADER_BUTTON\' | config)\" data-label=\"{{\'WEBAPP_HEADER_ICON_ACCOUNT_TITLE\' | dictionary }}\" title=\"(\'WEBAPP_HEADER_ICON_ACCOUNT_TITLE\' | dictionary)\"><span class=\"icon-account_spento\"></span></a></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/header/header_cloud.html","<div class=\"navbar\" role=\"navigation\" id=\"main-header\" ng-if=\"!(\'HIDE_MAIN_HEADER\'|config)\"><nav class=\"primary-nav\" ng-show=\"currentStateHasPrimaryHeader\"><ul><li><a class=\"link-head logo\" data-mipqa=\"logo-link\" ng-click=\"goTo(\'home\')\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\"></a></li><li><a data-mipqa=\"{{ userLogged ? \'header-link-settings-logged\' : \'header-link-settings-unlogged\' }}\" class=\"account link-head\" ng-class=\"{\'logged\' : userLogged}\" ng-href=\"{{userLogged ? (\'LOGGED_SETTINGS_LINK\' | config) : (\'URLMGR_SETTINGS-LINK\' | config)}}\" ng-if=\"!(\'HIDE_ACCOUNT_HEADER_BUTTON\' | config)\" data-label=\"{{\'WEBAPP_HEADER_ICON_ACCOUNT_TITLE\' | dictionary }}\"><span class=\"icon-account_spento\" ng-if=\"userLogged\"></span><dictionary key=\"\'WEBAPP_LABEL_LOGIN\'\" ng-if=\"!userLogged\"></dictionary></a></li></ul></nav><div ng-if=\"(\'SHOW_TEXT_HEADER_OPERATORS\' | config)\" class=\"text-header-box\" id=\"header-text\"><div ng-if=\"userLogged\"><dictionary key=\"\'WEBAPP_HOME_IS_LOGGED\'\"></dictionary></div><div ng-if=\"!userLogged\"><dictionary key=\"\'WEBAPP_HOME_NOT_LOGGED\'\"></dictionary></div></div><h4 class=\"hfooter text-center\" ng-show=\"overHeader\"><span ng-repeat=\"link in links\"><a href=\"{{link.url}}\">{{link.label}}</a></span></h4><div class=\"header-secondary-nav\" ng-if=\"currentStateHasSecondaryHeader\"><button class=\"backBtn\" data-mipqa=\"btn-back\" ng-click=\"headerBack($event);\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\"><span class=\"icon-back\"></span></button><p ng-if=\"isProfile\"><dictionary key=\"\'WEBAPP_STATUS_PROFILE\'\"></dictionary></p><h1 dir=\"{{setDir(headerData.customHeaderTitle)}}\" ng-bind-html=\"headerData.customHeaderTitle\"></h1></div></div><div class=\"header-secondary-nav-fixed\" ng-if=\"currentStateHasFixedHeader\"><button class=\"backBtn\" data-mipqa=\"btn-back\" ng-click=\"headerBack($event);\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\"><span class=\"icon-back\"></span></button><h1 dir=\"{{setDir(headerData.customHeaderTitle)}}\" ng-bind-html=\"headerData.customHeaderTitle\"></h1></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/header/header_cn.html","<div class=\"navbar\" role=\"navigation\" id=\"main-header\" ng-if=\"!(\'HIDE_MAIN_HEADER\'|config)\" ng-class=\"{\'op-text-visible\':(\'SHOW_TEXT_HEADER_OPERATORS\' | config)}\"><nav class=\"primary-nav\" ng-show=\"currentStateHasPrimaryHeader\"><a class=\"link-head logo\" data-mipqa=\"logo-link\" ng-click=\"goTo(\'home\')\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\"></a><ul><li><a class=\"explore link-head arrow-top\" data-mipqa=\"header-link-explore\" ng-class=\"{\'arrow-top--light\' : headerData.showinfo, \'arrow-top--dark\' : !headerData.showinfo}\" ng-click=\"goTo(\'explore\')\" data-label=\"{{\'WEBAPP_HEADER_ICON_EXPLORE_TITLE\' | dictionary }}\"><span class=\"icon-search_spento\"></span></a></li><li><a data-mipqa=\"header-link-settings-logged\" class=\"account logged link-head arrow-top arrow-top--dark\" ng-class=\"{\'fbImage\':avatar}\" ng-href=\"{{\'LOGGED_SETTINGS_LINK\' | config}}\" ng-if=\"userLogged && !(\'HIDE_ACCOUNT_HEADER_BUTTON\' | config)\" data-label=\"{{\'WEBAPP_HEADER_ICON_ACCOUNT_TITLE\' | dictionary }}\"><span ng-if=\"!avatar\" class=\"icon-account_spento\"></span><span ng-if=\"avatar\" class=\"avatar\"><img ng-src=\"{{avatar}}\" class=\"img-responsive fb-image\"></span></a></li><li><a data-mipqa=\"header-link-settings-unlogged\" class=\"account link-head arrow-top arrow-top--dark unlogged\" ng-href=\"{{\'URLMGR_SETTINGS-LINK\' | config}}\" ng-if=\"!userLogged && !(\'HIDE_ACCOUNT_HEADER_BUTTON\' | config)\"><span class=\"icon-account_acceso\"></span><span class=\"btn\"><dictionary key=\"\'WEBAPP_LABEL_LOGIN\'\"></dictionary></span></a></li></ul></nav><div ng-if=\"(\'SHOW_TEXT_HEADER_OPERATORS\' | config)\" class=\"text-header-box\" id=\"header-text\"><div ng-if=\"userLogged\"><dictionary key=\"\'WEBAPP_HOME_IS_LOGGED\'\"></dictionary></div><div ng-if=\"!userLogged\"><dictionary key=\"\'WEBAPP_HOME_NOT_LOGGED\'\"></dictionary></div></div><h4 class=\"hfooter text-center\" ng-show=\"overHeader\"><span ng-repeat=\"link in links\"><a href=\"{{link.url}}\">{{link.label}}</a></span></h4><div class=\"header-secondary-nav\" ng-if=\"currentStateHasSecondaryHeader\"><button class=\"backBtn\" data-mipqa=\"btn-back\" ng-click=\"headerBack($event);\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\"><span class=\"icon-back\"></span></button><p ng-if=\"isProfile\"><dictionary key=\"\'WEBAPP_MYLIST_TITLE\'\"></dictionary></p><h1 ng-if=\"customHeader\" dir=\"{{setDir(headerData.customHeaderTitle)}}\" ng-bind-html=\"headerData.customHeaderTitle\"></h1></div></div><div class=\"header-secondary-nav-fixed\" ng-if=\"currentStateHasFixedHeader\"><button class=\"backBtn\" data-mipqa=\"btn-back\" ng-click=\"headerBack($event);\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\"><span class=\"icon-back\"></span></button><h1 dir=\"{{setDir(headerData.customHeaderTitle)}}\" ng-bind-html=\"headerData.customHeaderTitle\"></h1></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/header/header_hamburger.html","<div class=\"navbar\" role=\"navigation\" id=\"main-header\" ng-if=\"!(\'HIDE_MAIN_HEADER\'|config)\" ng-class=\"{\'menu-open\' : showMenu, \'anim\' : anim}\"><div ng-if=\"(\'SVG_HEADER_INJECTED\' | config) && headerSvg\" class=\"headersvg\" data-src=\"{{headerSvg}}\"></div><nav class=\"primary-nav\"><ul><li><a class=\"link-head logo\" data-mipqa=\"logo-link\" ng-click=\"goTo(\'home\')\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\"></a></li><li class=\"icons\"><ul class=\"head-icons\"><li ng-if=\"(\'SHOW_CONTEST_LINK\' | config) && (\'ROUTER_CONTEST\' | config) && (\'ENABLE_CONTEST\' | config)\"><a class=\"contest link-headMT\" data-mipqa=\"header-link-contest\" ng-click=\"goTo(\'contest\')\" data-label=\"{{\'WEBAPP_GAMIFICATION_HEADER_ICON_TITLE\' | dictionary }}\"><span class=\"icon-coppa\"></span></a></li><li><a class=\"explore link-headMT arrow-top\" data-mipqa=\"header-link-explore\" ng-class=\"{\'arrow-top--light\' : headerData.showinfo, \'arrow-top--dark\' : !headerData.showinfo}\" ng-click=\"goTo(\'explore\')\" data-label=\"{{\'WEBAPP_HEADER_ICON_EXPLORE_TITLE\' | dictionary }}\"><span class=\"icon-search_spento\"></span></a></li><li ng-if=\"userLogged && !(\'HIDE_ACCOUNT_HEADER_BUTTON\' | config)\"><a data-mipqa=\"header-link-settings-logged\" class=\"account logged link-headMT\" ng-class=\"{\'fbImage\':avatar}\" ng-href=\"{{\'LOGGED_SETTINGS_LINK\' | config}}\" data-label=\"{{\'WEBAPP_HEADER_ICON_ACCOUNT_TITLE\' | dictionary }}\"><span class=\"account\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 142 142\"><g transform=\"translate(44.5,37.4)\"><g><ellipse cx=\"27.2\" cy=\"14.5\" rx=\"14.5\" ry=\"14.5\" fill=\"#fff\"/><path d=\"M0 57.2c0 0 3.5-25 27.2-25c23.8 0 25.8 25 25.8 25c0 0-8 10-25.8 10c-17.7 0-27.2-10-27.2-10Z\" fill=\"#fff\"/></g></g></svg></span></a></li><li ng-if=\"!userLogged && !(\'HIDE_ACCOUNT_HEADER_BUTTON\' | config)\"><a data-mipqa=\"header-link-settings-unlogged\" class=\"account link-headMT unlogged\" ng-href=\"{{\'URLMGR_SETTINGS-LINK\' | config}}\"><span class=\"account\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 142 142\"><g transform=\"translate(44.5,37.4)\"><g><ellipse cx=\"27.2\" cy=\"14.5\" rx=\"14.5\" ry=\"14.5\" fill=\"#fff\"/><path d=\"M0 57.2c0 0 3.5-25 27.2-25c23.8 0 25.8 25 25.8 25c0 0-8 10-25.8 10c-17.7 0-27.2-10-27.2-10Z\" fill=\"#fff\"/></g></g></svg></span></a></li><li><button data-mipqa=\"header-link-hub\" class=\"hamburger link-headMT\" ng-class=\"{\'menu-open\':showMenu}\" ng-click=\"triggerMenuAnim()\"><span class=\"hamburgerSvg\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 142 142\" id=\"hamburger\" ng-class=\"{\'invert\' : showMenu}\"><g class=\"hambGroup\" transform=\"translate(37.5,48.5)\" ng-class=\"{\'anim\': anim}\"><path d=\"M.5 48h67\" stroke=\"#fff\" fill=\"none\" stroke-width=\"9\"/><path d=\"M.5 24h67\" stroke=\"#fff\" fill=\"none\" stroke-width=\"9\"/><path d=\"M0 0h67\" stroke=\"#fff\" fill=\"none\" stroke-width=\"9\"/></g><g class=\"xGroup\" transform=\"translate(47.3,50.8)\" ng-class=\"{\'anim\' : anim}\"><path d=\"M0 0l47.4 47.4\" stroke=\"#fff\" fill=\"none\" stroke-width=\"9\"/><path d=\"M0 47.4l47.4-47.4\" stroke=\"#fff\" fill=\"none\" stroke-width=\"9\"/></g></svg></span></button></li></ul></li></ul></nav><div class=\"hub-menu\" ng-class=\"{\'shown\' : showMenu, \'transition\':anim}\"><ul><li><a data-mipqa=\"header-link-menu-games\" class=\"link-hub menu1\" ng-click=\"addToken($event, menu.link1 )\" href=\"{{menu.link1}}\"><dictionary key=\"\'WEBAPP_HEADER_HUBMENU_TITLE_1\'\"></dictionary></a></li><li><a data-mipqa=\"header-link-menu-store\" class=\"link-hub menu2\" ng-click=\"addToken($event, menu.link2)\" href=\"{{menu.link2}}\"><dictionary key=\"\'WEBAPP_HEADER_HUBMENU_TITLE_2\'\"></dictionary></a></li><li><a data-mipqa=\"header-link-menu-news\" class=\"link-hub menu3\" ng-click=\"addToken($event, menu.link3)\" href=\"{{menu.link3}}\"><dictionary key=\"\'WEBAPP_HEADER_HUBMENU_TITLE_3\'\"></dictionary></a></li></ul></div></div><div class=\"header-secondary-nav\" ng-if=\"currentStateHasSecondaryHeader\"><button class=\"backBtn\" data-mipqa=\"btn-back\" ng-click=\"headerBack($event);\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\"><span class=\"icon-back\"></span></button><h1 dir=\"{{setDir(headerData.customHeaderTitle)}}\" ng-bind-html=\"headerData.customHeaderTitle\"></h1></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/header/header_mt.html","<div class=\"navbar\" role=\"navigation\" id=\"main-header\" ng-if=\"!(\'HIDE_MAIN_HEADER\'|config)\" ng-class=\"{\'menu-open\' : showMenu, \'anim\' : anim}\"><div ng-if=\"(\'SVG_HEADER_INJECTED\' | config) && headerSvg\" class=\"headersvg\" data-src=\"{{headerSvg}}\"></div><nav class=\"primary-nav\" ng-show=\"currentStateHasPrimaryHeader\"><ul><li><a class=\"link-headMT logo logo-anim\" ng-class=\"{\'menu-open\' : showMenu}\" data-mipqa=\"logo-link\" href=\"{{parentLink}}\" ng-click=\"addToken($event, parentLink)\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\"></a></li><li class=\"icons\"><ul class=\"head-icons\"><li><a data-mipqa=\"{{ userLogged ? \'header-link-settings-logged\' : \'header-link-settings-unlogged\' }}\" class=\"account link-headMT\" ng-class=\"{\'logged\' : userLogged}\" ng-click=\"addToken($event, accountLink)\" href=\"{{accountLink}}\" data-label=\"{{\'WEBAPP_HEADER_ICON_ACCOUNT_TITLE\' | dictionary }}\"><span class=\"account\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 142 142\"><g transform=\"translate(44.5,37.4)\"><g><ellipse cx=\"27.2\" cy=\"14.5\" rx=\"14.5\" ry=\"14.5\" fill=\"#fff\"/><path d=\"M0 57.2c0 0 3.5-25 27.2-25c23.8 0 25.8 25 25.8 25c0 0-8 10-25.8 10c-17.7 0-27.2-10-27.2-10Z\" fill=\"#fff\"/></g></g></svg></span></a></li><li><button data-mipqa=\"header-link-hub\" class=\"hamburger link-headMT\" ng-class=\"{\'menu-open\':showMenu}\" ng-click=\"triggerMenuAnim()\"><span class=\"hamburgerSvg\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 142 142\" id=\"hamburger\" ng-class=\"{\'invert\' : showMenu}\"><g class=\"hambGroup\" transform=\"translate(37.5,48.5)\" ng-class=\"{\'anim\': anim}\"><path d=\"M.5 48h67\" stroke=\"#fff\" fill=\"none\" stroke-width=\"9\"/><path d=\"M.5 24h67\" stroke=\"#fff\" fill=\"none\" stroke-width=\"9\"/><path d=\"M0 0h67\" stroke=\"#fff\" fill=\"none\" stroke-width=\"9\"/></g><g class=\"xGroup\" transform=\"translate(47.3,50.8)\" ng-class=\"{\'anim\' : anim}\"><path d=\"M0 0l47.4 47.4\" stroke=\"#fff\" fill=\"none\" stroke-width=\"9\"/><path d=\"M0 47.4l47.4-47.4\" stroke=\"#fff\" fill=\"none\" stroke-width=\"9\"/></g></svg></span></button></li></ul></li></ul></nav><div class=\"hub-menu\" ng-class=\"{\'shown\' : showMenu, \'transition\':anim}\"><ul><li><a data-mipqa=\"header-link-menu-minigames\" class=\"link-hub mini\" ng-click=\"addToken($event, menu.link1 )\" href=\"{{menu.link1}}\"><dictionary key=\"\'WEBAPP_HEADER_MENU_TITLE_MINIGAMES\'\"></dictionary></a></li><li><a data-mipqa=\"header-link-menu-esport\" class=\"link-hub esports\" ng-click=\"addToken($event, menu.link2)\" href=\"{{menu.link2}}\"><dictionary key=\"\'WEBAPP_HEADER_MENU_TITLE_ESPORTS\'\"></dictionary></a></li></ul></div></div><div class=\"header-secondary-nav\" ng-if=\"currentStateHasSecondaryHeader\"><button class=\"backBtn\" data-mipqa=\"btn-back\" ng-click=\"headerBack($event);\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\"><span class=\"icon-back\"></span></button><h1 dir=\"{{setDir(headerData.customHeaderTitle)}}\" ng-bind-html=\"headerData.customHeaderTitle\"></h1></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/header/header_orange.html","<nav class=\"navbar\" role=\"navigation\" id=\"main-header\"><ul><li class=\"home-tab\"><a data-mipqa=\"header-link-home\" ng-click=\"goTo(\'home\',(\'WEBAPP_HEADER_ICON_HOME_TITLE\' | dictionary))\"><span class=\"icon-home\"></span><dictionary key=\"\'WEBAPP_HEADER_ICON_HOME_TITLE\'\"></dictionary></a></li><li ng-if=\"(\'SHOW_CONTEST_LINK\' | config) && (\'ROUTER_CONTEST\' | config) && (\'ENABLE_CONTEST\' | config)\" class=\"contest-tab\"><a data-mipqa=\"header-link-contest\" ng-click=\"goTo(\'contest\',(\'WEBAPP_GAMIFICATION_HEADER_ICON_TITLE\' | dictionary))\"><span class=\"icon-coppa\"></span><dictionary key=\"\'WEBAPP_GAMIFICATION_HEADER_ICON_TITLE\'\"></dictionary></a></li><li class=\"explore-tab\"><a data-mipqa=\"header-link-explore\" ng-click=\"goTo(\'explore\',(\'WEBAPP_HEADER_ICON_EXPLORE_TITLE\' | dictionary))\"><span class=\"icon-explore\"></span><dictionary key=\"\'WEBAPP_HEADER_ICON_EXPLORE_TITLE\'\"></dictionary></a></li><li class=\"search-tab\"><a data-mipqa=\"header-link-search\" ng-click=\"goTo(\'search\',(\'WEBAPP_HEADER_ICON_SEARCH_TITLE\' | dictionary))\"><span class=\"icon-search\"></span><dictionary key=\"\'WEBAPP_HEADER_ICON_SEARCH_TITLE\'\"></dictionary></a></li><li class=\"account-tab\"><a data-mipqa=\"header-link-settings\" ng-click=\"goTo(\'settings\',(\'WEBAPP_HEADER_ICON_ACCOUNT_TITLE\' | dictionary))\"><span class=\"icon-account\"></span><dictionary key=\"\'WEBAPP_HEADER_ICON_ACCOUNT_TITLE\'\"></dictionary></a></li></ul></nav><div class=\"elements subHeader {{headerData.listType}} list-{{headerData.listId}}\" ng-if=\"(customHeader && fullHeader)\"><a class=\"header-back\" data-mipqa=\"btn-back\" ng-click=\"headerBack($event);\" title=\"{{\'WEBAPP_HEADER_BACK_TITLE\' | dictionary }}\"><span class=\"icon-back\"></span><dictionary key=\"\'WEBAPP_HEADER_BACK_TITLE\'\"></dictionary></a><h1 dir=\"{{setDir(headerData.customHeaderTitle)}}\" ng-bind-html=\"headerData.customHeaderTitle\"></h1><div class=\"labelImg\" style=\"background-image:url({{labelImg}})\"></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/home/homePageBase.html","<div ng-cloak><div class=\"custom-banner\" ng-if=\"(\'SHOW_CUSTOM_BANNER\'|config)\"><a title=\"{{(\'WEBAPP_URL_CUSTOM_BANNER\' | dictionary)}}\" href=\"{{(\'WEBAPP_URL_CUSTOM_BANNER\' | dictionary)}}\" target=\"_blank\"><picture><img ng-if=\"$root.currLang !== \'ar\'\" ng-src=\"{{ \'CUSTOM_BANNER\' | config }}\" alt=\"{{(\'WEBAPP_URL_CUSTOM_BANNER\'| dictionary)}}\"> <img ng-if=\"$root.currLang === \'ar\'\" ng-src=\"{{ \'CUSTOM_BANNER_AR\' | config }}\" alt=\"{{(\'WEBAPP_URL_CUSTOM_BANNER\'| dictionary)}}\"></picture></a></div><contest-home-section></contest-home-section><items size=\"8\" slider=\"carousel\" tmplname=\"imgslider.html\" imgratio=\"ratio_2\" labelslug=\"topGames\" class=\"slider slider-topGames\" dataindex=\"topGames\" sliderconf=\"TOPGAMES_SLIDER_CONF\" formaticons=\"true\"></items><in-page-adv position=\"top\"></in-page-adv><div class=\"slider-content alternatedList\" ng-if=\"history\" ng-show=\"historyList\"><items size=\"8\" slider=\"slider\" sliderconf=\"USERITEMS_SLIDER_CONF\" imgratio=\"ratio_1_4\" tmplname=\"imgsliderSmall.html\" history=\"history\" section=\"recently_played\" gotolist=\"goToList(\'history\')\" class=\"small slider slider-recently_played\" dataindex=\"recently_played\" slidertitle=\"{{\'WEBAPP_LAST_PLAYED\' | dictionary}}\" formaticons=\"true\"></items></div><div class=\"alternatedList\" ng-class=\"{ \'lab\' : list.islabel, \'cat\':list.iscategory }\" ng-repeat=\"list in miscList\" ng-if=\"miscList.length\"><div class=\"spot-content\" ng-if=\"(($even && list.islabel) || ($odd && list.islabel))\" ng-hide=\"emptylist[list.id]\"><h2 ng-bind-html=\"list.name\" dir=\"{{setDir(list.name)}}\"></h2><h3 class=\"h3 btn-chevron\"><a ng-click=\"goLabel(list)\" data-mipqa=\"btn-go-to-list\" title=\"{{\'WEBAPP_LOAD_OTHER_CONTENTS\' | dictionary}}\" class=\"btn\"><dictionary key=\"\'WEBAPP_LOAD_OTHER_CONTENTS\'\"></dictionary><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span></a></h3><items size=\"{{getItemsNumber(\'card\')}}\" formaticons=\"true\" tmplname=\"itemSpot.html\" label=\"list\" imgratio=\"ratio_1_5\"></items></div><div class=\"slider-content\" ng-if=\"($odd && list.iscategory) || ($even && list.iscategory)\"><items size=\"8\" slider=\"slider\" imgratio=\"ratio_1_4\" sliderconf=\"USERITEMS_SLIDER_CONF\" tmplname=\"imgsliderSmall.html\" category=\"list\" section=\"category{{$parent.$index | round }}\" class=\"small slider slider-{{$index}}\" dataindex=\"{{$index}}\" slidertitle=\"{{list.name | titleCase}}\" gotolist=\"goCategory(list)\" shufflegames=\"$root.shuffleHome\" formaticons=\"true\"></items><hybrid-install extendedclass=\"midpage\" postype=\"midpage\" ng-show=\"showMidBanner && $index == 1\"></hybrid-install></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/home/homePage_asiacell.html","<div ng-cloak><contest-home-section></contest-home-section><div class=\"mixedContent\"><items highlighted=\"true\" size=\"10\" slider=\"carousel\" tmplname=\"imgslider.html\" imgratio=\"ratio_2\" label=\"topGamesLabel\" class=\"slider slider-topGames\" dataindex=\"topGames\" sliderconf=\"TOPGAMES_SLIDER_CONF\"></items></div><div class=\"alternatedList\" ng-repeat=\"list in miscList track by $index\" ng-if=\"miscList.length\"><div class=\"slider-content ratio_2 list-{{list.id}}\" ng-if=\"$odd\" ng-class=\"{\'zoomies\' : $odd && $index === 3 }\"><items size=\"4\" slider=\"slider\" imgratio=\"ratio_2\" sliderconf=\"{{list.sliderConf}}\" tmplname=\"imgsliderComplete.html\" category=\"list\" section=\"label{{$parent.$index | round }}\" class=\"small slider slider-{{$index}}\" dataindex=\"{{$index}}\" slidertitle=\"{{list.name | titleCase}}\" gotolist=\"goLabel(list)\" shufflegames=\"$root.shuffleHome\" formaticons=\"true\" list=\"list\"></items></div><div class=\"slider-content ratio_1 list-{{list.id}}\" data-slug=\"{{list.slug}}\" ng-if=\"$even\"><items size=\"10\" slider=\"slider\" imgratio=\"ratio_1\" sliderconf=\"{{list.sliderConf}}\" tmplname=\"imgsliderComplete.html\" label=\"list\" section=\"label{{$parent.$index | round }}\" class=\"small slider slider-{{$index}}\" dataindex=\"{{$index}}\" slidertitle=\"{{list.name | titleCase}}\" gotolist=\"goLabel(list)\" shufflegames=\"$root.shuffleHome\" formaticons=\"true\" list=\"list\"></items></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/home/homePage_categories.ctr.html","<listnav selectedlist=\"selectedlist\" ng-if=\"!(\'HIDE_LISTNAV\' | config)\"></listnav><items size=\"8\" slider=\"carousel\" tmplname=\"imgslider.html\" imgratio=\"ratio_1_5\" labelslug=\"topGames\" class=\"slider slider-topGames\" dataindex=\"topGames\" sliderconf=\"TOPGAMES_SLIDER_CONF\" formaticons=\"true\"></items><div class=\"recent cropped mygames\" ng-if=\"userData.logged && ((\'ACTIVITY_HISTORY\'|config) || (\'ACTIVITY_FAVORITES\'|config))\"><h2 class=\"title-and-more\" ng-click=\"goTo(\'favorites\')\"><dictionary key=\"\'WEBAPP_MYLIST_TITLE\'\"></dictionary></h2><items dataindex=\"mygames\" section=\"userList\" class=\"small slider slider-mygames\" readyitems=\"myGames\" size=\"6\" shufflegames=\"$root.shuffle\" useoutertitle=\"true\" imgratio=\"ratio_1\" slider=\"slider\" sliderconf=\"MYGAMES_SLIDER_CONF\" tmplname=\"imgsliderSmall.html\"></items><h3 ng-show=\"myGames\"><dictionary key=\"\'WEBAPP_LOAD_OTHER_CONTENTS\'\"></dictionary></h3><activitynav></activitynav></div><div class=\"cat-game-items cropped\"><h2 class=\"title-and-more\" ng-click=\"goToCat(randomCategory)\">{{randomCategory.name}}<span class=\"more\"></span></h2><items ng-hide=\"showNoResults\" size=\"3\" tmplname=\"boxedList.html\" category=\"randomCategory.id\" shufflegames=\"$root.shuffleLists\" imgratio=\"ratio_2\" formaticons=\"true\"></items></div><div class=\"cat-items\"><h2 dir=\"{{setDir((\'WEBAPP_EXPLORE_LATEST\' | dictionary))}}\">{{(\'WEBAPP_EXPLORE_LATEST\' | dictionary)}}</h2><div class=\"container\"><div ng-repeat=\"category in categories track by $index\"><img class=\"img-responsive b-lazy\" ng-click=\"goToCat(category)\" lazy-img=\"{{category.url_cover}}\" ng-src=\"{{\'ratio_1\' | config | imageSize:1:1}}\" title=\"{{category.name}}\"><span class=\"cat-name\" ng-style=\"{color: catItem[$index]}\">{{category.name}}</span></div></div></div><div class=\"our-selection\"><h2 class=\"title-and-more\" ng-click=\"goToLab(ourGames)\" dir=\"{{setDir((\'WEBAPP_EXPLORE_MOST_POPULAR\' | dictionary))}}\">{{(\'WEBAPP_EXPLORE_MOST_POPULAR\' | dictionary)}}<span class=\"more\"></span></h2><items ng-hide=\"showNoResults\" size=\"10\" sizecrop=\"2\" offset=\"{{ourGamesOffset}}\" tmplname=\"boxedList.html\" label=\"ourGames\" shufflegames=\"true\" imgratio=\"ratio_2\" formaticons=\"true\"></items></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/home/homePage_cloud.html","<div class=\"home-cloud\" ng-cloak><search-field></search-field><div class=\"cloud-grid\"><div class=\"slider {{getRatioConf(\'home_slider_1\', \'ratio_2\')}}\" data-gridsection=\"slider_ratio_2\"><items size=\"12\" slider=\"slider\" imgratio=\"{{getRatioConf(\'home_slider_1\', \'ratio_2\')}}\" sliderconf=\"USERITEMS_SLIDER_CONF_AR_2\" tmplname=\"slider_cloud.html\" category=\"slider_ratio_2\" section=\"label{{$parent.$index | round }}\" class=\"slider slider-{{slider_ratio_2.id}}\" dataindex=\"{{slider_ratio_2.id}}\" slidertitle=\"{{slider_ratio_2.name | titleCase}}\" gotolist=\"goLabel(slider_ratio_2)\" shufflegames=\"(\'SHUFFLE_HOME_TOP_CHART\' | config)\" formaticons=\"true\" list=\"slider_ratio_2\"></items></div><div class=\"banner-container feature\" data-gridsection=\"feature_banner\" ng-if=\"userLogged\" ng-hide=\"featureHidden\"><banner-cloud class=\"favorites-banner\" destination=\"\'favorites\'\" maintext=\"\'WEBAPP_FEATURE_BANNER_TITLE\'\" secondarytext=\"\'WEBAPP_FEATURE_BANNER_TEXT\'\"></banner-cloud></div><div class=\"list-history\" ng-if=\"userLogged\" ng-show=\"historyList\"><div class=\"list-details\"><h2 class=\"list-box-title\" ng-click=\"goTo(\'history\')\" data-mipqa=\"btn-go-to-list\" dir=\"{{setDir((\'WEBAPP_LAST_PLAYED\' | config))}}\"><dictionary key=\"\'WEBAPP_CONTINUE_PLAYING\'\"></dictionary></h2><button ng-if=\"!useoutertitle\" ng-click=\"goTo(\'history\')\" type=\"button\" data-mipqa=\"btn-go-to-list\" title=\"{{\'WEBAPP_SHOW_MORE\' | dictionary}}\" class=\"list-showmore\"><dictionary key=\"\'WEBAPP_SHOW_MORE\'\"></dictionary></button></div><items size=\"3\" tmplname=\"boxedList_cloud.html\" history=\"history\" imgratio=\"{{getRatioConf(\'home_history\', \'ratio_1\')}}\"></items></div><div class=\"slider {{getRatioConf(\'home_slider_2\', \'ratio_1_4\')}}\" data-gridsection=\"slider_ratio_1_4\"><items size=\"30\" sizecrop=\"12\" slider=\"slider\" imgratio=\"{{getRatioConf(\'home_slider_2\', \'ratio_1_4\')}}\" sliderconf=\"USERITEMS_SLIDER_CONF_AR_1_4\" tmplname=\"slider_cloud.html\" category=\"slider_ratio_1_4\" section=\"label{{$parent.$index | round }}\" class=\"slider slider-{{slider_ratio_1_4.id}}\" dataindex=\"{{slider_ratio_1_4.id}}\" slidertitle=\"{{slider_ratio_1_4.name | titleCase}}\" gotolist=\"goLabel(slider_ratio_1_4)\" shufflegames=\"(\'SHUFFLE_HOME_OTHER_CHARTS\' | config)\" formaticons=\"true\" list=\"slider_ratio_1_4\"></items></div><div class=\"banner-container chart\" data-gridsection=\"chart_banner\" ng-if=\"!userLogged\"><banner-cloud destination=\"\" maintext=\"\'WEBAPP_GAMES_BANNER_TITLE\'\" secondarytext=\"\'WEBAPP_GAMES_BANNER_TEXT\'\"></banner-cloud></div><div class=\"slider {{getRatioConf(\'home_slider_1\', \'ratio_2\')}}\" data-gridsection=\"slider_ratio_2_2\"><items size=\"30\" sizecrop=\"12\" slider=\"slider\" imgratio=\"{{getRatioConf(\'home_slider_1\', \'ratio_2\')}}\" sliderconf=\"USERITEMS_SLIDER_CONF_AR_2\" tmplname=\"slider_cloud.html\" category=\"slider_ratio_2_2\" section=\"label{{$parent.$index | round }}\" class=\"slider slider-{{slider_ratio_2_2.id}}\" dataindex=\"{{slider_ratio_2_2.id}}\" slidertitle=\"{{slider_ratio_2_2.name | titleCase}}\" gotolist=\"goLabel(slider_ratio_2_2)\" shufflegames=\"(\'SHUFFLE_HOME_OTHER_CHARTS\' | config)\" formaticons=\"true\" list=\"slider_ratio_2_2\"></items></div><div class=\"slider {{getRatioConf(\'home_slider_2\', \'ratio_1_4\')}}\" data-gridsection=\"slider_ratio_1_4_2\"><items size=\"30\" sizecrop=\"12\" slider=\"slider\" imgratio=\"{{getRatioConf(\'home_slider_2\', \'ratio_1_4\')}}\" sliderconf=\"USERITEMS_SLIDER_CONF_AR_1_4\" tmplname=\"slider_cloud.html\" category=\"slider_ratio_1_4_2\" section=\"label{{$parent.$index | round }}\" class=\"slider slider-{{slider_ratio_1_4_2.id}}\" dataindex=\"{{slider_ratio_1_4_2.id}}\" slidertitle=\"{{slider_ratio_1_4_2.name | titleCase}}\" gotolist=\"goLabel(slider_ratio_1_4_2)\" shufflegames=\"(\'SHUFFLE_HOME_OTHER_CHARTS\' | config)\" formaticons=\"true\" list=\"slider_ratio_1_4_2\"></items></div></div><category-grid categories=\"otherCategories\" size=\"30\" boxtitle=\"\'WEBAPP_MENU_CATEGORY\'\"></category-grid><div class=\"cloud-masonry\"><div class=\"list-details\"><p class=\"list-description\"><dictionary key=\"\'WEBAPP_SUGGESTED_SUBTITLE\'\"></dictionary></p><h2 class=\"list-box-title\"><dictionary key=\"\'WEBAPP_SUGGEST\'\"></dictionary></h2></div><div class=\"msnry-cloud-cols\"><imagelazy loadedclass=\"b-loaded\" source=\"pic\" data-ng-repeat=\"pic in pics track by pic.id\"></imagelazy></div><button type=\"button\" ng-show=\"progressiveLoading\" class=\"load_more btn play\" data-mipqa=\"btn-load-more\" ng-click=\"loadMore()\"><dictionary key=\"\'WEBAPP_LOAD_OTHER_CONTENTS\'\"></dictionary></button></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/home/homePage_mt.html","<listnav selectedlist=\"selectedlist\" ng-if=\"!(\'HIDE_LISTNAV\' | config)\"></listnav><search-field></search-field><items size=\"8\" slider=\"carousel\" tmplname=\"imgslider.html\" imgratio=\"ratio_1_5\" labelslug=\"topGames\" class=\"slider slider-topGames\" dataindex=\"topGames\" sliderconf=\"TOPGAMES_SLIDER_CONF\" formaticons=\"true\"></items><div class=\"recent cropped mygames\" ng-if=\"userData.logged && ((\'ACTIVITY_HISTORY\'|config) || (\'ACTIVITY_FAVORITES\'|config))\"><h2 class=\"title-and-more\" ng-click=\"goTo(\'favorites\')\"><dictionary key=\"\'WEBAPP_MYLIST_TITLE\'\"></dictionary></h2><items dataindex=\"mygames\" section=\"userList\" class=\"small slider slider-mygames\" readyitems=\"myGames\" size=\"6\" shufflegames=\"$root.shuffle\" useoutertitle=\"true\" imgratio=\"ratio_1\" slider=\"slider\" sliderconf=\"MYGAMES_SLIDER_CONF\" tmplname=\"imgsliderSmall.html\"></items><h3 ng-show=\"myGames\"><dictionary key=\"\'WEBAPP_LOAD_OTHER_CONTENTS\'\"></dictionary></h3><activitynav></activitynav></div><div class=\"cat-game-items cropped\"><h2 class=\"title-and-more\" ng-click=\"goToCat(randomCategory)\">{{randomCategory.name}}<span class=\"more\"></span></h2><items ng-hide=\"showNoResults\" size=\"3\" tmplname=\"boxedList_mt.html\" category=\"randomCategory.id\" shufflegames=\"$root.shuffleLists\" imgratio=\"ratio_2\" formaticons=\"true\"></items></div><div class=\"cat-items\"><h2 dir=\"{{setDir((\'WEBAPP_EXPLORE_LATEST\' | dictionary))}}\">{{(\'WEBAPP_EXPLORE_LATEST\' | dictionary)}}</h2><div class=\"container\"><div ng-repeat=\"category in categories track by $index\"><img class=\"img-responsive b-lazy\" ng-click=\"goToCat(category)\" lazy-img=\"{{category.url_cover}}\" ng-src=\"{{\'ratio_1\' | config | imageSize:1:1}}\" title=\"{{category.name}}\"><span class=\"cat-name\" ng-style=\"{color: catItem[$index]}\">{{category.name}}</span></div></div></div><div class=\"our-selection\"><h2 class=\"title-and-more\" ng-click=\"goToLab(ourGames)\" dir=\"{{setDir((\'WEBAPP_EXPLORE_MOST_POPULAR\' | dictionary))}}\">{{(\'WEBAPP_EXPLORE_MOST_POPULAR\' | dictionary)}}<span class=\"more\"></span></h2><items ng-hide=\"showNoResults\" size=\"10\" sizecrop=\"2\" offset=\"{{ourGamesOffset}}\" tmplname=\"boxedList_mt.html\" label=\"ourGames\" shufflegames=\"true\" imgratio=\"ratio_2\" formaticons=\"true\"></items></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/home/homePage_orange.html","<div ng-cloak><list-mixed-ratio highlighted=\"true\" ng-if=\"!(\'HOME_MIXED_COMPONENTS\' | config)\" labelslug=\"topGames\" size=\"12\" shufflegames=\"true\" class=\"gridlist\" mixratio=\"HOME_MIXED_RATIO\" tinyimg=\"true\"></list-mixed-ratio><contest-home-section></contest-home-section><div class=\"mixedContent\" ng-if=\"(\'HOME_MIXED_COMPONENTS\' | config)\"><div class=\"mixedTogether\"><list-mixed-ratio highlighted=\"true\" label=\"topGames_1Label\" labelslug=\"topGames_1\" size=\"10\" shufflegames=\"true\" class=\"gridlist\" mixratio=\"HOME_MIXED_COMPONENTS_RATIO\"></list-mixed-ratio><list-mixed-ratio highlighted=\"true\" label=\"topGames_2Label\" labelslug=\"topGames_2\" size=\"10\" shufflegames=\"true\" class=\"gridlist\" mixratio=\"HOME_MIXED_COMPONENTS_RATIO\"></list-mixed-ratio></div><items highlighted=\"true\" size=\"10\" slider=\"carousel\" tmplname=\"imgslider.html\" imgratio=\"ratio_1_5\" label=\"topGamesLabel\" class=\"slider slider-topGames\" dataindex=\"topGames\" sliderconf=\"TOPGAMES_SLIDER_CONF\"></items></div><div class=\"subsbanner promo\" ng-if=\"(\'ALTERNATIVE_SUBSBANNER_HOME\' | config) && (!(\'ALTERNATIVE_SUBSBANNER_HOME_GUEST_ONLY\' | config) || (\'ALTERNATIVE_SUBSBANNER_HOME_GUEST_ONLY\' | config) && guestUser)\"><a ng-href=\"{{\'ALTERNATIVE_SUBSBANNER_HOME_URL\' | config}}\"><img ng-src=\"{{\'additional-banner-2\' | config}}\" alt=\"\" class=\"img-responsive\"></a></div><subs-banner ng-if=\"!(\'SHOW_ADDITIONAL_BANNER_GUEST_ONLY\' | config)\"></subs-banner><div class=\"alternatedList\" ng-repeat=\"list in miscList track by $index\" ng-if=\"miscList.length\"><div class=\"slider-content ratio_1 list-{{list.id}}\" data-slug=\"{{list.slug}}\" ng-if=\"$even\"><items size=\"10\" slider=\"slider\" imgratio=\"ratio_1\" sliderconf=\"{{list.sliderConf}}\" tmplname=\"imgsliderComplete.html\" label=\"list\" section=\"label{{$parent.$index | round }}\" class=\"small slider slider-{{$index}}\" dataindex=\"{{$index}}\" slidertitle=\"{{list.name | titleCase}}\" gotolist=\"goLabel(list)\" shufflegames=\"$root.shuffleHome\" formaticons=\"true\" list=\"list\"></items></div><div ng-if=\"showAdditionalBanner && $index == bannerindex && bannerindexIsEven && $even\" class=\"additional-banner even\"><a ng-mousedown=\"trackBanner()\" ng-href=\"{{additionalBannerUrl}}\" target=\"{{ (\'ADDITIONAL_BANNER_SAME_WINDOW\' | config) ? \'\' : \'_blank\'}}\"><img class=\"img-responsive\" ng-src=\"{{(\'additional-banner\' | config)}}\"></a></div><div class=\"slider-content ratio_2 list-{{list.id}}\" ng-if=\"$odd\" ng-class=\"{\'zoomies\' : $odd && $index === 3 }\"><items size=\"4\" slider=\"slider\" imgratio=\"ratio_2\" sliderconf=\"{{list.sliderConf}}\" tmplname=\"imgsliderComplete.html\" category=\"list\" section=\"label{{$parent.$index | round }}\" class=\"small slider slider-{{$index}}\" dataindex=\"{{$index}}\" slidertitle=\"{{list.name | titleCase}}\" gotolist=\"goLabel(list)\" shufflegames=\"$root.shuffleHome\" formaticons=\"true\" list=\"list\"></items></div><div ng-if=\"showAdditionalBanner && $index == bannerindex && !bannerindexIsEven && $odd\" class=\"additional-banner odd\"><a ng-mousedown=\"trackBanner()\" ng-href=\"{{additionalBannerUrl}}\" target=\"{{ (\'ADDITIONAL_BANNER_SAME_WINDOW\' | config) ? \'\' : \'_blank\'}}\"><img class=\"img-responsive\" ng-src=\"{{(\'additional-banner\' | config)}}\"></a></div></div><subs-banner mini=\"true\"></subs-banner></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/home/homePage_plugin.html","<div class=\"arcade-home-container\" ng-cloak><h1 class=\"home-logo\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\"><div class=\"padding\"></div><img class=\"padding-inner\" ng-src=\"{{(\'logo\' | config)}}\" alt=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\"></h1><div class=\"arcade-home\"><div class=\"item-{{list.id}}\" ng-repeat=\"list in cats track by $index\" ng-if=\"cats.length\"><figure ng-click=\"goToCat(list)\" ng-style=\"{\'background-image\':\'url({{list.url_cover}})\'}\" class=\"padding\" title=\"{{list.name}}\"></figure><button type=\"button\" class=\"btn cat\" ng-click=\"goToCat(list)\">{{list.name}}</button></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/home/homePage_singleList.html","<div id=\"home-singleList\" ng-cloak><h3 class=\"home-ldb-title\" ng-if=\"(\'SHOW_LEADERBOARD\' | config)\" ng-show=\"homeLeaderboard.length\" ng-bind-html=\"ldbSliderTitle\"></h3><imgsliderleaderboard ng-if=\"(\'SHOW_LEADERBOARD\' | config)\" section=\"leaderboard\"></imgsliderleaderboard><div class=\"homeMixed\"><list-mixed-ratio tmplname=\"mixedRatioList.html\" labelslug=\"(\'HOME_SINGLE_LIST\' | config)\" size=\"12\" shufflegames=\"$root.shuffleHome\" class=\"gridlist\" ng-class=\"deviceType\" mixratio=\"HOME_MIXED_RATIO\" forcedcontent=\"true\"></list-mixed-ratio></div><p class=\"text-center\"><a class=\"bottom-link\" ng-click=\"goTo(\'explore\')\"><dictionary key=\"\'WEBAPP_EXPLORE_LINK\'\"></dictionary></a></p><onboarding ng-if=\"(\'SHOW_ONBOARDING\' | config)\"></onboarding></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/home/homePage_sliders.ctr.html","<div class=\"home-news\" ng-cloak><contest-home-section></contest-home-section><a class=\"btn shop\" title=\"{{\'WEBAPP_HOME_PARTNER_LINK\' | dictionary}}\" ng-click=\"goTo(\'shop\')\" ng-if=\"(\'SHOW_PARTNER_LINK\' | config)\"><dictionary key=\"\'WEBAPP_HOME_PARTNER_LINK\'\"></dictionary></a><items size=\"10\" slider=\"carousel\" tmplname=\"cardsCarousel.html\" storelink=\"1\" imgratio=\"ratio_1_4\" labelslug=\"selection.slug\" class=\"slider-cards\" dataindex=\"cards\" sliderconf=\"TOPGAMES_SLIDER_CONF\"></items><div class=\"home-news--list\" ng-repeat=\"list in lists track by $index\" ng-if=\"!list.isEmpty\"><h2 class=\"sections-title\" dir=\"{{setDir(list.name)}}\" ng-click=\"goToLab(list)\" data-mipqa=\"btn-go-to-list\"><span ng-bind-html=\"list.name\"></span></h2><items ng-if=\"list\" dataindex=\"{{list.id}}\" section=\"label_list\" label=\"list\" class=\"small slider slider-{{list.id}}\" size=\"10\" shufflegames=\"$root.shuffle\" useoutertitle=\"true\" showmoreactive=\"true\" imgratio=\"ratio_1\" gotolist=\"goToList(list)\" slider=\"slider\" sliderconf=\"SMALLSLIDER_OPTIONS\" tmplname=\"imgsliderSmall.html\" slidertitle=\"{{list.name | titleCase}}\"></items></div><h2 ng-if=\"(\'SHOW_NEWS\' | config)\" class=\"sections-title news\" dir=\"{{setDir((\'WEBAPP_HOME_NEWS_LIST\' | dictionary))}}\" ng-click=\"goTo(\'news\')\" data-mipqa=\"btn-go-to-list\" title=\"{{\'WEBAPP_HOME_NEWS_LIST\' | dictionary}}\"><dictionary key=\"\'WEBAPP_HOME_NEWS_LIST\'\"></dictionary></h2><slider-news size=\"8\" imgratio=\"ratio_1_5\" ng-if=\"(\'SHOW_NEWS\' | config)\" showmoreactive=\"true\"></slider-news></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/home/homePage_zain.html","<div ng-cloak><contest-home-section></contest-home-section><items size=\"8\" slider=\"carousel\" tmplname=\"imgslider_clickthrough.html\" imgratio=\"ratio_2\" labelslug=\"topGames\" class=\"slider slider-topGames\" dataindex=\"topGames\" sliderconf=\"TOPGAMES_SLIDER_CONF\" formaticons=\"true\"></items><div class=\"alternatedList history\"><div class=\"slider-content history\" ng-if=\"history\" ng-show=\"historyList\"><div class=\"outer-title\"><h2 dir=\"{{setDir((\'WEBAPP_LAST_PLAYED\' | dictionary))}}\"><dictionary key=\"\'WEBAPP_LAST_PLAYED\'\"></dictionary></h2><h3 class=\"h3 btn-chevron\"><a ng-click=\"goToList(\'history\')\" data-mipqa=\"btn-go-to-list\" title=\"{{\'WEBAPP_LOAD_OTHER_CONTENTS\' | dictionary}}\" class=\"btn\"><dictionary key=\"\'WEBAPP_LOAD_OTHER_CONTENTS\'\"></dictionary><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span></a></h3></div><items size=\"8\" slider=\"slider\" sliderconf=\"USERITEMS_SLIDER_CONF\" imgratio=\"ratio_1_5\" tmplname=\"imgsliderComplete.html\" history=\"history\" section=\"recently_played\" gotolist=\"goToList(\'history\')\" class=\"small slider slider-recently_played\" dataindex=\"recently_played\" useoutertitle=\"true\" formaticons=\"true\"></items></div></div><div class=\"alternatedList\" ng-class=\"{ \'lab\' : list.islabel, \'cat\':list.iscategory }\" ng-repeat=\"list in miscList\" ng-if=\"miscList.length\"><div class=\"slider-content\" ng-if=\"(($even && list.iscategory) || ($odd && list.iscategory))\" ng-hide=\"emptylist[list.id]\"><div class=\"outer-title\"><h2 ng-bind-html=\"list.name\" dir=\"{{setDir(list.name)}}\"></h2></div><items size=\"2\" formaticons=\"false\" tmplname=\"boxedList_cloud.html\" label=\"list\" imgratio=\"ratio_2\"></items></div><div class=\"slider-content\" ng-if=\"($odd && list.islabel) || ($even && list.islabel)\"><div class=\"outer-title\"><h2 ng-bind-html=\"list.name\" dir=\"{{setDir(list.name)}}\"></h2><h3 class=\"h3 btn-chevron\"><a ng-click=\"goLabel(list)\" data-mipqa=\"btn-go-to-list\" title=\"{{\'WEBAPP_LOAD_OTHER_CONTENTS\' | dictionary}}\" class=\"btn\"><dictionary key=\"\'WEBAPP_LOAD_OTHER_CONTENTS\'\"></dictionary><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span></a></h3></div><items size=\"8\" useoutertitle=\"true\" slider=\"slider\" imgratio=\"ratio_1_5\" sliderconf=\"USERITEMS_SLIDER_CONF\" tmplname=\"imgsliderComplete.html\" category=\"list\" section=\"label{{$parent.$index | round }}\" class=\"small slider slider-{{$index}}\" dataindex=\"{{$index}}\" slidertitle=\"{{list.name | titleCase}}\" gotolist=\"goLabel(list)\" shufflegames=\"$root.shuffleHome\" formaticons=\"true\"></items></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/lists/list_cloud.html","<activitynav ng-if=\"favoritesPage || historyPage\" active=\"{{myList}}\"></activitynav><items ng-hide=\"showNoResults\" size=\"{{itemsize}}\" tmplname=\"boxedList_cloud.html\" category=\"categoryId\" history=\"history\" favorites=\"favorites\" label=\"labelId\" shufflegames=\"$root.shuffleLists\" infinite=\"infiniteScroll\" imgratio=\"{{imgRatioList}}\" formaticons=\"true\"></items><div ng-if=\"showNoResults\" class=\"js-noresults\" ng-class=\"{\'favorites_nores\' : favoritesPage, \'history_nores\' : historyPage} \"><p class=\"general-padding\" ng-if=\"!historyPage && !favoritesPage\"><dictionary key=\"\'WEBAPP_INCOMPATIBLE_LIST\'\"></dictionary></p><p class=\"empty-space\" ng-if=\"(historyPage || favoritesPage) && (!labelId && !categoryId)\" ng-class=\"{\'favorites\' : favoritesPage, \'history\' : historyPage} \"><dictionary ng-if=\"historyPage\" key=\"\'WEBAPP_TEXT_INFO_HISTORY\'\"></dictionary><dictionary ng-if=\"favoritesPage\" key=\"\'WEBAPP_TEXT_INFO_FAVORITES\'\"></dictionary></p><div class=\"list-details\"><h2 class=\"list-box-title\"><dictionary key=\"\'WEBAPP_SUGGEST\'\"></dictionary></h2></div><items latest=\"true\" size=\"6\" tmplname=\"boxedList_cloud.html\" shufflegames=\"$root.shuffle\" imgratio=\"{{imgRatioList}}\" formaticons=\"true\"></items></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/lists/list_general.html","<activitynav ng-if=\"favoritesPage || historyPage\" active=\"{{myList}}\"></activitynav><items ng-hide=\"showNoResults\" size=\"{{itemsize}}\" tmplname=\"boxedList.html\" category=\"categoryId\" history=\"history\" favorites=\"favorites\" label=\"labelId\" shufflegames=\"$root.shuffleLists\" infinite=\"infiniteScroll\" imgratio=\"{{imgRatioList}}\" formaticons=\"true\"></items><div ng-if=\"showNoResults\" class=\"js-noresults\"><p class=\"general-padding\" ng-if=\"!historyPage && !favoritesPage\"><dictionary key=\"\'WEBAPP_INCOMPATIBLE_LIST\'\"></dictionary></p><p class=\"general-padding\" ng-if=\"(historyPage || favoritesPage) && (!labelId && !categoryId)\"><dictionary ng-if=\"historyPage\" key=\"\'WEBAPP_TEXT_INFO_HISTORY\'\"></dictionary><dictionary ng-if=\"favoritesPage\" key=\"\'WEBAPP_TEXT_INFO_FAVORITES\'\"></dictionary></p><h3><dictionary key=\"\'WEBAPP_PLAY_NOW\'\"></dictionary></h3><items latest=\"true\" size=\"6\" tmplname=\"boxedList.html\" shufflegames=\"$root.shuffle\" imgratio=\"{{imgRatioList}}\" formaticons=\"true\" abstract=\"(\'ABSTRACT_IN_LISTS\' | config)\"></items></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/lists/list_mixed.html","<listnav selectedlist=\"selectedlist\" ng-if=\"!(\'HIDE_LISTNAV\' | config)\"></listnav><list-mixed-ratio labelslug=\"labelslug\" ng-if=\"isHome\" class=\"gridlist\" callbackitems=\"setFlags\" mixratio=\"HOME_MIXED_RATIO\" shufflegames=\"$root.shuffleLists\" tinyimg=\"true\"></list-mixed-ratio><items ng-if=\"!isHome\" size=\"{{itemsize}}\" tmplname=\"simpleList.html\" category=\"categoryId\" history=\"history\" favorites=\"favorites\" label=\"labelId\" shufflegames=\"$root.shuffleLists\" infinite=\"infiniteScroll\" imgratio=\"ratio_1\" formaticons=\"true\"></items>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/lists/list_msnry.html","<listnav selectedlist=\"selectedlist\" ng-if=\"!(\'HIDE_LISTNAV\' | config)\"></listnav><div class=\"contest-container-home\" ng-if=\"(\'HOME_MASONRY\' | config) && isHome && (\'ENABLE_CONTEST\' | config)\"><contest-home-section></contest-home-section></div><items ng-if=\"(!(\'HOME_MASONRY\' | config) || ((\'HOME_MASONRY\' | config) && !isHome)) && !detailedList\" size=\"{{itemsize}}\" tmplname=\"simpleList.html\" label=\"labelId\" category=\"categoryId\" shufflegames=\"$root.shuffleLists\" infinite=\"infiniteScroll\"></items><items ng-if=\"!(\'HOME_MASONRY\' | config) && !isHome && detailedList\" size=\"{{itemsize}}\" tmplname=\"boxedList.html\" label=\"labelId\" category=\"categoryId\" shufflegames=\"$root.shuffleLists\" infinite=\"infiniteScroll\" imgratio=\"{{imgRatioList}}\"></items><div ng-if=\"(\'HOME_MASONRY\' | config) && isHome\" class=\"msnry-cols\" infinite-scroll=\"loadMore()\" infinite-scroll-distance=\"0\" infinite-scroll-disabled=\"disableScroll\" infinite-scroll-use-document-bottom=\"true\" infinite-scroll-immediate-check=\"$root.scrollPrefs.check\"><div data-ng-repeat=\"pic in pics track by pic.id\" ng-class=\"pic.format\" class=\"grid badge {{showBadge[getSingleGameAccess(pic.access_type)].class}}\" data-gametype=\"{{showBadge[getSingleGameAccess(pic.access_type)].dictKey | dictionary}}\" ng-click=\"itemPlay(pic,true,false,\'custom\')\" data-mipqa=\"clickitem\"><imagelazy loadedclass=\"b-loaded\" source=\"pic\"></imagelazy><span class=\"infolabel\"><dictionary key=\"\'WEBAPP_INSTANTPLAY_LABEL\'\"></dictionary></span></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/lists/list_mt.html","<listnav selectedlist=\"selectedlist\" ng-if=\"!(\'HIDE_LISTNAV\' | config)\"></listnav><search-field></search-field><items size=\"{{itemsize}}\" tmplname=\"boxedList_mt.html\" label=\"labelId\" category=\"categoryId\" shufflegames=\"$root.shuffleLists\" infinite=\"infiniteScroll\" imgratio=\"{{imgRatioList}}\"></items>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/lists/list_orange_offers.html","<items size=\"{{itemsize}}\" tmplname=\"boxedListOffers.html\" labelslug=\"labelslug\" infinite=\"infiniteScroll\" imgratio=\"{{imgRatioList}}\" list=\"list\"></items>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/lists/list_plugin.html","<div class=\"arcade-list\"><div class=\"outer-container\"><div class=\"inner-container\"><div class=\"slider-content ratio_1 list-{{list.id}}\" data-slug=\"{{list.slug}}\"><items shufflegames=\"(\'SHUFFLE_LISTS\' | config)\" size=\"30\" slider=\"carousel\" tmplname=\"onloadImgCarousel.html\" imgratio=\"ratio_1\" label=\"labelId\" category=\"categoryId\" labelslug=\"labelslug\" class=\"slider-cards\" dataindex=\"cards\" sliderconf=\"LIST_SLIDER_CONF\"></items></div></div></div><div class=\"arcade-cabinet\"><div class=\"cat_{{list.id}}\"></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/lists/list_user.html","<activitynav ng-if=\"favoritesPage || historyPage\" active=\"{{myList}}\"></activitynav><items ng-hide=\"showNoResults\" size=\"{{itemsize}}\" tmplname=\"boxedList_catDetails.html\" category=\"categoryId\" history=\"history\" favorites=\"favorites\" label=\"labelId\" shufflegames=\"$root.shuffleLists\" infinite=\"infiniteScroll\" imgratio=\"{{imgRatioList}}\" formaticons=\"true\"></items><div ng-if=\"showNoResults\" class=\"js-noresults\" ng-class=\"{\'favorites_nores\' : favoritesPage, \'history_nores\' : historyPage} \"><p class=\"general-padding\" ng-if=\"!historyPage && !favoritesPage\"><dictionary key=\"\'WEBAPP_INCOMPATIBLE_LIST\'\"></dictionary></p><p class=\"empty-space\" ng-if=\"(historyPage || favoritesPage) && (!labelId && !categoryId)\" ng-class=\"{\'favorites\' : favoritesPage, \'history\' : historyPage} \"><dictionary ng-if=\"historyPage\" key=\"\'WEBAPP_TEXT_INFO_HISTORY\'\"></dictionary><dictionary ng-if=\"favoritesPage\" key=\"\'WEBAPP_TEXT_INFO_FAVORITES\'\"></dictionary></p><div class=\"list-details\"><h2 class=\"list-box-title\"><dictionary key=\"\'WEBAPP_SUGGEST\'\"></dictionary></h2></div><items latest=\"true\" size=\"6\" tmplname=\"boxedList_catDetails.html\" shufflegames=\"$root.shuffle\" imgratio=\"{{imgRatioList}}\" formaticons=\"true\"></items></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/nav/hNavIcons.html","<div class=\"glide navigation-icons\" data-mipqa=\"list-navigation\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li class=\"glide__slide navslider\" ng-class=\"{\'selected\' : selectedlist == item.id}\" ng-repeat=\"item in items track by $index\" ng-if=\"(item.url_label && item.active) || !item.url_label\" nav-index=\"{{$index}}\" data-itemindex=\"{{$index}}\" data-listid=\"{{item.id}}\" data-mipqa=\"list-item-navigation\"><button class=\"naviconButton\" type=\"button\" data-mipqa=\"btn-go-to-list\" ng-click=\"goTo(item)\" title=\"{{item.name}}\"><span class=\"nav-icon\"><img ng-src=\"{{item.images.url_preview_big || item.url_cover || (\'default_label\' | config)}}\" class=\"img-responsive img-label\"></span><span class=\"text-icon-label\" dir=\"{{setDir(item.name)}}\">{{item.name}}</span></button></li></ul></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/nav/horizNavigation.dir.html","<div class=\"glide navigationMarquee\" data-mipqa=\"list-navigation\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li class=\"glide__slide navslider\" ng-class=\"{\'selected\' : selectedlist == item.id || !selectedlist && $first}\" ng-repeat=\"item in items track by $index\" ng-if=\"(item.url_label && item.active) || !item.url_label\" nav-index=\"{{$index}}\" data-itemindex=\"{{$index}}\" data-mipqa=\"list-item-navigation\"><button type=\"button\" data-mipqa=\"btn-go-to-list\" title=\"{{item.name}}\" ng-click=\"goTo(item)\" dir=\"{{setDir(item.name)}}\"><span class=\"nav-name\" ng-bind-html=\"item.name\"></span></button></li></ul></div><div class=\"glide__arrows\" data-glide-el=\"controls\" ng-show=\"showControls\"><button class=\"glide__arrow glide__arrow--left icon-arrow\" data-glide-dir=\"<\"></button><button class=\"glide__arrow glide__arrow--right icon-arrow\" data-glide-dir=\">\"></button></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/nav/listnav.dir.html","<div class=\"glide slider-home-container multiple-items listnav\" data-mipqa=\"list-navigation\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides slider-wrapper loadingcarousel\"><li data-mipqa=\"list-item-navigation\" ng-repeat=\"item in items\" class=\"glide__slide slider\" slide-index=\"{{$index}}\" ng-class=\"{\'selected\' : selectedlist == item.id }\"><div class=\"relative swipe-item\" ng-class=\"{\'selected\' : selectedlist == item.id}\"><button type=\"button\" data-mipqa=\"btn-go-to-list\" ng-click=\"goTo(this.item, this.item.url_label, $event)\" title=\"{{item.name}}\"><span class=\"gradient-effect\"><img ng-src=\"{{item.images.url_preview_big || item.url_cover || (\'default_label\' | config)}}\" class=\"img-responsive img-label\"></span><span class=\"text-label\" dir=\"{{setDir(item.name)}}\"><span class=\"valign\">{{item.name}}</span></span></button></div></li></ul></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/nav/secondarynav.dir.html","<nav id=\"secnav\"><ul><li class=\"home\" data-mipqa=\"header-link-home\" ng-click=\"goTo(\'home\')\" ng-if=\"home\"><dictionary key=\"\'WEBAPP_SECNAV_HOME\'\"></dictionary></li><li class=\"compass\" data-mipqa=\"header-link-explore\" ng-click=\"goTo(\'explore\')\" ng-if=\"explore\"><dictionary key=\"\'WEBAPP_SECNAV_EXPLORE\'\"></dictionary></li><li class=\"spacer\"></li><li data-mipqa=\"header-link-settings-logged\" class=\"settings\" ng-click=\"goTo(\'settings\')\" ng-if=\"userLogged && settings\"><dictionary key=\"\'WEBAPP_SECNAV_PROFILE\'\"></dictionary></li><li data-mipqa=\"header-link-settings-unlogged\" class=\"settings\" ng-if=\"!userLogged && settings\"><a ng-href=\"{{\'URLMGR_SETTINGS-LINK\' | config}}\"><dictionary key=\"\'WEBAPP_LABEL_LOGIN\'\"></dictionary></a></li></ul></nav>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/user-feedback/userFeedback.dir.html","<div id=\"user-feedback\" class=\"form__message form__message--pop-up\" style=\"display:none\"><div class=\"form__line\"><div class=\"form__message-icon\"><span id=\"user-feedback-icon\" class=\"icon\"></span></div><div class=\"form__message-text\"><div id=\"user-feedback-message\" class=\"message\"></div><a id=\"user-feedback-link\" class=\"link\" href=\"\" style=\"display:none\"></a></div><div id=\"user-feedback-close\" class=\"close\" data-mipqa=\"exit-popup\"></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/explore/explore.html","<div class=\"box-explore\" ng-cloak><search-field></search-field><in-page-adv position=\"top\"></in-page-adv><div data-mipqa=\"labelList\" class=\"label-list\" ng-class=\"{\'loadingcarousel\' : waitingLabels}\"><h2 class=\"text-center\"><dictionary key=\"\'WEBAPP_FEATURED\'\"></dictionary></h2><div ng-class=\"{\'labels\': !(\'EXPLORE_TOPITEMS_ALT_SLIDER\' | config), \'alternate-labels\' : (\'EXPLORE_TOPITEMS_ALT_SLIDER\' | config)}\" class=\"slider-home-container multiple-items\"><div class=\"glide labelSlider\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li ng-repeat=\"label in labels track by $index\" class=\"slider\" data-itemindex=\"{{$index}}\" ng-class=\"{\'label_{{labels.indexOf(label)}}\':!(\'EXPLORE_TOPITEMS_ALT_SLIDER\' | config)}\"><a data-mipqa=\"btn-go-to-list\" ng-click=\"goLabel(label);\" title=\"{{label.name}} {{\'WEBAPP_CANVAS_BUTTON_PLAY\' | dictionary}}\" data-gametype=\"{{showBadge[getSingleGameAccess(item.access_type)].dictKey | dictionary}}\" data-gameid=\"{{item.id}}\"><img ng-src=\"{{label.images.url_preview_big || (\'default_label\' | config)}}\" class=\"img-responsive img-label\"><span class=\"text-label\" dir=\"{{setDir(label.name)}}\">{{label.name}}</span></a></li></ul></div><div class=\"glide__bullets dots text-center\" data-glide-el=\"controls[nav]\"><button type=\"button\" class=\"glide__bullet dot\" data-glide-dir=\"={{$index}}\" ng-repeat=\"position in labels\"></button></div></div></div></div><div class=\"general-margin-tb\"><div data-mipqa=\"categoriesList\" class=\"categoriesList\"><hr><h2 class=\"h2-hr\"><dictionary key=\"\'WEBAPP_GOLD_HEADER_MENU_CATEGORIES\'\"></dictionary></h2><div class=\"box-items\" ng-if=\"favorites\" ng-show=\"favoritesList\"><h2 class=\"small cat-icon favorites\"><dictionary key=\"\'WEBAPP_FAVOURITES\'\"></dictionary></h2><h3 class=\"h3 btn-chevron\"><a ng-click=\"goTo(\'favorites\')\" data-mipqa=\"favorites\" class=\"btn\"><dictionary key=\"\'WEBAPP_LOAD_OTHER_CONTENTS\'\"></dictionary><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span></a></h3><items formaticons=\"true\" size=\"{{getItemsNumber(\'small\')}}\" tmplname=\"simpleList.html\" favorites=\"favorites\"></items></div><div infinite-scroll=\"loadMore()\" infinite-scroll-distance=\"0\" infinite-scroll-disabled=\"disableScroll\" infinite-scroll-use-document-bottom=\"true\" infinite-scroll-immediate-check=\"false\"><div class=\"box-items\" ng-repeat=\"category in categories\" ng-if=\"!category.isEmpty\"><h2 class=\"small cat-icon\" ng-class=\"{\'default-cat-icon\' : !category.url_cover || (\'HIDE_CATEGORY_ICONS\'|config)}\" ng-style=\"!(\'HIDE_CATEGORY_ICONS\'|config) && category.url_cover ? {\'background-image\':\'url({{category.url_cover}})\'} : {}\" ng-bind-html=\"category.name\" dir=\"{{setDir(category.name)}}\"></h2><h3 class=\"h3 btn-chevron\"><a ng-click=\"goCategory(category)\" data-mipqa=\"btn-go-to-list\" class=\"btn\" ng-class=\"{active: ($root.currentPage == \'CategoryPageCtr\' && $root.sectionId == category.id)}\"><dictionary key=\"\'WEBAPP_LOAD_OTHER_CONTENTS\'\"></dictionary><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span></a></h3><items formaticons=\"true\" size=\"{{getItemsNumber(\'small\')}}\" tmplname=\"simpleList.html\" category=\"category\" offset=\"{{offset}}\" shufflegames=\"$root.shuffle\"></items></div></div></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/explore/exploreList.html","<div class=\"box-explore\" ng-cloak><search-field></search-field><div><div data-mipqa=\"labelList\" ng-if=\"labels.length\" class=\"label-list\"><h2 class=\"h2-hr\"><dictionary key=\"\'WEBAPP_FEATURED\'\"></dictionary></h2><div class=\"box-items\" ng-repeat=\"label in labels track by $index\" ng-if=\"!label.isEmpty\"><h2 class=\"small cat-icon\" ng-class=\"{\'default-cat-icon\' : !label.url_cover || !(\'default_label\' | config) || (\'HIDE_CATEGORY_ICONS\'|config)}\" dir=\"{{setDir(label.name)}}\" data-mipqa=\"btn-go-to-list\" ng-click=\"goLabel(this.label);\"><span ng-style=\"!(\'HIDE_CATEGORY_ICONS\'|config) && label.images.url_preview_big ? {\'background-image\':\'url({{label.images.url_preview_big}})\'} : (\'default_label\' | config)\"></span>{{label.name}}</h2></div></div><div data-mipqa=\"categoriesList\" class=\"categoriesList\"><h2 class=\"h2-hr\"><dictionary key=\"\'WEBAPP_GOLD_HEADER_MENU_CATEGORIES\'\"></dictionary></h2><div class=\"box-items\" ng-repeat=\"category in categories\" ng-if=\"!category.isEmpty\"><h2 class=\"small cat-icon\" ng-class=\"{\'default-cat-icon\' : !category.url_cover || (\'HIDE_CATEGORY_ICONS\'|config)}\" dir=\"{{setDir(category.name)}}\" ng-click=\"goCategory(category)\" data-mipqa=\"btn-go-to-list\"><span ng-style=\"!(\'HIDE_CATEGORY_ICONS\'|config) && category.url_cover ? {\'background-image\':\'url({{category.url_cover}})\'} : {}\"></span>{{category.name}}</h2></div></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/explore/exploreMulti.html","<div class=\"explore--multiple\" ng-cloak><search-field></search-field><horiz-navigation ng-if=\"!(\'EXPLORE_MULTI_ICONS\' | config)\" selectedlist=\"selectedlist\"></horiz-navigation><h-nav-icons ng-if=\"(\'EXPLORE_MULTI_ICONS\' | config)\" selectedlist=\"selectedlist\"></h-nav-icons><div ng-include=\"searchResultsTmpl\" ng-if=\"isSearch\"></div><div class=\"game-items multiple\" ng-if=\"!isSearch\"><items size=\"12\" tmplname=\"boxedList.html\" category=\"categoryId\" history=\"history\" favorites=\"favorites\" label=\"labelId\" shufflegames=\"$root.shuffleLists\" infinite=\"infiniteScroll\" imgratio=\"{{imgRatioList}}\" formaticons=\"true\" abstract=\"(\'ABSTRACT_IN_LISTS\' | config)\"></items></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/explore/explore_orange.html","<div class=\"box-explore\" ng-cloak><div data-mipqa=\"labelList\" class=\"label-list\" ng-class=\"{\'loadingcarousel\' : waitingLabels}\"><h2><dictionary key=\"\'WEBAPP_FEATURED\'\"></dictionary></h2><div class=\"glide labelSlider\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li ng-repeat=\"label in labels track by $index\" class=\"slider\" data-itemindex=\"{{$index}}\" ng-class=\"{\'label_{{labels.indexOf(label)}}\':!(\'EXPLORE_TOPITEMS_ALT_SLIDER\' | config)}\"><a data-mipqa=\"btn-go-to-list\" ng-click=\"goLabel(label, $index+1);\" title=\"{{label.name}} {{\'WEBAPP_CANVAS_BUTTON_PLAY\' | dictionary}}\" data-gametype=\"{{showBadge[getSingleGameAccess(item.access_type)].dictKey | dictionary}}\" data-gameid=\"{{item.id}}\"><img ng-src=\"{{label.images.url_preview_big || (\'default_label\' | config)}}\" class=\"img-responsive img-label\"><span class=\"text-label\" dir=\"{{setDir(label.name)}}\">{{label.name}}</span></a></li></ul></div></div></div><div data-mipqa=\"categoriesList\" class=\"category-list\"><div class=\"cats-slider offers\" ng-if=\"(\'SHOW_OFFERS_EXPLORE\'|config) && ($root.selector !== \'pc\')\" ng-show=\"showOffers\"><items size=\"10\" slider=\"slider\" imgratio=\"ratio_2\" sliderconf=\"USERITEMS_SLIDER_CONF_EXPLORECAROUSEL\" tmplname=\"offersCarousel.html\" readyitems=\"offerItems\" section=\"offers\" class=\"small slider slider-{{offers.id}}\" dataindex=\"{{offers.id}}\" slidertitle=\"{{offers.name}}\" description=\"{{offers.description_short}}\" gotolist=\"goApps(offers)\" list=\"offers\"></items></div><h2><dictionary key=\"\'WEBAPP_GOLD_HEADER_MENU_CATEGORIES\'\"></dictionary></h2><div class=\"cats-slider\"><items size=\"8\" slider=\"slider\" imgratio=\"ratio_1\" sliderconf=\"USERITEMS_SLIDER_CONF_AR_1\" tmplname=\"imgsliderComplete.html\" category=\"catFirstSlider\" section=\"catFirstSlider{{$parent.$index | round }}\" class=\"small slider slider-{{catFirstSlider.id}}\" dataindex=\"{{catFirstSlider.id}}\" slidertitle=\"{{catFirstSlider.name | titleCase}}\" description=\"{{catFirstSlider.description_short}}\" gotolist=\"goCategory(catFirstSlider)\" formaticons=\"true\" list=\"catFirstSlider\"></items></div><div class=\"category-banner\"><list-banner ng-if=\"catBanner\" list=\"catBanner\" type=\"category\"></list-banner></div><div class=\"cats-slider\" ng-if=\"!catSlider.isEmpty\"><items size=\"8\" slider=\"slider\" imgratio=\"ratio_1\" sliderconf=\"USERITEMS_SLIDER_CONF_AR_1\" tmplname=\"imgsliderComplete.html\" category=\"catSlider\" section=\"catSlider{{$parent.$index | round }}\" class=\"small slider slider-{{catSlider.id}}\" dataindex=\"{{catSlider.id}}\" slidertitle=\"{{catSlider.name | titleCase}}\" description=\"{{catSlider.description_short}}\" gotolist=\"goCategory(catSlider)\" formaticons=\"true\" list=\"catSlider\"></items></div><div class=\"category-banner\"><list-banner ng-if=\"catBanner2\" list=\"catBanner2\" type=\"category\"></list-banner></div><div class=\"cats-slider\" ng-if=\"!catLastSlider.isEmpty\"><items size=\"8\" slider=\"slider\" imgratio=\"ratio_1\" sliderconf=\"USERITEMS_SLIDER_CONF_AR_1\" tmplname=\"imgsliderComplete.html\" category=\"catLastSlider\" section=\"catLastSlider{{$parent.$index | round }}\" class=\"small slider slider-{{catLastSlider.id}}\" dataindex=\"{{catLastSlider.id}}\" slidertitle=\"{{catLastSlider.name | titleCase}}\" description=\"{{catLastSlider.description_short}}\" gotolist=\"goCategory(catLastSlider)\" formaticons=\"true\" list=\"catLastSlider\"></items></div><div class=\"cats-list\" ng-if=\"!catList.isEmpty\"><h2><dictionary key=\"\'WEBAPP_MORE_CATEGORIES\'\"></dictionary></h2><ul class=\"list-links cats\"><li ng-repeat=\"cat in catList\"><a ng-click=\"goCategory(cat, true)\">{{cat.name}}</a></li></ul></div></div><subs-banner mini=\"true\"></subs-banner></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/explore/explore_zain.html","<div class=\"explore--multiple\" ng-cloak><search-field></search-field><div class=\"hNavIcons\" ng-if=\"!isSearch\"><h2 class=\"sub-title\" ng-if=\"stateName === \'explore\'\"><dictionary key=\"\'WEBAPP_FEATURED\'\"></dictionary></h2><h-nav-icons selectedlist=\"selectedlist\"></h-nav-icons></div><div ng-include=\"searchResultsTmpl\" ng-if=\"isSearch\"></div><div class=\"game-items multiple\" ng-if=\"!isSearch && stateName !== \'explore\'\"><items size=\"12\" tmplname=\"boxedList_cloud.html\" category=\"categoryId\" history=\"history\" favorites=\"favorites\" label=\"labelId\" shufflegames=\"$root.shuffleLists\" infinite=\"infiniteScroll\" imgratio=\"{{imgRatioList}}\" formaticons=\"true\" abstract=\"(\'ABSTRACT_IN_LISTS\' | config)\"></items></div><div class=\"game-items multiple\" ng-if=\"!isSearch && stateName === \'explore\'\"><div data-mipqa=\"categoriesList\" class=\"categoriesList\"><h2 class=\"sub-title\"><dictionary key=\"\'WEBAPP_GOLD_HEADER_MENU_CATEGORIES\'\"></dictionary></h2><div infinite-scroll=\"loadMore()\" infinite-scroll-distance=\"0\" infinite-scroll-disabled=\"disableScroll\" infinite-scroll-use-document-bottom=\"true\" infinite-scroll-immediate-check=\"false\"><div class=\"game-items slider-content\" ng-repeat=\"category in categories\" ng-if=\"category && !category.isEmpty\"><div class=\"outer-title\"><h2 ng-bind-html=\"category.name\" dir=\"{{setDir(category.name)}}\"></h2><h3 class=\"h3 btn-chevron\"><a ng-click=\"goCategory(category)\" data-mipqa=\"btn-go-to-list\" class=\"btn\" ng-class=\"{active: ($root.currentPage == \'CategoryPageCtr\' && $root.sectionId == category.id)}\"><dictionary key=\"\'WEBAPP_LOAD_OTHER_CONTENTS\'\"></dictionary><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span></a></h3></div><items slider=\"slider\" useoutertitle=\"true\" formaticons=\"true\" size=\"6\" tmplname=\"imgsliderComplete.html\" category=\"category\" class=\"small slider slider-{{$index}}\" dataindex=\"{{$index}}\" offset=\"{{offset}}\" imgratio=\"ratio_1_5\" sliderconf=\"USERITEMS_SLIDER_CONF\" shufflegames=\"$root.shuffle\"></items></div></div></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/news/newsPageList.ctr.html","<div class=\"filtered-list\"><list-news size=\"{{itemsize}}\" imgratio=\"ratio_1\" infinite=\"true\" extended=\"true\"></list-news></div><div ng-if=\"showNoResults\"><p class=\"general-padding\"><dictionary key=\"\'WEBAPP_NEWS_LIST_NO_RESULTS\'\"></dictionary></p></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/news/newsPageZoom.ctr.html","<main><div class=\"zoom-content relative\"><div class=\"news-info cover text-center\"><div class=\"{{coverRatio}}\"><img alt=\"{{news.title}}\" class=\"img-responsive\" data-mipqa=\"img-zoom\" style=\"background-image: url({{news.images.cover[coverRatio] | imageSize:imgWSize:imgHSize}})\" ng-src=\"{{ coverRatio | config }}\"></div></div><div class=\"description\"><h3 class=\"dirOverride\" dir=\"{{setDir(news.title)}}\" data-mipqa=\"zoom-title\" ng-bind-html=\"news.title\"></h3><p class=\"meta\">{{convertToDate(news.born_date)}}</p><p class=\"fulldesc\" data-mipqa=\"content-text-zoom\" ng-bind-html=\"newsDesc\" dir=\"{{setDir(newsDesc)}}\"></p></div><div class=\"related\" data-mipqa=\"zoom-related\"><h3 class=\"dirOverride\" dir=\"{{setDir((\'WEBAPP_NEWS_ZOOM_RELATED\' | dictionary))}}\"><dictionary key=\"\'WEBAPP_NEWS_ZOOM_RELATED\'\"></dictionary></h3><list-news size=\"7\" id=\"{{news.id}}\" extended=\"true\" imgratio=\"ratio_1\" separator=\"true\"></list-news></div></div></main>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/partner/iframe.html","<div id=\"partnerContainer\" data-mipqa=\"iframe-container\"><iframe ng-if=\"iframeUrl && showIframe\" id=\"partnerFrame\" type=\"text/html\" data=\"\" seamless ng-src=\"{{iframeUrl}}\"></iframe></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/partner/paythem.html","<div id=\"partnerContainer\"><iframe id=\"PTEmbed\" type=\"text/html\" data=\"\" seamless></iframe></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/promo/header.html","<nav></nav><div class=\"promo_logo\"></div><div class=\"state-icon\"></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/FBLogin.dir.html","<div ng-if=\"(\'PROFILE_FBCONNECT_SHOW\'|config)\"><div class=\"connect text-center\"><a ng-click=\"fbLogin($event, returl)\"><span class=\"fa fa-facebook-official\"><dictionary key=\"\'MIPCONNECT_LABEL_FACEBOOK_CONNECT\'\"></dictionary></span></a></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/account_list.html","<div class=\"settings-box\" ng-controller=\"Settings30Ctr\" data-mipqa=\"account-page\"><h2><dictionary key=\"\'WEBAPP_TITLE_ACCOUNT\'\"></dictionary></h2><ul class=\"list-links\"><li ng-if=\"(\'SHOW_USERLIST_ACCOUNTLIST\' | config) && logged\" class=\"userlist\" data-mipqa=\"favorites-history\" ng-click=\"goTo(\'history\')\"><dictionary key=\"\'WEBAPP_MYLIST_TITLE\'\"></dictionary></li><li ng-repeat=\"single in sections\" data-mipqa=\"{{single.subsection}}-{{single.content_id}}\" ng-click=\"trackClickEvent(single)\"><a ng-href=\"{{single.url}}\" title=\"{{single.label}}\">{{single.label}}</a></li><li class=\"list-spacer\" ng-if=\"(\'CHANGE_THEME_ENABLED\' | config)\"></li><li class=\"userprefs\" ng-if=\"(\'CHANGE_THEME_ENABLED\' | config)\"><form class=\"user-controls toggle theme\" ng-if=\"(\'CHANGE_THEME_ENABLED\' | config)\"><legend><dictionary key=\"\'WEBAPP_CHANGE_THEME\'\"></dictionary></legend><div><div class=\"checkbox\"><input type=\"checkbox\" ng-checked=\"themeChoice.dark\" ng-model=\"themeChoice.dark\" ng-change=\"toggleTheme(themeChoice.dark)\"><label></label></div></div></form></li></ul></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/account_list_external.html","<div class=\"settings-box\" ng-controller=\"Settings30Ctr\" data-mipqa=\"account-page\"><h2><dictionary key=\"\'WEBAPP_TITLE_ACCOUNT\'\"></dictionary></h2><ul class=\"list-links\"><li ng-if=\"!logged\" data-mipqa=\"smartlogin-\" ng-click=\"trackClickEvent(login)\"><a ng-href=\"{{login.url}}\" title=\"{{login.label}}\">{{login.label}}</a></li><li ng-repeat=\"single in linksExternal\" data-mipqa=\"{{single.subsection}}-{{single.content_id}}\" ng-click=\"trackClickEvent(single)\"><a ng-href=\"{{single.url}}\" title=\"{{single.label}}\">{{single.label}}</a></li><li class=\"list-spacer\" ng-if=\"(\'CHANGE_THEME_ENABLED\' | config)\"></li><li class=\"userprefs\" ng-if=\"(\'CHANGE_THEME_ENABLED\' | config)\"><form class=\"user-controls toggle theme\" ng-if=\"(\'CHANGE_THEME_ENABLED\' | config)\"><legend><dictionary key=\"\'WEBAPP_CHANGE_THEME\'\"></dictionary></legend><div><div class=\"checkbox\"><input type=\"checkbox\" ng-checked=\"themeChoice.dark\" ng-model=\"themeChoice.dark\" ng-change=\"toggleTheme(themeChoice.dark)\"><label></label></div></div></form></li></ul></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/activity.dir.html","<div class=\"link-user\"><ul><li ng-if=\"(\'ACTIVITY_FAVOURITES\'|config)\"><a ng-click=\"goTo(\'favorites\')\" data-mipqa=\"btn-go-to-list\"><div class=\"center-link\"><div class=\"col-xs-3\"><span class=\"icon-cuore_verde_zoom\"></span></div><div class=\"col-xs-6\"><dictionary key=\"\'WEBAPP_FAVOURITES\'\"></dictionary></div><div class=\"col-xs-3\"><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span></div></div></a></li><li ng-if=\"(\'ACTIVITY_HISTORY\'|config)\"><a ng-click=\"goTo(\'history\')\" data-mipqa=\"btn-go-to-list\"><div class=\"center-link\"><div class=\"col-xs-3\"><span class=\"icon-clock104\"></span></div><div class=\"col-xs-6\"><dictionary key=\"\'WEBAPP_LAST_PLAYED\'\"></dictionary></div><div class=\"col-xs-3\"><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span></div></div></a></li></ul></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/ageCheck.dir.html","<dialog class=\"age-check\" id=\"age-check-dialog\" data-mipqa=\"modal-check-age\"><div id=\"ageFirstCheck\" ng-hide=\"$root.showAgeForm\"><h3><dictionary key=\"\'WEBAPP_AGECHECK_QUESTION\'\"></dictionary></h3><button type=\"button\" class=\"btn ko\" ng-click=\"sendAnswer(false)\" data-mipqa=\"modal-age-btn-no\"><dictionary key=\"\'WEBAPP_AGECHECK_KO\'\"></dictionary></button><button type=\"button\" class=\"btn play\" ng-click=\"sendAnswer(true)\" data-mipqa=\"modal-age-btn-yes\"><dictionary key=\"\'WEBAPP_AGECHECK_OK\'\"></dictionary></button></div><form name=\"ageCheck\" id=\"ageCheck\" ng-show=\"$root.showAgeForm\" class=\"form\" ng-submit=\"sendAgeData($event)\" autocomplete=\"off\"><div class=\"form__line\"><label><dictionary key=\"\'WEBAPP_AGECHECK_USER_FNAME\'\"></dictionary></label><input required type=\"text\" name=\"firstName\"></div><div class=\"form__line\"><label><dictionary key=\"\'WEBAPP_AGECHECK_USER_LNAME\'\"></dictionary></label><input required type=\"text\" name=\"lastName\"></div><div class=\"form__line\"><label><dictionary key=\"\'WEBAPP_AGECHECK_USER_DOB\'\"></dictionary></label><input required type=\"date\" name=\"dateOfBirth\"></div><div class=\"form__control\"><button type=\"submit\" class=\"btn play\"><dictionary key=\"\'WEBAPP_AGECHECK_SENDPROPS\'\"></dictionary></button></div></form></dialog>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/banner_cloud.html","<div class=\"banner {{customclass}}\" ng-click=\"goTo(destination, external)\"><button type=\"button\" class=\"btn close\" ng-click=\"close()\" ng-if=\"dismissable\"></button><div class=\"banner-text\" ng-if=\"maintext || secondarytext\"><h3><dictionary key=\"maintext\"></dictionary></h3><p><dictionary key=\"secondarytext\"></dictionary></p></div><img ng-if=\"bannerImg\" ng-src=\"{{bannerImg}}\"></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/category_grid_cloud.html","<div class=\"other-categories\" data-gridsection=\"other_categories\"><div class=\"list-details\"><h2 class=\"list-box-title\"><dictionary key=\"boxtitle\"></dictionary></h2></div><button class=\"other-category\" data-mipqa=\"btn-go-to-list\" type=\"button\" ng-click=\"goCategory(category)\" ng-repeat=\"category in categoriesList\"><p>{{category.name}}</p><img ng-src=\"{{category.url_cover}}\"></button></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/consent.html","<h3 class=\"links\" ng-if=\"(\'SHOW_PRIVACY_BLOCK\' | config) && (\'DIDOMI_API_KEY\'|config) && (\'DIDOMI_ID\'|config)\"><a class=\"link-consent btn\" ng-click=\"openPrefs()\" data-mipqa=\"didomi-prefmanager\"><dictionary key=\"\'WEBAPP_MANAGE_CONSENT_LINK\'\"></dictionary></a></h3>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/crossSellingBanner.html","<div class=\"container-cross-selling-banner\" ng-if=\"(\'SHOW_CROSS_SELLING_BANNER\'|config)\"><div class=\"contain-cross-selling-banner\"><div class=\"cross-selling-banner-images\"><div class=\"banner-img\"></div><div class=\"banner-logo\"></div></div><div class=\"cross-selling-banner-text\"><p><dictionary key=\"\'WEBAPP_CROSS_SELLING_BANNER_TEXT\'\"></dictionary></p><button ng-click=\"goToUrl()\"><dictionary key=\"\'WEBAPP_CROSS_SELLING_BANNER_TEXT_LINK\'\"></dictionary></button></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/dynDom.html","<dynamic-dom content=\"content\"></dynamic-dom>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/footer.ctr.html","<in-page-adv position=\"bottom\"></in-page-adv><cross-selling-banner></cross-selling-banner><div class=\"footer text-center {{linkClass}} {{logoClass}}\" ng-class=\"{\'customFoot\': (\'CUSTOM_FOOTER_STYLE\' | config)}\"><h3 class=\"gotoHome\" ng-if=\"(\'SHOW_MOVISTAR_BACK_HOME\'|config) && !hideOperator\"><a class=\"btn\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\" ng-href=\"#!{{ \'MOVISTAR_BACK_HOME_URL\' | config }}\"><dictionary key=\"\'WEBAPP_MOVISTAR_BACK_HOME\'\"></dictionary></a></h3><div ng-class=\"{\'vertical-footer\': (\'ENABLE_VERTICAL_FOOTER\' | config) }\" ng-if=\"!hideFooter\" data-mipqa=\"footer-container\"><h3 class=\"links\" ng-repeat=\"link in links\"><a href=\"{{link.url}}\" class=\"btn\" dir=\"{{setDir(link.label)}}\" data-mipqa=\"footer-link-{{link.content_id}}\">{{link.label}}</a></h3><consent-manager></consent-manager></div><div class=\"operator-text\" ng-if=\"(\'SHOW_FOOTER_SERVICE_DESCRIPTION_BELOW\' | config)\"><hr><p data-mipqa=\"footer-text-description-below\"><dictionary key=\"\'WEBAPP_FOOTER_SERVICE_DESCRIPTION\'\"></dictionary></p></div><div data-mipqa=\"container-multilanguage\" ng-if=\"\'SHOW_MULTIPLE_LANGUAGE\'|config\" class=\"multiple-language\"><p><dictionary key=\"\'WEBAPP_CHANGE_LANGUAGE\'\"></dictionary></p><span ng-repeat=\"language in langList\"><a ng-attr-data-mipqa=\"{{currLang == language.ID ? \'current-language\' : \'link-other-language\'}}\" href=\"{{window.location.origin}}{{language._LANGURL_ABSOLUTE}}\" ng-class=\"{\'curr-lang\': currLang == language.ID}\" dir=\"{{setDir(language.LABEL)}}\">{{language.LABEL}}</a></span></div><div class=\"copy-footer\" ng-if=\"(\'SHOW_COPY_ON_FOOTER\' | config)\"><p class=\"copy-info\">{{footerCopy}}</p><p class=\"copy-info\"><a href=\"/#!/terms/privacy\" class=\"btn\"><dictionary key=\"\'PRIVACY_WEBAPP\'\"></dictionary></a></p></div><div class=\"post-footer-info\" ng-if=\"(\'SHOW_POST_FOOTER_BLOCK\'| config)\"><div class=\"footer\"><dictionary key=\"\'WEBAPP_FOOTER_AFTER_BLOCK\'\"></dictionary></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/footer_bf.html","<in-page-adv position=\"bottom\"></in-page-adv><div class=\"footer text-center {{linkClass}}\" ng-class=\"{\'customFoot\': (\'CUSTOM_FOOTER_STYLE\' | config)}\"><h3 class=\"gotoHome\" ng-if=\"(\'SHOW_MOVISTAR_BACK_HOME\'|config) && !hideOperator\"><a class=\"btn\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\" ng-href=\"#!{{ \'MOVISTAR_BACK_HOME_URL\' | config }}\"><dictionary key=\"\'WEBAPP_MOVISTAR_BACK_HOME\'\"></dictionary></a></h3><div ng-class=\"{\'vertical-footer\': (\'ENABLE_VERTICAL_FOOTER\' | config) }\" class=\"footer-links-ext\" ng-if=\"!hideFooter\" data-mipqa=\"footer-container\"><h3 class=\"links\" ng-repeat=\"link in linksExternal\"><a href=\"{{link.url}}\" class=\"btn\" dir=\"{{setDir(link.label)}}\" data-mipqa=\"footer-link-external\">{{link.label}}</a></h3><consent-manager></consent-manager></div><div class=\"operator-text\" ng-if=\"(\'SHOW_FOOTER_SERVICE_DESCRIPTION_BELOW\' | config)\"><hr><p data-mipqa=\"footer-text-description-below\"><dictionary key=\"\'WEBAPP_FOOTER_SERVICE_DESCRIPTION\'\"></dictionary></p></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/footer_mt.html","<in-page-adv position=\"bottom\"></in-page-adv><div class=\"footer text-center {{linkClass}}\" ng-class=\"{\'customFoot\': (\'CUSTOM_FOOTER_STYLE\' | config)}\"><h3 class=\"gotoHome\" ng-if=\"(\'SHOW_MOVISTAR_BACK_HOME\'|config) && !hideOperator\"><a class=\"btn\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\" ng-href=\"#!{{ \'MOVISTAR_BACK_HOME_URL\' | config }}\"><dictionary key=\"\'WEBAPP_MOVISTAR_BACK_HOME\'\"></dictionary></a></h3><div ng-class=\"{\'vertical-footer\': (\'ENABLE_VERTICAL_FOOTER\' | config) }\" class=\"footer-links-ext\" ng-if=\"!hideFooter\" data-mipqa=\"footer-container\"><h3 class=\"links\" ng-repeat=\"link in linksExternal\"><a href=\"{{link.url}}\" class=\"btn\" dir=\"{{setDir(link.label)}}\" data-mipqa=\"footer-link-external\" ng-click=\"link.action($event, link.url)\">{{link.label}}</a></h3><consent-manager></consent-manager></div><div class=\"operator-text\" ng-if=\"(\'SHOW_FOOTER_SERVICE_DESCRIPTION_BELOW\' | config)\"><hr><p data-mipqa=\"footer-text-description-below\"><dictionary key=\"\'WEBAPP_FOOTER_SERVICE_DESCRIPTION\'\"></dictionary></p></div><p class=\"copy\"><dictionary key=\"\'WEBAPP_FOOTER_COPYRIGHT\'\"></dictionary></p></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/footer_orange.html","<in-page-adv position=\"bottom\"></in-page-adv><div class=\"footer text-center {{linkClass}}\" ng-class=\"{\'customFoot\': (\'CUSTOM_FOOTER_STYLE\' | config)}\"><h3 class=\"gotoHome\" ng-if=\"(\'SHOW_MOVISTAR_BACK_HOME\'|config) && !hideOperator\"><a class=\"btn\" title=\"{{\'WEBAPP_GOLD_HEADER_META_TITLE\' | dictionary }}\" ng-href=\"#!{{ \'MOVISTAR_BACK_HOME_URL\' | config }}\"><dictionary key=\"\'WEBAPP_MOVISTAR_BACK_HOME\'\"></dictionary></a></h3><div ng-class=\"{\'vertical-footer\': (\'ENABLE_VERTICAL_FOOTER\' | config) }\" ng-if=\"!hideFooter\" data-mipqa=\"footer-container\"><h3 class=\"links\" ng-repeat=\"link in links\"><a href=\"{{link.url}}\" class=\"btn\" dir=\"{{setDir(link.label)}}\" data-mipqa=\"footer-link-{{link.content_id}}\">{{link.label}}</a></h3><consent-manager></consent-manager></div><div class=\"operator-text\" ng-if=\"(\'SHOW_FOOTER_SERVICE_DESCRIPTION_BELOW\' | config)\"><hr><p data-mipqa=\"footer-text-description-below\"><dictionary key=\"\'WEBAPP_FOOTER_SERVICE_DESCRIPTION\'\"></dictionary></p></div><div data-mipqa=\"container-multilanguage\" ng-if=\"\'SHOW_MULTIPLE_LANGUAGE\'|config\" class=\"multiple-language\"><p><dictionary key=\"\'WEBAPP_CHANGE_LANGUAGE\'\"></dictionary></p><span ng-repeat=\"language in langList\"><a ng-attr-data-mipqa=\"{{currLang == language.ID ? \'current-language\' : \'link-other-language\'}}\" href=\"{{window.location.origin}}{{language._LANGURL_ABSOLUTE}}\" ng-class=\"{\'curr-lang\': currLang == language.ID}\" dir=\"{{setDir(language.LABEL)}}\">{{language.LABEL}}</a></span></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/gamificationTabs.html","<nav class=\"gamification-nav\"><ul class=\"tabs\"><li class=\"link-contest\" data-mipqa=\"contest-link\" ng-click=\"goTo(\'contest\')\" ng-class=\"{\'active\':isContest}\" ng-if=\"(\'ENABLE_CONTEST\' | config)\"><h3><dictionary key=\"\'WEBAPP_COMPETITION_CONTEST_TITLE\'\"></dictionary></h3></li><li class=\"link-badges\" data-mipqa=\"explore-link\" ng-click=\"goTo(\'badges\')\" ng-class=\"{\'active\':isBadges}\" ng-if=\"(\'ENABLE_BADGES\' | config) && userData.logged\"><h3><dictionary key=\"\'WEBAPP_CONTEST_MY_BADGES\'\"></dictionary></h3></li></ul></nav>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/hybridInstall.dir.html","<div class=\"mask hybridInstall {{extendedclass}}\" ng-if=\"showBanner && !(\'SHOW_NATIVE_INSTALL_EXTENDED\' | config)\"><div class=\"info-message\"><div class=\"inner-container\"><button class=\"close-message\" type=\"button\" ng-click=\"closeAppBanner()\"><span class=\"icon-x\"></span></button><h2><span class=\"dict\" ng-bind-html=\"setDictDevice(\'WEBAPP_HYBRIDINSTALL_TXT\')\"></span></h2><div class=\"hybridApp\"><h5><span class=\"dict\" ng-bind-html=\"setDictDevice(\'WEBAPP_HYBRIDINSTALL_APPINFO\')\"></span></h5><h6><span class=\"dict\" ng-bind-html=\"setDictDevice(\'WEBAPP_HYBRIDINSTALL_APPINFOSMALL\')\"></span></h6></div><button id=\"goToStore\" type=\"button\" class=\"btn play\" ng-click=\"mobileFingerPrint()\"><span class=\"top\"><span class=\"dict\" ng-bind-html=\"setDictDevice(\'WEBAPP_NATIVEINSTALL_TOP_BTN\')\"></span></span><span class=\"bottom\"><span class=\"dict\" ng-bind-html=\"setDictDevice(\'WEBAPP_NATIVEINSTALL_PAGE_BTN\')\"></span></span></button></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/nativeInstall.html","<div class=\"native-install expanded\" ng-if=\"$root.showBeforePlay\"><div><figure title=\"{{\'WEBAPP_NATIVEINSTALL_APPNAME\' | dictionary}}\"></figure><figcaption><dictionary key=\"\'WEBAPP_NATIVEINSTALL_APPNAME\'\"></dictionary></figcaption><h4><p><dictionary key=\"\'WEBAPP_NATIVEINSTALL_TITLE\'\"></dictionary></p><p><dictionary key=\"\'WEBAPP_NATIVEINSTALL_TEXT\'\"></dictionary></p></h4><a href=\"\" ng-show=\"$root.showIntentBtn\" class=\"btn_banner_gotostore\" id=\"native_intent_ext\" dir=\"{{setDir((\'WEBAPP_NATIVEINSTALL_APPNAME\' | dictionary))}}\"></a><a href=\"\" id=\"invisibleDownloadButton_ext\" style=\"display: none;\"></a><button class=\"btn_dismiss\" type=\"button\" ng-click=\"closeAppBanner(true)\"><dictionary key=\"\'WEBAPP_NATIVEINSTALL_CLOSE\'\"></dictionary></button></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/nativeInstall_top.html","<div class=\"native-install simple\" ng-if=\"showBanner && (\'SHOW_NATIVE_INSTALL_EXTENDED\' | config) && !(\'INSTALL_BANNER_ONLY_ZOOM\')\"><button class=\"btn_close close\" type=\"button\" ng-click=\"closeAppBanner()\"></button><figure title=\"{{\'WEBAPP_NATIVEINSTALL_APPNAME\' | dictionary}}\"></figure><figcaption><dictionary key=\"\'WEBAPP_NATIVEINSTALL_TEXT\'\"></dictionary></figcaption><button type=\"button\" class=\"btn_banner_gotostore\" dir=\"{{setDir((\'WEBAPP_NATIVEINSTALL_APPNAME\' | dictionary))}}\" ng-click=\"mobileFingerPrint(gameId)\"></button></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/onboarding.dir.html","<div id=\"onboarding-cont\" class=\"onboarding-overlay\" data-mipqa=\"{{showOB ? \'onboarding-overlay\' : \'onboarding-overlay-hidden\'}}\" ng-show=\"showOB\" ng-class=\"{\'mosaic\': deviceType != \'phone\', \'home cards-content\':deviceType == \'phone\'}\"><div id=\"gameSample\" class=\"titled-card\"></div><div id=\"innerOB\"><button type=\"button\" class=\"onboarding-close\" ng-click=\"closeOB();\" data-mipqa=\"onboarding-close\"></button><div id=\"balloonText\"><dictionary id=\"w0\" class=\"ob-big\" key=\"\'WEBAPP_ONBOARDING_WELCOME\'\"></dictionary><dictionary id=\"w1\" key=\"\'WEBAPP_ONBOARDING_WELCOME_1\'\"></dictionary><dictionary id=\"w2\" class=\"ob-big\" key=\"\'WEBAPP_ONBOARDING_WELCOME_2\'\"></dictionary><dictionary id=\"w3\" key=\"\'WEBAPP_ONBOARDING_WELCOME_3\'\"></dictionary><dictionary id=\"g0\" class=\"ob-big\" key=\"\'WEBAPP_ONBOARDING_GAMEINFO\'\"></dictionary><dictionary id=\"g1\" key=\"\'WEBAPP_ONBOARDING_GAMEINFO_1\'\"></dictionary><dictionary id=\"g2\" key=\"\'WEBAPP_ONBOARDING_GAMEINFO_2\'\"></dictionary><dictionary id=\"g3\" class=\"ob-big\" key=\"\'WEBAPP_ONBOARDING_GAMEINFO_3\'\"></dictionary><dictionary id=\"g4\" key=\"\'WEBAPP_ONBOARDING_GAMEINFO_4\'\"></dictionary><dictionary id=\"g5\" key=\"\'WEBAPP_ONBOARDING_GAMEINFO_5\'\"></dictionary></div><svg id=\"step1\" image-rendering=\"auto\" baseProfile=\"basic\" version=\"1.1\" preserveAspectRatio=\"xMidYMid meet\" x=\"0px\" y=\"0px\" width=\"320\" height=\"400\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320 400\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" style=\"max-height:100%\"><defs><g id=\"fumetto\" overflow=\"visible\"><g><use xlink:href=\"#Layer1_0_FILL\"/></g></g><g id=\"Symbol-2\" overflow=\"visible\"><g><use xlink:href=\"#Layer2_0_FILL\"/></g></g><g id=\"Symbol-3\" overflow=\"visible\"><use xlink:href=\"#Symbol-4\" transform=\"translate(-1.8 -3.65)\"/><g><use xlink:href=\"#Layer3_0_FILL\"/></g></g><g id=\"ghostr12.5s\" overflow=\"visible\"><g display=\"none\"><use xlink:href=\"#Tween-1\" transform=\"translate(-113.45 260.55)\"/><animate attributeName=\"display\" fill=\"freeze\" begin=\".375s\" repeatDur=\"12.5s\" dur=\"0.292s\" keyTimes=\"0;.857;1\" values=\"none;inline;inline\"/></g><g display=\"none\"><use xlink:href=\"#Tween-2\" transform=\"translate(-113.3 260.75)\"><animateTransform attributeName=\"transform\" additive=\"replace\" type=\"translate\" begin=\".375s\" repeatDur=\"12.5s\" dur=\"0.292s\" keyTimes=\"0;.428;.856;1\" values=\"-113.3,260.75;-113.3,260.75;-113.45,260.55;-113.45,260.55\" fill=\"freeze\"/></use><animate attributeName=\"display\" fill=\"freeze\" begin=\".375s\" repeatDur=\"12.5s\" dur=\"0.292s\" keyTimes=\"0;.429;.857;1\" values=\"none;inline;none;none\"/></g><g><use xlink:href=\"#Tween-1\" transform=\"translate(-113.45 260.55)\"><animateTransform attributeName=\"transform\" additive=\"replace\" type=\"translate\" begin=\".375s\" repeatDur=\"12.5s\" dur=\"0.292s\" keyTimes=\"0;.428;1\" values=\"-113.45,260.55;-113.3,260.75;-113.3,260.75\" fill=\"freeze\"/></use><animate attributeName=\"display\" fill=\"freeze\" begin=\".375s\" repeatDur=\"12.5s\" dur=\"0.292s\" keyTimes=\"0;.429;1\" values=\"inline;none;none\"/></g></g><g id=\"ghost-2o308d315r1\" overflow=\"visible\"><g display=\"none\"><use xlink:href=\"#Tween-1\" transform=\"matrix(-1 0 0 1 -113.25 260.55)\"/><animate attributeName=\"display\" fill=\"freeze\" begin=\"indefinite\" repeatCount=\"1\" dur=\"13.125s\" keyTimes=\"0;.997;1\" values=\"none;inline;inline\"/></g><g display=\"none\"><use xlink:href=\"#Tween-2\" transform=\"matrix(-1 0 0 1 -113.4 260.75)\"><animateTransform attributeName=\"transform\" additive=\"replace\" type=\"translate\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;.987;.997;1\" values=\"-113.4,260.75;-113.4,260.75;-113.25,260.55;-113.25,260.55\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"skewY\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;1\" values=\"180;180\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"scale\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;1\" values=\"-1,1;-1,1\" fill=\"freeze\"/></use><animate attributeName=\"display\" fill=\"freeze\" begin=\"indefinite\" repeatCount=\"1\" dur=\"13.125s\" keyTimes=\"0;.987;.997;1\" values=\"none;inline;none;none\"/></g><g display=\"none\"><use xlink:href=\"#Tween-1\" transform=\"matrix(-1 0 0 1 -113.25 260.55)\"><animateTransform attributeName=\"transform\" additive=\"replace\" type=\"translate\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;.978;.987;1\" values=\"-113.25,260.55;-113.25,260.55;-113.4,260.75;-113.4,260.75\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"skewY\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;1\" values=\"180;180\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"scale\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;1\" values=\"-1,1;-1,1\" fill=\"freeze\"/></use><animate attributeName=\"display\" fill=\"freeze\" begin=\"indefinite\" repeatCount=\"1\" dur=\"13.125s\" keyTimes=\"0;.978;.987;1\" values=\"none;inline;none;none\"/></g></g><g id=\"Symbol-4\" overflow=\"visible\"><g><use xlink:href=\"#Layer4_0_FILL\"/></g></g><g id=\"Tween 1_0.0\" overflow=\"visible\"><g><use xlink:href=\"#Layer5_0_FILL\"/></g></g><g id=\"Tween-1\" overflow=\"visible\"><use xlink:href=\"#Tween 1_0.0\"/></g><g id=\"Tween 2_0.0\" overflow=\"visible\"><g><use xlink:href=\"#Layer6_0_FILL\"/></g></g><g id=\"Tween-2\" overflow=\"visible\"><use xlink:href=\"#Tween 2_0.0\"/></g><g id=\"Layer6_0_FILL\"><path fill=\"#000\" stroke=\"none\" d=\"M68.6 136.75L68.6 136.85 73.4 136.8 68.6 136.75M-85.5 85.65L-85.5 102.55 -68.6 102.55 -68.6 85.65 -85.5 85.65M-68.15 102.55L-68.6 102.55 -68.6 136.75 -68.85 136.75 -68.85 136.85 -51.2 136.85 -51.2 102.55 -68.15 102.55M-33.8 119.95L-33.8 136.85 -51.2 136.85 -51.2 154.15 -16.9 154.15 -16.9 119.95 -33.8 119.95M-102.45 102.55L-102.45 102.65 -102.05 102.65 -102.05 136.85 -85.45 136.85 -85.45 136.75 -85.5 136.75 -85.5 102.55 -102.45 102.55M-119.85 -68.6L-136.75 -68.6 -136.75 102.55 -136.8 102.55 -136.8 154.15 -102.65 154.15 -102.65 136.85 -118.95 136.85 -119.15 136.85 -119.85 136.85 -119.85 -68.6M-102.45 -119.8L-119.85 -119.8 -119.85 -68.6 -102.45 -68.6 -102.45 -119.8M-102.45 -119.8L-85.5 -119.8 -85.5 -136.7 -102.45 -136.7 -102.45 -119.8M68.6 102.45L85.5 102.45 85.5 85.55 68.6 85.55 68.6 102.45M102.9 102.45L85.5 102.45 85.5 136.75 102.9 136.75 102.9 102.45M17.4 119.95L17.4 102.65 -16.9 102.65 -16.9 119.95 17.4 119.95M51.05 102.45L51.1 136.75 68.45 136.75 68.45 102.45 51.05 102.45M51.7 136.85L51.1 136.85 34.3 136.85 34.3 119.95 17.4 119.95 17.4 154.15 51.7 154.15 51.7 136.85M136.75 -68.6L119.85 -68.6 119.65 136.75 102.95 136.75 102.95 154.05 136.8 154.05 136.75 -68.6M85.5 -136.7L85.5 -154.1 -85.5 -154.1 -85.5 -136.7 85.5 -136.7M0 0L0 -51.2 -16.9 -51.2 -51.2 -51.2 -51.2 0 -16.9 0 0 0M102.9 -51.2L85.5 -51.2 51.2 -51.2 51.2 0 85.5 0 102.9 0 102.9 -51.2M102.9 -119.8L102.9 -136.7 85.5 -136.7 85.5 -119.8 102.9 -119.8M119.85 -119.8L102.9 -119.8 102.9 -68.6 119.85 -68.6 119.85 -119.8Z\"/><path fill=\"#3CEFEF\" stroke=\"none\" d=\"M85.5 -119.8L85.5 -136.7 -85.5 -136.7 -85.5 -119.8 -102.45 -119.8 -102.45 -68.6 -119.85 -68.6 -119.85 136.85 -119.15 136.85 -118.95 136.45 -118.95 136.85 -102.65 136.85 -102.05 136.85 -102.05 102.65 -102.45 102.65 -102.55 102.65 -102.45 102.45 -102.45 102.55 -85.5 102.55 -85.5 85.65 -68.6 85.65 -68.6 102.55 -68.15 102.55 -68.15 102.45 -51.2 102.45 -51.2 102.55 -51.2 136.85 -33.8 136.85 -33.8 119.95 -16.9 119.95 -16.9 102.65 17.4 102.65 17.4 119.95 34.3 119.95 34.3 136.85 51.1 136.85 51.1 136.75 51.05 102.45 68.45 102.45 68.6 102.45 68.6 85.55 85.5 85.55 85.5 102.45 102.9 102.45 102.9 136.75 102.95 136.75 119.65 136.75 119.85 -68.6 102.9 -68.6 102.9 -119.8 85.5 -119.8M17.4 -51.2L34.3 -51.2 34.3 -68.6 85.5 -68.6 85.5 -51.2 102.9 -51.2 102.9 0 85.5 0 85.5 16.95 34.3 16.95 34.3 0 17.4 0 17.4 -51.2M0 -51.2L0 0 -16.9 0 -16.9 16.95 -68.15 16.95 -68.15 0 -85.5 0 -85.5 -51.2 -68.15 -51.2 -68.15 -68.6 -16.9 -68.6 -16.9 -51.2 0 -51.2Z\"/><path fill=\"#FFF\" stroke=\"none\" d=\"M-16.9 -51.2L-16.9 -68.6 -68.15 -68.6 -68.15 -51.2 -85.5 -51.2 -85.5 0 -68.15 0 -68.15 16.95 -16.9 16.95 -16.9 0 -51.2 0 -51.2 -51.2 -16.9 -51.2M34.3 -51.2L17.4 -51.2 17.4 0 34.3 0 34.3 16.95 85.5 16.95 85.5 0 51.2 0 51.2 -51.2 85.5 -51.2 85.5 -68.6 34.3 -68.6 34.3 -51.2Z\"/></g><g id=\"Layer5_0_FILL\"><path fill=\"#000\" stroke=\"none\" d=\"M-68.15 102.45L-68.15 136.75 -51.2 136.75 -51.2 102.45 -68.15 102.45M-16.9 102.45L-34.3 102.45 -34.3 136.75 -16.9 136.75 -16.9 102.45M-102.45 136.75L-102.45 154.15 -68.15 154.15 -68.15 136.75 -102.45 136.75M-34.3 85.55L-51.2 85.55 -51.2 102.45 -34.3 102.45 -34.3 85.55M-119.85 -68.6L-136.75 -68.6 -136.75 119.85 -119.85 119.85 -119.85 136.75 -102.45 136.75 -102.45 102.45 -119.85 102.45 -119.85 -68.6M-102.45 -119.8L-119.85 -119.8 -119.85 -68.6 -102.45 -68.6 -102.45 -119.8M-102.45 -119.8L-85.5 -119.8 -85.5 -136.7 -102.45 -136.7 -102.45 -119.8M68.6 136.75L68.6 154.15 102.9 154.15 102.9 136.75 68.6 136.75M17.4 154.15L17.4 136.75 -16.9 136.75 -16.9 154.15 17.4 154.15M17.4 102.45L17.4 136.75 34.3 136.75 34.3 102.45 17.4 102.45M68.6 102.45L51.2 102.45 51.2 136.75 68.6 136.75 68.6 102.45M51.2 85.55L34.3 85.55 34.3 102.45 51.2 102.45 51.2 85.55M136.75 -68.6L119.85 -68.6 119.85 102.45 102.9 102.45 102.9 136.75 119.85 136.75 119.85 119.85 136.75 119.85 136.75 -68.6M85.5 -136.7L85.5 -154.1 -85.5 -154.1 -85.5 -136.7 85.5 -136.7M119.85 -119.8L102.9 -119.8 102.9 -68.6 119.85 -68.6 119.85 -119.8M0 0L0 -51.2 -16.9 -51.2 -51.2 -51.2 -51.2 0 -16.9 0 0 0M102.9 -51.2L85.5 -51.2 51.2 -51.2 51.2 0 85.5 0 102.9 0 102.9 -51.2M85.5 -136.7L85.5 -119.8 102.9 -119.8 102.9 -136.7 85.5 -136.7Z\"/><path fill=\"#3CEFEF\" stroke=\"none\" d=\"M85.5 -119.8L85.5 -136.7 -85.5 -136.7 -85.5 -119.8 -102.45 -119.8 -102.45 -68.6 -119.85 -68.6 -119.85 102.45 -102.45 102.45 -102.45 136.75 -68.15 136.75 -68.15 102.45 -51.2 102.45 -51.2 85.55 -34.3 85.55 -34.3 102.45 -16.9 102.45 -16.9 136.75 17.4 136.75 17.4 102.45 34.3 102.45 34.3 85.55 51.2 85.55 51.2 102.45 68.6 102.45 68.6 136.75 102.9 136.75 102.9 102.45 119.85 102.45 119.85 -68.6 102.9 -68.6 102.9 -119.8 85.5 -119.8M17.4 -51.2L34.3 -51.2 34.3 -68.6 85.5 -68.6 85.5 -51.2 102.9 -51.2 102.9 0 85.5 0 85.5 16.95 34.3 16.95 34.3 0 17.4 0 17.4 -51.2M0 -51.2L0 0 -16.9 0 -16.9 16.95 -68.15 16.95 -68.15 0 -85.5 0 -85.5 -51.2 -68.15 -51.2 -68.15 -68.6 -16.9 -68.6 -16.9 -51.2 0 -51.2Z\"/><path fill=\"#FFF\" stroke=\"none\" d=\"M-16.9 -51.2L-16.9 -68.6 -68.15 -68.6 -68.15 -51.2 -85.5 -51.2 -85.5 0 -68.15 0 -68.15 16.95 -16.9 16.95 -16.9 0 -51.2 0 -51.2 -51.2 -16.9 -51.2M34.3 -51.2L17.4 -51.2 17.4 0 34.3 0 34.3 16.95 85.5 16.95 85.5 0 51.2 0 51.2 -51.2 85.5 -51.2 85.5 -68.6 34.3 -68.6 34.3 -51.2Z\"/></g><g id=\"Layer4_0_FILL\"><path fill=\"#3CEFEF\" stroke=\"none\" d=\"M75.3 5.35L75.3 0 0 0 0 53.65 74.9 53.65 74.9 50.45 77.65 50.45 77.65 5.35 75.3 5.35Z\"/></g><g id=\"Layer3_0_FILL\"><path fill=\"#FFF\" stroke=\"none\" d=\"M33.4 6.8L26.8 6.8 26.8 0 6.8 0 6.8 6.8 0 6.8 0 26.8 6.8 26.8 6.8 33.4 26.8 33.4 26.8 26.8 33.4 26.8 33.4 6.8M66.8 6.8L66.8 0 46.8 0 46.8 6.8 40.2 6.8 40.2 26.8 46.8 26.8 46.8 33.4 66.8 33.4 66.8 26.8 73.55 26.8 73.55 6.8 66.8 6.8Z\"/></g><g id=\"Layer2_0_FILL\"><path fill=\"#000\" stroke=\"none\" d=\"M0 20L20 20 20 0 0 0 0 20M60.15 20L60.15 0 40 0 40 20 60.15 20Z\"/></g><g id=\"Layer1_0_FILL\"><path fill=\"#F90\" stroke=\"none\" d=\"M1.55 146.85L1.55 15.7 -.45 15.7 -.45 146.85 1.55 146.85M15.65 160.55L15.65 162.55 70.35 162.55 70.5 162.55 70.5 162.4 70.5 160.55 15.65 160.55M235.4 162.55L235.4 160.55 89.95 160.55 89.9 182.85 91.85 182.85 91.85 162.55 235.4 162.55M251.75 15.7L249.75 15.7 249.75 146.85 251.75 146.85 251.75 15.7M235.4 -.75L15.65 -.75 15.65 1.25 235.4 1.25 235.4 -.75Z\"/><path fill=\"#FFBB03\" stroke=\"none\" d=\"M80.65 167.25L75.45 167.25 75.45 172.4 80.65 172.4 80.65 167.25M70.5 162.4L70.5 162.55 70.35 162.55 70.35 167.25 75.45 167.25 75.45 162.4 70.5 162.4M15.65 157.55L15.65 158.65 70.4 158.65 70.4 156.7 15.65 156.7 15.65 152.35 10.55 152.35 10.55 157.55 15.65 157.55M10.55 146.8L5.4 146.8 5.4 152.15 10.55 152.15 10.55 146.8M10.55 15.65L10.55 10.3 5.4 10.3 5.4 15.65 10.55 15.65M5.4 15.7L3.45 15.7 3.45 146.85 5.4 146.8 5.4 15.7M15.65 10.3L15.65 5.1 10.55 5.1 10.55 10.3 15.65 10.3M240.55 146.8L240.55 152.15 245.7 152.15 245.7 146.8 240.55 146.8M235.4 156.5L235.4 156.7 226.05 156.6 86 156.7 86 172.4 80.65 172.4 80.65 177.75 86 177.75 86 182.85 88 182.85 88 158.65 235.4 158.65 235.4 157.55 240.55 157.55 240.55 152.35 235.4 152.35 235.4 156.5M235.4 5.1L235.4 3.15 15.65 3.15 15.65 5.1 235.4 5.1M235.4 10.3L240.55 10.3 240.55 5.1 235.4 5.1 235.4 10.3M245.7 15.65L245.7 10.3 240.55 10.3 240.55 15.65 245.7 15.65M247.85 15.7L245.7 15.7 245.7 57.55Q245.714 57.575 245.7 57.6L245.7 57.6 245.7 146.75 245.9 146.75 245.9 146.8 247.85 146.85 247.85 15.7Z\"/><path fill=\"#FFF294\" stroke=\"none\" d=\"M15.65 158.65L15.65 160.55 70.5 160.55 70.4 158.65 15.65 158.65M3.45 15.7L1.55 15.7 1.55 146.85 3.45 146.85 3.45 15.7M235.4 160.55L235.4 158.65 88 158.65 88 182.85 89.9 182.85 89.95 160.55 235.4 160.55M235.4 3.15L235.4 1.25 15.65 1.25 15.65 3.15 235.4 3.15M249.75 15.7L247.85 15.7 247.85 146.85 249.75 146.85 249.75 15.7Z\"/><path fill=\"#000\" stroke=\"none\" d=\"M245.7 15.7L245.7 15.65 240.55 15.65 240.55 10.3 235.4 10.3 235.4 5.1 15.65 5.1 15.65 10.3 10.55 10.3 10.55 15.65 5.4 15.65 5.4 15.7 5.4 146.8 10.55 146.8 10.55 152.15 15.65 152.15 15.65 152.35 15.65 156.7 70.4 156.7 70.4 156.55 70.5 156.55 70.4 158.65 70.5 160.55 70.5 162.4 75.45 162.4 75.45 167.25 80.65 167.25 80.65 172.4 86 172.4 86 156.7 226.05 156.6 235.4 156.5 235.4 152.35 235.4 152.15 240.55 152.15 240.55 146.8 245.7 146.8 245.7 146.75 245.7 57.6 245.7 57.55 245.7 15.7Z\"/></g></defs><g id=\"Scene-1-copyr1\" overflow=\"visible\"><g display=\"none\"><use xlink:href=\"#ghost-2o308d315r1\" transform=\"matrix(.39 0 0 .39 177.55 229.7)\"><animateTransform attributeName=\"transform\" additive=\"replace\" type=\"translate\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;.978;.997;1\" values=\"177.498,229.648;177.498,229.648;-18.9,227.75;-18.9,227.75\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"scale\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;1\" values=\".39,.39;.39,.39\" fill=\"freeze\"/></use><animate attributeName=\"display\" fill=\"freeze\" begin=\"indefinite\" repeatCount=\"1\" dur=\"13.125s\" keyTimes=\"0;.978;1\" values=\"none;inline;inline\"/></g><g display=\"none\"><use xlink:href=\"#ghostr12.5s\" transform=\"matrix(.39 0 0 .39 -24.95 229.8)\"><animateTransform attributeName=\"transform\" additive=\"replace\" type=\"translate\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;.029;.057;.067;.079;.117;.156;.194;.232;.267;.308;.343;.384;.429;.473;.517;.568;.613;.66;.705;.752;.797;.835;.886;.965;.978;1\" values=\"-24.902,229.748;-24.902,229.748;200.898,229.748;160.898,229.748;160.898,219.748;160.898,229.748;160.898,219.748;160.898,229.748;160.898,219.748;160.898,229.748;160.898,219.748;160.898,229.748;160.898,219.748;160.898,229.748;160.898,219.748;160.898,229.748;160.898,219.748;160.898,229.748;160.898,219.748;160.898,229.748;160.898,219.748;160.898,221.648;160.896,222.995;160.898,221.648;160.898,229.748;177.548,229.698;177.548,229.698\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"scale\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;1\" values=\".39,.39;.39,.39\" fill=\"freeze\"/></use><animate attributeName=\"display\" fill=\"freeze\" begin=\"indefinite\" repeatCount=\"1\" dur=\"13.125s\" keyTimes=\"0;.029;.978;1\" values=\"none;inline;none;none\"/></g><g display=\"none\"><use xlink:href=\"#Symbol-3\" transform=\"translate(83.3 294.75)\"><animateTransform attributeName=\"transform\" additive=\"replace\" type=\"translate\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;.079;.086;.092;.098;.105;.117;.156;.194;.203;.21;.216;.232;.267;.308;.343;.362;.368;.384;.429;.473;.517;.568;.613;.66;.705;.752;.762;.768;.775;.797;.803;.81;.835;.838;.848;1\" values=\"83.3,294.75;83.3,294.75;83.3,296.4;83.3,298.2;83.3,299.7;83.3,301.5;83.3,304.5;83.3,294.6;83.3,304.5;83.3,302.3;83.3,300.6;83.3,298.8;83.3,294.6;83.3,304.5;83.3,294.6;83.3,304.5;83.3,300.3;83.3,298.8;83.3,294.6;83.3,304.5;83.3,294.6;83.3,304.5;83.3,294.6;83.3,304.5;83.3,294.6;83.3,304.5;83.3,295;83.3,295;83.3,295.45;83.3,295.75;83.3,296.65;83.3,296.95;83.3,297.1;83.3,298;83.3,298;83.3,297.25;83.3,297.25\" fill=\"freeze\"/></use><animate attributeName=\"display\" fill=\"freeze\" begin=\"indefinite\" repeatCount=\"1\" dur=\"13.125s\" keyTimes=\"0;.079;.86;1\" values=\"none;inline;none;none\"/></g><g display=\"none\"><use xlink:href=\"#Symbol-2\" transform=\"translate(96.7 301.55)\"><animateTransform attributeName=\"transform\" additive=\"replace\" type=\"translate\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;.079;.086;.092;.098;.105;.117;.156;.194;.203;.21;.216;.232;.267;.308;.343;.362;.368;.384;.429;.473;.517;.568;.613;.66;.705;.752;.762;.768;.775;.797;.803;.81;.835;.838;.848;.857;1\" values=\"126.75,311.55;126.75,311.55;126.75,305.7;126.75,307.5;126.85,309.054;126.75,310.8;126.75,313.8;126.75,303.9;126.75,313.8;126.75,312.2;126.85,309.949;126.75,308.1;126.75,303.9;126.75,313.8;126.75,303.9;126.75,313.8;126.85,309.654;126.75,308.1;126.75,303.9;126.75,313.8;126.75,303.9;126.75,313.8;126.75,303.9;126.75,313.8;126.75,303.9;126.75,313.8;126.75,304.3;120.15,311.7;120.1,309.499;120.15,312.45;120.15,313.35;120.1,310;120.15,313.8;120.15,314.7;126.65,314.7;126.65,313;126.65,313.95;126.65,313.95\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"scale\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;.092;.098;.105;.203;.21;.216;.343;.362;.368;.762;.768;.775;.797;.803;.81;.838;.848;.857;1\" values=\"1,1;1,1;1,.105;1,1;1,1;1,.105;1,1;1,1;1,.105;1,1;1,1;1,.105;1,1;1,1;1,.105;1,1;1,1;1,.18;1,1;1,1\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"translate\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;.092;.098;.105;.203;.21;.216;.343;.362;.368;.762;.768;.775;.797;.803;.81;.838;.848;.857;1\" values=\"-30.05,-10;-30.05,-10;-30.15,-11;-30.05,-10;-30.05,-10;-30.15,-10.95;-30.05,-10;-30.05,-10;-30.15,-11;-30.05,-10;-30.05,-10;-30.15,-10.95;-30.05,-10;-30.05,-10;-30.15,-10.95;-30.05,-10;-30.05,-10;-30.05,-10.55;-30.05,-10;-30.05,-10\" fill=\"freeze\"/></use><animate attributeName=\"display\" fill=\"freeze\" begin=\"indefinite\" repeatCount=\"1\" dur=\"13.125s\" keyTimes=\"0;.079;.86;1\" values=\"none;inline;none;none\"/></g><g display=\"none\"><use xlink:href=\"#fumetto\" transform=\"matrix(.1 0 0 .1 149.9 160.35)\" opacity=\"1\"><animateTransform attributeName=\"transform\" additive=\"replace\" type=\"translate\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;.063;.079;.086;.98099;.987;.997;1\" values=\"162.501,169.554;162.501,169.554;162.524,169.658;162.559,149.67;162.559,149.67;162.524,169.658;162.501,169.554;162.501,169.554\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"scale\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;.063;.079;.086;.98099;.987;.997;1\" values=\".1,.1;.1,.1;1.295,1.295;1.142,1.142;1.142,1.142;1.295,1.295;.1,.1;.1,.1\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"translate\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;.063;.079;.086;.98099;.987;.997;1\" values=\"-126.6,-92.6;-126.6,-92.6;-125.5,-91.55;-125.65,-91.6;-125.65,-91.6;-125.5,-91.55;-126.6,-92.6;-126.6,-92.6\" fill=\"freeze\"/><animate attributeName=\"opacity\" begin=\"indefinite\" dur=\"13.125s\" keyTimes=\"0;.98699;.997;1\" values=\"1;1;0;0\" fill=\"freeze\"/></use><animate id=\"balloonIntro\" attributeName=\"display\" fill=\"freeze\" begin=\"indefinite\" repeatCount=\"1\" dur=\"13.125s\" keyTimes=\"0;.063;1\" values=\"none;inline;inline\"/></g></g></svg><svg id=\"step2\" image-rendering=\"auto\" baseProfile=\"basic\" version=\"1.1\" preserveAspectRatio=\"xMidYMid meet\" x=\"0px\" y=\"0px\" width=\"320\" height=\"400\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320 400\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" style=\"max-height:100%\"><defs><g id=\"Duplicate-Items-Folder_fumetto\" overflow=\"visible\"><g><use xlink:href=\"#Layer1_0_FILL_2\"/></g></g><g id=\"Duplicate-Items-Folder_Symbol-2\" overflow=\"visible\"><g><use xlink:href=\"#Layer2_0_FILL_2\"/></g></g><g id=\"Duplicate-Items-Folder_Symbol-3\" overflow=\"visible\"><use xlink:href=\"#Duplicate-Items-Folder_Symbol-4\" transform=\"translate(-1.8 -3.65)\"/><g><use xlink:href=\"#Layer3_0_FILL_2\"/></g></g><g id=\"Duplicate-Items-Folder_ghost-2r17.083s\" overflow=\"visible\"><g display=\"none\"><use xlink:href=\"#Duplicate-Items-Folder_Tween-1\" transform=\"matrix(-1 0 0 1 -113.25 260.55)\"/><animate attributeName=\"display\" fill=\"freeze\" begin=\"balloonIntro.end\" repeatDur=\"17.083s\" dur=\"0.292s\" keyTimes=\"0;.857;1\" values=\"none;inline;inline\"/></g><g display=\"none\"><use xlink:href=\"#Duplicate-Items-Folder_Tween-2\" transform=\"matrix(-1 0 0 1 -113.4 260.75)\"><animateTransform attributeName=\"transform\" additive=\"replace\" type=\"translate\" begin=\"balloonIntro.end\" repeatDur=\"17.083s\" dur=\"0.292s\" keyTimes=\"0;.428;.856;1\" values=\"-113.4,260.75;-113.4,260.75;-113.25,260.55;-113.25,260.55\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"skewY\" begin=\"balloonIntro.end\" repeatDur=\"17.083s\" dur=\"0.292s\" keyTimes=\"0;1\" values=\"180;180\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"scale\" begin=\"balloonIntro.end\" repeatDur=\"17.083s\" dur=\"0.292s\" keyTimes=\"0;1\" values=\"-1,1;-1,1\" fill=\"freeze\"/></use><animate attributeName=\"display\" fill=\"freeze\" begin=\"balloonIntro.end\" repeatDur=\"17.083s\" dur=\"0.292s\" keyTimes=\"0;.429;.857;1\" values=\"none;inline;none;none\"/></g><g><use xlink:href=\"#Duplicate-Items-Folder_Tween-1\" transform=\"matrix(-1 0 0 1 -113.25 260.55)\"><animateTransform attributeName=\"transform\" additive=\"replace\" type=\"translate\" begin=\"balloonIntro.end\" repeatDur=\"17.083s\" dur=\"0.292s\" keyTimes=\"0;.428;1\" values=\"-113.25,260.55;-113.4,260.75;-113.4,260.75\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"skewY\" begin=\"balloonIntro.end\" repeatDur=\"17.083s\" dur=\"0.292s\" keyTimes=\"0;1\" values=\"180;180\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"scale\" begin=\"balloonIntro.end\" repeatDur=\"17.083s\" dur=\"0.292s\" keyTimes=\"0;1\" values=\"-1,1;-1,1\" fill=\"freeze\"/></use><animate attributeName=\"display\" fill=\"freeze\" begin=\"balloonIntro.end\" repeatDur=\"17.083s\" dur=\"0.292s\" keyTimes=\"0;.429;1\" values=\"inline;none;none\"/></g></g><g id=\"Duplicate-Items-Folder_Symbol-4\" overflow=\"visible\"/><g id=\"Duplicate Items Folder/Tween 1_0.0\" overflow=\"visible\"><g><use xlink:href=\"#Layer4_0_FILL_2\"/></g></g><g id=\"Duplicate-Items-Folder_Tween-1\" overflow=\"visible\"><use xlink:href=\"#Duplicate Items Folder/Tween 1_0.0\"/></g><g id=\"Duplicate Items Folder/Tween 2_0.0\" overflow=\"visible\"><g><use xlink:href=\"#Layer5_0_FILL_2\"/></g></g><g id=\"Duplicate-Items-Folder_Tween-2\" overflow=\"visible\"><use xlink:href=\"#Duplicate Items Folder/Tween 2_0.0\"/></g><g id=\"Layer5_0_FILL_2\"><path fill=\"#000\" stroke=\"none\" d=\"M68.6 136.75L68.6 136.85 73.4 136.8 68.6 136.75M-85.5 85.65L-85.5 102.55 -68.6 102.55 -68.6 85.65 -85.5 85.65M-68.15 102.55L-68.6 102.55 -68.6 136.75 -68.85 136.75 -68.85 136.85 -51.2 136.85 -51.2 102.55 -68.15 102.55M-33.8 119.95L-33.8 136.85 -51.2 136.85 -51.2 154.15 -16.9 154.15 -16.9 119.95 -33.8 119.95M-102.45 102.55L-102.45 102.65 -102.05 102.65 -102.05 136.85 -85.45 136.85 -85.45 136.75 -85.5 136.75 -85.5 102.55 -102.45 102.55M-119.85 -68.6L-136.75 -68.6 -136.75 102.55 -136.8 102.55 -136.8 154.15 -102.65 154.15 -102.65 136.85 -118.95 136.85 -119.15 136.85 -119.85 136.85 -119.85 -68.6M-102.45 -119.8L-119.85 -119.8 -119.85 -68.6 -102.45 -68.6 -102.45 -119.8M-102.45 -119.8L-85.5 -119.8 -85.5 -136.7 -102.45 -136.7 -102.45 -119.8M68.6 102.45L85.5 102.45 85.5 85.55 68.6 85.55 68.6 102.45M102.9 102.45L85.5 102.45 85.5 136.75 102.9 136.75 102.9 102.45M17.4 119.95L17.4 102.65 -16.9 102.65 -16.9 119.95 17.4 119.95M51.1 136.75L68.45 136.75 68.45 102.45 51.05 102.45 51.1 136.75M51.7 136.85L51.1 136.85 34.3 136.85 34.3 119.95 17.4 119.95 17.4 154.15 51.7 154.15 51.7 136.85M136.75 -68.6L119.85 -68.6 119.65 136.75 102.95 136.75 102.95 154.05 136.8 154.05 136.75 -68.6M85.5 -136.7L85.5 -154.1 -85.5 -154.1 -85.5 -136.7 85.5 -136.7M0 0L0 -51.2 -16.9 -51.2 -51.2 -51.2 -51.2 0 -16.9 0 0 0M102.9 -51.2L85.5 -51.2 51.2 -51.2 51.2 0 85.5 0 102.9 0 102.9 -51.2M102.9 -119.8L102.9 -136.7 85.5 -136.7 85.5 -119.8 102.9 -119.8M119.85 -119.8L102.9 -119.8 102.9 -68.6 119.85 -68.6 119.85 -119.8Z\"/><path fill=\"#3CEFEF\" stroke=\"none\" d=\"M85.5 -119.8L85.5 -136.7 -85.5 -136.7 -85.5 -119.8 -102.45 -119.8 -102.45 -68.6 -119.85 -68.6 -119.85 136.85 -119.15 136.85 -118.95 136.45 -118.95 136.85 -102.65 136.85 -102.05 136.85 -102.05 102.65 -102.45 102.65 -102.55 102.65 -102.45 102.45 -102.45 102.55 -85.5 102.55 -85.5 85.65 -68.6 85.65 -68.6 102.55 -68.15 102.55 -68.15 102.45 -51.2 102.45 -51.2 102.55 -51.2 136.85 -33.8 136.85 -33.8 119.95 -16.9 119.95 -16.9 102.65 17.4 102.65 17.4 119.95 34.3 119.95 34.3 136.85 51.1 136.85 51.1 136.75 51.05 102.45 68.45 102.45 68.6 102.45 68.6 85.55 85.5 85.55 85.5 102.45 102.9 102.45 102.9 136.75 102.95 136.75 119.65 136.75 119.85 -68.6 102.9 -68.6 102.9 -119.8 85.5 -119.8M17.4 -51.2L34.3 -51.2 34.3 -68.6 85.5 -68.6 85.5 -51.2 102.9 -51.2 102.9 0 85.5 0 85.5 16.95 34.3 16.95 34.3 0 17.4 0 17.4 -51.2M0 -51.2L0 0 -16.9 0 -16.9 16.95 -68.15 16.95 -68.15 0 -85.5 0 -85.5 -51.2 -68.15 -51.2 -68.15 -68.6 -16.9 -68.6 -16.9 -51.2 0 -51.2Z\"/><path fill=\"#FFF\" stroke=\"none\" d=\"M-16.9 -51.2L-16.9 -68.6 -68.15 -68.6 -68.15 -51.2 -85.5 -51.2 -85.5 0 -68.15 0 -68.15 16.95 -16.9 16.95 -16.9 0 -51.2 0 -51.2 -51.2 -16.9 -51.2M34.3 -51.2L17.4 -51.2 17.4 0 34.3 0 34.3 16.95 85.5 16.95 85.5 0 51.2 0 51.2 -51.2 85.5 -51.2 85.5 -68.6 34.3 -68.6 34.3 -51.2Z\"/></g><g id=\"Layer4_0_FILL_2\"><path fill=\"#000\" stroke=\"none\" d=\"M-68.15 102.45L-68.15 136.75 -51.2 136.75 -51.2 102.45 -68.15 102.45M-16.9 102.45L-34.3 102.45 -34.3 136.75 -16.9 136.75 -16.9 102.45M-102.45 136.75L-102.45 154.15 -68.15 154.15 -68.15 136.75 -102.45 136.75M-34.3 85.55L-51.2 85.55 -51.2 102.45 -34.3 102.45 -34.3 85.55M-119.85 -68.6L-136.75 -68.6 -136.75 119.85 -119.85 119.85 -119.85 136.75 -102.45 136.75 -102.45 102.45 -119.85 102.45 -119.85 -68.6M-102.45 -119.8L-119.85 -119.8 -119.85 -68.6 -102.45 -68.6 -102.45 -119.8M-102.45 -119.8L-85.5 -119.8 -85.5 -136.7 -102.45 -136.7 -102.45 -119.8M68.6 136.75L68.6 154.15 102.9 154.15 102.9 136.75 68.6 136.75M17.4 154.15L17.4 136.75 -16.9 136.75 -16.9 154.15 17.4 154.15M17.4 102.45L17.4 136.75 34.3 136.75 34.3 102.45 17.4 102.45M68.6 102.45L51.2 102.45 51.2 136.75 68.6 136.75 68.6 102.45M51.2 85.55L34.3 85.55 34.3 102.45 51.2 102.45 51.2 85.55M136.75 -68.6L119.85 -68.6 119.85 102.45 102.9 102.45 102.9 136.75 119.85 136.75 119.85 119.85 136.75 119.85 136.75 -68.6M85.5 -136.7L85.5 -154.1 -85.5 -154.1 -85.5 -136.7 85.5 -136.7M119.85 -119.8L102.9 -119.8 102.9 -68.6 119.85 -68.6 119.85 -119.8M0 0L0 -51.2 -16.9 -51.2 -51.2 -51.2 -51.2 0 -16.9 0 0 0M102.9 -51.2L85.5 -51.2 51.2 -51.2 51.2 0 85.5 0 102.9 0 102.9 -51.2M85.5 -136.7L85.5 -119.8 102.9 -119.8 102.9 -136.7 85.5 -136.7Z\"/><path fill=\"#3CEFEF\" stroke=\"none\" d=\"M85.5 -119.8L85.5 -136.7 -85.5 -136.7 -85.5 -119.8 -102.45 -119.8 -102.45 -68.6 -119.85 -68.6 -119.85 102.45 -102.45 102.45 -102.45 136.75 -68.15 136.75 -68.15 102.45 -51.2 102.45 -51.2 85.55 -34.3 85.55 -34.3 102.45 -16.9 102.45 -16.9 136.75 17.4 136.75 17.4 102.45 34.3 102.45 34.3 85.55 51.2 85.55 51.2 102.45 68.6 102.45 68.6 136.75 102.9 136.75 102.9 102.45 119.85 102.45 119.85 -68.6 102.9 -68.6 102.9 -119.8 85.5 -119.8M17.4 -51.2L34.3 -51.2 34.3 -68.6 85.5 -68.6 85.5 -51.2 102.9 -51.2 102.9 0 85.5 0 85.5 16.95 34.3 16.95 34.3 0 17.4 0 17.4 -51.2M0 -51.2L0 0 -16.9 0 -16.9 16.95 -68.15 16.95 -68.15 0 -85.5 0 -85.5 -51.2 -68.15 -51.2 -68.15 -68.6 -16.9 -68.6 -16.9 -51.2 0 -51.2Z\"/><path fill=\"#FFF\" stroke=\"none\" d=\"M-16.9 -51.2L-16.9 -68.6 -68.15 -68.6 -68.15 -51.2 -85.5 -51.2 -85.5 0 -68.15 0 -68.15 16.95 -16.9 16.95 -16.9 0 -51.2 0 -51.2 -51.2 -16.9 -51.2M34.3 -51.2L17.4 -51.2 17.4 0 34.3 0 34.3 16.95 85.5 16.95 85.5 0 51.2 0 51.2 -51.2 85.5 -51.2 85.5 -68.6 34.3 -68.6 34.3 -51.2Z\"/></g><g id=\"Layer3_0_FILL_2\"><path fill=\"#FFF\" stroke=\"none\" d=\"M33.4 6.8L26.8 6.8 26.8 0 6.8 0 6.8 6.8 0 6.8 0 26.8 6.8 26.8 6.8 33.4 26.8 33.4 26.8 26.8 33.4 26.8 33.4 6.8M66.8 6.8L66.8 0 46.8 0 46.8 6.8 40.2 6.8 40.2 26.8 46.8 26.8 46.8 33.4 66.8 33.4 66.8 26.8 73.55 26.8 73.55 6.8 66.8 6.8Z\"/></g><g id=\"Layer2_0_FILL_2\"><path fill=\"#000\" stroke=\"none\" d=\"M0 20L20 20 20 0 0 0 0 20M60.15 20L60.15 0 40 0 40 20 60.15 20Z\"/></g><g id=\"Layer1_0_FILL_2\"><path fill=\"#F90\" stroke=\"none\" d=\"M1.55 146.85L1.55 15.7 -.45 15.7 -.45 146.85 1.55 146.85M15.65 160.55L15.65 162.55 70.35 162.55 70.5 162.55 70.5 162.4 70.5 160.55 15.65 160.55M235.4 162.55L235.4 160.55 89.95 160.55 89.9 182.85 91.85 182.85 91.85 162.55 235.4 162.55M251.75 15.7L249.75 15.7 249.75 146.85 251.75 146.85 251.75 15.7M235.4 -.75L15.65 -.75 15.65 1.25 235.4 1.25 235.4 -.75Z\"/><path fill=\"#FFBB03\" stroke=\"none\" d=\"M80.65 167.25L75.45 167.25 75.45 172.4 80.65 172.4 80.65 167.25M70.5 162.4L70.5 162.55 70.35 162.55 70.35 167.25 75.45 167.25 75.45 162.4 70.5 162.4M15.65 157.55L15.65 158.65 70.4 158.65 70.4 156.7 15.65 156.7 15.65 152.35 10.55 152.35 10.55 157.55 15.65 157.55M10.55 146.8L5.4 146.8 5.4 152.15 10.55 152.15 10.55 146.8M10.55 15.65L10.55 10.3 5.4 10.3 5.4 15.65 10.55 15.65M5.4 15.7L3.45 15.7 3.45 146.85 5.4 146.8 5.4 15.7M15.65 10.3L15.65 5.1 10.55 5.1 10.55 10.3 15.65 10.3M240.55 146.8L240.55 152.15 245.7 152.15 245.7 146.8 240.55 146.8M235.4 156.5L235.4 156.7 226.05 156.6 86 156.7 86 172.4 80.65 172.4 80.65 177.75 86 177.75 86 182.85 88 182.85 88 158.65 235.4 158.65 235.4 157.55 240.55 157.55 240.55 152.35 235.4 152.35 235.4 156.5M235.4 5.1L235.4 3.15 15.65 3.15 15.65 5.1 235.4 5.1M235.4 10.3L240.55 10.3 240.55 5.1 235.4 5.1 235.4 10.3M245.7 15.65L245.7 10.3 240.55 10.3 240.55 15.65 245.7 15.65M247.85 15.7L245.7 15.7 245.7 57.55Q245.714 57.575 245.7 57.6L245.7 57.6 245.7 146.75 245.9 146.75 245.9 146.8 247.85 146.85 247.85 15.7Z\"/><path fill=\"#FFF294\" stroke=\"none\" d=\"M15.65 158.65L15.65 160.55 70.5 160.55 70.4 158.65 15.65 158.65M3.45 15.7L1.55 15.7 1.55 146.85 3.45 146.85 3.45 15.7M235.4 160.55L235.4 158.65 88 158.65 88 182.85 89.9 182.85 89.95 160.55 235.4 160.55M235.4 3.15L235.4 1.25 15.65 1.25 15.65 3.15 235.4 3.15M249.75 15.7L247.85 15.7 247.85 146.85 249.75 146.85 249.75 15.7Z\"/><path fill=\"#000\" stroke=\"none\" d=\"M245.7 15.7L245.7 15.65 240.55 15.65 240.55 10.3 235.4 10.3 235.4 5.1 15.65 5.1 15.65 10.3 10.55 10.3 10.55 15.65 5.4 15.65 5.4 15.7 5.4 146.8 10.55 146.8 10.55 152.15 15.65 152.15 15.65 152.35 15.65 156.7 70.4 156.7 70.4 156.55 70.5 156.55 70.4 158.65 70.5 160.55 70.5 162.4 75.45 162.4 75.45 167.25 80.65 167.25 80.65 172.4 86 172.4 86 156.7 226.05 156.6 235.4 156.5 235.4 152.35 235.4 152.15 240.55 152.15 240.55 146.8 245.7 146.8 245.7 146.75 245.7 57.6 245.7 57.55 245.7 15.7Z\"/></g></defs><g id=\"Scene-1-copy-copyr1\" overflow=\"visible\"><use xlink:href=\"#Duplicate-Items-Folder_ghost-2r17.083s\" transform=\"matrix(.39 0 0 .39 452.85 218.7)\"><animateTransform attributeName=\"transform\" additive=\"replace\" type=\"translate\" begin=\"balloonIntro.end\" dur=\"17.083s\" keyTimes=\"0;.027;.032;.041;.054;.09;.122;.154;.185;.217;.246;.285;.317;.349;.376;.402;.434;.473;.505;.534;.561;.59;.62;.651;.688;.727;.759;.788;.82;.851;.885;.912;.946;.978;.998;1\" values=\"452.798,218.648;272.798,218.648;272.798,217.047;272.795,213.995;272.798,208.647;272.798,218.648;272.798,208.647;272.798,218.648;272.798,208.647;272.798,218.648;272.798,208.647;272.798,218.648;272.798,208.647;272.798,218.648;272.798,208.647;272.798,218.648;272.798,208.647;272.798,218.648;272.798,208.647;272.798,218.648;272.798,208.647;272.798,218.648;272.798,208.647;272.798,218.648;272.798,208.647;272.798,218.648;272.798,208.647;272.798,218.648;272.798,208.647;272.798,218.648;272.798,208.647;272.798,218.648;272.798,208.647;272.798,218.597;452.795,218.545;452.795,218.545\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"scale\" begin=\"balloonIntro.end\" dur=\"17.083s\" keyTimes=\"0;1\" values=\".39,.39;.39,.39\" fill=\"freeze\"/></use><g display=\"none\"><use xlink:href=\"#Duplicate-Items-Folder_Symbol-3\" transform=\"translate(188.3 283.75)\"><animateTransform attributeName=\"transform\" additive=\"replace\" type=\"translate\" begin=\"balloonIntro.end\" dur=\"17.083s\" keyTimes=\"0;.054;.063;.071;.078;.085;.09;.122;.154;.185;.217;.246;.256;.261;.266;.271;.276;.285;.293;.317;.349;.376;.38;.385;.39;.395;.402;.434;.444;.449;.454;.459;.463;.473;.48;.505;.534;.561;.59;.62;.651;.688;.698;.702;.707;.712;.717;.727;.734;.759;.788;.82;.851;.885;.89;.895;.9;.905;.912;.946;.978;.998;1\" values=\"188.3,283.75;188.3,283.75;188.3,285.75;188.3,287.7;188.3,289.75;188.3,291.7;188.3,292.75;188.3,282.8;188.3,293.9;188.3,284.55;188.3,294.45;188.3,284.5;188.3,285.75;188.3,287.7;188.3,289.75;188.3,292.7;188.3,292.05;188.3,293.05;188.3,291.35;188.3,284.35;188.3,294.1;188.3,283.75;188.3,285.75;188.3,287.75;188.3,289.75;188.3,291.75;188.3,294.45;188.3,284.5;188.3,285.75;188.3,287.7;188.3,289.75;188.3,292.7;188.3,292.05;188.3,293.05;188.3,291.35;188.3,284.35;188.3,294.1;188.3,283.75;188.3,294.1;188.3,283.75;188.3,294.1;188.3,284.5;188.3,285.75;188.3,287.7;188.3,289.75;188.3,292.7;188.3,292.05;188.3,293.05;188.3,291.35;188.3,284.35;188.3,294.1;188.3,283.75;188.3,294.1;188.3,283.75;188.3,285.75;188.3,287.75;188.3,289.75;188.3,291.75;188.3,293.75;188.3,283.75;188.3,293.75;368.3,293.75;368.3,293.75\" fill=\"freeze\"/></use><animate attributeName=\"display\" fill=\"freeze\" begin=\"balloonIntro.end\" repeatCount=\"1\" dur=\"17.083s\" keyTimes=\"0;.054;1\" values=\"none;inline;inline\"/></g><g display=\"none\"><use xlink:href=\"#Duplicate-Items-Folder_Symbol-2\" transform=\"translate(188.7 289.55)\"><animateTransform attributeName=\"transform\" additive=\"replace\" type=\"translate\" begin=\"balloonIntro.end\" dur=\"17.083s\" keyTimes=\"0;.054;.063;.071;.078;.085;.09;.122;.154;.185;.217;.246;.256;.261;.266;.271;.276;.285;.293;.317;.349;.376;.38;.385;.39;.395;.402;.434;.444;.449;.454;.459;.463;.473;.48;.505;.534;.561;.59;.62;.651;.688;.698;.702;.707;.712;.717;.727;.734;.759;.788;.82;.851;.885;.89;.895;.9;.905;.912;.946;.978;.998;1\" values=\"218.75,299.55;218.75,299.55;218.75,295.55;218.8,297.054;218.75,299.55;218.8,301.054;218.75,302.55;218.75,299.6;218.75,309.9;218.75,300.75;218.75,310.8;218.75,300.7;218.75,295.55;218.8,297.054;218.75,299.55;218.8,302.054;218.75,301.55;218.75,302.55;218.75,307.6;218.75,300.6;218.75,310.8;218.75,300.55;224.75,302.55;224.5,304.552;224,306.55;224.9,308.55;218.75,310.8;218.75,300.7;218.75,295.55;218.8,297.054;218.75,299.55;218.8,302.054;218.75,301.55;218.75,302.55;218.75,307.6;218.75,300.6;218.75,310.8;218.75,300.55;218.75,310.8;218.75,300.55;218.75,310.8;218.75,300.7;218.75,295.55;218.8,297.054;218.75,299.55;218.8,302.054;218.75,301.55;218.75,302.55;218.75,307.6;218.75,300.6;218.75,310.8;218.75,300.55;218.75,310.8;218.75,300.55;224.75,302.55;224.5,304.552;224,306.55;224.9,308.55;231.75,310.55;231.75,300.55;231.75,310.55;411.75,310.55;411.75,310.55\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"scale\" begin=\"balloonIntro.end\" dur=\"17.083s\" keyTimes=\"0;.063;.071;.078;.085;.09;.256;.261;.266;.271;.276;.38;.385;.39;.444;.449;.454;.459;.463;.698;.702;.707;.712;.717;.89;.895;.9;1\" values=\"1,1;1,1;1,.105;1,1;1,.105;1,1;1,1;1,.105;1,1;1,.105;1,1;1,1;1,.14;1,1;1,1;1,.105;1,1;1,.105;1,1;1,1;1,.105;1,1;1,.105;1,1;1,1;1,.14;1,1;1,1\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"translate\" begin=\"balloonIntro.end\" dur=\"17.083s\" keyTimes=\"0;.063;.071;.078;.085;.09;.256;.261;.266;.271;.276;.38;.385;.39;.444;.449;.454;.459;.463;.698;.702;.707;.712;.717;.89;.895;.9;1\" values=\"-30.05,-10;-30.05,-10;-30.15,-11.95;-30.05,-10;-30.15,-11.95;-30.05,-10;-30.05,-10;-30.15,-11.95;-30.05,-10;-30.15,-11.95;-30.05,-10;-30.05,-10;-30.05,-11.45;-30.05,-10;-30.05,-10;-30.15,-11.95;-30.05,-10;-30.15,-11.95;-30.05,-10;-30.05,-10;-30.15,-11.95;-30.05,-10;-30.15,-11.95;-30.05,-10;-30.05,-10;-30.05,-11.45;-30.05,-10;-30.05,-10\" fill=\"freeze\"/></use><animate attributeName=\"display\" fill=\"freeze\" begin=\"balloonIntro.end\" repeatCount=\"1\" dur=\"17.083s\" keyTimes=\"0;.054;1\" values=\"none;inline;inline\"/></g><g display=\"none\"><use xlink:href=\"#Duplicate-Items-Folder_fumetto\" transform=\"matrix(-.1 0 0 .1 175.05 149.4)\" opacity=\"1\"><animateTransform attributeName=\"transform\" additive=\"replace\" type=\"translate\" begin=\"balloonIntro.end\" dur=\"17.083s\" keyTimes=\"0;.027;.039;.044;.96099;.966;.978;1\" values=\"162.505,158.556;162.505,158.556;162.564,158.702;162.502,138.662;162.502,138.662;162.564,158.702;162.505,158.556;162.505,158.556\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"skewY\" begin=\"balloonIntro.end\" dur=\"17.083s\" keyTimes=\"0;1\" values=\"180;180\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"scale\" begin=\"balloonIntro.end\" dur=\"17.083s\" keyTimes=\"0;.027;.039;.044;.96099;.966;.978;1\" values=\".1,.1;.1,.1;1.295,1.295;1.142,1.142;1.142,1.142;1.295,1.295;.1,.1;.1,.1\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"scale\" begin=\"balloonIntro.end\" dur=\"17.083s\" keyTimes=\"0;1\" values=\"-1,1;-1,1\" fill=\"freeze\"/><animateTransform attributeName=\"transform\" additive=\"sum\" type=\"translate\" begin=\"balloonIntro.end\" dur=\"17.083s\" keyTimes=\"0;.027;.039;.96599;.978;1\" values=\"-125.5,-91.6;-125.5,-91.6;-125.5,-91.5;-125.5,-91.5;-125.5,-91.6;-125.5,-91.6\" fill=\"freeze\"/><animate attributeName=\"opacity\" begin=\"balloonIntro.end\" dur=\"17.083s\" keyTimes=\"0;.96599;.978;1\" values=\"1;1;0;0\" fill=\"freeze\"/></use><animate id=\"balloonGame\" attributeName=\"display\" fill=\"freeze\" begin=\"balloonIntro.end\" repeatCount=\"1\" dur=\"17.083s\" keyTimes=\"0;.027;1\" values=\"none;inline;inline\"/></g></g></svg></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/pwaInstall.html","<div class=\"pwa-install_container\"><div class=\"pwa-install_overlay\" ng-if=\"(\'SHOW_PWA_INSTALL\' | config)\" ng-class=\"{\'visible\' : showPWAInstall}\"><div class=\"pwa-install_webapp\"><figure class=\"pwa-img\"><img ng-src=\"{{\'pwaInstallBg\' | config}}\" class=\"pwa-cover\"> <img ng-src=\"{{\'icon\' | config}}\" class=\"pwa-icon\"></figure><div class=\"pwa-info\"><h3><dictionary key=\"\'WEBAPP_PWA_INSTALL_TITLE\'\"></dictionary></h3><p><dictionary key=\"\'WEBAPP_PWA_INSTALL_INFO\'\"></dictionary></p><button class=\"btn install\" type=\"button\" ng-click=\"installPWA()\"><dictionary key=\"\'WEBAPP_PWA_INSTALL_BTN\'\"></dictionary></button><button type=\"button\" class=\"btn link\" ng-click=\"continueOnWeb()\" data-mipqa=\"{{closeMipQA}}\"><dictionary key=\"\'WEBAPP_PWA_INSTALL_SKIP\'\"></dictionary></button></div></div></div><div ng-show=\"showPWAInstallFeedback\" class=\"pwa-success\" ng-click=\"showPWAInstallFeedback = false\" ng-class=\"{\'visible\' : showPWAInstallFeedback}\"><img ng-src=\"{{\'icon\' | config}}\" class=\"pwa-icon success\"><p><dictionary key=\"\'WEBAPP_PWA_INSTALL_SUCCESS\'\"></dictionary></p></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/settings.ctr.html","<div class=\"settings-box\" ng-controller=\"SettingsCtr\" data-mipqa=\"account-page\"><dynamic-dom id=\"settingsList\" event-name=\"settingsDataEvent\"></dynamic-dom></div><a ng-if=\"(\'SHOW_LOGOUT_BUTTON_UO20\' | config) && userData.logged\" href=\"{{\'URLMGR_USER20LOGOUT\' | config }}\" class=\"btn logout\"><dictionary key=\"\'WEBAPP_UO30_LOGOUT\'\"></dictionary></a>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/settings30.ctr.html","<div class=\"settings-box\" ng-class=\"{\'activity\' : logged}\" ng-controller=\"Settings30Ctr\" data-mipqa=\"account-page\"><activity ng-if=\"logged\"></activity><div class=\"profile-nick\" ng-if=\"logged && userProfile\"><section ng-bind-html=\"userProfile\"></section></div><ul><li ng-class=\"{\'active\' : (active == {{$index}})}\" ng-repeat=\"single in sections\" class=\"simple-list simple-list--single-line\" data-mipqa=\"{{single.subsection}}-{{single.content_id}}\"><h2 ng-click=\"open(single, $index)\">{{single.label}}</h2><span ng-click=\"open(single, $index)\" class=\"icon-arrow_dx arrow-account\"></span><ul><li ng-class=\"{\'active\' : (active == {{$index}})}\" ng-bind-html=\"single.text\" class=\"account-section\" data-mipqa=\"content-{{single.subsection}}-{{single.content_id}}\"></li></ul></li></ul></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/settings_cloud.html","<div class=\"settings-box\" ng-controller=\"Settings30Ctr\" data-mipqa=\"account-page\"><h2 class=\"page-title\" ng-if=\"!logged\"><dictionary key=\"\'WEBAPP_TITLE_ACCOUNT\'\"></dictionary></h2><div class=\"profile\" ng-if=\"logged\" ng-click=\"goTo(\'favorites\')\"><p><span class=\"icon-account_spento\"></span><dictionary key=\"\'WEBAPP_STATUS_PROFILE\'\"></dictionary></p></div><ul><li ng-class=\"{\'active\' : (active == {{$index}})}\" ng-repeat=\"single in sections\" class=\"simple-list simple-list--single-line\" data-mipqa=\"{{single.subsection}}-{{single.content_id}}\"><h2 ng-click=\"open(single, $index)\">{{single.label}}</h2><ul><li ng-class=\"{\'active\' : (active == {{$index}})}\" ng-bind-html=\"single.text\" class=\"account-section\" data-mipqa=\"content-{{single.subsection}}-{{single.content_id}}\"></li></ul></li></ul><button ng-if=\"logged\" ng-show=\"(\'SHOW_LOGOUT_BUTTON\' | config)\" type=\"button\" ng-click=\"userLogout()\" class=\"btn logout\"><dictionary key=\"\'WEBAPP_UO30_LOGOUT\'\"></dictionary></button></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/simpleNative.html","<div class=\"native-install simple\" ng-if=\"showSimpleNative && intentUrl\" ng-class=\"{\'visible\' : showNativeBanner}\"><button class=\"btn_close close\" type=\"button\" ng-click=\"bannerClose()\"></button><figure></figure><p><dictionary key=\"\'WEBAPP_NATIVEINSTALL_TEXT\'\"></dictionary></p><a class=\"btn play\" ng-click=\"install()\" ng-href=\"{{intentUrl}}\"><dictionary key=\"\'WEBAPP_NATIVEINSTALL_TOP_BTN\'\"></dictionary></a></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/subsBanner.dir.html","<div class=\"subsbanner\" ng-class=\"{\'mini\':mini}\" ng-if=\"guestUser && (\'SHOW_SUBSCRIPTION_BANNER_IN_PAGE\' | config)\"><div class=\"innerCont\"><h2 dir=\"{{setDir((\'WEBAPP_SUBSCRIPTION_BANNER_GENERAL_TITLE\' | dictionary))}}\"><dictionary key=\"\'WEBAPP_SUBSCRIPTION_BANNER_GENERAL_TITLE\'\" ng-if=\"!content\"></dictionary><span class=\"subtext\" ng-if=\"content\" ng-bind-html=\"contentText\"></span></h2><h3 ng-if=\"!mini\"><span class=\"subsLogo\"><dictionary key=\"\'WEBAPP_SUBSCRIPTION_BANNER_LOGO_TEXT\'\"></dictionary></span><dictionary key=\"\'WEBAPP_SUBSCRIPTION_BANNER_GENERAL_TEXT\'\"></dictionary></h3><a class=\"btn play\" ng-click=\"trackClickEvent()\"><dictionary ng-if=\"!mini\" key=\"\'WEBAPP_SUBSCRIPTION_BANNER_GENERAL_CTA\'\"></dictionary><dictionary ng-if=\"mini\" key=\"\'WEBAPP_SUBSCRIPTION_BANNER_MINI_CTA\'\"></dictionary></a></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/terms30.ctr.html","<h2 class=\"general-margin\" ng-if=\"!userData.logged && status\"><dictionary key=\"\'WEBAPP_STATUS_ACCOUNT\'\"></dictionary></h2><button ng-if=\"(\'ENABLE_TERMS_BACK\' | config)\" type=\"button\" class=\"terms-back back\" ng-click=\"backToAccount()\"><span class=\"icon-back\"></span><dictionary key=\"\'WEBAPP_TERMS_BACK_BTN\'\"></dictionary></button><div ng-bind-html=\"text\"></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/top_install_intent.html","<div class=\"mask hybridInstall {{extendedclass}}\" ng-if=\"showBanner && !(\'SHOW_NATIVE_INSTALL_EXTENDED\' | config)\"><div class=\"info-message\"><div class=\"inner-container\"><button class=\"close-message\" type=\"button\" ng-click=\"closeAppBanner()\"><span class=\"icon-x\"></span></button><div class=\"hybridApp\" dir=\"{{setDir(setDictDevice(\'WEBAPP_HYBRIDINSTALL_APPINFO\'))}}\"><h2 dir=\"{{setDir(setDictDevice(\'WEBAPP_HYBRIDINSTALL_TXT\'))}}\"><span class=\"dict\" ng-bind-html=\"setDictDevice(\'WEBAPP_HYBRIDINSTALL_TXT\')\"></span></h2><h5 dir=\"{{setDir(setDictDevice(\'WEBAPP_HYBRIDINSTALL_APPINFO\'))}}\"><span class=\"dict\" ng-bind-html=\"setDictDevice(\'WEBAPP_HYBRIDINSTALL_APPINFO\')\"></span></h5><h6 dir=\"{{setDir(setDictDevice(\'WEBAPP_HYBRIDINSTALL_APPINFOSMALL\'))}}\"><span class=\"dict\" ng-bind-html=\"setDictDevice(\'WEBAPP_HYBRIDINSTALL_APPINFOSMALL\')\"></span></h6></div><button dir=\"{{setDir(setDictDevice(\'WEBAPP_NATIVEINSTALL_TOP_BTN\'))}}\" id=\"goToStore\" type=\"button\" class=\"btn play\" ng-click=\"mobileFingerPrint()\"><span class=\"top\"><span class=\"dict\" ng-bind-html=\"setDictDevice(\'WEBAPP_NATIVEINSTALL_TOP_BTN\')\"></span></span></button><a href=\"\" id=\"invisibleDownloadButton_ext\" style=\"display: none;\"></a></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/parts/welcome.dir.html","<div class=\"welcome-overlay\" ng-show=\"showWelcome\" data-mipqa=\"{{showWelcome ? \'welcome-overlay\' : \'welcome-overlay-hidden\'}}\"><div id=\"welcome-body\"><div ng-if=\"(\'SVG_HEADER_INJECTED\' | config)\" class=\"headersvg\" data-src=\"{{headerSvg}}\"></div><button type=\"button\" class=\"icon-close close\" data-mipqa=\"welcome-close\" ng-click=\"closeWelcome()\"></button><h2><dictionary key=\"\'WEBAPP_WELCOME_MODAL_TITLE\'\"></dictionary></h2><h3><dictionary key=\"\'WEBAPP_WELCOME_MODAL_TEXT\'\"></dictionary></h3><button type=\"button\" class=\"btn play\" ng-click=\"closeWelcome()\"><dictionary key=\"\'WEBAPP_WELCOME_MODAL_ACTION\'\"></dictionary></button></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/search/searchForm.html","<div class=\"container-input\"><form name=\"gmySearch\" ng-submit=\"newSearch()\" autocomplete=\"off\"><div class=\"content-input content-input--explore\" ng-class=\"{\'active\' : inputFocus}\"><span class=\"icon-search_piccola\" ng-click=\"newSearch()\"></span><input inputmode=\"search\" type=\"search\" name=\"search\" class=\"search-input\" ng-pattern=\"searchPattern\" ng-model=\"newQuery\" placeholder=\"{{\'SEARCH_BUTTON_WEBAPP\' | dictionary}}\" ng-focus=\"inputFocus = true\" ng-blur=\"inputFocus = false\" data-mipqa=\"searchBox\"><button type=\"submit\" class=\"hiddenSubmit ng-hide\"></button></div><div id=\"errormsg_search\" class=\"form__message useris-error-msg errorlogin\" data-mipqa=\"error-inpage-message\" ng-show=\"gmySearch.search.$error.pattern\"><div class=\"form__line\"><span class=\"icon icon-allert\"></span><div class=\"message\"><dictionary key=\"\'WEBAPP_SEARCH_REGEX_INFO\'\"></dictionary></div></div></div></form></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/search/searchPage.html","<listnav ng-if=\"!(\'HIDE_LISTNAV\' | config) && (\'SHOW_LISTNAV_EXPLORE\' | config)\"></listnav><div class=\"box-explore\" ng-cloak><search-field></search-field><div ng-include=\"searchResultsTmpl\"></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/search/searchPage_mt.html","<div class=\"box-explore\" ng-cloak><search-field></search-field><div ng-include=\"searchResultsTmpl\"></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/search/searchResultsOrange.html","<div ng-controller=\"SearchPage\"><div ng-show=\"showResults && query\" class=\"js-results\" data-mipqa=\"searchResults\"><h2 class=\"text-center\" ng-if=\"query\"><dictionary key=\"\'WEBAPP_YOU_ARE_SEARCHED\'\"></dictionary><span class=\"searchquery\">{{query}}</span></h2><items query=\"query\" size=\"10\" infinite=\"true\" tmplname=\"boxedList.html\" imgratio=\"{{imgRatio}}\" formaticons=\"true\" abstract=\"(\'ABSTRACT_IN_LISTS\' | config)\"></items></div><div ng-if=\"showNoResults || !query\" class=\"js-noresults\" data-mipqa=\"searchNoResults\"><div class=\"center-block\" ng-if=\"query && showNoResults\"><h2 class=\"text-center\"><dictionary key=\"\'WEBAPP_YOU_ARE_SEARCHED\'\"></dictionary><span class=\"searchquery\">{{query}}</span></h2><p class=\"text-center\"><dictionary key=\"\'WEBAPP_GOLD_SEARCH_NORESULTS\'\"></dictionary></p></div><div class=\"extra-labels\"><h3><dictionary key=\"\'WEBAPP_SUGGEST\'\"></dictionary></h3><ul class=\"labelList\"><li ng-repeat=\"chart in chartSelection\"><a data-mipqa=\"label\" ng-click=\"goLabel(chart)\"><span><img ng-src=\"{{chart.images.url_preview_big}}\"></span>{{chart.name}}</a></li></ul></div><div class=\"extra-items\"><h2><dictionary key=\"\'WEBAPP_SUGGEST_EXTRACONTENT\'\"></dictionary></h2><items abstract=\"(\'ABSTRACT_IN_LISTS\' | config)\" latest=\"true\" shufflegames=\"true\" size=\"5\" tmplname=\"boxedList.html\" imgratio=\"{{imgRatio}}\" formaticons=\"true\"></items></div></div><subs-banner mini=\"true\"></subs-banner></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/search/searchResultsUnified.html","<div ng-controller=\"SearchPage\"><div ng-show=\"showResults && query\" class=\"js-results\" data-mipqa=\"searchResults\"><h2 class=\"text-center\" ng-if=\"query\"><dictionary key=\"\'WEBAPP_YOU_ARE_SEARCHED\'\"></dictionary><span class=\"searchquery\">{{query}}</span></h2><in-page-adv position=\"top\"></in-page-adv><items query=\"query\" size=\"10\" infinite=\"true\" tmplname=\"boxedList.html\" imgratio=\"{{imgRatio}}\" formaticons=\"true\" abstract=\"(\'ABSTRACT_IN_LISTS\' | config)\"></items></div><div ng-if=\"showNoResults || !query\" class=\"js-noresults\" data-mipqa=\"searchNoResults\"><div class=\"center-block\" ng-if=\"query\"><h2 class=\"text-center\"><dictionary key=\"\'WEBAPP_YOU_ARE_SEARCHED\'\"></dictionary><span class=\"searchquery\">{{query}}</span></h2><p class=\"text-center\"><dictionary key=\"\'WEBAPP_GOLD_SEARCH_NORESULTS\'\"></dictionary></p></div><h3 class=\"general-margin-tb\"><dictionary key=\"\'WEBAPP_SUGGEST\'\"></dictionary></h3><items abstract=\"(\'ABSTRACT_IN_LISTS\' | config)\" latest=\"true\" shufflegames=\"true\" size=\"10\" tmplname=\"boxedList.html\" imgratio=\"{{imgRatio}}\" formaticons=\"true\"></items></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/search/searchResults_cloud.html","<div ng-controller=\"SearchPage\"><div ng-show=\"showResults && query\" class=\"js-results\" data-mipqa=\"searchResults\"><items query=\"query\" size=\"10\" infinite=\"true\" tmplname=\"boxedList_cloud.html\" imgratio=\"{{getRatioConf(\'search\', \'ratio_1\')}}\" formaticons=\"true\"></items></div><div ng-if=\"(showNoResults && query) || !query\" class=\"js-noresults\" data-mipqa=\"searchNoResults\"><div class=\"center-block\" ng-if=\"query && showNoResults\"><p class=\"no-results-info\"><dictionary key=\"\'WEBAPP_GOLD_SEARCH_NORESULTS\'\"></dictionary></p></div><div class=\"extra-items\"><div class=\"slider {{getRatioConf(\'search_noResults\', \'ratio_1_4\')}}\"><div class=\"list-details\"><h2 class=\"list-box-title\"><dictionary key=\"\'WEBAPP_SUGGEST\'\"></dictionary></h2></div><items size=\"4\" latest=\"true\" slider=\"slider\" imgratio=\"{{getRatioConf(\'search_noResults\', \'ratio_1_4\')}}\" imgratio=\"{{getRatioConf(\'search_noResults\', \'ratio_1_4\')}}\" sliderconf=\"USERITEMS_SLIDER_CONF_AR_1_4\" tmplname=\"slider_cloud.html\" section=\"label{{$parent.$index | round }}\" class=\"slider slider-{{slider_ratio_1_4.id}}\" dataindex=\"{{slider_ratio_1_4.id}}\" useoutertitle=\"true\" formaticons=\"true\"></items></div><category-grid categories=\"otherCategories\" boxtitle=\"\'WEBAPP_SEARCH_CATEGORIES\'\" size=\"4\"></category-grid><div class=\"slider {{getRatioConf(\'search_noResults_2\', \'ratio_1\')}}\"><div class=\"list-details\"><h2 class=\"list-box-title\"><dictionary key=\"\'WEBAPP_LOVED_GAMES_TITLE\'\"></dictionary></h2></div><items size=\"6\" slider=\"slider\" imgratio=\"{{getRatioConf(\'search_noResults_2\', \'ratio_1\')}}\" imgratio=\"{{getRatioConf(\'search_noResults_2\', \'ratio_1\')}}\" sliderconf=\"USERITEMS_SLIDER_CONF_AR_1\" tmplname=\"slider_cloud.html\" section=\"label{{$parent.$index | round }}\" class=\"slider slider-most-loved-games\" dataindex=\"most-loved-games\" useoutertitle=\"true\" formaticons=\"true\" labelslug=\"(\'TOPGAMES_LABELSLUG\' | config)\" list=\"(\'TOPGAMES_LABELSLUG\' | config)\"></items></div></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/search/searchResults_mt.html","<div ng-controller=\"SearchPage\"><div ng-show=\"showResults && query\" class=\"js-results\" data-mipqa=\"searchResults\"><h2 class=\"text-center\" ng-if=\"query\"><dictionary key=\"\'WEBAPP_YOU_ARE_SEARCHED\'\"></dictionary><span class=\"searchquery\">{{query}}</span></h2><in-page-adv position=\"top\"></in-page-adv><items query=\"query\" size=\"10\" infinite=\"true\" tmplname=\"boxedList_mt.html\" imgratio=\"{{imgRatio}}\" formaticons=\"true\" abstract=\"(\'ABSTRACT_IN_LISTS\' | config)\"></items></div><div ng-if=\"showNoResults || !query\" class=\"js-noresults\" data-mipqa=\"searchNoResults\"><div class=\"center-block\" ng-if=\"query\"><h2 class=\"text-center\"><dictionary key=\"\'WEBAPP_YOU_ARE_SEARCHED\'\"></dictionary><span class=\"searchquery\">{{query}}</span></h2><p class=\"text-center\"><dictionary key=\"\'WEBAPP_GOLD_SEARCH_NORESULTS\'\"></dictionary></p></div><h3 class=\"general-margin-tb\"><dictionary key=\"\'WEBAPP_SUGGEST\'\"></dictionary></h3><items abstract=\"(\'ABSTRACT_IN_LISTS\' | config)\" latest=\"true\" shufflegames=\"true\" size=\"10\" tmplname=\"boxedList_mt.html\" imgratio=\"{{imgRatio}}\" formaticons=\"true\"></items></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/search/searchResults_zain.html","<div ng-controller=\"SearchPage\"><div ng-show=\"showResults && query\" class=\"js-results\" data-mipqa=\"searchResults\"><h2 class=\"text-center\" ng-if=\"query\"><dictionary key=\"\'WEBAPP_YOU_ARE_SEARCHED\'\"></dictionary><span class=\"searchquery\">{{query}}</span></h2><in-page-adv position=\"top\"></in-page-adv><items query=\"query\" size=\"10\" infinite=\"true\" tmplname=\"boxedList_cloud.html\" imgratio=\"{{imgRatio}}\" formaticons=\"true\" abstract=\"(\'ABSTRACT_IN_LISTS\' | config)\"></items></div><div ng-if=\"showNoResults || !query\" class=\"js-noresults\" data-mipqa=\"searchNoResults\"><div class=\"center-block\" ng-if=\"query\"><h2 class=\"text-center\"><dictionary key=\"\'WEBAPP_YOU_ARE_SEARCHED\'\"></dictionary><span class=\"searchquery\">{{query}}</span></h2><p class=\"text-center\"><dictionary key=\"\'WEBAPP_GOLD_SEARCH_NORESULTS\'\"></dictionary></p></div><h3 class=\"general-margin-tb\"><dictionary key=\"\'WEBAPP_SUGGEST\'\"></dictionary></h3><items abstract=\"(\'ABSTRACT_IN_LISTS\' | config)\" latest=\"true\" shufflegames=\"true\" size=\"10\" tmplname=\"boxedList_cloud.html\" imgratio=\"{{imgRatio}}\" formaticons=\"true\"></items></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/zoom/appZoom_orange.html","<div class=\"offer-zoom\"><div id=\"fixed-button-top\" data-mipqa=\"btn-container-scrolling\" ng-if=\"(\'ENABLE_MOVING_PLAY\' | config) && !incompatible\"><figure><img lazy-img=\"{{iconImage | imageSize:180:0}}\" ng-src=\"{{iconImage | imageSize:4:0}}\" alt=\"{{game.title}}\" class=\"img-responsive b-lazy\"></figure><figcaption><h2><strong>{{game.title}}</strong></h2><button id=\"contentBtnTop\" type=\"button\" ng-click=\"getApp(game)\" class=\"btn play\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\'  | dictionary}}\" data-mipqa=\"btn-get-game\" data-format=\"{{game.format}}\"><span dir=\"{{setDir(ctaBtnLabel)}}\">{{ctaBtnLabel}}</span></button></figcaption></div><main><div itemscope itemtype=\"http://schema.org/VideoGame\"><div data-format=\"{{game.format}}\" class=\"zoom-content relative\"><div class=\"game-info cover outer\"><div class=\"{{coverRatio}} inner\"><img lazy-img=\"{{coverImage[0]}}\" ng-src=\"{{coverLoader}}\" title=\"{{game.title}}\" class=\"img-responsive b-lazy\" data-mipqa=\"img-zoom\"></div></div><div id=\"fixed-button\"><figure><img lazy-img=\"{{iconImage | imageSize:180:0}}\" ng-src=\"{{iconImage | imageSize:4:0}}\" alt=\"{{game.title}}\" class=\"img-responsive b-lazy offer-app-icon\"></figure><figcaption><h2 data-mipqa=\"zoom-title\"><strong>{{game.title}}</strong></h2><button id=\"contentAppBtn\" type=\"button\" ng-click=\"getApp(game)\" class=\"btn play\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\'  | dictionary}}\" data-mipqa=\"btn-get-app\" data-format=\"{{game.format}}\"><span dir=\"{{setDir(ctaBtnLabel)}}\">{{ctaBtnLabel}}</span></button></figcaption></div><div class=\"game-info screenshots\" data-mipqa=\"zoom-screenshots\"><div class=\"glide screenshotSlider\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li ng-repeat=\"img in gameImages track by $index\" class=\"slider\" data-itemindex=\"{{$index}}\"><img data-mipqa=\"img-screenshot-thumbnail\" lazy-img=\"{{img}}\" ng-src=\"{{\'loader\' | config}}\" class=\"b-lazy img-responsive {{lazyClass}} screenshot-{{$index}}\" ng-click=\"showScreenshots(gameImages, $index)\"></li></ul></div></div></div><div id=\"shot\" ng-show=\"showShot\"><img ng-src=\"{{selected}}\" class=\"img-responsive\" ng-click=\"showScreenshots(gameImages, currentIndex+1)\"><span class=\"icon-x\" ng-click=\"showShot = !showShot\"></span><button type=\"button\" class=\"prev shotCtrl\" ng-click=\"showScreenshots(gameImages, currentIndex-1)\"><span class=\"icon-arrow\"></span></button><button type=\"button\" class=\"next shotCtrl\" ng-click=\"showScreenshots(gameImages, currentIndex+1)\"><span class=\"icon-arrow\"></span></button></div><div class=\"game-info description\"><h3 dir=\"{{setDir(game.title)}}\">{{game.title}}</h3><pre ng-bind-html=\"gameDesc\" class=\"descriptionContent\" dir=\"{{setDir(gameDesc)}}\" data-mipqa=\"{{descMipQA}}\"></pre></div></div></div></main></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/zoom/gameZoom.html","<div><in-page-adv position=\"top\"></in-page-adv><main><div itemscope itemtype=\"http://schema.org/VideoGame\" ng-class=\"{\'guestZoom\' : game.access_type.guest,\'freeZoom\' : game.access_type.free,\'premiumZoom\' : game.access_type.premium}\"><div data-format=\"{{game.format}}\" class=\"zoom-content relative\" ng-class=\"{\'noapk\':incompatible}\"><div class=\"game-info cover text-center\"><div class=\"{{coverRatio}}\"><span class=\"zoom-contest-badge\" dir=\"{{setDir((\'WEBAPP_COMPETITION_GAMEBADGE_ZOOM\' | dictionary))}}\" ng-if=\"showLDBCompetition && !isContestOver && !notStarted\" ng-show=\"ready\"><dictionary key=\"\'WEBAPP_COMPETITION_GAMEBADGE_ZOOM\'\"></dictionary></span><img lazy-img=\"{{coverImage[0]}}\" ng-src=\"{{coverLoader}}\" alt=\"{{game.title}}\" class=\"img-responsive b-lazy\" data-mipqa=\"img-zoom\" ng-click=\"getGame($event)\"><p class=\"tune-in\" ng-if=\"game.tune_in_msg && (\'SHOW_TUNEINMSG\' | config)\">{{game.tune_in_msg}}</p><h3 data-mipqa=\"zoom-title\" ng-show=\"game.title\" dir=\"{{setDir(game.title)}}\" ng-class=\"textClass\"><span class=\"item-name\" dir=\"{{setDir(game.title)}}\">{{game.title}}</span><span class=\"item-category\" dir=\"{{setDir(game.category.name_category)}}\">{{game.category.name_category}}</span><span ng-if=\"(\'SHOW_PEGI\' | config) && pegiAge\" class=\"item-category\">{{\'WEBAPP_GAMEZOOM_AGE_TITLE\' | dictionary}} {{pegiAge}}</span><button id=\"getContentBtn\" ng-if=\"(\'ZOOM_CTA_ON_COVER\' | config) && !incompatible\" ng-hide=\"startDld || fromSitemap\" type=\"button\" ng-click=\"getGame($event)\" class=\"btn play {{game.format}}\" ng-class=\"{\'playContest\' : showLDBCompetition}\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\'  | dictionary}}\" data-mipqa=\"btn-get-game\" data-format=\"{{game.format}}\" dir=\"{{setDir(ctaBtnLabel)}}\"><span>{{ctaBtnLabel}}</span></button><contest-players game=\"contestGame\" ng-if=\"isContestGame\" starttime=\"start\" endtime=\"end\" ng-show=\"ready && !isContestOver\"></contest-players></h3></div><p class=\"playtime_warn\" ng-if=\"(\'SHOW_ZOOM_PLAYING_WARNING\' | config)\"><dictionary key=\"\'WEBAPP_GAMEZOOM_PLAYING_WARNING\'\"></dictionary></p></div><div class=\"feedbackContainer\" ng-if=\"game.format === \'androidapplications\'\"><p class=\"text-center apk-err\" ng-show=\"dldError\"><dictionary key=\"\'WEBAPP_DOWNLOAD_ERROR_TEXT\'\"></dictionary></p><p class=\"text-center apk-err\" ng-if=\"incompatible || fromSitemap\" data-mipqa=\"game-incompatible\"><span class=\"dict-break err-big\"><dictionary key=\"\'WEBAPP_DOWNLOAD_FAILED_ZOOM_TITLE\'\"></dictionary></span><dictionary key=\"\'WEBAPP_DOWNLOAD_FAILED_ZOOM\'\"></dictionary></p><div class=\"text-center browser-info\" ng-if=\"(\'SHOW_DLD_TIP\' | config)\" ng-show=\"showDldTip\"><p><dictionary key=\"\'WEBAPP_AUTODOWNLOAD_TIP\'\"></dictionary></p><div ng-if=\"(\'SHOW_DLD_FEEDBACK\' | config)\" class=\"animation inject-me\" data-src=\"{{dldAnimation}}\"></div></div></div><div ng-if=\"!(\'ZOOM_CTA_ON_COVER\' | config) && !incompatible\" class=\"sticky-button text-center {{game.format}}\" ng-class=\"{\'fixed\':deviceType == \'phone\' && !privacyCondition, \'incompatiblePlay\': incompatible, \'composite-btn\' : (\'GAME_FORMAT_ICONS\' | config)}\" id=\"sticky-button\"><favorite-button itemid=\"game.id\" unloggedurl=\"game.url_play\" ng-if=\"(\'ENABLE_FAVORITES\'|config)\"></favorite-button><button ng-hide=\"startDld || fromSitemap\" id=\"getContentBtn\" type=\"button\" ng-click=\"getGame($event)\" class=\"btn play\" ng-class=\"{\'playContest\' : showLDBCompetition}\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\'  | dictionary}}\" data-mipqa=\"btn-get-game\" data-format=\"{{game.format}}\"><span dir=\"{{setDir(ctaBtnLabel)}}\">{{ctaBtnLabel}}</span><img class=\"format-game img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config)\" ng-src=\"{{\'transparent-background\' | config}}\"></button></div><p class=\"my-score_zoom\" ng-if=\"myScore && ready\"><dictionary key=\"\'WEBAPP_YOUR_SCORE\'\"></dictionary><span class=\"score\">{{myScore}}</span></p><leaderboard-zoom game=\"contestGame\" dates=\"contestDates\" limit=\"10\" items=\"contestResults\" ng-if=\"showLDBCompetition && !isContestOver && !notStarted\" ng-show=\"ready\"></leaderboard-zoom><hr><leaderboard items=\"gameLdb\" ng-if=\"showLDB && !contestGame\"></leaderboard><hr ng-if=\"showLDB\"><div class=\"game-info screenshots text-center\" data-mipqa=\"zoom-screenshots\"><h3><dictionary key=\"\'WEBAPP_ZOOM_SCREENSHOTS_TITLE\'\"></dictionary></h3><div class=\"imgsCont {{orientation}}\" ng-if=\"!(\'USE_SCREENSHOT_SLIDER\' | config)\"><img data-mipqa=\"img-screenshot-thumbnail\" lazy-img=\"{{img}}\" ng-src=\"{{\'loader\' | config}}\" class=\"b-lazy img-responsive {{lazyClass}} screenshot-{{$index}}\" ng-click=\"showScreenshots(gameImages, $index)\" ng-repeat=\"img in gameImages\"></div><div class=\"glide screenshotSlider\" ng-if=\"(\'USE_SCREENSHOT_SLIDER\' | config)\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li ng-repeat=\"img in gameImages track by $index\" class=\"slider\" data-itemindex=\"{{$index}}\"><img data-mipqa=\"img-screenshot-thumbnail\" ng-src=\"{{img}}\" class=\"img-responsive {{lazyClass}} screenshot-{{$index}}\"></li></ul></div></div></div><div id=\"shot\" ng-show=\"showShot\"><img ng-src=\"{{selected}}\" class=\"img-responsive\" ng-click=\"showScreenshots(gameImages, currentIndex+1)\"><span data-mipqa=\"btn-close-screenshots\" class=\"icon-x\" ng-click=\"showShot = !showShot\"></span><button type=\"button\" class=\"prev shotCtrl\" ng-click=\"showScreenshots(gameImages, currentIndex-1)\"><span class=\"icon-arrow\"></span></button><button type=\"button\" class=\"next shotCtrl\" ng-click=\"showScreenshots(gameImages, currentIndex+1)\"><span class=\"icon-arrow\"></span></button></div><hr><div class=\"description\" ng-class=\"{\'more-hidden\': moreHidden, \'agcom\': (\'URL_IMG_PEGI\' | config)}\"><h3 dir=\"{{setDir(game.title)}}\" ng-bind-html=\"game.title\"></h3><div ng-if=\"(\'URL_IMG_PEGI\' | config)\" class=\"agcom-container\"><img data-mipqa=\"img-pegi\" class=\"img-responsive\" ng-src=\"{{ \'URL_IMG_PEGI\' | config }}\" alt=\"Agcom icon\"></div><p class=\"tune-in-desc\" dir=\"{{setDir(game.tune_in_msg)}}\" ng-if=\"game.tune_in_msg && (\'SHOW_TUNEINMSG\' | config)\">{{game.tune_in_msg}}</p><p data-mipqa=\"package-size\" class=\"size\" ng-if=\"game.format == \'androidapplications\'\"><span class=\"icon-peso\"></span>{{game.size}}</p><p ng-bind-html=\"gameDesc\" data-mipqa=\"{{descMipQA}}\" class=\"descriptionContent\" dir=\"{{setDir(gameDesc)}}\"></p><a ng-click=\"toggleDescription()\" class=\"text-right\" data-mipqa=\"btn-readmore\"><dictionary ng-show=\"moreHidden\" key=\"\'WEBAPP_SHOW_MORE\'\"></dictionary><dictionary key=\"\'WEBAPP_SHOW_LESS\'\" ng-show=\"!moreHidden\"></dictionary></a></div><hr><div data-mipqa=\"zoom-related\" class=\"ralated recommendations\" ng-show=\"relitems.length\"><h3><dictionary key=\"\'WEBAPP_RELATED_TITLE\'\"></dictionary></h3><items ng-if=\"!(\'NOSLIDER_RECOMMENDED\' | config)\" size=\"10\" slider=\"slider\" sliderconf=\"USERITEMS_SLIDER_CONF\" imgratio=\"{{imgRatioRelated}}\" tmplname=\"imgsliderSmall.html\" related=\"game.id\" section=\"related\" class=\"small slider slider-related\" dataindex=\"related\" shufflegames=\"$root.shuffle\" callbackitems=\"nextList\" useoutertitle=\"true\" formaticons=\"true\" list=\"related\"></items><items ng-if=\"(\'NOSLIDER_RECOMMENDED\' | config)\" related=\"game.id\" size=\"2\" imgratio=\"ratio_2\" tmplname=\"boxedList.html\" shufflegames=\"$root.shuffleLists\" callbackitems=\"nextList\" formaticons=\"true\" list=\"related\"></items></div><hr><div data-mipqa=\"zoom-other-games\" class=\"ralated other-games\" ng-show=\"categoryZoomList.length\"><h3><dictionary key=\"\'WEBAPP_ZOOM_OTHER_GAMES_TITLE\'\"></dictionary></h3><items size=\"4\" ng-if=\"!(\'ZOOM_OTHER_LIST_TYPE\' | config) && !(\'ZOOM_OTHER_LIST_TYPE_CAT\' | config)\" tmplname=\"simpleList.html\" readyitems=\"categoryZoomList\" shufflegames=\"$root.shuffleLists\" imgratio=\"ratio_1\" formaticons=\"true\"></items><items size=\"2\" ng-if=\"(\'ZOOM_OTHER_LIST_TYPE\' | config) && !(\'ZOOM_OTHER_LIST_TYPE_CAT\' | config)\" tmplname=\"boxedList.html\" readyitems=\"categoryZoomList\" shufflegames=\"$root.shuffleLists\" abstract=\"true\" imgratio=\"ratio_1\" formaticons=\"true\"></items><items size=\"3\" ng-if=\"(\'ZOOM_OTHER_LIST_TYPE_CAT\' | config) && !(\'ZOOM_OTHER_LIST_TYPE\' | config)\" tmplname=\"boxedList_catDetails.html\" readyitems=\"categoryZoomList\" shufflegames=\"$root.shuffleLists\" abstract=\"true\" imgratio=\"ratio_1\" formaticons=\"true\"></items></div><hr ng-show=\"categoryZoomList.length\"><div data-mipqa=\"zoom-favorites\" class=\"ralated favorites\" ng-if=\"favorites\" ng-show=\"favoritesList\"><h3><dictionary key=\"\'WEBAPP_ZOOM_FAVORITES_TITLE\'\"></dictionary></h3><h3 class=\"h3 btn-chevron\"><a ng-click=\"goTo(\'favorites\')\" data-mipqa=\"btn-go-to-list\" class=\"btn\"><dictionary key=\"\'WEBAPP_LOAD_OTHER_CONTENTS\'\"></dictionary><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span></a></h3><items size=\"4\" tmplname=\"simpleList.html\" imgratio=\"ratio_2\" favorites=\"favorites\" formaticons=\"true\"></items></div><hr ng-if=\"favorites\" ng-show=\"favoritesList\"><div class=\"lucky text-center\" ng-if=\"(\'SHOW_RANDOM_GAME_BTN\' | config)\"><h3><dictionary key=\"\'WEBAPP_RANDOM_GAME_TITLE\'\"></dictionary></h3><div class=\"luckyCont\"><h4><dictionary key=\"\'WEBAPP_RANDOM_GAME_DESC\'\"></dictionary></h4><button data-mipqa=\"btn-random-game\" class=\"btn lucky\" type=\"button\" ng-click=\"randomItem()\" dir=\"{{setDir((\'WEBAPP_RANDOM_GAME_BUTTON\' | dictionary))}}\"><dictionary key=\"\'WEBAPP_RANDOM_GAME_BUTTON\'\"></dictionary></button></div></div><div class=\"guestfavs text-center\" ng-show=\"showsignin\"><p><dictionary key=\"\'WEBAPP_UNLOGGED_FAVORITES_TIP\'\"></dictionary></p><a ng-href=\"{{game.url_play}}?show_paywall=1\" class=\"btn\"><dictionary key=\"\'WEBAPP_UNLOGGED_FAVORITES_SIGNIN\'\"></dictionary></a><button type=\"button\" class=\"icon-x\" ng-click=\"showsignin = false\"></button></div></div></div></main><a href=\"\" id=\"invisibleDownloadButton_extZoom\" style=\"display: none;\"></a></div><hybrid-install postype=\"bottom-banner\" tmplname=\"nativeInstall.html\" ng-class=\"{\'visible\' : showextendedbanner}\"></hybrid-install>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/zoom/gameZoom_asiacell.html","<div><div id=\"fixed-button-top\" data-mipqa=\"btn-container-scrolling\" ng-if=\"(\'ENABLE_MOVING_PLAY\' | config) && !incompatible\"><figure><img lazy-img=\"{{iconImage | imageSize:180:0}}\" ng-src=\"{{iconImage | imageSize:4:0}}\" alt=\"{{game.title}}\" class=\"img-responsive b-lazy\"></figure><figcaption><h2><strong>{{game.title}}</strong></h2><button ng-hide=\"startDld || fromSitemap || incompatible\" id=\"contentBtnTop\" type=\"button\" ng-click=\"getGame($event, document.querySelector(\'#contentBtnTop\'))\" class=\"btn play\" ng-class=\"{\'playContest\' : showLDBCompetition}\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\'  | dictionary}}\" data-mipqa=\"btn-get-game\" data-format=\"{{game.format}}\"><span dir=\"{{setDir(ctaBtnLabel)}}\">{{ctaBtnLabel}}</span></button></figcaption></div><main><div itemscope itemtype=\"http://schema.org/VideoGame\" ng-class=\"{\'guestZoom\' : game.access_type.guest,\'freeZoom\' : game.access_type.free,\'premiumZoom\' : game.access_type.premium}\"><div data-format=\"{{game.format}}\" class=\"zoom-content relative\" ng-class=\"{\'noapk\':incompatible}\"><div class=\"game-info cover outer\"><div class=\"{{coverRatio}} inner\"><div class=\"zoom-contest-badge\" dir=\"{{setDir((\'WEBAPP_COMPETITION_GAMEBADGE_ZOOM\' | dictionary))}}\" ng-if=\"showLDBCompetition && !isContestOver && !notStarted\"><dictionary key=\"\'WEBAPP_COMPETITION_GAMEBADGE_ZOOM\'\"></dictionary></div><img lazy-img=\"{{coverImage[0]}}\" ng-src=\"{{coverLoader}}\" alt=\"{{game.title}}\" class=\"img-responsive b-lazy\" data-mipqa=\"img-zoom\"></div></div><div class=\"feedbackContainer\" ng-if=\"game.format === \'androidapplications\'\"><p class=\"text-center apk-err\" ng-show=\"dldError\"><dictionary key=\"\'WEBAPP_DOWNLOAD_ERROR_TEXT\'\"></dictionary></p><p class=\"text-center apk-err\" ng-if=\"incompatible || fromSitemap\" data-mipqa=\"game-incompatible\"><span class=\"dict-break err-big\"><dictionary key=\"\'WEBAPP_DOWNLOAD_FAILED_ZOOM_TITLE\'\"></dictionary></span><dictionary key=\"\'WEBAPP_DOWNLOAD_FAILED_ZOOM\'\"></dictionary></p><div class=\"text-center browser-info\" ng-if=\"(\'SHOW_DLD_TIP\' | config)\" ng-show=\"showDldTip\"><p><dictionary key=\"\'WEBAPP_AUTODOWNLOAD_TIP\'\"></dictionary></p><div ng-if=\"(\'SHOW_DLD_FEEDBACK\' | config)\" class=\"animation inject-me\" data-src=\"{{dldAnimation}}\"></div></div></div><div ng-class=\"{\'incompatiblePlay\': incompatible, \'composite-btn\' : (\'GAME_FORMAT_ICONS\' | config)}\" id=\"fixed-button\"><figure><img lazy-img=\"{{iconImage | imageSize:180:0}}\" ng-src=\"{{iconImage | imageSize:4:0}}\" alt=\"{{game.title}}\" class=\"img-responsive b-lazy\"></figure><figcaption><h2 data-mipqa=\"zoom-title\"><strong>{{game.title}}</strong><span>{{game.publisher.title_publisher}}</span></h2><div class=\"zoom-actions\"><button ng-hide=\"startDld || fromSitemap\" ng-if=\"!incompatible\" id=\"contentBtn\" type=\"button\" ng-click=\"getGame($event)\" class=\"btn play\" ng-class=\"{\'playContest\' : showLDBCompetition}\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\'  | dictionary}}\" data-mipqa=\"btn-get-game\" data-format=\"{{game.format}}\"><span dir=\"{{setDir(ctaBtnLabel)}}\">{{ctaBtnLabel}}</span><img class=\"format-game img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config)\" ng-src=\"{{formatIcon}}\"></button><favorite-button itemid=\"game.id\" unloggedurl=\"game.url_play\" ng-if=\"(\'ENABLE_FAVORITES\'|config) && !guestUser\"></favorite-button></div></figcaption></div><div class=\"zoom-contest-data\" ng-show=\"ready\"><h3 class=\"contest-title\"><dictionary key=\"\'WEBAPP_COMPETITION_CONTEST_TITLE\'\"></dictionary></h3><p class=\"my-score_zoom\" ng-show=\"myScore\"><dictionary key=\"\'WEBAPP_YOUR_SCORE\'\"></dictionary><span class=\"score\">{{myScore}}</span></p><contest-time page=\"contest-page\" dates=\"contestDates\"></contest-time><leaderboard-zoom game=\"contestGame\" dates=\"contestDates\" items=\"contestResults\" limit=\"10\" ng-if=\"showLDBCompetition && !isContestOver && !notStarted\"></leaderboard-zoom></div><div class=\"game-info screenshots\" data-mipqa=\"zoom-screenshots\"><h3><dictionary key=\"\'WEBAPP_ZOOM_SCREENSHOTS_TITLE\'\"></dictionary></h3><div class=\"glide screenshotSlider\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li ng-repeat=\"img in gameImages track by $index\" class=\"slider\" data-itemindex=\"{{$index}}\"><img data-mipqa=\"img-screenshot-thumbnail\" lazy-img=\"{{img}}\" ng-src=\"{{\'loader\' | config}}\" class=\"b-lazy img-responsive {{lazyClass}} screenshot-{{$index}}\" ng-click=\"showScreenshots(gameImages, $index)\"></li></ul></div></div></div><div id=\"shot\" ng-show=\"showShot\"><img ng-src=\"{{selected}}\" class=\"img-responsive\" ng-click=\"showScreenshots(gameImages, currentIndex+1)\"><span class=\"icon-x\" ng-click=\"showShot = !showShot\"></span><button type=\"button\" class=\"prev shotCtrl\" ng-click=\"showScreenshots(gameImages, currentIndex-1)\"><span class=\"icon-arrow\"></span></button><button type=\"button\" class=\"next shotCtrl\" ng-click=\"showScreenshots(gameImages, currentIndex+1)\"><span class=\"icon-arrow\"></span></button></div><div class=\"game-info description\" ng-class=\"{\'more-hidden\': moreHidden, \'agcom\': (\'URL_IMG_PEGI\' | config)}\"><h3 dir=\"{{setDir((\'WEBAPP_ZOOM_DESCRIPTION_TITLE\' | dictionary))}}\"><dictionary key=\"\'WEBAPP_ZOOM_DESCRIPTION_TITLE\'\"></dictionary></h3><div ng-if=\"(\'URL_IMG_PEGI\' | config)\" class=\"agcom-container\"><img data-mipqa=\"img-pegi\" class=\"img-responsive\" ng-src=\"{{ \'URL_IMG_PEGI\' | config }}\" alt=\"Agcom icons\"></div><p data-mipqa=\"package-size\" class=\"size\" ng-if=\"game.format == \'androidapplications\'\"><span class=\"icon-peso\"></span>{{game.size}}</p><p ng-bind-html=\"gameDesc\" class=\"descriptionContent\" dir=\"{{setDir(gameDesc)}}\" data-mipqa=\"{{descMipQA}}\"></p><a ng-click=\"toggleDescription()\" class=\"text-right\" data-mipqa=\"btn-readmore\"><dictionary ng-show=\"moreHidden\" key=\"\'WEBAPP_SHOW_MORE\'\"></dictionary><dictionary key=\"\'WEBAPP_SHOW_LESS\'\" ng-show=\"!moreHidden\"></dictionary></a></div><div data-mipqa=\"zoom-related\" class=\"game-info recommendations slider-content ratio_2\" ng-show=\"relitems.length\"><items size=\"10\" slider=\"slider\" sliderconf=\"USERITEMS_SLIDER_CONF_AR_2\" imgratio=\"{{imgRatioRelated}}\" tmplname=\"imgsliderComplete.html\" related=\"game.id\" section=\"related\" class=\"small slider slider-related\" dataindex=\"related\" shufflegames=\"$root.shuffle\" callbackitems=\"nextList\" slidertitle=\"{{\'WEBAPP_RELATED_TITLE\' | dictionary}}\" formaticons=\"true\" list=\"related\"></items></div><div data-mipqa=\"zoom-other-games\" class=\"game-info other-games slider-content ratio_1\" ng-show=\"categoryZoomList.length\"><items size=\"8\" slider=\"slider\" class=\"small slider slider-other-games\" sliderconf=\"USERITEMS_SLIDER_CONF_AR_1\" tmplname=\"imgsliderComplete.html\" dataindex=\"other-games\" section=\"other-games\" readyitems=\"categoryZoomList\" shufflegames=\"$root.shuffleLists\" slidertitle=\"{{\'WEBAPP_ZOOM_OTHER_GAMES_TITLE\' | dictionary}}\" imgratio=\"ratio_1\" formaticons=\"true\" list=\"gameCatData\"></items></div></div></div></main></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/zoom/gameZoom_cloud.html","<div class=\"game-zoom-cloud\"><div id=\"fixed-button-top\" data-mipqa=\"btn-container-scrolling\" ng-if=\"(\'ENABLE_MOVING_PLAY\' | config) && !incompatible\"><figure><img lazy-img=\"{{iconImage | imageSize:180:0}}\" ng-src=\"{{iconImage | imageSize:4:0}}\" alt=\"{{game.title}}\" class=\"img-responsive b-lazy\"></figure><figcaption><h2><strong>{{game.title}}</strong></h2><button id=\"contentBtnTop\" type=\"button\" ng-click=\"gamePlay($event)\" class=\"btn play\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\'  | dictionary}}\" data-mipqa=\"btn-get-game\" data-format=\"{{game.format}}\"><span dir=\"{{setDir(ctaBtnLabel)}}\">{{ctaBtnLabel}}</span></button></figcaption></div><main><div itemscope itemtype=\"http://schema.org/VideoGame\"><div data-format=\"{{game.format}}\" class=\"zoom-content relative\"><div class=\"game-info cover {{coverRatio}}\"><img lazy-img=\"{{coverImage[0]}}\" title=\"{{game.title}}\" class=\"img-responsive b-lazy\" data-mipqa=\"img-zoom\"></div><div id=\"fixed-button\" class=\"{{textClass}}\"><div class=\"overlayed\"><figure><img lazy-img=\"{{iconImage | imageSize:180:0}}\" alt=\"{{game.title}}\" class=\"img-responsive b-lazy game-app-icon\"></figure><favorite-button itemid=\"game.id\" unloggedurl=\"game.url_play\" ng-if=\"(\'ENABLE_FAVORITES\'|config)\"></favorite-button><figcaption class=\"{{textClass}}\"><h2 data-mipqa=\"zoom-title\"><strong>{{game.title}}</strong></h2><p>{{game.publisher.title_publisher}}</p><button id=\"contentAppBtn\" type=\"button\" ng-click=\"gamePlay($event)\" class=\"btn play\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\'  | dictionary}}\" data-mipqa=\"btn-get-app\" data-format=\"{{game.format}}\"><span dir=\"{{setDir(ctaBtnLabel)}}\">{{ctaBtnLabel}}</span></button></figcaption></div></div><div class=\"game-info description\"><h3 dir=\"{{setDir((\'WEBAPP_DESCRIPTION\' | dictionary))}}\"><dictionary key=\"\'WEBAPP_DESCRIPTION\'\"></dictionary></h3><pre ng-bind-html=\"gameDesc\" class=\"descriptionContent\" dir=\"{{setDir(gameDesc)}}\" data-mipqa=\"{{descMipQA}}\"></pre></div><div class=\"game-info screenshots\" data-mipqa=\"zoom-screenshots\"><div class=\"glide screenshotSlider\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li ng-repeat=\"img in gameImages track by $index\" class=\"slider\" data-itemindex=\"{{$index}}\"><img data-mipqa=\"img-screenshot-thumbnail\" loading=\"lazy\" ng-src=\"{{img}}\" class=\"img-responsive {{lazyClass}} screenshot-{{$index}}\" ng-click=\"showScreenshots(gameImages, $index)\"></li></ul></div></div></div><div id=\"shot\" ng-show=\"showShot\"><img ng-src=\"{{selected}}\" class=\"img-responsive\" ng-click=\"showScreenshots(gameImages, currentIndex+1)\"><span class=\"icon-x\" ng-click=\"showShot = !showShot\"></span><button type=\"button\" class=\"prev shotCtrl\" ng-click=\"showScreenshots(gameImages, currentIndex-1)\"><span class=\"icon-arrow\"></span></button><button type=\"button\" class=\"next shotCtrl\" ng-click=\"showScreenshots(gameImages, currentIndex+1)\"><span class=\"icon-arrow\"></span></button></div><div class=\"guestfavs text-center\" ng-show=\"showsignin\"><p><dictionary key=\"\'WEBAPP_UNLOGGED_FAVORITES_TIP\'\"></dictionary></p><a ng-href=\"{{game.url_play}}\" class=\"btn\"><dictionary key=\"\'WEBAPP_UNLOGGED_FAVORITES_SIGNIN\'\"></dictionary></a><button type=\"button\" class=\"icon-x\" ng-click=\"showsignin = false\"></button></div></div></div></main><pwa-install></pwa-install></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/zoom/gameZoom_mt.html","<div><in-page-adv position=\"top\"></in-page-adv><main><div itemscope itemtype=\"http://schema.org/VideoGame\" ng-class=\"{\'guestZoom\' : game.access_type.guest,\'freeZoom\' : game.access_type.free,\'premiumZoom\' : game.access_type.premium}\"><div data-format=\"{{game.format}}\" class=\"zoom-content relative\" ng-class=\"{\'noapk\':incompatible}\"><div class=\"game-info cover text-center\"><div class=\"{{coverRatio}}\"><span class=\"zoom-contest-badge\" dir=\"{{setDir((\'WEBAPP_COMPETITION_GAMEBADGE_ZOOM\' | dictionary))}}\" ng-if=\"showLDBCompetition && !isContestOver && !notStarted\" ng-show=\"ready\"><dictionary key=\"\'WEBAPP_COMPETITION_GAMEBADGE_ZOOM\'\"></dictionary></span><img lazy-img=\"{{coverImage[0]}}\" ng-src=\"{{coverLoader}}\" alt=\"{{game.title}}\" class=\"img-responsive b-lazy\" data-mipqa=\"img-zoom\" ng-click=\"getGame($event)\"><p class=\"tune-in\" ng-if=\"game.tune_in_msg && (\'SHOW_TUNEINMSG\' | config)\">{{game.tune_in_msg}}</p><h3 data-mipqa=\"zoom-title\" ng-show=\"game.title\" dir=\"{{setDir(game.title)}}\" ng-class=\"textClass\"><span class=\"item-name\" dir=\"{{setDir(game.title)}}\">{{game.title}}</span><span class=\"item-category\" dir=\"{{setDir(game.category.name_category)}}\">{{game.category.name_category}}</span><button id=\"getContentBtn\" ng-if=\"(\'ZOOM_CTA_ON_COVER\' | config) && !incompatible\" ng-hide=\"startDld || fromSitemap\" type=\"button\" ng-click=\"getGame($event)\" class=\"btn play {{game.format}}\" ng-class=\"{\'playContest\' : showLDBCompetition}\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\'  | dictionary}}\" data-mipqa=\"btn-get-game\" data-format=\"{{game.format}}\" dir=\"{{setDir(ctaBtnLabel)}}\"><span>{{ctaBtnLabel}}</span></button><contest-players game=\"contestGame\" ng-if=\"isContestGame\" starttime=\"start\" endtime=\"end\" ng-show=\"ready && !isContestOver\"></contest-players></h3></div></div><div class=\"feedbackContainer\" ng-if=\"game.format === \'androidapplications\'\"><p class=\"text-center apk-err\" ng-show=\"dldError\"><dictionary key=\"\'WEBAPP_DOWNLOAD_ERROR_TEXT\'\"></dictionary></p><p class=\"text-center apk-err\" ng-if=\"incompatible || fromSitemap\" data-mipqa=\"game-incompatible\"><span class=\"dict-break err-big\"><dictionary key=\"\'WEBAPP_DOWNLOAD_FAILED_ZOOM_TITLE\'\"></dictionary></span><dictionary key=\"\'WEBAPP_DOWNLOAD_FAILED_ZOOM\'\"></dictionary></p><div class=\"text-center browser-info\" ng-if=\"(\'SHOW_DLD_TIP\' | config)\" ng-show=\"showDldTip\"><p><dictionary key=\"\'WEBAPP_AUTODOWNLOAD_TIP\'\"></dictionary></p><div ng-if=\"(\'SHOW_DLD_FEEDBACK\' | config)\" class=\"animation inject-me\" data-src=\"{{dldAnimation}}\"></div></div></div><div ng-if=\"!(\'ZOOM_CTA_ON_COVER\' | config) && !incompatible\" class=\"sticky-button text-center {{game.format}}\" ng-class=\"{\'fixed\':deviceType == \'phone\' && !privacyCondition, \'incompatiblePlay\': incompatible, \'composite-btn\' : (\'GAME_FORMAT_ICONS\' | config)}\" id=\"sticky-button\"><favorite-button itemid=\"game.id\" unloggedurl=\"game.url_play\" ng-if=\"(\'ENABLE_FAVORITES\'|config)\"></favorite-button><button ng-hide=\"startDld || fromSitemap\" id=\"getContentBtn\" type=\"button\" ng-click=\"getGame($event)\" class=\"btn play\" ng-class=\"{\'playContest\' : showLDBCompetition}\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\'  | dictionary}}\" data-mipqa=\"btn-get-game\" data-format=\"{{game.format}}\"><span dir=\"{{setDir(ctaBtnLabel)}}\">{{ctaBtnLabel}}</span><img class=\"format-game img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config)\" ng-src=\"{{\'transparent-background\' | config}}\"></button></div><p class=\"my-score_zoom\" ng-if=\"myScore && ready\"><dictionary key=\"\'WEBAPP_YOUR_SCORE\'\"></dictionary><span class=\"score\">{{myScore}}</span></p><leaderboard-zoom game=\"contestGame\" dates=\"contestDates\" limit=\"10\" ng-if=\"showLDBCompetition && !isContestOver && !notStarted\" ng-show=\"ready\"></leaderboard-zoom><hr><leaderboard items=\"gameLdb\" ng-if=\"showLDB\"></leaderboard><hr ng-if=\"showLDB\"><div class=\"game-info screenshots text-center\" data-mipqa=\"zoom-screenshots\"><h3><dictionary key=\"\'WEBAPP_ZOOM_SCREENSHOTS_TITLE\'\"></dictionary></h3><div class=\"imgsCont {{orientation}}\" ng-if=\"!(\'USE_SCREENSHOT_SLIDER\' | config)\"><img data-mipqa=\"img-screenshot-thumbnail\" lazy-img=\"{{img}}\" ng-src=\"{{\'loader\' | config}}\" class=\"b-lazy img-responsive {{lazyClass}} screenshot-{{$index}}\" ng-click=\"showScreenshots(gameImages, $index)\" ng-repeat=\"img in gameImages\"></div><div class=\"glide screenshotSlider\" ng-if=\"(\'USE_SCREENSHOT_SLIDER\' | config)\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li ng-repeat=\"img in gameImages track by $index\" class=\"slider\" data-itemindex=\"{{$index}}\"><img data-mipqa=\"img-screenshot-thumbnail\" ng-src=\"{{img}}\" class=\"img-responsive {{lazyClass}} screenshot-{{$index}}\"></li></ul></div></div></div><div id=\"shot\" ng-show=\"showShot\"><img ng-src=\"{{selected}}\" class=\"img-responsive\" ng-click=\"showScreenshots(gameImages, currentIndex+1)\"><span data-mipqa=\"btn-close-screenshots\" class=\"icon-x\" ng-click=\"showShot = !showShot\"></span><button type=\"button\" class=\"prev shotCtrl\" ng-click=\"showScreenshots(gameImages, currentIndex-1)\"><span class=\"icon-arrow\"></span></button><button type=\"button\" class=\"next shotCtrl\" ng-click=\"showScreenshots(gameImages, currentIndex+1)\"><span class=\"icon-arrow\"></span></button></div><hr><div class=\"description\" ng-class=\"{\'more-hidden\': moreHidden, \'agcom\': (\'URL_IMG_PEGI\' | config)}\"><h3 dir=\"{{setDir(game.title)}}\" ng-bind-html=\"game.title\"></h3><div ng-if=\"(\'URL_IMG_PEGI\' | config)\" class=\"agcom-container\"><img data-mipqa=\"img-pegi\" class=\"img-responsive\" ng-src=\"{{ \'URL_IMG_PEGI\' | config }}\" alt=\"Agcom icon\"></div><p class=\"tune-in-desc\" dir=\"{{setDir(game.tune_in_msg)}}\" ng-if=\"game.tune_in_msg && (\'SHOW_TUNEINMSG\' | config)\">{{game.tune_in_msg}}</p><p data-mipqa=\"package-size\" class=\"size\" ng-if=\"game.format == \'androidapplications\'\"><span class=\"icon-peso\"></span>{{game.size}}</p><p ng-bind-html=\"gameDesc\" data-mipqa=\"{{descMipQA}}\" class=\"descriptionContent\" dir=\"{{setDir(gameDesc)}}\"></p><a ng-click=\"toggleDescription()\" class=\"text-right\" data-mipqa=\"btn-readmore\"><dictionary ng-show=\"moreHidden\" key=\"\'WEBAPP_SHOW_MORE\'\"></dictionary><dictionary key=\"\'WEBAPP_SHOW_LESS\'\" ng-show=\"!moreHidden\"></dictionary></a></div><hr><div data-mipqa=\"zoom-related\" class=\"ralated recommendations\" ng-show=\"relitems.length\"><h3><dictionary key=\"\'WEBAPP_RELATED_TITLE\'\"></dictionary></h3><items ng-if=\"!(\'NOSLIDER_RECOMMENDED\' | config)\" size=\"10\" slider=\"slider\" sliderconf=\"USERITEMS_SLIDER_CONF\" imgratio=\"{{imgRatioRelated}}\" tmplname=\"imgsliderSmall.html\" related=\"game.id\" section=\"related\" class=\"small slider slider-related\" dataindex=\"related\" shufflegames=\"$root.shuffle\" callbackitems=\"nextList\" useoutertitle=\"true\" formaticons=\"true\" list=\"related\"></items><items ng-if=\"(\'NOSLIDER_RECOMMENDED\' | config)\" related=\"game.id\" size=\"2\" imgratio=\"ratio_2\" tmplname=\"boxedList_mt.html\" shufflegames=\"$root.shuffleLists\" callbackitems=\"nextList\" formaticons=\"true\" list=\"related\"></items></div><hr><div class=\"lucky text-center\" ng-if=\"(\'SHOW_RANDOM_GAME_BTN\' | config)\"><h3><dictionary key=\"\'WEBAPP_RANDOM_GAME_TITLE\'\"></dictionary></h3><div class=\"luckyCont\"><h4><dictionary key=\"\'WEBAPP_RANDOM_GAME_DESC\'\"></dictionary></h4><button data-mipqa=\"btn-random-game\" class=\"btn lucky\" type=\"button\" ng-click=\"randomItem()\" dir=\"{{setDir((\'WEBAPP_RANDOM_GAME_BUTTON\' | dictionary))}}\"><dictionary key=\"\'WEBAPP_RANDOM_GAME_BUTTON\'\"></dictionary></button></div></div><div class=\"guestfavs text-center\" ng-show=\"showsignin\"><p><dictionary key=\"\'WEBAPP_UNLOGGED_FAVORITES_TIP\'\"></dictionary></p><a ng-href=\"{{game.url_play}}?show_paywall=1\" class=\"btn\"><dictionary key=\"\'WEBAPP_UNLOGGED_FAVORITES_SIGNIN\'\"></dictionary></a><button type=\"button\" class=\"icon-x\" ng-click=\"showsignin = false\"></button></div></div></div></main><a href=\"\" id=\"invisibleDownloadButton_extZoom\" style=\"display: none;\"></a></div><hybrid-install postype=\"bottom-banner\" tmplname=\"nativeInstall.html\" ng-class=\"{\'visible\' : showextendedbanner}\"></hybrid-install>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/zoom/gameZoom_orange.html","<div><div id=\"fixed-button-top\" data-mipqa=\"btn-container-scrolling\" ng-if=\"(\'ENABLE_MOVING_PLAY\' | config) && !incompatible\"><figure><img lazy-img=\"{{iconImage | imageSize:180:0}}\" ng-src=\"{{iconImage | imageSize:4:0}}\" alt=\"{{game.title}}\" class=\"img-responsive b-lazy\"></figure><figcaption><h2><strong>{{game.title}}</strong></h2><button ng-hide=\"startDld || fromSitemap || incompatible\" id=\"contentBtnTop\" type=\"button\" ng-click=\"getGame($event, document.querySelector(\'#contentBtnTop\'))\" class=\"btn play\" ng-class=\"{\'playContest\' : showLDBCompetition}\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\'  | dictionary}}\" data-mipqa=\"btn-get-game\" data-format=\"{{game.format}}\"><span dir=\"{{setDir(ctaBtnLabel)}}\">{{ctaBtnLabel}}</span></button></figcaption></div><main><div itemscope itemtype=\"http://schema.org/VideoGame\" ng-class=\"{\'guestZoom\' : game.access_type.guest,\'freeZoom\' : game.access_type.free,\'premiumZoom\' : game.access_type.premium}\"><div data-format=\"{{game.format}}\" class=\"zoom-content relative\" ng-class=\"{\'noapk\':incompatible}\"><div class=\"game-info cover outer\"><div class=\"{{coverRatio}} inner\"><div class=\"zoom-contest-badge\" dir=\"{{setDir((\'WEBAPP_COMPETITION_GAMEBADGE_ZOOM\' | dictionary))}}\" ng-if=\"showLDBCompetition && !isContestOver && !notStarted\"><dictionary key=\"\'WEBAPP_COMPETITION_GAMEBADGE_ZOOM\'\"></dictionary></div><img lazy-img=\"{{coverImage[0]}}\" ng-src=\"{{coverLoader}}\" alt=\"{{game.title}}\" class=\"img-responsive b-lazy\" data-mipqa=\"img-zoom\"><contest-players game=\"contestGame\" ng-if=\"isContestGame && results\" starttime=\"start\" endtime=\"end\" ng-show=\"ready && !isContestOver\"></contest-players></div></div><div class=\"feedbackContainer\" ng-if=\"game.format === \'androidapplications\'\"><p class=\"text-center apk-err\" ng-show=\"dldError\"><dictionary key=\"\'WEBAPP_DOWNLOAD_ERROR_TEXT\'\"></dictionary></p><p class=\"text-center apk-err\" ng-if=\"incompatible || fromSitemap\" data-mipqa=\"game-incompatible\"><span class=\"dict-break err-big\"><dictionary key=\"\'WEBAPP_DOWNLOAD_FAILED_ZOOM_TITLE\'\"></dictionary></span><dictionary key=\"\'WEBAPP_DOWNLOAD_FAILED_ZOOM\'\"></dictionary></p><div class=\"text-center browser-info\" ng-if=\"(\'SHOW_DLD_TIP\' | config)\" ng-show=\"showDldTip\"><p><dictionary key=\"\'WEBAPP_AUTODOWNLOAD_TIP\'\"></dictionary></p><div ng-if=\"(\'SHOW_DLD_FEEDBACK\' | config)\" class=\"animation inject-me\" data-src=\"{{dldAnimation}}\"></div></div></div><div ng-class=\"{\'incompatiblePlay\': incompatible, \'composite-btn\' : (\'GAME_FORMAT_ICONS\' | config)}\" id=\"fixed-button\"><figure><img lazy-img=\"{{iconImage | imageSize:180:0}}\" ng-src=\"{{iconImage | imageSize:4:0}}\" alt=\"{{game.title}}\" class=\"img-responsive b-lazy\"></figure><figcaption><h2 data-mipqa=\"zoom-title\"><strong>{{game.title}}</strong><span>{{game.publisher.title_publisher}}</span></h2><button ng-hide=\"startDld || fromSitemap\" ng-if=\"!incompatible\" id=\"contentBtn\" type=\"button\" ng-click=\"getGame($event)\" class=\"btn play\" ng-class=\"{\'playContest\' : showLDBCompetition}\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\'  | dictionary}}\" data-mipqa=\"btn-get-game\" data-format=\"{{game.format}}\"><span dir=\"{{setDir(ctaBtnLabel)}}\">{{ctaBtnLabel}}</span><img class=\"format-game img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config)\" ng-src=\"{{formatIcon}}\"></button></figcaption></div><p class=\"my-score_zoom\" ng-if=\"myScore && ready\"><dictionary key=\"\'WEBAPP_YOUR_SCORE\'\"></dictionary><span class=\"score\">{{myScore}}</span></p><leaderboard-zoom game=\"contestGame\" dates=\"contestDates\" limit=\"10\" ng-if=\"showLDBCompetition && !isContestOver && !notStarted\" ng-show=\"ready\"></leaderboard-zoom><div class=\"game-info screenshots\" data-mipqa=\"zoom-screenshots\"><div class=\"glide screenshotSlider\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li ng-repeat=\"img in gameImages track by $index\" class=\"slider\" data-itemindex=\"{{$index}}\"><img data-mipqa=\"img-screenshot-thumbnail\" lazy-img=\"{{img}}\" ng-src=\"{{\'loader\' | config}}\" class=\"b-lazy img-responsive {{lazyClass}} screenshot-{{$index}}\" ng-click=\"showScreenshots(gameImages, $index)\"></li></ul></div></div></div><div id=\"shot\" ng-show=\"showShot\"><img ng-src=\"{{selected}}\" class=\"img-responsive\" ng-click=\"showScreenshots(gameImages, currentIndex+1)\"><span class=\"icon-x\" ng-click=\"showShot = !showShot\"></span><button type=\"button\" class=\"prev shotCtrl\" ng-click=\"showScreenshots(gameImages, currentIndex-1)\"><span class=\"icon-arrow\"></span></button><button type=\"button\" class=\"next shotCtrl\" ng-click=\"showScreenshots(gameImages, currentIndex+1)\"><span class=\"icon-arrow\"></span></button></div><subs-banner ng-if=\"!(\'SHOW_ADDITIONAL_BANNER_GUEST_ONLY\' | config)\"></subs-banner><div class=\"game-info description\" ng-class=\"{\'more-hidden\': moreHidden, \'agcom\': (\'URL_IMG_PEGI\' | config)}\"><h3 dir=\"{{setDir((\'WEBAPP_ZOOM_DESCRIPTION_TITLE\' | dictionary))}}\"><dictionary key=\"\'WEBAPP_ZOOM_DESCRIPTION_TITLE\'\"></dictionary></h3><div ng-if=\"(\'URL_IMG_PEGI\' | config)\" class=\"agcom-container\"><img data-mipqa=\"img-pegi\" class=\"img-responsive\" ng-src=\"{{ \'URL_IMG_PEGI\' | config }}\" alt=\"Agcom icons\"></div><p data-mipqa=\"package-size\" class=\"size\" ng-if=\"game.format == \'androidapplications\'\"><span class=\"icon-peso\"></span>{{game.size}}</p><p ng-bind-html=\"gameDesc\" class=\"descriptionContent\" dir=\"{{setDir(gameDesc)}}\" data-mipqa=\"{{descMipQA}}\"></p><a ng-click=\"toggleDescription()\" class=\"text-right\" data-mipqa=\"btn-readmore\"><dictionary ng-show=\"moreHidden\" key=\"\'WEBAPP_SHOW_MORE\'\"></dictionary><dictionary key=\"\'WEBAPP_SHOW_LESS\'\" ng-show=\"!moreHidden\"></dictionary></a></div><div data-mipqa=\"zoom-related\" class=\"game-info recommendations\" ng-show=\"relitems.length\"><h2><dictionary key=\"\'WEBAPP_RELATED_TITLE\'\"></dictionary></h2><items size=\"10\" slider=\"slider\" sliderconf=\"USERITEMS_SLIDER_CONF_ZOOM\" imgratio=\"{{imgRatioRelated}}\" tmplname=\"imgsliderSmall.html\" related=\"game.id\" section=\"related\" class=\"small slider slider-related\" dataindex=\"related\" shufflegames=\"$root.shuffle\" callbackitems=\"nextList\" useoutertitle=\"true\" formaticons=\"true\" list=\"related\"></items></div><div data-mipqa=\"zoom-other-games\" class=\"game-info other-games\" ng-show=\"categoryZoomList.length\"><h2>{{gameCatData.name_category}}</h2><items size=\"5\" tmplname=\"boxedList.html\" readyitems=\"categoryZoomList\" shufflegames=\"$root.shuffleLists\" abstract=\"true\" imgratio=\"ratio_1\" formaticons=\"true\" list=\"gameCatData\"></items></div></div></div></main><simple-native-install></simple-native-install></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/pages/zoom/gameZoom_zain.html","<div><main><div itemscope itemtype=\"http://schema.org/VideoGame\" ng-class=\"{\'guestZoom\' : game.access_type.guest,\'freeZoom\' : game.access_type.free,\'premiumZoom\' : game.access_type.premium}\"><div data-format=\"{{game.format}}\" class=\"zoom-content relative\" ng-class=\"{\'noapk\':incompatible}\"><div class=\"game-info cover\"><div class=\"{{coverRatio}}\"><span class=\"zoom-contest-badge\" dir=\"{{setDir((\'WEBAPP_COMPETITION_GAMEBADGE_ZOOM\' | dictionary))}}\" ng-if=\"showLDBCompetition && !isContestOver && !notStarted\" ng-show=\"ready\"><dictionary key=\"\'WEBAPP_COMPETITION_GAMEBADGE_ZOOM\'\"></dictionary></span><img lazy-img=\"{{coverImage[0]}}\" ng-src=\"{{coverLoader}}\" alt=\"{{game.title}}\" class=\"img-responsive b-lazy\" data-mipqa=\"img-zoom\" ng-click=\"getGame($event)\"><p class=\"tune-in\" ng-if=\"game.tune_in_msg && (\'SHOW_TUNEINMSG\' | config)\">{{game.tune_in_msg}}</p><h3 data-mipqa=\"zoom-title\" ng-show=\"game.title\" dir=\"{{setDir(game.title)}}\" ng-class=\"{{textClass}}\"><span class=\"item-name\" dir=\"{{setDir(game.title)}}\">{{game.title}}</span><span class=\"item-category\" dir=\"{{setDir(game.category.name_category)}}\">{{game.category.name_category}}</span><button id=\"getContentBtn\" ng-if=\"(\'ZOOM_CTA_ON_COVER\' | config) && !incompatible\" ng-hide=\"startDld || fromSitemap\" type=\"button\" ng-click=\"getGame($event)\" class=\"btn play {{game.format}}\" ng-class=\"{\'playContest\' : showLDBCompetition}\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\'  | dictionary}}\" data-mipqa=\"btn-get-game\" data-format=\"{{game.format}}\" dir=\"{{setDir(ctaBtnLabel)}}\"><span>{{ctaBtnLabel}}</span></button></h3></div></div><div class=\"feedbackContainer\" ng-if=\"game.format === \'androidapplications\'\"><p class=\"text-center apk-err\" ng-show=\"dldError\"><dictionary key=\"\'WEBAPP_DOWNLOAD_ERROR_TEXT\'\"></dictionary></p><p class=\"text-center apk-err\" ng-if=\"incompatible || fromSitemap\" data-mipqa=\"game-incompatible\"><span class=\"dict-break err-big\"><dictionary key=\"\'WEBAPP_DOWNLOAD_FAILED_ZOOM_TITLE\'\"></dictionary></span><dictionary key=\"\'WEBAPP_DOWNLOAD_FAILED_ZOOM\'\"></dictionary></p><div class=\"text-center browser-info\" ng-if=\"(\'SHOW_DLD_TIP\' | config)\" ng-show=\"showDldTip\"><p><dictionary key=\"\'WEBAPP_AUTODOWNLOAD_TIP\'\"></dictionary></p><div ng-if=\"(\'SHOW_DLD_FEEDBACK\' | config)\" class=\"animation\"><svg xmlns:svg=\"http://www.w3.org/2000/svg\" xmlns=\"http://www.w3.org/2000/svg\" id=\"dldAnimation\" viewBox=\"0 0 320 200\" version=\"1.1\" xml:space=\"preserve\"><path class=\"pacball\" d=\"m 12.621451,111.11672 c 0,-8.2844 6.7156,-15.000002 15,-15.000002 8.2844,0 15,6.715602 15,15.000002 0,8.2844 -6.7156,15 -15,15 -8.2844,0 -15,-6.7156 -15,-15 z\"/><path d=\"M 224.05078 106.57812 A 43.962807 44.554096 0 0 0 268.01367 151.13281 A 43.962807 44.554096 0 0 0 311.97656 106.57812 L 224.05078 106.57812 z\" class=\"pac lower\"/><path d=\"M 311.97858,106.58385 A 43.962807,44.554096 0 0 0 268.01569,62.02972 43.962807,44.554096 0 0 0 224.0528,106.58385 Z\" class=\"pac upper\"/></svg></div></div></div><div ng-if=\"!(\'ZOOM_CTA_ON_COVER\' | config) && !incompatible\" class=\"sticky-button text-center {{game.format}}\" ng-class=\"{\'fixed\':deviceType == \'phone\' && !privacyCondition, \'incompatiblePlay\': incompatible, \'composite-btn\' : (\'GAME_FORMAT_ICONS\' | config)}\" id=\"sticky-button\"><favorite-button itemid=\"game.id\" unloggedurl=\"game.url_play\"></favorite-button><button ng-hide=\"startDld || fromSitemap\" id=\"getContentBtn\" type=\"button\" ng-click=\"getGame($event)\" class=\"btn play\" ng-class=\"{\'playContest\' : showLDBCompetition}\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\'  | dictionary}}\" data-mipqa=\"btn-get-game\" data-format=\"{{game.format}}\"><span dir=\"{{setDir(ctaBtnLabel)}}\">{{ctaBtnLabel}}</span><img class=\"format-game img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config)\" ng-src=\"{{\'transparent-background\' | config}}\"></button></div><p class=\"my-score_zoom\" ng-if=\"myScore && ready\"><span class=\"zoom-contest-title\"><dictionary key=\"\'WEBAPP_COMPETITION_CONTEST_TITLE\'\"></dictionary></span><span><dictionary key=\"\'WEBAPP_YOUR_SCORE\'\"></dictionary><span class=\"score\">{{myScore}}</span></span></p><contest-time page=\"zoom-page\" dates=\"contestDates\"></contest-time><leaderboard-zoom game=\"contestGame\" dates=\"contestDates\" limit=\"10\" ng-if=\"showLDBCompetition && !isContestOver && !notStarted\" ng-show=\"ready\"></leaderboard-zoom><hr><leaderboard items=\"gameLdb\" ng-if=\"showLDB\"></leaderboard><hr ng-if=\"showLDB\"><div class=\"game-info screenshots\" data-mipqa=\"zoom-screenshots\"><h3><dictionary key=\"\'WEBAPP_ZOOM_SCREENSHOTS_TITLE\'\"></dictionary></h3><div class=\"imgsCont {{orientation}}\" ng-if=\"!(\'USE_SCREENSHOT_SLIDER\' | config)\"><img data-mipqa=\"img-screenshot-thumbnail\" lazy-img=\"{{img}}\" ng-src=\"{{\'loader\' | config}}\" class=\"b-lazy img-responsive {{lazyClass}} screenshot-{{$index}}\" ng-click=\"showScreenshots(gameImages, $index)\" ng-repeat=\"img in gameImages\"></div><div class=\"glide screenshotSlider\" ng-if=\"(\'USE_SCREENSHOT_SLIDER\' | config)\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li ng-repeat=\"img in gameImages track by $index\" class=\"slider\" data-itemindex=\"{{$index}}\"><img data-mipqa=\"img-screenshot-thumbnail\" ng-src=\"{{img}}\" class=\"img-responsive {{lazyClass}} screenshot-{{$index}}\"></li></ul></div></div></div><div id=\"shot\" ng-show=\"showShot\"><img ng-src=\"{{selected}}\" class=\"img-responsive\" ng-click=\"showScreenshots(gameImages, currentIndex+1)\"><span data-mipqa=\"btn-close-screenshots\" class=\"icon-x\" ng-click=\"showShot = !showShot\"></span><button type=\"button\" class=\"prev shotCtrl\" ng-click=\"showScreenshots(gameImages, currentIndex-1)\"><span class=\"icon-arrow\"></span></button><button type=\"button\" class=\"next shotCtrl\" ng-click=\"showScreenshots(gameImages, currentIndex+1)\"><span class=\"icon-arrow\"></span></button></div><hr><div class=\"description\" ng-class=\"{\'more-hidden\': moreHidden, \'agcom\': (\'URL_IMG_PEGI\' | config)}\"><h3 dir=\"{{setDir(game.title)}}\" ng-bind-html=\"game.title\"></h3><div ng-if=\"(\'URL_IMG_PEGI\' | config)\" class=\"agcom-container\"><img data-mipqa=\"img-pegi\" class=\"img-responsive\" ng-src=\"{{ \'URL_IMG_PEGI\' | config }}\" alt=\"Agcom icon\"></div><p class=\"tune-in-desc\" dir=\"{{setDir(game.tune_in_msg)}}\" ng-if=\"game.tune_in_msg && (\'SHOW_TUNEINMSG\' | config)\">{{game.tune_in_msg}}</p><p data-mipqa=\"package-size\" class=\"size\" ng-if=\"game.format == \'androidapplications\'\"><span class=\"icon-peso\"></span>{{game.size}}</p><p ng-bind-html=\"gameDesc\" data-mipqa=\"{{descMipQA}}\" class=\"descriptionContent\" dir=\"{{setDir(gameDesc)}}\"></p><a ng-click=\"toggleDescription()\" class=\"text-right\" data-mipqa=\"btn-readmore\"><dictionary ng-show=\"moreHidden\" key=\"\'WEBAPP_SHOW_MORE\'\"></dictionary><dictionary key=\"\'WEBAPP_SHOW_LESS\'\" ng-show=\"!moreHidden\"></dictionary></a></div><hr><div data-mipqa=\"zoom-related\" class=\"recommendations\" ng-show=\"relitems.length\"><h3><dictionary key=\"\'WEBAPP_RELATED_TITLE\'\"></dictionary></h3><items related=\"game.id\" size=\"2\" imgratio=\"ratio_2\" tmplname=\"boxedList_cloud.html\" shufflegames=\"$root.shuffleLists\" callbackitems=\"nextList\" formaticons=\"true\" list=\"related\"></items></div><hr><div data-mipqa=\"zoom-other-games\" class=\"other-games slider-content\" ng-show=\"categoryZoomList.length\"><h3><dictionary key=\"\'WEBAPP_ZOOM_OTHER_GAMES_TITLE\'\"></dictionary></h3><items size=\"8\" useoutertitle=\"true\" slider=\"slider\" imgratio=\"ratio_1_5\" sliderconf=\"USERITEMS_SLIDER_CONF\" tmplname=\"imgsliderComplete.html\" category=\"list\" section=\"label{{$parent.$index | round }}\" class=\"small slider slider-{{$index}}\" dataindex=\"{{$index}}\" slidertitle=\"{{list.name | titleCase}}\" shufflegames=\"$root.shuffleHome\" readyitems=\"categoryZoomList\" formaticons=\"true\"></items></div><hr ng-show=\"categoryZoomList.length\"><div class=\"lucky\" ng-if=\"(\'SHOW_RANDOM_GAME_BTN\' | config)\"><h3><dictionary key=\"\'WEBAPP_RANDOM_GAME_TITLE\'\"></dictionary></h3><div class=\"luckyCont\"><h4><dictionary key=\"\'WEBAPP_RANDOM_GAME_DESC\'\"></dictionary></h4><button data-mipqa=\"btn-random-game\" class=\"btn lucky\" type=\"button\" ng-click=\"randomItem()\" dir=\"{{setDir((\'WEBAPP_RANDOM_GAME_BUTTON\' | dictionary))}}\"><dictionary key=\"\'WEBAPP_RANDOM_GAME_BUTTON\'\"></dictionary></button></div></div><div class=\"guestfavs text-center\" ng-show=\"showsignin\"><p><dictionary key=\"\'WEBAPP_UNLOGGED_FAVORITES_TIP\'\"></dictionary></p><a ng-href=\"{{game.url_play}}?show_paywall=1\" class=\"btn\"><dictionary key=\"\'WEBAPP_UNLOGGED_FAVORITES_SIGNIN\'\"></dictionary></a><button type=\"button\" class=\"icon-x\" ng-click=\"showsignin = false\"></button></div></div></div></main><a href=\"\" id=\"invisibleDownloadButton_extZoom\" style=\"display: none;\"></a></div><hybrid-install postype=\"bottom-banner\" tmplname=\"nativeInstall.html\" ng-class=\"{\'visible\' : showextendedbanner}\"></hybrid-install>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/news/newsList.html","<div class=\"list-news\" infinite-scroll=\"loadMore()\" infinite-scroll-distance=\"0\" infinite-scroll-disabled=\"disableScroll\" infinite-scroll-use-document-bottom=\"$root.scrollPrefs.doc\" infinite-scroll-immediate-check=\"$root.scrollPrefs.check\" ng-class=\"{\'extended\' : extended}\"><div ng-repeat=\"item in items track by $index\" class=\"list-item\" data-mipqa=\"list-item-news\"><a ng-click=\"goToZoom(item)\" data-format=\"news\" title=\"{{item.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\' | dictionary}}\" data-mipqa=\"clickitem-news\"><figure><img class=\"b-lazy img-responsive\" lazy-img=\"{{item.images.cover[imgRatio] | imageSize:imgWSize:imgHSize}}\"></figure><figcaption><h3 dir=\"{{setDir(item.title)}}\" class=\"list-title\">{{item.title}}</h3><h4 dir=\"{{setDir(item.abstract)}}\" ng-if=\"extended\" class=\"list-abstract\" ng-bind-html=\"item.abstract\"></h4></figcaption></a></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/news/newsSlider.html","<div class=\"glide newsContainer\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li class=\"glide__slide\" ng-repeat=\"item in items track by $index\" data-itemindex=\"{{$index}}\" data-mipqa=\"list-item-news\" ng-click=\"itemPlay(item,true, false, \'custom\')\" title=\"{{item.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\"><a ng-click=\"goToZoom(item)\" data-format=\"news\" title=\"{{item.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\' | dictionary}}\" data-mipqa=\"clickitem-news\" ng-if=\"!item.showMore\"><figure><img class=\"b-lazy img-responsive\" style=\"background-image: url({{item.images.cover[imgTrueRatio] | imageSize:imgWSize:imgHSize}})\" ng-src=\"{{ imgRatio | config }}\"><figcaption><h3 dir=\"{{setDir(item.title)}}\" class=\"list-title\">{{item.title}}</h3><h4 dir=\"{{setDir(item.abstract)}}\" class=\"list-abstract\" ng-bind-html=\"item.abstract\"></h4></figcaption></figure></a><button type=\"button\" ng-if=\"item.showMore\" class=\"showMore-item\" data-mipqa=\"btn-go-to-list\" ng-click=\"goTo(\'news\')\"><img title=\"{{\'WEBAPP_LOAD_OTHER_CONTENTS\' | dictionary}}\" ng-src=\"{{ imgRatio | config }}\" class=\"img-responsive\"><dictionary key=\"\'WEBAPP_LOAD_OTHER_CONTENTS\'\"></dictionary></button></li></ul></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/boxedList.html","<div class=\"listGame boxed {{imgRatio}}\" infinite-scroll=\"loadMore()\" infinite-scroll-distance=\"0\" infinite-scroll-disabled=\"disableScroll\" infinite-scroll-use-document-bottom=\"$root.scrollPrefs.doc\" infinite-scroll-immediate-check=\"$root.scrollPrefs.check\"><div itemtype=\"http://schema.org/VideoGame\" class=\"list-item {{showBadge[getSingleGameAccess(game.access_type)].class}}\" callbackitems=\"callbackitems\" ng-repeat=\"game in items track by $index\" ng-if=\"(game && game != \'adv\')\" data-gameid=\"{{game.id}}\" data-mipqa=\"list-item\" data-format=\"{{game.format}}\"><figure ng-if=\"game != \'adv\' && game != \'hybridinstall\'\"><a ng-if=\"!game.utility\" data-mipqa=\"clickitem\" ng-click=\"itemPlay(game,true, $index+1, \'general\')\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" class=\"badge {{game.format}}\" data-gametype=\"{{showBadge[getSingleGameAccess(game.access_type)].dictKey | dictionary}}\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\"><img alt=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" lazy-img=\"{{game.images.cover[imgRatio] | imageSize:imgWSize:imgHSize}}\" class=\"b-lazy img-responsive {{lazyClass}}\" ng-src=\"{{game.images.cover[imgRatio] | imageSize:4:0}}\"> <img class=\"format-game-icon img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config) && ($root.selector === \'android\')\" ng-src=\"{{setGameFormatBtn(game.format,apkicon,html5icon)}}\"></a><a ng-if=\"game.utility && (\'SHOW_OFFERS_EXPLORE\'|config) && ($root.selector !== \'pc\')\" data-mipqa=\"clickitem\" ng-click=\"goTo(\'application\',{appUrl: game.url_zoom_simple}, game, false, \'offer_click\')\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" class=\"badge {{game.format}}\" data-gametype=\"{{showBadge[getSingleGameAccess(game.access_type)].dictKey | dictionary}}\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\"><img alt=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" lazy-img=\"{{game.images.cover[imgRatio] | imageSize:imgWSize:imgHSize}}\" class=\"b-lazy img-responsive {{lazyClass}}\" ng-src=\"{{game.images.cover[imgRatio] | imageSize:4:0}}\"> <img class=\"format-game-icon img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config) && ($root.selector === \'android\')\" ng-src=\"{{setGameFormatBtn(game.format,apkicon,html5icon)}}\"></a><figcaption ng-if=\"!(\'SHOW_ALL_DETAILS_IN_LIST\' | config)\"><h3 class=\"name\" dir=\"{{setDir(game.title)}}\"><a data-mipqa=\"clickitem\" ng-click=\"itemPlay(game,true, $index+1, \'general\')\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" dir=\"{{setDir(game.title)}}\">{{game.title}}</a></h3><h4 class=\"abstract\" ng-if=\"abstract\" dir=\"{{setDir(game.description_short)}}\"><span dir=\"{{setDir(game.description_short)}}\" ng-bind-html=\"game.description_short\"></span></h4></figcaption><figcaption ng-if=\"game.utility && (\'SHOW_OFFERS_EXPLORE\'|config) && ($root.selector !== \'pc\') &&(\'SHOW_ALL_DETAILS_IN_LIST\' | config)\" data-mipqa=\"REM_clickitem\" ng-click=\"goTo(\'application\',{appUrl: game.url_zoom_simple}, game, false, \'offer_click\')\"><p class=\"item-publisher\" dir=\"{{setDir(ggame.publisher.title_publisher)}}\"><span>{{game.publisher.title_publisher}}</span></p><p class=\"item-title\" dir=\"{{setDir(game.title)}}\"><span>{{game.title}}</span></p><p class=\"item-abstract\" dir=\"{{setDir(game.description_short)}}\"><span>{{game.description_short}}</span></p></figcaption><figcaption ng-if=\"!game.utility && (\'SHOW_ALL_DETAILS_IN_LIST\' | config)\" data-mipqa=\"clickitem\" ng-click=\"itemPlay(game,true, $index+1, \'general\')\"><p class=\"item-publisher\" dir=\"{{setDir(ggame.publisher.title_publisher)}}\"><span>{{game.publisher.title_publisher}}</span></p><p class=\"item-title\" dir=\"{{setDir(game.title)}}\"><span>{{game.title}}</span></p><p class=\"item-abstract\" dir=\"{{setDir(game.description_short)}}\"><span>{{game.description_short}}</span></p></figcaption><button ng-if=\"!(\'NO_CTA_ON_LISTGAMES\' | config) && !game.utility\" type=\"button\" data-mipqa=\"{{(\'LIST_CTA_GOTOZOOM\' | config) ? \'clickitem\' : \'clickitem-gameplay\'}}\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" class=\"btn play {{game.format}}\" ng-click=\"itemPlay(game,(\'LIST_CTA_GOTOZOOM\' | config), $index+1, \'general\', true)\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" dir=\"{{setDir(setBtnLabel(game.format))}}\">{{setBtnLabel(game.format)}}</button><button type=\"button\" ng-if=\"game.utility && (\'SHOW_OFFERS_EXPLORE\'|config) && ($root.selector !== \'pc\')\" data-mipqa=\"REM_clickitem-gameplay\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" class=\"btn play utility {{game.format}}\" ng-click=\"getApp(game)\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" dir=\"{{setDir(setBtnLabel(game.format, \'WEBAPP_LIST_CALLTOACTION\'))}}\">{{game.format === \'androidapplications\' ? setBtnLabel(game.format, \'WEBAPP_LIST_CALLTOACTION\') : setBtnLabel(game.format, \'WEBAPP_LIST_CALLTOACTION_IOS\')}}</button></figure></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/boxedListOffers.html","<div class=\"listGame boxed offers {{imgRatio}}\" infinite-scroll=\"loadMore()\" infinite-scroll-distance=\"0\" infinite-scroll-disabled=\"disableScroll\" infinite-scroll-use-document-bottom=\"$root.scrollPrefs.doc\" infinite-scroll-immediate-check=\"$root.scrollPrefs.check\"><div itemtype=\"http://schema.org/VideoGame\" class=\"list-item {{showBadge[getSingleGameAccess(game.access_type)].class}}\" callbackitems=\"callbackitems\" ng-repeat=\"game in items track by $index\" ng-if=\"(game && game != \'adv\')\" data-gameid=\"{{game.id}}\" data-mipqa=\"REM_list-item\" data-format=\"{{game.format}}\"><figure ng-if=\"game != \'adv\' && game != \'hybridinstall\'\"><a data-mipqa=\"clickitem\" ng-click=\"goTo(\'application\',{ appUrl: game.url_zoom_simple}, game, list, \'offer_click\')\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" class=\"badge {{game.format}}\" data-gametype=\"{{showBadge[getSingleGameAccess(game.access_type)].dictKey | dictionary}}\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\"><img alt=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" lazy-img=\"{{(game.images.icon | imageSize:imgWSize:imgHSize) || (game.images.cover[imgRatio] | imageSize:imgWSize:imgHSize)}}\" class=\"b-lazy img-responsive {{lazyClass}}\" ng-src=\"{{game.images.cover[imgRatio] | imageSize:4:0}}\"> <img class=\"format-game-icon img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config) && ($root.selector !== \'pc\')\" ng-src=\"{{setGameFormatBtn(game.format,apkicon,html5icon)}}\"></a><figcaption ng-click=\"goTo(\'application\',{ appUrl: game.url_zoom_simple}, game, list, \'offer_click\')\"><p class=\"item-title\" dir=\"{{setDir(game.title)}}\"><span>{{game.title}}</span></p></figcaption><button data-mipqa=\"REM_clickitem-gameplay\" type=\"button\" class=\"btn play {{game.format}} offer\" ng-click=\"getApp(game)\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" dir=\"{{setDir(setBtnLabel(game.format, \'WEBAPP_LIST_CALLTOACTION\'))}}\">{{game.format === \'androidapplications\' ? setBtnLabel(game.format, \'WEBAPP_LIST_CALLTOACTION\') : setBtnLabel(game.format, \'WEBAPP_LIST_CALLTOACTION_IOS\')}}</button></figure></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/boxedList_catDetails.html","<div class=\"listGame boxed cloud {{imgRatio}}\" infinite-scroll=\"loadMore()\" infinite-scroll-distance=\"0\" infinite-scroll-disabled=\"disableScroll\" infinite-scroll-use-document-bottom=\"$root.scrollPrefs.doc\" infinite-scroll-immediate-check=\"$root.scrollPrefs.check\"><div itemtype=\"http://schema.org/VideoGame\" class=\"list-item\" callbackitems=\"callbackitems\" ng-repeat=\"game in items track by $index\" data-gameid=\"{{game.id}}\" data-mipqa=\"list-item\" data-format=\"{{game.format}}\"><figure><a data-mipqa=\"clickitem\" ng-click=\"itemPlay(game,true, $index+1, \'general\')\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" class=\"badge {{game.format}}\" data-gametype=\"{{showBadge[getSingleGameAccess(game.access_type)].dictKey | dictionary}}\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\"><img imagelazyloaded alt=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" loading=\"lazy\" ng-src=\"{{(game.images.icon | imageSize:imgWSize:imgHSize) || (game.images.cover[imgRatio] | imageSize:imgWSize:imgHSize)}}\" class=\"b-lazy img-responsive {{lazyClass}}\"></a><div class=\"details\"><figcaption data-mipqa=\"clickitem\" ng-click=\"itemPlay(game,true, $index+1, \'general\')\"><p class=\"item-category\" dir=\"{{setDir(game.category.name_category)}}\"><span>{{game.category.name_category}}</span></p><p class=\"item-title\" dir=\"{{setDir(game.title)}}\"><span>{{game.title}}</span></p></figcaption><button type=\"button\" data-mipqa=\"{{(\'LIST_CTA_GOTOZOOM\' | config) ? \'clickitem\' : \'clickitem-gameplay\'}}\" class=\"btn play {{game.format}}\" ng-click=\"itemPlay(game,(\'LIST_CTA_GOTOZOOM\' | config), $index+1, \'general\', true)\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" dir=\"{{setDir(setBtnLabel(game.format))}}\">{{setBtnLabel(game.format)}}</button></div></figure></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/boxedList_cloud.html","<div class=\"listGame boxed cloud {{imgRatio}}\" infinite-scroll=\"loadMore()\" infinite-scroll-distance=\"0\" infinite-scroll-disabled=\"disableScroll\" infinite-scroll-use-document-bottom=\"$root.scrollPrefs.doc\" infinite-scroll-immediate-check=\"$root.scrollPrefs.check\"><div itemtype=\"http://schema.org/VideoGame\" class=\"list-item\" callbackitems=\"callbackitems\" ng-repeat=\"game in items track by $index\" data-gameid=\"{{game.id}}\" data-mipqa=\"list-item\" data-format=\"{{game.format}}\"><figure><a data-mipqa=\"clickitem\" ng-click=\"itemPlay(game,true, $index+1, \'general\')\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" class=\"badge {{game.format}}\" data-gametype=\"{{showBadge[getSingleGameAccess(game.access_type)].dictKey | dictionary}}\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\"><img imagelazyloaded ng-if=\"!(\'AVOID_ICON_IN_BOXEDLIST\' | config)\" alt=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" loading=\"lazy\" ng-src=\"{{(game.images.icon | imageSize:imgWSize:imgHSize) || (game.images.cover[imgRatio] | imageSize:imgWSize:imgHSize)}}\" class=\"b-lazy img-responsive {{lazyClass}}\"> <img imagelazyloaded ng-if=\"(\'AVOID_ICON_IN_BOXEDLIST\' | config)\" alt=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" loading=\"lazy\" ng-src=\"{{(game.images.cover[imgRatio] | imageSize:imgWSize:imgHSize)}}\" class=\"b-lazy img-responsive {{lazyClass}}\"></a><div class=\"details\"><figcaption data-mipqa=\"clickitem\" ng-click=\"itemPlay(game,true, $index+1, \'general\')\"><p class=\"item-title\" dir=\"{{setDir(game.title)}}\"><span>{{game.title}}</span></p><p class=\"item-publisher\" dir=\"{{setDir(game.publisher.title_publisher)}}\"><span>{{game.publisher.title_publisher}}</span></p></figcaption><button type=\"button\" data-mipqa=\"{{(\'LIST_CTA_GOTOZOOM\' | config) ? \'clickitem\' : \'clickitem-gameplay\'}}\" class=\"btn play {{game.format}}\" ng-click=\"itemPlay(game,(\'LIST_CTA_GOTOZOOM\' | config), $index+1, \'general\', true)\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" dir=\"{{setDir(setBtnLabel(game.format))}}\">{{setBtnLabel(game.format)}}</button></div></figure></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/boxedList_mt.html","<div class=\"listGame boxed {{imgRatio}}\" infinite-scroll=\"loadMore()\" infinite-scroll-distance=\"0\" infinite-scroll-disabled=\"disableScroll\" infinite-scroll-use-document-bottom=\"$root.scrollPrefs.doc\" infinite-scroll-immediate-check=\"$root.scrollPrefs.check\"><div itemtype=\"http://schema.org/VideoGame\" class=\"list-item {{showBadge[getSingleGameAccess(game.access_type)].class}}\" callbackitems=\"callbackitems\" ng-repeat=\"game in items track by $index\" ng-if=\"(game && game != \'adv\')\" data-gameid=\"{{game.id}}\" data-mipqa=\"list-item\" data-format=\"{{game.format}}\"><figure ng-if=\"game != \'adv\' && game != \'hybridinstall\'\"><a ng-if=\"!game.utility\" data-mipqa=\"clickitem\" ng-click=\"itemPlay(game,true, $index+1, \'general\')\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" class=\"badge {{game.format}}\" data-gametype=\"{{showBadge[getSingleGameAccess(game.access_type)].dictKey | dictionary}}\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\"><img alt=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" lazy-img=\"{{game.images.cover[imgRatio] | imageSize:imgWSize:imgHSize}}\" class=\"b-lazy img-responsive {{lazyClass}}\" ng-src=\"{{game.images.cover[imgRatio] | imageSize:4:0}}\"> <img class=\"format-game-icon img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config) && ($root.selector === \'android\')\" ng-src=\"{{setGameFormatBtn(game.format,apkicon,html5icon)}}\"></a><a ng-if=\"game.utility && (\'SHOW_OFFERS_EXPLORE\'|config) && ($root.selector !== \'pc\')\" data-mipqa=\"clickitem\" ng-click=\"goTo(\'application\',{appUrl: game.url_zoom_simple}, game, false, \'offer_click\')\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" class=\"badge {{game.format}}\" data-gametype=\"{{showBadge[getSingleGameAccess(game.access_type)].dictKey | dictionary}}\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\"><img alt=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" lazy-img=\"{{game.images.cover[imgRatio] | imageSize:imgWSize:imgHSize}}\" class=\"b-lazy img-responsive {{lazyClass}}\" ng-src=\"{{game.images.cover[imgRatio] | imageSize:4:0}}\"> <img class=\"format-game-icon img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config) && ($root.selector === \'android\')\" ng-src=\"{{setGameFormatBtn(game.format,apkicon,html5icon)}}\"></a><figcaption ng-if=\"!(\'SHOW_ALL_DETAILS_IN_LIST\' | config)\"><h3 class=\"name\" dir=\"{{setDir(game.title)}}\"><a data-mipqa=\"clickitem\" ng-click=\"itemPlay(game,true, $index+1, \'general\')\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" dir=\"{{setDir(game.title)}}\">{{game.title}}</a></h3><h4 class=\"abstract\" ng-if=\"abstract\" dir=\"{{setDir(game.description_short)}}\"><span dir=\"{{setDir(game.description_short)}}\" ng-bind-html=\"game.description_short\"></span></h4></figcaption><figcaption ng-if=\"game.utility && (\'SHOW_OFFERS_EXPLORE\'|config) && ($root.selector !== \'pc\') &&(\'SHOW_ALL_DETAILS_IN_LIST\' | config)\" data-mipqa=\"REM_clickitem\" ng-click=\"goTo(\'application\',{appUrl: game.url_zoom_simple}, game, false, \'offer_click\')\"><p class=\"item-publisher\" dir=\"{{setDir(ggame.publisher.title_publisher)}}\"><span>{{game.publisher.title_publisher}}</span></p><p class=\"item-title\" dir=\"{{setDir(game.title)}}\"><span>{{game.title}}</span></p><p class=\"item-abstract\" dir=\"{{setDir(game.description_short)}}\"><span>{{game.description_short}}</span></p></figcaption><figcaption ng-if=\"!game.utility && (\'SHOW_ALL_DETAILS_IN_LIST\' | config)\" data-mipqa=\"clickitem\" ng-click=\"itemPlay(game,true, $index+1, \'general\')\"><p class=\"item-publisher\" dir=\"{{setDir(ggame.publisher.title_publisher)}}\"><span>{{game.publisher.title_publisher}}</span></p><p class=\"item-title\" dir=\"{{setDir(game.title)}}\"><span>{{game.title}}</span></p><p class=\"item-abstract\" dir=\"{{setDir(game.description_short)}}\"><span>{{game.description_short}}</span></p></figcaption><button ng-if=\"!(\'NO_CTA_ON_LISTGAMES\' | config) && !game.utility\" type=\"button\" data-mipqa=\"{{(\'LIST_CTA_GOTOZOOM\' | config) ? \'clickitem\' : \'clickitem-gameplay\'}}\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" class=\"btn play {{game.format}}\" ng-click=\"itemPlay(game,(\'LIST_CTA_GOTOZOOM\' | config), $index+1, \'general\', true)\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" dir=\"{{setDir(setBtnLabel(game.format))}}\"><span>{{setBtnLabel(game.format)}}</span></button><button type=\"button\" ng-if=\"game.utility && (\'SHOW_OFFERS_EXPLORE\'|config) && ($root.selector !== \'pc\')\" data-mipqa=\"REM_clickitem-gameplay\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" class=\"btn play utility {{game.format}}\" ng-click=\"getApp(game)\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" dir=\"{{setDir(setBtnLabel(game.format, \'WEBAPP_LIST_CALLTOACTION\'))}}\">{{game.format === \'androidapplications\' ? setBtnLabel(game.format, \'WEBAPP_LIST_CALLTOACTION\') : setBtnLabel(game.format, \'WEBAPP_LIST_CALLTOACTION_IOS\')}}</button></figure></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/cardsCarousel.html","<div class=\"glide cardsContainer\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li class=\"glide__slide\" ng-repeat=\"item in items track by $index\" data-itemindex=\"{{$index}}\" data-mipqa=\"{{item.mipqa ? item.mipqa : \'list-item\'}}\" data-gamedest=\"{{gameGoesTo(item, \'custom\')}}\" data-format=\"{{item.format}}\" title=\"{{item.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\"><div itemtype=\"http://schema.org/VideoGame\"><div ng-click=\"itemPlay(item,true, false, \'custom\')\" data-mipqa=\"{{item.mipqa ? item.mipqa : \'clickitem\'}}\"><img ng-cloak alt=\"{{item.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" ng-src=\"{{item.images.cover[imgRatio] | imageSize:imgWSize:imgHSize}}\" class=\"img-responsive\"><h3>{{item.title}}</h3></div><span class=\"btn play\" ng-click=\"itemPlay(item,(\'CAROUSEL_CTA_GOTOZOOM\' | config), false, \'custom\')\" data-mipqa=\"{{item.mipqa ? item.mipqa : (\'CAROUSEL_CTA_GOTOZOOM\' | config) ? \'clickitem\' : \'clickitem-gameplay\'}}\">{{setBtnLabel(item.format, item.custom_label)}}</span></div></li></ul></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/contestItem.html","<div class=\"listGame boxed single contest-item {{imgratio}}\" ng-show=\"contest.content_info\"><div itemtype=\"http://schema.org/VideoGame\" class=\"list-item\" callbackitems=\"callbackitems\" ng-if=\"contest.content_info\" data-gameid=\"{{game.id}}\" data-format=\"{{game.format}}\"><figure data-mipqa=\"{{showBadge[getSingleGameAccess(game.access_type)].class}}\"><a data-mipqa=\"clickitem\" ng-click=\"itemZoom(game)\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" class=\"badge {{game.format}}\" ng-class=\"{\'hideBadge\' : contest.isContestOver}\" data-gametype=\"{{showBadge[getSingleGameAccess(game.access_type)].dictKey | dictionary}}\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" data-contest=\"{{\'WEBAPP_COMPETITION_GAMEBADGE\' | dictionary}}\"><img alt=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" ng-src=\"{{gameImg | imageSize:4:0}}\" class=\"img-responsive\" lazy-img=\"{{gameImg | imageSize:imgWSize:imgHSize}}\"></a><figcaption><div class=\"caption-container\"><h3 class=\"name\" dir=\"{{setDir(game.title)}}\"><a data-mipqa=\"clickitem\" ng-click=\"itemZoom(game)\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" dir=\"{{setDir(game.title)}}\">{{game.title}}</a></h3><contest-players game=\"game\" starttime=\"start\" endtime=\"end\" ng-show=\"contest && contest.leaderboard && contest.leaderboard.top_scorer && contest.leaderboard.top_scorer.length\"></contest-players></div><button ng-if=\"!(\'CONTESTITEM_SAME_AS_HOME\' | config)\" type=\"button\" data-mipqa=\"clickitem-gameplay\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" class=\"btn play {{game.format}}\" ng-click=\"gamePlay($event)\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" dir=\"{{setDir(setBtnLabel(game.format))}}\">{{setBtnLabel(game.format)}}</button></figcaption><button ng-if=\"(\'CONTESTITEM_SAME_AS_HOME\' | config)\" type=\"button\" data-mipqa=\"clickitem-gameplay\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" class=\"btn play {{game.format}}\" ng-click=\"gamePlay($event)\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" dir=\"{{setDir(setBtnLabel(game.format))}}\">{{setBtnLabel(game.format)}}</button></figure></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/imglazyelement.html","<img ng-src=\"{{source.mixedImage.img}}\" ng-click=\"itemPlay(source, true, false, \'custom\')\" class=\"b-lazy img-responsive ratio_{{source.mixedImage.ratio}}\" style=\"aspect-ratio: {{source.mixedImage.calculatedRatio}}\">");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/imgslider.html","<div class=\"glide bigSlider\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li itemtype=\"http://schema.org/VideoGame\" ng-repeat=\"item in items track by $index\" class=\"glide__slide\" data-mipqa=\"list-item\" data-itemindex=\"{{$index}}\" data-format=\"{{item.format}}\"><div data-mipqa=\"clickitem\" ng-click=\"itemPlay(item,true,{{$index+1}},\'slider\');\"><img title=\"{{item.title}} {{\'WEBAPP_CANVAS_BUTTON_PLAY\' | dictionary}}\" ng-src=\"{{item.images.cover[imgRatio] | imageSize:imgWSize:imgHSize}}\" class=\"img-responsive {{showBadge[getSingleGameAccess(item.access_type)].class}}\" data-gametitle=\"{{item.title}}\" data-mipqa=\"gotogame_img\" data-gametype=\"{{showBadge[getSingleGameAccess(item.access_type)].dictKey | dictionary}}\" data-gamedest=\"{{gameGoesTo(item, \'slider\')}}\"><p class=\"tune-in\" ng-if=\"item.tune_in_msg && (\'SHOW_TUNEINMSG\' | config)\">{{item.tune_in_msg}}</p><h3 ng-if=\"gameName || (\'CTA_BIGSLIDER\' | config)\" class=\"btn top-games\" dir=\"{{setDir((\'CTA_BIGSLIDER\' | config) ? setBtnLabel(item.format) : item.title)}}\" data-mipqa=\"gotogame_name\" ng-bind-html=\"(\'CTA_BIGSLIDER\' | config) ? setBtnLabel(item.format) : item.title\"></h3><button ng-if=\"(\'GAME_FORMAT_ICONS\' | config) && ($root.selector === \'android\')\" data-mipqa=\"gotogame_btn\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" class=\"btn play format-icon {{item.format}}\" type=\"button\" title=\"{{item.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\"><span dir=\"{{setDir(setBtnLabel(item.format))}}\">{{setBtnLabel(item.format)}}</span><img class=\"format-game img-responsive\" ng-src=\"{{setGameFormatBtn(item.format,apkicon_long,html5icon_long)}}\"></button></div></li></ul></div><h3 class=\"btn top-games\" ng-if=\"!gameName\"><dictionary key=\"\'WEBAPP_HOME_TOPGAMES\'\"></dictionary></h3><div class=\"glide__bullets dots text-center\" data-glide-el=\"controls[nav]\"><button type=\"button\" class=\"glide__bullet dot\" data-glide-dir=\"={{$index}}\" ng-repeat=\"position in items\"></button></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/imgsliderComplete.html","<div class=\"listGame slider slider-complete slider-container {{imgRatio}}\"><p ng-if=\"description\">{{description}}</p><div class=\"dir-setter\" dir=\"{{setDir(slidertitle)}}\"><h2 ng-click=\"goToList(list)\" data-mipqa=\"btn-go-to-list\" ng-if=\"!useoutertitle\" dir=\"{{setDir(slidertitle)}}\">{{slidertitle}}</h2><h3 ng-if=\"!useoutertitle\" class=\"h3 btn-chevron\"><a ng-click=\"goToList(list)\" data-mipqa=\"btn-go-to-list\" title=\"{{\'WEBAPP_LOAD_OTHER_CONTENTS\' | dictionary}}\" class=\"btn\"><dictionary key=\"\'WEBAPP_LOAD_OTHER_CONTENTS\'\"></dictionary></a></h3></div><div class=\"glide simpleSlider slider\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li data-mipqa=\"list-item\" itemtype=\"http://schema.org/VideoGame\" ng-repeat=\"item in items track by $index\" data-itemindex=\"{{$index}}\" ng-show=\"item.images.cover[imgRatio] || item.showMore\" data-format=\"{{item.format}}\"><a ng-if=\"!item.showMore\" data-mipqa=\"clickitem\" data-gamedest=\"{{gameGoesTo(item, \'slidersmall\')}}\" ng-click=\"itemPlay(item,true,$index+1, \'slidersmall\');\" title=\"{{item.title}} {{\'WEBAPP_CANVAS_BUTTON_PLAY\' | dictionary}}\" data-gametype=\"{{showBadge[getSingleGameAccess(item.access_type)].dictKey | dictionary}}\" data-gameid=\"{{item.id}}\"><img title=\"{{item.title}} {{\'WEBAPP_CANVAS_BUTTON_PLAY\' | dictionary}}\" ng-src=\"{{item.images.cover[imgRatio] | imageSize:4:0}}\" lazy-img=\"{{item.images.cover[imgRatio] | imageSize:imgWSize:imgHSize}}\" class=\"b-lazy img-responsive {{showBadge[getSingleGameAccess(item.access_type)].class}}\"><p class=\"item-publisher\" dir=\"{{setDir(item.publisher.title_publisher)}}\"><span dir=\"{{setDir(item.publisher.title_publisher)}}\">{{item.publisher.title_publisher}}</span></p><p class=\"item-title\" dir=\"{{setDir(item.title)}}\"><span dir=\"{{setDir(item.title)}}\">{{item.title}}</span></p><p class=\"item-abstract\" dir=\"{{setDir(item.description_short)}}\"><span dir=\"{{setDir(item.description_short)}}\">{{item.description_short}}</span></p></a><img class=\"format-game-icon img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config) && ($root.selector === \'android\') && !item.showMore\" ng-src=\"{{setGameFormatBtn(item.format,apkicon,html5icon)}}\"></li></ul></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/imgsliderSmall.html","<div class=\"listGame slider slider-container {{imgRatio}}\"><h2 ng-click=\"goToList(list)\" data-mipqa=\"btn-go-to-list\" ng-if=\"!useoutertitle\" ng-bind-html=\"slidertitle\" dir=\"{{setDir(slidertitle)}}\"></h2><h3 ng-if=\"!useoutertitle\" class=\"h3 btn-chevron\"><a ng-click=\"goToList(list)\" data-mipqa=\"btn-go-to-list\" title=\"{{\'WEBAPP_OTHER_GAMES\' | dictionary}}\" class=\"btn\"><dictionary key=\"\'WEBAPP_LOAD_OTHER_CONTENTS\'\"></dictionary><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span><span class=\"icon-arrow\"></span></a></h3><div class=\"glide simpleSlider\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li data-mipqa=\"list-item\" itemtype=\"http://schema.org/VideoGame\" ng-repeat=\"item in items track by $index\" data-itemindex=\"{{$index}}\" ng-show=\"item.images.cover[imgRatio] || item.showMore\" data-format=\"{{item.format}}\" data-userlist=\"{{item.userlist ? item.userlist : \'\'}}\"><a ng-if=\"!item.showMore\" data-mipqa=\"clickitem\" data-gamedest=\"{{gameGoesTo(item, \'slidersmall\')}}\" ng-click=\"itemPlay(item,true,$index+1, \'slidersmall\');\" title=\"{{item.title}} {{\'WEBAPP_CANVAS_BUTTON_PLAY\' | dictionary}}\" data-gametype=\"{{showBadge[getSingleGameAccess(item.access_type)].dictKey | dictionary}}\" data-gameid=\"{{item.id}}\"><img title=\"{{item.title}} {{\'WEBAPP_CANVAS_BUTTON_PLAY\' | dictionary}}\" ng-src=\"{{item.images.cover[imgRatio] | imageSize:imgWSize:imgHSize}}\" class=\"img-responsive {{showBadge[getSingleGameAccess(item.access_type)].class}}\"><p class=\"item-alt-overlay dirOverride\" ng-if=\"(\'ALTERNATE_LAYOUT\' | config)\"><span>{{item.title}}</span></p><div class=\"gradient-bg-bottom badge\" data-gametype=\"{{showBadge[getSingleGameAccess(item.access_type)].dictKey | dictionary}}\" data-mipqa=\"{{getSingleGameAccess(item.access_type)}}\"></div></a><button type=\"button\" ng-if=\"item.showMore\" class=\"showMore-item\" data-mipqa=\"btn-go-to-list\" ng-click=\"goToList(list)\"><img title=\"{{list.title}} {{\'WEBAPP_LOAD_OTHER_CONTENTS\' | dictionary}}\" ng-src=\"{{ imgRatio | config }}\" class=\"img-responsive\"><dictionary key=\"\'WEBAPP_LOAD_OTHER_CONTENTS\'\"></dictionary></button><img class=\"format-game-icon img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config) && ($root.selector === \'android\') && !item.showMore\" ng-src=\"{{setGameFormatBtn(item.format,apkicon,html5icon)}}\"></li></ul></div><div class=\"glide__bullets dots text-center\" data-glide-el=\"controls[nav]\"><button type=\"button\" class=\"glide__bullet dot\" data-glide-dir=\"={{$index}}\" ng-repeat=\"position in items\"></button></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/imgslider_clickthrough.html","<div class=\"glide bigSlider\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li itemtype=\"http://schema.org/VideoGame\" ng-repeat=\"item in items track by $index\" class=\"glide__slide\" data-mipqa=\"list-item\" data-itemindex=\"{{$index}}\" data-format=\"{{item.format}}\" data-mipqa=\"clickitem\" ng-click=\"itemPlay(item,true,{{$index+1}},\'slider\');\"><div><img title=\"{{item.title}} {{\'WEBAPP_CANVAS_BUTTON_PLAY\' | dictionary}}\" ng-src=\"{{item.images.cover[imgRatio] | imageSize:imgWSize:imgHSize}}\" class=\"img-responsive {{showBadge[getSingleGameAccess(item.access_type)].class}}\" data-gametitle=\"{{item.title}}\" data-mipqa=\"gotogame_img\" data-gametype=\"{{showBadge[getSingleGameAccess(item.access_type)].dictKey | dictionary}}\" data-gamedest=\"{{gameGoesTo(item, \'slider\')}}\"><p class=\"tune-in\" ng-if=\"item.tune_in_msg && (\'SHOW_TUNEINMSG\' | config)\">{{item.tune_in_msg}}</p><h3 ng-if=\"gameName || (\'CTA_BIGSLIDER\' | config)\" class=\"btn top-games\" dir=\"{{setDir((\'CTA_BIGSLIDER\' | config) ? setBtnLabel(item.format) : item.title)}}\" data-mipqa=\"gotogame_name\" ng-bind-html=\"(\'CTA_BIGSLIDER\' | config) ? setBtnLabel(item.format) : item.title\"></h3><button ng-if=\"(\'GAME_FORMAT_ICONS\' | config) && ($root.selector === \'android\')\" data-mipqa=\"gotogame_btn\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" class=\"btn play format-icon {{item.format}}\" type=\"button\" title=\"{{item.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\"><span dir=\"{{setDir(setBtnLabel(item.format))}}\">{{setBtnLabel(item.format)}}</span><img class=\"format-game img-responsive\" ng-src=\"{{setGameFormatBtn(item.format,apkicon_long,html5icon_long)}}\"></button></div></li></ul></div><h3 class=\"btn top-games\" ng-if=\"!gameName\"><dictionary key=\"\'WEBAPP_HOME_TOPGAMES\'\"></dictionary></h3><div class=\"glide__bullets dots text-center\" data-glide-el=\"controls[nav]\"><button type=\"button\" class=\"glide__bullet dot\" data-glide-dir=\"={{$index}}\" ng-repeat=\"position in items\"></button></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/itemActions.dir.html","<div class=\"item_actions hidden id{{item.id}}\" data-format=\"{{item.format}}\"><div class=\"actions\"><a ng-click=\"itemZoom(item)\" data-mipqa=\"clickitem\" class=\"item_zoom\"><span class=\"itemActionIcon\"></span>Info</a><button type=\"button\" data-mipqa=\"clickitem-gameplay\" class=\"item_direct {{item.format}}\" ng-click=\"gamePlay(item, $event)\" title=\"{{item.title}}\" dir=\"{{setDir(setBtnLabel(item.format))}}\"><span class=\"itemActionIcon\"></span>{{setBtnLabel(item.format)}}</button></div><div class=\"item_info\"><p dir=\"{{setDir(item.title)}}\">{{item.title}}</p><p dir=\"{{setDir(item.category.name_category)}}\" class=\"cat\">{{item.category.name_category}}</p></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/itemSingle.html","<div class=\"listGame boxed single {{imgratio}}\" ng-show=\"contest.content_info\"><div itemtype=\"http://schema.org/VideoGame\" class=\"list-item\" callbackitems=\"callbackitems\" ng-if=\"contest.content_info\" data-gameid=\"{{game.id}}\" data-format=\"{{game.format}}\"><figure data-mipqa=\"{{showBadge[getSingleGameAccess(game.access_type)].class}}\"><a data-mipqa=\"clickitem\" ng-click=\"itemZoom(game)\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" class=\"badge {{game.format}}\" ng-class=\"{\'hideBadge\' : contest.isContestOver}\" data-gametype=\"{{showBadge[getSingleGameAccess(game.access_type)].dictKey | dictionary}}\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" data-contest=\"{{\'WEBAPP_COMPETITION_GAMEBADGE\' | dictionary}}\"><img alt=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" ng-src=\"{{gameImg | imageSize:4:0}}\" class=\"img-responsive\" lazy-img=\"{{gameImg | imageSize:imgWSize:imgHSize}}\"> <img class=\"format-game-icon img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config) && ($root.selector === \'android\')\" ng-src=\"{{setGameFormatBtn(game.format,apkicon,html5icon)}}\"></a><figcaption><h3 class=\"name\" dir=\"{{setDir(game.title)}}\"><a data-mipqa=\"clickitem\" ng-click=\"itemZoom(game)\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" dir=\"{{setDir(game.title)}}\">{{game.title}}</a></h3><h4 class=\"abstract\" ng-if=\"abstract\" dir=\"{{setDir(game.description_short)}}\"><span dir=\"{{setDir(game.description_short)}}\" ng-bind-html=\"game.description_short\"></span></h4><contest-players game=\"game\" starttime=\"start\" endtime=\"end\" ng-show=\"!contest.isContestOver\"></contest-players><p class=\"my-score\" ng-if=\"contest.user_score\"><dictionary key=\"\'WEBAPP_YOUR_SCORE\'\"></dictionary><span class=\"score\">{{contest.user_score}}</span></p></figcaption><button type=\"button\" data-mipqa=\"clickitem-gameplay\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" class=\"btn play {{game.format}}\" ng-click=\"gamePlay($event)\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" dir=\"{{setDir(setBtnLabel(game.format))}}\">{{setBtnLabel(game.format)}}</button></figure></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/itemSingle_multicontest.html","<div class=\"listGame boxed single {{imgratio}}\" ng-show=\"game\"><div itemtype=\"http://schema.org/VideoGame\" class=\"list-item\" callbackitems=\"callbackitems\" ng-if=\"game\" data-gameid=\"{{game.id}}\" data-format=\"{{game.format}}\"><figure data-mipqa=\"{{showBadge[getSingleGameAccess(game.access_type)].class}}\"><a data-mipqa=\"clickitem\" ng-click=\"itemZoom(game)\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" class=\"badge {{game.format}}\" ng-class=\"{\'hideBadge\' : contest.isContestOver}\" data-gametype=\"{{showBadge[getSingleGameAccess(game.access_type)].dictKey | dictionary}}\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" data-contest=\"{{\'WEBAPP_COMPETITION_GAMEBADGE\' | dictionary}}\"><img alt=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" ng-src=\"{{game.images.cover[imgratio] | imageSize:imgWSize:imgHSize}}\" class=\"img-responsive\" lazy-img=\"{{game.images.cover[imgRatio] | imageSize:4:0}}\"> <img class=\"format-game-icon img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config) && ($root.selector === \'android\')\" ng-src=\"{{setGameFormatBtn(game.format,apkicon,html5icon)}}\"></a><figcaption><h3 class=\"name\" dir=\"{{setDir(game.title)}}\"><a data-mipqa=\"clickitem\" ng-click=\"itemZoom(game)\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" dir=\"{{setDir(game.title)}}\">{{game.title}}</a></h3><h4 class=\"abstract\" ng-if=\"abstract\" dir=\"{{setDir(game.description_short)}}\"><span dir=\"{{setDir(game.description_short)}}\" ng-bind-html=\"game.description_short\"></span></h4><contest-players game=\"game\" starttime=\"start\" endtime=\"end\" ng-show=\"!contest.isContestOver\"></contest-players><p class=\"my-score\" ng-if=\"contest.user_score\">{{contest.user_score}}</p></figcaption><button type=\"button\" data-mipqa=\"clickitem-gameplay\" data-gamedest=\"{{gameGoesTo(game, \'general\')}}\" class=\"btn play {{game.format}}\" ng-click=\"gamePlay($event)\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" dir=\"{{setDir(setBtnLabel(game.format))}}\">{{setBtnLabel(game.format)}}</button></figure></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/itemSpot.html","<div class=\"listGame spot {{imgRatio}}\" infinite-scroll=\"loadMore()\" infinite-scroll-distance=\"0\" infinite-scroll-disabled=\"disableScroll\" infinite-scroll-use-document-bottom=\"$root.scrollPrefs.doc\" infinite-scroll-immediate-check=\"$root.scrollPrefs.check\"><figure itemtype=\"http://schema.org/VideoGame\" ng-repeat=\"item in items track by $index\" class=\"{{showBadge[getSingleGameAccess(item.access_type)].class}}\" data-mipqa=\"list-item\" data-format=\"{{item.format}}\"><a class=\"badge\" data-mipqa=\"clickitem\" ng-click=\"itemPlay(item, true, false, \'itemspot\');\" title=\"{{item.title}} {{\'WEBAPP_CANVAS_BUTTON_PLAY\' | dictionary}}\" data-gametype=\"{{showBadge[getSingleGameAccess(item.access_type)].dictKey | dictionary}}\" data-gamedest=\"{{gameGoesTo(item, \'itemspot\')}}\"><img lazy-img=\"{{item.images.cover[imgRatio] | imageSize:imgWSize:imgHSize}}\" ng-src=\"{{item.images.cover[imgRatio] | imageSize:4:0}}\" class=\"b-lazy img-responsive {{lazyClass}}\" itemprop=\"image\" alt=\"{{item.title}} {{\'WEBAPP_CANVAS_BUTTON_PLAY\' | dictionary}}\"><p class=\"tune-in\" ng-if=\"item.tune_in_msg && (\'SHOW_TUNEINMSG\' | config)\" dir=\"{{setDir(item.tune_in_msg)}}\">{{item.tune_in_msg}}</p></a><figcaption ng-class=\"{\'item-alt-overlay\' : (\'ALTERNATE_LAYOUT\' | config)}\"><img class=\"format-game-icon img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config) && ($root.selector === \'android\')\" ng-src=\"{{setGameFormatBtn(item.format,apkicon,html5icon)}}\"><a data-mipqa=\"clickitem\" ng-click=\"openZoom(item)\" title=\"{{item.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" ng-class=\"{\'text-center\' : !(\'ALTERNATE_LAYOUT\' | config)}\"><h4 itemprop=\"name\" class=\"dirOverride\" dir=\"{{setDir(item.title)}}\">{{item.title}}</h4><h4 dir=\"{{setDir(item.category.name_category)}}\" ng-if=\"(!(\'SHOW_CATEGORY_LINK_ITEMSPOT\' | config) && (\'ALTERNATE_LAYOUT\' | config)) && !(\'HIDE_CAT_ITEMSPOT\' | config)\">{{item.category.name_category}}</h4></a><a ng-if=\"(\'SHOW_CATEGORY_LINK_ITEMSPOT\' | config) && !(\'HIDE_CAT_ITEMSPOT\' | config)\" data-mipqa=\"btn-go-to-list\" ng-href=\"{{item.category.url_category}}\" title=\"{{item.category.name_category}}\" ng-class=\"{\'text-center\' : !(\'ALTERNATE_LAYOUT\' | config)}\"><h4 dir=\"{{setDir(item.category.name_category)}}\">{{item.category.name_category}}</h4></a></figcaption></figure></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/listBanner.html","<div class=\"listbanner\" data-mipqa=\"btn-go-to-list\" ng-click=\"goToList(list)\"><h4>{{list.description_short}}</h4><h3>{{list.name}}</h3><div class=\"slidercontainer\"><div class=\"glide listbanner-slider slider1 list-{{list.id}}_1\" dir=\"ltr\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li ng-repeat=\"item in items1 track by $index\" class=\"slider\" data-itemindex=\"{{$index}}\"><img ng-src=\"{{item.images.cover.ratio_1 | imageSize:180:180}}\" class=\"img-responsive\"></li></ul></div></div><div class=\"glide listbanner-slider slider2 list-{{list.id}}_2\" dir=\"rtl\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li ng-repeat=\"item in items2 track by $index\" class=\"slider\" data-itemindex=\"{{$index}}\"><img ng-src=\"{{item.images.cover.ratio_1 | imageSize:180:180}}\" class=\"img-responsive\"></li></ul></div></div></div><p>{{list.description}}</p></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/mixedRatioList.html","<div class=\"listGame simple mixed {{imgRatio}} mixed{{confSize}}\"><div itemtype=\"http://schema.org/VideoGame\" ng-repeat=\"game in items track by $index\" data-gameid=\"{{game.id}}\" class=\"{{showBadge[getSingleGameAccess(game.access_type)].class}} {{game.mixedRatio.ratio}}\" data-mipqa=\"list-item\" data-format=\"{{game.format}}\"><figure ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" data-gametype=\"{{showBadge[getSingleGameAccess(game.access_type)].dictKey | dictionary}}\" class=\"badge\" data-mipqa=\"{{getSingleGameAccess(game.access_type)}}\"><a data-mipqa=\"{{(\'HOME_ITEMS_DIRECT_PLAY\' | config) ? \'clickitem-actions\' : \'clickitem\'}}\" data-gamedest=\"{{gameGoesTo(game, \'games\')}}\" ng-click=\"itemPlay(game,true, $index+1, \'games\', false, $event)\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\"><img ng-if=\"tinyimg\" alt=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" lazy-img=\"{{game.mixedRatio.imgFull}}\" ng-src=\"{{game.images.cover[game.mixedRatio.ratio] | imageSize:4:0}}\" class=\"b-lazy img-responsive {{lazyClass}}\"> <img ng-if=\"!tinyimg\" alt=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" ng-src=\"{{game.mixedRatio.imgFull}}\" class=\"b-lazy img-responsive {{lazyClass}}\"><p class=\"item-alt-overlay\" ng-if=\"(\'GAMENAME_SIMPLEITEMS\' | config)\" dir=\"{{setDir(game.title)}}\"><span>{{game.title}}</span></p></a></figure><img class=\"format-game-icon img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config) && ($root.selector === \'android\')\" ng-src=\"{{setGameFormatBtn(game.format,apkicon,html5icon)}}\"><item-actions ng-if=\"(\'HOME_ITEMS_DIRECT_PLAY\' | config)\" item=\"game\"></item-actions></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/offersCarousel.html","<div class=\"listGame slider slider-complete slider-offers slider-container {{imgRatio}}\"><p ng-if=\"description\">{{description}}</p><h2 ng-click=\"goToList(list, true)\" data-mipqa=\"rem_btn-go-to-list\" ng-if=\"!useoutertitle\" dir=\"{{setDir(slidertitle)}}\">{{slidertitle}}</h2><h3 ng-if=\"!useoutertitle\" class=\"h3 btn-chevron\"><a ng-click=\"goToList(list, true)\" data-mipqa=\"rem_btn-go-to-list\" title=\"{{\'WEBAPP_LOAD_OTHER_CONTENTS\' | dictionary}}\" class=\"btn\"><dictionary key=\"\'WEBAPP_LOAD_OTHER_CONTENTS\'\"></dictionary></a></h3><div class=\"glide simpleSlider slider\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li data-mipqa=\"REM_list-item\" itemtype=\"http://schema.org/VideoGame\" ng-repeat=\"item in items track by $index\" data-itemindex=\"{{$index}}\" ng-show=\"item.images.cover[imgRatio] || item.showMore\" data-format=\"{{item.format}}\" ng-click=\"goTo(\'application\',{ appUrl:item.url_zoom_simple}, item, list, \'offer_click\')\"><img class=\"{{item.textClass}}\" title=\"{{item.title}} {{\'WEBAPP_CANVAS_BUTTON_PLAY\' | dictionary}}\" ng-src=\"{{item.images.cover[imgRatio] | imageSize:imgWSize:imgHSize}}\" class=\"img-responsive {{showBadge[getSingleGameAccess(item.access_type)].class}}\"><div class=\"details_container\"><p class=\"item-title\"><span>{{item.title}}</span></p><p class=\"item-abstract\"><span>{{item.description_short}}</span></p><button type=\"button\" data-mipqa=\"REM_clickitem\" data-gamedest=\"{{gameGoesTo(item, \'general\')}}\" class=\"btn play {{item.format}}\" title=\"{{item.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\" dir=\"{{setDir(setBtnLabel(item.format, \'WEBAPP_CAROUSEL_CALLTOACTION\'))}}\">{{setBtnLabel(item.format, \'WEBAPP_CAROUSEL_CALLTOACTION\')}}</button></div></li></ul></div><div class=\"glide__bullets dots text-center\" data-glide-el=\"controls[nav]\"><button type=\"button\" class=\"glide__bullet dot\" data-glide-dir=\"={{$index}}\" ng-repeat=\"position in items\"></button></div></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/onloadImgCarousel.html","<div class=\"glide cardsContainer\" ng-class=\"{\'visible\' : loaded}\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li class=\"glide__slide\" ng-repeat=\"item in items track by $index\" data-itemindex=\"{{$index}}\" data-mipqa=\"list-item\" data-gamedest=\"{{gameGoesTo(item, \'custom\')}}\" data-format=\"{{item.format}}\" title=\"{{item.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\"><div itemtype=\"http://schema.org/VideoGame\" ng-click=\"itemPlay(item,(\'CAROUSEL_CTA_GOTOZOOM\' | config), false, \'custom\')\" data-mipqa=\"{{(\'CAROUSEL_CTA_GOTOZOOM\' | config) ? \'clickitem\' : \'clickitem-gameplay\'}}\"><img imageloaded alt=\"{{item.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" ng-src=\"{{item.images.cover[imgRatio] | imageSize:imgWSize:imgHSize}}\" class=\"img-responsive\"><h3>{{item.title}}</h3><span class=\"btn play\">{{setBtnLabel(item.format)}}</span></div></li></ul></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/simpleList.html","<div class=\"listGame simple {{imgRatio}}\" infinite-scroll=\"loadMore()\" infinite-scroll-distance=\"0\" infinite-scroll-disabled=\"disableScroll\" infinite-scroll-use-document-bottom=\"$root.scrollPrefs.doc\" infinite-scroll-immediate-check=\"$root.scrollPrefs.check\"><div data-mipqa=\"list-item\" itemtype=\"http://schema.org/VideoGame\" ng-repeat=\"game in items track by $index\" data-gameid=\"{{game.id}}\" class=\"{{showBadge[getSingleGameAccess(game.access_type)].class}}\" data-format=\"{{game.format}}\"><figure data-gametype=\"{{showBadge[getSingleGameAccess(game.access_type)].dictKey | dictionary}}\" class=\"badge\" data-mipqa=\"{{getSingleGameAccess(game.access_type)}}\"><a data-mipqa=\"clickitem\" data-gamedest=\"{{gameGoesTo(game, \'games\')}}\" ng-click=\"itemPlay(game,true, false, \'games\')\" title=\"{{game.title}} {{\'SEO_WEBAPP_IMG_TITLE_ATTR\'  | dictionary}}\"><img alt=\"{{game.title}} {{\'SEO_WEBAPP_IMG_ALT_ATTR\' | dictionary}}\" lazy-img=\"{{game.images.cover[imgRatio] | imageSize:imgWSize:imgHSize}}\" ng-src=\"{{game.images.cover[imgRatio] | imageSize:4:0}}\" class=\"b-lazy img-responsive {{lazyClass}}\"><p class=\"item-alt-overlay\" ng-if=\"(\'GAMENAME_SIMPLEITEMS\' | config)\" dir=\"{{setDir(game.title)}}\"><span>{{game.title}}</span></p></a></figure><img class=\"format-game-icon img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config) && ($root.selector === \'android\')\" ng-src=\"{{setGameFormatBtn(game.format,apkicon,html5icon)}}\"></div></div>");
$templateCache.put("/js/wl/webstore_gameasy/app/modules/content/items/slider_cloud.html","<div class=\"listGame slider slider-cloud slider-container {{imgRatio}}\"><div class=\"list-details\"><h2 class=\"list-box-title\" ng-click=\"goToList(list)\" data-mipqa=\"btn-go-to-list\" ng-if=\"!useoutertitle\" dir=\"{{setDir(slidertitle)}}\">{{slidertitle}}</h2><button ng-if=\"!useoutertitle\" ng-click=\"goToList(list)\" type=\"button\" data-mipqa=\"btn-go-to-list\" title=\"{{\'WEBAPP_SHOW_MORE\' | dictionary}}\" class=\"list-showmore\"><dictionary key=\"\'WEBAPP_SHOW_MORE\'\"></dictionary></button></div><div class=\"glide cloudSlider slider-{{list.id}}\"><div class=\"glide__track\" data-glide-el=\"track\"><ul class=\"glide__slides\"><li data-mipqa=\"list-item\" itemtype=\"http://schema.org/VideoGame\" ng-repeat=\"item in items track by $index\" data-itemindex=\"{{$index}}\" data-format=\"{{item.format}}\" data-mipqa=\"clickitem\" ng-click=\"itemPlay(item,true,$index+1, \'slidersmall\');\"><figure><img title=\"{{item.title}} {{\'WEBAPP_CANVAS_BUTTON_PLAY\' | dictionary}}\" loading=\"lazy\" imagelazyloaded ng-src=\"{{item.images.cover[imgRatio] | imageSize:imgWSize:imgHSize}}\" class=\"img-responsive sliderimg b-lazy\"></figure><div class=\"item-details\"><p class=\"item-title\"><span>{{item.title}}</span></p><p class=\"item-publisher\"><span>{{item.publisher.title_publisher}}</span></p></div><img class=\"format-game-icon img-responsive\" ng-if=\"(\'GAME_FORMAT_ICONS\' | config) && ($root.selector === \'android\') && !item.showMore\" ng-src=\"{{setGameFormatBtn(item.format,apkicon,html5icon)}}\"></li></ul></div></div></div>");}]);